var OA = Object.defineProperty;
var zA = (n, e, t) => e in n ? OA(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var Gt = (n, e, t) => zA(n, typeof e != "symbol" ? e + "" : e, t);
import { jsx as b, jsxs as P, Fragment as dn } from "react/jsx-runtime";
import { FileSelectorModal as Ol, useFileUploaderManager as AA, isAcceptTypeValid as Cc, fileInputAcceptTypes as Tc, imageToFile as NA, FileTypeEnum as Mc, FileSourceEnum as LA } from "@systemeio/file-manager";
import * as Jn from "react";
import _e, { createContext as Cs, useContext as Ch, useRef as gr, useState as ye, useDebugValue as Th, useEffect as Je, forwardRef as DA, useLayoutEffect as RA, useMemo as Ve, Fragment as IA, useCallback as PA } from "react";
import jA, { flushSync as Mh } from "react-dom";
import { twMerge as W, twJoin as Te } from "tailwind-merge";
import { Hint as Eh, LanguageCodeEnum as qa, FormInputUrl as $h, Tooltip as te, FormInput as BA, toast as po, ListBoxSelect as Ht, Popover as xo, FormSelectInline as Ec, ColorPicker as So, NeutralButton as Oh, NeutralTypeEnum as zh, PrimaryButton as wo } from "@systemeio/ui";
import { CheckIcon as zl, ArrowDownIcon as Ah, CloseIcon as Nh, DotsIcon as FA } from "@systemeio/ui/icons";
import { isValidUrl as Lh } from "@systemeio/util";
import { FocusTrapFeatures as Co, FocusTrap as Dh } from "@headlessui/react";
var T = /* @__PURE__ */ ((n) => (n.Document = "Document", n.Paragraph = "Paragraph", n.Text = "Text", n.TextStyle = "TextStyle", n.FontFamily = "FontFamily", n.Heading = "Heading", n.Bold = "Bold", n.Italic = "Italic", n.Strike = "Strike", n.Underline = "Underline", n.BulletList = "BulletList", n.OrderedList = "OrderedList", n.ListItem = "ListItem", n.TextAlign = "TextAlign", n.Link = "Link", n.SimpleLink = "SimpleLink", n.History = "History", n.TextColor = "TextColor", n.TextBackgroundColor = "TextBackgroundColor", n.FontSize = "FontSize", n.Indent = "Indent", n.HardBreak = "HardBreak", n.SimpleHardBreak = "SimpleHardBreak", n.Substitution = "Substitution", n.SpecialCharacters = "SpecialCharacters", n.Image = "Image", n.DropCursor = "DropCursor", n.CharacterCount = "CharacterCount", n))(T || {});
const Ts = [
  T.Document,
  T.Paragraph,
  T.Text,
  T.History
], qA = [
  ...Ts,
  T.Bold,
  T.Italic,
  T.Strike,
  T.Underline,
  T.BulletList,
  T.OrderedList,
  T.ListItem,
  T.HardBreak
], HA = [
  ...Ts,
  ...qA,
  T.TextStyle,
  T.FontFamily,
  T.Heading,
  T.TextAlign,
  T.Link,
  T.TextColor,
  T.TextBackgroundColor,
  T.FontSize,
  T.Indent,
  T.HardBreak,
  T.SpecialCharacters,
  T.Image,
  T.DropCursor
], V8 = [
  ...HA,
  T.Substitution
], U8 = [
  ...Ts,
  T.Substitution,
  T.CharacterCount,
  T.SimpleLink,
  T.SimpleHardBreak
];
function Be(n) {
  this.content = n;
}
Be.prototype = {
  constructor: Be,
  find: function(n) {
    for (var e = 0; e < this.content.length; e += 2)
      if (this.content[e] === n) return e;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(n) {
    var e = this.find(n);
    return e == -1 ? void 0 : this.content[e + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(n, e, t) {
    var i = t && t != n ? this.remove(t) : this, r = i.find(n), o = i.content.slice();
    return r == -1 ? o.push(t || n, e) : (o[r + 1] = e, t && (o[r] = t)), new Be(o);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(n) {
    var e = this.find(n);
    if (e == -1) return this;
    var t = this.content.slice();
    return t.splice(e, 2), new Be(t);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(n, e) {
    return new Be([n, e].concat(this.remove(n).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(n, e) {
    var t = this.remove(n).content.slice();
    return t.push(n, e), new Be(t);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(n, e, t) {
    var i = this.remove(e), r = i.content.slice(), o = i.find(n);
    return r.splice(o == -1 ? r.length : o, 0, e, t), new Be(r);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(n) {
    for (var e = 0; e < this.content.length; e += 2)
      n(this.content[e], this.content[e + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(n) {
    return n = Be.from(n), n.size ? new Be(n.content.concat(this.subtract(n).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(n) {
    return n = Be.from(n), n.size ? new Be(this.subtract(n).content.concat(n.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(n) {
    var e = this;
    n = Be.from(n);
    for (var t = 0; t < n.content.length; t += 2)
      e = e.remove(n.content[t]);
    return e;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var n = {};
    return this.forEach(function(e, t) {
      n[e] = t;
    }), n;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
Be.from = function(n) {
  if (n instanceof Be) return n;
  var e = [];
  if (n) for (var t in n) e.push(t, n[t]);
  return new Be(e);
};
function Rh(n, e, t) {
  for (let i = 0; ; i++) {
    if (i == n.childCount || i == e.childCount)
      return n.childCount == e.childCount ? null : t;
    let r = n.child(i), o = e.child(i);
    if (r == o) {
      t += r.nodeSize;
      continue;
    }
    if (!r.sameMarkup(o))
      return t;
    if (r.isText && r.text != o.text) {
      for (let s = 0; r.text[s] == o.text[s]; s++)
        t++;
      return t;
    }
    if (r.content.size || o.content.size) {
      let s = Rh(r.content, o.content, t + 1);
      if (s != null)
        return s;
    }
    t += r.nodeSize;
  }
}
function Ih(n, e, t, i) {
  for (let r = n.childCount, o = e.childCount; ; ) {
    if (r == 0 || o == 0)
      return r == o ? null : { a: t, b: i };
    let s = n.child(--r), a = e.child(--o), l = s.nodeSize;
    if (s == a) {
      t -= l, i -= l;
      continue;
    }
    if (!s.sameMarkup(a))
      return { a: t, b: i };
    if (s.isText && s.text != a.text) {
      let c = 0, u = Math.min(s.text.length, a.text.length);
      for (; c < u && s.text[s.text.length - c - 1] == a.text[a.text.length - c - 1]; )
        c++, t--, i--;
      return { a: t, b: i };
    }
    if (s.content.size || a.content.size) {
      let c = Ih(s.content, a.content, t - 1, i - 1);
      if (c)
        return c;
    }
    t -= l, i -= l;
  }
}
class M {
  /**
  @internal
  */
  constructor(e, t) {
    if (this.content = e, this.size = t || 0, t == null)
      for (let i = 0; i < e.length; i++)
        this.size += e[i].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(e, t, i, r = 0, o) {
    for (let s = 0, a = 0; a < t; s++) {
      let l = this.content[s], c = a + l.nodeSize;
      if (c > e && i(l, r + a, o || null, s) !== !1 && l.content.size) {
        let u = a + 1;
        l.nodesBetween(Math.max(0, e - u), Math.min(l.content.size, t - u), i, r + u);
      }
      a = c;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(e) {
    this.nodesBetween(0, this.size, e);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(e, t, i, r) {
    let o = "", s = !0;
    return this.nodesBetween(e, t, (a, l) => {
      let c = a.isText ? a.text.slice(Math.max(e, l) - l, t - l) : a.isLeaf ? r ? typeof r == "function" ? r(a) : r : a.type.spec.leafText ? a.type.spec.leafText(a) : "" : "";
      a.isBlock && (a.isLeaf && c || a.isTextblock) && i && (s ? s = !1 : o += i), o += c;
    }, 0), o;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(e) {
    if (!e.size)
      return this;
    if (!this.size)
      return e;
    let t = this.lastChild, i = e.firstChild, r = this.content.slice(), o = 0;
    for (t.isText && t.sameMarkup(i) && (r[r.length - 1] = t.withText(t.text + i.text), o = 1); o < e.content.length; o++)
      r.push(e.content[o]);
    return new M(r, this.size + e.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(e, t = this.size) {
    if (e == 0 && t == this.size)
      return this;
    let i = [], r = 0;
    if (t > e)
      for (let o = 0, s = 0; s < t; o++) {
        let a = this.content[o], l = s + a.nodeSize;
        l > e && ((s < e || l > t) && (a.isText ? a = a.cut(Math.max(0, e - s), Math.min(a.text.length, t - s)) : a = a.cut(Math.max(0, e - s - 1), Math.min(a.content.size, t - s - 1))), i.push(a), r += a.nodeSize), s = l;
      }
    return new M(i, r);
  }
  /**
  @internal
  */
  cutByIndex(e, t) {
    return e == t ? M.empty : e == 0 && t == this.content.length ? this : new M(this.content.slice(e, t));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(e, t) {
    let i = this.content[e];
    if (i == t)
      return this;
    let r = this.content.slice(), o = this.size + t.nodeSize - i.nodeSize;
    return r[e] = t, new M(r, o);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(e) {
    return new M([e].concat(this.content), this.size + e.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(e) {
    return new M(this.content.concat(e), this.size + e.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(e) {
    if (this.content.length != e.content.length)
      return !1;
    for (let t = 0; t < this.content.length; t++)
      if (!this.content[t].eq(e.content[t]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(e) {
    let t = this.content[e];
    if (!t)
      throw new RangeError("Index " + e + " out of range for " + this);
    return t;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content[e] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    for (let t = 0, i = 0; t < this.content.length; t++) {
      let r = this.content[t];
      e(r, i, t), i += r.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(e, t = 0) {
    return Rh(this, e, t);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(e, t = this.size, i = e.size) {
    return Ih(this, e, t, i);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(e) {
    if (e == 0)
      return Ur(0, e);
    if (e == this.size)
      return Ur(this.content.length, e);
    if (e > this.size || e < 0)
      throw new RangeError(`Position ${e} outside of fragment (${this})`);
    for (let t = 0, i = 0; ; t++) {
      let r = this.child(t), o = i + r.nodeSize;
      if (o >= e)
        return o == e ? Ur(t + 1, o) : Ur(t, i);
      i = o;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((e) => e.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      return M.empty;
    if (!Array.isArray(t))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new M(t.map(e.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(e) {
    if (!e.length)
      return M.empty;
    let t, i = 0;
    for (let r = 0; r < e.length; r++) {
      let o = e[r];
      i += o.nodeSize, r && o.isText && e[r - 1].sameMarkup(o) ? (t || (t = e.slice(0, r)), t[t.length - 1] = o.withText(t[t.length - 1].text + o.text)) : t && t.push(o);
    }
    return new M(t || e, i);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(e) {
    if (!e)
      return M.empty;
    if (e instanceof M)
      return e;
    if (Array.isArray(e))
      return this.fromArray(e);
    if (e.attrs)
      return new M([e], e.nodeSize);
    throw new RangeError("Can not convert " + e + " to a Fragment" + (e.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
M.empty = new M([], 0);
const Gs = { index: 0, offset: 0 };
function Ur(n, e) {
  return Gs.index = n, Gs.offset = e, Gs;
}
function To(n, e) {
  if (n === e)
    return !0;
  if (!(n && typeof n == "object") || !(e && typeof e == "object"))
    return !1;
  let t = Array.isArray(n);
  if (Array.isArray(e) != t)
    return !1;
  if (t) {
    if (n.length != e.length)
      return !1;
    for (let i = 0; i < n.length; i++)
      if (!To(n[i], e[i]))
        return !1;
  } else {
    for (let i in n)
      if (!(i in e) || !To(n[i], e[i]))
        return !1;
    for (let i in e)
      if (!(i in n))
        return !1;
  }
  return !0;
}
let fe = class Ha {
  /**
  @internal
  */
  constructor(e, t) {
    this.type = e, this.attrs = t;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(e) {
    let t, i = !1;
    for (let r = 0; r < e.length; r++) {
      let o = e[r];
      if (this.eq(o))
        return e;
      if (this.type.excludes(o.type))
        t || (t = e.slice(0, r));
      else {
        if (o.type.excludes(this.type))
          return e;
        !i && o.type.rank > this.type.rank && (t || (t = e.slice(0, r)), t.push(this), i = !0), t && t.push(o);
      }
    }
    return t || (t = e.slice()), i || t.push(this), t;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(e) {
    for (let t = 0; t < e.length; t++)
      if (this.eq(e[t]))
        return e.slice(0, t).concat(e.slice(t + 1));
    return e;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(e) {
    for (let t = 0; t < e.length; t++)
      if (this.eq(e[t]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(e) {
    return this == e || this.type == e.type && To(this.attrs, e.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let t in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return e;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(e, t) {
    if (!t)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let i = e.marks[t.type];
    if (!i)
      throw new RangeError(`There is no mark type ${t.type} in this schema`);
    let r = i.create(t.attrs);
    return i.checkAttrs(r.attrs), r;
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(e, t) {
    if (e == t)
      return !0;
    if (e.length != t.length)
      return !1;
    for (let i = 0; i < e.length; i++)
      if (!e[i].eq(t[i]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(e) {
    if (!e || Array.isArray(e) && e.length == 0)
      return Ha.none;
    if (e instanceof Ha)
      return [e];
    let t = e.slice();
    return t.sort((i, r) => i.type.rank - r.type.rank), t;
  }
};
fe.none = [];
class Mo extends Error {
}
class L {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(e, t, i) {
    this.content = e, this.openStart = t, this.openEnd = i;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(e, t) {
    let i = jh(this.content, e + this.openStart, t);
    return i && new L(i, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(e, t) {
    return new L(Ph(this.content, e + this.openStart, t + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(e) {
    return this.content.eq(e.content) && this.openStart == e.openStart && this.openEnd == e.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let e = { content: this.content.toJSON() };
    return this.openStart > 0 && (e.openStart = this.openStart), this.openEnd > 0 && (e.openEnd = this.openEnd), e;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      return L.empty;
    let i = t.openStart || 0, r = t.openEnd || 0;
    if (typeof i != "number" || typeof r != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new L(M.fromJSON(e, t.content), i, r);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(e, t = !0) {
    let i = 0, r = 0;
    for (let o = e.firstChild; o && !o.isLeaf && (t || !o.type.spec.isolating); o = o.firstChild)
      i++;
    for (let o = e.lastChild; o && !o.isLeaf && (t || !o.type.spec.isolating); o = o.lastChild)
      r++;
    return new L(e, i, r);
  }
}
L.empty = new L(M.empty, 0, 0);
function Ph(n, e, t) {
  let { index: i, offset: r } = n.findIndex(e), o = n.maybeChild(i), { index: s, offset: a } = n.findIndex(t);
  if (r == e || o.isText) {
    if (a != t && !n.child(s).isText)
      throw new RangeError("Removing non-flat range");
    return n.cut(0, e).append(n.cut(t));
  }
  if (i != s)
    throw new RangeError("Removing non-flat range");
  return n.replaceChild(i, o.copy(Ph(o.content, e - r - 1, t - r - 1)));
}
function jh(n, e, t, i) {
  let { index: r, offset: o } = n.findIndex(e), s = n.maybeChild(r);
  if (o == e || s.isText)
    return i && !i.canReplace(r, r, t) ? null : n.cut(0, e).append(t).append(n.cut(e));
  let a = jh(s.content, e - o - 1, t, s);
  return a && n.replaceChild(r, s.copy(a));
}
function VA(n, e, t) {
  if (t.openStart > n.depth)
    throw new Mo("Inserted content deeper than insertion position");
  if (n.depth - t.openStart != e.depth - t.openEnd)
    throw new Mo("Inconsistent open depths");
  return Bh(n, e, t, 0);
}
function Bh(n, e, t, i) {
  let r = n.index(i), o = n.node(i);
  if (r == e.index(i) && i < n.depth - t.openStart) {
    let s = Bh(n, e, t, i + 1);
    return o.copy(o.content.replaceChild(r, s));
  } else if (t.content.size)
    if (!t.openStart && !t.openEnd && n.depth == i && e.depth == i) {
      let s = n.parent, a = s.content;
      return ii(s, a.cut(0, n.parentOffset).append(t.content).append(a.cut(e.parentOffset)));
    } else {
      let { start: s, end: a } = UA(t, n);
      return ii(o, qh(n, s, a, e, i));
    }
  else return ii(o, Eo(n, e, i));
}
function Fh(n, e) {
  if (!e.type.compatibleContent(n.type))
    throw new Mo("Cannot join " + e.type.name + " onto " + n.type.name);
}
function Va(n, e, t) {
  let i = n.node(t);
  return Fh(i, e.node(t)), i;
}
function ni(n, e) {
  let t = e.length - 1;
  t >= 0 && n.isText && n.sameMarkup(e[t]) ? e[t] = n.withText(e[t].text + n.text) : e.push(n);
}
function Qi(n, e, t, i) {
  let r = (e || n).node(t), o = 0, s = e ? e.index(t) : r.childCount;
  n && (o = n.index(t), n.depth > t ? o++ : n.textOffset && (ni(n.nodeAfter, i), o++));
  for (let a = o; a < s; a++)
    ni(r.child(a), i);
  e && e.depth == t && e.textOffset && ni(e.nodeBefore, i);
}
function ii(n, e) {
  return n.type.checkContent(e), n.copy(e);
}
function qh(n, e, t, i, r) {
  let o = n.depth > r && Va(n, e, r + 1), s = i.depth > r && Va(t, i, r + 1), a = [];
  return Qi(null, n, r, a), o && s && e.index(r) == t.index(r) ? (Fh(o, s), ni(ii(o, qh(n, e, t, i, r + 1)), a)) : (o && ni(ii(o, Eo(n, e, r + 1)), a), Qi(e, t, r, a), s && ni(ii(s, Eo(t, i, r + 1)), a)), Qi(i, null, r, a), new M(a);
}
function Eo(n, e, t) {
  let i = [];
  if (Qi(null, n, t, i), n.depth > t) {
    let r = Va(n, e, t + 1);
    ni(ii(r, Eo(n, e, t + 1)), i);
  }
  return Qi(e, null, t, i), new M(i);
}
function UA(n, e) {
  let t = e.depth - n.openStart, r = e.node(t).copy(n.content);
  for (let o = t - 1; o >= 0; o--)
    r = e.node(o).copy(M.from(r));
  return {
    start: r.resolveNoCache(n.openStart + t),
    end: r.resolveNoCache(r.content.size - n.openEnd - t)
  };
}
class _r {
  /**
  @internal
  */
  constructor(e, t, i) {
    this.pos = e, this.path = t, this.parentOffset = i, this.depth = t.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(e) {
    return e == null ? this.depth : e < 0 ? this.depth + e : e;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(e) {
    return this.path[this.resolveDepth(e) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(e) {
    return this.path[this.resolveDepth(e) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(e) {
    return e = this.resolveDepth(e), this.index(e) + (e == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(e) {
    return e = this.resolveDepth(e), e == 0 ? 0 : this.path[e * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(e) {
    return e = this.resolveDepth(e), this.start(e) + this.node(e).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position before the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position after the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1] + this.path[e * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let e = this.parent, t = this.index(this.depth);
    if (t == e.childCount)
      return null;
    let i = this.pos - this.path[this.path.length - 1], r = e.child(t);
    return i ? e.child(t).cut(i) : r;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let e = this.index(this.depth), t = this.pos - this.path[this.path.length - 1];
    return t ? this.parent.child(e).cut(0, t) : e == 0 ? null : this.parent.child(e - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(e, t) {
    t = this.resolveDepth(t);
    let i = this.path[t * 3], r = t == 0 ? 0 : this.path[t * 3 - 1] + 1;
    for (let o = 0; o < e; o++)
      r += i.child(o).nodeSize;
    return r;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let e = this.parent, t = this.index();
    if (e.content.size == 0)
      return fe.none;
    if (this.textOffset)
      return e.child(t).marks;
    let i = e.maybeChild(t - 1), r = e.maybeChild(t);
    if (!i) {
      let a = i;
      i = r, r = a;
    }
    let o = i.marks;
    for (var s = 0; s < o.length; s++)
      o[s].type.spec.inclusive === !1 && (!r || !o[s].isInSet(r.marks)) && (o = o[s--].removeFromSet(o));
    return o;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(e) {
    let t = this.parent.maybeChild(this.index());
    if (!t || !t.isInline)
      return null;
    let i = t.marks, r = e.parent.maybeChild(e.index());
    for (var o = 0; o < i.length; o++)
      i[o].type.spec.inclusive === !1 && (!r || !i[o].isInSet(r.marks)) && (i = i[o--].removeFromSet(i));
    return i;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(e) {
    for (let t = this.depth; t > 0; t--)
      if (this.start(t) <= e && this.end(t) >= e)
        return t;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(e = this, t) {
    if (e.pos < this.pos)
      return e.blockRange(this);
    for (let i = this.depth - (this.parent.inlineContent || this.pos == e.pos ? 1 : 0); i >= 0; i--)
      if (e.pos <= this.end(i) && (!t || t(this.node(i))))
        return new $o(this, e, i);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(e) {
    return this.pos - this.parentOffset == e.pos - e.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(e) {
    return e.pos > this.pos ? e : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(e) {
    return e.pos < this.pos ? e : this;
  }
  /**
  @internal
  */
  toString() {
    let e = "";
    for (let t = 1; t <= this.depth; t++)
      e += (e ? "/" : "") + this.node(t).type.name + "_" + this.index(t - 1);
    return e + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(e, t) {
    if (!(t >= 0 && t <= e.content.size))
      throw new RangeError("Position " + t + " out of range");
    let i = [], r = 0, o = t;
    for (let s = e; ; ) {
      let { index: a, offset: l } = s.content.findIndex(o), c = o - l;
      if (i.push(s, a, r + l), !c || (s = s.child(a), s.isText))
        break;
      o = c - 1, r += l + 1;
    }
    return new _r(t, i, o);
  }
  /**
  @internal
  */
  static resolveCached(e, t) {
    let i = $c.get(e);
    if (i)
      for (let o = 0; o < i.elts.length; o++) {
        let s = i.elts[o];
        if (s.pos == t)
          return s;
      }
    else
      $c.set(e, i = new WA());
    let r = i.elts[i.i] = _r.resolve(e, t);
    return i.i = (i.i + 1) % KA, r;
  }
}
class WA {
  constructor() {
    this.elts = [], this.i = 0;
  }
}
const KA = 12, $c = /* @__PURE__ */ new WeakMap();
class $o {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(e, t, i) {
    this.$from = e, this.$to = t, this.depth = i;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const ZA = /* @__PURE__ */ Object.create(null);
let an = class Ua {
  /**
  @internal
  */
  constructor(e, t, i, r = fe.none) {
    this.type = e, this.attrs = t, this.marks = r, this.content = i || M.empty;
  }
  /**
  The array of this node's child nodes.
  */
  get children() {
    return this.content.content;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(e) {
    return this.content.child(e);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content.maybeChild(e);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    this.content.forEach(e);
  }
  /**
  Invoke a callback for all descendant nodes recursively between
  the given two positions that are relative to start of this
  node's content. The callback is invoked with the node, its
  position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(e, t, i, r = 0) {
    this.content.nodesBetween(e, t, i, r, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(e) {
    this.nodesBetween(0, this.content.size, e);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec.leafText) will be used.
  */
  textBetween(e, t, i, r) {
    return this.content.textBetween(e, t, i, r);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(e) {
    return this == e || this.sameMarkup(e) && this.content.eq(e.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(e) {
    return this.hasMarkup(e.type, e.attrs, e.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(e, t, i) {
    return this.type == e && To(this.attrs, t || e.defaultAttrs || ZA) && fe.sameSet(this.marks, i || fe.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(e = null) {
    return e == this.content ? this : new Ua(this.type, this.attrs, e, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(e) {
    return e == this.marks ? this : new Ua(this.type, this.attrs, this.content, e);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(e, t = this.content.size) {
    return e == 0 && t == this.content.size ? this : this.copy(this.content.cut(e, t));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(e, t = this.content.size, i = !1) {
    if (e == t)
      return L.empty;
    let r = this.resolve(e), o = this.resolve(t), s = i ? 0 : r.sharedDepth(t), a = r.start(s), c = r.node(s).content.cut(r.pos - a, o.pos - a);
    return new L(c, r.depth - s, o.depth - s);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(e, t, i) {
    return VA(this.resolve(e), this.resolve(t), i);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(e) {
    for (let t = this; ; ) {
      let { index: i, offset: r } = t.content.findIndex(e);
      if (t = t.maybeChild(i), !t)
        return null;
      if (r == e || t.isText)
        return t;
      e -= r + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(e) {
    let { index: t, offset: i } = this.content.findIndex(e);
    return { node: this.content.maybeChild(t), index: t, offset: i };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(e) {
    if (e == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: t, offset: i } = this.content.findIndex(e);
    if (i < e)
      return { node: this.content.child(t), index: t, offset: i };
    let r = this.content.child(t - 1);
    return { node: r, index: t - 1, offset: i - r.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(e) {
    return _r.resolveCached(this, e);
  }
  /**
  @internal
  */
  resolveNoCache(e) {
    return _r.resolve(this, e);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(e, t, i) {
    let r = !1;
    return t > e && this.nodesBetween(e, t, (o) => (i.isInSet(o.marks) && (r = !0), !r)), r;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let e = this.type.name;
    return this.content.size && (e += "(" + this.content.toStringInner() + ")"), Hh(this.marks, e);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(e) {
    let t = this.type.contentMatch.matchFragment(this.content, 0, e);
    if (!t)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return t;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(e, t, i = M.empty, r = 0, o = i.childCount) {
    let s = this.contentMatchAt(e).matchFragment(i, r, o), a = s && s.matchFragment(this.content, t);
    if (!a || !a.validEnd)
      return !1;
    for (let l = r; l < o; l++)
      if (!this.type.allowsMarks(i.child(l).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(e, t, i, r) {
    if (r && !this.type.allowsMarks(r))
      return !1;
    let o = this.contentMatchAt(e).matchType(i), s = o && o.matchFragment(this.content, t);
    return s ? s.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(e) {
    return e.content.size ? this.canReplace(this.childCount, this.childCount, e.content) : this.type.compatibleContent(e.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise an exception when they do not.
  */
  check() {
    this.type.checkContent(this.content), this.type.checkAttrs(this.attrs);
    let e = fe.none;
    for (let t = 0; t < this.marks.length; t++) {
      let i = this.marks[t];
      i.type.checkAttrs(i.attrs), e = i.addToSet(e);
    }
    if (!fe.sameSet(e, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((t) => t.type.name)}`);
    this.content.forEach((t) => t.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let t in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return this.content.size && (e.content = this.content.toJSON()), this.marks.length && (e.marks = this.marks.map((t) => t.toJSON())), e;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      throw new RangeError("Invalid input for Node.fromJSON");
    let i;
    if (t.marks) {
      if (!Array.isArray(t.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      i = t.marks.map(e.markFromJSON);
    }
    if (t.type == "text") {
      if (typeof t.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return e.text(t.text, i);
    }
    let r = M.fromJSON(e, t.content), o = e.nodeType(t.type).create(t.attrs, r, i);
    return o.type.checkAttrs(o.attrs), o;
  }
};
an.prototype.text = void 0;
class Oo extends an {
  /**
  @internal
  */
  constructor(e, t, i, r) {
    if (super(e, t, null, r), !i)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = i;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : Hh(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(e, t) {
    return this.text.slice(e, t);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(e) {
    return e == this.marks ? this : new Oo(this.type, this.attrs, this.text, e);
  }
  withText(e) {
    return e == this.text ? this : new Oo(this.type, this.attrs, e, this.marks);
  }
  cut(e = 0, t = this.text.length) {
    return e == 0 && t == this.text.length ? this : this.withText(this.text.slice(e, t));
  }
  eq(e) {
    return this.sameMarkup(e) && this.text == e.text;
  }
  toJSON() {
    let e = super.toJSON();
    return e.text = this.text, e;
  }
}
function Hh(n, e) {
  for (let t = n.length - 1; t >= 0; t--)
    e = n[t].type.name + "(" + e + ")";
  return e;
}
class li {
  /**
  @internal
  */
  constructor(e) {
    this.validEnd = e, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(e, t) {
    let i = new JA(e, t);
    if (i.next == null)
      return li.empty;
    let r = Vh(i);
    i.next && i.err("Unexpected trailing text");
    let o = nN(tN(r));
    return iN(o, i), o;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(e) {
    for (let t = 0; t < this.next.length; t++)
      if (this.next[t].type == e)
        return this.next[t].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(e, t = 0, i = e.childCount) {
    let r = this;
    for (let o = t; r && o < i; o++)
      r = r.matchType(e.child(o).type);
    return r;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let e = 0; e < this.next.length; e++) {
      let { type: t } = this.next[e];
      if (!(t.isText || t.hasRequiredAttrs()))
        return t;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(e) {
    for (let t = 0; t < this.next.length; t++)
      for (let i = 0; i < e.next.length; i++)
        if (this.next[t].type == e.next[i].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(e, t = !1, i = 0) {
    let r = [this];
    function o(s, a) {
      let l = s.matchFragment(e, i);
      if (l && (!t || l.validEnd))
        return M.from(a.map((c) => c.createAndFill()));
      for (let c = 0; c < s.next.length; c++) {
        let { type: u, next: d } = s.next[c];
        if (!(u.isText || u.hasRequiredAttrs()) && r.indexOf(d) == -1) {
          r.push(d);
          let h = o(d, a.concat(u));
          if (h)
            return h;
        }
      }
      return null;
    }
    return o(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(e) {
    for (let i = 0; i < this.wrapCache.length; i += 2)
      if (this.wrapCache[i] == e)
        return this.wrapCache[i + 1];
    let t = this.computeWrapping(e);
    return this.wrapCache.push(e, t), t;
  }
  /**
  @internal
  */
  computeWrapping(e) {
    let t = /* @__PURE__ */ Object.create(null), i = [{ match: this, type: null, via: null }];
    for (; i.length; ) {
      let r = i.shift(), o = r.match;
      if (o.matchType(e)) {
        let s = [];
        for (let a = r; a.type; a = a.via)
          s.push(a.type);
        return s.reverse();
      }
      for (let s = 0; s < o.next.length; s++) {
        let { type: a, next: l } = o.next[s];
        !a.isLeaf && !a.hasRequiredAttrs() && !(a.name in t) && (!r.type || l.validEnd) && (i.push({ match: a.contentMatch, type: a, via: r }), t[a.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(e) {
    if (e >= this.next.length)
      throw new RangeError(`There's no ${e}th edge in this content match`);
    return this.next[e];
  }
  /**
  @internal
  */
  toString() {
    let e = [];
    function t(i) {
      e.push(i);
      for (let r = 0; r < i.next.length; r++)
        e.indexOf(i.next[r].next) == -1 && t(i.next[r].next);
    }
    return t(this), e.map((i, r) => {
      let o = r + (i.validEnd ? "*" : " ") + " ";
      for (let s = 0; s < i.next.length; s++)
        o += (s ? ", " : "") + i.next[s].type.name + "->" + e.indexOf(i.next[s].next);
      return o;
    }).join(`
`);
  }
}
li.empty = new li(!0);
class JA {
  constructor(e, t) {
    this.string = e, this.nodeTypes = t, this.inline = null, this.pos = 0, this.tokens = e.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(e) {
    return this.next == e && (this.pos++ || !0);
  }
  err(e) {
    throw new SyntaxError(e + " (in content expression '" + this.string + "')");
  }
}
function Vh(n) {
  let e = [];
  do
    e.push(GA(n));
  while (n.eat("|"));
  return e.length == 1 ? e[0] : { type: "choice", exprs: e };
}
function GA(n) {
  let e = [];
  do
    e.push(YA(n));
  while (n.next && n.next != ")" && n.next != "|");
  return e.length == 1 ? e[0] : { type: "seq", exprs: e };
}
function YA(n) {
  let e = eN(n);
  for (; ; )
    if (n.eat("+"))
      e = { type: "plus", expr: e };
    else if (n.eat("*"))
      e = { type: "star", expr: e };
    else if (n.eat("?"))
      e = { type: "opt", expr: e };
    else if (n.eat("{"))
      e = XA(n, e);
    else
      break;
  return e;
}
function Oc(n) {
  /\D/.test(n.next) && n.err("Expected number, got '" + n.next + "'");
  let e = Number(n.next);
  return n.pos++, e;
}
function XA(n, e) {
  let t = Oc(n), i = t;
  return n.eat(",") && (n.next != "}" ? i = Oc(n) : i = -1), n.eat("}") || n.err("Unclosed braced range"), { type: "range", min: t, max: i, expr: e };
}
function QA(n, e) {
  let t = n.nodeTypes, i = t[e];
  if (i)
    return [i];
  let r = [];
  for (let o in t) {
    let s = t[o];
    s.isInGroup(e) && r.push(s);
  }
  return r.length == 0 && n.err("No node type or group '" + e + "' found"), r;
}
function eN(n) {
  if (n.eat("(")) {
    let e = Vh(n);
    return n.eat(")") || n.err("Missing closing paren"), e;
  } else if (/\W/.test(n.next))
    n.err("Unexpected token '" + n.next + "'");
  else {
    let e = QA(n, n.next).map((t) => (n.inline == null ? n.inline = t.isInline : n.inline != t.isInline && n.err("Mixing inline and block content"), { type: "name", value: t }));
    return n.pos++, e.length == 1 ? e[0] : { type: "choice", exprs: e };
  }
}
function tN(n) {
  let e = [[]];
  return r(o(n, 0), t()), e;
  function t() {
    return e.push([]) - 1;
  }
  function i(s, a, l) {
    let c = { term: l, to: a };
    return e[s].push(c), c;
  }
  function r(s, a) {
    s.forEach((l) => l.to = a);
  }
  function o(s, a) {
    if (s.type == "choice")
      return s.exprs.reduce((l, c) => l.concat(o(c, a)), []);
    if (s.type == "seq")
      for (let l = 0; ; l++) {
        let c = o(s.exprs[l], a);
        if (l == s.exprs.length - 1)
          return c;
        r(c, a = t());
      }
    else if (s.type == "star") {
      let l = t();
      return i(a, l), r(o(s.expr, l), l), [i(l)];
    } else if (s.type == "plus") {
      let l = t();
      return r(o(s.expr, a), l), r(o(s.expr, l), l), [i(l)];
    } else {
      if (s.type == "opt")
        return [i(a)].concat(o(s.expr, a));
      if (s.type == "range") {
        let l = a;
        for (let c = 0; c < s.min; c++) {
          let u = t();
          r(o(s.expr, l), u), l = u;
        }
        if (s.max == -1)
          r(o(s.expr, l), l);
        else
          for (let c = s.min; c < s.max; c++) {
            let u = t();
            i(l, u), r(o(s.expr, l), u), l = u;
          }
        return [i(l)];
      } else {
        if (s.type == "name")
          return [i(a, void 0, s.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function Uh(n, e) {
  return e - n;
}
function zc(n, e) {
  let t = [];
  return i(e), t.sort(Uh);
  function i(r) {
    let o = n[r];
    if (o.length == 1 && !o[0].term)
      return i(o[0].to);
    t.push(r);
    for (let s = 0; s < o.length; s++) {
      let { term: a, to: l } = o[s];
      !a && t.indexOf(l) == -1 && i(l);
    }
  }
}
function nN(n) {
  let e = /* @__PURE__ */ Object.create(null);
  return t(zc(n, 0));
  function t(i) {
    let r = [];
    i.forEach((s) => {
      n[s].forEach(({ term: a, to: l }) => {
        if (!a)
          return;
        let c;
        for (let u = 0; u < r.length; u++)
          r[u][0] == a && (c = r[u][1]);
        zc(n, l).forEach((u) => {
          c || r.push([a, c = []]), c.indexOf(u) == -1 && c.push(u);
        });
      });
    });
    let o = e[i.join(",")] = new li(i.indexOf(n.length - 1) > -1);
    for (let s = 0; s < r.length; s++) {
      let a = r[s][1].sort(Uh);
      o.next.push({ type: r[s][0], next: e[a.join(",")] || t(a) });
    }
    return o;
  }
}
function iN(n, e) {
  for (let t = 0, i = [n]; t < i.length; t++) {
    let r = i[t], o = !r.validEnd, s = [];
    for (let a = 0; a < r.next.length; a++) {
      let { type: l, next: c } = r.next[a];
      s.push(l.name), o && !(l.isText || l.hasRequiredAttrs()) && (o = !1), i.indexOf(c) == -1 && i.push(c);
    }
    o && e.err("Only non-generatable nodes (" + s.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function Wh(n) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let t in n) {
    let i = n[t];
    if (!i.hasDefault)
      return null;
    e[t] = i.default;
  }
  return e;
}
function Kh(n, e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let i in n) {
    let r = e && e[i];
    if (r === void 0) {
      let o = n[i];
      if (o.hasDefault)
        r = o.default;
      else
        throw new RangeError("No value supplied for attribute " + i);
    }
    t[i] = r;
  }
  return t;
}
function Zh(n, e, t, i) {
  for (let r in e)
    if (!(r in n))
      throw new RangeError(`Unsupported attribute ${r} for ${t} of type ${r}`);
  for (let r in n) {
    let o = n[r];
    o.validate && o.validate(e[r]);
  }
}
function Jh(n, e) {
  let t = /* @__PURE__ */ Object.create(null);
  if (e)
    for (let i in e)
      t[i] = new oN(n, i, e[i]);
  return t;
}
let Ac = class Gh {
  /**
  @internal
  */
  constructor(e, t, i) {
    this.name = e, this.schema = t, this.spec = i, this.markSet = null, this.groups = i.group ? i.group.split(" ") : [], this.attrs = Jh(e, i.attrs), this.defaultAttrs = Wh(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(i.inline || e == "text"), this.isText = e == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == li.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  Return true when this node type is part of the given
  [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
  */
  isInGroup(e) {
    return this.groups.indexOf(e) > -1;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let e in this.attrs)
      if (this.attrs[e].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(e) {
    return this == e || this.contentMatch.compatible(e.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(e) {
    return !e && this.defaultAttrs ? this.defaultAttrs : Kh(this.attrs, e);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(e = null, t, i) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new an(this, this.computeAttrs(e), M.from(t), fe.setFrom(i));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(e = null, t, i) {
    return t = M.from(t), this.checkContent(t), new an(this, this.computeAttrs(e), t, fe.setFrom(i));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(e = null, t, i) {
    if (e = this.computeAttrs(e), t = M.from(t), t.size) {
      let s = this.contentMatch.fillBefore(t);
      if (!s)
        return null;
      t = s.append(t);
    }
    let r = this.contentMatch.matchFragment(t), o = r && r.fillBefore(M.empty, !0);
    return o ? new an(this, e, t.append(o), fe.setFrom(i)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(e) {
    let t = this.contentMatch.matchFragment(e);
    if (!t || !t.validEnd)
      return !1;
    for (let i = 0; i < e.childCount; i++)
      if (!this.allowsMarks(e.child(i).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(e) {
    if (!this.validContent(e))
      throw new RangeError(`Invalid content for node ${this.name}: ${e.toString().slice(0, 50)}`);
  }
  /**
  @internal
  */
  checkAttrs(e) {
    Zh(this.attrs, e, "node", this.name);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(e) {
    return this.markSet == null || this.markSet.indexOf(e) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(e) {
    if (this.markSet == null)
      return !0;
    for (let t = 0; t < e.length; t++)
      if (!this.allowsMarkType(e[t].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(e) {
    if (this.markSet == null)
      return e;
    let t;
    for (let i = 0; i < e.length; i++)
      this.allowsMarkType(e[i].type) ? t && t.push(e[i]) : t || (t = e.slice(0, i));
    return t ? t.length ? t : fe.none : e;
  }
  /**
  @internal
  */
  static compile(e, t) {
    let i = /* @__PURE__ */ Object.create(null);
    e.forEach((o, s) => i[o] = new Gh(o, t, s));
    let r = t.spec.topNode || "doc";
    if (!i[r])
      throw new RangeError("Schema is missing its top node type ('" + r + "')");
    if (!i.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let o in i.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return i;
  }
};
function rN(n, e, t) {
  let i = t.split("|");
  return (r) => {
    let o = r === null ? "null" : typeof r;
    if (i.indexOf(o) < 0)
      throw new RangeError(`Expected value of type ${i} for attribute ${e} on type ${n}, got ${o}`);
  };
}
class oN {
  constructor(e, t, i) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(i, "default"), this.default = i.default, this.validate = typeof i.validate == "string" ? rN(e, t, i.validate) : i.validate;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class Ms {
  /**
  @internal
  */
  constructor(e, t, i, r) {
    this.name = e, this.rank = t, this.schema = i, this.spec = r, this.attrs = Jh(e, r.attrs), this.excluded = null;
    let o = Wh(this.attrs);
    this.instance = o ? new fe(this, o) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(e = null) {
    return !e && this.instance ? this.instance : new fe(this, Kh(this.attrs, e));
  }
  /**
  @internal
  */
  static compile(e, t) {
    let i = /* @__PURE__ */ Object.create(null), r = 0;
    return e.forEach((o, s) => i[o] = new Ms(o, r++, t, s)), i;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(e) {
    for (var t = 0; t < e.length; t++)
      e[t].type == this && (e = e.slice(0, t).concat(e.slice(t + 1)), t--);
    return e;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(e) {
    for (let t = 0; t < e.length; t++)
      if (e[t].type == this)
        return e[t];
  }
  /**
  @internal
  */
  checkAttrs(e) {
    Zh(this.attrs, e, "mark", this.name);
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(e) {
    return this.excluded.indexOf(e) > -1;
  }
}
class Yh {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(e) {
    this.linebreakReplacement = null, this.cached = /* @__PURE__ */ Object.create(null);
    let t = this.spec = {};
    for (let r in e)
      t[r] = e[r];
    t.nodes = Be.from(e.nodes), t.marks = Be.from(e.marks || {}), this.nodes = Ac.compile(this.spec.nodes, this), this.marks = Ms.compile(this.spec.marks, this);
    let i = /* @__PURE__ */ Object.create(null);
    for (let r in this.nodes) {
      if (r in this.marks)
        throw new RangeError(r + " can not be both a node and a mark");
      let o = this.nodes[r], s = o.spec.content || "", a = o.spec.marks;
      if (o.contentMatch = i[s] || (i[s] = li.parse(s, this.nodes)), o.inlineContent = o.contentMatch.inlineContent, o.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!o.isInline || !o.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = o;
      }
      o.markSet = a == "_" ? null : a ? Nc(this, a.split(" ")) : a == "" || !o.inlineContent ? [] : null;
    }
    for (let r in this.marks) {
      let o = this.marks[r], s = o.spec.excludes;
      o.excluded = s == null ? [o] : s == "" ? [] : Nc(this, s.split(" "));
    }
    this.nodeFromJSON = (r) => an.fromJSON(this, r), this.markFromJSON = (r) => fe.fromJSON(this, r), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(e, t = null, i, r) {
    if (typeof e == "string")
      e = this.nodeType(e);
    else if (e instanceof Ac) {
      if (e.schema != this)
        throw new RangeError("Node type from different schema used (" + e.name + ")");
    } else throw new RangeError("Invalid node type: " + e);
    return e.createChecked(t, i, r);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(e, t) {
    let i = this.nodes.text;
    return new Oo(i, i.defaultAttrs, e, fe.setFrom(t));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(e, t) {
    return typeof e == "string" && (e = this.marks[e]), e.create(t);
  }
  /**
  @internal
  */
  nodeType(e) {
    let t = this.nodes[e];
    if (!t)
      throw new RangeError("Unknown node type: " + e);
    return t;
  }
}
function Nc(n, e) {
  let t = [];
  for (let i = 0; i < e.length; i++) {
    let r = e[i], o = n.marks[r], s = o;
    if (o)
      t.push(o);
    else
      for (let a in n.marks) {
        let l = n.marks[a];
        (r == "_" || l.spec.group && l.spec.group.split(" ").indexOf(r) > -1) && t.push(s = l);
      }
    if (!s)
      throw new SyntaxError("Unknown mark type: '" + e[i] + "'");
  }
  return t;
}
function sN(n) {
  return n.tag != null;
}
function aN(n) {
  return n.style != null;
}
class zn {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(e, t) {
    this.schema = e, this.rules = t, this.tags = [], this.styles = [];
    let i = this.matchedStyles = [];
    t.forEach((r) => {
      if (sN(r))
        this.tags.push(r);
      else if (aN(r)) {
        let o = /[^=]*/.exec(r.style)[0];
        i.indexOf(o) < 0 && i.push(o), this.styles.push(r);
      }
    }), this.normalizeLists = !this.tags.some((r) => {
      if (!/^(ul|ol)\b/.test(r.tag) || !r.node)
        return !1;
      let o = e.nodes[r.node];
      return o.contentMatch.matchType(o);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(e, t = {}) {
    let i = new Dc(this, t, !1);
    return i.addAll(e, fe.none, t.from, t.to), i.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(e, t = {}) {
    let i = new Dc(this, t, !0);
    return i.addAll(e, fe.none, t.from, t.to), L.maxOpen(i.finish());
  }
  /**
  @internal
  */
  matchTag(e, t, i) {
    for (let r = i ? this.tags.indexOf(i) + 1 : 0; r < this.tags.length; r++) {
      let o = this.tags[r];
      if (uN(e, o.tag) && (o.namespace === void 0 || e.namespaceURI == o.namespace) && (!o.context || t.matchesContext(o.context))) {
        if (o.getAttrs) {
          let s = o.getAttrs(e);
          if (s === !1)
            continue;
          o.attrs = s || void 0;
        }
        return o;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(e, t, i, r) {
    for (let o = r ? this.styles.indexOf(r) + 1 : 0; o < this.styles.length; o++) {
      let s = this.styles[o], a = s.style;
      if (!(a.indexOf(e) != 0 || s.context && !i.matchesContext(s.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      a.length > e.length && (a.charCodeAt(e.length) != 61 || a.slice(e.length + 1) != t))) {
        if (s.getAttrs) {
          let l = s.getAttrs(t);
          if (l === !1)
            continue;
          s.attrs = l || void 0;
        }
        return s;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(e) {
    let t = [];
    function i(r) {
      let o = r.priority == null ? 50 : r.priority, s = 0;
      for (; s < t.length; s++) {
        let a = t[s];
        if ((a.priority == null ? 50 : a.priority) < o)
          break;
      }
      t.splice(s, 0, r);
    }
    for (let r in e.marks) {
      let o = e.marks[r].spec.parseDOM;
      o && o.forEach((s) => {
        i(s = Rc(s)), s.mark || s.ignore || s.clearMark || (s.mark = r);
      });
    }
    for (let r in e.nodes) {
      let o = e.nodes[r].spec.parseDOM;
      o && o.forEach((s) => {
        i(s = Rc(s)), s.node || s.ignore || s.mark || (s.node = r);
      });
    }
    return t;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.GenericParseRule.priority).
  */
  static fromSchema(e) {
    return e.cached.domParser || (e.cached.domParser = new zn(e, zn.schemaRules(e)));
  }
}
const Xh = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, lN = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, Qh = { ol: !0, ul: !0 }, br = 1, Wa = 2, er = 4;
function Lc(n, e, t) {
  return e != null ? (e ? br : 0) | (e === "full" ? Wa : 0) : n && n.whitespace == "pre" ? br | Wa : t & ~er;
}
class Wr {
  constructor(e, t, i, r, o, s) {
    this.type = e, this.attrs = t, this.marks = i, this.solid = r, this.options = s, this.content = [], this.activeMarks = fe.none, this.match = o || (s & er ? null : e.contentMatch);
  }
  findWrapping(e) {
    if (!this.match) {
      if (!this.type)
        return [];
      let t = this.type.contentMatch.fillBefore(M.from(e));
      if (t)
        this.match = this.type.contentMatch.matchFragment(t);
      else {
        let i = this.type.contentMatch, r;
        return (r = i.findWrapping(e.type)) ? (this.match = i, r) : null;
      }
    }
    return this.match.findWrapping(e.type);
  }
  finish(e) {
    if (!(this.options & br)) {
      let i = this.content[this.content.length - 1], r;
      if (i && i.isText && (r = /[ \t\r\n\u000c]+$/.exec(i.text))) {
        let o = i;
        i.text.length == r[0].length ? this.content.pop() : this.content[this.content.length - 1] = o.withText(o.text.slice(0, o.text.length - r[0].length));
      }
    }
    let t = M.from(this.content);
    return !e && this.match && (t = t.append(this.match.fillBefore(M.empty, !0))), this.type ? this.type.create(this.attrs, t, this.marks) : t;
  }
  inlineContext(e) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : e.parentNode && !Xh.hasOwnProperty(e.parentNode.nodeName.toLowerCase());
  }
}
class Dc {
  constructor(e, t, i) {
    this.parser = e, this.options = t, this.isOpen = i, this.open = 0, this.localPreserveWS = !1;
    let r = t.topNode, o, s = Lc(null, t.preserveWhitespace, 0) | (i ? er : 0);
    r ? o = new Wr(r.type, r.attrs, fe.none, !0, t.topMatch || r.type.contentMatch, s) : i ? o = new Wr(null, null, fe.none, !0, null, s) : o = new Wr(e.schema.topNodeType, null, fe.none, !0, null, s), this.nodes = [o], this.find = t.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(e, t) {
    e.nodeType == 3 ? this.addTextNode(e, t) : e.nodeType == 1 && this.addElement(e, t);
  }
  addTextNode(e, t) {
    let i = e.nodeValue, r = this.top, o = r.options & Wa ? "full" : this.localPreserveWS || (r.options & br) > 0, { schema: s } = this.parser;
    if (o === "full" || r.inlineContext(e) || /[^ \t\r\n\u000c]/.test(i)) {
      if (o)
        if (o === "full")
          i = i.replace(/\r\n?/g, `
`);
        else if (s.linebreakReplacement && /[\r\n]/.test(i) && this.top.findWrapping(s.linebreakReplacement.create())) {
          let a = i.split(/\r?\n|\r/);
          for (let l = 0; l < a.length; l++)
            l && this.insertNode(s.linebreakReplacement.create(), t, !0), a[l] && this.insertNode(s.text(a[l]), t, !/\S/.test(a[l]));
          i = "";
        } else
          i = i.replace(/\r?\n|\r/g, " ");
      else if (i = i.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(i) && this.open == this.nodes.length - 1) {
        let a = r.content[r.content.length - 1], l = e.previousSibling;
        (!a || l && l.nodeName == "BR" || a.isText && /[ \t\r\n\u000c]$/.test(a.text)) && (i = i.slice(1));
      }
      i && this.insertNode(s.text(i), t, !/\S/.test(i)), this.findInText(e);
    } else
      this.findInside(e);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(e, t, i) {
    let r = this.localPreserveWS, o = this.top;
    (e.tagName == "PRE" || /pre/.test(e.style && e.style.whiteSpace)) && (this.localPreserveWS = !0);
    let s = e.nodeName.toLowerCase(), a;
    Qh.hasOwnProperty(s) && this.parser.normalizeLists && cN(e);
    let l = this.options.ruleFromNode && this.options.ruleFromNode(e) || (a = this.parser.matchTag(e, this, i));
    e: if (l ? l.ignore : lN.hasOwnProperty(s))
      this.findInside(e), this.ignoreFallback(e, t);
    else if (!l || l.skip || l.closeParent) {
      l && l.closeParent ? this.open = Math.max(0, this.open - 1) : l && l.skip.nodeType && (e = l.skip);
      let c, u = this.needsBlock;
      if (Xh.hasOwnProperty(s))
        o.content.length && o.content[0].isInline && this.open && (this.open--, o = this.top), c = !0, o.type || (this.needsBlock = !0);
      else if (!e.firstChild) {
        this.leafFallback(e, t);
        break e;
      }
      let d = l && l.skip ? t : this.readStyles(e, t);
      d && this.addAll(e, d), c && this.sync(o), this.needsBlock = u;
    } else {
      let c = this.readStyles(e, t);
      c && this.addElementByRule(e, l, c, l.consuming === !1 ? a : void 0);
    }
    this.localPreserveWS = r;
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(e, t) {
    e.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(e.ownerDocument.createTextNode(`
`), t);
  }
  // Called for ignored nodes
  ignoreFallback(e, t) {
    e.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"), t, !0);
  }
  // Run any style parser associated with the node's styles. Either
  // return an updated array of marks, or null to indicate some of the
  // styles had a rule with `ignore` set.
  readStyles(e, t) {
    let i = e.style;
    if (i && i.length)
      for (let r = 0; r < this.parser.matchedStyles.length; r++) {
        let o = this.parser.matchedStyles[r], s = i.getPropertyValue(o);
        if (s)
          for (let a = void 0; ; ) {
            let l = this.parser.matchStyle(o, s, this, a);
            if (!l)
              break;
            if (l.ignore)
              return null;
            if (l.clearMark ? t = t.filter((c) => !l.clearMark(c)) : t = t.concat(this.parser.schema.marks[l.mark].create(l.attrs)), l.consuming === !1)
              a = l;
            else
              break;
          }
      }
    return t;
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(e, t, i, r) {
    let o, s;
    if (t.node)
      if (s = this.parser.schema.nodes[t.node], s.isLeaf)
        this.insertNode(s.create(t.attrs), i, e.nodeName == "BR") || this.leafFallback(e, i);
      else {
        let l = this.enter(s, t.attrs || null, i, t.preserveWhitespace);
        l && (o = !0, i = l);
      }
    else {
      let l = this.parser.schema.marks[t.mark];
      i = i.concat(l.create(t.attrs));
    }
    let a = this.top;
    if (s && s.isLeaf)
      this.findInside(e);
    else if (r)
      this.addElement(e, i, r);
    else if (t.getContent)
      this.findInside(e), t.getContent(e, this.parser.schema).forEach((l) => this.insertNode(l, i, !1));
    else {
      let l = e;
      typeof t.contentElement == "string" ? l = e.querySelector(t.contentElement) : typeof t.contentElement == "function" ? l = t.contentElement(e) : t.contentElement && (l = t.contentElement), this.findAround(e, l, !0), this.addAll(l, i), this.findAround(e, l, !1);
    }
    o && this.sync(a) && this.open--;
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(e, t, i, r) {
    let o = i || 0;
    for (let s = i ? e.childNodes[i] : e.firstChild, a = r == null ? null : e.childNodes[r]; s != a; s = s.nextSibling, ++o)
      this.findAtPoint(e, o), this.addDOM(s, t);
    this.findAtPoint(e, o);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(e, t, i) {
    let r, o;
    for (let s = this.open, a = 0; s >= 0; s--) {
      let l = this.nodes[s], c = l.findWrapping(e);
      if (c && (!r || r.length > c.length + a) && (r = c, o = l, !c.length))
        break;
      if (l.solid) {
        if (i)
          break;
        a += 2;
      }
    }
    if (!r)
      return null;
    this.sync(o);
    for (let s = 0; s < r.length; s++)
      t = this.enterInner(r[s], null, t, !1);
    return t;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(e, t, i) {
    if (e.isInline && this.needsBlock && !this.top.type) {
      let o = this.textblockFromContext();
      o && (t = this.enterInner(o, null, t));
    }
    let r = this.findPlace(e, t, i);
    if (r) {
      this.closeExtra();
      let o = this.top;
      o.match && (o.match = o.match.matchType(e.type));
      let s = fe.none;
      for (let a of r.concat(e.marks))
        (o.type ? o.type.allowsMarkType(a.type) : Ic(a.type, e.type)) && (s = a.addToSet(s));
      return o.content.push(e.mark(s)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(e, t, i, r) {
    let o = this.findPlace(e.create(t), i, !1);
    return o && (o = this.enterInner(e, t, i, !0, r)), o;
  }
  // Open a node of the given type
  enterInner(e, t, i, r = !1, o) {
    this.closeExtra();
    let s = this.top;
    s.match = s.match && s.match.matchType(e);
    let a = Lc(e, o, s.options);
    s.options & er && s.content.length == 0 && (a |= er);
    let l = fe.none;
    return i = i.filter((c) => (s.type ? s.type.allowsMarkType(c.type) : Ic(c.type, e)) ? (l = c.addToSet(l), !1) : !0), this.nodes.push(new Wr(e, t, l, r, null, a)), this.open++, i;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(e = !1) {
    let t = this.nodes.length - 1;
    if (t > this.open) {
      for (; t > this.open; t--)
        this.nodes[t - 1].content.push(this.nodes[t].finish(e));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
  }
  sync(e) {
    for (let t = this.open; t >= 0; t--) {
      if (this.nodes[t] == e)
        return this.open = t, !0;
      this.localPreserveWS && (this.nodes[t].options |= br);
    }
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let e = 0;
    for (let t = this.open; t >= 0; t--) {
      let i = this.nodes[t].content;
      for (let r = i.length - 1; r >= 0; r--)
        e += i[r].nodeSize;
      t && e++;
    }
    return e;
  }
  findAtPoint(e, t) {
    if (this.find)
      for (let i = 0; i < this.find.length; i++)
        this.find[i].node == e && this.find[i].offset == t && (this.find[i].pos = this.currentPos);
  }
  findInside(e) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].pos == null && e.nodeType == 1 && e.contains(this.find[t].node) && (this.find[t].pos = this.currentPos);
  }
  findAround(e, t, i) {
    if (e != t && this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].pos == null && e.nodeType == 1 && e.contains(this.find[r].node) && t.compareDocumentPosition(this.find[r].node) & (i ? 2 : 4) && (this.find[r].pos = this.currentPos);
  }
  findInText(e) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].node == e && (this.find[t].pos = this.currentPos - (e.nodeValue.length - this.find[t].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(e) {
    if (e.indexOf("|") > -1)
      return e.split(/\s*\|\s*/).some(this.matchesContext, this);
    let t = e.split("/"), i = this.options.context, r = !this.isOpen && (!i || i.parent.type == this.nodes[0].type), o = -(i ? i.depth + 1 : 0) + (r ? 0 : 1), s = (a, l) => {
      for (; a >= 0; a--) {
        let c = t[a];
        if (c == "") {
          if (a == t.length - 1 || a == 0)
            continue;
          for (; l >= o; l--)
            if (s(a - 1, l))
              return !0;
          return !1;
        } else {
          let u = l > 0 || l == 0 && r ? this.nodes[l].type : i && l >= o ? i.node(l - o).type : null;
          if (!u || u.name != c && !u.isInGroup(c))
            return !1;
          l--;
        }
      }
      return !0;
    };
    return s(t.length - 1, this.open);
  }
  textblockFromContext() {
    let e = this.options.context;
    if (e)
      for (let t = e.depth; t >= 0; t--) {
        let i = e.node(t).contentMatchAt(e.indexAfter(t)).defaultType;
        if (i && i.isTextblock && i.defaultAttrs)
          return i;
      }
    for (let t in this.parser.schema.nodes) {
      let i = this.parser.schema.nodes[t];
      if (i.isTextblock && i.defaultAttrs)
        return i;
    }
  }
}
function cN(n) {
  for (let e = n.firstChild, t = null; e; e = e.nextSibling) {
    let i = e.nodeType == 1 ? e.nodeName.toLowerCase() : null;
    i && Qh.hasOwnProperty(i) && t ? (t.appendChild(e), e = t) : i == "li" ? t = e : i && (t = null);
  }
}
function uN(n, e) {
  return (n.matches || n.msMatchesSelector || n.webkitMatchesSelector || n.mozMatchesSelector).call(n, e);
}
function Rc(n) {
  let e = {};
  for (let t in n)
    e[t] = n[t];
  return e;
}
function Ic(n, e) {
  let t = e.schema.nodes;
  for (let i in t) {
    let r = t[i];
    if (!r.allowsMarkType(n))
      continue;
    let o = [], s = (a) => {
      o.push(a);
      for (let l = 0; l < a.edgeCount; l++) {
        let { type: c, next: u } = a.edge(l);
        if (c == e || o.indexOf(u) < 0 && s(u))
          return !0;
      }
    };
    if (s(r.contentMatch))
      return !0;
  }
}
class fi {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(e, t) {
    this.nodes = e, this.marks = t;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(e, t = {}, i) {
    i || (i = Ys(t).createDocumentFragment());
    let r = i, o = [];
    return e.forEach((s) => {
      if (o.length || s.marks.length) {
        let a = 0, l = 0;
        for (; a < o.length && l < s.marks.length; ) {
          let c = s.marks[l];
          if (!this.marks[c.type.name]) {
            l++;
            continue;
          }
          if (!c.eq(o[a][0]) || c.type.spec.spanning === !1)
            break;
          a++, l++;
        }
        for (; a < o.length; )
          r = o.pop()[1];
        for (; l < s.marks.length; ) {
          let c = s.marks[l++], u = this.serializeMark(c, s.isInline, t);
          u && (o.push([c, r]), r.appendChild(u.dom), r = u.contentDOM || u.dom);
        }
      }
      r.appendChild(this.serializeNodeInner(s, t));
    }), i;
  }
  /**
  @internal
  */
  serializeNodeInner(e, t) {
    let { dom: i, contentDOM: r } = mo(Ys(t), this.nodes[e.type.name](e), null, e.attrs);
    if (r) {
      if (e.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(e.content, t, r);
    }
    return i;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(e, t = {}) {
    let i = this.serializeNodeInner(e, t);
    for (let r = e.marks.length - 1; r >= 0; r--) {
      let o = this.serializeMark(e.marks[r], e.isInline, t);
      o && ((o.contentDOM || o.dom).appendChild(i), i = o.dom);
    }
    return i;
  }
  /**
  @internal
  */
  serializeMark(e, t, i = {}) {
    let r = this.marks[e.type.name];
    return r && mo(Ys(i), r(e, t), null, e.attrs);
  }
  static renderSpec(e, t, i = null, r) {
    return mo(e, t, i, r);
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(e) {
    return e.cached.domSerializer || (e.cached.domSerializer = new fi(this.nodesFromSchema(e), this.marksFromSchema(e)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(e) {
    let t = Pc(e.nodes);
    return t.text || (t.text = (i) => i.text), t;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(e) {
    return Pc(e.marks);
  }
}
function Pc(n) {
  let e = {};
  for (let t in n) {
    let i = n[t].spec.toDOM;
    i && (e[t] = i);
  }
  return e;
}
function Ys(n) {
  return n.document || window.document;
}
const jc = /* @__PURE__ */ new WeakMap();
function dN(n) {
  let e = jc.get(n);
  return e === void 0 && jc.set(n, e = hN(n)), e;
}
function hN(n) {
  let e = null;
  function t(i) {
    if (i && typeof i == "object")
      if (Array.isArray(i))
        if (typeof i[0] == "string")
          e || (e = []), e.push(i);
        else
          for (let r = 0; r < i.length; r++)
            t(i[r]);
      else
        for (let r in i)
          t(i[r]);
  }
  return t(n), e;
}
function mo(n, e, t, i) {
  if (typeof e == "string")
    return { dom: n.createTextNode(e) };
  if (e.nodeType != null)
    return { dom: e };
  if (e.dom && e.dom.nodeType != null)
    return e;
  let r = e[0], o;
  if (typeof r != "string")
    throw new RangeError("Invalid array passed to renderSpec");
  if (i && (o = dN(i)) && o.indexOf(e) > -1)
    throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
  let s = r.indexOf(" ");
  s > 0 && (t = r.slice(0, s), r = r.slice(s + 1));
  let a, l = t ? n.createElementNS(t, r) : n.createElement(r), c = e[1], u = 1;
  if (c && typeof c == "object" && c.nodeType == null && !Array.isArray(c)) {
    u = 2;
    for (let d in c)
      if (c[d] != null) {
        let h = d.indexOf(" ");
        h > 0 ? l.setAttributeNS(d.slice(0, h), d.slice(h + 1), c[d]) : d == "style" && l.style ? l.style.cssText = c[d] : l.setAttribute(d, c[d]);
      }
  }
  for (let d = u; d < e.length; d++) {
    let h = e[d];
    if (h === 0) {
      if (d < e.length - 1 || d > u)
        throw new RangeError("Content hole must be the only child of its parent node");
      return { dom: l, contentDOM: l };
    } else {
      let { dom: f, contentDOM: p } = mo(n, h, t, i);
      if (l.appendChild(f), p) {
        if (a)
          throw new RangeError("Multiple content holes");
        a = p;
      }
    }
  }
  return { dom: l, contentDOM: a };
}
const ef = 65535, tf = Math.pow(2, 16);
function fN(n, e) {
  return n + e * tf;
}
function Bc(n) {
  return n & ef;
}
function pN(n) {
  return (n - (n & ef)) / tf;
}
const nf = 1, rf = 2, go = 4, of = 8;
class Ka {
  /**
  @internal
  */
  constructor(e, t, i) {
    this.pos = e, this.delInfo = t, this.recover = i;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & of) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (nf | go)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (rf | go)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & go) > 0;
  }
}
class ut {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(e, t = !1) {
    if (this.ranges = e, this.inverted = t, !e.length && ut.empty)
      return ut.empty;
  }
  /**
  @internal
  */
  recover(e) {
    let t = 0, i = Bc(e);
    if (!this.inverted)
      for (let r = 0; r < i; r++)
        t += this.ranges[r * 3 + 2] - this.ranges[r * 3 + 1];
    return this.ranges[i * 3] + t + pN(e);
  }
  mapResult(e, t = 1) {
    return this._map(e, t, !1);
  }
  map(e, t = 1) {
    return this._map(e, t, !0);
  }
  /**
  @internal
  */
  _map(e, t, i) {
    let r = 0, o = this.inverted ? 2 : 1, s = this.inverted ? 1 : 2;
    for (let a = 0; a < this.ranges.length; a += 3) {
      let l = this.ranges[a] - (this.inverted ? r : 0);
      if (l > e)
        break;
      let c = this.ranges[a + o], u = this.ranges[a + s], d = l + c;
      if (e <= d) {
        let h = c ? e == l ? -1 : e == d ? 1 : t : t, f = l + r + (h < 0 ? 0 : u);
        if (i)
          return f;
        let p = e == (t < 0 ? l : d) ? null : fN(a / 3, e - l), m = e == l ? rf : e == d ? nf : go;
        return (t < 0 ? e != l : e != d) && (m |= of), new Ka(f, m, p);
      }
      r += u - c;
    }
    return i ? e + r : new Ka(e + r, 0, null);
  }
  /**
  @internal
  */
  touches(e, t) {
    let i = 0, r = Bc(t), o = this.inverted ? 2 : 1, s = this.inverted ? 1 : 2;
    for (let a = 0; a < this.ranges.length; a += 3) {
      let l = this.ranges[a] - (this.inverted ? i : 0);
      if (l > e)
        break;
      let c = this.ranges[a + o], u = l + c;
      if (e <= u && a == r * 3)
        return !0;
      i += this.ranges[a + s] - c;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(e) {
    let t = this.inverted ? 2 : 1, i = this.inverted ? 1 : 2;
    for (let r = 0, o = 0; r < this.ranges.length; r += 3) {
      let s = this.ranges[r], a = s - (this.inverted ? o : 0), l = s + (this.inverted ? 0 : o), c = this.ranges[r + t], u = this.ranges[r + i];
      e(a, a + c, l, l + u), o += u - c;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new ut(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(e) {
    return e == 0 ? ut.empty : new ut(e < 0 ? [0, -e, 0] : [0, 0, e]);
  }
}
ut.empty = new ut([]);
class kr {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(e, t, i = 0, r = e ? e.length : 0) {
    this.mirror = t, this.from = i, this.to = r, this._maps = e || [], this.ownData = !(e || t);
  }
  /**
  The step maps in this mapping.
  */
  get maps() {
    return this._maps;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(e = 0, t = this.maps.length) {
    return new kr(this._maps, this.mirror, e, t);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(e, t) {
    this.ownData || (this._maps = this._maps.slice(), this.mirror = this.mirror && this.mirror.slice(), this.ownData = !0), this.to = this._maps.push(e), t != null && this.setMirror(this._maps.length - 1, t);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(e) {
    for (let t = 0, i = this._maps.length; t < e._maps.length; t++) {
      let r = e.getMirror(t);
      this.appendMap(e._maps[t], r != null && r < t ? i + r : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(e) {
    if (this.mirror) {
      for (let t = 0; t < this.mirror.length; t++)
        if (this.mirror[t] == e)
          return this.mirror[t + (t % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(e, t) {
    this.mirror || (this.mirror = []), this.mirror.push(e, t);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(e) {
    for (let t = e.maps.length - 1, i = this._maps.length + e._maps.length; t >= 0; t--) {
      let r = e.getMirror(t);
      this.appendMap(e._maps[t].invert(), r != null && r > t ? i - r - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let e = new kr();
    return e.appendMappingInverted(this), e;
  }
  /**
  Map a position through this mapping.
  */
  map(e, t = 1) {
    if (this.mirror)
      return this._map(e, t, !0);
    for (let i = this.from; i < this.to; i++)
      e = this._maps[i].map(e, t);
    return e;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(e, t = 1) {
    return this._map(e, t, !1);
  }
  /**
  @internal
  */
  _map(e, t, i) {
    let r = 0;
    for (let o = this.from; o < this.to; o++) {
      let s = this._maps[o], a = s.mapResult(e, t);
      if (a.recover != null) {
        let l = this.getMirror(o);
        if (l != null && l > o && l < this.to) {
          o = l, e = this._maps[l].recover(a.recover);
          continue;
        }
      }
      r |= a.delInfo, e = a.pos;
    }
    return i ? e : new Ka(e, r, null);
  }
}
const Xs = /* @__PURE__ */ Object.create(null);
class Ge {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return ut.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(e) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(e, t) {
    if (!t || !t.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let i = Xs[t.stepType];
    if (!i)
      throw new RangeError(`No step type ${t.stepType} defined`);
    return i.fromJSON(e, t);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(e, t) {
    if (e in Xs)
      throw new RangeError("Duplicate use of step JSON ID " + e);
    return Xs[e] = t, t.prototype.jsonID = e, t;
  }
}
class Me {
  /**
  @internal
  */
  constructor(e, t) {
    this.doc = e, this.failed = t;
  }
  /**
  Create a successful step result.
  */
  static ok(e) {
    return new Me(e, null);
  }
  /**
  Create a failed step result.
  */
  static fail(e) {
    return new Me(null, e);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(e, t, i, r) {
    try {
      return Me.ok(e.replace(t, i, r));
    } catch (o) {
      if (o instanceof Mo)
        return Me.fail(o.message);
      throw o;
    }
  }
}
function Al(n, e, t) {
  let i = [];
  for (let r = 0; r < n.childCount; r++) {
    let o = n.child(r);
    o.content.size && (o = o.copy(Al(o.content, e, o))), o.isInline && (o = e(o, t, r)), i.push(o);
  }
  return M.fromArray(i);
}
class Tn extends Ge {
  /**
  Create a mark step.
  */
  constructor(e, t, i) {
    super(), this.from = e, this.to = t, this.mark = i;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), i = e.resolve(this.from), r = i.node(i.sharedDepth(this.to)), o = new L(Al(t.content, (s, a) => !s.isAtom || !a.type.allowsMarkType(this.mark.type) ? s : s.mark(this.mark.addToSet(s.marks)), r), t.openStart, t.openEnd);
    return Me.fromReplace(e, this.from, this.to, o);
  }
  invert() {
    return new Bt(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), i = e.mapResult(this.to, -1);
    return t.deleted && i.deleted || t.pos >= i.pos ? null : new Tn(t.pos, i.pos, this.mark);
  }
  merge(e) {
    return e instanceof Tn && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new Tn(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new Tn(t.from, t.to, e.markFromJSON(t.mark));
  }
}
Ge.jsonID("addMark", Tn);
class Bt extends Ge {
  /**
  Create a mark-removing step.
  */
  constructor(e, t, i) {
    super(), this.from = e, this.to = t, this.mark = i;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), i = new L(Al(t.content, (r) => r.mark(this.mark.removeFromSet(r.marks)), e), t.openStart, t.openEnd);
    return Me.fromReplace(e, this.from, this.to, i);
  }
  invert() {
    return new Tn(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), i = e.mapResult(this.to, -1);
    return t.deleted && i.deleted || t.pos >= i.pos ? null : new Bt(t.pos, i.pos, this.mark);
  }
  merge(e) {
    return e instanceof Bt && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new Bt(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new Bt(t.from, t.to, e.markFromJSON(t.mark));
  }
}
Ge.jsonID("removeMark", Bt);
class Mn extends Ge {
  /**
  Create a node mark step.
  */
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return Me.fail("No node at mark step's position");
    let i = t.type.create(t.attrs, null, this.mark.addToSet(t.marks));
    return Me.fromReplace(e, this.pos, this.pos + 1, new L(M.from(i), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    if (t) {
      let i = this.mark.addToSet(t.marks);
      if (i.length == t.marks.length) {
        for (let r = 0; r < t.marks.length; r++)
          if (!t.marks[r].isInSet(i))
            return new Mn(this.pos, t.marks[r]);
        return new Mn(this.pos, this.mark);
      }
    }
    return new ci(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new Mn(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new Mn(t.pos, e.markFromJSON(t.mark));
  }
}
Ge.jsonID("addNodeMark", Mn);
class ci extends Ge {
  /**
  Create a mark-removing step.
  */
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return Me.fail("No node at mark step's position");
    let i = t.type.create(t.attrs, null, this.mark.removeFromSet(t.marks));
    return Me.fromReplace(e, this.pos, this.pos + 1, new L(M.from(i), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    return !t || !this.mark.isInSet(t.marks) ? this : new Mn(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new ci(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new ci(t.pos, e.markFromJSON(t.mark));
  }
}
Ge.jsonID("removeNodeMark", ci);
class De extends Ge {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(e, t, i, r = !1) {
    super(), this.from = e, this.to = t, this.slice = i, this.structure = r;
  }
  apply(e) {
    return this.structure && Za(e, this.from, this.to) ? Me.fail("Structure replace would overwrite content") : Me.fromReplace(e, this.from, this.to, this.slice);
  }
  getMap() {
    return new ut([this.from, this.to - this.from, this.slice.size]);
  }
  invert(e) {
    return new De(this.from, this.from + this.slice.size, e.slice(this.from, this.to));
  }
  map(e) {
    let t = e.mapResult(this.from, 1), i = e.mapResult(this.to, -1);
    return t.deletedAcross && i.deletedAcross ? null : new De(t.pos, Math.max(t.pos, i.pos), this.slice, this.structure);
  }
  merge(e) {
    if (!(e instanceof De) || e.structure || this.structure)
      return null;
    if (this.from + this.slice.size == e.from && !this.slice.openEnd && !e.slice.openStart) {
      let t = this.slice.size + e.slice.size == 0 ? L.empty : new L(this.slice.content.append(e.slice.content), this.slice.openStart, e.slice.openEnd);
      return new De(this.from, this.to + (e.to - e.from), t, this.structure);
    } else if (e.to == this.from && !this.slice.openStart && !e.slice.openEnd) {
      let t = this.slice.size + e.slice.size == 0 ? L.empty : new L(e.slice.content.append(this.slice.content), e.slice.openStart, this.slice.openEnd);
      return new De(e.from, this.to, t, this.structure);
    } else
      return null;
  }
  toJSON() {
    let e = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new De(t.from, t.to, L.fromJSON(e, t.slice), !!t.structure);
  }
}
Ge.jsonID("replace", De);
class Re extends Ge {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(e, t, i, r, o, s, a = !1) {
    super(), this.from = e, this.to = t, this.gapFrom = i, this.gapTo = r, this.slice = o, this.insert = s, this.structure = a;
  }
  apply(e) {
    if (this.structure && (Za(e, this.from, this.gapFrom) || Za(e, this.gapTo, this.to)))
      return Me.fail("Structure gap-replace would overwrite content");
    let t = e.slice(this.gapFrom, this.gapTo);
    if (t.openStart || t.openEnd)
      return Me.fail("Gap is not a flat range");
    let i = this.slice.insertAt(this.insert, t.content);
    return i ? Me.fromReplace(e, this.from, this.to, i) : Me.fail("Content does not fit in gap");
  }
  getMap() {
    return new ut([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(e) {
    let t = this.gapTo - this.gapFrom;
    return new Re(this.from, this.from + this.slice.size + t, this.from + this.insert, this.from + this.insert + t, e.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), i = e.mapResult(this.to, -1), r = this.from == this.gapFrom ? t.pos : e.map(this.gapFrom, -1), o = this.to == this.gapTo ? i.pos : e.map(this.gapTo, 1);
    return t.deletedAcross && i.deletedAcross || r < t.pos || o > i.pos ? null : new Re(t.pos, i.pos, r, o, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let e = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number" || typeof t.gapFrom != "number" || typeof t.gapTo != "number" || typeof t.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new Re(t.from, t.to, t.gapFrom, t.gapTo, L.fromJSON(e, t.slice), t.insert, !!t.structure);
  }
}
Ge.jsonID("replaceAround", Re);
function Za(n, e, t) {
  let i = n.resolve(e), r = t - e, o = i.depth;
  for (; r > 0 && o > 0 && i.indexAfter(o) == i.node(o).childCount; )
    o--, r--;
  if (r > 0) {
    let s = i.node(o).maybeChild(i.indexAfter(o));
    for (; r > 0; ) {
      if (!s || s.isLeaf)
        return !0;
      s = s.firstChild, r--;
    }
  }
  return !1;
}
function mN(n, e, t, i) {
  let r = [], o = [], s, a;
  n.doc.nodesBetween(e, t, (l, c, u) => {
    if (!l.isInline)
      return;
    let d = l.marks;
    if (!i.isInSet(d) && u.type.allowsMarkType(i.type)) {
      let h = Math.max(c, e), f = Math.min(c + l.nodeSize, t), p = i.addToSet(d);
      for (let m = 0; m < d.length; m++)
        d[m].isInSet(p) || (s && s.to == h && s.mark.eq(d[m]) ? s.to = f : r.push(s = new Bt(h, f, d[m])));
      a && a.to == h ? a.to = f : o.push(a = new Tn(h, f, i));
    }
  }), r.forEach((l) => n.step(l)), o.forEach((l) => n.step(l));
}
function gN(n, e, t, i) {
  let r = [], o = 0;
  n.doc.nodesBetween(e, t, (s, a) => {
    if (!s.isInline)
      return;
    o++;
    let l = null;
    if (i instanceof Ms) {
      let c = s.marks, u;
      for (; u = i.isInSet(c); )
        (l || (l = [])).push(u), c = u.removeFromSet(c);
    } else i ? i.isInSet(s.marks) && (l = [i]) : l = s.marks;
    if (l && l.length) {
      let c = Math.min(a + s.nodeSize, t);
      for (let u = 0; u < l.length; u++) {
        let d = l[u], h;
        for (let f = 0; f < r.length; f++) {
          let p = r[f];
          p.step == o - 1 && d.eq(r[f].style) && (h = p);
        }
        h ? (h.to = c, h.step = o) : r.push({ style: d, from: Math.max(a, e), to: c, step: o });
      }
    }
  }), r.forEach((s) => n.step(new Bt(s.from, s.to, s.style)));
}
function Nl(n, e, t, i = t.contentMatch, r = !0) {
  let o = n.doc.nodeAt(e), s = [], a = e + 1;
  for (let l = 0; l < o.childCount; l++) {
    let c = o.child(l), u = a + c.nodeSize, d = i.matchType(c.type);
    if (!d)
      s.push(new De(a, u, L.empty));
    else {
      i = d;
      for (let h = 0; h < c.marks.length; h++)
        t.allowsMarkType(c.marks[h].type) || n.step(new Bt(a, u, c.marks[h]));
      if (r && c.isText && t.whitespace != "pre") {
        let h, f = /\r?\n|\r/g, p;
        for (; h = f.exec(c.text); )
          p || (p = new L(M.from(t.schema.text(" ", t.allowedMarks(c.marks))), 0, 0)), s.push(new De(a + h.index, a + h.index + h[0].length, p));
      }
    }
    a = u;
  }
  if (!i.validEnd) {
    let l = i.fillBefore(M.empty, !0);
    n.replace(a, a, new L(l, 0, 0));
  }
  for (let l = s.length - 1; l >= 0; l--)
    n.step(s[l]);
}
function _N(n, e, t) {
  return (e == 0 || n.canReplace(e, n.childCount)) && (t == n.childCount || n.canReplace(0, t));
}
function Hi(n) {
  let t = n.parent.content.cutByIndex(n.startIndex, n.endIndex);
  for (let i = n.depth; ; --i) {
    let r = n.$from.node(i), o = n.$from.index(i), s = n.$to.indexAfter(i);
    if (i < n.depth && r.canReplace(o, s, t))
      return i;
    if (i == 0 || r.type.spec.isolating || !_N(r, o, s))
      break;
  }
  return null;
}
function bN(n, e, t) {
  let { $from: i, $to: r, depth: o } = e, s = i.before(o + 1), a = r.after(o + 1), l = s, c = a, u = M.empty, d = 0;
  for (let p = o, m = !1; p > t; p--)
    m || i.index(p) > 0 ? (m = !0, u = M.from(i.node(p).copy(u)), d++) : l--;
  let h = M.empty, f = 0;
  for (let p = o, m = !1; p > t; p--)
    m || r.after(p + 1) < r.end(p) ? (m = !0, h = M.from(r.node(p).copy(h)), f++) : c++;
  n.step(new Re(l, c, s, a, new L(u.append(h), d, f), u.size - d, !0));
}
function Ll(n, e, t = null, i = n) {
  let r = kN(n, e), o = r && yN(i, e);
  return o ? r.map(Fc).concat({ type: e, attrs: t }).concat(o.map(Fc)) : null;
}
function Fc(n) {
  return { type: n, attrs: null };
}
function kN(n, e) {
  let { parent: t, startIndex: i, endIndex: r } = n, o = t.contentMatchAt(i).findWrapping(e);
  if (!o)
    return null;
  let s = o.length ? o[0] : e;
  return t.canReplaceWith(i, r, s) ? o : null;
}
function yN(n, e) {
  let { parent: t, startIndex: i, endIndex: r } = n, o = t.child(i), s = e.contentMatch.findWrapping(o.type);
  if (!s)
    return null;
  let l = (s.length ? s[s.length - 1] : e).contentMatch;
  for (let c = i; l && c < r; c++)
    l = l.matchType(t.child(c).type);
  return !l || !l.validEnd ? null : s;
}
function vN(n, e, t) {
  let i = M.empty;
  for (let s = t.length - 1; s >= 0; s--) {
    if (i.size) {
      let a = t[s].type.contentMatch.matchFragment(i);
      if (!a || !a.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    i = M.from(t[s].type.create(t[s].attrs, i));
  }
  let r = e.start, o = e.end;
  n.step(new Re(r, o, r, o, new L(i, 0, 0), t.length, !0));
}
function xN(n, e, t, i, r) {
  if (!i.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let o = n.steps.length;
  n.doc.nodesBetween(e, t, (s, a) => {
    let l = typeof r == "function" ? r(s) : r;
    if (s.isTextblock && !s.hasMarkup(i, l) && SN(n.doc, n.mapping.slice(o).map(a), i)) {
      let c = null;
      if (i.schema.linebreakReplacement) {
        let f = i.whitespace == "pre", p = !!i.contentMatch.matchType(i.schema.linebreakReplacement);
        f && !p ? c = !1 : !f && p && (c = !0);
      }
      c === !1 && af(n, s, a, o), Nl(n, n.mapping.slice(o).map(a, 1), i, void 0, c === null);
      let u = n.mapping.slice(o), d = u.map(a, 1), h = u.map(a + s.nodeSize, 1);
      return n.step(new Re(d, h, d + 1, h - 1, new L(M.from(i.create(l, null, s.marks)), 0, 0), 1, !0)), c === !0 && sf(n, s, a, o), !1;
    }
  });
}
function sf(n, e, t, i) {
  e.forEach((r, o) => {
    if (r.isText) {
      let s, a = /\r?\n|\r/g;
      for (; s = a.exec(r.text); ) {
        let l = n.mapping.slice(i).map(t + 1 + o + s.index);
        n.replaceWith(l, l + 1, e.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function af(n, e, t, i) {
  e.forEach((r, o) => {
    if (r.type == r.type.schema.linebreakReplacement) {
      let s = n.mapping.slice(i).map(t + 1 + o);
      n.replaceWith(s, s + 1, e.type.schema.text(`
`));
    }
  });
}
function SN(n, e, t) {
  let i = n.resolve(e), r = i.index();
  return i.parent.canReplaceWith(r, r + 1, t);
}
function wN(n, e, t, i, r) {
  let o = n.doc.nodeAt(e);
  if (!o)
    throw new RangeError("No node at given position");
  t || (t = o.type);
  let s = t.create(i, null, r || o.marks);
  if (o.isLeaf)
    return n.replaceWith(e, e + o.nodeSize, s);
  if (!t.validContent(o.content))
    throw new RangeError("Invalid content for node type " + t.name);
  n.step(new Re(e, e + o.nodeSize, e + 1, e + o.nodeSize - 1, new L(M.from(s), 0, 0), 1, !0));
}
function ln(n, e, t = 1, i) {
  let r = n.resolve(e), o = r.depth - t, s = i && i[i.length - 1] || r.parent;
  if (o < 0 || r.parent.type.spec.isolating || !r.parent.canReplace(r.index(), r.parent.childCount) || !s.type.validContent(r.parent.content.cutByIndex(r.index(), r.parent.childCount)))
    return !1;
  for (let c = r.depth - 1, u = t - 2; c > o; c--, u--) {
    let d = r.node(c), h = r.index(c);
    if (d.type.spec.isolating)
      return !1;
    let f = d.content.cutByIndex(h, d.childCount), p = i && i[u + 1];
    p && (f = f.replaceChild(0, p.type.create(p.attrs)));
    let m = i && i[u] || d;
    if (!d.canReplace(h + 1, d.childCount) || !m.type.validContent(f))
      return !1;
  }
  let a = r.indexAfter(o), l = i && i[0];
  return r.node(o).canReplaceWith(a, a, l ? l.type : r.node(o + 1).type);
}
function CN(n, e, t = 1, i) {
  let r = n.doc.resolve(e), o = M.empty, s = M.empty;
  for (let a = r.depth, l = r.depth - t, c = t - 1; a > l; a--, c--) {
    o = M.from(r.node(a).copy(o));
    let u = i && i[c];
    s = M.from(u ? u.type.create(u.attrs, s) : r.node(a).copy(s));
  }
  n.step(new De(e, e, new L(o.append(s), t, t), !0));
}
function In(n, e) {
  let t = n.resolve(e), i = t.index();
  return lf(t.nodeBefore, t.nodeAfter) && t.parent.canReplace(i, i + 1);
}
function TN(n, e) {
  e.content.size || n.type.compatibleContent(e.type);
  let t = n.contentMatchAt(n.childCount), { linebreakReplacement: i } = n.type.schema;
  for (let r = 0; r < e.childCount; r++) {
    let o = e.child(r), s = o.type == i ? n.type.schema.nodes.text : o.type;
    if (t = t.matchType(s), !t || !n.type.allowsMarks(o.marks))
      return !1;
  }
  return t.validEnd;
}
function lf(n, e) {
  return !!(n && e && !n.isLeaf && TN(n, e));
}
function Es(n, e, t = -1) {
  let i = n.resolve(e);
  for (let r = i.depth; ; r--) {
    let o, s, a = i.index(r);
    if (r == i.depth ? (o = i.nodeBefore, s = i.nodeAfter) : t > 0 ? (o = i.node(r + 1), a++, s = i.node(r).maybeChild(a)) : (o = i.node(r).maybeChild(a - 1), s = i.node(r + 1)), o && !o.isTextblock && lf(o, s) && i.node(r).canReplace(a, a + 1))
      return e;
    if (r == 0)
      break;
    e = t < 0 ? i.before(r) : i.after(r);
  }
}
function MN(n, e, t) {
  let i = null, { linebreakReplacement: r } = n.doc.type.schema, o = n.doc.resolve(e - t), s = o.node().type;
  if (r && s.inlineContent) {
    let u = s.whitespace == "pre", d = !!s.contentMatch.matchType(r);
    u && !d ? i = !1 : !u && d && (i = !0);
  }
  let a = n.steps.length;
  if (i === !1) {
    let u = n.doc.resolve(e + t);
    af(n, u.node(), u.before(), a);
  }
  s.inlineContent && Nl(n, e + t - 1, s, o.node().contentMatchAt(o.index()), i == null);
  let l = n.mapping.slice(a), c = l.map(e - t);
  if (n.step(new De(c, l.map(e + t, -1), L.empty, !0)), i === !0) {
    let u = n.doc.resolve(c);
    sf(n, u.node(), u.before(), n.steps.length);
  }
  return n;
}
function EN(n, e, t) {
  let i = n.resolve(e);
  if (i.parent.canReplaceWith(i.index(), i.index(), t))
    return e;
  if (i.parentOffset == 0)
    for (let r = i.depth - 1; r >= 0; r--) {
      let o = i.index(r);
      if (i.node(r).canReplaceWith(o, o, t))
        return i.before(r + 1);
      if (o > 0)
        return null;
    }
  if (i.parentOffset == i.parent.content.size)
    for (let r = i.depth - 1; r >= 0; r--) {
      let o = i.indexAfter(r);
      if (i.node(r).canReplaceWith(o, o, t))
        return i.after(r + 1);
      if (o < i.node(r).childCount)
        return null;
    }
  return null;
}
function cf(n, e, t) {
  let i = n.resolve(e);
  if (!t.content.size)
    return e;
  let r = t.content;
  for (let o = 0; o < t.openStart; o++)
    r = r.firstChild.content;
  for (let o = 1; o <= (t.openStart == 0 && t.size ? 2 : 1); o++)
    for (let s = i.depth; s >= 0; s--) {
      let a = s == i.depth ? 0 : i.pos <= (i.start(s + 1) + i.end(s + 1)) / 2 ? -1 : 1, l = i.index(s) + (a > 0 ? 1 : 0), c = i.node(s), u = !1;
      if (o == 1)
        u = c.canReplace(l, l, r);
      else {
        let d = c.contentMatchAt(l).findWrapping(r.firstChild.type);
        u = d && c.canReplaceWith(l, l, d[0]);
      }
      if (u)
        return a == 0 ? i.pos : a < 0 ? i.before(s + 1) : i.after(s + 1);
    }
  return null;
}
function $s(n, e, t = e, i = L.empty) {
  if (e == t && !i.size)
    return null;
  let r = n.resolve(e), o = n.resolve(t);
  return uf(r, o, i) ? new De(e, t, i) : new $N(r, o, i).fit();
}
function uf(n, e, t) {
  return !t.openStart && !t.openEnd && n.start() == e.start() && n.parent.canReplace(n.index(), e.index(), t.content);
}
class $N {
  constructor(e, t, i) {
    this.$from = e, this.$to = t, this.unplaced = i, this.frontier = [], this.placed = M.empty;
    for (let r = 0; r <= e.depth; r++) {
      let o = e.node(r);
      this.frontier.push({
        type: o.type,
        match: o.contentMatchAt(e.indexAfter(r))
      });
    }
    for (let r = e.depth; r > 0; r--)
      this.placed = M.from(e.node(r).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let c = this.findFittable();
      c ? this.placeNodes(c) : this.openMore() || this.dropNode();
    }
    let e = this.mustMoveInline(), t = this.placed.size - this.depth - this.$from.depth, i = this.$from, r = this.close(e < 0 ? this.$to : i.doc.resolve(e));
    if (!r)
      return null;
    let o = this.placed, s = i.depth, a = r.depth;
    for (; s && a && o.childCount == 1; )
      o = o.firstChild.content, s--, a--;
    let l = new L(o, s, a);
    return e > -1 ? new Re(i.pos, e, this.$to.pos, this.$to.end(), l, t) : l.size || i.pos != this.$to.pos ? new De(i.pos, r.pos, l) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let e = this.unplaced.openStart;
    for (let t = this.unplaced.content, i = 0, r = this.unplaced.openEnd; i < e; i++) {
      let o = t.firstChild;
      if (t.childCount > 1 && (r = 0), o.type.spec.isolating && r <= i) {
        e = i;
        break;
      }
      t = o.content;
    }
    for (let t = 1; t <= 2; t++)
      for (let i = t == 1 ? e : this.unplaced.openStart; i >= 0; i--) {
        let r, o = null;
        i ? (o = Qs(this.unplaced.content, i - 1).firstChild, r = o.content) : r = this.unplaced.content;
        let s = r.firstChild;
        for (let a = this.depth; a >= 0; a--) {
          let { type: l, match: c } = this.frontier[a], u, d = null;
          if (t == 1 && (s ? c.matchType(s.type) || (d = c.fillBefore(M.from(s), !1)) : o && l.compatibleContent(o.type)))
            return { sliceDepth: i, frontierDepth: a, parent: o, inject: d };
          if (t == 2 && s && (u = c.findWrapping(s.type)))
            return { sliceDepth: i, frontierDepth: a, parent: o, wrap: u };
          if (o && c.matchType(o.type))
            break;
        }
      }
  }
  openMore() {
    let { content: e, openStart: t, openEnd: i } = this.unplaced, r = Qs(e, t);
    return !r.childCount || r.firstChild.isLeaf ? !1 : (this.unplaced = new L(e, t + 1, Math.max(i, r.size + t >= e.size - i ? t + 1 : 0)), !0);
  }
  dropNode() {
    let { content: e, openStart: t, openEnd: i } = this.unplaced, r = Qs(e, t);
    if (r.childCount <= 1 && t > 0) {
      let o = e.size - t <= t + r.size;
      this.unplaced = new L(Zi(e, t - 1, 1), t - 1, o ? t - 1 : i);
    } else
      this.unplaced = new L(Zi(e, t, 1), t, i);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: e, frontierDepth: t, parent: i, inject: r, wrap: o }) {
    for (; this.depth > t; )
      this.closeFrontierNode();
    if (o)
      for (let m = 0; m < o.length; m++)
        this.openFrontierNode(o[m]);
    let s = this.unplaced, a = i ? i.content : s.content, l = s.openStart - e, c = 0, u = [], { match: d, type: h } = this.frontier[t];
    if (r) {
      for (let m = 0; m < r.childCount; m++)
        u.push(r.child(m));
      d = d.matchFragment(r);
    }
    let f = a.size + e - (s.content.size - s.openEnd);
    for (; c < a.childCount; ) {
      let m = a.child(c), g = d.matchType(m.type);
      if (!g)
        break;
      c++, (c > 1 || l == 0 || m.content.size) && (d = g, u.push(df(m.mark(h.allowedMarks(m.marks)), c == 1 ? l : 0, c == a.childCount ? f : -1)));
    }
    let p = c == a.childCount;
    p || (f = -1), this.placed = Ji(this.placed, t, M.from(u)), this.frontier[t].match = d, p && f < 0 && i && i.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let m = 0, g = a; m < f; m++) {
      let k = g.lastChild;
      this.frontier.push({ type: k.type, match: k.contentMatchAt(k.childCount) }), g = k.content;
    }
    this.unplaced = p ? e == 0 ? L.empty : new L(Zi(s.content, e - 1, 1), e - 1, f < 0 ? s.openEnd : e - 1) : new L(Zi(s.content, e, c), s.openStart, s.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let e = this.frontier[this.depth], t;
    if (!e.type.isTextblock || !ea(this.$to, this.$to.depth, e.type, e.match, !1) || this.$to.depth == this.depth && (t = this.findCloseLevel(this.$to)) && t.depth == this.depth)
      return -1;
    let { depth: i } = this.$to, r = this.$to.after(i);
    for (; i > 1 && r == this.$to.end(--i); )
      ++r;
    return r;
  }
  findCloseLevel(e) {
    e: for (let t = Math.min(this.depth, e.depth); t >= 0; t--) {
      let { match: i, type: r } = this.frontier[t], o = t < e.depth && e.end(t + 1) == e.pos + (e.depth - (t + 1)), s = ea(e, t, r, i, o);
      if (s) {
        for (let a = t - 1; a >= 0; a--) {
          let { match: l, type: c } = this.frontier[a], u = ea(e, a, c, l, !0);
          if (!u || u.childCount)
            continue e;
        }
        return { depth: t, fit: s, move: o ? e.doc.resolve(e.after(t + 1)) : e };
      }
    }
  }
  close(e) {
    let t = this.findCloseLevel(e);
    if (!t)
      return null;
    for (; this.depth > t.depth; )
      this.closeFrontierNode();
    t.fit.childCount && (this.placed = Ji(this.placed, t.depth, t.fit)), e = t.move;
    for (let i = t.depth + 1; i <= e.depth; i++) {
      let r = e.node(i), o = r.type.contentMatch.fillBefore(r.content, !0, e.index(i));
      this.openFrontierNode(r.type, r.attrs, o);
    }
    return e;
  }
  openFrontierNode(e, t = null, i) {
    let r = this.frontier[this.depth];
    r.match = r.match.matchType(e), this.placed = Ji(this.placed, this.depth, M.from(e.create(t, i))), this.frontier.push({ type: e, match: e.contentMatch });
  }
  closeFrontierNode() {
    let t = this.frontier.pop().match.fillBefore(M.empty, !0);
    t.childCount && (this.placed = Ji(this.placed, this.frontier.length, t));
  }
}
function Zi(n, e, t) {
  return e == 0 ? n.cutByIndex(t, n.childCount) : n.replaceChild(0, n.firstChild.copy(Zi(n.firstChild.content, e - 1, t)));
}
function Ji(n, e, t) {
  return e == 0 ? n.append(t) : n.replaceChild(n.childCount - 1, n.lastChild.copy(Ji(n.lastChild.content, e - 1, t)));
}
function Qs(n, e) {
  for (let t = 0; t < e; t++)
    n = n.firstChild.content;
  return n;
}
function df(n, e, t) {
  if (e <= 0)
    return n;
  let i = n.content;
  return e > 1 && (i = i.replaceChild(0, df(i.firstChild, e - 1, i.childCount == 1 ? t - 1 : 0))), e > 0 && (i = n.type.contentMatch.fillBefore(i).append(i), t <= 0 && (i = i.append(n.type.contentMatch.matchFragment(i).fillBefore(M.empty, !0)))), n.copy(i);
}
function ea(n, e, t, i, r) {
  let o = n.node(e), s = r ? n.indexAfter(e) : n.index(e);
  if (s == o.childCount && !t.compatibleContent(o.type))
    return null;
  let a = i.fillBefore(o.content, !0, s);
  return a && !ON(t, o.content, s) ? a : null;
}
function ON(n, e, t) {
  for (let i = t; i < e.childCount; i++)
    if (!n.allowsMarks(e.child(i).marks))
      return !0;
  return !1;
}
function zN(n) {
  return n.spec.defining || n.spec.definingForContent;
}
function AN(n, e, t, i) {
  if (!i.size)
    return n.deleteRange(e, t);
  let r = n.doc.resolve(e), o = n.doc.resolve(t);
  if (uf(r, o, i))
    return n.step(new De(e, t, i));
  let s = ff(r, n.doc.resolve(t));
  s[s.length - 1] == 0 && s.pop();
  let a = -(r.depth + 1);
  s.unshift(a);
  for (let h = r.depth, f = r.pos - 1; h > 0; h--, f--) {
    let p = r.node(h).type.spec;
    if (p.defining || p.definingAsContext || p.isolating)
      break;
    s.indexOf(h) > -1 ? a = h : r.before(h) == f && s.splice(1, 0, -h);
  }
  let l = s.indexOf(a), c = [], u = i.openStart;
  for (let h = i.content, f = 0; ; f++) {
    let p = h.firstChild;
    if (c.push(p), f == i.openStart)
      break;
    h = p.content;
  }
  for (let h = u - 1; h >= 0; h--) {
    let f = c[h], p = zN(f.type);
    if (p && !f.sameMarkup(r.node(Math.abs(a) - 1)))
      u = h;
    else if (p || !f.type.isTextblock)
      break;
  }
  for (let h = i.openStart; h >= 0; h--) {
    let f = (h + u + 1) % (i.openStart + 1), p = c[f];
    if (p)
      for (let m = 0; m < s.length; m++) {
        let g = s[(m + l) % s.length], k = !0;
        g < 0 && (k = !1, g = -g);
        let x = r.node(g - 1), S = r.index(g - 1);
        if (x.canReplaceWith(S, S, p.type, p.marks))
          return n.replace(r.before(g), k ? o.after(g) : t, new L(hf(i.content, 0, i.openStart, f), f, i.openEnd));
      }
  }
  let d = n.steps.length;
  for (let h = s.length - 1; h >= 0 && (n.replace(e, t, i), !(n.steps.length > d)); h--) {
    let f = s[h];
    f < 0 || (e = r.before(f), t = o.after(f));
  }
}
function hf(n, e, t, i, r) {
  if (e < t) {
    let o = n.firstChild;
    n = n.replaceChild(0, o.copy(hf(o.content, e + 1, t, i, o)));
  }
  if (e > i) {
    let o = r.contentMatchAt(0), s = o.fillBefore(n).append(n);
    n = s.append(o.matchFragment(s).fillBefore(M.empty, !0));
  }
  return n;
}
function NN(n, e, t, i) {
  if (!i.isInline && e == t && n.doc.resolve(e).parent.content.size) {
    let r = EN(n.doc, e, i.type);
    r != null && (e = t = r);
  }
  n.replaceRange(e, t, new L(M.from(i), 0, 0));
}
function LN(n, e, t) {
  let i = n.doc.resolve(e), r = n.doc.resolve(t), o = ff(i, r);
  for (let s = 0; s < o.length; s++) {
    let a = o[s], l = s == o.length - 1;
    if (l && a == 0 || i.node(a).type.contentMatch.validEnd)
      return n.delete(i.start(a), r.end(a));
    if (a > 0 && (l || i.node(a - 1).canReplace(i.index(a - 1), r.indexAfter(a - 1))))
      return n.delete(i.before(a), r.after(a));
  }
  for (let s = 1; s <= i.depth && s <= r.depth; s++)
    if (e - i.start(s) == i.depth - s && t > i.end(s) && r.end(s) - t != r.depth - s && i.start(s - 1) == r.start(s - 1) && i.node(s - 1).canReplace(i.index(s - 1), r.index(s - 1)))
      return n.delete(i.before(s), t);
  n.delete(e, t);
}
function ff(n, e) {
  let t = [], i = Math.min(n.depth, e.depth);
  for (let r = i; r >= 0; r--) {
    let o = n.start(r);
    if (o < n.pos - (n.depth - r) || e.end(r) > e.pos + (e.depth - r) || n.node(r).type.spec.isolating || e.node(r).type.spec.isolating)
      break;
    (o == e.start(r) || r == n.depth && r == e.depth && n.parent.inlineContent && e.parent.inlineContent && r && e.start(r - 1) == o - 1) && t.push(r);
  }
  return t;
}
class zi extends Ge {
  /**
  Construct an attribute step.
  */
  constructor(e, t, i) {
    super(), this.pos = e, this.attr = t, this.value = i;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return Me.fail("No node at attribute step's position");
    let i = /* @__PURE__ */ Object.create(null);
    for (let o in t.attrs)
      i[o] = t.attrs[o];
    i[this.attr] = this.value;
    let r = t.type.create(i, null, t.marks);
    return Me.fromReplace(e, this.pos, this.pos + 1, new L(M.from(r), 0, t.isLeaf ? 0 : 1));
  }
  getMap() {
    return ut.empty;
  }
  invert(e) {
    return new zi(this.pos, this.attr, e.nodeAt(this.pos).attrs[this.attr]);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new zi(t.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(e, t) {
    if (typeof t.pos != "number" || typeof t.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new zi(t.pos, t.attr, t.value);
  }
}
Ge.jsonID("attr", zi);
class yr extends Ge {
  /**
  Construct an attribute step.
  */
  constructor(e, t) {
    super(), this.attr = e, this.value = t;
  }
  apply(e) {
    let t = /* @__PURE__ */ Object.create(null);
    for (let r in e.attrs)
      t[r] = e.attrs[r];
    t[this.attr] = this.value;
    let i = e.type.create(t, e.content, e.marks);
    return Me.ok(i);
  }
  getMap() {
    return ut.empty;
  }
  invert(e) {
    return new yr(this.attr, e.attrs[this.attr]);
  }
  map(e) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(e, t) {
    if (typeof t.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new yr(t.attr, t.value);
  }
}
Ge.jsonID("docAttr", yr);
let Ni = class extends Error {
};
Ni = function n(e) {
  let t = Error.call(this, e);
  return t.__proto__ = n.prototype, t;
};
Ni.prototype = Object.create(Error.prototype);
Ni.prototype.constructor = Ni;
Ni.prototype.name = "TransformError";
class pf {
  /**
  Create a transform that starts with the given document.
  */
  constructor(e) {
    this.doc = e, this.steps = [], this.docs = [], this.mapping = new kr();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(e) {
    let t = this.maybeStep(e);
    if (t.failed)
      throw new Ni(t.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(e) {
    let t = e.apply(this.doc);
    return t.failed || this.addStep(e, t.doc), t;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  @internal
  */
  addStep(e, t) {
    this.docs.push(this.doc), this.steps.push(e), this.mapping.appendMap(e.getMap()), this.doc = t;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(e, t = e, i = L.empty) {
    let r = $s(this.doc, e, t, i);
    return r && this.step(r), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(e, t, i) {
    return this.replace(e, t, new L(M.from(i), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(e, t) {
    return this.replace(e, t, L.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(e, t) {
    return this.replaceWith(e, e, t);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(e, t, i) {
    return AN(this, e, t, i), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(e, t, i) {
    return NN(this, e, t, i), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(e, t) {
    return LN(this, e, t), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(e, t) {
    return bN(this, e, t), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(e, t = 1) {
    return MN(this, e, t), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(e, t) {
    return vN(this, e, t), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(e, t = e, i, r = null) {
    return xN(this, e, t, i, r), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(e, t, i = null, r) {
    return wN(this, e, t, i, r), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(e, t, i) {
    return this.step(new zi(e, t, i)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(e, t) {
    return this.step(new yr(e, t)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(e, t) {
    return this.step(new Mn(e, t)), this;
  }
  /**
  Remove a mark (or all marks of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(e, t) {
    let i = this.doc.nodeAt(e);
    if (!i)
      throw new RangeError("No node at position " + e);
    if (t instanceof fe)
      t.isInSet(i.marks) && this.step(new ci(e, t));
    else {
      let r = i.marks, o, s = [];
      for (; o = t.isInSet(r); )
        s.push(new ci(e, o)), r = o.removeFromSet(r);
      for (let a = s.length - 1; a >= 0; a--)
        this.step(s[a]);
    }
    return this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split (with the outermost nodes coming first).
  */
  split(e, t = 1, i) {
    return CN(this, e, t, i), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(e, t, i) {
    return mN(this, e, t, i), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(e, t, i) {
    return gN(this, e, t, i), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(e, t, i) {
    return Nl(this, e, t, i), this;
  }
}
const ta = /* @__PURE__ */ Object.create(null);
class ne {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(e, t, i) {
    this.$anchor = e, this.$head = t, this.ranges = i || [new DN(e.min(t), e.max(t))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let e = this.ranges;
    for (let t = 0; t < e.length; t++)
      if (e[t].$from.pos != e[t].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(e, t = L.empty) {
    let i = t.content.lastChild, r = null;
    for (let a = 0; a < t.openEnd; a++)
      r = i, i = i.lastChild;
    let o = e.steps.length, s = this.ranges;
    for (let a = 0; a < s.length; a++) {
      let { $from: l, $to: c } = s[a], u = e.mapping.slice(o);
      e.replaceRange(u.map(l.pos), u.map(c.pos), a ? L.empty : t), a == 0 && Vc(e, o, (i ? i.isInline : r && r.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(e, t) {
    let i = e.steps.length, r = this.ranges;
    for (let o = 0; o < r.length; o++) {
      let { $from: s, $to: a } = r[o], l = e.mapping.slice(i), c = l.map(s.pos), u = l.map(a.pos);
      o ? e.deleteRange(c, u) : (e.replaceRangeWith(c, u, t), Vc(e, i, t.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(e, t, i = !1) {
    let r = e.parent.inlineContent ? new G(e) : Ti(e.node(0), e.parent, e.pos, e.index(), t, i);
    if (r)
      return r;
    for (let o = e.depth - 1; o >= 0; o--) {
      let s = t < 0 ? Ti(e.node(0), e.node(o), e.before(o + 1), e.index(o), t, i) : Ti(e.node(0), e.node(o), e.after(o + 1), e.index(o) + 1, t, i);
      if (s)
        return s;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(e, t = 1) {
    return this.findFrom(e, t) || this.findFrom(e, -t) || new ot(e.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(e) {
    return Ti(e, e, 0, 0, 1) || new ot(e);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(e) {
    return Ti(e, e, e.content.size, e.childCount, -1) || new ot(e);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(e, t) {
    if (!t || !t.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let i = ta[t.type];
    if (!i)
      throw new RangeError(`No selection type ${t.type} defined`);
    return i.fromJSON(e, t);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(e, t) {
    if (e in ta)
      throw new RangeError("Duplicate use of selection JSON ID " + e);
    return ta[e] = t, t.prototype.jsonID = e, t;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return G.between(this.$anchor, this.$head).getBookmark();
  }
}
ne.prototype.visible = !0;
class DN {
  /**
  Create a range.
  */
  constructor(e, t) {
    this.$from = e, this.$to = t;
  }
}
let qc = !1;
function Hc(n) {
  !qc && !n.parent.inlineContent && (qc = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + n.parent.type.name + ")"));
}
class G extends ne {
  /**
  Construct a text selection between the given points.
  */
  constructor(e, t = e) {
    Hc(e), Hc(t), super(e, t);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(e, t) {
    let i = e.resolve(t.map(this.head));
    if (!i.parent.inlineContent)
      return ne.near(i);
    let r = e.resolve(t.map(this.anchor));
    return new G(r.parent.inlineContent ? r : i, i);
  }
  replace(e, t = L.empty) {
    if (super.replace(e, t), t == L.empty) {
      let i = this.$from.marksAcross(this.$to);
      i && e.ensureMarks(i);
    }
  }
  eq(e) {
    return e instanceof G && e.anchor == this.anchor && e.head == this.head;
  }
  getBookmark() {
    return new Os(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.anchor != "number" || typeof t.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new G(e.resolve(t.anchor), e.resolve(t.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(e, t, i = t) {
    let r = e.resolve(t);
    return new this(r, i == t ? r : e.resolve(i));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(e, t, i) {
    let r = e.pos - t.pos;
    if ((!i || r) && (i = r >= 0 ? 1 : -1), !t.parent.inlineContent) {
      let o = ne.findFrom(t, i, !0) || ne.findFrom(t, -i, !0);
      if (o)
        t = o.$head;
      else
        return ne.near(t, i);
    }
    return e.parent.inlineContent || (r == 0 ? e = t : (e = (ne.findFrom(e, -i, !0) || ne.findFrom(e, i, !0)).$anchor, e.pos < t.pos != r < 0 && (e = t))), new G(e, t);
  }
}
ne.jsonID("text", G);
class Os {
  constructor(e, t) {
    this.anchor = e, this.head = t;
  }
  map(e) {
    return new Os(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    return G.between(e.resolve(this.anchor), e.resolve(this.head));
  }
}
class F extends ne {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(e) {
    let t = e.nodeAfter, i = e.node(0).resolve(e.pos + t.nodeSize);
    super(e, i), this.node = t;
  }
  map(e, t) {
    let { deleted: i, pos: r } = t.mapResult(this.anchor), o = e.resolve(r);
    return i ? ne.near(o) : new F(o);
  }
  content() {
    return new L(M.from(this.node), 0, 0);
  }
  eq(e) {
    return e instanceof F && e.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new Dl(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new F(e.resolve(t.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(e, t) {
    return new F(e.resolve(t));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(e) {
    return !e.isText && e.type.spec.selectable !== !1;
  }
}
F.prototype.visible = !1;
ne.jsonID("node", F);
class Dl {
  constructor(e) {
    this.anchor = e;
  }
  map(e) {
    let { deleted: t, pos: i } = e.mapResult(this.anchor);
    return t ? new Os(i, i) : new Dl(i);
  }
  resolve(e) {
    let t = e.resolve(this.anchor), i = t.nodeAfter;
    return i && F.isSelectable(i) ? new F(t) : ne.near(t);
  }
}
class ot extends ne {
  /**
  Create an all-selection over the given document.
  */
  constructor(e) {
    super(e.resolve(0), e.resolve(e.content.size));
  }
  replace(e, t = L.empty) {
    if (t == L.empty) {
      e.delete(0, e.doc.content.size);
      let i = ne.atStart(e.doc);
      i.eq(e.selection) || e.setSelection(i);
    } else
      super.replace(e, t);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(e) {
    return new ot(e);
  }
  map(e) {
    return new ot(e);
  }
  eq(e) {
    return e instanceof ot;
  }
  getBookmark() {
    return RN;
  }
}
ne.jsonID("all", ot);
const RN = {
  map() {
    return this;
  },
  resolve(n) {
    return new ot(n);
  }
};
function Ti(n, e, t, i, r, o = !1) {
  if (e.inlineContent)
    return G.create(n, t);
  for (let s = i - (r > 0 ? 0 : 1); r > 0 ? s < e.childCount : s >= 0; s += r) {
    let a = e.child(s);
    if (a.isAtom) {
      if (!o && F.isSelectable(a))
        return F.create(n, t - (r < 0 ? a.nodeSize : 0));
    } else {
      let l = Ti(n, a, t + r, r < 0 ? a.childCount : 0, r, o);
      if (l)
        return l;
    }
    t += a.nodeSize * r;
  }
  return null;
}
function Vc(n, e, t) {
  let i = n.steps.length - 1;
  if (i < e)
    return;
  let r = n.steps[i];
  if (!(r instanceof De || r instanceof Re))
    return;
  let o = n.mapping.maps[i], s;
  o.forEach((a, l, c, u) => {
    s == null && (s = u);
  }), n.setSelection(ne.near(n.doc.resolve(s), t));
}
const Uc = 1, Kr = 2, Wc = 4;
class IN extends pf {
  /**
  @internal
  */
  constructor(e) {
    super(e.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = e.selection, this.storedMarks = e.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(e) {
    if (e.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = e, this.curSelectionFor = this.steps.length, this.updated = (this.updated | Uc) & ~Kr, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & Uc) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(e) {
    return this.storedMarks = e, this.updated |= Kr, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(e) {
    return fe.sameSet(this.storedMarks || this.selection.$from.marks(), e) || this.setStoredMarks(e), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(e) {
    return this.ensureMarks(e.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(e) {
    return this.ensureMarks(e.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & Kr) > 0;
  }
  /**
  @internal
  */
  addStep(e, t) {
    super.addStep(e, t), this.updated = this.updated & ~Kr, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(e) {
    return this.time = e, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(e) {
    return this.selection.replace(this, e), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(e, t = !0) {
    let i = this.selection;
    return t && (e = e.mark(this.storedMarks || (i.empty ? i.$from.marks() : i.$from.marksAcross(i.$to) || fe.none))), i.replaceWith(this, e), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(e, t, i) {
    let r = this.doc.type.schema;
    if (t == null)
      return e ? this.replaceSelectionWith(r.text(e), !0) : this.deleteSelection();
    {
      if (i == null && (i = t), !e)
        return this.deleteRange(t, i);
      let o = this.storedMarks;
      if (!o) {
        let s = this.doc.resolve(t);
        o = i == t ? s.marks() : s.marksAcross(this.doc.resolve(i));
      }
      return this.replaceRangeWith(t, i, r.text(e, o)), !this.selection.empty && this.selection.to == t + e.length && this.setSelection(ne.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(e, t) {
    return this.meta[typeof e == "string" ? e : e.key] = t, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(e) {
    return this.meta[typeof e == "string" ? e : e.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let e in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= Wc, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & Wc) > 0;
  }
}
function Kc(n, e) {
  return !e || !n ? n : n.bind(e);
}
class Gi {
  constructor(e, t, i) {
    this.name = e, this.init = Kc(t.init, i), this.apply = Kc(t.apply, i);
  }
}
const PN = [
  new Gi("doc", {
    init(n) {
      return n.doc || n.schema.topNodeType.createAndFill();
    },
    apply(n) {
      return n.doc;
    }
  }),
  new Gi("selection", {
    init(n, e) {
      return n.selection || ne.atStart(e.doc);
    },
    apply(n) {
      return n.selection;
    }
  }),
  new Gi("storedMarks", {
    init(n) {
      return n.storedMarks || null;
    },
    apply(n, e, t, i) {
      return i.selection.$cursor ? n.storedMarks : null;
    }
  }),
  new Gi("scrollToSelection", {
    init() {
      return 0;
    },
    apply(n, e) {
      return n.scrolledIntoView ? e + 1 : e;
    }
  })
];
class na {
  constructor(e, t) {
    this.schema = e, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = PN.slice(), t && t.forEach((i) => {
      if (this.pluginsByKey[i.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + i.key + ")");
      this.plugins.push(i), this.pluginsByKey[i.key] = i, i.spec.state && this.fields.push(new Gi(i.key, i.spec.state, i));
    });
  }
}
class Oi {
  /**
  @internal
  */
  constructor(e) {
    this.config = e;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(e) {
    return this.applyTransaction(e).state;
  }
  /**
  @internal
  */
  filterTransaction(e, t = -1) {
    for (let i = 0; i < this.config.plugins.length; i++)
      if (i != t) {
        let r = this.config.plugins[i];
        if (r.spec.filterTransaction && !r.spec.filterTransaction.call(r, e, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(e) {
    if (!this.filterTransaction(e))
      return { state: this, transactions: [] };
    let t = [e], i = this.applyInner(e), r = null;
    for (; ; ) {
      let o = !1;
      for (let s = 0; s < this.config.plugins.length; s++) {
        let a = this.config.plugins[s];
        if (a.spec.appendTransaction) {
          let l = r ? r[s].n : 0, c = r ? r[s].state : this, u = l < t.length && a.spec.appendTransaction.call(a, l ? t.slice(l) : t, c, i);
          if (u && i.filterTransaction(u, s)) {
            if (u.setMeta("appendedTransaction", e), !r) {
              r = [];
              for (let d = 0; d < this.config.plugins.length; d++)
                r.push(d < s ? { state: i, n: t.length } : { state: this, n: 0 });
            }
            t.push(u), i = i.applyInner(u), o = !0;
          }
          r && (r[s] = { state: i, n: t.length });
        }
      }
      if (!o)
        return { state: i, transactions: t };
    }
  }
  /**
  @internal
  */
  applyInner(e) {
    if (!e.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let t = new Oi(this.config), i = this.config.fields;
    for (let r = 0; r < i.length; r++) {
      let o = i[r];
      t[o.name] = o.apply(e, this[o.name], this, t);
    }
    return t;
  }
  /**
  Accessor that constructs and returns a new [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new IN(this);
  }
  /**
  Create a new state.
  */
  static create(e) {
    let t = new na(e.doc ? e.doc.type.schema : e.schema, e.plugins), i = new Oi(t);
    for (let r = 0; r < t.fields.length; r++)
      i[t.fields[r].name] = t.fields[r].init(e, i);
    return i;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(e) {
    let t = new na(this.schema, e.plugins), i = t.fields, r = new Oi(t);
    for (let o = 0; o < i.length; o++) {
      let s = i[o].name;
      r[s] = this.hasOwnProperty(s) ? this[s] : i[o].init(e, r);
    }
    return r;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(e) {
    let t = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (t.storedMarks = this.storedMarks.map((i) => i.toJSON())), e && typeof e == "object")
      for (let i in e) {
        if (i == "doc" || i == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let r = e[i], o = r.spec.state;
        o && o.toJSON && (t[i] = o.toJSON.call(r, this[r.key]));
      }
    return t;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(e, t, i) {
    if (!t)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!e.schema)
      throw new RangeError("Required config field 'schema' missing");
    let r = new na(e.schema, e.plugins), o = new Oi(r);
    return r.fields.forEach((s) => {
      if (s.name == "doc")
        o.doc = an.fromJSON(e.schema, t.doc);
      else if (s.name == "selection")
        o.selection = ne.fromJSON(o.doc, t.selection);
      else if (s.name == "storedMarks")
        t.storedMarks && (o.storedMarks = t.storedMarks.map(e.schema.markFromJSON));
      else {
        if (i)
          for (let a in i) {
            let l = i[a], c = l.spec.state;
            if (l.key == s.name && c && c.fromJSON && Object.prototype.hasOwnProperty.call(t, a)) {
              o[s.name] = c.fromJSON.call(l, e, t[a], o);
              return;
            }
          }
        o[s.name] = s.init(e, o);
      }
    }), o;
  }
}
function mf(n, e, t) {
  for (let i in n) {
    let r = n[i];
    r instanceof Function ? r = r.bind(e) : i == "handleDOMEvents" && (r = mf(r, e, {})), t[i] = r;
  }
  return t;
}
class Ee {
  /**
  Create a plugin.
  */
  constructor(e) {
    this.spec = e, this.props = {}, e.props && mf(e.props, this, this.props), this.key = e.key ? e.key.key : gf("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const ia = /* @__PURE__ */ Object.create(null);
function gf(n) {
  return n in ia ? n + "$" + ++ia[n] : (ia[n] = 0, n + "$");
}
class Ue {
  /**
  Create a plugin key.
  */
  constructor(e = "key") {
    this.key = gf(e);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(e) {
    return e.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const Fe = function(n) {
  for (var e = 0; ; e++)
    if (n = n.previousSibling, !n)
      return e;
}, Li = function(n) {
  let e = n.assignedSlot || n.parentNode;
  return e && e.nodeType == 11 ? e.host : e;
};
let Ja = null;
const nn = function(n, e, t) {
  let i = Ja || (Ja = document.createRange());
  return i.setEnd(n, t ?? n.nodeValue.length), i.setStart(n, e || 0), i;
}, jN = function() {
  Ja = null;
}, ui = function(n, e, t, i) {
  return t && (Zc(n, e, t, i, -1) || Zc(n, e, t, i, 1));
}, BN = /^(img|br|input|textarea|hr)$/i;
function Zc(n, e, t, i, r) {
  for (var o; ; ) {
    if (n == t && e == i)
      return !0;
    if (e == (r < 0 ? 0 : bt(n))) {
      let s = n.parentNode;
      if (!s || s.nodeType != 1 || Rr(n) || BN.test(n.nodeName) || n.contentEditable == "false")
        return !1;
      e = Fe(n) + (r < 0 ? 0 : 1), n = s;
    } else if (n.nodeType == 1) {
      let s = n.childNodes[e + (r < 0 ? -1 : 0)];
      if (s.nodeType == 1 && s.contentEditable == "false")
        if (!((o = s.pmViewDesc) === null || o === void 0) && o.ignoreForSelection)
          e += r;
        else
          return !1;
      else
        n = s, e = r < 0 ? bt(n) : 0;
    } else
      return !1;
  }
}
function bt(n) {
  return n.nodeType == 3 ? n.nodeValue.length : n.childNodes.length;
}
function FN(n, e) {
  for (; ; ) {
    if (n.nodeType == 3 && e)
      return n;
    if (n.nodeType == 1 && e > 0) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[e - 1], e = bt(n);
    } else if (n.parentNode && !Rr(n))
      e = Fe(n), n = n.parentNode;
    else
      return null;
  }
}
function qN(n, e) {
  for (; ; ) {
    if (n.nodeType == 3 && e < n.nodeValue.length)
      return n;
    if (n.nodeType == 1 && e < n.childNodes.length) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[e], e = 0;
    } else if (n.parentNode && !Rr(n))
      e = Fe(n) + 1, n = n.parentNode;
    else
      return null;
  }
}
function HN(n, e, t) {
  for (let i = e == 0, r = e == bt(n); i || r; ) {
    if (n == t)
      return !0;
    let o = Fe(n);
    if (n = n.parentNode, !n)
      return !1;
    i = i && o == 0, r = r && o == bt(n);
  }
}
function Rr(n) {
  let e;
  for (let t = n; t && !(e = t.pmViewDesc); t = t.parentNode)
    ;
  return e && e.node && e.node.isBlock && (e.dom == n || e.contentDOM == n);
}
const zs = function(n) {
  return n.focusNode && ui(n.focusNode, n.focusOffset, n.anchorNode, n.anchorOffset);
};
function Gn(n, e) {
  let t = document.createEvent("Event");
  return t.initEvent("keydown", !0, !0), t.keyCode = n, t.key = t.code = e, t;
}
function VN(n) {
  let e = n.activeElement;
  for (; e && e.shadowRoot; )
    e = e.shadowRoot.activeElement;
  return e;
}
function UN(n, e, t) {
  if (n.caretPositionFromPoint)
    try {
      let i = n.caretPositionFromPoint(e, t);
      if (i)
        return { node: i.offsetNode, offset: Math.min(bt(i.offsetNode), i.offset) };
    } catch {
    }
  if (n.caretRangeFromPoint) {
    let i = n.caretRangeFromPoint(e, t);
    if (i)
      return { node: i.startContainer, offset: Math.min(bt(i.startContainer), i.startOffset) };
  }
}
const Vt = typeof navigator < "u" ? navigator : null, Jc = typeof document < "u" ? document : null, Pn = Vt && Vt.userAgent || "", Ga = /Edge\/(\d+)/.exec(Pn), _f = /MSIE \d/.exec(Pn), Ya = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(Pn), st = !!(_f || Ya || Ga), An = _f ? document.documentMode : Ya ? +Ya[1] : Ga ? +Ga[1] : 0, yt = !st && /gecko\/(\d+)/i.test(Pn);
yt && +(/Firefox\/(\d+)/.exec(Pn) || [0, 0])[1];
const Xa = !st && /Chrome\/(\d+)/.exec(Pn), Ze = !!Xa, bf = Xa ? +Xa[1] : 0, et = !st && !!Vt && /Apple Computer/.test(Vt.vendor), Di = et && (/Mobile\/\w+/.test(Pn) || !!Vt && Vt.maxTouchPoints > 2), _t = Di || (Vt ? /Mac/.test(Vt.platform) : !1), WN = Vt ? /Win/.test(Vt.platform) : !1, on = /Android \d/.test(Pn), Ir = !!Jc && "webkitFontSmoothing" in Jc.documentElement.style, KN = Ir ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function ZN(n) {
  let e = n.defaultView && n.defaultView.visualViewport;
  return e ? {
    left: 0,
    right: e.width,
    top: 0,
    bottom: e.height
  } : {
    left: 0,
    right: n.documentElement.clientWidth,
    top: 0,
    bottom: n.documentElement.clientHeight
  };
}
function Yt(n, e) {
  return typeof n == "number" ? n : n[e];
}
function JN(n) {
  let e = n.getBoundingClientRect(), t = e.width / n.offsetWidth || 1, i = e.height / n.offsetHeight || 1;
  return {
    left: e.left,
    right: e.left + n.clientWidth * t,
    top: e.top,
    bottom: e.top + n.clientHeight * i
  };
}
function Gc(n, e, t) {
  let i = n.someProp("scrollThreshold") || 0, r = n.someProp("scrollMargin") || 5, o = n.dom.ownerDocument;
  for (let s = t || n.dom; s; ) {
    if (s.nodeType != 1) {
      s = Li(s);
      continue;
    }
    let a = s, l = a == o.body, c = l ? ZN(o) : JN(a), u = 0, d = 0;
    if (e.top < c.top + Yt(i, "top") ? d = -(c.top - e.top + Yt(r, "top")) : e.bottom > c.bottom - Yt(i, "bottom") && (d = e.bottom - e.top > c.bottom - c.top ? e.top + Yt(r, "top") - c.top : e.bottom - c.bottom + Yt(r, "bottom")), e.left < c.left + Yt(i, "left") ? u = -(c.left - e.left + Yt(r, "left")) : e.right > c.right - Yt(i, "right") && (u = e.right - c.right + Yt(r, "right")), u || d)
      if (l)
        o.defaultView.scrollBy(u, d);
      else {
        let f = a.scrollLeft, p = a.scrollTop;
        d && (a.scrollTop += d), u && (a.scrollLeft += u);
        let m = a.scrollLeft - f, g = a.scrollTop - p;
        e = { left: e.left - m, top: e.top - g, right: e.right - m, bottom: e.bottom - g };
      }
    let h = l ? "fixed" : getComputedStyle(s).position;
    if (/^(fixed|sticky)$/.test(h))
      break;
    s = h == "absolute" ? s.offsetParent : Li(s);
  }
}
function GN(n) {
  let e = n.dom.getBoundingClientRect(), t = Math.max(0, e.top), i, r;
  for (let o = (e.left + e.right) / 2, s = t + 1; s < Math.min(innerHeight, e.bottom); s += 5) {
    let a = n.root.elementFromPoint(o, s);
    if (!a || a == n.dom || !n.dom.contains(a))
      continue;
    let l = a.getBoundingClientRect();
    if (l.top >= t - 20) {
      i = a, r = l.top;
      break;
    }
  }
  return { refDOM: i, refTop: r, stack: kf(n.dom) };
}
function kf(n) {
  let e = [], t = n.ownerDocument;
  for (let i = n; i && (e.push({ dom: i, top: i.scrollTop, left: i.scrollLeft }), n != t); i = Li(i))
    ;
  return e;
}
function YN({ refDOM: n, refTop: e, stack: t }) {
  let i = n ? n.getBoundingClientRect().top : 0;
  yf(t, i == 0 ? 0 : i - e);
}
function yf(n, e) {
  for (let t = 0; t < n.length; t++) {
    let { dom: i, top: r, left: o } = n[t];
    i.scrollTop != r + e && (i.scrollTop = r + e), i.scrollLeft != o && (i.scrollLeft = o);
  }
}
let bi = null;
function XN(n) {
  if (n.setActive)
    return n.setActive();
  if (bi)
    return n.focus(bi);
  let e = kf(n);
  n.focus(bi == null ? {
    get preventScroll() {
      return bi = { preventScroll: !0 }, !0;
    }
  } : void 0), bi || (bi = !1, yf(e, 0));
}
function vf(n, e) {
  let t, i = 2e8, r, o = 0, s = e.top, a = e.top, l, c;
  for (let u = n.firstChild, d = 0; u; u = u.nextSibling, d++) {
    let h;
    if (u.nodeType == 1)
      h = u.getClientRects();
    else if (u.nodeType == 3)
      h = nn(u).getClientRects();
    else
      continue;
    for (let f = 0; f < h.length; f++) {
      let p = h[f];
      if (p.top <= s && p.bottom >= a) {
        s = Math.max(p.bottom, s), a = Math.min(p.top, a);
        let m = p.left > e.left ? p.left - e.left : p.right < e.left ? e.left - p.right : 0;
        if (m < i) {
          t = u, i = m, r = m && t.nodeType == 3 ? {
            left: p.right < e.left ? p.right : p.left,
            top: e.top
          } : e, u.nodeType == 1 && m && (o = d + (e.left >= (p.left + p.right) / 2 ? 1 : 0));
          continue;
        }
      } else p.top > e.top && !l && p.left <= e.left && p.right >= e.left && (l = u, c = { left: Math.max(p.left, Math.min(p.right, e.left)), top: p.top });
      !t && (e.left >= p.right && e.top >= p.top || e.left >= p.left && e.top >= p.bottom) && (o = d + 1);
    }
  }
  return !t && l && (t = l, r = c, i = 0), t && t.nodeType == 3 ? QN(t, r) : !t || i && t.nodeType == 1 ? { node: n, offset: o } : vf(t, r);
}
function QN(n, e) {
  let t = n.nodeValue.length, i = document.createRange();
  for (let r = 0; r < t; r++) {
    i.setEnd(n, r + 1), i.setStart(n, r);
    let o = yn(i, 1);
    if (o.top != o.bottom && Rl(e, o))
      return { node: n, offset: r + (e.left >= (o.left + o.right) / 2 ? 1 : 0) };
  }
  return { node: n, offset: 0 };
}
function Rl(n, e) {
  return n.left >= e.left - 1 && n.left <= e.right + 1 && n.top >= e.top - 1 && n.top <= e.bottom + 1;
}
function eL(n, e) {
  let t = n.parentNode;
  return t && /^li$/i.test(t.nodeName) && e.left < n.getBoundingClientRect().left ? t : n;
}
function tL(n, e, t) {
  let { node: i, offset: r } = vf(e, t), o = -1;
  if (i.nodeType == 1 && !i.firstChild) {
    let s = i.getBoundingClientRect();
    o = s.left != s.right && t.left > (s.left + s.right) / 2 ? 1 : -1;
  }
  return n.docView.posFromDOM(i, r, o);
}
function nL(n, e, t, i) {
  let r = -1;
  for (let o = e, s = !1; o != n.dom; ) {
    let a = n.docView.nearestDesc(o, !0), l;
    if (!a)
      return null;
    if (a.dom.nodeType == 1 && (a.node.isBlock && a.parent || !a.contentDOM) && // Ignore elements with zero-size bounding rectangles
    ((l = a.dom.getBoundingClientRect()).width || l.height) && (a.node.isBlock && a.parent && !/^T(R|BODY|HEAD|FOOT)$/.test(a.dom.nodeName) && (!s && l.left > i.left || l.top > i.top ? r = a.posBefore : (!s && l.right < i.left || l.bottom < i.top) && (r = a.posAfter), s = !0), !a.contentDOM && r < 0 && !a.node.isText))
      return (a.node.isBlock ? i.top < (l.top + l.bottom) / 2 : i.left < (l.left + l.right) / 2) ? a.posBefore : a.posAfter;
    o = a.dom.parentNode;
  }
  return r > -1 ? r : n.docView.posFromDOM(e, t, -1);
}
function xf(n, e, t) {
  let i = n.childNodes.length;
  if (i && t.top < t.bottom)
    for (let r = Math.max(0, Math.min(i - 1, Math.floor(i * (e.top - t.top) / (t.bottom - t.top)) - 2)), o = r; ; ) {
      let s = n.childNodes[o];
      if (s.nodeType == 1) {
        let a = s.getClientRects();
        for (let l = 0; l < a.length; l++) {
          let c = a[l];
          if (Rl(e, c))
            return xf(s, e, c);
        }
      }
      if ((o = (o + 1) % i) == r)
        break;
    }
  return n;
}
function iL(n, e) {
  let t = n.dom.ownerDocument, i, r = 0, o = UN(t, e.left, e.top);
  o && ({ node: i, offset: r } = o);
  let s = (n.root.elementFromPoint ? n.root : t).elementFromPoint(e.left, e.top), a;
  if (!s || !n.dom.contains(s.nodeType != 1 ? s.parentNode : s)) {
    let c = n.dom.getBoundingClientRect();
    if (!Rl(e, c) || (s = xf(n.dom, e, c), !s))
      return null;
  }
  if (et)
    for (let c = s; i && c; c = Li(c))
      c.draggable && (i = void 0);
  if (s = eL(s, e), i) {
    if (yt && i.nodeType == 1 && (r = Math.min(r, i.childNodes.length), r < i.childNodes.length)) {
      let u = i.childNodes[r], d;
      u.nodeName == "IMG" && (d = u.getBoundingClientRect()).right <= e.left && d.bottom > e.top && r++;
    }
    let c;
    Ir && r && i.nodeType == 1 && (c = i.childNodes[r - 1]).nodeType == 1 && c.contentEditable == "false" && c.getBoundingClientRect().top >= e.top && r--, i == n.dom && r == i.childNodes.length - 1 && i.lastChild.nodeType == 1 && e.top > i.lastChild.getBoundingClientRect().bottom ? a = n.state.doc.content.size : (r == 0 || i.nodeType != 1 || i.childNodes[r - 1].nodeName != "BR") && (a = nL(n, i, r, e));
  }
  a == null && (a = tL(n, s, e));
  let l = n.docView.nearestDesc(s, !0);
  return { pos: a, inside: l ? l.posAtStart - l.border : -1 };
}
function Yc(n) {
  return n.top < n.bottom || n.left < n.right;
}
function yn(n, e) {
  let t = n.getClientRects();
  if (t.length) {
    let i = t[e < 0 ? 0 : t.length - 1];
    if (Yc(i))
      return i;
  }
  return Array.prototype.find.call(t, Yc) || n.getBoundingClientRect();
}
const rL = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function Sf(n, e, t) {
  let { node: i, offset: r, atom: o } = n.docView.domFromPos(e, t < 0 ? -1 : 1), s = Ir || yt;
  if (i.nodeType == 3)
    if (s && (rL.test(i.nodeValue) || (t < 0 ? !r : r == i.nodeValue.length))) {
      let l = yn(nn(i, r, r), t);
      if (yt && r && /\s/.test(i.nodeValue[r - 1]) && r < i.nodeValue.length) {
        let c = yn(nn(i, r - 1, r - 1), -1);
        if (c.top == l.top) {
          let u = yn(nn(i, r, r + 1), -1);
          if (u.top != l.top)
            return Vi(u, u.left < c.left);
        }
      }
      return l;
    } else {
      let l = r, c = r, u = t < 0 ? 1 : -1;
      return t < 0 && !r ? (c++, u = -1) : t >= 0 && r == i.nodeValue.length ? (l--, u = 1) : t < 0 ? l-- : c++, Vi(yn(nn(i, l, c), u), u < 0);
    }
  if (!n.state.doc.resolve(e - (o || 0)).parent.inlineContent) {
    if (o == null && r && (t < 0 || r == bt(i))) {
      let l = i.childNodes[r - 1];
      if (l.nodeType == 1)
        return ra(l.getBoundingClientRect(), !1);
    }
    if (o == null && r < bt(i)) {
      let l = i.childNodes[r];
      if (l.nodeType == 1)
        return ra(l.getBoundingClientRect(), !0);
    }
    return ra(i.getBoundingClientRect(), t >= 0);
  }
  if (o == null && r && (t < 0 || r == bt(i))) {
    let l = i.childNodes[r - 1], c = l.nodeType == 3 ? nn(l, bt(l) - (s ? 0 : 1)) : l.nodeType == 1 && (l.nodeName != "BR" || !l.nextSibling) ? l : null;
    if (c)
      return Vi(yn(c, 1), !1);
  }
  if (o == null && r < bt(i)) {
    let l = i.childNodes[r];
    for (; l.pmViewDesc && l.pmViewDesc.ignoreForCoords; )
      l = l.nextSibling;
    let c = l ? l.nodeType == 3 ? nn(l, 0, s ? 0 : 1) : l.nodeType == 1 ? l : null : null;
    if (c)
      return Vi(yn(c, -1), !0);
  }
  return Vi(yn(i.nodeType == 3 ? nn(i) : i, -t), t >= 0);
}
function Vi(n, e) {
  if (n.width == 0)
    return n;
  let t = e ? n.left : n.right;
  return { top: n.top, bottom: n.bottom, left: t, right: t };
}
function ra(n, e) {
  if (n.height == 0)
    return n;
  let t = e ? n.top : n.bottom;
  return { top: t, bottom: t, left: n.left, right: n.right };
}
function wf(n, e, t) {
  let i = n.state, r = n.root.activeElement;
  i != e && n.updateState(e), r != n.dom && n.focus();
  try {
    return t();
  } finally {
    i != e && n.updateState(i), r != n.dom && r && r.focus();
  }
}
function oL(n, e, t) {
  let i = e.selection, r = t == "up" ? i.$from : i.$to;
  return wf(n, e, () => {
    let { node: o } = n.docView.domFromPos(r.pos, t == "up" ? -1 : 1);
    for (; ; ) {
      let a = n.docView.nearestDesc(o, !0);
      if (!a)
        break;
      if (a.node.isBlock) {
        o = a.contentDOM || a.dom;
        break;
      }
      o = a.dom.parentNode;
    }
    let s = Sf(n, r.pos, 1);
    for (let a = o.firstChild; a; a = a.nextSibling) {
      let l;
      if (a.nodeType == 1)
        l = a.getClientRects();
      else if (a.nodeType == 3)
        l = nn(a, 0, a.nodeValue.length).getClientRects();
      else
        continue;
      for (let c = 0; c < l.length; c++) {
        let u = l[c];
        if (u.bottom > u.top + 1 && (t == "up" ? s.top - u.top > (u.bottom - s.top) * 2 : u.bottom - s.bottom > (s.bottom - u.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const sL = /[\u0590-\u08ac]/;
function aL(n, e, t) {
  let { $head: i } = e.selection;
  if (!i.parent.isTextblock)
    return !1;
  let r = i.parentOffset, o = !r, s = r == i.parent.content.size, a = n.domSelection();
  return a ? !sL.test(i.parent.textContent) || !a.modify ? t == "left" || t == "backward" ? o : s : wf(n, e, () => {
    let { focusNode: l, focusOffset: c, anchorNode: u, anchorOffset: d } = n.domSelectionRange(), h = a.caretBidiLevel;
    a.modify("move", t, "character");
    let f = i.depth ? n.docView.domAfterPos(i.before()) : n.dom, { focusNode: p, focusOffset: m } = n.domSelectionRange(), g = p && !f.contains(p.nodeType == 1 ? p : p.parentNode) || l == p && c == m;
    try {
      a.collapse(u, d), l && (l != u || c != d) && a.extend && a.extend(l, c);
    } catch {
    }
    return h != null && (a.caretBidiLevel = h), g;
  }) : i.pos == i.start() || i.pos == i.end();
}
let Xc = null, Qc = null, eu = !1;
function lL(n, e, t) {
  return Xc == e && Qc == t ? eu : (Xc = e, Qc = t, eu = t == "up" || t == "down" ? oL(n, e, t) : aL(n, e, t));
}
const vt = 0, tu = 1, Xn = 2, Ut = 3;
class Pr {
  constructor(e, t, i, r) {
    this.parent = e, this.children = t, this.dom = i, this.contentDOM = r, this.dirty = vt, i.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(e) {
    return !1;
  }
  matchesMark(e) {
    return !1;
  }
  matchesNode(e, t, i) {
    return !1;
  }
  matchesHack(e) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(e) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let e = 0;
    for (let t = 0; t < this.children.length; t++)
      e += this.children[t].size;
    return e;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let e = 0; e < this.children.length; e++)
      this.children[e].destroy();
  }
  posBeforeChild(e) {
    for (let t = 0, i = this.posAtStart; ; t++) {
      let r = this.children[t];
      if (r == e)
        return i;
      i += r.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(e, t, i) {
    if (this.contentDOM && this.contentDOM.contains(e.nodeType == 1 ? e : e.parentNode))
      if (i < 0) {
        let o, s;
        if (e == this.contentDOM)
          o = e.childNodes[t - 1];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          o = e.previousSibling;
        }
        for (; o && !((s = o.pmViewDesc) && s.parent == this); )
          o = o.previousSibling;
        return o ? this.posBeforeChild(s) + s.size : this.posAtStart;
      } else {
        let o, s;
        if (e == this.contentDOM)
          o = e.childNodes[t];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          o = e.nextSibling;
        }
        for (; o && !((s = o.pmViewDesc) && s.parent == this); )
          o = o.nextSibling;
        return o ? this.posBeforeChild(s) : this.posAtEnd;
      }
    let r;
    if (e == this.dom && this.contentDOM)
      r = t > Fe(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      r = e.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (t == 0)
        for (let o = e; ; o = o.parentNode) {
          if (o == this.dom) {
            r = !1;
            break;
          }
          if (o.previousSibling)
            break;
        }
      if (r == null && t == e.childNodes.length)
        for (let o = e; ; o = o.parentNode) {
          if (o == this.dom) {
            r = !0;
            break;
          }
          if (o.nextSibling)
            break;
        }
    }
    return r ?? i > 0 ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(e, t = !1) {
    for (let i = !0, r = e; r; r = r.parentNode) {
      let o = this.getDesc(r), s;
      if (o && (!t || o.node))
        if (i && (s = o.nodeDOM) && !(s.nodeType == 1 ? s.contains(e.nodeType == 1 ? e : e.parentNode) : s == e))
          i = !1;
        else
          return o;
    }
  }
  getDesc(e) {
    let t = e.pmViewDesc;
    for (let i = t; i; i = i.parent)
      if (i == this)
        return t;
  }
  posFromDOM(e, t, i) {
    for (let r = e; r; r = r.parentNode) {
      let o = this.getDesc(r);
      if (o)
        return o.localPosFromDOM(e, t, i);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(e) {
    for (let t = 0, i = 0; t < this.children.length; t++) {
      let r = this.children[t], o = i + r.size;
      if (i == e && o != i) {
        for (; !r.border && r.children.length; )
          for (let s = 0; s < r.children.length; s++) {
            let a = r.children[s];
            if (a.size) {
              r = a;
              break;
            }
          }
        return r;
      }
      if (e < o)
        return r.descAt(e - i - r.border);
      i = o;
    }
  }
  domFromPos(e, t) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: e + 1 };
    let i = 0, r = 0;
    for (let o = 0; i < this.children.length; i++) {
      let s = this.children[i], a = o + s.size;
      if (a > e || s instanceof Tf) {
        r = e - o;
        break;
      }
      o = a;
    }
    if (r)
      return this.children[i].domFromPos(r - this.children[i].border, t);
    for (let o; i && !(o = this.children[i - 1]).size && o instanceof Cf && o.side >= 0; i--)
      ;
    if (t <= 0) {
      let o, s = !0;
      for (; o = i ? this.children[i - 1] : null, !(!o || o.dom.parentNode == this.contentDOM); i--, s = !1)
        ;
      return o && t && s && !o.border && !o.domAtom ? o.domFromPos(o.size, t) : { node: this.contentDOM, offset: o ? Fe(o.dom) + 1 : 0 };
    } else {
      let o, s = !0;
      for (; o = i < this.children.length ? this.children[i] : null, !(!o || o.dom.parentNode == this.contentDOM); i++, s = !1)
        ;
      return o && s && !o.border && !o.domAtom ? o.domFromPos(0, t) : { node: this.contentDOM, offset: o ? Fe(o.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(e, t, i = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: e, to: t, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let r = -1, o = -1;
    for (let s = i, a = 0; ; a++) {
      let l = this.children[a], c = s + l.size;
      if (r == -1 && e <= c) {
        let u = s + l.border;
        if (e >= u && t <= c - l.border && l.node && l.contentDOM && this.contentDOM.contains(l.contentDOM))
          return l.parseRange(e, t, u);
        e = s;
        for (let d = a; d > 0; d--) {
          let h = this.children[d - 1];
          if (h.size && h.dom.parentNode == this.contentDOM && !h.emptyChildAt(1)) {
            r = Fe(h.dom) + 1;
            break;
          }
          e -= h.size;
        }
        r == -1 && (r = 0);
      }
      if (r > -1 && (c > t || a == this.children.length - 1)) {
        t = c;
        for (let u = a + 1; u < this.children.length; u++) {
          let d = this.children[u];
          if (d.size && d.dom.parentNode == this.contentDOM && !d.emptyChildAt(-1)) {
            o = Fe(d.dom);
            break;
          }
          t += d.size;
        }
        o == -1 && (o = this.contentDOM.childNodes.length);
        break;
      }
      s = c;
    }
    return { node: this.contentDOM, from: e, to: t, fromOffset: r, toOffset: o };
  }
  emptyChildAt(e) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let t = this.children[e < 0 ? 0 : this.children.length - 1];
    return t.size == 0 || t.emptyChildAt(e);
  }
  domAfterPos(e) {
    let { node: t, offset: i } = this.domFromPos(e, 0);
    if (t.nodeType != 1 || i == t.childNodes.length)
      throw new RangeError("No node after pos " + e);
    return t.childNodes[i];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(e, t, i, r = !1) {
    let o = Math.min(e, t), s = Math.max(e, t);
    for (let f = 0, p = 0; f < this.children.length; f++) {
      let m = this.children[f], g = p + m.size;
      if (o > p && s < g)
        return m.setSelection(e - p - m.border, t - p - m.border, i, r);
      p = g;
    }
    let a = this.domFromPos(e, e ? -1 : 1), l = t == e ? a : this.domFromPos(t, t ? -1 : 1), c = i.root.getSelection(), u = i.domSelectionRange(), d = !1;
    if ((yt || et) && e == t) {
      let { node: f, offset: p } = a;
      if (f.nodeType == 3) {
        if (d = !!(p && f.nodeValue[p - 1] == `
`), d && p == f.nodeValue.length)
          for (let m = f, g; m; m = m.parentNode) {
            if (g = m.nextSibling) {
              g.nodeName == "BR" && (a = l = { node: g.parentNode, offset: Fe(g) + 1 });
              break;
            }
            let k = m.pmViewDesc;
            if (k && k.node && k.node.isBlock)
              break;
          }
      } else {
        let m = f.childNodes[p - 1];
        d = m && (m.nodeName == "BR" || m.contentEditable == "false");
      }
    }
    if (yt && u.focusNode && u.focusNode != l.node && u.focusNode.nodeType == 1) {
      let f = u.focusNode.childNodes[u.focusOffset];
      f && f.contentEditable == "false" && (r = !0);
    }
    if (!(r || d && et) && ui(a.node, a.offset, u.anchorNode, u.anchorOffset) && ui(l.node, l.offset, u.focusNode, u.focusOffset))
      return;
    let h = !1;
    if ((c.extend || e == t) && !(d && yt)) {
      c.collapse(a.node, a.offset);
      try {
        e != t && c.extend(l.node, l.offset), h = !0;
      } catch {
      }
    }
    if (!h) {
      if (e > t) {
        let p = a;
        a = l, l = p;
      }
      let f = document.createRange();
      f.setEnd(l.node, l.offset), f.setStart(a.node, a.offset), c.removeAllRanges(), c.addRange(f);
    }
  }
  ignoreMutation(e) {
    return !this.contentDOM && e.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(e, t) {
    for (let i = 0, r = 0; r < this.children.length; r++) {
      let o = this.children[r], s = i + o.size;
      if (i == s ? e <= s && t >= i : e < s && t > i) {
        let a = i + o.border, l = s - o.border;
        if (e >= a && t <= l) {
          this.dirty = e == i || t == s ? Xn : tu, e == a && t == l && (o.contentLost || o.dom.parentNode != this.contentDOM) ? o.dirty = Ut : o.markDirty(e - a, t - a);
          return;
        } else
          o.dirty = o.dom == o.contentDOM && o.dom.parentNode == this.contentDOM && !o.children.length ? Xn : Ut;
      }
      i = s;
    }
    this.dirty = Xn;
  }
  markParentsDirty() {
    let e = 1;
    for (let t = this.parent; t; t = t.parent, e++) {
      let i = e == 1 ? Xn : tu;
      t.dirty < i && (t.dirty = i);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
  get ignoreForSelection() {
    return !1;
  }
  isText(e) {
    return !1;
  }
}
class Cf extends Pr {
  constructor(e, t, i, r) {
    let o, s = t.type.toDOM;
    if (typeof s == "function" && (s = s(i, () => {
      if (!o)
        return r;
      if (o.parent)
        return o.parent.posBeforeChild(o);
    })), !t.type.spec.raw) {
      if (s.nodeType != 1) {
        let a = document.createElement("span");
        a.appendChild(s), s = a;
      }
      s.contentEditable = "false", s.classList.add("ProseMirror-widget");
    }
    super(e, [], s, null), this.widget = t, this.widget = t, o = this;
  }
  matchesWidget(e) {
    return this.dirty == vt && e.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(e) {
    let t = this.widget.spec.stopEvent;
    return t ? t(e) : !1;
  }
  ignoreMutation(e) {
    return e.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get ignoreForSelection() {
    return !!this.widget.type.spec.relaxedSide;
  }
  get side() {
    return this.widget.type.side;
  }
}
class cL extends Pr {
  constructor(e, t, i, r) {
    super(e, [], t, null), this.textDOM = i, this.text = r;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(e, t) {
    return e != this.textDOM ? this.posAtStart + (t ? this.size : 0) : this.posAtStart + t;
  }
  domFromPos(e) {
    return { node: this.textDOM, offset: e };
  }
  ignoreMutation(e) {
    return e.type === "characterData" && e.target.nodeValue == e.oldValue;
  }
}
class di extends Pr {
  constructor(e, t, i, r, o) {
    super(e, [], i, r), this.mark = t, this.spec = o;
  }
  static create(e, t, i, r) {
    let o = r.nodeViews[t.type.name], s = o && o(t, r, i);
    return (!s || !s.dom) && (s = fi.renderSpec(document, t.type.spec.toDOM(t, i), null, t.attrs)), new di(e, t, s.dom, s.contentDOM || s.dom, s);
  }
  parseRule() {
    return this.dirty & Ut || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(e) {
    return this.dirty != Ut && this.mark.eq(e);
  }
  markDirty(e, t) {
    if (super.markDirty(e, t), this.dirty != vt) {
      let i = this.parent;
      for (; !i.node; )
        i = i.parent;
      i.dirty < this.dirty && (i.dirty = this.dirty), this.dirty = vt;
    }
  }
  slice(e, t, i) {
    let r = di.create(this.parent, this.mark, !0, i), o = this.children, s = this.size;
    t < s && (o = el(o, t, s, i)), e > 0 && (o = el(o, 0, e, i));
    for (let a = 0; a < o.length; a++)
      o[a].parent = r;
    return r.children = o, r;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
}
class Nn extends Pr {
  constructor(e, t, i, r, o, s, a, l, c) {
    super(e, [], o, s), this.node = t, this.outerDeco = i, this.innerDeco = r, this.nodeDOM = a;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(e, t, i, r, o, s) {
    let a = o.nodeViews[t.type.name], l, c = a && a(t, o, () => {
      if (!l)
        return s;
      if (l.parent)
        return l.parent.posBeforeChild(l);
    }, i, r), u = c && c.dom, d = c && c.contentDOM;
    if (t.isText) {
      if (!u)
        u = document.createTextNode(t.text);
      else if (u.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else u || ({ dom: u, contentDOM: d } = fi.renderSpec(document, t.type.spec.toDOM(t), null, t.attrs));
    !d && !t.isText && u.nodeName != "BR" && (u.hasAttribute("contenteditable") || (u.contentEditable = "false"), t.type.spec.draggable && (u.draggable = !0));
    let h = u;
    return u = $f(u, i, t), c ? l = new uL(e, t, i, r, u, d || null, h, c, o, s + 1) : t.isText ? new As(e, t, i, r, u, h, o) : new Nn(e, t, i, r, u, d || null, h, o, s + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let e = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (e.preserveWhitespace = "full"), !this.contentDOM)
      e.getContent = () => this.node.content;
    else if (!this.contentLost)
      e.contentElement = this.contentDOM;
    else {
      for (let t = this.children.length - 1; t >= 0; t--) {
        let i = this.children[t];
        if (this.dom.contains(i.dom.parentNode)) {
          e.contentElement = i.dom.parentNode;
          break;
        }
      }
      e.contentElement || (e.getContent = () => M.empty);
    }
    return e;
  }
  matchesNode(e, t, i) {
    return this.dirty == vt && e.eq(this.node) && zo(t, this.outerDeco) && i.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(e, t) {
    let i = this.node.inlineContent, r = t, o = e.composing ? this.localCompositionInfo(e, t) : null, s = o && o.pos > -1 ? o : null, a = o && o.pos < 0, l = new hL(this, s && s.node, e);
    mL(this.node, this.innerDeco, (c, u, d) => {
      c.spec.marks ? l.syncToMarks(c.spec.marks, i, e) : c.type.side >= 0 && !d && l.syncToMarks(u == this.node.childCount ? fe.none : this.node.child(u).marks, i, e), l.placeWidget(c, e, r);
    }, (c, u, d, h) => {
      l.syncToMarks(c.marks, i, e);
      let f;
      l.findNodeMatch(c, u, d, h) || a && e.state.selection.from > r && e.state.selection.to < r + c.nodeSize && (f = l.findIndexWithChild(o.node)) > -1 && l.updateNodeAt(c, u, d, f, e) || l.updateNextNode(c, u, d, e, h, r) || l.addNode(c, u, d, e, r), r += c.nodeSize;
    }), l.syncToMarks([], i, e), this.node.isTextblock && l.addTextblockHacks(), l.destroyRest(), (l.changed || this.dirty == Xn) && (s && this.protectLocalComposition(e, s), Mf(this.contentDOM, this.children, e), Di && gL(this.dom));
  }
  localCompositionInfo(e, t) {
    let { from: i, to: r } = e.state.selection;
    if (!(e.state.selection instanceof G) || i < t || r > t + this.node.content.size)
      return null;
    let o = e.input.compositionNode;
    if (!o || !this.dom.contains(o.parentNode))
      return null;
    if (this.node.inlineContent) {
      let s = o.nodeValue, a = _L(this.node.content, s, i - t, r - t);
      return a < 0 ? null : { node: o, pos: a, text: s };
    } else
      return { node: o, pos: -1, text: "" };
  }
  protectLocalComposition(e, { node: t, pos: i, text: r }) {
    if (this.getDesc(t))
      return;
    let o = t;
    for (; o.parentNode != this.contentDOM; o = o.parentNode) {
      for (; o.previousSibling; )
        o.parentNode.removeChild(o.previousSibling);
      for (; o.nextSibling; )
        o.parentNode.removeChild(o.nextSibling);
      o.pmViewDesc && (o.pmViewDesc = void 0);
    }
    let s = new cL(this, o, t, r);
    e.input.compositionNodes.push(s), this.children = el(this.children, i, i + r.length, e, s);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(e, t, i, r) {
    return this.dirty == Ut || !e.sameMarkup(this.node) ? !1 : (this.updateInner(e, t, i, r), !0);
  }
  updateInner(e, t, i, r) {
    this.updateOuterDeco(t), this.node = e, this.innerDeco = i, this.contentDOM && this.updateChildren(r, this.posAtStart), this.dirty = vt;
  }
  updateOuterDeco(e) {
    if (zo(e, this.outerDeco))
      return;
    let t = this.nodeDOM.nodeType != 1, i = this.dom;
    this.dom = Ef(this.dom, this.nodeDOM, Qa(this.outerDeco, this.node, t), Qa(e, this.node, t)), this.dom != i && (i.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = e;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.nodeDOM.draggable = !0));
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.nodeDOM.removeAttribute("draggable"));
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function nu(n, e, t, i, r) {
  $f(i, e, n);
  let o = new Nn(void 0, n, e, t, i, i, i, r, 0);
  return o.contentDOM && o.updateChildren(r, 0), o;
}
class As extends Nn {
  constructor(e, t, i, r, o, s, a) {
    super(e, t, i, r, o, null, s, a, 0);
  }
  parseRule() {
    let e = this.nodeDOM.parentNode;
    for (; e && e != this.dom && !e.pmIsDeco; )
      e = e.parentNode;
    return { skip: e || !0 };
  }
  update(e, t, i, r) {
    return this.dirty == Ut || this.dirty != vt && !this.inParent() || !e.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(t), (this.dirty != vt || e.text != this.node.text) && e.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = e.text, r.trackWrites == this.nodeDOM && (r.trackWrites = null)), this.node = e, this.dirty = vt, !0);
  }
  inParent() {
    let e = this.parent.contentDOM;
    for (let t = this.nodeDOM; t; t = t.parentNode)
      if (t == e)
        return !0;
    return !1;
  }
  domFromPos(e) {
    return { node: this.nodeDOM, offset: e };
  }
  localPosFromDOM(e, t, i) {
    return e == this.nodeDOM ? this.posAtStart + Math.min(t, this.node.text.length) : super.localPosFromDOM(e, t, i);
  }
  ignoreMutation(e) {
    return e.type != "characterData" && e.type != "selection";
  }
  slice(e, t, i) {
    let r = this.node.cut(e, t), o = document.createTextNode(r.text);
    return new As(this.parent, r, this.outerDeco, this.innerDeco, o, o, i);
  }
  markDirty(e, t) {
    super.markDirty(e, t), this.dom != this.nodeDOM && (e == 0 || t == this.nodeDOM.nodeValue.length) && (this.dirty = Ut);
  }
  get domAtom() {
    return !1;
  }
  isText(e) {
    return this.node.text == e;
  }
}
class Tf extends Pr {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(e) {
    return this.dirty == vt && this.dom.nodeName == e;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class uL extends Nn {
  constructor(e, t, i, r, o, s, a, l, c, u) {
    super(e, t, i, r, o, s, a, c, u), this.spec = l;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(e, t, i, r) {
    if (this.dirty == Ut)
      return !1;
    if (this.spec.update && (this.node.type == e.type || this.spec.multiType)) {
      let o = this.spec.update(e, t, i);
      return o && this.updateInner(e, t, i, r), o;
    } else return !this.contentDOM && !e.isLeaf ? !1 : super.update(e, t, i, r);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(e, t, i, r) {
    this.spec.setSelection ? this.spec.setSelection(e, t, i.root) : super.setSelection(e, t, i, r);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(e) {
    return this.spec.stopEvent ? this.spec.stopEvent(e) : !1;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
}
function Mf(n, e, t) {
  let i = n.firstChild, r = !1;
  for (let o = 0; o < e.length; o++) {
    let s = e[o], a = s.dom;
    if (a.parentNode == n) {
      for (; a != i; )
        i = iu(i), r = !0;
      i = i.nextSibling;
    } else
      r = !0, n.insertBefore(a, i);
    if (s instanceof di) {
      let l = i ? i.previousSibling : n.lastChild;
      Mf(s.contentDOM, s.children, t), i = l ? l.nextSibling : n.firstChild;
    }
  }
  for (; i; )
    i = iu(i), r = !0;
  r && t.trackWrites == n && (t.trackWrites = null);
}
const tr = function(n) {
  n && (this.nodeName = n);
};
tr.prototype = /* @__PURE__ */ Object.create(null);
const Qn = [new tr()];
function Qa(n, e, t) {
  if (n.length == 0)
    return Qn;
  let i = t ? Qn[0] : new tr(), r = [i];
  for (let o = 0; o < n.length; o++) {
    let s = n[o].type.attrs;
    if (s) {
      s.nodeName && r.push(i = new tr(s.nodeName));
      for (let a in s) {
        let l = s[a];
        l != null && (t && r.length == 1 && r.push(i = new tr(e.isInline ? "span" : "div")), a == "class" ? i.class = (i.class ? i.class + " " : "") + l : a == "style" ? i.style = (i.style ? i.style + ";" : "") + l : a != "nodeName" && (i[a] = l));
      }
    }
  }
  return r;
}
function Ef(n, e, t, i) {
  if (t == Qn && i == Qn)
    return e;
  let r = e;
  for (let o = 0; o < i.length; o++) {
    let s = i[o], a = t[o];
    if (o) {
      let l;
      a && a.nodeName == s.nodeName && r != n && (l = r.parentNode) && l.nodeName.toLowerCase() == s.nodeName || (l = document.createElement(s.nodeName), l.pmIsDeco = !0, l.appendChild(r), a = Qn[0]), r = l;
    }
    dL(r, a || Qn[0], s);
  }
  return r;
}
function dL(n, e, t) {
  for (let i in e)
    i != "class" && i != "style" && i != "nodeName" && !(i in t) && n.removeAttribute(i);
  for (let i in t)
    i != "class" && i != "style" && i != "nodeName" && t[i] != e[i] && n.setAttribute(i, t[i]);
  if (e.class != t.class) {
    let i = e.class ? e.class.split(" ").filter(Boolean) : [], r = t.class ? t.class.split(" ").filter(Boolean) : [];
    for (let o = 0; o < i.length; o++)
      r.indexOf(i[o]) == -1 && n.classList.remove(i[o]);
    for (let o = 0; o < r.length; o++)
      i.indexOf(r[o]) == -1 && n.classList.add(r[o]);
    n.classList.length == 0 && n.removeAttribute("class");
  }
  if (e.style != t.style) {
    if (e.style) {
      let i = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, r;
      for (; r = i.exec(e.style); )
        n.style.removeProperty(r[1]);
    }
    t.style && (n.style.cssText += t.style);
  }
}
function $f(n, e, t) {
  return Ef(n, n, Qn, Qa(e, t, n.nodeType != 1));
}
function zo(n, e) {
  if (n.length != e.length)
    return !1;
  for (let t = 0; t < n.length; t++)
    if (!n[t].type.eq(e[t].type))
      return !1;
  return !0;
}
function iu(n) {
  let e = n.nextSibling;
  return n.parentNode.removeChild(n), e;
}
class hL {
  constructor(e, t, i) {
    this.lock = t, this.view = i, this.index = 0, this.stack = [], this.changed = !1, this.top = e, this.preMatch = fL(e.node.content, e);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(e, t) {
    if (e != t) {
      for (let i = e; i < t; i++)
        this.top.children[i].destroy();
      this.top.children.splice(e, t - e), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(e, t, i) {
    let r = 0, o = this.stack.length >> 1, s = Math.min(o, e.length);
    for (; r < s && (r == o - 1 ? this.top : this.stack[r + 1 << 1]).matchesMark(e[r]) && e[r].type.spec.spanning !== !1; )
      r++;
    for (; r < o; )
      this.destroyRest(), this.top.dirty = vt, this.index = this.stack.pop(), this.top = this.stack.pop(), o--;
    for (; o < e.length; ) {
      this.stack.push(this.top, this.index + 1);
      let a = -1;
      for (let l = this.index; l < Math.min(this.index + 3, this.top.children.length); l++) {
        let c = this.top.children[l];
        if (c.matchesMark(e[o]) && !this.isLocked(c.dom)) {
          a = l;
          break;
        }
      }
      if (a > -1)
        a > this.index && (this.changed = !0, this.destroyBetween(this.index, a)), this.top = this.top.children[this.index];
      else {
        let l = di.create(this.top, e[o], t, i);
        this.top.children.splice(this.index, 0, l), this.top = l, this.changed = !0;
      }
      this.index = 0, o++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(e, t, i, r) {
    let o = -1, s;
    if (r >= this.preMatch.index && (s = this.preMatch.matches[r - this.preMatch.index]).parent == this.top && s.matchesNode(e, t, i))
      o = this.top.children.indexOf(s, this.index);
    else
      for (let a = this.index, l = Math.min(this.top.children.length, a + 5); a < l; a++) {
        let c = this.top.children[a];
        if (c.matchesNode(e, t, i) && !this.preMatch.matched.has(c)) {
          o = a;
          break;
        }
      }
    return o < 0 ? !1 : (this.destroyBetween(this.index, o), this.index++, !0);
  }
  updateNodeAt(e, t, i, r, o) {
    let s = this.top.children[r];
    return s.dirty == Ut && s.dom == s.contentDOM && (s.dirty = Xn), s.update(e, t, i, o) ? (this.destroyBetween(this.index, r), this.index++, !0) : !1;
  }
  findIndexWithChild(e) {
    for (; ; ) {
      let t = e.parentNode;
      if (!t)
        return -1;
      if (t == this.top.contentDOM) {
        let i = e.pmViewDesc;
        if (i) {
          for (let r = this.index; r < this.top.children.length; r++)
            if (this.top.children[r] == i)
              return r;
        }
        return -1;
      }
      e = t;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(e, t, i, r, o, s) {
    for (let a = this.index; a < this.top.children.length; a++) {
      let l = this.top.children[a];
      if (l instanceof Nn) {
        let c = this.preMatch.matched.get(l);
        if (c != null && c != o)
          return !1;
        let u = l.dom, d, h = this.isLocked(u) && !(e.isText && l.node && l.node.isText && l.nodeDOM.nodeValue == e.text && l.dirty != Ut && zo(t, l.outerDeco));
        if (!h && l.update(e, t, i, r))
          return this.destroyBetween(this.index, a), l.dom != u && (this.changed = !0), this.index++, !0;
        if (!h && (d = this.recreateWrapper(l, e, t, i, r, s)))
          return this.destroyBetween(this.index, a), this.top.children[this.index] = d, d.contentDOM && (d.dirty = Xn, d.updateChildren(r, s + 1), d.dirty = vt), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(e, t, i, r, o, s) {
    if (e.dirty || t.isAtom || !e.children.length || !e.node.content.eq(t.content) || !zo(i, e.outerDeco) || !r.eq(e.innerDeco))
      return null;
    let a = Nn.create(this.top, t, i, r, o, s);
    if (a.contentDOM) {
      a.children = e.children, e.children = [];
      for (let l of a.children)
        l.parent = a;
    }
    return e.destroy(), a;
  }
  // Insert the node as a newly created node desc.
  addNode(e, t, i, r, o) {
    let s = Nn.create(this.top, e, t, i, r, o);
    s.contentDOM && s.updateChildren(r, o + 1), this.top.children.splice(this.index++, 0, s), this.changed = !0;
  }
  placeWidget(e, t, i) {
    let r = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (r && r.matchesWidget(e) && (e == r.widget || !r.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let o = new Cf(this.top, e, t, i);
      this.top.children.splice(this.index++, 0, o), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let e = this.top.children[this.index - 1], t = this.top;
    for (; e instanceof di; )
      t = e, e = t.children[t.children.length - 1];
    (!e || // Empty textblock
    !(e instanceof As) || /\n$/.test(e.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(e.node.text)) && ((et || Ze) && e && e.dom.contentEditable == "false" && this.addHackNode("IMG", t), this.addHackNode("BR", this.top));
  }
  addHackNode(e, t) {
    if (t == this.top && this.index < t.children.length && t.children[this.index].matchesHack(e))
      this.index++;
    else {
      let i = document.createElement(e);
      e == "IMG" && (i.className = "ProseMirror-separator", i.alt = ""), e == "BR" && (i.className = "ProseMirror-trailingBreak");
      let r = new Tf(this.top, [], i, null);
      t != this.top ? t.children.push(r) : t.children.splice(this.index++, 0, r), this.changed = !0;
    }
  }
  isLocked(e) {
    return this.lock && (e == this.lock || e.nodeType == 1 && e.contains(this.lock.parentNode));
  }
}
function fL(n, e) {
  let t = e, i = t.children.length, r = n.childCount, o = /* @__PURE__ */ new Map(), s = [];
  e: for (; r > 0; ) {
    let a;
    for (; ; )
      if (i) {
        let c = t.children[i - 1];
        if (c instanceof di)
          t = c, i = c.children.length;
        else {
          a = c, i--;
          break;
        }
      } else {
        if (t == e)
          break e;
        i = t.parent.children.indexOf(t), t = t.parent;
      }
    let l = a.node;
    if (l) {
      if (l != n.child(r - 1))
        break;
      --r, o.set(a, r), s.push(a);
    }
  }
  return { index: r, matched: o, matches: s.reverse() };
}
function pL(n, e) {
  return n.type.side - e.type.side;
}
function mL(n, e, t, i) {
  let r = e.locals(n), o = 0;
  if (r.length == 0) {
    for (let c = 0; c < n.childCount; c++) {
      let u = n.child(c);
      i(u, r, e.forChild(o, u), c), o += u.nodeSize;
    }
    return;
  }
  let s = 0, a = [], l = null;
  for (let c = 0; ; ) {
    let u, d;
    for (; s < r.length && r[s].to == o; ) {
      let g = r[s++];
      g.widget && (u ? (d || (d = [u])).push(g) : u = g);
    }
    if (u)
      if (d) {
        d.sort(pL);
        for (let g = 0; g < d.length; g++)
          t(d[g], c, !!l);
      } else
        t(u, c, !!l);
    let h, f;
    if (l)
      f = -1, h = l, l = null;
    else if (c < n.childCount)
      f = c, h = n.child(c++);
    else
      break;
    for (let g = 0; g < a.length; g++)
      a[g].to <= o && a.splice(g--, 1);
    for (; s < r.length && r[s].from <= o && r[s].to > o; )
      a.push(r[s++]);
    let p = o + h.nodeSize;
    if (h.isText) {
      let g = p;
      s < r.length && r[s].from < g && (g = r[s].from);
      for (let k = 0; k < a.length; k++)
        a[k].to < g && (g = a[k].to);
      g < p && (l = h.cut(g - o), h = h.cut(0, g - o), p = g, f = -1);
    } else
      for (; s < r.length && r[s].to < p; )
        s++;
    let m = h.isInline && !h.isLeaf ? a.filter((g) => !g.inline) : a.slice();
    i(h, m, e.forChild(o, h), f), o = p;
  }
}
function gL(n) {
  if (n.nodeName == "UL" || n.nodeName == "OL") {
    let e = n.style.cssText;
    n.style.cssText = e + "; list-style: square !important", window.getComputedStyle(n).listStyle, n.style.cssText = e;
  }
}
function _L(n, e, t, i) {
  for (let r = 0, o = 0; r < n.childCount && o <= i; ) {
    let s = n.child(r++), a = o;
    if (o += s.nodeSize, !s.isText)
      continue;
    let l = s.text;
    for (; r < n.childCount; ) {
      let c = n.child(r++);
      if (o += c.nodeSize, !c.isText)
        break;
      l += c.text;
    }
    if (o >= t) {
      if (o >= i && l.slice(i - e.length - a, i - a) == e)
        return i - e.length;
      let c = a < i ? l.lastIndexOf(e, i - a - 1) : -1;
      if (c >= 0 && c + e.length + a >= t)
        return a + c;
      if (t == i && l.length >= i + e.length - a && l.slice(i - a, i - a + e.length) == e)
        return i;
    }
  }
  return -1;
}
function el(n, e, t, i, r) {
  let o = [];
  for (let s = 0, a = 0; s < n.length; s++) {
    let l = n[s], c = a, u = a += l.size;
    c >= t || u <= e ? o.push(l) : (c < e && o.push(l.slice(0, e - c, i)), r && (o.push(r), r = void 0), u > t && o.push(l.slice(t - c, l.size, i)));
  }
  return o;
}
function Il(n, e = null) {
  let t = n.domSelectionRange(), i = n.state.doc;
  if (!t.focusNode)
    return null;
  let r = n.docView.nearestDesc(t.focusNode), o = r && r.size == 0, s = n.docView.posFromDOM(t.focusNode, t.focusOffset, 1);
  if (s < 0)
    return null;
  let a = i.resolve(s), l, c;
  if (zs(t)) {
    for (l = s; r && !r.node; )
      r = r.parent;
    let d = r.node;
    if (r && d.isAtom && F.isSelectable(d) && r.parent && !(d.isInline && HN(t.focusNode, t.focusOffset, r.dom))) {
      let h = r.posBefore;
      c = new F(s == h ? a : i.resolve(h));
    }
  } else {
    if (t instanceof n.dom.ownerDocument.defaultView.Selection && t.rangeCount > 1) {
      let d = s, h = s;
      for (let f = 0; f < t.rangeCount; f++) {
        let p = t.getRangeAt(f);
        d = Math.min(d, n.docView.posFromDOM(p.startContainer, p.startOffset, 1)), h = Math.max(h, n.docView.posFromDOM(p.endContainer, p.endOffset, -1));
      }
      if (d < 0)
        return null;
      [l, s] = h == n.state.selection.anchor ? [h, d] : [d, h], a = i.resolve(s);
    } else
      l = n.docView.posFromDOM(t.anchorNode, t.anchorOffset, 1);
    if (l < 0)
      return null;
  }
  let u = i.resolve(l);
  if (!c) {
    let d = e == "pointer" || n.state.selection.head < a.pos && !o ? 1 : -1;
    c = Pl(n, u, a, d);
  }
  return c;
}
function Of(n) {
  return n.editable ? n.hasFocus() : Af(n) && document.activeElement && document.activeElement.contains(n.dom);
}
function cn(n, e = !1) {
  let t = n.state.selection;
  if (zf(n, t), !!Of(n)) {
    if (!e && n.input.mouseDown && n.input.mouseDown.allowDefault && Ze) {
      let i = n.domSelectionRange(), r = n.domObserver.currentSelection;
      if (i.anchorNode && r.anchorNode && ui(i.anchorNode, i.anchorOffset, r.anchorNode, r.anchorOffset)) {
        n.input.mouseDown.delayedSelectionSync = !0, n.domObserver.setCurSelection();
        return;
      }
    }
    if (n.domObserver.disconnectSelection(), n.cursorWrapper)
      kL(n);
    else {
      let { anchor: i, head: r } = t, o, s;
      ru && !(t instanceof G) && (t.$from.parent.inlineContent || (o = ou(n, t.from)), !t.empty && !t.$from.parent.inlineContent && (s = ou(n, t.to))), n.docView.setSelection(i, r, n, e), ru && (o && su(o), s && su(s)), t.visible ? n.dom.classList.remove("ProseMirror-hideselection") : (n.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && bL(n));
    }
    n.domObserver.setCurSelection(), n.domObserver.connectSelection();
  }
}
const ru = et || Ze && bf < 63;
function ou(n, e) {
  let { node: t, offset: i } = n.docView.domFromPos(e, 0), r = i < t.childNodes.length ? t.childNodes[i] : null, o = i ? t.childNodes[i - 1] : null;
  if (et && r && r.contentEditable == "false")
    return oa(r);
  if ((!r || r.contentEditable == "false") && (!o || o.contentEditable == "false")) {
    if (r)
      return oa(r);
    if (o)
      return oa(o);
  }
}
function oa(n) {
  return n.contentEditable = "true", et && n.draggable && (n.draggable = !1, n.wasDraggable = !0), n;
}
function su(n) {
  n.contentEditable = "false", n.wasDraggable && (n.draggable = !0, n.wasDraggable = null);
}
function bL(n) {
  let e = n.dom.ownerDocument;
  e.removeEventListener("selectionchange", n.input.hideSelectionGuard);
  let t = n.domSelectionRange(), i = t.anchorNode, r = t.anchorOffset;
  e.addEventListener("selectionchange", n.input.hideSelectionGuard = () => {
    (t.anchorNode != i || t.anchorOffset != r) && (e.removeEventListener("selectionchange", n.input.hideSelectionGuard), setTimeout(() => {
      (!Of(n) || n.state.selection.visible) && n.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function kL(n) {
  let e = n.domSelection();
  if (!e)
    return;
  let t = n.cursorWrapper.dom, i = t.nodeName == "IMG";
  i ? e.collapse(t.parentNode, Fe(t) + 1) : e.collapse(t, 0), !i && !n.state.selection.visible && st && An <= 11 && (t.disabled = !0, t.disabled = !1);
}
function zf(n, e) {
  if (e instanceof F) {
    let t = n.docView.descAt(e.from);
    t != n.lastSelectedViewDesc && (au(n), t && t.selectNode(), n.lastSelectedViewDesc = t);
  } else
    au(n);
}
function au(n) {
  n.lastSelectedViewDesc && (n.lastSelectedViewDesc.parent && n.lastSelectedViewDesc.deselectNode(), n.lastSelectedViewDesc = void 0);
}
function Pl(n, e, t, i) {
  return n.someProp("createSelectionBetween", (r) => r(n, e, t)) || G.between(e, t, i);
}
function lu(n) {
  return n.editable && !n.hasFocus() ? !1 : Af(n);
}
function Af(n) {
  let e = n.domSelectionRange();
  if (!e.anchorNode)
    return !1;
  try {
    return n.dom.contains(e.anchorNode.nodeType == 3 ? e.anchorNode.parentNode : e.anchorNode) && (n.editable || n.dom.contains(e.focusNode.nodeType == 3 ? e.focusNode.parentNode : e.focusNode));
  } catch {
    return !1;
  }
}
function yL(n) {
  let e = n.docView.domFromPos(n.state.selection.anchor, 0), t = n.domSelectionRange();
  return ui(e.node, e.offset, t.anchorNode, t.anchorOffset);
}
function tl(n, e) {
  let { $anchor: t, $head: i } = n.selection, r = e > 0 ? t.max(i) : t.min(i), o = r.parent.inlineContent ? r.depth ? n.doc.resolve(e > 0 ? r.after() : r.before()) : null : r;
  return o && ne.findFrom(o, e);
}
function vn(n, e) {
  return n.dispatch(n.state.tr.setSelection(e).scrollIntoView()), !0;
}
function cu(n, e, t) {
  let i = n.state.selection;
  if (i instanceof G)
    if (t.indexOf("s") > -1) {
      let { $head: r } = i, o = r.textOffset ? null : e < 0 ? r.nodeBefore : r.nodeAfter;
      if (!o || o.isText || !o.isLeaf)
        return !1;
      let s = n.state.doc.resolve(r.pos + o.nodeSize * (e < 0 ? -1 : 1));
      return vn(n, new G(i.$anchor, s));
    } else if (i.empty) {
      if (n.endOfTextblock(e > 0 ? "forward" : "backward")) {
        let r = tl(n.state, e);
        return r && r instanceof F ? vn(n, r) : !1;
      } else if (!(_t && t.indexOf("m") > -1)) {
        let r = i.$head, o = r.textOffset ? null : e < 0 ? r.nodeBefore : r.nodeAfter, s;
        if (!o || o.isText)
          return !1;
        let a = e < 0 ? r.pos - o.nodeSize : r.pos;
        return o.isAtom || (s = n.docView.descAt(a)) && !s.contentDOM ? F.isSelectable(o) ? vn(n, new F(e < 0 ? n.state.doc.resolve(r.pos - o.nodeSize) : r)) : Ir ? vn(n, new G(n.state.doc.resolve(e < 0 ? a : a + o.nodeSize))) : !1 : !1;
      }
    } else return !1;
  else {
    if (i instanceof F && i.node.isInline)
      return vn(n, new G(e > 0 ? i.$to : i.$from));
    {
      let r = tl(n.state, e);
      return r ? vn(n, r) : !1;
    }
  }
}
function Ao(n) {
  return n.nodeType == 3 ? n.nodeValue.length : n.childNodes.length;
}
function nr(n, e) {
  let t = n.pmViewDesc;
  return t && t.size == 0 && (e < 0 || n.nextSibling || n.nodeName != "BR");
}
function ki(n, e) {
  return e < 0 ? vL(n) : xL(n);
}
function vL(n) {
  let e = n.domSelectionRange(), t = e.focusNode, i = e.focusOffset;
  if (!t)
    return;
  let r, o, s = !1;
  for (yt && t.nodeType == 1 && i < Ao(t) && nr(t.childNodes[i], -1) && (s = !0); ; )
    if (i > 0) {
      if (t.nodeType != 1)
        break;
      {
        let a = t.childNodes[i - 1];
        if (nr(a, -1))
          r = t, o = --i;
        else if (a.nodeType == 3)
          t = a, i = t.nodeValue.length;
        else
          break;
      }
    } else {
      if (Nf(t))
        break;
      {
        let a = t.previousSibling;
        for (; a && nr(a, -1); )
          r = t.parentNode, o = Fe(a), a = a.previousSibling;
        if (a)
          t = a, i = Ao(t);
        else {
          if (t = t.parentNode, t == n.dom)
            break;
          i = 0;
        }
      }
    }
  s ? nl(n, t, i) : r && nl(n, r, o);
}
function xL(n) {
  let e = n.domSelectionRange(), t = e.focusNode, i = e.focusOffset;
  if (!t)
    return;
  let r = Ao(t), o, s;
  for (; ; )
    if (i < r) {
      if (t.nodeType != 1)
        break;
      let a = t.childNodes[i];
      if (nr(a, 1))
        o = t, s = ++i;
      else
        break;
    } else {
      if (Nf(t))
        break;
      {
        let a = t.nextSibling;
        for (; a && nr(a, 1); )
          o = a.parentNode, s = Fe(a) + 1, a = a.nextSibling;
        if (a)
          t = a, i = 0, r = Ao(t);
        else {
          if (t = t.parentNode, t == n.dom)
            break;
          i = r = 0;
        }
      }
    }
  o && nl(n, o, s);
}
function Nf(n) {
  let e = n.pmViewDesc;
  return e && e.node && e.node.isBlock;
}
function SL(n, e) {
  for (; n && e == n.childNodes.length && !Rr(n); )
    e = Fe(n) + 1, n = n.parentNode;
  for (; n && e < n.childNodes.length; ) {
    let t = n.childNodes[e];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    n = t, e = 0;
  }
}
function wL(n, e) {
  for (; n && !e && !Rr(n); )
    e = Fe(n), n = n.parentNode;
  for (; n && e; ) {
    let t = n.childNodes[e - 1];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    n = t, e = n.childNodes.length;
  }
}
function nl(n, e, t) {
  if (e.nodeType != 3) {
    let o, s;
    (s = SL(e, t)) ? (e = s, t = 0) : (o = wL(e, t)) && (e = o, t = o.nodeValue.length);
  }
  let i = n.domSelection();
  if (!i)
    return;
  if (zs(i)) {
    let o = document.createRange();
    o.setEnd(e, t), o.setStart(e, t), i.removeAllRanges(), i.addRange(o);
  } else i.extend && i.extend(e, t);
  n.domObserver.setCurSelection();
  let { state: r } = n;
  setTimeout(() => {
    n.state == r && cn(n);
  }, 50);
}
function uu(n, e) {
  let t = n.state.doc.resolve(e);
  if (!(Ze || WN) && t.parent.inlineContent) {
    let r = n.coordsAtPos(e);
    if (e > t.start()) {
      let o = n.coordsAtPos(e - 1), s = (o.top + o.bottom) / 2;
      if (s > r.top && s < r.bottom && Math.abs(o.left - r.left) > 1)
        return o.left < r.left ? "ltr" : "rtl";
    }
    if (e < t.end()) {
      let o = n.coordsAtPos(e + 1), s = (o.top + o.bottom) / 2;
      if (s > r.top && s < r.bottom && Math.abs(o.left - r.left) > 1)
        return o.left > r.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(n.dom).direction == "rtl" ? "rtl" : "ltr";
}
function du(n, e, t) {
  let i = n.state.selection;
  if (i instanceof G && !i.empty || t.indexOf("s") > -1 || _t && t.indexOf("m") > -1)
    return !1;
  let { $from: r, $to: o } = i;
  if (!r.parent.inlineContent || n.endOfTextblock(e < 0 ? "up" : "down")) {
    let s = tl(n.state, e);
    if (s && s instanceof F)
      return vn(n, s);
  }
  if (!r.parent.inlineContent) {
    let s = e < 0 ? r : o, a = i instanceof ot ? ne.near(s, e) : ne.findFrom(s, e);
    return a ? vn(n, a) : !1;
  }
  return !1;
}
function hu(n, e) {
  if (!(n.state.selection instanceof G))
    return !0;
  let { $head: t, $anchor: i, empty: r } = n.state.selection;
  if (!t.sameParent(i))
    return !0;
  if (!r)
    return !1;
  if (n.endOfTextblock(e > 0 ? "forward" : "backward"))
    return !0;
  let o = !t.textOffset && (e < 0 ? t.nodeBefore : t.nodeAfter);
  if (o && !o.isText) {
    let s = n.state.tr;
    return e < 0 ? s.delete(t.pos - o.nodeSize, t.pos) : s.delete(t.pos, t.pos + o.nodeSize), n.dispatch(s), !0;
  }
  return !1;
}
function fu(n, e, t) {
  n.domObserver.stop(), e.contentEditable = t, n.domObserver.start();
}
function CL(n) {
  if (!et || n.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: e, focusOffset: t } = n.domSelectionRange();
  if (e && e.nodeType == 1 && t == 0 && e.firstChild && e.firstChild.contentEditable == "false") {
    let i = e.firstChild;
    fu(n, i, "true"), setTimeout(() => fu(n, i, "false"), 20);
  }
  return !1;
}
function TL(n) {
  let e = "";
  return n.ctrlKey && (e += "c"), n.metaKey && (e += "m"), n.altKey && (e += "a"), n.shiftKey && (e += "s"), e;
}
function ML(n, e) {
  let t = e.keyCode, i = TL(e);
  if (t == 8 || _t && t == 72 && i == "c")
    return hu(n, -1) || ki(n, -1);
  if (t == 46 && !e.shiftKey || _t && t == 68 && i == "c")
    return hu(n, 1) || ki(n, 1);
  if (t == 13 || t == 27)
    return !0;
  if (t == 37 || _t && t == 66 && i == "c") {
    let r = t == 37 ? uu(n, n.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return cu(n, r, i) || ki(n, r);
  } else if (t == 39 || _t && t == 70 && i == "c") {
    let r = t == 39 ? uu(n, n.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return cu(n, r, i) || ki(n, r);
  } else {
    if (t == 38 || _t && t == 80 && i == "c")
      return du(n, -1, i) || ki(n, -1);
    if (t == 40 || _t && t == 78 && i == "c")
      return CL(n) || du(n, 1, i) || ki(n, 1);
    if (i == (_t ? "m" : "c") && (t == 66 || t == 73 || t == 89 || t == 90))
      return !0;
  }
  return !1;
}
function jl(n, e) {
  n.someProp("transformCopied", (f) => {
    e = f(e, n);
  });
  let t = [], { content: i, openStart: r, openEnd: o } = e;
  for (; r > 1 && o > 1 && i.childCount == 1 && i.firstChild.childCount == 1; ) {
    r--, o--;
    let f = i.firstChild;
    t.push(f.type.name, f.attrs != f.type.defaultAttrs ? f.attrs : null), i = f.content;
  }
  let s = n.someProp("clipboardSerializer") || fi.fromSchema(n.state.schema), a = jf(), l = a.createElement("div");
  l.appendChild(s.serializeFragment(i, { document: a }));
  let c = l.firstChild, u, d = 0;
  for (; c && c.nodeType == 1 && (u = Pf[c.nodeName.toLowerCase()]); ) {
    for (let f = u.length - 1; f >= 0; f--) {
      let p = a.createElement(u[f]);
      for (; l.firstChild; )
        p.appendChild(l.firstChild);
      l.appendChild(p), d++;
    }
    c = l.firstChild;
  }
  c && c.nodeType == 1 && c.setAttribute("data-pm-slice", `${r} ${o}${d ? ` -${d}` : ""} ${JSON.stringify(t)}`);
  let h = n.someProp("clipboardTextSerializer", (f) => f(e, n)) || e.content.textBetween(0, e.content.size, `

`);
  return { dom: l, text: h, slice: e };
}
function Lf(n, e, t, i, r) {
  let o = r.parent.type.spec.code, s, a;
  if (!t && !e)
    return null;
  let l = !!e && (i || o || !t);
  if (l) {
    if (n.someProp("transformPastedText", (h) => {
      e = h(e, o || i, n);
    }), o)
      return a = new L(M.from(n.state.schema.text(e.replace(/\r\n?/g, `
`))), 0, 0), n.someProp("transformPasted", (h) => {
        a = h(a, n, !0);
      }), a;
    let d = n.someProp("clipboardTextParser", (h) => h(e, r, i, n));
    if (d)
      a = d;
    else {
      let h = r.marks(), { schema: f } = n.state, p = fi.fromSchema(f);
      s = document.createElement("div"), e.split(/(?:\r\n?|\n)+/).forEach((m) => {
        let g = s.appendChild(document.createElement("p"));
        m && g.appendChild(p.serializeNode(f.text(m, h)));
      });
    }
  } else
    n.someProp("transformPastedHTML", (d) => {
      t = d(t, n);
    }), s = zL(t), Ir && AL(s);
  let c = s && s.querySelector("[data-pm-slice]"), u = c && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(c.getAttribute("data-pm-slice") || "");
  if (u && u[3])
    for (let d = +u[3]; d > 0; d--) {
      let h = s.firstChild;
      for (; h && h.nodeType != 1; )
        h = h.nextSibling;
      if (!h)
        break;
      s = h;
    }
  if (a || (a = (n.someProp("clipboardParser") || n.someProp("domParser") || zn.fromSchema(n.state.schema)).parseSlice(s, {
    preserveWhitespace: !!(l || u),
    context: r,
    ruleFromNode(h) {
      return h.nodeName == "BR" && !h.nextSibling && h.parentNode && !EL.test(h.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), u)
    a = NL(pu(a, +u[1], +u[2]), u[4]);
  else if (a = L.maxOpen($L(a.content, r), !0), a.openStart || a.openEnd) {
    let d = 0, h = 0;
    for (let f = a.content.firstChild; d < a.openStart && !f.type.spec.isolating; d++, f = f.firstChild)
      ;
    for (let f = a.content.lastChild; h < a.openEnd && !f.type.spec.isolating; h++, f = f.lastChild)
      ;
    a = pu(a, d, h);
  }
  return n.someProp("transformPasted", (d) => {
    a = d(a, n, l);
  }), a;
}
const EL = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function $L(n, e) {
  if (n.childCount < 2)
    return n;
  for (let t = e.depth; t >= 0; t--) {
    let r = e.node(t).contentMatchAt(e.index(t)), o, s = [];
    if (n.forEach((a) => {
      if (!s)
        return;
      let l = r.findWrapping(a.type), c;
      if (!l)
        return s = null;
      if (c = s.length && o.length && Rf(l, o, a, s[s.length - 1], 0))
        s[s.length - 1] = c;
      else {
        s.length && (s[s.length - 1] = If(s[s.length - 1], o.length));
        let u = Df(a, l);
        s.push(u), r = r.matchType(u.type), o = l;
      }
    }), s)
      return M.from(s);
  }
  return n;
}
function Df(n, e, t = 0) {
  for (let i = e.length - 1; i >= t; i--)
    n = e[i].create(null, M.from(n));
  return n;
}
function Rf(n, e, t, i, r) {
  if (r < n.length && r < e.length && n[r] == e[r]) {
    let o = Rf(n, e, t, i.lastChild, r + 1);
    if (o)
      return i.copy(i.content.replaceChild(i.childCount - 1, o));
    if (i.contentMatchAt(i.childCount).matchType(r == n.length - 1 ? t.type : n[r + 1]))
      return i.copy(i.content.append(M.from(Df(t, n, r + 1))));
  }
}
function If(n, e) {
  if (e == 0)
    return n;
  let t = n.content.replaceChild(n.childCount - 1, If(n.lastChild, e - 1)), i = n.contentMatchAt(n.childCount).fillBefore(M.empty, !0);
  return n.copy(t.append(i));
}
function il(n, e, t, i, r, o) {
  let s = e < 0 ? n.firstChild : n.lastChild, a = s.content;
  return n.childCount > 1 && (o = 0), r < i - 1 && (a = il(a, e, t, i, r + 1, o)), r >= t && (a = e < 0 ? s.contentMatchAt(0).fillBefore(a, o <= r).append(a) : a.append(s.contentMatchAt(s.childCount).fillBefore(M.empty, !0))), n.replaceChild(e < 0 ? 0 : n.childCount - 1, s.copy(a));
}
function pu(n, e, t) {
  return e < n.openStart && (n = new L(il(n.content, -1, e, n.openStart, 0, n.openEnd), e, n.openEnd)), t < n.openEnd && (n = new L(il(n.content, 1, t, n.openEnd, 0, 0), n.openStart, t)), n;
}
const Pf = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let mu = null;
function jf() {
  return mu || (mu = document.implementation.createHTMLDocument("title"));
}
let sa = null;
function OL(n) {
  let e = window.trustedTypes;
  return e ? (sa || (sa = e.defaultPolicy || e.createPolicy("ProseMirrorClipboard", { createHTML: (t) => t })), sa.createHTML(n)) : n;
}
function zL(n) {
  let e = /^(\s*<meta [^>]*>)*/.exec(n);
  e && (n = n.slice(e[0].length));
  let t = jf().createElement("div"), i = /<([a-z][^>\s]+)/i.exec(n), r;
  if ((r = i && Pf[i[1].toLowerCase()]) && (n = r.map((o) => "<" + o + ">").join("") + n + r.map((o) => "</" + o + ">").reverse().join("")), t.innerHTML = OL(n), r)
    for (let o = 0; o < r.length; o++)
      t = t.querySelector(r[o]) || t;
  return t;
}
function AL(n) {
  let e = n.querySelectorAll(Ze ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let t = 0; t < e.length; t++) {
    let i = e[t];
    i.childNodes.length == 1 && i.textContent == " " && i.parentNode && i.parentNode.replaceChild(n.ownerDocument.createTextNode(" "), i);
  }
}
function NL(n, e) {
  if (!n.size)
    return n;
  let t = n.content.firstChild.type.schema, i;
  try {
    i = JSON.parse(e);
  } catch {
    return n;
  }
  let { content: r, openStart: o, openEnd: s } = n;
  for (let a = i.length - 2; a >= 0; a -= 2) {
    let l = t.nodes[i[a]];
    if (!l || l.hasRequiredAttrs())
      break;
    r = M.from(l.create(i[a + 1], r)), o++, s++;
  }
  return new L(r, o, s);
}
const tt = {}, nt = {}, LL = { touchstart: !0, touchmove: !0 };
class DL {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "", button: 0 }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastChromeDelete = 0, this.composing = !1, this.compositionNode = null, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
}
function RL(n) {
  for (let e in tt) {
    let t = tt[e];
    n.dom.addEventListener(e, n.input.eventHandlers[e] = (i) => {
      PL(n, i) && !Bl(n, i) && (n.editable || !(i.type in nt)) && t(n, i);
    }, LL[e] ? { passive: !0 } : void 0);
  }
  et && n.dom.addEventListener("input", () => null), rl(n);
}
function En(n, e) {
  n.input.lastSelectionOrigin = e, n.input.lastSelectionTime = Date.now();
}
function IL(n) {
  n.domObserver.stop();
  for (let e in n.input.eventHandlers)
    n.dom.removeEventListener(e, n.input.eventHandlers[e]);
  clearTimeout(n.input.composingTimeout), clearTimeout(n.input.lastIOSEnterFallbackTimeout);
}
function rl(n) {
  n.someProp("handleDOMEvents", (e) => {
    for (let t in e)
      n.input.eventHandlers[t] || n.dom.addEventListener(t, n.input.eventHandlers[t] = (i) => Bl(n, i));
  });
}
function Bl(n, e) {
  return n.someProp("handleDOMEvents", (t) => {
    let i = t[e.type];
    return i ? i(n, e) || e.defaultPrevented : !1;
  });
}
function PL(n, e) {
  if (!e.bubbles)
    return !0;
  if (e.defaultPrevented)
    return !1;
  for (let t = e.target; t != n.dom; t = t.parentNode)
    if (!t || t.nodeType == 11 || t.pmViewDesc && t.pmViewDesc.stopEvent(e))
      return !1;
  return !0;
}
function jL(n, e) {
  !Bl(n, e) && tt[e.type] && (n.editable || !(e.type in nt)) && tt[e.type](n, e);
}
nt.keydown = (n, e) => {
  let t = e;
  if (n.input.shiftKey = t.keyCode == 16 || t.shiftKey, !Ff(n, t) && (n.input.lastKeyCode = t.keyCode, n.input.lastKeyCodeTime = Date.now(), !(on && Ze && t.keyCode == 13)))
    if (t.keyCode != 229 && n.domObserver.forceFlush(), Di && t.keyCode == 13 && !t.ctrlKey && !t.altKey && !t.metaKey) {
      let i = Date.now();
      n.input.lastIOSEnter = i, n.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        n.input.lastIOSEnter == i && (n.someProp("handleKeyDown", (r) => r(n, Gn(13, "Enter"))), n.input.lastIOSEnter = 0);
      }, 200);
    } else n.someProp("handleKeyDown", (i) => i(n, t)) || ML(n, t) ? t.preventDefault() : En(n, "key");
};
nt.keyup = (n, e) => {
  e.keyCode == 16 && (n.input.shiftKey = !1);
};
nt.keypress = (n, e) => {
  let t = e;
  if (Ff(n, t) || !t.charCode || t.ctrlKey && !t.altKey || _t && t.metaKey)
    return;
  if (n.someProp("handleKeyPress", (r) => r(n, t))) {
    t.preventDefault();
    return;
  }
  let i = n.state.selection;
  if (!(i instanceof G) || !i.$from.sameParent(i.$to)) {
    let r = String.fromCharCode(t.charCode), o = () => n.state.tr.insertText(r).scrollIntoView();
    !/[\r\n]/.test(r) && !n.someProp("handleTextInput", (s) => s(n, i.$from.pos, i.$to.pos, r, o)) && n.dispatch(o()), t.preventDefault();
  }
};
function Ns(n) {
  return { left: n.clientX, top: n.clientY };
}
function BL(n, e) {
  let t = e.x - n.clientX, i = e.y - n.clientY;
  return t * t + i * i < 100;
}
function Fl(n, e, t, i, r) {
  if (i == -1)
    return !1;
  let o = n.state.doc.resolve(i);
  for (let s = o.depth + 1; s > 0; s--)
    if (n.someProp(e, (a) => s > o.depth ? a(n, t, o.nodeAfter, o.before(s), r, !0) : a(n, t, o.node(s), o.before(s), r, !1)))
      return !0;
  return !1;
}
function Ai(n, e, t) {
  if (n.focused || n.focus(), n.state.selection.eq(e))
    return;
  let i = n.state.tr.setSelection(e);
  i.setMeta("pointer", !0), n.dispatch(i);
}
function FL(n, e) {
  if (e == -1)
    return !1;
  let t = n.state.doc.resolve(e), i = t.nodeAfter;
  return i && i.isAtom && F.isSelectable(i) ? (Ai(n, new F(t)), !0) : !1;
}
function qL(n, e) {
  if (e == -1)
    return !1;
  let t = n.state.selection, i, r;
  t instanceof F && (i = t.node);
  let o = n.state.doc.resolve(e);
  for (let s = o.depth + 1; s > 0; s--) {
    let a = s > o.depth ? o.nodeAfter : o.node(s);
    if (F.isSelectable(a)) {
      i && t.$from.depth > 0 && s >= t.$from.depth && o.before(t.$from.depth + 1) == t.$from.pos ? r = o.before(t.$from.depth) : r = o.before(s);
      break;
    }
  }
  return r != null ? (Ai(n, F.create(n.state.doc, r)), !0) : !1;
}
function HL(n, e, t, i, r) {
  return Fl(n, "handleClickOn", e, t, i) || n.someProp("handleClick", (o) => o(n, e, i)) || (r ? qL(n, t) : FL(n, t));
}
function VL(n, e, t, i) {
  return Fl(n, "handleDoubleClickOn", e, t, i) || n.someProp("handleDoubleClick", (r) => r(n, e, i));
}
function UL(n, e, t, i) {
  return Fl(n, "handleTripleClickOn", e, t, i) || n.someProp("handleTripleClick", (r) => r(n, e, i)) || WL(n, t, i);
}
function WL(n, e, t) {
  if (t.button != 0)
    return !1;
  let i = n.state.doc;
  if (e == -1)
    return i.inlineContent ? (Ai(n, G.create(i, 0, i.content.size)), !0) : !1;
  let r = i.resolve(e);
  for (let o = r.depth + 1; o > 0; o--) {
    let s = o > r.depth ? r.nodeAfter : r.node(o), a = r.before(o);
    if (s.inlineContent)
      Ai(n, G.create(i, a + 1, a + 1 + s.content.size));
    else if (F.isSelectable(s))
      Ai(n, F.create(i, a));
    else
      continue;
    return !0;
  }
}
function ql(n) {
  return No(n);
}
const Bf = _t ? "metaKey" : "ctrlKey";
tt.mousedown = (n, e) => {
  let t = e;
  n.input.shiftKey = t.shiftKey;
  let i = ql(n), r = Date.now(), o = "singleClick";
  r - n.input.lastClick.time < 500 && BL(t, n.input.lastClick) && !t[Bf] && n.input.lastClick.button == t.button && (n.input.lastClick.type == "singleClick" ? o = "doubleClick" : n.input.lastClick.type == "doubleClick" && (o = "tripleClick")), n.input.lastClick = { time: r, x: t.clientX, y: t.clientY, type: o, button: t.button };
  let s = n.posAtCoords(Ns(t));
  s && (o == "singleClick" ? (n.input.mouseDown && n.input.mouseDown.done(), n.input.mouseDown = new KL(n, s, t, !!i)) : (o == "doubleClick" ? VL : UL)(n, s.pos, s.inside, t) ? t.preventDefault() : En(n, "pointer"));
};
class KL {
  constructor(e, t, i, r) {
    this.view = e, this.pos = t, this.event = i, this.flushed = r, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = e.state.doc, this.selectNode = !!i[Bf], this.allowDefault = i.shiftKey;
    let o, s;
    if (t.inside > -1)
      o = e.state.doc.nodeAt(t.inside), s = t.inside;
    else {
      let u = e.state.doc.resolve(t.pos);
      o = u.parent, s = u.depth ? u.before() : 0;
    }
    const a = r ? null : i.target, l = a ? e.docView.nearestDesc(a, !0) : null;
    this.target = l && l.nodeDOM.nodeType == 1 ? l.nodeDOM : null;
    let { selection: c } = e.state;
    (i.button == 0 && o.type.spec.draggable && o.type.spec.selectable !== !1 || c instanceof F && c.from <= s && c.to > s) && (this.mightDrag = {
      node: o,
      pos: s,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && yt && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), e.root.addEventListener("mouseup", this.up = this.up.bind(this)), e.root.addEventListener("mousemove", this.move = this.move.bind(this)), En(e, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => cn(this.view)), this.view.input.mouseDown = null;
  }
  up(e) {
    if (this.done(), !this.view.dom.contains(e.target))
      return;
    let t = this.pos;
    this.view.state.doc != this.startDoc && (t = this.view.posAtCoords(Ns(e))), this.updateAllowDefault(e), this.allowDefault || !t ? En(this.view, "pointer") : HL(this.view, t.pos, t.inside, e, this.selectNode) ? e.preventDefault() : e.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    et && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    Ze && !this.view.state.selection.visible && Math.min(Math.abs(t.pos - this.view.state.selection.from), Math.abs(t.pos - this.view.state.selection.to)) <= 2) ? (Ai(this.view, ne.near(this.view.state.doc.resolve(t.pos))), e.preventDefault()) : En(this.view, "pointer");
  }
  move(e) {
    this.updateAllowDefault(e), En(this.view, "pointer"), e.buttons == 0 && this.done();
  }
  updateAllowDefault(e) {
    !this.allowDefault && (Math.abs(this.event.x - e.clientX) > 4 || Math.abs(this.event.y - e.clientY) > 4) && (this.allowDefault = !0);
  }
}
tt.touchstart = (n) => {
  n.input.lastTouch = Date.now(), ql(n), En(n, "pointer");
};
tt.touchmove = (n) => {
  n.input.lastTouch = Date.now(), En(n, "pointer");
};
tt.contextmenu = (n) => ql(n);
function Ff(n, e) {
  return n.composing ? !0 : et && Math.abs(e.timeStamp - n.input.compositionEndedAt) < 500 ? (n.input.compositionEndedAt = -2e8, !0) : !1;
}
const ZL = on ? 5e3 : -1;
nt.compositionstart = nt.compositionupdate = (n) => {
  if (!n.composing) {
    n.domObserver.flush();
    let { state: e } = n, t = e.selection.$to;
    if (e.selection instanceof G && (e.storedMarks || !t.textOffset && t.parentOffset && t.nodeBefore.marks.some((i) => i.type.spec.inclusive === !1)))
      n.markCursor = n.state.storedMarks || t.marks(), No(n, !0), n.markCursor = null;
    else if (No(n, !e.selection.empty), yt && e.selection.empty && t.parentOffset && !t.textOffset && t.nodeBefore.marks.length) {
      let i = n.domSelectionRange();
      for (let r = i.focusNode, o = i.focusOffset; r && r.nodeType == 1 && o != 0; ) {
        let s = o < 0 ? r.lastChild : r.childNodes[o - 1];
        if (!s)
          break;
        if (s.nodeType == 3) {
          let a = n.domSelection();
          a && a.collapse(s, s.nodeValue.length);
          break;
        } else
          r = s, o = -1;
      }
    }
    n.input.composing = !0;
  }
  qf(n, ZL);
};
nt.compositionend = (n, e) => {
  n.composing && (n.input.composing = !1, n.input.compositionEndedAt = e.timeStamp, n.input.compositionPendingChanges = n.domObserver.pendingRecords().length ? n.input.compositionID : 0, n.input.compositionNode = null, n.input.compositionPendingChanges && Promise.resolve().then(() => n.domObserver.flush()), n.input.compositionID++, qf(n, 20));
};
function qf(n, e) {
  clearTimeout(n.input.composingTimeout), e > -1 && (n.input.composingTimeout = setTimeout(() => No(n), e));
}
function Hf(n) {
  for (n.composing && (n.input.composing = !1, n.input.compositionEndedAt = GL()); n.input.compositionNodes.length > 0; )
    n.input.compositionNodes.pop().markParentsDirty();
}
function JL(n) {
  let e = n.domSelectionRange();
  if (!e.focusNode)
    return null;
  let t = FN(e.focusNode, e.focusOffset), i = qN(e.focusNode, e.focusOffset);
  if (t && i && t != i) {
    let r = i.pmViewDesc, o = n.domObserver.lastChangedTextNode;
    if (t == o || i == o)
      return o;
    if (!r || !r.isText(i.nodeValue))
      return i;
    if (n.input.compositionNode == i) {
      let s = t.pmViewDesc;
      if (!(!s || !s.isText(t.nodeValue)))
        return i;
    }
  }
  return t || i;
}
function GL() {
  let n = document.createEvent("Event");
  return n.initEvent("event", !0, !0), n.timeStamp;
}
function No(n, e = !1) {
  if (!(on && n.domObserver.flushingSoon >= 0)) {
    if (n.domObserver.forceFlush(), Hf(n), e || n.docView && n.docView.dirty) {
      let t = Il(n), i = n.state.selection;
      return t && !t.eq(i) ? n.dispatch(n.state.tr.setSelection(t)) : (n.markCursor || e) && !i.$from.node(i.$from.sharedDepth(i.to)).inlineContent ? n.dispatch(n.state.tr.deleteSelection()) : n.updateState(n.state), !0;
    }
    return !1;
  }
}
function YL(n, e) {
  if (!n.dom.parentNode)
    return;
  let t = n.dom.parentNode.appendChild(document.createElement("div"));
  t.appendChild(e), t.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let i = getSelection(), r = document.createRange();
  r.selectNodeContents(e), n.dom.blur(), i.removeAllRanges(), i.addRange(r), setTimeout(() => {
    t.parentNode && t.parentNode.removeChild(t), n.focus();
  }, 50);
}
const vr = st && An < 15 || Di && KN < 604;
tt.copy = nt.cut = (n, e) => {
  let t = e, i = n.state.selection, r = t.type == "cut";
  if (i.empty)
    return;
  let o = vr ? null : t.clipboardData, s = i.content(), { dom: a, text: l } = jl(n, s);
  o ? (t.preventDefault(), o.clearData(), o.setData("text/html", a.innerHTML), o.setData("text/plain", l)) : YL(n, a), r && n.dispatch(n.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function XL(n) {
  return n.openStart == 0 && n.openEnd == 0 && n.content.childCount == 1 ? n.content.firstChild : null;
}
function QL(n, e) {
  if (!n.dom.parentNode)
    return;
  let t = n.input.shiftKey || n.state.selection.$from.parent.type.spec.code, i = n.dom.parentNode.appendChild(document.createElement(t ? "textarea" : "div"));
  t || (i.contentEditable = "true"), i.style.cssText = "position: fixed; left: -10000px; top: 10px", i.focus();
  let r = n.input.shiftKey && n.input.lastKeyCode != 45;
  setTimeout(() => {
    n.focus(), i.parentNode && i.parentNode.removeChild(i), t ? xr(n, i.value, null, r, e) : xr(n, i.textContent, i.innerHTML, r, e);
  }, 50);
}
function xr(n, e, t, i, r) {
  let o = Lf(n, e, t, i, n.state.selection.$from);
  if (n.someProp("handlePaste", (l) => l(n, r, o || L.empty)))
    return !0;
  if (!o)
    return !1;
  let s = XL(o), a = s ? n.state.tr.replaceSelectionWith(s, i) : n.state.tr.replaceSelection(o);
  return n.dispatch(a.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function Vf(n) {
  let e = n.getData("text/plain") || n.getData("Text");
  if (e)
    return e;
  let t = n.getData("text/uri-list");
  return t ? t.replace(/\r?\n/g, " ") : "";
}
nt.paste = (n, e) => {
  let t = e;
  if (n.composing && !on)
    return;
  let i = vr ? null : t.clipboardData, r = n.input.shiftKey && n.input.lastKeyCode != 45;
  i && xr(n, Vf(i), i.getData("text/html"), r, t) ? t.preventDefault() : QL(n, t);
};
class Uf {
  constructor(e, t, i) {
    this.slice = e, this.move = t, this.node = i;
  }
}
const eD = _t ? "altKey" : "ctrlKey";
function Wf(n, e) {
  let t = n.someProp("dragCopies", (i) => !i(e));
  return t ?? !e[eD];
}
tt.dragstart = (n, e) => {
  let t = e, i = n.input.mouseDown;
  if (i && i.done(), !t.dataTransfer)
    return;
  let r = n.state.selection, o = r.empty ? null : n.posAtCoords(Ns(t)), s;
  if (!(o && o.pos >= r.from && o.pos <= (r instanceof F ? r.to - 1 : r.to))) {
    if (i && i.mightDrag)
      s = F.create(n.state.doc, i.mightDrag.pos);
    else if (t.target && t.target.nodeType == 1) {
      let d = n.docView.nearestDesc(t.target, !0);
      d && d.node.type.spec.draggable && d != n.docView && (s = F.create(n.state.doc, d.posBefore));
    }
  }
  let a = (s || n.state.selection).content(), { dom: l, text: c, slice: u } = jl(n, a);
  (!t.dataTransfer.files.length || !Ze || bf > 120) && t.dataTransfer.clearData(), t.dataTransfer.setData(vr ? "Text" : "text/html", l.innerHTML), t.dataTransfer.effectAllowed = "copyMove", vr || t.dataTransfer.setData("text/plain", c), n.dragging = new Uf(u, Wf(n, t), s);
};
tt.dragend = (n) => {
  let e = n.dragging;
  window.setTimeout(() => {
    n.dragging == e && (n.dragging = null);
  }, 50);
};
nt.dragover = nt.dragenter = (n, e) => e.preventDefault();
nt.drop = (n, e) => {
  let t = e, i = n.dragging;
  if (n.dragging = null, !t.dataTransfer)
    return;
  let r = n.posAtCoords(Ns(t));
  if (!r)
    return;
  let o = n.state.doc.resolve(r.pos), s = i && i.slice;
  s ? n.someProp("transformPasted", (p) => {
    s = p(s, n, !1);
  }) : s = Lf(n, Vf(t.dataTransfer), vr ? null : t.dataTransfer.getData("text/html"), !1, o);
  let a = !!(i && Wf(n, t));
  if (n.someProp("handleDrop", (p) => p(n, t, s || L.empty, a))) {
    t.preventDefault();
    return;
  }
  if (!s)
    return;
  t.preventDefault();
  let l = s ? cf(n.state.doc, o.pos, s) : o.pos;
  l == null && (l = o.pos);
  let c = n.state.tr;
  if (a) {
    let { node: p } = i;
    p ? p.replace(c) : c.deleteSelection();
  }
  let u = c.mapping.map(l), d = s.openStart == 0 && s.openEnd == 0 && s.content.childCount == 1, h = c.doc;
  if (d ? c.replaceRangeWith(u, u, s.content.firstChild) : c.replaceRange(u, u, s), c.doc.eq(h))
    return;
  let f = c.doc.resolve(u);
  if (d && F.isSelectable(s.content.firstChild) && f.nodeAfter && f.nodeAfter.sameMarkup(s.content.firstChild))
    c.setSelection(new F(f));
  else {
    let p = c.mapping.map(l);
    c.mapping.maps[c.mapping.maps.length - 1].forEach((m, g, k, x) => p = x), c.setSelection(Pl(n, f, c.doc.resolve(p)));
  }
  n.focus(), n.dispatch(c.setMeta("uiEvent", "drop"));
};
tt.focus = (n) => {
  n.input.lastFocus = Date.now(), n.focused || (n.domObserver.stop(), n.dom.classList.add("ProseMirror-focused"), n.domObserver.start(), n.focused = !0, setTimeout(() => {
    n.docView && n.hasFocus() && !n.domObserver.currentSelection.eq(n.domSelectionRange()) && cn(n);
  }, 20));
};
tt.blur = (n, e) => {
  let t = e;
  n.focused && (n.domObserver.stop(), n.dom.classList.remove("ProseMirror-focused"), n.domObserver.start(), t.relatedTarget && n.dom.contains(t.relatedTarget) && n.domObserver.currentSelection.clear(), n.focused = !1);
};
tt.beforeinput = (n, e) => {
  if (Ze && on && e.inputType == "deleteContentBackward") {
    n.domObserver.flushSoon();
    let { domChangeCount: i } = n.input;
    setTimeout(() => {
      if (n.input.domChangeCount != i || (n.dom.blur(), n.focus(), n.someProp("handleKeyDown", (o) => o(n, Gn(8, "Backspace")))))
        return;
      let { $cursor: r } = n.state.selection;
      r && r.pos > 0 && n.dispatch(n.state.tr.delete(r.pos - 1, r.pos).scrollIntoView());
    }, 50);
  }
};
for (let n in nt)
  tt[n] = nt[n];
function Sr(n, e) {
  if (n == e)
    return !0;
  for (let t in n)
    if (n[t] !== e[t])
      return !1;
  for (let t in e)
    if (!(t in n))
      return !1;
  return !0;
}
class Lo {
  constructor(e, t) {
    this.toDOM = e, this.spec = t || ri, this.side = this.spec.side || 0;
  }
  map(e, t, i, r) {
    let { pos: o, deleted: s } = e.mapResult(t.from + r, this.side < 0 ? -1 : 1);
    return s ? null : new Et(o - i, o - i, this);
  }
  valid() {
    return !0;
  }
  eq(e) {
    return this == e || e instanceof Lo && (this.spec.key && this.spec.key == e.spec.key || this.toDOM == e.toDOM && Sr(this.spec, e.spec));
  }
  destroy(e) {
    this.spec.destroy && this.spec.destroy(e);
  }
}
class Ln {
  constructor(e, t) {
    this.attrs = e, this.spec = t || ri;
  }
  map(e, t, i, r) {
    let o = e.map(t.from + r, this.spec.inclusiveStart ? -1 : 1) - i, s = e.map(t.to + r, this.spec.inclusiveEnd ? 1 : -1) - i;
    return o >= s ? null : new Et(o, s, this);
  }
  valid(e, t) {
    return t.from < t.to;
  }
  eq(e) {
    return this == e || e instanceof Ln && Sr(this.attrs, e.attrs) && Sr(this.spec, e.spec);
  }
  static is(e) {
    return e.type instanceof Ln;
  }
  destroy() {
  }
}
class Hl {
  constructor(e, t) {
    this.attrs = e, this.spec = t || ri;
  }
  map(e, t, i, r) {
    let o = e.mapResult(t.from + r, 1);
    if (o.deleted)
      return null;
    let s = e.mapResult(t.to + r, -1);
    return s.deleted || s.pos <= o.pos ? null : new Et(o.pos - i, s.pos - i, this);
  }
  valid(e, t) {
    let { index: i, offset: r } = e.content.findIndex(t.from), o;
    return r == t.from && !(o = e.child(i)).isText && r + o.nodeSize == t.to;
  }
  eq(e) {
    return this == e || e instanceof Hl && Sr(this.attrs, e.attrs) && Sr(this.spec, e.spec);
  }
  destroy() {
  }
}
class Et {
  /**
  @internal
  */
  constructor(e, t, i) {
    this.from = e, this.to = t, this.type = i;
  }
  /**
  @internal
  */
  copy(e, t) {
    return new Et(e, t, this.type);
  }
  /**
  @internal
  */
  eq(e, t = 0) {
    return this.type.eq(e.type) && this.from + t == e.from && this.to + t == e.to;
  }
  /**
  @internal
  */
  map(e, t, i) {
    return this.type.map(e, this, t, i);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(e, t, i) {
    return new Et(e, e, new Lo(t, i));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(e, t, i, r) {
    return new Et(e, t, new Ln(i, r));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(e, t, i, r) {
    return new Et(e, t, new Hl(i, r));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof Ln;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof Lo;
  }
}
const Mi = [], ri = {};
class Le {
  /**
  @internal
  */
  constructor(e, t) {
    this.local = e.length ? e : Mi, this.children = t.length ? t : Mi;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(e, t) {
    return t.length ? Do(t, e, 0, ri) : We;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(e, t, i) {
    let r = [];
    return this.findInner(e ?? 0, t ?? 1e9, r, 0, i), r;
  }
  findInner(e, t, i, r, o) {
    for (let s = 0; s < this.local.length; s++) {
      let a = this.local[s];
      a.from <= t && a.to >= e && (!o || o(a.spec)) && i.push(a.copy(a.from + r, a.to + r));
    }
    for (let s = 0; s < this.children.length; s += 3)
      if (this.children[s] < t && this.children[s + 1] > e) {
        let a = this.children[s] + 1;
        this.children[s + 2].findInner(e - a, t - a, i, r + a, o);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(e, t, i) {
    return this == We || e.maps.length == 0 ? this : this.mapInner(e, t, 0, 0, i || ri);
  }
  /**
  @internal
  */
  mapInner(e, t, i, r, o) {
    let s;
    for (let a = 0; a < this.local.length; a++) {
      let l = this.local[a].map(e, i, r);
      l && l.type.valid(t, l) ? (s || (s = [])).push(l) : o.onRemove && o.onRemove(this.local[a].spec);
    }
    return this.children.length ? tD(this.children, s || [], e, t, i, r, o) : s ? new Le(s.sort(oi), Mi) : We;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(e, t) {
    return t.length ? this == We ? Le.create(e, t) : this.addInner(e, t, 0) : this;
  }
  addInner(e, t, i) {
    let r, o = 0;
    e.forEach((a, l) => {
      let c = l + i, u;
      if (u = Zf(t, a, c)) {
        for (r || (r = this.children.slice()); o < r.length && r[o] < l; )
          o += 3;
        r[o] == l ? r[o + 2] = r[o + 2].addInner(a, u, c + 1) : r.splice(o, 0, l, l + a.nodeSize, Do(u, a, c + 1, ri)), o += 3;
      }
    });
    let s = Kf(o ? Jf(t) : t, -i);
    for (let a = 0; a < s.length; a++)
      s[a].type.valid(e, s[a]) || s.splice(a--, 1);
    return new Le(s.length ? this.local.concat(s).sort(oi) : this.local, r || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(e) {
    return e.length == 0 || this == We ? this : this.removeInner(e, 0);
  }
  removeInner(e, t) {
    let i = this.children, r = this.local;
    for (let o = 0; o < i.length; o += 3) {
      let s, a = i[o] + t, l = i[o + 1] + t;
      for (let u = 0, d; u < e.length; u++)
        (d = e[u]) && d.from > a && d.to < l && (e[u] = null, (s || (s = [])).push(d));
      if (!s)
        continue;
      i == this.children && (i = this.children.slice());
      let c = i[o + 2].removeInner(s, a + 1);
      c != We ? i[o + 2] = c : (i.splice(o, 3), o -= 3);
    }
    if (r.length) {
      for (let o = 0, s; o < e.length; o++)
        if (s = e[o])
          for (let a = 0; a < r.length; a++)
            r[a].eq(s, t) && (r == this.local && (r = this.local.slice()), r.splice(a--, 1));
    }
    return i == this.children && r == this.local ? this : r.length || i.length ? new Le(r, i) : We;
  }
  forChild(e, t) {
    if (this == We)
      return this;
    if (t.isLeaf)
      return Le.empty;
    let i, r;
    for (let a = 0; a < this.children.length; a += 3)
      if (this.children[a] >= e) {
        this.children[a] == e && (i = this.children[a + 2]);
        break;
      }
    let o = e + 1, s = o + t.content.size;
    for (let a = 0; a < this.local.length; a++) {
      let l = this.local[a];
      if (l.from < s && l.to > o && l.type instanceof Ln) {
        let c = Math.max(o, l.from) - o, u = Math.min(s, l.to) - o;
        c < u && (r || (r = [])).push(l.copy(c, u));
      }
    }
    if (r) {
      let a = new Le(r.sort(oi), Mi);
      return i ? new wn([a, i]) : a;
    }
    return i || We;
  }
  /**
  @internal
  */
  eq(e) {
    if (this == e)
      return !0;
    if (!(e instanceof Le) || this.local.length != e.local.length || this.children.length != e.children.length)
      return !1;
    for (let t = 0; t < this.local.length; t++)
      if (!this.local[t].eq(e.local[t]))
        return !1;
    for (let t = 0; t < this.children.length; t += 3)
      if (this.children[t] != e.children[t] || this.children[t + 1] != e.children[t + 1] || !this.children[t + 2].eq(e.children[t + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(e) {
    return Vl(this.localsInner(e));
  }
  /**
  @internal
  */
  localsInner(e) {
    if (this == We)
      return Mi;
    if (e.inlineContent || !this.local.some(Ln.is))
      return this.local;
    let t = [];
    for (let i = 0; i < this.local.length; i++)
      this.local[i].type instanceof Ln || t.push(this.local[i]);
    return t;
  }
  forEachSet(e) {
    e(this);
  }
}
Le.empty = new Le([], []);
Le.removeOverlap = Vl;
const We = Le.empty;
class wn {
  constructor(e) {
    this.members = e;
  }
  map(e, t) {
    const i = this.members.map((r) => r.map(e, t, ri));
    return wn.from(i);
  }
  forChild(e, t) {
    if (t.isLeaf)
      return Le.empty;
    let i = [];
    for (let r = 0; r < this.members.length; r++) {
      let o = this.members[r].forChild(e, t);
      o != We && (o instanceof wn ? i = i.concat(o.members) : i.push(o));
    }
    return wn.from(i);
  }
  eq(e) {
    if (!(e instanceof wn) || e.members.length != this.members.length)
      return !1;
    for (let t = 0; t < this.members.length; t++)
      if (!this.members[t].eq(e.members[t]))
        return !1;
    return !0;
  }
  locals(e) {
    let t, i = !0;
    for (let r = 0; r < this.members.length; r++) {
      let o = this.members[r].localsInner(e);
      if (o.length)
        if (!t)
          t = o;
        else {
          i && (t = t.slice(), i = !1);
          for (let s = 0; s < o.length; s++)
            t.push(o[s]);
        }
    }
    return t ? Vl(i ? t : t.sort(oi)) : Mi;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(e) {
    switch (e.length) {
      case 0:
        return We;
      case 1:
        return e[0];
      default:
        return new wn(e.every((t) => t instanceof Le) ? e : e.reduce((t, i) => t.concat(i instanceof Le ? i : i.members), []));
    }
  }
  forEachSet(e) {
    for (let t = 0; t < this.members.length; t++)
      this.members[t].forEachSet(e);
  }
}
function tD(n, e, t, i, r, o, s) {
  let a = n.slice();
  for (let c = 0, u = o; c < t.maps.length; c++) {
    let d = 0;
    t.maps[c].forEach((h, f, p, m) => {
      let g = m - p - (f - h);
      for (let k = 0; k < a.length; k += 3) {
        let x = a[k + 1];
        if (x < 0 || h > x + u - d)
          continue;
        let S = a[k] + u - d;
        f >= S ? a[k + 1] = h <= S ? -2 : -1 : h >= u && g && (a[k] += g, a[k + 1] += g);
      }
      d += g;
    }), u = t.maps[c].map(u, -1);
  }
  let l = !1;
  for (let c = 0; c < a.length; c += 3)
    if (a[c + 1] < 0) {
      if (a[c + 1] == -2) {
        l = !0, a[c + 1] = -1;
        continue;
      }
      let u = t.map(n[c] + o), d = u - r;
      if (d < 0 || d >= i.content.size) {
        l = !0;
        continue;
      }
      let h = t.map(n[c + 1] + o, -1), f = h - r, { index: p, offset: m } = i.content.findIndex(d), g = i.maybeChild(p);
      if (g && m == d && m + g.nodeSize == f) {
        let k = a[c + 2].mapInner(t, g, u + 1, n[c] + o + 1, s);
        k != We ? (a[c] = d, a[c + 1] = f, a[c + 2] = k) : (a[c + 1] = -2, l = !0);
      } else
        l = !0;
    }
  if (l) {
    let c = nD(a, n, e, t, r, o, s), u = Do(c, i, 0, s);
    e = u.local;
    for (let d = 0; d < a.length; d += 3)
      a[d + 1] < 0 && (a.splice(d, 3), d -= 3);
    for (let d = 0, h = 0; d < u.children.length; d += 3) {
      let f = u.children[d];
      for (; h < a.length && a[h] < f; )
        h += 3;
      a.splice(h, 0, u.children[d], u.children[d + 1], u.children[d + 2]);
    }
  }
  return new Le(e.sort(oi), a);
}
function Kf(n, e) {
  if (!e || !n.length)
    return n;
  let t = [];
  for (let i = 0; i < n.length; i++) {
    let r = n[i];
    t.push(new Et(r.from + e, r.to + e, r.type));
  }
  return t;
}
function nD(n, e, t, i, r, o, s) {
  function a(l, c) {
    for (let u = 0; u < l.local.length; u++) {
      let d = l.local[u].map(i, r, c);
      d ? t.push(d) : s.onRemove && s.onRemove(l.local[u].spec);
    }
    for (let u = 0; u < l.children.length; u += 3)
      a(l.children[u + 2], l.children[u] + c + 1);
  }
  for (let l = 0; l < n.length; l += 3)
    n[l + 1] == -1 && a(n[l + 2], e[l] + o + 1);
  return t;
}
function Zf(n, e, t) {
  if (e.isLeaf)
    return null;
  let i = t + e.nodeSize, r = null;
  for (let o = 0, s; o < n.length; o++)
    (s = n[o]) && s.from > t && s.to < i && ((r || (r = [])).push(s), n[o] = null);
  return r;
}
function Jf(n) {
  let e = [];
  for (let t = 0; t < n.length; t++)
    n[t] != null && e.push(n[t]);
  return e;
}
function Do(n, e, t, i) {
  let r = [], o = !1;
  e.forEach((a, l) => {
    let c = Zf(n, a, l + t);
    if (c) {
      o = !0;
      let u = Do(c, a, t + l + 1, i);
      u != We && r.push(l, l + a.nodeSize, u);
    }
  });
  let s = Kf(o ? Jf(n) : n, -t).sort(oi);
  for (let a = 0; a < s.length; a++)
    s[a].type.valid(e, s[a]) || (i.onRemove && i.onRemove(s[a].spec), s.splice(a--, 1));
  return s.length || r.length ? new Le(s, r) : We;
}
function oi(n, e) {
  return n.from - e.from || n.to - e.to;
}
function Vl(n) {
  let e = n;
  for (let t = 0; t < e.length - 1; t++) {
    let i = e[t];
    if (i.from != i.to)
      for (let r = t + 1; r < e.length; r++) {
        let o = e[r];
        if (o.from == i.from) {
          o.to != i.to && (e == n && (e = n.slice()), e[r] = o.copy(o.from, i.to), gu(e, r + 1, o.copy(i.to, o.to)));
          continue;
        } else {
          o.from < i.to && (e == n && (e = n.slice()), e[t] = i.copy(i.from, o.from), gu(e, r, i.copy(o.from, i.to)));
          break;
        }
      }
  }
  return e;
}
function gu(n, e, t) {
  for (; e < n.length && oi(t, n[e]) > 0; )
    e++;
  n.splice(e, 0, t);
}
function aa(n) {
  let e = [];
  return n.someProp("decorations", (t) => {
    let i = t(n.state);
    i && i != We && e.push(i);
  }), n.cursorWrapper && e.push(Le.create(n.state.doc, [n.cursorWrapper.deco])), wn.from(e);
}
const iD = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, rD = st && An <= 11;
class oD {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(e) {
    this.anchorNode = e.anchorNode, this.anchorOffset = e.anchorOffset, this.focusNode = e.focusNode, this.focusOffset = e.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(e) {
    return e.anchorNode == this.anchorNode && e.anchorOffset == this.anchorOffset && e.focusNode == this.focusNode && e.focusOffset == this.focusOffset;
  }
}
class sD {
  constructor(e, t) {
    this.view = e, this.handleDOMChange = t, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new oD(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.lastChangedTextNode = null, this.observer = window.MutationObserver && new window.MutationObserver((i) => {
      for (let r = 0; r < i.length; r++)
        this.queue.push(i[r]);
      st && An <= 11 && i.some((r) => r.type == "childList" && r.removedNodes.length || r.type == "characterData" && r.oldValue.length > r.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), rD && (this.onCharData = (i) => {
      this.queue.push({ target: i.target, type: "characterData", oldValue: i.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, iD)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let e = this.observer.takeRecords();
      if (e.length) {
        for (let t = 0; t < e.length; t++)
          this.queue.push(e[t]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (lu(this.view)) {
      if (this.suppressingSelectionUpdates)
        return cn(this.view);
      if (st && An <= 11 && !this.view.state.selection.empty) {
        let e = this.view.domSelectionRange();
        if (e.focusNode && ui(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(e) {
    if (!e.focusNode)
      return !0;
    let t = /* @__PURE__ */ new Set(), i;
    for (let o = e.focusNode; o; o = Li(o))
      t.add(o);
    for (let o = e.anchorNode; o; o = Li(o))
      if (t.has(o)) {
        i = o;
        break;
      }
    let r = i && this.view.docView.nearestDesc(i);
    if (r && r.ignoreMutation({
      type: "selection",
      target: i.nodeType == 3 ? i.parentNode : i
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let e of this.observer.takeRecords())
        this.queue.push(e);
    return this.queue;
  }
  flush() {
    let { view: e } = this;
    if (!e.docView || this.flushingSoon > -1)
      return;
    let t = this.pendingRecords();
    t.length && (this.queue = []);
    let i = e.domSelectionRange(), r = !this.suppressingSelectionUpdates && !this.currentSelection.eq(i) && lu(e) && !this.ignoreSelectionChange(i), o = -1, s = -1, a = !1, l = [];
    if (e.editable)
      for (let u = 0; u < t.length; u++) {
        let d = this.registerMutation(t[u], l);
        d && (o = o < 0 ? d.from : Math.min(d.from, o), s = s < 0 ? d.to : Math.max(d.to, s), d.typeOver && (a = !0));
      }
    if (yt && l.length) {
      let u = l.filter((d) => d.nodeName == "BR");
      if (u.length == 2) {
        let [d, h] = u;
        d.parentNode && d.parentNode.parentNode == h.parentNode ? h.remove() : d.remove();
      } else {
        let { focusNode: d } = this.currentSelection;
        for (let h of u) {
          let f = h.parentNode;
          f && f.nodeName == "LI" && (!d || cD(e, d) != f) && h.remove();
        }
      }
    }
    let c = null;
    o < 0 && r && e.input.lastFocus > Date.now() - 200 && Math.max(e.input.lastTouch, e.input.lastClick.time) < Date.now() - 300 && zs(i) && (c = Il(e)) && c.eq(ne.near(e.state.doc.resolve(0), 1)) ? (e.input.lastFocus = 0, cn(e), this.currentSelection.set(i), e.scrollToSelection()) : (o > -1 || r) && (o > -1 && (e.docView.markDirty(o, s), aD(e)), this.handleDOMChange(o, s, a, l), e.docView && e.docView.dirty ? e.updateState(e.state) : this.currentSelection.eq(i) || cn(e), this.currentSelection.set(i));
  }
  registerMutation(e, t) {
    if (t.indexOf(e.target) > -1)
      return null;
    let i = this.view.docView.nearestDesc(e.target);
    if (e.type == "attributes" && (i == this.view.docView || e.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    e.attributeName == "style" && !e.oldValue && !e.target.getAttribute("style")) || !i || i.ignoreMutation(e))
      return null;
    if (e.type == "childList") {
      for (let u = 0; u < e.addedNodes.length; u++) {
        let d = e.addedNodes[u];
        t.push(d), d.nodeType == 3 && (this.lastChangedTextNode = d);
      }
      if (i.contentDOM && i.contentDOM != i.dom && !i.contentDOM.contains(e.target))
        return { from: i.posBefore, to: i.posAfter };
      let r = e.previousSibling, o = e.nextSibling;
      if (st && An <= 11 && e.addedNodes.length)
        for (let u = 0; u < e.addedNodes.length; u++) {
          let { previousSibling: d, nextSibling: h } = e.addedNodes[u];
          (!d || Array.prototype.indexOf.call(e.addedNodes, d) < 0) && (r = d), (!h || Array.prototype.indexOf.call(e.addedNodes, h) < 0) && (o = h);
        }
      let s = r && r.parentNode == e.target ? Fe(r) + 1 : 0, a = i.localPosFromDOM(e.target, s, -1), l = o && o.parentNode == e.target ? Fe(o) : e.target.childNodes.length, c = i.localPosFromDOM(e.target, l, 1);
      return { from: a, to: c };
    } else return e.type == "attributes" ? { from: i.posAtStart - i.border, to: i.posAtEnd + i.border } : (this.lastChangedTextNode = e.target, {
      from: i.posAtStart,
      to: i.posAtEnd,
      // An event was generated for a text change that didn't change
      // any text. Mark the dom change to fall back to assuming the
      // selection was typed over with an identical value if it can't
      // find another change.
      typeOver: e.target.nodeValue == e.oldValue
    });
  }
}
let _u = /* @__PURE__ */ new WeakMap(), bu = !1;
function aD(n) {
  if (!_u.has(n) && (_u.set(n, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(n.dom).whiteSpace) !== -1)) {
    if (n.requiresGeckoHackNode = yt, bu)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), bu = !0;
  }
}
function ku(n, e) {
  let t = e.startContainer, i = e.startOffset, r = e.endContainer, o = e.endOffset, s = n.domAtPos(n.state.selection.anchor);
  return ui(s.node, s.offset, r, o) && ([t, i, r, o] = [r, o, t, i]), { anchorNode: t, anchorOffset: i, focusNode: r, focusOffset: o };
}
function lD(n, e) {
  if (e.getComposedRanges) {
    let r = e.getComposedRanges(n.root)[0];
    if (r)
      return ku(n, r);
  }
  let t;
  function i(r) {
    r.preventDefault(), r.stopImmediatePropagation(), t = r.getTargetRanges()[0];
  }
  return n.dom.addEventListener("beforeinput", i, !0), document.execCommand("indent"), n.dom.removeEventListener("beforeinput", i, !0), t ? ku(n, t) : null;
}
function cD(n, e) {
  for (let t = e.parentNode; t && t != n.dom; t = t.parentNode) {
    let i = n.docView.nearestDesc(t, !0);
    if (i && i.node.isBlock)
      return t;
  }
  return null;
}
function uD(n, e, t) {
  let { node: i, fromOffset: r, toOffset: o, from: s, to: a } = n.docView.parseRange(e, t), l = n.domSelectionRange(), c, u = l.anchorNode;
  if (u && n.dom.contains(u.nodeType == 1 ? u : u.parentNode) && (c = [{ node: u, offset: l.anchorOffset }], zs(l) || c.push({ node: l.focusNode, offset: l.focusOffset })), Ze && n.input.lastKeyCode === 8)
    for (let g = o; g > r; g--) {
      let k = i.childNodes[g - 1], x = k.pmViewDesc;
      if (k.nodeName == "BR" && !x) {
        o = g;
        break;
      }
      if (!x || x.size)
        break;
    }
  let d = n.state.doc, h = n.someProp("domParser") || zn.fromSchema(n.state.schema), f = d.resolve(s), p = null, m = h.parse(i, {
    topNode: f.parent,
    topMatch: f.parent.contentMatchAt(f.index()),
    topOpen: !0,
    from: r,
    to: o,
    preserveWhitespace: f.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: c,
    ruleFromNode: dD,
    context: f
  });
  if (c && c[0].pos != null) {
    let g = c[0].pos, k = c[1] && c[1].pos;
    k == null && (k = g), p = { anchor: g + s, head: k + s };
  }
  return { doc: m, sel: p, from: s, to: a };
}
function dD(n) {
  let e = n.pmViewDesc;
  if (e)
    return e.parseRule();
  if (n.nodeName == "BR" && n.parentNode) {
    if (et && /^(ul|ol)$/i.test(n.parentNode.nodeName)) {
      let t = document.createElement("div");
      return t.appendChild(document.createElement("li")), { skip: t };
    } else if (n.parentNode.lastChild == n || et && /^(tr|table)$/i.test(n.parentNode.nodeName))
      return { ignore: !0 };
  } else if (n.nodeName == "IMG" && n.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const hD = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|img|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function fD(n, e, t, i, r) {
  let o = n.input.compositionPendingChanges || (n.composing ? n.input.compositionID : 0);
  if (n.input.compositionPendingChanges = 0, e < 0) {
    let w = n.input.lastSelectionTime > Date.now() - 50 ? n.input.lastSelectionOrigin : null, $ = Il(n, w);
    if ($ && !n.state.selection.eq($)) {
      if (Ze && on && n.input.lastKeyCode === 13 && Date.now() - 100 < n.input.lastKeyCodeTime && n.someProp("handleKeyDown", (z) => z(n, Gn(13, "Enter"))))
        return;
      let A = n.state.tr.setSelection($);
      w == "pointer" ? A.setMeta("pointer", !0) : w == "key" && A.scrollIntoView(), o && A.setMeta("composition", o), n.dispatch(A);
    }
    return;
  }
  let s = n.state.doc.resolve(e), a = s.sharedDepth(t);
  e = s.before(a + 1), t = n.state.doc.resolve(t).after(a + 1);
  let l = n.state.selection, c = uD(n, e, t), u = n.state.doc, d = u.slice(c.from, c.to), h, f;
  n.input.lastKeyCode === 8 && Date.now() - 100 < n.input.lastKeyCodeTime ? (h = n.state.selection.to, f = "end") : (h = n.state.selection.from, f = "start"), n.input.lastKeyCode = null;
  let p = gD(d.content, c.doc.content, c.from, h, f);
  if (p && n.input.domChangeCount++, (Di && n.input.lastIOSEnter > Date.now() - 225 || on) && r.some((w) => w.nodeType == 1 && !hD.test(w.nodeName)) && (!p || p.endA >= p.endB) && n.someProp("handleKeyDown", (w) => w(n, Gn(13, "Enter")))) {
    n.input.lastIOSEnter = 0;
    return;
  }
  if (!p)
    if (i && l instanceof G && !l.empty && l.$head.sameParent(l.$anchor) && !n.composing && !(c.sel && c.sel.anchor != c.sel.head))
      p = { start: l.from, endA: l.to, endB: l.to };
    else {
      if (c.sel) {
        let w = yu(n, n.state.doc, c.sel);
        if (w && !w.eq(n.state.selection)) {
          let $ = n.state.tr.setSelection(w);
          o && $.setMeta("composition", o), n.dispatch($);
        }
      }
      return;
    }
  n.state.selection.from < n.state.selection.to && p.start == p.endB && n.state.selection instanceof G && (p.start > n.state.selection.from && p.start <= n.state.selection.from + 2 && n.state.selection.from >= c.from ? p.start = n.state.selection.from : p.endA < n.state.selection.to && p.endA >= n.state.selection.to - 2 && n.state.selection.to <= c.to && (p.endB += n.state.selection.to - p.endA, p.endA = n.state.selection.to)), st && An <= 11 && p.endB == p.start + 1 && p.endA == p.start && p.start > c.from && c.doc.textBetween(p.start - c.from - 1, p.start - c.from + 1) == "  " && (p.start--, p.endA--, p.endB--);
  let m = c.doc.resolveNoCache(p.start - c.from), g = c.doc.resolveNoCache(p.endB - c.from), k = u.resolve(p.start), x = m.sameParent(g) && m.parent.inlineContent && k.end() >= p.endA;
  if ((Di && n.input.lastIOSEnter > Date.now() - 225 && (!x || r.some((w) => w.nodeName == "DIV" || w.nodeName == "P")) || !x && m.pos < c.doc.content.size && (!m.sameParent(g) || !m.parent.inlineContent) && m.pos < g.pos && !/\S/.test(c.doc.textBetween(m.pos, g.pos, "", ""))) && n.someProp("handleKeyDown", (w) => w(n, Gn(13, "Enter")))) {
    n.input.lastIOSEnter = 0;
    return;
  }
  if (n.state.selection.anchor > p.start && mD(u, p.start, p.endA, m, g) && n.someProp("handleKeyDown", (w) => w(n, Gn(8, "Backspace")))) {
    on && Ze && n.domObserver.suppressSelectionUpdates();
    return;
  }
  Ze && p.endB == p.start && (n.input.lastChromeDelete = Date.now()), on && !x && m.start() != g.start() && g.parentOffset == 0 && m.depth == g.depth && c.sel && c.sel.anchor == c.sel.head && c.sel.head == p.endA && (p.endB -= 2, g = c.doc.resolveNoCache(p.endB - c.from), setTimeout(() => {
    n.someProp("handleKeyDown", function(w) {
      return w(n, Gn(13, "Enter"));
    });
  }, 20));
  let S = p.start, _ = p.endA, v = (w) => {
    let $ = w || n.state.tr.replace(S, _, c.doc.slice(p.start - c.from, p.endB - c.from));
    if (c.sel) {
      let A = yu(n, $.doc, c.sel);
      A && !(Ze && n.composing && A.empty && (p.start != p.endB || n.input.lastChromeDelete < Date.now() - 100) && (A.head == S || A.head == $.mapping.map(_) - 1) || st && A.empty && A.head == S) && $.setSelection(A);
    }
    return o && $.setMeta("composition", o), $.scrollIntoView();
  }, y;
  if (x)
    if (m.pos == g.pos) {
      st && An <= 11 && m.parentOffset == 0 && (n.domObserver.suppressSelectionUpdates(), setTimeout(() => cn(n), 20));
      let w = v(n.state.tr.delete(S, _)), $ = u.resolve(p.start).marksAcross(u.resolve(p.endA));
      $ && w.ensureMarks($), n.dispatch(w);
    } else if (
      // Adding or removing a mark
      p.endA == p.endB && (y = pD(m.parent.content.cut(m.parentOffset, g.parentOffset), k.parent.content.cut(k.parentOffset, p.endA - k.start())))
    ) {
      let w = v(n.state.tr);
      y.type == "add" ? w.addMark(S, _, y.mark) : w.removeMark(S, _, y.mark), n.dispatch(w);
    } else if (m.parent.child(m.index()).isText && m.index() == g.index() - (g.textOffset ? 0 : 1)) {
      let w = m.parent.textBetween(m.parentOffset, g.parentOffset), $ = () => v(n.state.tr.insertText(w, S, _));
      n.someProp("handleTextInput", (A) => A(n, S, _, w, $)) || n.dispatch($());
    } else
      n.dispatch(v());
  else
    n.dispatch(v());
}
function yu(n, e, t) {
  return Math.max(t.anchor, t.head) > e.content.size ? null : Pl(n, e.resolve(t.anchor), e.resolve(t.head));
}
function pD(n, e) {
  let t = n.firstChild.marks, i = e.firstChild.marks, r = t, o = i, s, a, l;
  for (let u = 0; u < i.length; u++)
    r = i[u].removeFromSet(r);
  for (let u = 0; u < t.length; u++)
    o = t[u].removeFromSet(o);
  if (r.length == 1 && o.length == 0)
    a = r[0], s = "add", l = (u) => u.mark(a.addToSet(u.marks));
  else if (r.length == 0 && o.length == 1)
    a = o[0], s = "remove", l = (u) => u.mark(a.removeFromSet(u.marks));
  else
    return null;
  let c = [];
  for (let u = 0; u < e.childCount; u++)
    c.push(l(e.child(u)));
  if (M.from(c).eq(n))
    return { mark: a, type: s };
}
function mD(n, e, t, i, r) {
  if (
    // The content must have shrunk
    t - e <= r.pos - i.pos || // newEnd must point directly at or after the end of the block that newStart points into
    la(i, !0, !1) < r.pos
  )
    return !1;
  let o = n.resolve(e);
  if (!i.parent.isTextblock) {
    let a = o.nodeAfter;
    return a != null && t == e + a.nodeSize;
  }
  if (o.parentOffset < o.parent.content.size || !o.parent.isTextblock)
    return !1;
  let s = n.resolve(la(o, !0, !0));
  return !s.parent.isTextblock || s.pos > t || la(s, !0, !1) < t ? !1 : i.parent.content.cut(i.parentOffset).eq(s.parent.content);
}
function la(n, e, t) {
  let i = n.depth, r = e ? n.end() : n.pos;
  for (; i > 0 && (e || n.indexAfter(i) == n.node(i).childCount); )
    i--, r++, e = !1;
  if (t) {
    let o = n.node(i).maybeChild(n.indexAfter(i));
    for (; o && !o.isLeaf; )
      o = o.firstChild, r++;
  }
  return r;
}
function gD(n, e, t, i, r) {
  let o = n.findDiffStart(e, t);
  if (o == null)
    return null;
  let { a: s, b: a } = n.findDiffEnd(e, t + n.size, t + e.size);
  if (r == "end") {
    let l = Math.max(0, o - Math.min(s, a));
    i -= s + l - o;
  }
  if (s < o && n.size < e.size) {
    let l = i <= o && i >= s ? o - i : 0;
    o -= l, o && o < e.size && vu(e.textBetween(o - 1, o + 1)) && (o += l ? 1 : -1), a = o + (a - s), s = o;
  } else if (a < o) {
    let l = i <= o && i >= a ? o - i : 0;
    o -= l, o && o < n.size && vu(n.textBetween(o - 1, o + 1)) && (o += l ? 1 : -1), s = o + (s - a), a = o;
  }
  return { start: o, endA: s, endB: a };
}
function vu(n) {
  if (n.length != 2)
    return !1;
  let e = n.charCodeAt(0), t = n.charCodeAt(1);
  return e >= 56320 && e <= 57343 && t >= 55296 && t <= 56319;
}
class Gf {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(e, t) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new DL(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = t, this.state = t.state, this.directPlugins = t.plugins || [], this.directPlugins.forEach(Tu), this.dispatch = this.dispatch.bind(this), this.dom = e && e.mount || document.createElement("div"), e && (e.appendChild ? e.appendChild(this.dom) : typeof e == "function" ? e(this.dom) : e.mount && (this.mounted = !0)), this.editable = wu(this), Su(this), this.nodeViews = Cu(this), this.docView = nu(this.state.doc, xu(this), aa(this), this.dom, this), this.domObserver = new sD(this, (i, r, o, s) => fD(this, i, r, o, s)), this.domObserver.start(), RL(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let e = this._props;
      this._props = {};
      for (let t in e)
        this._props[t] = e[t];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(e) {
    e.handleDOMEvents != this._props.handleDOMEvents && rl(this);
    let t = this._props;
    this._props = e, e.plugins && (e.plugins.forEach(Tu), this.directPlugins = e.plugins), this.updateStateInner(e.state, t);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(e) {
    let t = {};
    for (let i in this._props)
      t[i] = this._props[i];
    t.state = this.state;
    for (let i in e)
      t[i] = e[i];
    this.update(t);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(e) {
    this.updateStateInner(e, this._props);
  }
  updateStateInner(e, t) {
    var i;
    let r = this.state, o = !1, s = !1;
    e.storedMarks && this.composing && (Hf(this), s = !0), this.state = e;
    let a = r.plugins != e.plugins || this._props.plugins != t.plugins;
    if (a || this._props.plugins != t.plugins || this._props.nodeViews != t.nodeViews) {
      let f = Cu(this);
      bD(f, this.nodeViews) && (this.nodeViews = f, o = !0);
    }
    (a || t.handleDOMEvents != this._props.handleDOMEvents) && rl(this), this.editable = wu(this), Su(this);
    let l = aa(this), c = xu(this), u = r.plugins != e.plugins && !r.doc.eq(e.doc) ? "reset" : e.scrollToSelection > r.scrollToSelection ? "to selection" : "preserve", d = o || !this.docView.matchesNode(e.doc, c, l);
    (d || !e.selection.eq(r.selection)) && (s = !0);
    let h = u == "preserve" && s && this.dom.style.overflowAnchor == null && GN(this);
    if (s) {
      this.domObserver.stop();
      let f = d && (st || Ze) && !this.composing && !r.selection.empty && !e.selection.empty && _D(r.selection, e.selection);
      if (d) {
        let p = Ze ? this.trackWrites = this.domSelectionRange().focusNode : null;
        this.composing && (this.input.compositionNode = JL(this)), (o || !this.docView.update(e.doc, c, l, this)) && (this.docView.updateOuterDeco(c), this.docView.destroy(), this.docView = nu(e.doc, c, l, this.dom, this)), p && !this.trackWrites && (f = !0);
      }
      f || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && yL(this)) ? cn(this, f) : (zf(this, e.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(r), !((i = this.dragging) === null || i === void 0) && i.node && !r.doc.eq(e.doc) && this.updateDraggedNode(this.dragging, r), u == "reset" ? this.dom.scrollTop = 0 : u == "to selection" ? this.scrollToSelection() : h && YN(h);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let e = this.domSelectionRange().focusNode;
    if (!(!e || !this.dom.contains(e.nodeType == 1 ? e : e.parentNode))) {
      if (!this.someProp("handleScrollToSelection", (t) => t(this))) if (this.state.selection instanceof F) {
        let t = this.docView.domAfterPos(this.state.selection.from);
        t.nodeType == 1 && Gc(this, t.getBoundingClientRect(), e);
      } else
        Gc(this, this.coordsAtPos(this.state.selection.head, 1), e);
    }
  }
  destroyPluginViews() {
    let e;
    for (; e = this.pluginViews.pop(); )
      e.destroy && e.destroy();
  }
  updatePluginViews(e) {
    if (!e || e.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let t = 0; t < this.directPlugins.length; t++) {
        let i = this.directPlugins[t];
        i.spec.view && this.pluginViews.push(i.spec.view(this));
      }
      for (let t = 0; t < this.state.plugins.length; t++) {
        let i = this.state.plugins[t];
        i.spec.view && this.pluginViews.push(i.spec.view(this));
      }
    } else
      for (let t = 0; t < this.pluginViews.length; t++) {
        let i = this.pluginViews[t];
        i.update && i.update(this, e);
      }
  }
  updateDraggedNode(e, t) {
    let i = e.node, r = -1;
    if (this.state.doc.nodeAt(i.from) == i.node)
      r = i.from;
    else {
      let o = i.from + (this.state.doc.content.size - t.doc.content.size);
      (o > 0 && this.state.doc.nodeAt(o)) == i.node && (r = o);
    }
    this.dragging = new Uf(e.slice, e.move, r < 0 ? void 0 : F.create(this.state.doc, r));
  }
  someProp(e, t) {
    let i = this._props && this._props[e], r;
    if (i != null && (r = t ? t(i) : i))
      return r;
    for (let s = 0; s < this.directPlugins.length; s++) {
      let a = this.directPlugins[s].props[e];
      if (a != null && (r = t ? t(a) : a))
        return r;
    }
    let o = this.state.plugins;
    if (o)
      for (let s = 0; s < o.length; s++) {
        let a = o[s].props[e];
        if (a != null && (r = t ? t(a) : a))
          return r;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (st) {
      let e = this.root.activeElement;
      if (e == this.dom)
        return !0;
      if (!e || !this.dom.contains(e))
        return !1;
      for (; e && this.dom != e && this.dom.contains(e); ) {
        if (e.contentEditable == "false")
          return !1;
        e = e.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && XN(this.dom), cn(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let e = this._root;
    if (e == null) {
      for (let t = this.dom.parentNode; t; t = t.parentNode)
        if (t.nodeType == 9 || t.nodeType == 11 && t.host)
          return t.getSelection || (Object.getPrototypeOf(t).getSelection = () => t.ownerDocument.getSelection()), this._root = t;
    }
    return e || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(e) {
    return iL(this, e);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(e, t = 1) {
    return Sf(this, e, t);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(e, t = 0) {
    return this.docView.domFromPos(e, t);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(e) {
    let t = this.docView.descAt(e);
    return t ? t.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(e, t, i = -1) {
    let r = this.docView.posFromDOM(e, t, i);
    if (r == null)
      throw new RangeError("DOM position not inside the editor");
    return r;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(e, t) {
    return lL(this, t || this.state, e);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(e, t) {
    return xr(this, "", e, !1, t || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(e, t) {
    return xr(this, e, null, !0, t || new ClipboardEvent("paste"));
  }
  /**
  Serialize the given slice as it would be if it was copied from
  this editor. Returns a DOM element that contains a
  representation of the slice as its children, a textual
  representation, and the transformed slice (which can be
  different from the given input due to hooks like
  [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
  */
  serializeForClipboard(e) {
    return jl(this, e);
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (IL(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], aa(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null, jN());
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(e) {
    return jL(this, e);
  }
  /**
  @internal
  */
  domSelectionRange() {
    let e = this.domSelection();
    return e ? et && this.root.nodeType === 11 && VN(this.dom.ownerDocument) == this.dom && lD(this, e) || e : { focusNode: null, focusOffset: 0, anchorNode: null, anchorOffset: 0 };
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
}
Gf.prototype.dispatch = function(n) {
  let e = this._props.dispatchTransaction;
  e ? e.call(this, n) : this.updateState(this.state.apply(n));
};
function xu(n) {
  let e = /* @__PURE__ */ Object.create(null);
  return e.class = "ProseMirror", e.contenteditable = String(n.editable), n.someProp("attributes", (t) => {
    if (typeof t == "function" && (t = t(n.state)), t)
      for (let i in t)
        i == "class" ? e.class += " " + t[i] : i == "style" ? e.style = (e.style ? e.style + ";" : "") + t[i] : !e[i] && i != "contenteditable" && i != "nodeName" && (e[i] = String(t[i]));
  }), e.translate || (e.translate = "no"), [Et.node(0, n.state.doc.content.size, e)];
}
function Su(n) {
  if (n.markCursor) {
    let e = document.createElement("img");
    e.className = "ProseMirror-separator", e.setAttribute("mark-placeholder", "true"), e.setAttribute("alt", ""), n.cursorWrapper = { dom: e, deco: Et.widget(n.state.selection.from, e, { raw: !0, marks: n.markCursor }) };
  } else
    n.cursorWrapper = null;
}
function wu(n) {
  return !n.someProp("editable", (e) => e(n.state) === !1);
}
function _D(n, e) {
  let t = Math.min(n.$anchor.sharedDepth(n.head), e.$anchor.sharedDepth(e.head));
  return n.$anchor.start(t) != e.$anchor.start(t);
}
function Cu(n) {
  let e = /* @__PURE__ */ Object.create(null);
  function t(i) {
    for (let r in i)
      Object.prototype.hasOwnProperty.call(e, r) || (e[r] = i[r]);
  }
  return n.someProp("nodeViews", t), n.someProp("markViews", t), e;
}
function bD(n, e) {
  let t = 0, i = 0;
  for (let r in n) {
    if (n[r] != e[r])
      return !0;
    t++;
  }
  for (let r in e)
    i++;
  return t != i;
}
function Tu(n) {
  if (n.spec.state || n.spec.filterTransaction || n.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var Dn = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, Ro = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, kD = typeof navigator < "u" && /Mac/.test(navigator.platform), yD = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var qe = 0; qe < 10; qe++) Dn[48 + qe] = Dn[96 + qe] = String(qe);
for (var qe = 1; qe <= 24; qe++) Dn[qe + 111] = "F" + qe;
for (var qe = 65; qe <= 90; qe++)
  Dn[qe] = String.fromCharCode(qe + 32), Ro[qe] = String.fromCharCode(qe);
for (var ca in Dn) Ro.hasOwnProperty(ca) || (Ro[ca] = Dn[ca]);
function vD(n) {
  var e = kD && n.metaKey && n.shiftKey && !n.ctrlKey && !n.altKey || yD && n.shiftKey && n.key && n.key.length == 1 || n.key == "Unidentified", t = !e && n.key || (n.shiftKey ? Ro : Dn)[n.keyCode] || n.key || "Unidentified";
  return t == "Esc" && (t = "Escape"), t == "Del" && (t = "Delete"), t == "Left" && (t = "ArrowLeft"), t == "Up" && (t = "ArrowUp"), t == "Right" && (t = "ArrowRight"), t == "Down" && (t = "ArrowDown"), t;
}
const xD = typeof navigator < "u" && /Mac|iP(hone|[oa]d)/.test(navigator.platform), SD = typeof navigator < "u" && /Win/.test(navigator.platform);
function wD(n) {
  let e = n.split(/-(?!$)/), t = e[e.length - 1];
  t == "Space" && (t = " ");
  let i, r, o, s;
  for (let a = 0; a < e.length - 1; a++) {
    let l = e[a];
    if (/^(cmd|meta|m)$/i.test(l))
      s = !0;
    else if (/^a(lt)?$/i.test(l))
      i = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      r = !0;
    else if (/^s(hift)?$/i.test(l))
      o = !0;
    else if (/^mod$/i.test(l))
      xD ? s = !0 : r = !0;
    else
      throw new Error("Unrecognized modifier name: " + l);
  }
  return i && (t = "Alt-" + t), r && (t = "Ctrl-" + t), s && (t = "Meta-" + t), o && (t = "Shift-" + t), t;
}
function CD(n) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let t in n)
    e[wD(t)] = n[t];
  return e;
}
function ua(n, e, t = !0) {
  return e.altKey && (n = "Alt-" + n), e.ctrlKey && (n = "Ctrl-" + n), e.metaKey && (n = "Meta-" + n), t && e.shiftKey && (n = "Shift-" + n), n;
}
function TD(n) {
  return new Ee({ props: { handleKeyDown: MD(n) } });
}
function MD(n) {
  let e = CD(n);
  return function(t, i) {
    let r = vD(i), o, s = e[ua(r, i)];
    if (s && s(t.state, t.dispatch, t))
      return !0;
    if (r.length == 1 && r != " ") {
      if (i.shiftKey) {
        let a = e[ua(r, i, !1)];
        if (a && a(t.state, t.dispatch, t))
          return !0;
      }
      if ((i.altKey || i.metaKey || i.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
      !(SD && i.ctrlKey && i.altKey) && (o = Dn[i.keyCode]) && o != r) {
        let a = e[ua(o, i)];
        if (a && a(t.state, t.dispatch, t))
          return !0;
      }
    }
    return !1;
  };
}
const Ul = (n, e) => n.selection.empty ? !1 : (e && e(n.tr.deleteSelection().scrollIntoView()), !0);
function Yf(n, e) {
  let { $cursor: t } = n.selection;
  return !t || (e ? !e.endOfTextblock("backward", n) : t.parentOffset > 0) ? null : t;
}
const Xf = (n, e, t) => {
  let i = Yf(n, t);
  if (!i)
    return !1;
  let r = Wl(i);
  if (!r) {
    let s = i.blockRange(), a = s && Hi(s);
    return a == null ? !1 : (e && e(n.tr.lift(s, a).scrollIntoView()), !0);
  }
  let o = r.nodeBefore;
  if (ap(n, r, e, -1))
    return !0;
  if (i.parent.content.size == 0 && (Ri(o, "end") || F.isSelectable(o)))
    for (let s = i.depth; ; s--) {
      let a = $s(n.doc, i.before(s), i.after(s), L.empty);
      if (a && a.slice.size < a.to - a.from) {
        if (e) {
          let l = n.tr.step(a);
          l.setSelection(Ri(o, "end") ? ne.findFrom(l.doc.resolve(l.mapping.map(r.pos, -1)), -1) : F.create(l.doc, r.pos - o.nodeSize)), e(l.scrollIntoView());
        }
        return !0;
      }
      if (s == 1 || i.node(s - 1).childCount > 1)
        break;
    }
  return o.isAtom && r.depth == i.depth - 1 ? (e && e(n.tr.delete(r.pos - o.nodeSize, r.pos).scrollIntoView()), !0) : !1;
}, ED = (n, e, t) => {
  let i = Yf(n, t);
  if (!i)
    return !1;
  let r = Wl(i);
  return r ? Qf(n, r, e) : !1;
}, $D = (n, e, t) => {
  let i = tp(n, t);
  if (!i)
    return !1;
  let r = Kl(i);
  return r ? Qf(n, r, e) : !1;
};
function Qf(n, e, t) {
  let i = e.nodeBefore, r = i, o = e.pos - 1;
  for (; !r.isTextblock; o--) {
    if (r.type.spec.isolating)
      return !1;
    let u = r.lastChild;
    if (!u)
      return !1;
    r = u;
  }
  let s = e.nodeAfter, a = s, l = e.pos + 1;
  for (; !a.isTextblock; l++) {
    if (a.type.spec.isolating)
      return !1;
    let u = a.firstChild;
    if (!u)
      return !1;
    a = u;
  }
  let c = $s(n.doc, o, l, L.empty);
  if (!c || c.from != o || c instanceof De && c.slice.size >= l - o)
    return !1;
  if (t) {
    let u = n.tr.step(c);
    u.setSelection(G.create(u.doc, o)), t(u.scrollIntoView());
  }
  return !0;
}
function Ri(n, e, t = !1) {
  for (let i = n; i; i = e == "start" ? i.firstChild : i.lastChild) {
    if (i.isTextblock)
      return !0;
    if (t && i.childCount != 1)
      return !1;
  }
  return !1;
}
const ep = (n, e, t) => {
  let { $head: i, empty: r } = n.selection, o = i;
  if (!r)
    return !1;
  if (i.parent.isTextblock) {
    if (t ? !t.endOfTextblock("backward", n) : i.parentOffset > 0)
      return !1;
    o = Wl(i);
  }
  let s = o && o.nodeBefore;
  return !s || !F.isSelectable(s) ? !1 : (e && e(n.tr.setSelection(F.create(n.doc, o.pos - s.nodeSize)).scrollIntoView()), !0);
};
function Wl(n) {
  if (!n.parent.type.spec.isolating)
    for (let e = n.depth - 1; e >= 0; e--) {
      if (n.index(e) > 0)
        return n.doc.resolve(n.before(e + 1));
      if (n.node(e).type.spec.isolating)
        break;
    }
  return null;
}
function tp(n, e) {
  let { $cursor: t } = n.selection;
  return !t || (e ? !e.endOfTextblock("forward", n) : t.parentOffset < t.parent.content.size) ? null : t;
}
const np = (n, e, t) => {
  let i = tp(n, t);
  if (!i)
    return !1;
  let r = Kl(i);
  if (!r)
    return !1;
  let o = r.nodeAfter;
  if (ap(n, r, e, 1))
    return !0;
  if (i.parent.content.size == 0 && (Ri(o, "start") || F.isSelectable(o))) {
    let s = $s(n.doc, i.before(), i.after(), L.empty);
    if (s && s.slice.size < s.to - s.from) {
      if (e) {
        let a = n.tr.step(s);
        a.setSelection(Ri(o, "start") ? ne.findFrom(a.doc.resolve(a.mapping.map(r.pos)), 1) : F.create(a.doc, a.mapping.map(r.pos))), e(a.scrollIntoView());
      }
      return !0;
    }
  }
  return o.isAtom && r.depth == i.depth - 1 ? (e && e(n.tr.delete(r.pos, r.pos + o.nodeSize).scrollIntoView()), !0) : !1;
}, ip = (n, e, t) => {
  let { $head: i, empty: r } = n.selection, o = i;
  if (!r)
    return !1;
  if (i.parent.isTextblock) {
    if (t ? !t.endOfTextblock("forward", n) : i.parentOffset < i.parent.content.size)
      return !1;
    o = Kl(i);
  }
  let s = o && o.nodeAfter;
  return !s || !F.isSelectable(s) ? !1 : (e && e(n.tr.setSelection(F.create(n.doc, o.pos)).scrollIntoView()), !0);
};
function Kl(n) {
  if (!n.parent.type.spec.isolating)
    for (let e = n.depth - 1; e >= 0; e--) {
      let t = n.node(e);
      if (n.index(e) + 1 < t.childCount)
        return n.doc.resolve(n.after(e + 1));
      if (t.type.spec.isolating)
        break;
    }
  return null;
}
const OD = (n, e) => {
  let t = n.selection, i = t instanceof F, r;
  if (i) {
    if (t.node.isTextblock || !In(n.doc, t.from))
      return !1;
    r = t.from;
  } else if (r = Es(n.doc, t.from, -1), r == null)
    return !1;
  if (e) {
    let o = n.tr.join(r);
    i && o.setSelection(F.create(o.doc, r - n.doc.resolve(r).nodeBefore.nodeSize)), e(o.scrollIntoView());
  }
  return !0;
}, zD = (n, e) => {
  let t = n.selection, i;
  if (t instanceof F) {
    if (t.node.isTextblock || !In(n.doc, t.to))
      return !1;
    i = t.to;
  } else if (i = Es(n.doc, t.to, 1), i == null)
    return !1;
  return e && e(n.tr.join(i).scrollIntoView()), !0;
}, AD = (n, e) => {
  let { $from: t, $to: i } = n.selection, r = t.blockRange(i), o = r && Hi(r);
  return o == null ? !1 : (e && e(n.tr.lift(r, o).scrollIntoView()), !0);
}, rp = (n, e) => {
  let { $head: t, $anchor: i } = n.selection;
  return !t.parent.type.spec.code || !t.sameParent(i) ? !1 : (e && e(n.tr.insertText(`
`).scrollIntoView()), !0);
};
function Zl(n) {
  for (let e = 0; e < n.edgeCount; e++) {
    let { type: t } = n.edge(e);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
const ND = (n, e) => {
  let { $head: t, $anchor: i } = n.selection;
  if (!t.parent.type.spec.code || !t.sameParent(i))
    return !1;
  let r = t.node(-1), o = t.indexAfter(-1), s = Zl(r.contentMatchAt(o));
  if (!s || !r.canReplaceWith(o, o, s))
    return !1;
  if (e) {
    let a = t.after(), l = n.tr.replaceWith(a, a, s.createAndFill());
    l.setSelection(ne.near(l.doc.resolve(a), 1)), e(l.scrollIntoView());
  }
  return !0;
}, op = (n, e) => {
  let t = n.selection, { $from: i, $to: r } = t;
  if (t instanceof ot || i.parent.inlineContent || r.parent.inlineContent)
    return !1;
  let o = Zl(r.parent.contentMatchAt(r.indexAfter()));
  if (!o || !o.isTextblock)
    return !1;
  if (e) {
    let s = (!i.parentOffset && r.index() < r.parent.childCount ? i : r).pos, a = n.tr.insert(s, o.createAndFill());
    a.setSelection(G.create(a.doc, s + 1)), e(a.scrollIntoView());
  }
  return !0;
}, sp = (n, e) => {
  let { $cursor: t } = n.selection;
  if (!t || t.parent.content.size)
    return !1;
  if (t.depth > 1 && t.after() != t.end(-1)) {
    let o = t.before();
    if (ln(n.doc, o))
      return e && e(n.tr.split(o).scrollIntoView()), !0;
  }
  let i = t.blockRange(), r = i && Hi(i);
  return r == null ? !1 : (e && e(n.tr.lift(i, r).scrollIntoView()), !0);
};
function LD(n) {
  return (e, t) => {
    let { $from: i, $to: r } = e.selection;
    if (e.selection instanceof F && e.selection.node.isBlock)
      return !i.parentOffset || !ln(e.doc, i.pos) ? !1 : (t && t(e.tr.split(i.pos).scrollIntoView()), !0);
    if (!i.depth)
      return !1;
    let o = [], s, a, l = !1, c = !1;
    for (let f = i.depth; ; f--)
      if (i.node(f).isBlock) {
        l = i.end(f) == i.pos + (i.depth - f), c = i.start(f) == i.pos - (i.depth - f), a = Zl(i.node(f - 1).contentMatchAt(i.indexAfter(f - 1))), o.unshift(l && a ? { type: a } : null), s = f;
        break;
      } else {
        if (f == 1)
          return !1;
        o.unshift(null);
      }
    let u = e.tr;
    (e.selection instanceof G || e.selection instanceof ot) && u.deleteSelection();
    let d = u.mapping.map(i.pos), h = ln(u.doc, d, o.length, o);
    if (h || (o[0] = a ? { type: a } : null, h = ln(u.doc, d, o.length, o)), !h)
      return !1;
    if (u.split(d, o.length, o), !l && c && i.node(s).type != a) {
      let f = u.mapping.map(i.before(s)), p = u.doc.resolve(f);
      a && i.node(s - 1).canReplaceWith(p.index(), p.index() + 1, a) && u.setNodeMarkup(u.mapping.map(i.before(s)), a);
    }
    return t && t(u.scrollIntoView()), !0;
  };
}
const DD = LD(), RD = (n, e) => {
  let { $from: t, to: i } = n.selection, r, o = t.sharedDepth(i);
  return o == 0 ? !1 : (r = t.before(o), e && e(n.tr.setSelection(F.create(n.doc, r))), !0);
};
function ID(n, e, t) {
  let i = e.nodeBefore, r = e.nodeAfter, o = e.index();
  return !i || !r || !i.type.compatibleContent(r.type) ? !1 : !i.content.size && e.parent.canReplace(o - 1, o) ? (t && t(n.tr.delete(e.pos - i.nodeSize, e.pos).scrollIntoView()), !0) : !e.parent.canReplace(o, o + 1) || !(r.isTextblock || In(n.doc, e.pos)) ? !1 : (t && t(n.tr.join(e.pos).scrollIntoView()), !0);
}
function ap(n, e, t, i) {
  let r = e.nodeBefore, o = e.nodeAfter, s, a, l = r.type.spec.isolating || o.type.spec.isolating;
  if (!l && ID(n, e, t))
    return !0;
  let c = !l && e.parent.canReplace(e.index(), e.index() + 1);
  if (c && (s = (a = r.contentMatchAt(r.childCount)).findWrapping(o.type)) && a.matchType(s[0] || o.type).validEnd) {
    if (t) {
      let f = e.pos + o.nodeSize, p = M.empty;
      for (let k = s.length - 1; k >= 0; k--)
        p = M.from(s[k].create(null, p));
      p = M.from(r.copy(p));
      let m = n.tr.step(new Re(e.pos - 1, f, e.pos, f, new L(p, 1, 0), s.length, !0)), g = m.doc.resolve(f + 2 * s.length);
      g.nodeAfter && g.nodeAfter.type == r.type && In(m.doc, g.pos) && m.join(g.pos), t(m.scrollIntoView());
    }
    return !0;
  }
  let u = o.type.spec.isolating || i > 0 && l ? null : ne.findFrom(e, 1), d = u && u.$from.blockRange(u.$to), h = d && Hi(d);
  if (h != null && h >= e.depth)
    return t && t(n.tr.lift(d, h).scrollIntoView()), !0;
  if (c && Ri(o, "start", !0) && Ri(r, "end")) {
    let f = r, p = [];
    for (; p.push(f), !f.isTextblock; )
      f = f.lastChild;
    let m = o, g = 1;
    for (; !m.isTextblock; m = m.firstChild)
      g++;
    if (f.canReplace(f.childCount, f.childCount, m.content)) {
      if (t) {
        let k = M.empty;
        for (let S = p.length - 1; S >= 0; S--)
          k = M.from(p[S].copy(k));
        let x = n.tr.step(new Re(e.pos - p.length, e.pos + o.nodeSize, e.pos + g, e.pos + o.nodeSize - g, new L(k, p.length, 0), 0, !0));
        t(x.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function lp(n) {
  return function(e, t) {
    let i = e.selection, r = n < 0 ? i.$from : i.$to, o = r.depth;
    for (; r.node(o).isInline; ) {
      if (!o)
        return !1;
      o--;
    }
    return r.node(o).isTextblock ? (t && t(e.tr.setSelection(G.create(e.doc, n < 0 ? r.start(o) : r.end(o)))), !0) : !1;
  };
}
const PD = lp(-1), jD = lp(1);
function BD(n, e = null) {
  return function(t, i) {
    let { $from: r, $to: o } = t.selection, s = r.blockRange(o), a = s && Ll(s, n, e);
    return a ? (i && i(t.tr.wrap(s, a).scrollIntoView()), !0) : !1;
  };
}
function Mu(n, e = null) {
  return function(t, i) {
    let r = !1;
    for (let o = 0; o < t.selection.ranges.length && !r; o++) {
      let { $from: { pos: s }, $to: { pos: a } } = t.selection.ranges[o];
      t.doc.nodesBetween(s, a, (l, c) => {
        if (r)
          return !1;
        if (!(!l.isTextblock || l.hasMarkup(n, e)))
          if (l.type == n)
            r = !0;
          else {
            let u = t.doc.resolve(c), d = u.index();
            r = u.parent.canReplaceWith(d, d + 1, n);
          }
      });
    }
    if (!r)
      return !1;
    if (i) {
      let o = t.tr;
      for (let s = 0; s < t.selection.ranges.length; s++) {
        let { $from: { pos: a }, $to: { pos: l } } = t.selection.ranges[s];
        o.setBlockType(a, l, n, e);
      }
      i(o.scrollIntoView());
    }
    return !0;
  };
}
function Jl(...n) {
  return function(e, t, i) {
    for (let r = 0; r < n.length; r++)
      if (n[r](e, t, i))
        return !0;
    return !1;
  };
}
Jl(Ul, Xf, ep);
Jl(Ul, np, ip);
Jl(rp, op, sp, DD);
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function FD(n, e = null) {
  return function(t, i) {
    let { $from: r, $to: o } = t.selection, s = r.blockRange(o);
    if (!s)
      return !1;
    let a = i ? t.tr : null;
    return qD(a, s, n, e) ? (i && i(a.scrollIntoView()), !0) : !1;
  };
}
function qD(n, e, t, i = null) {
  let r = !1, o = e, s = e.$from.doc;
  if (e.depth >= 2 && e.$from.node(e.depth - 1).type.compatibleContent(t) && e.startIndex == 0) {
    if (e.$from.index(e.depth - 1) == 0)
      return !1;
    let l = s.resolve(e.start - 2);
    o = new $o(l, l, e.depth), e.endIndex < e.parent.childCount && (e = new $o(e.$from, s.resolve(e.$to.end(e.depth)), e.depth)), r = !0;
  }
  let a = Ll(o, t, i, e);
  return a ? (n && HD(n, e, a, r, t), !0) : !1;
}
function HD(n, e, t, i, r) {
  let o = M.empty;
  for (let u = t.length - 1; u >= 0; u--)
    o = M.from(t[u].type.create(t[u].attrs, o));
  n.step(new Re(e.start - (i ? 2 : 0), e.end, e.start, e.end, new L(o, 0, 0), t.length, !0));
  let s = 0;
  for (let u = 0; u < t.length; u++)
    t[u].type == r && (s = u + 1);
  let a = t.length - s, l = e.start + t.length - (i ? 2 : 0), c = e.parent;
  for (let u = e.startIndex, d = e.endIndex, h = !0; u < d; u++, h = !1)
    !h && ln(n.doc, l, a) && (n.split(l, a), l += 2 * a), l += c.child(u).nodeSize;
  return n;
}
function VD(n) {
  return function(e, t) {
    let { $from: i, $to: r } = e.selection, o = i.blockRange(r, (s) => s.childCount > 0 && s.firstChild.type == n);
    return o ? t ? i.node(o.depth - 1).type == n ? UD(e, t, n, o) : WD(e, t, o) : !0 : !1;
  };
}
function UD(n, e, t, i) {
  let r = n.tr, o = i.end, s = i.$to.end(i.depth);
  o < s && (r.step(new Re(o - 1, s, o, s, new L(M.from(t.create(null, i.parent.copy())), 1, 0), 1, !0)), i = new $o(r.doc.resolve(i.$from.pos), r.doc.resolve(s), i.depth));
  const a = Hi(i);
  if (a == null)
    return !1;
  r.lift(i, a);
  let l = r.doc.resolve(r.mapping.map(o, -1) - 1);
  return In(r.doc, l.pos) && l.nodeBefore.type == l.nodeAfter.type && r.join(l.pos), e(r.scrollIntoView()), !0;
}
function WD(n, e, t) {
  let i = n.tr, r = t.parent;
  for (let f = t.end, p = t.endIndex - 1, m = t.startIndex; p > m; p--)
    f -= r.child(p).nodeSize, i.delete(f - 1, f + 1);
  let o = i.doc.resolve(t.start), s = o.nodeAfter;
  if (i.mapping.map(t.end) != t.start + o.nodeAfter.nodeSize)
    return !1;
  let a = t.startIndex == 0, l = t.endIndex == r.childCount, c = o.node(-1), u = o.index(-1);
  if (!c.canReplace(u + (a ? 0 : 1), u + 1, s.content.append(l ? M.empty : M.from(r))))
    return !1;
  let d = o.pos, h = d + s.nodeSize;
  return i.step(new Re(d - (a ? 1 : 0), h + (l ? 1 : 0), d + 1, h - 1, new L((a ? M.empty : M.from(r.copy(M.empty))).append(l ? M.empty : M.from(r.copy(M.empty))), a ? 0 : 1, l ? 0 : 1), a ? 0 : 1)), e(i.scrollIntoView()), !0;
}
function KD(n) {
  return function(e, t) {
    let { $from: i, $to: r } = e.selection, o = i.blockRange(r, (c) => c.childCount > 0 && c.firstChild.type == n);
    if (!o)
      return !1;
    let s = o.startIndex;
    if (s == 0)
      return !1;
    let a = o.parent, l = a.child(s - 1);
    if (l.type != n)
      return !1;
    if (t) {
      let c = l.lastChild && l.lastChild.type == a.type, u = M.from(c ? n.create() : null), d = new L(M.from(n.create(null, M.from(a.type.create(null, u)))), c ? 3 : 1, 0), h = o.start, f = o.end;
      t(e.tr.step(new Re(h - (c ? 3 : 1), f, h, f, d, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
function Ls(n) {
  const { state: e, transaction: t } = n;
  let { selection: i } = t, { doc: r } = t, { storedMarks: o } = t;
  return {
    ...e,
    apply: e.apply.bind(e),
    applyTransaction: e.applyTransaction.bind(e),
    plugins: e.plugins,
    schema: e.schema,
    reconfigure: e.reconfigure.bind(e),
    toJSON: e.toJSON.bind(e),
    get storedMarks() {
      return o;
    },
    get selection() {
      return i;
    },
    get doc() {
      return r;
    },
    get tr() {
      return i = t.selection, r = t.doc, o = t.storedMarks, t;
    }
  };
}
class Ds {
  constructor(e) {
    this.editor = e.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = e.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: e, editor: t, state: i } = this, { view: r } = t, { tr: o } = i, s = this.buildProps(o);
    return Object.fromEntries(Object.entries(e).map(([a, l]) => [a, (...u) => {
      const d = l(...u)(s);
      return !o.getMeta("preventDispatch") && !this.hasCustomState && r.dispatch(o), d;
    }]));
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(e, t = !0) {
    const { rawCommands: i, editor: r, state: o } = this, { view: s } = r, a = [], l = !!e, c = e || o.tr, u = () => (!l && t && !c.getMeta("preventDispatch") && !this.hasCustomState && s.dispatch(c), a.every((h) => h === !0)), d = {
      ...Object.fromEntries(Object.entries(i).map(([h, f]) => [h, (...m) => {
        const g = this.buildProps(c, t), k = f(...m)(g);
        return a.push(k), d;
      }])),
      run: u
    };
    return d;
  }
  createCan(e) {
    const { rawCommands: t, state: i } = this, r = !1, o = e || i.tr, s = this.buildProps(o, r);
    return {
      ...Object.fromEntries(Object.entries(t).map(([l, c]) => [l, (...u) => c(...u)({ ...s, dispatch: void 0 })])),
      chain: () => this.createChain(o, r)
    };
  }
  buildProps(e, t = !0) {
    const { rawCommands: i, editor: r, state: o } = this, { view: s } = r, a = {
      tr: e,
      editor: r,
      view: s,
      state: Ls({
        state: o,
        transaction: e
      }),
      dispatch: t ? () => {
      } : void 0,
      chain: () => this.createChain(e, t),
      can: () => this.createCan(e),
      get commands() {
        return Object.fromEntries(Object.entries(i).map(([l, c]) => [l, (...u) => c(...u)(a)]));
      }
    };
    return a;
  }
}
let ZD = class {
  constructor() {
    this.callbacks = {};
  }
  on(e, t) {
    return this.callbacks[e] || (this.callbacks[e] = []), this.callbacks[e].push(t), this;
  }
  emit(e, ...t) {
    const i = this.callbacks[e];
    return i && i.forEach((r) => r.apply(this, t)), this;
  }
  off(e, t) {
    const i = this.callbacks[e];
    return i && (t ? this.callbacks[e] = i.filter((r) => r !== t) : delete this.callbacks[e]), this;
  }
  once(e, t) {
    const i = (...r) => {
      this.off(e, i), t.apply(this, r);
    };
    return this.on(e, i);
  }
  removeAllListeners() {
    this.callbacks = {};
  }
};
function R(n, e, t) {
  return n.config[e] === void 0 && n.parent ? R(n.parent, e, t) : typeof n.config[e] == "function" ? n.config[e].bind({
    ...t,
    parent: n.parent ? R(n.parent, e, t) : null
  }) : n.config[e];
}
function Rs(n) {
  const e = n.filter((r) => r.type === "extension"), t = n.filter((r) => r.type === "node"), i = n.filter((r) => r.type === "mark");
  return {
    baseExtensions: e,
    nodeExtensions: t,
    markExtensions: i
  };
}
function cp(n) {
  const e = [], { nodeExtensions: t, markExtensions: i } = Rs(n), r = [...t, ...i], o = {
    default: null,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  };
  return n.forEach((s) => {
    const a = {
      name: s.name,
      options: s.options,
      storage: s.storage,
      extensions: r
    }, l = R(s, "addGlobalAttributes", a);
    if (!l)
      return;
    l().forEach((u) => {
      u.types.forEach((d) => {
        Object.entries(u.attributes).forEach(([h, f]) => {
          e.push({
            type: d,
            name: h,
            attribute: {
              ...o,
              ...f
            }
          });
        });
      });
    });
  }), r.forEach((s) => {
    const a = {
      name: s.name,
      options: s.options,
      storage: s.storage
    }, l = R(s, "addAttributes", a);
    if (!l)
      return;
    const c = l();
    Object.entries(c).forEach(([u, d]) => {
      const h = {
        ...o,
        ...d
      };
      typeof (h == null ? void 0 : h.default) == "function" && (h.default = h.default()), h != null && h.isRequired && (h == null ? void 0 : h.default) === void 0 && delete h.default, e.push({
        type: s.name,
        name: u,
        attribute: h
      });
    });
  }), e;
}
function Pe(n, e) {
  if (typeof n == "string") {
    if (!e.nodes[n])
      throw Error(`There is no node type named '${n}'. Maybe you forgot to add the extension?`);
    return e.nodes[n];
  }
  return n;
}
function ke(...n) {
  return n.filter((e) => !!e).reduce((e, t) => {
    const i = { ...e };
    return Object.entries(t).forEach(([r, o]) => {
      if (!i[r]) {
        i[r] = o;
        return;
      }
      if (r === "class") {
        const a = o ? String(o).split(" ") : [], l = i[r] ? i[r].split(" ") : [], c = a.filter((u) => !l.includes(u));
        i[r] = [...l, ...c].join(" ");
      } else if (r === "style") {
        const a = o ? o.split(";").map((u) => u.trim()).filter(Boolean) : [], l = i[r] ? i[r].split(";").map((u) => u.trim()).filter(Boolean) : [], c = /* @__PURE__ */ new Map();
        l.forEach((u) => {
          const [d, h] = u.split(":").map((f) => f.trim());
          c.set(d, h);
        }), a.forEach((u) => {
          const [d, h] = u.split(":").map((f) => f.trim());
          c.set(d, h);
        }), i[r] = Array.from(c.entries()).map(([u, d]) => `${u}: ${d}`).join("; ");
      } else
        i[r] = o;
    }), i;
  }, {});
}
function Io(n, e) {
  return e.filter((t) => t.type === n.type.name).filter((t) => t.attribute.rendered).map((t) => t.attribute.renderHTML ? t.attribute.renderHTML(n.attrs) || {} : {
    [t.name]: n.attrs[t.name]
  }).reduce((t, i) => ke(t, i), {});
}
function up(n) {
  return typeof n == "function";
}
function ee(n, e = void 0, ...t) {
  return up(n) ? e ? n.bind(e)(...t) : n(...t) : n;
}
function JD(n = {}) {
  return Object.keys(n).length === 0 && n.constructor === Object;
}
function GD(n) {
  return typeof n != "string" ? n : n.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(n) : n === "true" ? !0 : n === "false" ? !1 : n;
}
function Eu(n, e) {
  return "style" in n ? n : {
    ...n,
    getAttrs: (t) => {
      const i = n.getAttrs ? n.getAttrs(t) : n.attrs;
      if (i === !1)
        return !1;
      const r = e.reduce((o, s) => {
        const a = s.attribute.parseHTML ? s.attribute.parseHTML(t) : GD(t.getAttribute(s.name));
        return a == null ? o : {
          ...o,
          [s.name]: a
        };
      }, {});
      return { ...i, ...r };
    }
  };
}
function $u(n) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(n).filter(([e, t]) => e === "attrs" && JD(t) ? !1 : t != null)
  );
}
function dp(n, e) {
  var t;
  const i = cp(n), { nodeExtensions: r, markExtensions: o } = Rs(n), s = (t = r.find((c) => R(c, "topNode"))) === null || t === void 0 ? void 0 : t.name, a = Object.fromEntries(r.map((c) => {
    const u = i.filter((k) => k.type === c.name), d = {
      name: c.name,
      options: c.options,
      storage: c.storage,
      editor: e
    }, h = n.reduce((k, x) => {
      const S = R(x, "extendNodeSchema", d);
      return {
        ...k,
        ...S ? S(c) : {}
      };
    }, {}), f = $u({
      ...h,
      content: ee(R(c, "content", d)),
      marks: ee(R(c, "marks", d)),
      group: ee(R(c, "group", d)),
      inline: ee(R(c, "inline", d)),
      atom: ee(R(c, "atom", d)),
      selectable: ee(R(c, "selectable", d)),
      draggable: ee(R(c, "draggable", d)),
      code: ee(R(c, "code", d)),
      whitespace: ee(R(c, "whitespace", d)),
      linebreakReplacement: ee(R(c, "linebreakReplacement", d)),
      defining: ee(R(c, "defining", d)),
      isolating: ee(R(c, "isolating", d)),
      attrs: Object.fromEntries(u.map((k) => {
        var x;
        return [k.name, { default: (x = k == null ? void 0 : k.attribute) === null || x === void 0 ? void 0 : x.default }];
      }))
    }), p = ee(R(c, "parseHTML", d));
    p && (f.parseDOM = p.map((k) => Eu(k, u)));
    const m = R(c, "renderHTML", d);
    m && (f.toDOM = (k) => m({
      node: k,
      HTMLAttributes: Io(k, u)
    }));
    const g = R(c, "renderText", d);
    return g && (f.toText = g), [c.name, f];
  })), l = Object.fromEntries(o.map((c) => {
    const u = i.filter((g) => g.type === c.name), d = {
      name: c.name,
      options: c.options,
      storage: c.storage,
      editor: e
    }, h = n.reduce((g, k) => {
      const x = R(k, "extendMarkSchema", d);
      return {
        ...g,
        ...x ? x(c) : {}
      };
    }, {}), f = $u({
      ...h,
      inclusive: ee(R(c, "inclusive", d)),
      excludes: ee(R(c, "excludes", d)),
      group: ee(R(c, "group", d)),
      spanning: ee(R(c, "spanning", d)),
      code: ee(R(c, "code", d)),
      attrs: Object.fromEntries(u.map((g) => {
        var k;
        return [g.name, { default: (k = g == null ? void 0 : g.attribute) === null || k === void 0 ? void 0 : k.default }];
      }))
    }), p = ee(R(c, "parseHTML", d));
    p && (f.parseDOM = p.map((g) => Eu(g, u)));
    const m = R(c, "renderHTML", d);
    return m && (f.toDOM = (g) => m({
      mark: g,
      HTMLAttributes: Io(g, u)
    })), [c.name, f];
  }));
  return new Yh({
    topNode: s,
    nodes: a,
    marks: l
  });
}
function da(n, e) {
  return e.nodes[n] || e.marks[n] || null;
}
function Ou(n, e) {
  return Array.isArray(e) ? e.some((t) => (typeof t == "string" ? t : t.name) === n.name) : e;
}
function Is(n, e) {
  const t = fi.fromSchema(e).serializeFragment(n), r = document.implementation.createHTMLDocument().createElement("div");
  return r.appendChild(t), r.innerHTML;
}
const YD = (n, e = 500) => {
  let t = "";
  const i = n.parentOffset;
  return n.parent.nodesBetween(Math.max(0, i - e), i, (r, o, s, a) => {
    var l, c;
    const u = ((c = (l = r.type.spec).toText) === null || c === void 0 ? void 0 : c.call(l, {
      node: r,
      pos: o,
      parent: s,
      index: a
    })) || r.textContent || "%leaf%";
    t += r.isAtom && !r.isText ? u : u.slice(0, Math.max(0, i - o));
  }), t;
};
function Gl(n) {
  return Object.prototype.toString.call(n) === "[object RegExp]";
}
class Yl {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
const XD = (n, e) => {
  if (Gl(e))
    return e.exec(n);
  const t = e(n);
  if (!t)
    return null;
  const i = [t.text];
  return i.index = t.index, i.input = n, i.data = t.data, t.replaceWith && (t.text.includes(t.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), i.push(t.replaceWith)), i;
};
function Zr(n) {
  var e;
  const { editor: t, from: i, to: r, text: o, rules: s, plugin: a } = n, { view: l } = t;
  if (l.composing)
    return !1;
  const c = l.state.doc.resolve(i);
  if (
    // check for code node
    c.parent.type.spec.code || !((e = c.nodeBefore || c.nodeAfter) === null || e === void 0) && e.marks.find((h) => h.type.spec.code)
  )
    return !1;
  let u = !1;
  const d = YD(c) + o;
  return s.forEach((h) => {
    if (u)
      return;
    const f = XD(d, h.find);
    if (!f)
      return;
    const p = l.state.tr, m = Ls({
      state: l.state,
      transaction: p
    }), g = {
      from: i - (f[0].length - o.length),
      to: r
    }, { commands: k, chain: x, can: S } = new Ds({
      editor: t,
      state: m
    });
    h.handler({
      state: m,
      range: g,
      match: f,
      commands: k,
      chain: x,
      can: S
    }) === null || !p.steps.length || (p.setMeta(a, {
      transform: p,
      from: i,
      to: r,
      text: o
    }), l.dispatch(p), u = !0);
  }), u;
}
function QD(n) {
  const { editor: e, rules: t } = n, i = new Ee({
    state: {
      init() {
        return null;
      },
      apply(r, o, s) {
        const a = r.getMeta(i);
        if (a)
          return a;
        const l = r.getMeta("applyInputRules");
        return !!l && setTimeout(() => {
          let { text: u } = l;
          typeof u == "string" ? u = u : u = Is(M.from(u), s.schema);
          const { from: d } = l, h = d + u.length;
          Zr({
            editor: e,
            from: d,
            to: h,
            text: u,
            rules: t,
            plugin: i
          });
        }), r.selectionSet || r.docChanged ? null : o;
      }
    },
    props: {
      handleTextInput(r, o, s, a) {
        return Zr({
          editor: e,
          from: o,
          to: s,
          text: a,
          rules: t,
          plugin: i
        });
      },
      handleDOMEvents: {
        compositionend: (r) => (setTimeout(() => {
          const { $cursor: o } = r.state.selection;
          o && Zr({
            editor: e,
            from: o.pos,
            to: o.pos,
            text: "",
            rules: t,
            plugin: i
          });
        }), !1)
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(r, o) {
        if (o.key !== "Enter")
          return !1;
        const { $cursor: s } = r.state.selection;
        return s ? Zr({
          editor: e,
          from: s.pos,
          to: s.pos,
          text: `
`,
          rules: t,
          plugin: i
        }) : !1;
      }
    },
    // @ts-ignore
    isInputRules: !0
  });
  return i;
}
function e6(n) {
  return Object.prototype.toString.call(n).slice(8, -1);
}
function Jr(n) {
  return e6(n) !== "Object" ? !1 : n.constructor === Object && Object.getPrototypeOf(n) === Object.prototype;
}
function Ps(n, e) {
  const t = { ...n };
  return Jr(n) && Jr(e) && Object.keys(e).forEach((i) => {
    Jr(e[i]) && Jr(n[i]) ? t[i] = Ps(n[i], e[i]) : t[i] = e[i];
  }), t;
}
class Wt {
  constructor(e = {}) {
    this.type = "mark", this.name = "mark", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = ee(R(this, "addOptions", {
      name: this.name
    }))), this.storage = ee(R(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new Wt(e);
  }
  configure(e = {}) {
    const t = this.extend({
      ...this.config,
      addOptions: () => Ps(this.options, e)
    });
    return t.name = this.name, t.parent = this.parent, t;
  }
  extend(e = {}) {
    const t = new Wt(e);
    return t.parent = this, this.child = t, t.name = e.name ? e.name : t.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${t.name}".`), t.options = ee(R(t, "addOptions", {
      name: t.name
    })), t.storage = ee(R(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
  static handleExit({ editor: e, mark: t }) {
    const { tr: i } = e.state, r = e.state.selection.$from;
    if (r.pos === r.end()) {
      const s = r.marks();
      if (!!!s.find((c) => (c == null ? void 0 : c.type.name) === t.name))
        return !1;
      const l = s.find((c) => (c == null ? void 0 : c.type.name) === t.name);
      return l && i.removeStoredMark(l), i.insertText(" ", r.pos), e.view.dispatch(i), !0;
    }
    return !1;
  }
}
function t6(n) {
  return typeof n == "number";
}
class n6 {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
const i6 = (n, e, t) => {
  if (Gl(e))
    return [...n.matchAll(e)];
  const i = e(n, t);
  return i ? i.map((r) => {
    const o = [r.text];
    return o.index = r.index, o.input = n, o.data = r.data, r.replaceWith && (r.text.includes(r.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), o.push(r.replaceWith)), o;
  }) : [];
};
function r6(n) {
  const { editor: e, state: t, from: i, to: r, rule: o, pasteEvent: s, dropEvent: a } = n, { commands: l, chain: c, can: u } = new Ds({
    editor: e,
    state: t
  }), d = [];
  return t.doc.nodesBetween(i, r, (f, p) => {
    if (!f.isTextblock || f.type.spec.code)
      return;
    const m = Math.max(i, p), g = Math.min(r, p + f.content.size), k = f.textBetween(m - p, g - p, void 0, "￼");
    i6(k, o.find, s).forEach((S) => {
      if (S.index === void 0)
        return;
      const _ = m + S.index + 1, v = _ + S[0].length, y = {
        from: t.tr.mapping.map(_),
        to: t.tr.mapping.map(v)
      }, w = o.handler({
        state: t,
        range: y,
        match: S,
        commands: l,
        chain: c,
        can: u,
        pasteEvent: s,
        dropEvent: a
      });
      d.push(w);
    });
  }), d.every((f) => f !== null);
}
let Gr = null;
const o6 = (n) => {
  var e;
  const t = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  return (e = t.clipboardData) === null || e === void 0 || e.setData("text/html", n), t;
};
function s6(n) {
  const { editor: e, rules: t } = n;
  let i = null, r = !1, o = !1, s = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, a;
  try {
    a = typeof DragEvent < "u" ? new DragEvent("drop") : null;
  } catch {
    a = null;
  }
  const l = ({ state: u, from: d, to: h, rule: f, pasteEvt: p }) => {
    const m = u.tr, g = Ls({
      state: u,
      transaction: m
    });
    if (!(!r6({
      editor: e,
      state: g,
      from: Math.max(d - 1, 0),
      to: h.b - 1,
      rule: f,
      pasteEvent: p,
      dropEvent: a
    }) || !m.steps.length)) {
      try {
        a = typeof DragEvent < "u" ? new DragEvent("drop") : null;
      } catch {
        a = null;
      }
      return s = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, m;
    }
  };
  return t.map((u) => new Ee({
    // we register a global drag handler to track the current drag source element
    view(d) {
      const h = (p) => {
        var m;
        i = !((m = d.dom.parentElement) === null || m === void 0) && m.contains(p.target) ? d.dom.parentElement : null, i && (Gr = e);
      }, f = () => {
        Gr && (Gr = null);
      };
      return window.addEventListener("dragstart", h), window.addEventListener("dragend", f), {
        destroy() {
          window.removeEventListener("dragstart", h), window.removeEventListener("dragend", f);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (d, h) => {
          if (o = i === d.dom.parentElement, a = h, !o) {
            const f = Gr;
            f != null && f.isEditable && setTimeout(() => {
              const p = f.state.selection;
              p && f.commands.deleteRange({ from: p.from, to: p.to });
            }, 10);
          }
          return !1;
        },
        paste: (d, h) => {
          var f;
          const p = (f = h.clipboardData) === null || f === void 0 ? void 0 : f.getData("text/html");
          return s = h, r = !!(p != null && p.includes("data-pm-slice")), !1;
        }
      }
    },
    appendTransaction: (d, h, f) => {
      const p = d[0], m = p.getMeta("uiEvent") === "paste" && !r, g = p.getMeta("uiEvent") === "drop" && !o, k = p.getMeta("applyPasteRules"), x = !!k;
      if (!m && !g && !x)
        return;
      if (x) {
        let { text: v } = k;
        typeof v == "string" ? v = v : v = Is(M.from(v), f.schema);
        const { from: y } = k, w = y + v.length, $ = o6(v);
        return l({
          rule: u,
          state: f,
          from: y,
          to: { b: w },
          pasteEvt: $
        });
      }
      const S = h.doc.content.findDiffStart(f.doc.content), _ = h.doc.content.findDiffEnd(f.doc.content);
      if (!(!t6(S) || !_ || S === _.b))
        return l({
          rule: u,
          state: f,
          from: S,
          to: _,
          pasteEvt: s
        });
    }
  }));
}
function a6(n) {
  const e = n.filter((t, i) => n.indexOf(t) !== i);
  return Array.from(new Set(e));
}
class ei {
  constructor(e, t) {
    this.splittableMarks = [], this.editor = t, this.extensions = ei.resolve(e), this.schema = dp(this.extensions, t), this.setupExtensions();
  }
  /**
   * Returns a flattened and sorted extension list while
   * also checking for duplicated extensions and warns the user.
   * @param extensions An array of Tiptap extensions
   * @returns An flattened and sorted array of Tiptap extensions
   */
  static resolve(e) {
    const t = ei.sort(ei.flatten(e)), i = a6(t.map((r) => r.name));
    return i.length && console.warn(`[tiptap warn]: Duplicate extension names found: [${i.map((r) => `'${r}'`).join(", ")}]. This can lead to issues.`), t;
  }
  /**
   * Create a flattened array of extensions by traversing the `addExtensions` field.
   * @param extensions An array of Tiptap extensions
   * @returns A flattened array of Tiptap extensions
   */
  static flatten(e) {
    return e.map((t) => {
      const i = {
        name: t.name,
        options: t.options,
        storage: t.storage
      }, r = R(t, "addExtensions", i);
      return r ? [t, ...this.flatten(r())] : t;
    }).flat(10);
  }
  /**
   * Sort extensions by priority.
   * @param extensions An array of Tiptap extensions
   * @returns A sorted array of Tiptap extensions by priority
   */
  static sort(e) {
    return e.sort((i, r) => {
      const o = R(i, "priority") || 100, s = R(r, "priority") || 100;
      return o > s ? -1 : o < s ? 1 : 0;
    });
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((e, t) => {
      const i = {
        name: t.name,
        options: t.options,
        storage: t.storage,
        editor: this.editor,
        type: da(t.name, this.schema)
      }, r = R(t, "addCommands", i);
      return r ? {
        ...e,
        ...r()
      } : e;
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor: e } = this, t = ei.sort([...this.extensions].reverse()), i = [], r = [], o = t.map((s) => {
      const a = {
        name: s.name,
        options: s.options,
        storage: s.storage,
        editor: e,
        type: da(s.name, this.schema)
      }, l = [], c = R(s, "addKeyboardShortcuts", a);
      let u = {};
      if (s.type === "mark" && R(s, "exitable", a) && (u.ArrowRight = () => Wt.handleExit({ editor: e, mark: s })), c) {
        const m = Object.fromEntries(Object.entries(c()).map(([g, k]) => [g, () => k({ editor: e })]));
        u = { ...u, ...m };
      }
      const d = TD(u);
      l.push(d);
      const h = R(s, "addInputRules", a);
      Ou(s, e.options.enableInputRules) && h && i.push(...h());
      const f = R(s, "addPasteRules", a);
      Ou(s, e.options.enablePasteRules) && f && r.push(...f());
      const p = R(s, "addProseMirrorPlugins", a);
      if (p) {
        const m = p();
        l.push(...m);
      }
      return l;
    }).flat();
    return [
      QD({
        editor: e,
        rules: i
      }),
      ...s6({
        editor: e,
        rules: r
      }),
      ...o
    ];
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return cp(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor: e } = this, { nodeExtensions: t } = Rs(this.extensions);
    return Object.fromEntries(t.filter((i) => !!R(i, "addNodeView")).map((i) => {
      const r = this.attributes.filter((l) => l.type === i.name), o = {
        name: i.name,
        options: i.options,
        storage: i.storage,
        editor: e,
        type: Pe(i.name, this.schema)
      }, s = R(i, "addNodeView", o);
      if (!s)
        return [];
      const a = (l, c, u, d, h) => {
        const f = Io(l, r);
        return s()({
          // pass-through
          node: l,
          view: c,
          getPos: u,
          decorations: d,
          innerDecorations: h,
          // tiptap-specific
          editor: e,
          extension: i,
          HTMLAttributes: f
        });
      };
      return [i.name, a];
    }));
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    this.extensions.forEach((e) => {
      var t;
      this.editor.extensionStorage[e.name] = e.storage;
      const i = {
        name: e.name,
        options: e.options,
        storage: e.storage,
        editor: this.editor,
        type: da(e.name, this.schema)
      };
      e.type === "mark" && (!((t = ee(R(e, "keepOnSplit", i))) !== null && t !== void 0) || t) && this.splittableMarks.push(e.name);
      const r = R(e, "onBeforeCreate", i), o = R(e, "onCreate", i), s = R(e, "onUpdate", i), a = R(e, "onSelectionUpdate", i), l = R(e, "onTransaction", i), c = R(e, "onFocus", i), u = R(e, "onBlur", i), d = R(e, "onDestroy", i);
      r && this.editor.on("beforeCreate", r), o && this.editor.on("create", o), s && this.editor.on("update", s), a && this.editor.on("selectionUpdate", a), l && this.editor.on("transaction", l), c && this.editor.on("focus", c), u && this.editor.on("blur", u), d && this.editor.on("destroy", d);
    });
  }
}
class Se {
  constructor(e = {}) {
    this.type = "extension", this.name = "extension", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = ee(R(this, "addOptions", {
      name: this.name
    }))), this.storage = ee(R(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new Se(e);
  }
  configure(e = {}) {
    const t = this.extend({
      ...this.config,
      addOptions: () => Ps(this.options, e)
    });
    return t.name = this.name, t.parent = this.parent, t;
  }
  extend(e = {}) {
    const t = new Se({ ...this.config, ...e });
    return t.parent = this, this.child = t, t.name = e.name ? e.name : t.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${t.name}".`), t.options = ee(R(t, "addOptions", {
      name: t.name
    })), t.storage = ee(R(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
}
function hp(n, e, t) {
  const { from: i, to: r } = e, { blockSeparator: o = `

`, textSerializers: s = {} } = t || {};
  let a = "";
  return n.nodesBetween(i, r, (l, c, u, d) => {
    var h;
    l.isBlock && c > i && (a += o);
    const f = s == null ? void 0 : s[l.type.name];
    if (f)
      return u && (a += f({
        node: l,
        pos: c,
        parent: u,
        index: d,
        range: e
      })), !1;
    l.isText && (a += (h = l == null ? void 0 : l.text) === null || h === void 0 ? void 0 : h.slice(Math.max(i, c) - c, r - c));
  }), a;
}
function fp(n) {
  return Object.fromEntries(Object.entries(n.nodes).filter(([, e]) => e.spec.toText).map(([e, t]) => [e, t.spec.toText]));
}
const l6 = Se.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new Ee({
        key: new Ue("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: n } = this, { state: e, schema: t } = n, { doc: i, selection: r } = e, { ranges: o } = r, s = Math.min(...o.map((u) => u.$from.pos)), a = Math.max(...o.map((u) => u.$to.pos)), l = fp(t);
            return hp(i, { from: s, to: a }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: l
            });
          }
        }
      })
    ];
  }
}), c6 = () => ({ editor: n, view: e }) => (requestAnimationFrame(() => {
  var t;
  n.isDestroyed || (e.dom.blur(), (t = window == null ? void 0 : window.getSelection()) === null || t === void 0 || t.removeAllRanges());
}), !0), u6 = (n = !1) => ({ commands: e }) => e.setContent("", n), d6 = () => ({ state: n, tr: e, dispatch: t }) => {
  const { selection: i } = e, { ranges: r } = i;
  return t && r.forEach(({ $from: o, $to: s }) => {
    n.doc.nodesBetween(o.pos, s.pos, (a, l) => {
      if (a.type.isText)
        return;
      const { doc: c, mapping: u } = e, d = c.resolve(u.map(l)), h = c.resolve(u.map(l + a.nodeSize)), f = d.blockRange(h);
      if (!f)
        return;
      const p = Hi(f);
      if (a.type.isTextblock) {
        const { defaultType: m } = d.parent.contentMatchAt(d.index());
        e.setNodeMarkup(f.start, m);
      }
      (p || p === 0) && e.lift(f, p);
    });
  }), !0;
}, h6 = (n) => (e) => n(e), f6 = () => ({ state: n, dispatch: e }) => op(n, e), p6 = (n, e) => ({ editor: t, tr: i }) => {
  const { state: r } = t, o = r.doc.slice(n.from, n.to);
  i.deleteRange(n.from, n.to);
  const s = i.mapping.map(e);
  return i.insert(s, o.content), i.setSelection(new G(i.doc.resolve(Math.max(s - 1, 0)))), !0;
}, m6 = () => ({ tr: n, dispatch: e }) => {
  const { selection: t } = n, i = t.$anchor.node();
  if (i.content.size > 0)
    return !1;
  const r = n.selection.$anchor;
  for (let o = r.depth; o > 0; o -= 1)
    if (r.node(o).type === i.type) {
      if (e) {
        const a = r.before(o), l = r.after(o);
        n.delete(a, l).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, g6 = (n) => ({ tr: e, state: t, dispatch: i }) => {
  const r = Pe(n, t.schema), o = e.selection.$anchor;
  for (let s = o.depth; s > 0; s -= 1)
    if (o.node(s).type === r) {
      if (i) {
        const l = o.before(s), c = o.after(s);
        e.delete(l, c).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, _6 = (n) => ({ tr: e, dispatch: t }) => {
  const { from: i, to: r } = n;
  return t && e.delete(i, r), !0;
}, b6 = () => ({ state: n, dispatch: e }) => Ul(n, e), k6 = () => ({ commands: n }) => n.keyboardShortcut("Enter"), y6 = () => ({ state: n, dispatch: e }) => ND(n, e);
function Po(n, e, t = { strict: !0 }) {
  const i = Object.keys(e);
  return i.length ? i.every((r) => t.strict ? e[r] === n[r] : Gl(e[r]) ? e[r].test(n[r]) : e[r] === n[r]) : !0;
}
function pp(n, e, t = {}) {
  return n.find((i) => i.type === e && Po(
    // Only check equality for the attributes that are provided
    Object.fromEntries(Object.keys(t).map((r) => [r, i.attrs[r]])),
    t
  ));
}
function zu(n, e, t = {}) {
  return !!pp(n, e, t);
}
function Xl(n, e, t) {
  var i;
  if (!n || !e)
    return;
  let r = n.parent.childAfter(n.parentOffset);
  if ((!r.node || !r.node.marks.some((u) => u.type === e)) && (r = n.parent.childBefore(n.parentOffset)), !r.node || !r.node.marks.some((u) => u.type === e) || (t = t || ((i = r.node.marks[0]) === null || i === void 0 ? void 0 : i.attrs), !pp([...r.node.marks], e, t)))
    return;
  let s = r.index, a = n.start() + r.offset, l = s + 1, c = a + r.node.nodeSize;
  for (; s > 0 && zu([...n.parent.child(s - 1).marks], e, t); )
    s -= 1, a -= n.parent.child(s).nodeSize;
  for (; l < n.parent.childCount && zu([...n.parent.child(l).marks], e, t); )
    c += n.parent.child(l).nodeSize, l += 1;
  return {
    from: a,
    to: c
  };
}
function jn(n, e) {
  if (typeof n == "string") {
    if (!e.marks[n])
      throw Error(`There is no mark type named '${n}'. Maybe you forgot to add the extension?`);
    return e.marks[n];
  }
  return n;
}
const v6 = (n, e = {}) => ({ tr: t, state: i, dispatch: r }) => {
  const o = jn(n, i.schema), { doc: s, selection: a } = t, { $from: l, from: c, to: u } = a;
  if (r) {
    const d = Xl(l, o, e);
    if (d && d.from <= c && d.to >= u) {
      const h = G.create(s, d.from, d.to);
      t.setSelection(h);
    }
  }
  return !0;
}, x6 = (n) => (e) => {
  const t = typeof n == "function" ? n(e) : n;
  for (let i = 0; i < t.length; i += 1)
    if (t[i](e))
      return !0;
  return !1;
};
function Ql(n) {
  return n instanceof G;
}
function sn(n = 0, e = 0, t = 0) {
  return Math.min(Math.max(n, e), t);
}
function mp(n, e = null) {
  if (!e)
    return null;
  const t = ne.atStart(n), i = ne.atEnd(n);
  if (e === "start" || e === !0)
    return t;
  if (e === "end")
    return i;
  const r = t.from, o = i.to;
  return e === "all" ? G.create(n, sn(0, r, o), sn(n.content.size, r, o)) : G.create(n, sn(e, r, o), sn(e, r, o));
}
function gp() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
function js() {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
const S6 = (n = null, e = {}) => ({ editor: t, view: i, tr: r, dispatch: o }) => {
  e = {
    scrollIntoView: !0,
    ...e
  };
  const s = () => {
    (js() || gp()) && i.dom.focus(), requestAnimationFrame(() => {
      t.isDestroyed || (i.focus(), e != null && e.scrollIntoView && t.commands.scrollIntoView());
    });
  };
  if (i.hasFocus() && n === null || n === !1)
    return !0;
  if (o && n === null && !Ql(t.state.selection))
    return s(), !0;
  const a = mp(r.doc, n) || t.state.selection, l = t.state.selection.eq(a);
  return o && (l || r.setSelection(a), l && r.storedMarks && r.setStoredMarks(r.storedMarks), s()), !0;
}, w6 = (n, e) => (t) => n.every((i, r) => e(i, { ...t, index: r })), C6 = (n, e) => ({ tr: t, commands: i }) => i.insertContentAt({ from: t.selection.from, to: t.selection.to }, n, e), _p = (n) => {
  const e = n.childNodes;
  for (let t = e.length - 1; t >= 0; t -= 1) {
    const i = e[t];
    i.nodeType === 3 && i.nodeValue && /^(\n\s\s|\n)$/.test(i.nodeValue) ? n.removeChild(i) : i.nodeType === 1 && _p(i);
  }
  return n;
};
function Yr(n) {
  const e = `<body>${n}</body>`, t = new window.DOMParser().parseFromString(e, "text/html").body;
  return _p(t);
}
function wr(n, e, t) {
  if (n instanceof an || n instanceof M)
    return n;
  t = {
    slice: !0,
    parseOptions: {},
    ...t
  };
  const i = typeof n == "object" && n !== null, r = typeof n == "string";
  if (i)
    try {
      if (Array.isArray(n) && n.length > 0)
        return M.fromArray(n.map((a) => e.nodeFromJSON(a)));
      const s = e.nodeFromJSON(n);
      return t.errorOnInvalidContent && s.check(), s;
    } catch (o) {
      if (t.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: o });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", n, "Error:", o), wr("", e, t);
    }
  if (r) {
    if (t.errorOnInvalidContent) {
      let s = !1, a = "";
      const l = new Yh({
        topNode: e.spec.topNode,
        marks: e.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: e.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (c) => (s = !0, a = typeof c == "string" ? c : c.outerHTML, null)
              }
            ]
          }
        })
      });
      if (t.slice ? zn.fromSchema(l).parseSlice(Yr(n), t.parseOptions) : zn.fromSchema(l).parse(Yr(n), t.parseOptions), t.errorOnInvalidContent && s)
        throw new Error("[tiptap error]: Invalid HTML content", { cause: new Error(`Invalid element found: ${a}`) });
    }
    const o = zn.fromSchema(e);
    return t.slice ? o.parseSlice(Yr(n), t.parseOptions).content : o.parse(Yr(n), t.parseOptions);
  }
  return wr("", e, t);
}
function T6(n, e, t) {
  const i = n.steps.length - 1;
  if (i < e)
    return;
  const r = n.steps[i];
  if (!(r instanceof De || r instanceof Re))
    return;
  const o = n.mapping.maps[i];
  let s = 0;
  o.forEach((a, l, c, u) => {
    s === 0 && (s = u);
  }), n.setSelection(ne.near(n.doc.resolve(s), t));
}
const M6 = (n) => !("type" in n), E6 = (n, e, t) => ({ tr: i, dispatch: r, editor: o }) => {
  var s;
  if (r) {
    t = {
      parseOptions: o.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...t
    };
    let a;
    const l = (g) => {
      o.emit("contentError", {
        editor: o,
        error: g,
        disableCollaboration: () => {
          o.storage.collaboration && (o.storage.collaboration.isDisabled = !0);
        }
      });
    }, c = {
      preserveWhitespace: "full",
      ...t.parseOptions
    };
    if (!t.errorOnInvalidContent && !o.options.enableContentCheck && o.options.emitContentError)
      try {
        wr(e, o.schema, {
          parseOptions: c,
          errorOnInvalidContent: !0
        });
      } catch (g) {
        l(g);
      }
    try {
      a = wr(e, o.schema, {
        parseOptions: c,
        errorOnInvalidContent: (s = t.errorOnInvalidContent) !== null && s !== void 0 ? s : o.options.enableContentCheck
      });
    } catch (g) {
      return l(g), !1;
    }
    let { from: u, to: d } = typeof n == "number" ? { from: n, to: n } : { from: n.from, to: n.to }, h = !0, f = !0;
    if ((M6(a) ? a : [a]).forEach((g) => {
      g.check(), h = h ? g.isText && g.marks.length === 0 : !1, f = f ? g.isBlock : !1;
    }), u === d && f) {
      const { parent: g } = i.doc.resolve(u);
      g.isTextblock && !g.type.spec.code && !g.childCount && (u -= 1, d += 1);
    }
    let m;
    if (h) {
      if (Array.isArray(e))
        m = e.map((g) => g.text || "").join("");
      else if (e instanceof M) {
        let g = "";
        e.forEach((k) => {
          k.text && (g += k.text);
        }), m = g;
      } else typeof e == "object" && e && e.text ? m = e.text : m = e;
      i.insertText(m, u, d);
    } else
      m = a, i.replaceWith(u, d, m);
    t.updateSelection && T6(i, i.steps.length - 1, -1), t.applyInputRules && i.setMeta("applyInputRules", { from: u, text: m }), t.applyPasteRules && i.setMeta("applyPasteRules", { from: u, text: m });
  }
  return !0;
}, $6 = () => ({ state: n, dispatch: e }) => OD(n, e), O6 = () => ({ state: n, dispatch: e }) => zD(n, e), z6 = () => ({ state: n, dispatch: e }) => Xf(n, e), A6 = () => ({ state: n, dispatch: e }) => np(n, e), N6 = () => ({ state: n, dispatch: e, tr: t }) => {
  try {
    const i = Es(n.doc, n.selection.$from.pos, -1);
    return i == null ? !1 : (t.join(i, 2), e && e(t), !0);
  } catch {
    return !1;
  }
}, L6 = () => ({ state: n, dispatch: e, tr: t }) => {
  try {
    const i = Es(n.doc, n.selection.$from.pos, 1);
    return i == null ? !1 : (t.join(i, 2), e && e(t), !0);
  } catch {
    return !1;
  }
}, D6 = () => ({ state: n, dispatch: e }) => ED(n, e), R6 = () => ({ state: n, dispatch: e }) => $D(n, e);
function bp() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function I6(n) {
  const e = n.split(/-(?!$)/);
  let t = e[e.length - 1];
  t === "Space" && (t = " ");
  let i, r, o, s;
  for (let a = 0; a < e.length - 1; a += 1) {
    const l = e[a];
    if (/^(cmd|meta|m)$/i.test(l))
      s = !0;
    else if (/^a(lt)?$/i.test(l))
      i = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      r = !0;
    else if (/^s(hift)?$/i.test(l))
      o = !0;
    else if (/^mod$/i.test(l))
      js() || bp() ? s = !0 : r = !0;
    else
      throw new Error(`Unrecognized modifier name: ${l}`);
  }
  return i && (t = `Alt-${t}`), r && (t = `Ctrl-${t}`), s && (t = `Meta-${t}`), o && (t = `Shift-${t}`), t;
}
const P6 = (n) => ({ editor: e, view: t, tr: i, dispatch: r }) => {
  const o = I6(n).split(/-(?!$)/), s = o.find((c) => !["Alt", "Ctrl", "Meta", "Shift"].includes(c)), a = new KeyboardEvent("keydown", {
    key: s === "Space" ? " " : s,
    altKey: o.includes("Alt"),
    ctrlKey: o.includes("Ctrl"),
    metaKey: o.includes("Meta"),
    shiftKey: o.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), l = e.captureTransaction(() => {
    t.someProp("handleKeyDown", (c) => c(t, a));
  });
  return l == null || l.steps.forEach((c) => {
    const u = c.map(i.mapping);
    u && r && i.maybeStep(u);
  }), !0;
};
function Cr(n, e, t = {}) {
  const { from: i, to: r, empty: o } = n.selection, s = e ? Pe(e, n.schema) : null, a = [];
  n.doc.nodesBetween(i, r, (d, h) => {
    if (d.isText)
      return;
    const f = Math.max(i, h), p = Math.min(r, h + d.nodeSize);
    a.push({
      node: d,
      from: f,
      to: p
    });
  });
  const l = r - i, c = a.filter((d) => s ? s.name === d.node.type.name : !0).filter((d) => Po(d.node.attrs, t, { strict: !1 }));
  return o ? !!c.length : c.reduce((d, h) => d + h.to - h.from, 0) >= l;
}
const j6 = (n, e = {}) => ({ state: t, dispatch: i }) => {
  const r = Pe(n, t.schema);
  return Cr(t, r, e) ? AD(t, i) : !1;
}, B6 = () => ({ state: n, dispatch: e }) => sp(n, e), F6 = (n) => ({ state: e, dispatch: t }) => {
  const i = Pe(n, e.schema);
  return VD(i)(e, t);
}, q6 = () => ({ state: n, dispatch: e }) => rp(n, e);
function Bs(n, e) {
  return e.nodes[n] ? "node" : e.marks[n] ? "mark" : null;
}
function Au(n, e) {
  const t = typeof e == "string" ? [e] : e;
  return Object.keys(n).reduce((i, r) => (t.includes(r) || (i[r] = n[r]), i), {});
}
const H6 = (n, e) => ({ tr: t, state: i, dispatch: r }) => {
  let o = null, s = null;
  const a = Bs(typeof n == "string" ? n : n.name, i.schema);
  return a ? (a === "node" && (o = Pe(n, i.schema)), a === "mark" && (s = jn(n, i.schema)), r && t.selection.ranges.forEach((l) => {
    i.doc.nodesBetween(l.$from.pos, l.$to.pos, (c, u) => {
      o && o === c.type && t.setNodeMarkup(u, void 0, Au(c.attrs, e)), s && c.marks.length && c.marks.forEach((d) => {
        s === d.type && t.addMark(u, u + c.nodeSize, s.create(Au(d.attrs, e)));
      });
    });
  }), !0) : !1;
}, V6 = () => ({ tr: n, dispatch: e }) => (e && n.scrollIntoView(), !0), U6 = () => ({ tr: n, dispatch: e }) => {
  if (e) {
    const t = new ot(n.doc);
    n.setSelection(t);
  }
  return !0;
}, W6 = () => ({ state: n, dispatch: e }) => ep(n, e), K6 = () => ({ state: n, dispatch: e }) => ip(n, e), Z6 = () => ({ state: n, dispatch: e }) => RD(n, e), J6 = () => ({ state: n, dispatch: e }) => jD(n, e), G6 = () => ({ state: n, dispatch: e }) => PD(n, e);
function ol(n, e, t = {}, i = {}) {
  return wr(n, e, {
    slice: !1,
    parseOptions: t,
    errorOnInvalidContent: i.errorOnInvalidContent
  });
}
const Y6 = (n, e = !1, t = {}, i = {}) => ({ editor: r, tr: o, dispatch: s, commands: a }) => {
  var l, c;
  const { doc: u } = o;
  if (t.preserveWhitespace !== "full") {
    const d = ol(n, r.schema, t, {
      errorOnInvalidContent: (l = i.errorOnInvalidContent) !== null && l !== void 0 ? l : r.options.enableContentCheck
    });
    return s && o.replaceWith(0, u.content.size, d).setMeta("preventUpdate", !e), !0;
  }
  return s && o.setMeta("preventUpdate", !e), a.insertContentAt({ from: 0, to: u.content.size }, n, {
    parseOptions: t,
    errorOnInvalidContent: (c = i.errorOnInvalidContent) !== null && c !== void 0 ? c : r.options.enableContentCheck
  });
};
function kp(n, e) {
  const t = jn(e, n.schema), { from: i, to: r, empty: o } = n.selection, s = [];
  o ? (n.storedMarks && s.push(...n.storedMarks), s.push(...n.selection.$head.marks())) : n.doc.nodesBetween(i, r, (l) => {
    s.push(...l.marks);
  });
  const a = s.find((l) => l.type.name === t.name);
  return a ? { ...a.attrs } : {};
}
function X6(n, e) {
  const t = new pf(n);
  return e.forEach((i) => {
    i.steps.forEach((r) => {
      t.step(r);
    });
  }), t;
}
function Q6(n) {
  for (let e = 0; e < n.edgeCount; e += 1) {
    const { type: t } = n.edge(e);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
function yp(n, e, t) {
  const i = [];
  return n.nodesBetween(e.from, e.to, (r, o) => {
    t(r) && i.push({
      node: r,
      pos: o
    });
  }), i;
}
function e5(n, e) {
  for (let t = n.depth; t > 0; t -= 1) {
    const i = n.node(t);
    if (e(i))
      return {
        pos: t > 0 ? n.before(t) : 0,
        start: n.start(t),
        depth: t,
        node: i
      };
  }
}
function ec(n) {
  return (e) => e5(e.$from, n);
}
function t5(n, e) {
  const t = ei.resolve(n);
  return dp(t, e);
}
function n5(n, e) {
  const t = t5(e), i = an.fromJSON(t, n);
  return Is(i.content, t);
}
function i5(n, e) {
  const t = {
    from: 0,
    to: n.content.size
  };
  return hp(n, t, e);
}
function r5(n, e) {
  const t = Pe(e, n.schema), { from: i, to: r } = n.selection, o = [];
  n.doc.nodesBetween(i, r, (a) => {
    o.push(a);
  });
  const s = o.reverse().find((a) => a.type.name === t.name);
  return s ? { ...s.attrs } : {};
}
function vp(n, e) {
  const t = Bs(typeof e == "string" ? e : e.name, n.schema);
  return t === "node" ? r5(n, e) : t === "mark" ? kp(n, e) : {};
}
function o5(n, e = JSON.stringify) {
  const t = {};
  return n.filter((i) => {
    const r = e(i);
    return Object.prototype.hasOwnProperty.call(t, r) ? !1 : t[r] = !0;
  });
}
function s5(n) {
  const e = o5(n);
  return e.length === 1 ? e : e.filter((t, i) => !e.filter((o, s) => s !== i).some((o) => t.oldRange.from >= o.oldRange.from && t.oldRange.to <= o.oldRange.to && t.newRange.from >= o.newRange.from && t.newRange.to <= o.newRange.to));
}
function a5(n) {
  const { mapping: e, steps: t } = n, i = [];
  return e.maps.forEach((r, o) => {
    const s = [];
    if (r.ranges.length)
      r.forEach((a, l) => {
        s.push({ from: a, to: l });
      });
    else {
      const { from: a, to: l } = t[o];
      if (a === void 0 || l === void 0)
        return;
      s.push({ from: a, to: l });
    }
    s.forEach(({ from: a, to: l }) => {
      const c = e.slice(o).map(a, -1), u = e.slice(o).map(l), d = e.invert().map(c, -1), h = e.invert().map(u);
      i.push({
        oldRange: {
          from: d,
          to: h
        },
        newRange: {
          from: c,
          to: u
        }
      });
    });
  }), s5(i);
}
function tc(n, e, t) {
  const i = [];
  return n === e ? t.resolve(n).marks().forEach((r) => {
    const o = t.resolve(n), s = Xl(o, r.type);
    s && i.push({
      mark: r,
      ...s
    });
  }) : t.nodesBetween(n, e, (r, o) => {
    !r || (r == null ? void 0 : r.nodeSize) === void 0 || i.push(...r.marks.map((s) => ({
      from: o,
      to: o + r.nodeSize,
      mark: s
    })));
  }), i;
}
function _o(n, e, t) {
  return Object.fromEntries(Object.entries(t).filter(([i]) => {
    const r = n.find((o) => o.type === e && o.name === i);
    return r ? r.attribute.keepOnSplit : !1;
  }));
}
function sl(n, e, t = {}) {
  const { empty: i, ranges: r } = n.selection, o = e ? jn(e, n.schema) : null;
  if (i)
    return !!(n.storedMarks || n.selection.$from.marks()).filter((d) => o ? o.name === d.type.name : !0).find((d) => Po(d.attrs, t, { strict: !1 }));
  let s = 0;
  const a = [];
  if (r.forEach(({ $from: d, $to: h }) => {
    const f = d.pos, p = h.pos;
    n.doc.nodesBetween(f, p, (m, g) => {
      if (!m.isText && !m.marks.length)
        return;
      const k = Math.max(f, g), x = Math.min(p, g + m.nodeSize), S = x - k;
      s += S, a.push(...m.marks.map((_) => ({
        mark: _,
        from: k,
        to: x
      })));
    });
  }), s === 0)
    return !1;
  const l = a.filter((d) => o ? o.name === d.mark.type.name : !0).filter((d) => Po(d.mark.attrs, t, { strict: !1 })).reduce((d, h) => d + h.to - h.from, 0), c = a.filter((d) => o ? d.mark.type !== o && d.mark.type.excludes(o) : !0).reduce((d, h) => d + h.to - h.from, 0);
  return (l > 0 ? l + c : l) >= s;
}
function l5(n, e, t = {}) {
  if (!e)
    return Cr(n, null, t) || sl(n, null, t);
  const i = Bs(e, n.schema);
  return i === "node" ? Cr(n, e, t) : i === "mark" ? sl(n, e, t) : !1;
}
function Nu(n, e) {
  const { nodeExtensions: t } = Rs(e), i = t.find((s) => s.name === n);
  if (!i)
    return !1;
  const r = {
    name: i.name,
    options: i.options,
    storage: i.storage
  }, o = ee(R(i, "group", r));
  return typeof o != "string" ? !1 : o.split(" ").includes("list");
}
function nc(n, { checkChildren: e = !0, ignoreWhitespace: t = !1 } = {}) {
  var i;
  if (t) {
    if (n.type.name === "hardBreak")
      return !0;
    if (n.isText)
      return /^\s*$/m.test((i = n.text) !== null && i !== void 0 ? i : "");
  }
  if (n.isText)
    return !n.text;
  if (n.isAtom || n.isLeaf)
    return !1;
  if (n.content.childCount === 0)
    return !0;
  if (e) {
    let r = !0;
    return n.content.forEach((o) => {
      r !== !1 && (nc(o, { ignoreWhitespace: t, checkChildren: e }) || (r = !1));
    }), r;
  }
  return !1;
}
function c5(n) {
  return n instanceof F;
}
function u5(n, e, t) {
  const r = n.state.doc.content.size, o = sn(e, 0, r), s = sn(t, 0, r), a = n.coordsAtPos(o), l = n.coordsAtPos(s, -1), c = Math.min(a.top, l.top), u = Math.max(a.bottom, l.bottom), d = Math.min(a.left, l.left), h = Math.max(a.right, l.right), f = h - d, p = u - c, k = {
    top: c,
    bottom: u,
    left: d,
    right: h,
    width: f,
    height: p,
    x: d,
    y: c
  };
  return {
    ...k,
    toJSON: () => k
  };
}
function d5(n, e, t) {
  var i;
  const { selection: r } = e;
  let o = null;
  if (Ql(r) && (o = r.$cursor), o) {
    const a = (i = n.storedMarks) !== null && i !== void 0 ? i : o.marks();
    return !!t.isInSet(a) || !a.some((l) => l.type.excludes(t));
  }
  const { ranges: s } = r;
  return s.some(({ $from: a, $to: l }) => {
    let c = a.depth === 0 ? n.doc.inlineContent && n.doc.type.allowsMarkType(t) : !1;
    return n.doc.nodesBetween(a.pos, l.pos, (u, d, h) => {
      if (c)
        return !1;
      if (u.isInline) {
        const f = !h || h.type.allowsMarkType(t), p = !!t.isInSet(u.marks) || !u.marks.some((m) => m.type.excludes(t));
        c = f && p;
      }
      return !c;
    }), c;
  });
}
const h5 = (n, e = {}) => ({ tr: t, state: i, dispatch: r }) => {
  const { selection: o } = t, { empty: s, ranges: a } = o, l = jn(n, i.schema);
  if (r)
    if (s) {
      const c = kp(i, l);
      t.addStoredMark(l.create({
        ...c,
        ...e
      }));
    } else
      a.forEach((c) => {
        const u = c.$from.pos, d = c.$to.pos;
        i.doc.nodesBetween(u, d, (h, f) => {
          const p = Math.max(f, u), m = Math.min(f + h.nodeSize, d);
          h.marks.find((k) => k.type === l) ? h.marks.forEach((k) => {
            l === k.type && t.addMark(p, m, l.create({
              ...k.attrs,
              ...e
            }));
          }) : t.addMark(p, m, l.create(e));
        });
      });
  return d5(i, t, l);
}, f5 = (n, e) => ({ tr: t }) => (t.setMeta(n, e), !0), p5 = (n, e = {}) => ({ state: t, dispatch: i, chain: r }) => {
  const o = Pe(n, t.schema);
  let s;
  return t.selection.$anchor.sameParent(t.selection.$head) && (s = t.selection.$anchor.parent.attrs), o.isTextblock ? r().command(({ commands: a }) => Mu(o, { ...s, ...e })(t) ? !0 : a.clearNodes()).command(({ state: a }) => Mu(o, { ...s, ...e })(a, i)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, m5 = (n) => ({ tr: e, dispatch: t }) => {
  if (t) {
    const { doc: i } = e, r = sn(n, 0, i.content.size), o = F.create(i, r);
    e.setSelection(o);
  }
  return !0;
}, g5 = (n) => ({ tr: e, dispatch: t }) => {
  if (t) {
    const { doc: i } = e, { from: r, to: o } = typeof n == "number" ? { from: n, to: n } : n, s = G.atStart(i).from, a = G.atEnd(i).to, l = sn(r, s, a), c = sn(o, s, a), u = G.create(i, l, c);
    e.setSelection(u);
  }
  return !0;
}, _5 = (n) => ({ state: e, dispatch: t }) => {
  const i = Pe(n, e.schema);
  return KD(i)(e, t);
};
function Lu(n, e) {
  const t = n.storedMarks || n.selection.$to.parentOffset && n.selection.$from.marks();
  if (t) {
    const i = t.filter((r) => e == null ? void 0 : e.includes(r.type.name));
    n.tr.ensureMarks(i);
  }
}
const b5 = ({ keepMarks: n = !0 } = {}) => ({ tr: e, state: t, dispatch: i, editor: r }) => {
  const { selection: o, doc: s } = e, { $from: a, $to: l } = o, c = r.extensionManager.attributes, u = _o(c, a.node().type.name, a.node().attrs);
  if (o instanceof F && o.node.isBlock)
    return !a.parentOffset || !ln(s, a.pos) ? !1 : (i && (n && Lu(t, r.extensionManager.splittableMarks), e.split(a.pos).scrollIntoView()), !0);
  if (!a.parent.isBlock)
    return !1;
  const d = l.parentOffset === l.parent.content.size, h = a.depth === 0 ? void 0 : Q6(a.node(-1).contentMatchAt(a.indexAfter(-1)));
  let f = d && h ? [
    {
      type: h,
      attrs: u
    }
  ] : void 0, p = ln(e.doc, e.mapping.map(a.pos), 1, f);
  if (!f && !p && ln(e.doc, e.mapping.map(a.pos), 1, h ? [{ type: h }] : void 0) && (p = !0, f = h ? [
    {
      type: h,
      attrs: u
    }
  ] : void 0), i) {
    if (p && (o instanceof G && e.deleteSelection(), e.split(e.mapping.map(a.pos), 1, f), h && !d && !a.parentOffset && a.parent.type !== h)) {
      const m = e.mapping.map(a.before()), g = e.doc.resolve(m);
      a.node(-1).canReplaceWith(g.index(), g.index() + 1, h) && e.setNodeMarkup(e.mapping.map(a.before()), h);
    }
    n && Lu(t, r.extensionManager.splittableMarks), e.scrollIntoView();
  }
  return p;
}, k5 = (n, e = {}) => ({ tr: t, state: i, dispatch: r, editor: o }) => {
  var s;
  const a = Pe(n, i.schema), { $from: l, $to: c } = i.selection, u = i.selection.node;
  if (u && u.isBlock || l.depth < 2 || !l.sameParent(c))
    return !1;
  const d = l.node(-1);
  if (d.type !== a)
    return !1;
  const h = o.extensionManager.attributes;
  if (l.parent.content.size === 0 && l.node(-1).childCount === l.indexAfter(-1)) {
    if (l.depth === 2 || l.node(-3).type !== a || l.index(-2) !== l.node(-2).childCount - 1)
      return !1;
    if (r) {
      let k = M.empty;
      const x = l.index(-1) ? 1 : l.index(-2) ? 2 : 3;
      for (let $ = l.depth - x; $ >= l.depth - 3; $ -= 1)
        k = M.from(l.node($).copy(k));
      const S = l.indexAfter(-1) < l.node(-2).childCount ? 1 : l.indexAfter(-2) < l.node(-3).childCount ? 2 : 3, _ = {
        ..._o(h, l.node().type.name, l.node().attrs),
        ...e
      }, v = ((s = a.contentMatch.defaultType) === null || s === void 0 ? void 0 : s.createAndFill(_)) || void 0;
      k = k.append(M.from(a.createAndFill(null, v) || void 0));
      const y = l.before(l.depth - (x - 1));
      t.replace(y, l.after(-S), new L(k, 4 - x, 0));
      let w = -1;
      t.doc.nodesBetween(y, t.doc.content.size, ($, A) => {
        if (w > -1)
          return !1;
        $.isTextblock && $.content.size === 0 && (w = A + 1);
      }), w > -1 && t.setSelection(G.near(t.doc.resolve(w))), t.scrollIntoView();
    }
    return !0;
  }
  const f = c.pos === l.end() ? d.contentMatchAt(0).defaultType : null, p = {
    ..._o(h, d.type.name, d.attrs),
    ...e
  }, m = {
    ..._o(h, l.node().type.name, l.node().attrs),
    ...e
  };
  t.delete(l.pos, c.pos);
  const g = f ? [
    { type: a, attrs: p },
    { type: f, attrs: m }
  ] : [{ type: a, attrs: p }];
  if (!ln(t.doc, l.pos, 2))
    return !1;
  if (r) {
    const { selection: k, storedMarks: x } = i, { splittableMarks: S } = o.extensionManager, _ = x || k.$to.parentOffset && k.$from.marks();
    if (t.split(l.pos, 2, g).scrollIntoView(), !_ || !r)
      return !0;
    const v = _.filter((y) => S.includes(y.type.name));
    t.ensureMarks(v);
  }
  return !0;
}, ha = (n, e) => {
  const t = ec((s) => s.type === e)(n.selection);
  if (!t)
    return !0;
  const i = n.doc.resolve(Math.max(0, t.pos - 1)).before(t.depth);
  if (i === void 0)
    return !0;
  const r = n.doc.nodeAt(i);
  return t.node.type === (r == null ? void 0 : r.type) && In(n.doc, t.pos) && n.join(t.pos), !0;
}, fa = (n, e) => {
  const t = ec((s) => s.type === e)(n.selection);
  if (!t)
    return !0;
  const i = n.doc.resolve(t.start).after(t.depth);
  if (i === void 0)
    return !0;
  const r = n.doc.nodeAt(i);
  return t.node.type === (r == null ? void 0 : r.type) && In(n.doc, i) && n.join(i), !0;
}, y5 = (n, e, t, i = {}) => ({ editor: r, tr: o, state: s, dispatch: a, chain: l, commands: c, can: u }) => {
  const { extensions: d, splittableMarks: h } = r.extensionManager, f = Pe(n, s.schema), p = Pe(e, s.schema), { selection: m, storedMarks: g } = s, { $from: k, $to: x } = m, S = k.blockRange(x), _ = g || m.$to.parentOffset && m.$from.marks();
  if (!S)
    return !1;
  const v = ec((y) => Nu(y.type.name, d))(m);
  if (S.depth >= 1 && v && S.depth - v.depth <= 1) {
    if (v.node.type === f)
      return c.liftListItem(p);
    if (Nu(v.node.type.name, d) && f.validContent(v.node.content) && a)
      return l().command(() => (o.setNodeMarkup(v.pos, f), !0)).command(() => ha(o, f)).command(() => fa(o, f)).run();
  }
  return !t || !_ || !a ? l().command(() => u().wrapInList(f, i) ? !0 : c.clearNodes()).wrapInList(f, i).command(() => ha(o, f)).command(() => fa(o, f)).run() : l().command(() => {
    const y = u().wrapInList(f, i), w = _.filter(($) => h.includes($.type.name));
    return o.ensureMarks(w), y ? !0 : c.clearNodes();
  }).wrapInList(f, i).command(() => ha(o, f)).command(() => fa(o, f)).run();
}, v5 = (n, e = {}, t = {}) => ({ state: i, commands: r }) => {
  const { extendEmptyMarkRange: o = !1 } = t, s = jn(n, i.schema);
  return sl(i, s, e) ? r.unsetMark(s, { extendEmptyMarkRange: o }) : r.setMark(s, e);
}, x5 = (n, e, t = {}) => ({ state: i, commands: r }) => {
  const o = Pe(n, i.schema), s = Pe(e, i.schema), a = Cr(i, o, t);
  let l;
  return i.selection.$anchor.sameParent(i.selection.$head) && (l = i.selection.$anchor.parent.attrs), a ? r.setNode(s, l) : r.setNode(o, { ...l, ...t });
}, S5 = (n, e = {}) => ({ state: t, commands: i }) => {
  const r = Pe(n, t.schema);
  return Cr(t, r, e) ? i.lift(r) : i.wrapIn(r, e);
}, w5 = () => ({ state: n, dispatch: e }) => {
  const t = n.plugins;
  for (let i = 0; i < t.length; i += 1) {
    const r = t[i];
    let o;
    if (r.spec.isInputRules && (o = r.getState(n))) {
      if (e) {
        const s = n.tr, a = o.transform;
        for (let l = a.steps.length - 1; l >= 0; l -= 1)
          s.step(a.steps[l].invert(a.docs[l]));
        if (o.text) {
          const l = s.doc.resolve(o.from).marks();
          s.replaceWith(o.from, o.to, n.schema.text(o.text, l));
        } else
          s.delete(o.from, o.to);
      }
      return !0;
    }
  }
  return !1;
}, C5 = () => ({ tr: n, dispatch: e }) => {
  const { selection: t } = n, { empty: i, ranges: r } = t;
  return i || e && r.forEach((o) => {
    n.removeMark(o.$from.pos, o.$to.pos);
  }), !0;
}, T5 = (n, e = {}) => ({ tr: t, state: i, dispatch: r }) => {
  var o;
  const { extendEmptyMarkRange: s = !1 } = e, { selection: a } = t, l = jn(n, i.schema), { $from: c, empty: u, ranges: d } = a;
  if (!r)
    return !0;
  if (u && s) {
    let { from: h, to: f } = a;
    const p = (o = c.marks().find((g) => g.type === l)) === null || o === void 0 ? void 0 : o.attrs, m = Xl(c, l, p);
    m && (h = m.from, f = m.to), t.removeMark(h, f, l);
  } else
    d.forEach((h) => {
      t.removeMark(h.$from.pos, h.$to.pos, l);
    });
  return t.removeStoredMark(l), !0;
}, M5 = (n, e = {}) => ({ tr: t, state: i, dispatch: r }) => {
  let o = null, s = null;
  const a = Bs(typeof n == "string" ? n : n.name, i.schema);
  return a ? (a === "node" && (o = Pe(n, i.schema)), a === "mark" && (s = jn(n, i.schema)), r && t.selection.ranges.forEach((l) => {
    const c = l.$from.pos, u = l.$to.pos;
    let d, h, f, p;
    t.selection.empty ? i.doc.nodesBetween(c, u, (m, g) => {
      o && o === m.type && (f = Math.max(g, c), p = Math.min(g + m.nodeSize, u), d = g, h = m);
    }) : i.doc.nodesBetween(c, u, (m, g) => {
      g < c && o && o === m.type && (f = Math.max(g, c), p = Math.min(g + m.nodeSize, u), d = g, h = m), g >= c && g <= u && (o && o === m.type && t.setNodeMarkup(g, void 0, {
        ...m.attrs,
        ...e
      }), s && m.marks.length && m.marks.forEach((k) => {
        if (s === k.type) {
          const x = Math.max(g, c), S = Math.min(g + m.nodeSize, u);
          t.addMark(x, S, s.create({
            ...k.attrs,
            ...e
          }));
        }
      }));
    }), h && (d !== void 0 && t.setNodeMarkup(d, void 0, {
      ...h.attrs,
      ...e
    }), s && h.marks.length && h.marks.forEach((m) => {
      s === m.type && t.addMark(f, p, s.create({
        ...m.attrs,
        ...e
      }));
    }));
  }), !0) : !1;
}, E5 = (n, e = {}) => ({ state: t, dispatch: i }) => {
  const r = Pe(n, t.schema);
  return BD(r, e)(t, i);
}, $5 = (n, e = {}) => ({ state: t, dispatch: i }) => {
  const r = Pe(n, t.schema);
  return FD(r, e)(t, i);
};
var O5 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blur: c6,
  clearContent: u6,
  clearNodes: d6,
  command: h6,
  createParagraphNear: f6,
  cut: p6,
  deleteCurrentNode: m6,
  deleteNode: g6,
  deleteRange: _6,
  deleteSelection: b6,
  enter: k6,
  exitCode: y6,
  extendMarkRange: v6,
  first: x6,
  focus: S6,
  forEach: w6,
  insertContent: C6,
  insertContentAt: E6,
  joinBackward: z6,
  joinDown: O6,
  joinForward: A6,
  joinItemBackward: N6,
  joinItemForward: L6,
  joinTextblockBackward: D6,
  joinTextblockForward: R6,
  joinUp: $6,
  keyboardShortcut: P6,
  lift: j6,
  liftEmptyBlock: B6,
  liftListItem: F6,
  newlineInCode: q6,
  resetAttributes: H6,
  scrollIntoView: V6,
  selectAll: U6,
  selectNodeBackward: W6,
  selectNodeForward: K6,
  selectParentNode: Z6,
  selectTextblockEnd: J6,
  selectTextblockStart: G6,
  setContent: Y6,
  setMark: h5,
  setMeta: f5,
  setNode: p5,
  setNodeSelection: m5,
  setTextSelection: g5,
  sinkListItem: _5,
  splitBlock: b5,
  splitListItem: k5,
  toggleList: y5,
  toggleMark: v5,
  toggleNode: x5,
  toggleWrap: S5,
  undoInputRule: w5,
  unsetAllMarks: C5,
  unsetMark: T5,
  updateAttributes: M5,
  wrapIn: E5,
  wrapInList: $5
});
const z5 = Se.create({
  name: "commands",
  addCommands() {
    return {
      ...O5
    };
  }
}), A5 = Se.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new Ee({
        key: new Ue("tiptapDrop"),
        props: {
          handleDrop: (n, e, t, i) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: e,
              slice: t,
              moved: i
            });
          }
        }
      })
    ];
  }
}), N5 = Se.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new Ee({
        key: new Ue("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), L5 = new Ue("focusEvents"), D5 = Se.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: n } = this;
    return [
      new Ee({
        key: L5,
        props: {
          handleDOMEvents: {
            focus: (e, t) => {
              n.isFocused = !0;
              const i = n.state.tr.setMeta("focus", { event: t }).setMeta("addToHistory", !1);
              return e.dispatch(i), !1;
            },
            blur: (e, t) => {
              n.isFocused = !1;
              const i = n.state.tr.setMeta("blur", { event: t }).setMeta("addToHistory", !1);
              return e.dispatch(i), !1;
            }
          }
        }
      })
    ];
  }
}), R5 = Se.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const n = () => this.editor.commands.first(({ commands: s }) => [
      () => s.undoInputRule(),
      // maybe convert first text block node to default node
      () => s.command(({ tr: a }) => {
        const { selection: l, doc: c } = a, { empty: u, $anchor: d } = l, { pos: h, parent: f } = d, p = d.parent.isTextblock && h > 0 ? a.doc.resolve(h - 1) : d, m = p.parent.type.spec.isolating, g = d.pos - d.parentOffset, k = m && p.parent.childCount === 1 ? g === d.pos : ne.atStart(c).from === h;
        return !u || !f.type.isTextblock || f.textContent.length || !k || k && d.parent.type.name === "paragraph" ? !1 : s.clearNodes();
      }),
      () => s.deleteSelection(),
      () => s.joinBackward(),
      () => s.selectNodeBackward()
    ]), e = () => this.editor.commands.first(({ commands: s }) => [
      () => s.deleteSelection(),
      () => s.deleteCurrentNode(),
      () => s.joinForward(),
      () => s.selectNodeForward()
    ]), i = {
      Enter: () => this.editor.commands.first(({ commands: s }) => [
        () => s.newlineInCode(),
        () => s.createParagraphNear(),
        () => s.liftEmptyBlock(),
        () => s.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: n,
      "Mod-Backspace": n,
      "Shift-Backspace": n,
      Delete: e,
      "Mod-Delete": e,
      "Mod-a": () => this.editor.commands.selectAll()
    }, r = {
      ...i
    }, o = {
      ...i,
      "Ctrl-h": n,
      "Alt-Backspace": n,
      "Ctrl-d": e,
      "Ctrl-Alt-Backspace": e,
      "Alt-Delete": e,
      "Alt-d": e,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return js() || bp() ? o : r;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new Ee({
        key: new Ue("clearDocument"),
        appendTransaction: (n, e, t) => {
          if (n.some((m) => m.getMeta("composition")))
            return;
          const i = n.some((m) => m.docChanged) && !e.doc.eq(t.doc), r = n.some((m) => m.getMeta("preventClearDocument"));
          if (!i || r)
            return;
          const { empty: o, from: s, to: a } = e.selection, l = ne.atStart(e.doc).from, c = ne.atEnd(e.doc).to;
          if (o || !(s === l && a === c) || !nc(t.doc))
            return;
          const h = t.tr, f = Ls({
            state: t,
            transaction: h
          }), { commands: p } = new Ds({
            editor: this.editor,
            state: f
          });
          if (p.clearNodes(), !!h.steps.length)
            return h;
        }
      })
    ];
  }
}), I5 = Se.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new Ee({
        key: new Ue("tiptapPaste"),
        props: {
          handlePaste: (n, e, t) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: e,
              slice: t
            });
          }
        }
      })
    ];
  }
}), P5 = Se.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new Ee({
        key: new Ue("tabindex"),
        props: {
          attributes: () => this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
});
class Yn {
  get name() {
    return this.node.type.name;
  }
  constructor(e, t, i = !1, r = null) {
    this.currentNode = null, this.actualDepth = null, this.isBlock = i, this.resolvedPos = e, this.editor = t, this.currentNode = r;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var e;
    return (e = this.actualDepth) !== null && e !== void 0 ? e : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(e) {
    let t = this.from, i = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      t = this.from + 1, i = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: t, to: i }, e);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0)
      return null;
    const e = this.resolvedPos.start(this.resolvedPos.depth - 1), t = this.resolvedPos.doc.resolve(e);
    return new Yn(t, this.editor);
  }
  get before() {
    let e = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.from - 3)), new Yn(e, this.editor);
  }
  get after() {
    let e = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.to + 3)), new Yn(e, this.editor);
  }
  get children() {
    const e = [];
    return this.node.content.forEach((t, i) => {
      const r = t.isBlock && !t.isTextblock, o = t.isAtom && !t.isText, s = this.pos + i + (o ? 0 : 1);
      if (s < 0 || s > this.resolvedPos.doc.nodeSize - 2)
        return;
      const a = this.resolvedPos.doc.resolve(s);
      if (!r && a.depth <= this.depth)
        return;
      const l = new Yn(a, this.editor, r, r ? t : null);
      r && (l.actualDepth = this.depth + 1), e.push(new Yn(a, this.editor, r, r ? t : null));
    }), e;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const e = this.children;
    return e[e.length - 1] || null;
  }
  closest(e, t = {}) {
    let i = null, r = this.parent;
    for (; r && !i; ) {
      if (r.node.type.name === e)
        if (Object.keys(t).length > 0) {
          const o = r.node.attrs, s = Object.keys(t);
          for (let a = 0; a < s.length; a += 1) {
            const l = s[a];
            if (o[l] !== t[l])
              break;
          }
        } else
          i = r;
      r = r.parent;
    }
    return i;
  }
  querySelector(e, t = {}) {
    return this.querySelectorAll(e, t, !0)[0] || null;
  }
  querySelectorAll(e, t = {}, i = !1) {
    let r = [];
    if (!this.children || this.children.length === 0)
      return r;
    const o = Object.keys(t);
    return this.children.forEach((s) => {
      i && r.length > 0 || (s.node.type.name === e && o.every((l) => t[l] === s.node.attrs[l]) && r.push(s), !(i && r.length > 0) && (r = r.concat(s.querySelectorAll(e, t, i))));
    }), r;
  }
  setAttribute(e) {
    const { tr: t } = this.editor.state;
    t.setNodeMarkup(this.from, void 0, {
      ...this.node.attrs,
      ...e
    }), this.editor.view.dispatch(t);
  }
}
const j5 = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.tippy-box[data-animation=fade][data-state=hidden] {
  opacity: 0
}`;
function B5(n, e, t) {
  const i = document.querySelector("style[data-tiptap-style]");
  if (i !== null)
    return i;
  const r = document.createElement("style");
  return e && r.setAttribute("nonce", e), r.setAttribute("data-tiptap-style", ""), r.innerHTML = n, document.getElementsByTagName("head")[0].appendChild(r), r;
}
class F5 extends ZD {
  constructor(e = {}) {
    super(), this.isFocused = !1, this.isInitialized = !1, this.extensionStorage = {}, this.options = {
      element: document.createElement("div"),
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      enableContentCheck: !1,
      emitContentError: !1,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null,
      onContentError: ({ error: t }) => {
        throw t;
      },
      onPaste: () => null,
      onDrop: () => null
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.setOptions(e), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.on("contentError", this.options.onContentError), this.createView(), this.injectCSS(), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), this.on("drop", ({ event: t, slice: i, moved: r }) => this.options.onDrop(t, i, r)), this.on("paste", ({ event: t, slice: i }) => this.options.onPaste(t, i)), window.setTimeout(() => {
      this.isDestroyed || (this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }), this.isInitialized = !0);
    }, 0);
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    this.options.injectCSS && document && (this.css = B5(j5, this.options.injectNonce));
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(e = {}) {
    this.options = {
      ...this.options,
      ...e
    }, !(!this.view || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(e, t = !0) {
    this.setOptions({ editable: e }), t && this.emit("update", { editor: this, transaction: this.state.tr });
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.view.state;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   * @returns The new editor state
   */
  registerPlugin(e, t) {
    const i = up(t) ? t(e, [...this.state.plugins]) : [...this.state.plugins, e], r = this.state.reconfigure({ plugins: i });
    return this.view.updateState(r), r;
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKeyToRemove The plugins name
   * @returns The new editor state or undefined if the editor is destroyed
   */
  unregisterPlugin(e) {
    if (this.isDestroyed)
      return;
    const t = this.state.plugins;
    let i = t;
    if ([].concat(e).forEach((o) => {
      const s = typeof o == "string" ? `${o}$` : o.key;
      i = i.filter((a) => !a.key.startsWith(s));
    }), t.length === i.length)
      return;
    const r = this.state.reconfigure({
      plugins: i
    });
    return this.view.updateState(r), r;
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var e, t;
    const r = [...this.options.enableCoreExtensions ? [
      N5,
      l6.configure({
        blockSeparator: (t = (e = this.options.coreExtensionOptions) === null || e === void 0 ? void 0 : e.clipboardTextSerializer) === null || t === void 0 ? void 0 : t.blockSeparator
      }),
      z5,
      D5,
      R5,
      P5,
      A5,
      I5
    ].filter((o) => typeof this.options.enableCoreExtensions == "object" ? this.options.enableCoreExtensions[o.name] !== !1 : !0) : [], ...this.options.extensions].filter((o) => ["extension", "node", "mark"].includes(o == null ? void 0 : o.type));
    this.extensionManager = new ei(r, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new Ds({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView() {
    var e;
    let t;
    try {
      t = ol(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: this.options.enableContentCheck });
    } catch (s) {
      if (!(s instanceof Error) || !["[tiptap error]: Invalid JSON content", "[tiptap error]: Invalid HTML content"].includes(s.message))
        throw s;
      this.emit("contentError", {
        editor: this,
        error: s,
        disableCollaboration: () => {
          this.storage.collaboration && (this.storage.collaboration.isDisabled = !0), this.options.extensions = this.options.extensions.filter((a) => a.name !== "collaboration"), this.createExtensionManager();
        }
      }), t = ol(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: !1 });
    }
    const i = mp(t, this.options.autofocus);
    this.view = new Gf(this.options.element, {
      ...this.options.editorProps,
      attributes: {
        // add `role="textbox"` to the editor element
        role: "textbox",
        ...(e = this.options.editorProps) === null || e === void 0 ? void 0 : e.attributes
      },
      dispatchTransaction: this.dispatchTransaction.bind(this),
      state: Oi.create({
        doc: t,
        selection: i || void 0
      })
    });
    const r = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(r), this.createNodeViews(), this.prependClass();
    const o = this.view.dom;
    o.editor = this;
  }
  /**
   * Creates all node views.
   */
  createNodeViews() {
    this.view.isDestroyed || this.view.setProps({
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `tiptap ${this.view.dom.className}`;
  }
  captureTransaction(e) {
    this.isCapturingTransaction = !0, e(), this.isCapturingTransaction = !1;
    const t = this.capturedTransaction;
    return this.capturedTransaction = null, t;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(e) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = e;
        return;
      }
      e.steps.forEach((s) => {
        var a;
        return (a = this.capturedTransaction) === null || a === void 0 ? void 0 : a.step(s);
      });
      return;
    }
    const t = this.state.apply(e), i = !this.state.selection.eq(t.selection);
    this.emit("beforeTransaction", {
      editor: this,
      transaction: e,
      nextState: t
    }), this.view.updateState(t), this.emit("transaction", {
      editor: this,
      transaction: e
    }), i && this.emit("selectionUpdate", {
      editor: this,
      transaction: e
    });
    const r = e.getMeta("focus"), o = e.getMeta("blur");
    r && this.emit("focus", {
      editor: this,
      event: r.event,
      transaction: e
    }), o && this.emit("blur", {
      editor: this,
      event: o.event,
      transaction: e
    }), !(!e.docChanged || e.getMeta("preventUpdate")) && this.emit("update", {
      editor: this,
      transaction: e
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(e) {
    return vp(this.state, e);
  }
  isActive(e, t) {
    const i = typeof e == "string" ? e : null, r = typeof e == "string" ? t : e;
    return l5(this.state, i, r);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return Is(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(e) {
    const { blockSeparator: t = `

`, textSerializers: i = {} } = e || {};
    return i5(this.state.doc, {
      blockSeparator: t,
      textSerializers: {
        ...fp(this.schema),
        ...i
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return nc(this.state.doc);
  }
  /**
   * Get the number of characters for the current document.
   *
   * @deprecated
   */
  getCharacterCount() {
    return console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.'), this.state.doc.content.size - 2;
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    if (this.emit("destroy"), this.view) {
      const e = this.view.dom;
      e && e.editor && delete e.editor, this.view.destroy();
    }
    this.removeAllListeners();
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var e;
    return !(!((e = this.view) === null || e === void 0) && e.docView);
  }
  $node(e, t) {
    var i;
    return ((i = this.$doc) === null || i === void 0 ? void 0 : i.querySelector(e, t)) || null;
  }
  $nodes(e, t) {
    var i;
    return ((i = this.$doc) === null || i === void 0 ? void 0 : i.querySelectorAll(e, t)) || null;
  }
  $pos(e) {
    const t = this.state.doc.resolve(e);
    return new Yn(t, this);
  }
  get $doc() {
    return this.$pos(0);
  }
}
function Tr(n) {
  return new Yl({
    find: n.find,
    handler: ({ state: e, range: t, match: i }) => {
      const r = ee(n.getAttributes, void 0, i);
      if (r === !1 || r === null)
        return null;
      const { tr: o } = e, s = i[i.length - 1], a = i[0];
      if (s) {
        const l = a.search(/\S/), c = t.from + a.indexOf(s), u = c + s.length;
        if (tc(t.from, t.to, e.doc).filter((f) => f.mark.type.excluded.find((m) => m === n.type && m !== f.mark.type)).filter((f) => f.to > c).length)
          return null;
        u < t.to && o.delete(u, t.to), c > t.from && o.delete(t.from + l, c);
        const h = t.from + l + s.length;
        o.addMark(t.from + l, h, n.type.create(r || {})), o.removeStoredMark(n.type);
      }
    }
  });
}
function q5(n) {
  return new Yl({
    find: n.find,
    handler: ({ state: e, range: t, match: i }) => {
      const r = e.doc.resolve(t.from), o = ee(n.getAttributes, void 0, i) || {};
      if (!r.node(-1).canReplaceWith(r.index(-1), r.indexAfter(-1), n.type))
        return null;
      e.tr.delete(t.from, t.to).setBlockType(t.from, t.from, n.type, o);
    }
  });
}
function jo(n) {
  return new Yl({
    find: n.find,
    handler: ({ state: e, range: t, match: i, chain: r }) => {
      const o = ee(n.getAttributes, void 0, i) || {}, s = e.tr.delete(t.from, t.to), l = s.doc.resolve(t.from).blockRange(), c = l && Ll(l, n.type, o);
      if (!c)
        return null;
      if (s.wrap(l, c), n.keepMarks && n.editor) {
        const { selection: d, storedMarks: h } = e, { splittableMarks: f } = n.editor.extensionManager, p = h || d.$to.parentOffset && d.$from.marks();
        if (p) {
          const m = p.filter((g) => f.includes(g.type.name));
          s.ensureMarks(m);
        }
      }
      if (n.keepAttributes) {
        const d = n.type.name === "bulletList" || n.type.name === "orderedList" ? "listItem" : "taskList";
        r().updateAttributes(d, o).run();
      }
      const u = s.doc.resolve(t.from - 1).nodeBefore;
      u && u.type === n.type && In(s.doc, t.from - 1) && (!n.joinPredicate || n.joinPredicate(i, u)) && s.join(t.from - 1);
    }
  });
}
class St {
  constructor(e = {}) {
    this.type = "node", this.name = "node", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = ee(R(this, "addOptions", {
      name: this.name
    }))), this.storage = ee(R(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new St(e);
  }
  configure(e = {}) {
    const t = this.extend({
      ...this.config,
      addOptions: () => Ps(this.options, e)
    });
    return t.name = this.name, t.parent = this.parent, t;
  }
  extend(e = {}) {
    const t = new St(e);
    return t.parent = this, this.child = t, t.name = e.name ? e.name : t.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${t.name}".`), t.options = ee(R(t, "addOptions", {
      name: t.name
    })), t.storage = ee(R(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
}
class H5 {
  constructor(e, t, i) {
    this.isDragging = !1, this.component = e, this.editor = t.editor, this.options = {
      stopEvent: null,
      ignoreMutation: null,
      ...i
    }, this.extension = t.extension, this.node = t.node, this.decorations = t.decorations, this.innerDecorations = t.innerDecorations, this.view = t.view, this.HTMLAttributes = t.HTMLAttributes, this.getPos = t.getPos, this.mount();
  }
  mount() {
  }
  get dom() {
    return this.editor.view.dom;
  }
  get contentDOM() {
    return null;
  }
  onDragStart(e) {
    var t, i, r, o, s, a, l;
    const { view: c } = this.editor, u = e.target, d = u.nodeType === 3 ? (t = u.parentElement) === null || t === void 0 ? void 0 : t.closest("[data-drag-handle]") : u.closest("[data-drag-handle]");
    if (!this.dom || !((i = this.contentDOM) === null || i === void 0) && i.contains(u) || !d)
      return;
    let h = 0, f = 0;
    if (this.dom !== d) {
      const x = this.dom.getBoundingClientRect(), S = d.getBoundingClientRect(), _ = (r = e.offsetX) !== null && r !== void 0 ? r : (o = e.nativeEvent) === null || o === void 0 ? void 0 : o.offsetX, v = (s = e.offsetY) !== null && s !== void 0 ? s : (a = e.nativeEvent) === null || a === void 0 ? void 0 : a.offsetY;
      h = S.x - x.x + _, f = S.y - x.y + v;
    }
    const p = this.dom.cloneNode(!0);
    (l = e.dataTransfer) === null || l === void 0 || l.setDragImage(p, h, f);
    const m = this.getPos();
    if (typeof m != "number")
      return;
    const g = F.create(c.state.doc, m), k = c.state.tr.setSelection(g);
    c.dispatch(k);
  }
  stopEvent(e) {
    var t;
    if (!this.dom)
      return !1;
    if (typeof this.options.stopEvent == "function")
      return this.options.stopEvent({ event: e });
    const i = e.target;
    if (!(this.dom.contains(i) && !(!((t = this.contentDOM) === null || t === void 0) && t.contains(i))))
      return !1;
    const o = e.type.startsWith("drag"), s = e.type === "drop";
    if ((["INPUT", "BUTTON", "SELECT", "TEXTAREA"].includes(i.tagName) || i.isContentEditable) && !s && !o)
      return !0;
    const { isEditable: l } = this.editor, { isDragging: c } = this, u = !!this.node.type.spec.draggable, d = F.isSelectable(this.node), h = e.type === "copy", f = e.type === "paste", p = e.type === "cut", m = e.type === "mousedown";
    if (!u && d && o && e.target === this.dom && e.preventDefault(), u && o && !c && e.target === this.dom)
      return e.preventDefault(), !1;
    if (u && l && !c && m) {
      const g = i.closest("[data-drag-handle]");
      g && (this.dom === g || this.dom.contains(g)) && (this.isDragging = !0, document.addEventListener("dragend", () => {
        this.isDragging = !1;
      }, { once: !0 }), document.addEventListener("drop", () => {
        this.isDragging = !1;
      }, { once: !0 }), document.addEventListener("mouseup", () => {
        this.isDragging = !1;
      }, { once: !0 }));
    }
    return !(c || s || h || f || p || m && d);
  }
  /**
   * Called when a DOM [mutation](https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver) or a selection change happens within the view.
   * @return `false` if the editor should re-read the selection or re-parse the range around the mutation
   * @return `true` if it can safely be ignored.
   */
  ignoreMutation(e) {
    return !this.dom || !this.contentDOM ? !0 : typeof this.options.ignoreMutation == "function" ? this.options.ignoreMutation({ mutation: e }) : this.node.isLeaf || this.node.isAtom ? !0 : e.type === "selection" || this.dom.contains(e.target) && e.type === "childList" && (js() || gp()) && this.editor.isFocused && [
      ...Array.from(e.addedNodes),
      ...Array.from(e.removedNodes)
    ].every((i) => i.isContentEditable) ? !1 : this.contentDOM === e.target && e.type === "attributes" ? !0 : !this.contentDOM.contains(e.target);
  }
  /**
   * Update the attributes of the prosemirror node.
   */
  updateAttributes(e) {
    this.editor.commands.command(({ tr: t }) => {
      const i = this.getPos();
      return typeof i != "number" ? !1 : (t.setNodeMarkup(i, void 0, {
        ...this.node.attrs,
        ...e
      }), !0);
    });
  }
  /**
   * Delete the node.
   */
  deleteNode() {
    const e = this.getPos();
    if (typeof e != "number")
      return;
    const t = e + this.node.nodeSize;
    this.editor.commands.deleteRange({ from: e, to: t });
  }
}
function Ii(n) {
  return new n6({
    find: n.find,
    handler: ({ state: e, range: t, match: i, pasteEvent: r }) => {
      const o = ee(n.getAttributes, void 0, i, r);
      if (o === !1 || o === null)
        return null;
      const { tr: s } = e, a = i[i.length - 1], l = i[0];
      let c = t.to;
      if (a) {
        const u = l.search(/\S/), d = t.from + l.indexOf(a), h = d + a.length;
        if (tc(t.from, t.to, e.doc).filter((p) => p.mark.type.excluded.find((g) => g === n.type && g !== p.mark.type)).filter((p) => p.to > d).length)
          return null;
        h < t.to && s.delete(h, t.to), d > t.from && s.delete(t.from + u, d), c = t.from + u + a.length, s.addMark(t.from + u, c, n.type.create(o || {})), s.removeStoredMark(n.type);
      }
    }
  });
}
class V5 {
  constructor(e) {
    this.transaction = e, this.currentStep = this.transaction.steps.length;
  }
  map(e) {
    let t = !1;
    return {
      position: this.transaction.steps.slice(this.currentStep).reduce((r, o) => {
        const s = o.getMap().mapResult(r);
        return s.deleted && (t = !0), s.pos;
      }, e),
      deleted: t
    };
  }
}
var at = "top", wt = "bottom", Ct = "right", lt = "left", ic = "auto", jr = [at, wt, Ct, lt], Pi = "start", Mr = "end", U5 = "clippingParents", xp = "viewport", Ui = "popper", W5 = "reference", Du = /* @__PURE__ */ jr.reduce(function(n, e) {
  return n.concat([e + "-" + Pi, e + "-" + Mr]);
}, []), Sp = /* @__PURE__ */ [].concat(jr, [ic]).reduce(function(n, e) {
  return n.concat([e, e + "-" + Pi, e + "-" + Mr]);
}, []), K5 = "beforeRead", Z5 = "read", J5 = "afterRead", G5 = "beforeMain", Y5 = "main", X5 = "afterMain", Q5 = "beforeWrite", e9 = "write", t9 = "afterWrite", n9 = [K5, Z5, J5, G5, Y5, X5, Q5, e9, t9];
function Kt(n) {
  return n ? (n.nodeName || "").toLowerCase() : null;
}
function ht(n) {
  if (n == null)
    return window;
  if (n.toString() !== "[object Window]") {
    var e = n.ownerDocument;
    return e && e.defaultView || window;
  }
  return n;
}
function hi(n) {
  var e = ht(n).Element;
  return n instanceof e || n instanceof Element;
}
function xt(n) {
  var e = ht(n).HTMLElement;
  return n instanceof e || n instanceof HTMLElement;
}
function rc(n) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = ht(n).ShadowRoot;
  return n instanceof e || n instanceof ShadowRoot;
}
function i9(n) {
  var e = n.state;
  Object.keys(e.elements).forEach(function(t) {
    var i = e.styles[t] || {}, r = e.attributes[t] || {}, o = e.elements[t];
    !xt(o) || !Kt(o) || (Object.assign(o.style, i), Object.keys(r).forEach(function(s) {
      var a = r[s];
      a === !1 ? o.removeAttribute(s) : o.setAttribute(s, a === !0 ? "" : a);
    }));
  });
}
function r9(n) {
  var e = n.state, t = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, t.popper), e.styles = t, e.elements.arrow && Object.assign(e.elements.arrow.style, t.arrow), function() {
    Object.keys(e.elements).forEach(function(i) {
      var r = e.elements[i], o = e.attributes[i] || {}, s = Object.keys(e.styles.hasOwnProperty(i) ? e.styles[i] : t[i]), a = s.reduce(function(l, c) {
        return l[c] = "", l;
      }, {});
      !xt(r) || !Kt(r) || (Object.assign(r.style, a), Object.keys(o).forEach(function(l) {
        r.removeAttribute(l);
      }));
    });
  };
}
const wp = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: i9,
  effect: r9,
  requires: ["computeStyles"]
};
function qt(n) {
  return n.split("-")[0];
}
var si = Math.max, Bo = Math.min, ji = Math.round;
function al() {
  var n = navigator.userAgentData;
  return n != null && n.brands && Array.isArray(n.brands) ? n.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function Cp() {
  return !/^((?!chrome|android).)*safari/i.test(al());
}
function Bi(n, e, t) {
  e === void 0 && (e = !1), t === void 0 && (t = !1);
  var i = n.getBoundingClientRect(), r = 1, o = 1;
  e && xt(n) && (r = n.offsetWidth > 0 && ji(i.width) / n.offsetWidth || 1, o = n.offsetHeight > 0 && ji(i.height) / n.offsetHeight || 1);
  var s = hi(n) ? ht(n) : window, a = s.visualViewport, l = !Cp() && t, c = (i.left + (l && a ? a.offsetLeft : 0)) / r, u = (i.top + (l && a ? a.offsetTop : 0)) / o, d = i.width / r, h = i.height / o;
  return {
    width: d,
    height: h,
    top: u,
    right: c + d,
    bottom: u + h,
    left: c,
    x: c,
    y: u
  };
}
function oc(n) {
  var e = Bi(n), t = n.offsetWidth, i = n.offsetHeight;
  return Math.abs(e.width - t) <= 1 && (t = e.width), Math.abs(e.height - i) <= 1 && (i = e.height), {
    x: n.offsetLeft,
    y: n.offsetTop,
    width: t,
    height: i
  };
}
function Tp(n, e) {
  var t = e.getRootNode && e.getRootNode();
  if (n.contains(e))
    return !0;
  if (t && rc(t)) {
    var i = e;
    do {
      if (i && n.isSameNode(i))
        return !0;
      i = i.parentNode || i.host;
    } while (i);
  }
  return !1;
}
function hn(n) {
  return ht(n).getComputedStyle(n);
}
function o9(n) {
  return ["table", "td", "th"].indexOf(Kt(n)) >= 0;
}
function Bn(n) {
  return ((hi(n) ? n.ownerDocument : (
    // $FlowFixMe[prop-missing]
    n.document
  )) || window.document).documentElement;
}
function Fs(n) {
  return Kt(n) === "html" ? n : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    n.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    n.parentNode || // DOM Element detected
    (rc(n) ? n.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Bn(n)
  );
}
function Ru(n) {
  return !xt(n) || // https://github.com/popperjs/popper-core/issues/837
  hn(n).position === "fixed" ? null : n.offsetParent;
}
function s9(n) {
  var e = /firefox/i.test(al()), t = /Trident/i.test(al());
  if (t && xt(n)) {
    var i = hn(n);
    if (i.position === "fixed")
      return null;
  }
  var r = Fs(n);
  for (rc(r) && (r = r.host); xt(r) && ["html", "body"].indexOf(Kt(r)) < 0; ) {
    var o = hn(r);
    if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || e && o.willChange === "filter" || e && o.filter && o.filter !== "none")
      return r;
    r = r.parentNode;
  }
  return null;
}
function Br(n) {
  for (var e = ht(n), t = Ru(n); t && o9(t) && hn(t).position === "static"; )
    t = Ru(t);
  return t && (Kt(t) === "html" || Kt(t) === "body" && hn(t).position === "static") ? e : t || s9(n) || e;
}
function sc(n) {
  return ["top", "bottom"].indexOf(n) >= 0 ? "x" : "y";
}
function ir(n, e, t) {
  return si(n, Bo(e, t));
}
function a9(n, e, t) {
  var i = ir(n, e, t);
  return i > t ? t : i;
}
function Mp() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Ep(n) {
  return Object.assign({}, Mp(), n);
}
function $p(n, e) {
  return e.reduce(function(t, i) {
    return t[i] = n, t;
  }, {});
}
var l9 = function(e, t) {
  return e = typeof e == "function" ? e(Object.assign({}, t.rects, {
    placement: t.placement
  })) : e, Ep(typeof e != "number" ? e : $p(e, jr));
};
function c9(n) {
  var e, t = n.state, i = n.name, r = n.options, o = t.elements.arrow, s = t.modifiersData.popperOffsets, a = qt(t.placement), l = sc(a), c = [lt, Ct].indexOf(a) >= 0, u = c ? "height" : "width";
  if (!(!o || !s)) {
    var d = l9(r.padding, t), h = oc(o), f = l === "y" ? at : lt, p = l === "y" ? wt : Ct, m = t.rects.reference[u] + t.rects.reference[l] - s[l] - t.rects.popper[u], g = s[l] - t.rects.reference[l], k = Br(o), x = k ? l === "y" ? k.clientHeight || 0 : k.clientWidth || 0 : 0, S = m / 2 - g / 2, _ = d[f], v = x - h[u] - d[p], y = x / 2 - h[u] / 2 + S, w = ir(_, y, v), $ = l;
    t.modifiersData[i] = (e = {}, e[$] = w, e.centerOffset = w - y, e);
  }
}
function u9(n) {
  var e = n.state, t = n.options, i = t.element, r = i === void 0 ? "[data-popper-arrow]" : i;
  r != null && (typeof r == "string" && (r = e.elements.popper.querySelector(r), !r) || Tp(e.elements.popper, r) && (e.elements.arrow = r));
}
const d9 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: c9,
  effect: u9,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Fi(n) {
  return n.split("-")[1];
}
var h9 = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function f9(n, e) {
  var t = n.x, i = n.y, r = e.devicePixelRatio || 1;
  return {
    x: ji(t * r) / r || 0,
    y: ji(i * r) / r || 0
  };
}
function Iu(n) {
  var e, t = n.popper, i = n.popperRect, r = n.placement, o = n.variation, s = n.offsets, a = n.position, l = n.gpuAcceleration, c = n.adaptive, u = n.roundOffsets, d = n.isFixed, h = s.x, f = h === void 0 ? 0 : h, p = s.y, m = p === void 0 ? 0 : p, g = typeof u == "function" ? u({
    x: f,
    y: m
  }) : {
    x: f,
    y: m
  };
  f = g.x, m = g.y;
  var k = s.hasOwnProperty("x"), x = s.hasOwnProperty("y"), S = lt, _ = at, v = window;
  if (c) {
    var y = Br(t), w = "clientHeight", $ = "clientWidth";
    if (y === ht(t) && (y = Bn(t), hn(y).position !== "static" && a === "absolute" && (w = "scrollHeight", $ = "scrollWidth")), y = y, r === at || (r === lt || r === Ct) && o === Mr) {
      _ = wt;
      var A = d && y === v && v.visualViewport ? v.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        y[w]
      );
      m -= A - i.height, m *= l ? 1 : -1;
    }
    if (r === lt || (r === at || r === wt) && o === Mr) {
      S = Ct;
      var z = d && y === v && v.visualViewport ? v.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        y[$]
      );
      f -= z - i.width, f *= l ? 1 : -1;
    }
  }
  var N = Object.assign({
    position: a
  }, c && h9), D = u === !0 ? f9({
    x: f,
    y: m
  }, ht(t)) : {
    x: f,
    y: m
  };
  if (f = D.x, m = D.y, l) {
    var j;
    return Object.assign({}, N, (j = {}, j[_] = x ? "0" : "", j[S] = k ? "0" : "", j.transform = (v.devicePixelRatio || 1) <= 1 ? "translate(" + f + "px, " + m + "px)" : "translate3d(" + f + "px, " + m + "px, 0)", j));
  }
  return Object.assign({}, N, (e = {}, e[_] = x ? m + "px" : "", e[S] = k ? f + "px" : "", e.transform = "", e));
}
function p9(n) {
  var e = n.state, t = n.options, i = t.gpuAcceleration, r = i === void 0 ? !0 : i, o = t.adaptive, s = o === void 0 ? !0 : o, a = t.roundOffsets, l = a === void 0 ? !0 : a, c = {
    placement: qt(e.placement),
    variation: Fi(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: r,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, Iu(Object.assign({}, c, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: s,
    roundOffsets: l
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, Iu(Object.assign({}, c, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const m9 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: p9,
  data: {}
};
var Xr = {
  passive: !0
};
function g9(n) {
  var e = n.state, t = n.instance, i = n.options, r = i.scroll, o = r === void 0 ? !0 : r, s = i.resize, a = s === void 0 ? !0 : s, l = ht(e.elements.popper), c = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return o && c.forEach(function(u) {
    u.addEventListener("scroll", t.update, Xr);
  }), a && l.addEventListener("resize", t.update, Xr), function() {
    o && c.forEach(function(u) {
      u.removeEventListener("scroll", t.update, Xr);
    }), a && l.removeEventListener("resize", t.update, Xr);
  };
}
const _9 = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: g9,
  data: {}
};
var b9 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function bo(n) {
  return n.replace(/left|right|bottom|top/g, function(e) {
    return b9[e];
  });
}
var k9 = {
  start: "end",
  end: "start"
};
function Pu(n) {
  return n.replace(/start|end/g, function(e) {
    return k9[e];
  });
}
function ac(n) {
  var e = ht(n), t = e.pageXOffset, i = e.pageYOffset;
  return {
    scrollLeft: t,
    scrollTop: i
  };
}
function lc(n) {
  return Bi(Bn(n)).left + ac(n).scrollLeft;
}
function y9(n, e) {
  var t = ht(n), i = Bn(n), r = t.visualViewport, o = i.clientWidth, s = i.clientHeight, a = 0, l = 0;
  if (r) {
    o = r.width, s = r.height;
    var c = Cp();
    (c || !c && e === "fixed") && (a = r.offsetLeft, l = r.offsetTop);
  }
  return {
    width: o,
    height: s,
    x: a + lc(n),
    y: l
  };
}
function v9(n) {
  var e, t = Bn(n), i = ac(n), r = (e = n.ownerDocument) == null ? void 0 : e.body, o = si(t.scrollWidth, t.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0), s = si(t.scrollHeight, t.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0), a = -i.scrollLeft + lc(n), l = -i.scrollTop;
  return hn(r || t).direction === "rtl" && (a += si(t.clientWidth, r ? r.clientWidth : 0) - o), {
    width: o,
    height: s,
    x: a,
    y: l
  };
}
function cc(n) {
  var e = hn(n), t = e.overflow, i = e.overflowX, r = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(t + r + i);
}
function Op(n) {
  return ["html", "body", "#document"].indexOf(Kt(n)) >= 0 ? n.ownerDocument.body : xt(n) && cc(n) ? n : Op(Fs(n));
}
function rr(n, e) {
  var t;
  e === void 0 && (e = []);
  var i = Op(n), r = i === ((t = n.ownerDocument) == null ? void 0 : t.body), o = ht(i), s = r ? [o].concat(o.visualViewport || [], cc(i) ? i : []) : i, a = e.concat(s);
  return r ? a : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    a.concat(rr(Fs(s)))
  );
}
function ll(n) {
  return Object.assign({}, n, {
    left: n.x,
    top: n.y,
    right: n.x + n.width,
    bottom: n.y + n.height
  });
}
function x9(n, e) {
  var t = Bi(n, !1, e === "fixed");
  return t.top = t.top + n.clientTop, t.left = t.left + n.clientLeft, t.bottom = t.top + n.clientHeight, t.right = t.left + n.clientWidth, t.width = n.clientWidth, t.height = n.clientHeight, t.x = t.left, t.y = t.top, t;
}
function ju(n, e, t) {
  return e === xp ? ll(y9(n, t)) : hi(e) ? x9(e, t) : ll(v9(Bn(n)));
}
function S9(n) {
  var e = rr(Fs(n)), t = ["absolute", "fixed"].indexOf(hn(n).position) >= 0, i = t && xt(n) ? Br(n) : n;
  return hi(i) ? e.filter(function(r) {
    return hi(r) && Tp(r, i) && Kt(r) !== "body";
  }) : [];
}
function w9(n, e, t, i) {
  var r = e === "clippingParents" ? S9(n) : [].concat(e), o = [].concat(r, [t]), s = o[0], a = o.reduce(function(l, c) {
    var u = ju(n, c, i);
    return l.top = si(u.top, l.top), l.right = Bo(u.right, l.right), l.bottom = Bo(u.bottom, l.bottom), l.left = si(u.left, l.left), l;
  }, ju(n, s, i));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function zp(n) {
  var e = n.reference, t = n.element, i = n.placement, r = i ? qt(i) : null, o = i ? Fi(i) : null, s = e.x + e.width / 2 - t.width / 2, a = e.y + e.height / 2 - t.height / 2, l;
  switch (r) {
    case at:
      l = {
        x: s,
        y: e.y - t.height
      };
      break;
    case wt:
      l = {
        x: s,
        y: e.y + e.height
      };
      break;
    case Ct:
      l = {
        x: e.x + e.width,
        y: a
      };
      break;
    case lt:
      l = {
        x: e.x - t.width,
        y: a
      };
      break;
    default:
      l = {
        x: e.x,
        y: e.y
      };
  }
  var c = r ? sc(r) : null;
  if (c != null) {
    var u = c === "y" ? "height" : "width";
    switch (o) {
      case Pi:
        l[c] = l[c] - (e[u] / 2 - t[u] / 2);
        break;
      case Mr:
        l[c] = l[c] + (e[u] / 2 - t[u] / 2);
        break;
    }
  }
  return l;
}
function Er(n, e) {
  e === void 0 && (e = {});
  var t = e, i = t.placement, r = i === void 0 ? n.placement : i, o = t.strategy, s = o === void 0 ? n.strategy : o, a = t.boundary, l = a === void 0 ? U5 : a, c = t.rootBoundary, u = c === void 0 ? xp : c, d = t.elementContext, h = d === void 0 ? Ui : d, f = t.altBoundary, p = f === void 0 ? !1 : f, m = t.padding, g = m === void 0 ? 0 : m, k = Ep(typeof g != "number" ? g : $p(g, jr)), x = h === Ui ? W5 : Ui, S = n.rects.popper, _ = n.elements[p ? x : h], v = w9(hi(_) ? _ : _.contextElement || Bn(n.elements.popper), l, u, s), y = Bi(n.elements.reference), w = zp({
    reference: y,
    element: S,
    placement: r
  }), $ = ll(Object.assign({}, S, w)), A = h === Ui ? $ : y, z = {
    top: v.top - A.top + k.top,
    bottom: A.bottom - v.bottom + k.bottom,
    left: v.left - A.left + k.left,
    right: A.right - v.right + k.right
  }, N = n.modifiersData.offset;
  if (h === Ui && N) {
    var D = N[r];
    Object.keys(z).forEach(function(j) {
      var U = [Ct, wt].indexOf(j) >= 0 ? 1 : -1, Y = [at, wt].indexOf(j) >= 0 ? "y" : "x";
      z[j] += D[Y] * U;
    });
  }
  return z;
}
function C9(n, e) {
  e === void 0 && (e = {});
  var t = e, i = t.placement, r = t.boundary, o = t.rootBoundary, s = t.padding, a = t.flipVariations, l = t.allowedAutoPlacements, c = l === void 0 ? Sp : l, u = Fi(i), d = u ? a ? Du : Du.filter(function(p) {
    return Fi(p) === u;
  }) : jr, h = d.filter(function(p) {
    return c.indexOf(p) >= 0;
  });
  h.length === 0 && (h = d);
  var f = h.reduce(function(p, m) {
    return p[m] = Er(n, {
      placement: m,
      boundary: r,
      rootBoundary: o,
      padding: s
    })[qt(m)], p;
  }, {});
  return Object.keys(f).sort(function(p, m) {
    return f[p] - f[m];
  });
}
function T9(n) {
  if (qt(n) === ic)
    return [];
  var e = bo(n);
  return [Pu(n), e, Pu(e)];
}
function M9(n) {
  var e = n.state, t = n.options, i = n.name;
  if (!e.modifiersData[i]._skip) {
    for (var r = t.mainAxis, o = r === void 0 ? !0 : r, s = t.altAxis, a = s === void 0 ? !0 : s, l = t.fallbackPlacements, c = t.padding, u = t.boundary, d = t.rootBoundary, h = t.altBoundary, f = t.flipVariations, p = f === void 0 ? !0 : f, m = t.allowedAutoPlacements, g = e.options.placement, k = qt(g), x = k === g, S = l || (x || !p ? [bo(g)] : T9(g)), _ = [g].concat(S).reduce(function($e, we) {
      return $e.concat(qt(we) === ic ? C9(e, {
        placement: we,
        boundary: u,
        rootBoundary: d,
        padding: c,
        flipVariations: p,
        allowedAutoPlacements: m
      }) : we);
    }, []), v = e.rects.reference, y = e.rects.popper, w = /* @__PURE__ */ new Map(), $ = !0, A = _[0], z = 0; z < _.length; z++) {
      var N = _[z], D = qt(N), j = Fi(N) === Pi, U = [at, wt].indexOf(D) >= 0, Y = U ? "width" : "height", B = Er(e, {
        placement: N,
        boundary: u,
        rootBoundary: d,
        altBoundary: h,
        padding: c
      }), K = U ? j ? Ct : lt : j ? wt : at;
      v[Y] > y[Y] && (K = bo(K));
      var V = bo(K), pe = [];
      if (o && pe.push(B[D] <= 0), a && pe.push(B[K] <= 0, B[V] <= 0), pe.every(function($e) {
        return $e;
      })) {
        A = N, $ = !1;
        break;
      }
      w.set(N, pe);
    }
    if ($)
      for (var me = p ? 3 : 1, Z = function(we) {
        var Oe = _.find(function(re) {
          var be = w.get(re);
          if (be)
            return be.slice(0, we).every(function(je) {
              return je;
            });
        });
        if (Oe)
          return A = Oe, "break";
      }, Q = me; Q > 0; Q--) {
        var X = Z(Q);
        if (X === "break") break;
      }
    e.placement !== A && (e.modifiersData[i]._skip = !0, e.placement = A, e.reset = !0);
  }
}
const E9 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: M9,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Bu(n, e, t) {
  return t === void 0 && (t = {
    x: 0,
    y: 0
  }), {
    top: n.top - e.height - t.y,
    right: n.right - e.width + t.x,
    bottom: n.bottom - e.height + t.y,
    left: n.left - e.width - t.x
  };
}
function Fu(n) {
  return [at, Ct, wt, lt].some(function(e) {
    return n[e] >= 0;
  });
}
function $9(n) {
  var e = n.state, t = n.name, i = e.rects.reference, r = e.rects.popper, o = e.modifiersData.preventOverflow, s = Er(e, {
    elementContext: "reference"
  }), a = Er(e, {
    altBoundary: !0
  }), l = Bu(s, i), c = Bu(a, r, o), u = Fu(l), d = Fu(c);
  e.modifiersData[t] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: c,
    isReferenceHidden: u,
    hasPopperEscaped: d
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": d
  });
}
const O9 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: $9
};
function z9(n, e, t) {
  var i = qt(n), r = [lt, at].indexOf(i) >= 0 ? -1 : 1, o = typeof t == "function" ? t(Object.assign({}, e, {
    placement: n
  })) : t, s = o[0], a = o[1];
  return s = s || 0, a = (a || 0) * r, [lt, Ct].indexOf(i) >= 0 ? {
    x: a,
    y: s
  } : {
    x: s,
    y: a
  };
}
function A9(n) {
  var e = n.state, t = n.options, i = n.name, r = t.offset, o = r === void 0 ? [0, 0] : r, s = Sp.reduce(function(u, d) {
    return u[d] = z9(d, e.rects, o), u;
  }, {}), a = s[e.placement], l = a.x, c = a.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += l, e.modifiersData.popperOffsets.y += c), e.modifiersData[i] = s;
}
const N9 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: A9
};
function L9(n) {
  var e = n.state, t = n.name;
  e.modifiersData[t] = zp({
    reference: e.rects.reference,
    element: e.rects.popper,
    placement: e.placement
  });
}
const D9 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: L9,
  data: {}
};
function R9(n) {
  return n === "x" ? "y" : "x";
}
function I9(n) {
  var e = n.state, t = n.options, i = n.name, r = t.mainAxis, o = r === void 0 ? !0 : r, s = t.altAxis, a = s === void 0 ? !1 : s, l = t.boundary, c = t.rootBoundary, u = t.altBoundary, d = t.padding, h = t.tether, f = h === void 0 ? !0 : h, p = t.tetherOffset, m = p === void 0 ? 0 : p, g = Er(e, {
    boundary: l,
    rootBoundary: c,
    padding: d,
    altBoundary: u
  }), k = qt(e.placement), x = Fi(e.placement), S = !x, _ = sc(k), v = R9(_), y = e.modifiersData.popperOffsets, w = e.rects.reference, $ = e.rects.popper, A = typeof m == "function" ? m(Object.assign({}, e.rects, {
    placement: e.placement
  })) : m, z = typeof A == "number" ? {
    mainAxis: A,
    altAxis: A
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, A), N = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, D = {
    x: 0,
    y: 0
  };
  if (y) {
    if (o) {
      var j, U = _ === "y" ? at : lt, Y = _ === "y" ? wt : Ct, B = _ === "y" ? "height" : "width", K = y[_], V = K + g[U], pe = K - g[Y], me = f ? -$[B] / 2 : 0, Z = x === Pi ? w[B] : $[B], Q = x === Pi ? -$[B] : -w[B], X = e.elements.arrow, $e = f && X ? oc(X) : {
        width: 0,
        height: 0
      }, we = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : Mp(), Oe = we[U], re = we[Y], be = ir(0, w[B], $e[B]), je = S ? w[B] / 2 - me - be - Oe - z.mainAxis : Z - be - Oe - z.mainAxis, it = S ? -w[B] / 2 + me + be + re + z.mainAxis : Q + be + re + z.mainAxis, Jt = e.elements.arrow && Br(e.elements.arrow), Fn = Jt ? _ === "y" ? Jt.clientTop || 0 : Jt.clientLeft || 0 : 0, pn = (j = N == null ? void 0 : N[_]) != null ? j : 0, qn = K + je - pn - Fn, Hn = K + it - pn, mn = ir(f ? Bo(V, qn) : V, K, f ? si(pe, Hn) : pe);
      y[_] = mn, D[_] = mn - K;
    }
    if (a) {
      var gn, Ot = _ === "x" ? at : lt, Ye = _ === "x" ? wt : Ct, oe = y[v], Xe = v === "y" ? "height" : "width", zt = oe + g[Ot], ct = oe - g[Ye], At = [at, lt].indexOf(k) !== -1, _n = (gn = N == null ? void 0 : N[v]) != null ? gn : 0, bn = At ? zt : oe - w[Xe] - $[Xe] - _n + z.altAxis, pi = At ? oe + w[Xe] + $[Xe] - _n - z.altAxis : ct, Vn = f && At ? a9(bn, oe, pi) : ir(f ? bn : zt, oe, f ? pi : ct);
      y[v] = Vn, D[v] = Vn - oe;
    }
    e.modifiersData[i] = D;
  }
}
const P9 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: I9,
  requiresIfExists: ["offset"]
};
function j9(n) {
  return {
    scrollLeft: n.scrollLeft,
    scrollTop: n.scrollTop
  };
}
function B9(n) {
  return n === ht(n) || !xt(n) ? ac(n) : j9(n);
}
function F9(n) {
  var e = n.getBoundingClientRect(), t = ji(e.width) / n.offsetWidth || 1, i = ji(e.height) / n.offsetHeight || 1;
  return t !== 1 || i !== 1;
}
function q9(n, e, t) {
  t === void 0 && (t = !1);
  var i = xt(e), r = xt(e) && F9(e), o = Bn(e), s = Bi(n, r, t), a = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (i || !i && !t) && ((Kt(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  cc(o)) && (a = B9(e)), xt(e) ? (l = Bi(e, !0), l.x += e.clientLeft, l.y += e.clientTop) : o && (l.x = lc(o))), {
    x: s.left + a.scrollLeft - l.x,
    y: s.top + a.scrollTop - l.y,
    width: s.width,
    height: s.height
  };
}
function H9(n) {
  var e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Set(), i = [];
  n.forEach(function(o) {
    e.set(o.name, o);
  });
  function r(o) {
    t.add(o.name);
    var s = [].concat(o.requires || [], o.requiresIfExists || []);
    s.forEach(function(a) {
      if (!t.has(a)) {
        var l = e.get(a);
        l && r(l);
      }
    }), i.push(o);
  }
  return n.forEach(function(o) {
    t.has(o.name) || r(o);
  }), i;
}
function V9(n) {
  var e = H9(n);
  return n9.reduce(function(t, i) {
    return t.concat(e.filter(function(r) {
      return r.phase === i;
    }));
  }, []);
}
function U9(n) {
  var e;
  return function() {
    return e || (e = new Promise(function(t) {
      Promise.resolve().then(function() {
        e = void 0, t(n());
      });
    })), e;
  };
}
function W9(n) {
  var e = n.reduce(function(t, i) {
    var r = t[i.name];
    return t[i.name] = r ? Object.assign({}, r, i, {
      options: Object.assign({}, r.options, i.options),
      data: Object.assign({}, r.data, i.data)
    }) : i, t;
  }, {});
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}
var qu = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Hu() {
  for (var n = arguments.length, e = new Array(n), t = 0; t < n; t++)
    e[t] = arguments[t];
  return !e.some(function(i) {
    return !(i && typeof i.getBoundingClientRect == "function");
  });
}
function K9(n) {
  n === void 0 && (n = {});
  var e = n, t = e.defaultModifiers, i = t === void 0 ? [] : t, r = e.defaultOptions, o = r === void 0 ? qu : r;
  return function(a, l, c) {
    c === void 0 && (c = o);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, qu, o),
      modifiersData: {},
      elements: {
        reference: a,
        popper: l
      },
      attributes: {},
      styles: {}
    }, d = [], h = !1, f = {
      state: u,
      setOptions: function(k) {
        var x = typeof k == "function" ? k(u.options) : k;
        m(), u.options = Object.assign({}, o, u.options, x), u.scrollParents = {
          reference: hi(a) ? rr(a) : a.contextElement ? rr(a.contextElement) : [],
          popper: rr(l)
        };
        var S = V9(W9([].concat(i, u.options.modifiers)));
        return u.orderedModifiers = S.filter(function(_) {
          return _.enabled;
        }), p(), f.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!h) {
          var k = u.elements, x = k.reference, S = k.popper;
          if (Hu(x, S)) {
            u.rects = {
              reference: q9(x, Br(S), u.options.strategy === "fixed"),
              popper: oc(S)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(z) {
              return u.modifiersData[z.name] = Object.assign({}, z.data);
            });
            for (var _ = 0; _ < u.orderedModifiers.length; _++) {
              if (u.reset === !0) {
                u.reset = !1, _ = -1;
                continue;
              }
              var v = u.orderedModifiers[_], y = v.fn, w = v.options, $ = w === void 0 ? {} : w, A = v.name;
              typeof y == "function" && (u = y({
                state: u,
                options: $,
                name: A,
                instance: f
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: U9(function() {
        return new Promise(function(g) {
          f.forceUpdate(), g(u);
        });
      }),
      destroy: function() {
        m(), h = !0;
      }
    };
    if (!Hu(a, l))
      return f;
    f.setOptions(c).then(function(g) {
      !h && c.onFirstUpdate && c.onFirstUpdate(g);
    });
    function p() {
      u.orderedModifiers.forEach(function(g) {
        var k = g.name, x = g.options, S = x === void 0 ? {} : x, _ = g.effect;
        if (typeof _ == "function") {
          var v = _({
            state: u,
            name: k,
            instance: f,
            options: S
          }), y = function() {
          };
          d.push(v || y);
        }
      });
    }
    function m() {
      d.forEach(function(g) {
        return g();
      }), d = [];
    }
    return f;
  };
}
var Z9 = [_9, D9, m9, wp, N9, E9, P9, d9, O9], J9 = /* @__PURE__ */ K9({
  defaultModifiers: Z9
}), G9 = "tippy-box", Ap = "tippy-content", Y9 = "tippy-backdrop", Np = "tippy-arrow", Lp = "tippy-svg-arrow", Zn = {
  passive: !0,
  capture: !0
}, Dp = function() {
  return document.body;
};
function X9(n, e) {
  return {}.hasOwnProperty.call(n, e);
}
function pa(n, e, t) {
  if (Array.isArray(n)) {
    var i = n[e];
    return i ?? (Array.isArray(t) ? t[e] : t);
  }
  return n;
}
function uc(n, e) {
  var t = {}.toString.call(n);
  return t.indexOf("[object") === 0 && t.indexOf(e + "]") > -1;
}
function Rp(n, e) {
  return typeof n == "function" ? n.apply(void 0, e) : n;
}
function Vu(n, e) {
  if (e === 0)
    return n;
  var t;
  return function(i) {
    clearTimeout(t), t = setTimeout(function() {
      n(i);
    }, e);
  };
}
function Q9(n, e) {
  var t = Object.assign({}, n);
  return e.forEach(function(i) {
    delete t[i];
  }), t;
}
function e4(n) {
  return n.split(/\s+/).filter(Boolean);
}
function Ei(n) {
  return [].concat(n);
}
function Uu(n, e) {
  n.indexOf(e) === -1 && n.push(e);
}
function t4(n) {
  return n.filter(function(e, t) {
    return n.indexOf(e) === t;
  });
}
function n4(n) {
  return n.split("-")[0];
}
function Fo(n) {
  return [].slice.call(n);
}
function Wu(n) {
  return Object.keys(n).reduce(function(e, t) {
    return n[t] !== void 0 && (e[t] = n[t]), e;
  }, {});
}
function or() {
  return document.createElement("div");
}
function $r(n) {
  return ["Element", "Fragment"].some(function(e) {
    return uc(n, e);
  });
}
function i4(n) {
  return uc(n, "NodeList");
}
function r4(n) {
  return uc(n, "MouseEvent");
}
function o4(n) {
  return !!(n && n._tippy && n._tippy.reference === n);
}
function s4(n) {
  return $r(n) ? [n] : i4(n) ? Fo(n) : Array.isArray(n) ? n : Fo(document.querySelectorAll(n));
}
function ma(n, e) {
  n.forEach(function(t) {
    t && (t.style.transitionDuration = e + "ms");
  });
}
function Ku(n, e) {
  n.forEach(function(t) {
    t && t.setAttribute("data-state", e);
  });
}
function a4(n) {
  var e, t = Ei(n), i = t[0];
  return i != null && (e = i.ownerDocument) != null && e.body ? i.ownerDocument : document;
}
function l4(n, e) {
  var t = e.clientX, i = e.clientY;
  return n.every(function(r) {
    var o = r.popperRect, s = r.popperState, a = r.props, l = a.interactiveBorder, c = n4(s.placement), u = s.modifiersData.offset;
    if (!u)
      return !0;
    var d = c === "bottom" ? u.top.y : 0, h = c === "top" ? u.bottom.y : 0, f = c === "right" ? u.left.x : 0, p = c === "left" ? u.right.x : 0, m = o.top - i + d > l, g = i - o.bottom - h > l, k = o.left - t + f > l, x = t - o.right - p > l;
    return m || g || k || x;
  });
}
function ga(n, e, t) {
  var i = e + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(r) {
    n[i](r, t);
  });
}
function Zu(n, e) {
  for (var t = e; t; ) {
    var i;
    if (n.contains(t))
      return !0;
    t = t.getRootNode == null || (i = t.getRootNode()) == null ? void 0 : i.host;
  }
  return !1;
}
var jt = {
  isTouch: !1
}, Ju = 0;
function c4() {
  jt.isTouch || (jt.isTouch = !0, window.performance && document.addEventListener("mousemove", Ip));
}
function Ip() {
  var n = performance.now();
  n - Ju < 20 && (jt.isTouch = !1, document.removeEventListener("mousemove", Ip)), Ju = n;
}
function u4() {
  var n = document.activeElement;
  if (o4(n)) {
    var e = n._tippy;
    n.blur && !e.state.isVisible && n.blur();
  }
}
function d4() {
  document.addEventListener("touchstart", c4, Zn), window.addEventListener("blur", u4);
}
var h4 = typeof window < "u" && typeof document < "u", f4 = h4 ? (
  // @ts-ignore
  !!window.msCrypto
) : !1;
function yi(n) {
  var e = n === "destroy" ? "n already-" : " ";
  return [n + "() was called on a" + e + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function Gu(n) {
  var e = /[ \t]{2,}/g, t = /^[ \t]*/gm;
  return n.replace(e, " ").replace(t, "").trim();
}
function p4(n) {
  return Gu(`
  %ctippy.js

  %c` + Gu(n) + `

  %c👷‍ This is a development-only message. It will be removed in production.
  `);
}
function Pp(n) {
  return [
    p4(n),
    // title
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    // message
    "line-height: 1.5",
    // footer
    "color: #a6a095;"
  ];
}
var Or;
process.env.NODE_ENV !== "production" && m4();
function m4() {
  Or = /* @__PURE__ */ new Set();
}
function rn(n, e) {
  if (n && !Or.has(e)) {
    var t;
    Or.add(e), (t = console).warn.apply(t, Pp(e));
  }
}
function cl(n, e) {
  if (n && !Or.has(e)) {
    var t;
    Or.add(e), (t = console).error.apply(t, Pp(e));
  }
}
function g4(n) {
  var e = !n, t = Object.prototype.toString.call(n) === "[object Object]" && !n.addEventListener;
  cl(e, ["tippy() was passed", "`" + String(n) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), cl(t, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var jp = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, _4 = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, dt = Object.assign({
  appendTo: Dp,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, jp, _4), b4 = Object.keys(dt), k4 = function(e) {
  process.env.NODE_ENV !== "production" && Fp(e, []);
  var t = Object.keys(e);
  t.forEach(function(i) {
    dt[i] = e[i];
  });
};
function Bp(n) {
  var e = n.plugins || [], t = e.reduce(function(i, r) {
    var o = r.name, s = r.defaultValue;
    if (o) {
      var a;
      i[o] = n[o] !== void 0 ? n[o] : (a = dt[o]) != null ? a : s;
    }
    return i;
  }, {});
  return Object.assign({}, n, t);
}
function y4(n, e) {
  var t = e ? Object.keys(Bp(Object.assign({}, dt, {
    plugins: e
  }))) : b4, i = t.reduce(function(r, o) {
    var s = (n.getAttribute("data-tippy-" + o) || "").trim();
    if (!s)
      return r;
    if (o === "content")
      r[o] = s;
    else
      try {
        r[o] = JSON.parse(s);
      } catch {
        r[o] = s;
      }
    return r;
  }, {});
  return i;
}
function Yu(n, e) {
  var t = Object.assign({}, e, {
    content: Rp(e.content, [n])
  }, e.ignoreAttributes ? {} : y4(n, e.plugins));
  return t.aria = Object.assign({}, dt.aria, t.aria), t.aria = {
    expanded: t.aria.expanded === "auto" ? e.interactive : t.aria.expanded,
    content: t.aria.content === "auto" ? e.interactive ? null : "describedby" : t.aria.content
  }, t;
}
function Fp(n, e) {
  n === void 0 && (n = {}), e === void 0 && (e = []);
  var t = Object.keys(n);
  t.forEach(function(i) {
    var r = Q9(dt, Object.keys(jp)), o = !X9(r, i);
    o && (o = e.filter(function(s) {
      return s.name === i;
    }).length === 0), rn(o, ["`" + i + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
var v4 = function() {
  return "innerHTML";
};
function ul(n, e) {
  n[v4()] = e;
}
function Xu(n) {
  var e = or();
  return n === !0 ? e.className = Np : (e.className = Lp, $r(n) ? e.appendChild(n) : ul(e, n)), e;
}
function Qu(n, e) {
  $r(e.content) ? (ul(n, ""), n.appendChild(e.content)) : typeof e.content != "function" && (e.allowHTML ? ul(n, e.content) : n.textContent = e.content);
}
function dl(n) {
  var e = n.firstElementChild, t = Fo(e.children);
  return {
    box: e,
    content: t.find(function(i) {
      return i.classList.contains(Ap);
    }),
    arrow: t.find(function(i) {
      return i.classList.contains(Np) || i.classList.contains(Lp);
    }),
    backdrop: t.find(function(i) {
      return i.classList.contains(Y9);
    })
  };
}
function qp(n) {
  var e = or(), t = or();
  t.className = G9, t.setAttribute("data-state", "hidden"), t.setAttribute("tabindex", "-1");
  var i = or();
  i.className = Ap, i.setAttribute("data-state", "hidden"), Qu(i, n.props), e.appendChild(t), t.appendChild(i), r(n.props, n.props);
  function r(o, s) {
    var a = dl(e), l = a.box, c = a.content, u = a.arrow;
    s.theme ? l.setAttribute("data-theme", s.theme) : l.removeAttribute("data-theme"), typeof s.animation == "string" ? l.setAttribute("data-animation", s.animation) : l.removeAttribute("data-animation"), s.inertia ? l.setAttribute("data-inertia", "") : l.removeAttribute("data-inertia"), l.style.maxWidth = typeof s.maxWidth == "number" ? s.maxWidth + "px" : s.maxWidth, s.role ? l.setAttribute("role", s.role) : l.removeAttribute("role"), (o.content !== s.content || o.allowHTML !== s.allowHTML) && Qu(c, n.props), s.arrow ? u ? o.arrow !== s.arrow && (l.removeChild(u), l.appendChild(Xu(s.arrow))) : l.appendChild(Xu(s.arrow)) : u && l.removeChild(u);
  }
  return {
    popper: e,
    onUpdate: r
  };
}
qp.$$tippy = !0;
var x4 = 1, Qr = [], _a = [];
function S4(n, e) {
  var t = Yu(n, Object.assign({}, dt, Bp(Wu(e)))), i, r, o, s = !1, a = !1, l = !1, c = !1, u, d, h, f = [], p = Vu(qn, t.interactiveDebounce), m, g = x4++, k = null, x = t4(t.plugins), S = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, _ = {
    // properties
    id: g,
    reference: n,
    popper: or(),
    popperInstance: k,
    props: t,
    state: S,
    plugins: x,
    // methods
    clearDelayTimeouts: bn,
    setProps: pi,
    setContent: Vn,
    show: Nt,
    hide: mi,
    hideWithInteractivity: Un,
    enable: At,
    disable: _n,
    unmount: qr,
    destroy: EA
  };
  if (!t.render)
    return process.env.NODE_ENV !== "production" && cl(!0, "render() function has not been supplied."), _;
  var v = t.render(_), y = v.popper, w = v.onUpdate;
  y.setAttribute("data-tippy-root", ""), y.id = "tippy-" + _.id, _.popper = y, n._tippy = _, y._tippy = _;
  var $ = x.map(function(C) {
    return C.fn(_);
  }), A = n.hasAttribute("aria-expanded");
  return Jt(), me(), K(), V("onCreate", [_]), t.showOnCreate && zt(), y.addEventListener("mouseenter", function() {
    _.props.interactive && _.state.isVisible && _.clearDelayTimeouts();
  }), y.addEventListener("mouseleave", function() {
    _.props.interactive && _.props.trigger.indexOf("mouseenter") >= 0 && U().addEventListener("mousemove", p);
  }), _;
  function z() {
    var C = _.props.touch;
    return Array.isArray(C) ? C : [C, 0];
  }
  function N() {
    return z()[0] === "hold";
  }
  function D() {
    var C;
    return !!((C = _.props.render) != null && C.$$tippy);
  }
  function j() {
    return m || n;
  }
  function U() {
    var C = j().parentNode;
    return C ? a4(C) : document;
  }
  function Y() {
    return dl(y);
  }
  function B(C) {
    return _.state.isMounted && !_.state.isVisible || jt.isTouch || u && u.type === "focus" ? 0 : pa(_.props.delay, C ? 0 : 1, dt.delay);
  }
  function K(C) {
    C === void 0 && (C = !1), y.style.pointerEvents = _.props.interactive && !C ? "" : "none", y.style.zIndex = "" + _.props.zIndex;
  }
  function V(C, I, q) {
    if (q === void 0 && (q = !0), $.forEach(function(se) {
      se[C] && se[C].apply(se, I);
    }), q) {
      var ue;
      (ue = _.props)[C].apply(ue, I);
    }
  }
  function pe() {
    var C = _.props.aria;
    if (C.content) {
      var I = "aria-" + C.content, q = y.id, ue = Ei(_.props.triggerTarget || n);
      ue.forEach(function(se) {
        var Qe = se.getAttribute(I);
        if (_.state.isVisible)
          se.setAttribute(I, Qe ? Qe + " " + q : q);
        else {
          var pt = Qe && Qe.replace(q, "").trim();
          pt ? se.setAttribute(I, pt) : se.removeAttribute(I);
        }
      });
    }
  }
  function me() {
    if (!(A || !_.props.aria.expanded)) {
      var C = Ei(_.props.triggerTarget || n);
      C.forEach(function(I) {
        _.props.interactive ? I.setAttribute("aria-expanded", _.state.isVisible && I === j() ? "true" : "false") : I.removeAttribute("aria-expanded");
      });
    }
  }
  function Z() {
    U().removeEventListener("mousemove", p), Qr = Qr.filter(function(C) {
      return C !== p;
    });
  }
  function Q(C) {
    if (!(jt.isTouch && (l || C.type === "mousedown"))) {
      var I = C.composedPath && C.composedPath()[0] || C.target;
      if (!(_.props.interactive && Zu(y, I))) {
        if (Ei(_.props.triggerTarget || n).some(function(q) {
          return Zu(q, I);
        })) {
          if (jt.isTouch || _.state.isVisible && _.props.trigger.indexOf("click") >= 0)
            return;
        } else
          V("onClickOutside", [_, C]);
        _.props.hideOnClick === !0 && (_.clearDelayTimeouts(), _.hide(), a = !0, setTimeout(function() {
          a = !1;
        }), _.state.isMounted || Oe());
      }
    }
  }
  function X() {
    l = !0;
  }
  function $e() {
    l = !1;
  }
  function we() {
    var C = U();
    C.addEventListener("mousedown", Q, !0), C.addEventListener("touchend", Q, Zn), C.addEventListener("touchstart", $e, Zn), C.addEventListener("touchmove", X, Zn);
  }
  function Oe() {
    var C = U();
    C.removeEventListener("mousedown", Q, !0), C.removeEventListener("touchend", Q, Zn), C.removeEventListener("touchstart", $e, Zn), C.removeEventListener("touchmove", X, Zn);
  }
  function re(C, I) {
    je(C, function() {
      !_.state.isVisible && y.parentNode && y.parentNode.contains(y) && I();
    });
  }
  function be(C, I) {
    je(C, I);
  }
  function je(C, I) {
    var q = Y().box;
    function ue(se) {
      se.target === q && (ga(q, "remove", ue), I());
    }
    if (C === 0)
      return I();
    ga(q, "remove", d), ga(q, "add", ue), d = ue;
  }
  function it(C, I, q) {
    q === void 0 && (q = !1);
    var ue = Ei(_.props.triggerTarget || n);
    ue.forEach(function(se) {
      se.addEventListener(C, I, q), f.push({
        node: se,
        eventType: C,
        handler: I,
        options: q
      });
    });
  }
  function Jt() {
    N() && (it("touchstart", pn, {
      passive: !0
    }), it("touchend", Hn, {
      passive: !0
    })), e4(_.props.trigger).forEach(function(C) {
      if (C !== "manual")
        switch (it(C, pn), C) {
          case "mouseenter":
            it("mouseleave", Hn);
            break;
          case "focus":
            it(f4 ? "focusout" : "blur", mn);
            break;
          case "focusin":
            it("focusout", mn);
            break;
        }
    });
  }
  function Fn() {
    f.forEach(function(C) {
      var I = C.node, q = C.eventType, ue = C.handler, se = C.options;
      I.removeEventListener(q, ue, se);
    }), f = [];
  }
  function pn(C) {
    var I, q = !1;
    if (!(!_.state.isEnabled || gn(C) || a)) {
      var ue = ((I = u) == null ? void 0 : I.type) === "focus";
      u = C, m = C.currentTarget, me(), !_.state.isVisible && r4(C) && Qr.forEach(function(se) {
        return se(C);
      }), C.type === "click" && (_.props.trigger.indexOf("mouseenter") < 0 || s) && _.props.hideOnClick !== !1 && _.state.isVisible ? q = !0 : zt(C), C.type === "click" && (s = !q), q && !ue && ct(C);
    }
  }
  function qn(C) {
    var I = C.target, q = j().contains(I) || y.contains(I);
    if (!(C.type === "mousemove" && q)) {
      var ue = Xe().concat(y).map(function(se) {
        var Qe, pt = se._tippy, gi = (Qe = pt.popperInstance) == null ? void 0 : Qe.state;
        return gi ? {
          popperRect: se.getBoundingClientRect(),
          popperState: gi,
          props: t
        } : null;
      }).filter(Boolean);
      l4(ue, C) && (Z(), ct(C));
    }
  }
  function Hn(C) {
    var I = gn(C) || _.props.trigger.indexOf("click") >= 0 && s;
    if (!I) {
      if (_.props.interactive) {
        _.hideWithInteractivity(C);
        return;
      }
      ct(C);
    }
  }
  function mn(C) {
    _.props.trigger.indexOf("focusin") < 0 && C.target !== j() || _.props.interactive && C.relatedTarget && y.contains(C.relatedTarget) || ct(C);
  }
  function gn(C) {
    return jt.isTouch ? N() !== C.type.indexOf("touch") >= 0 : !1;
  }
  function Ot() {
    Ye();
    var C = _.props, I = C.popperOptions, q = C.placement, ue = C.offset, se = C.getReferenceClientRect, Qe = C.moveTransition, pt = D() ? dl(y).arrow : null, gi = se ? {
      getBoundingClientRect: se,
      contextElement: se.contextElement || j()
    } : n, wc = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(Hr) {
        var _i = Hr.state;
        if (D()) {
          var $A = Y(), Js = $A.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(Vr) {
            Vr === "placement" ? Js.setAttribute("data-placement", _i.placement) : _i.attributes.popper["data-popper-" + Vr] ? Js.setAttribute("data-" + Vr, "") : Js.removeAttribute("data-" + Vr);
          }), _i.attributes.popper = {};
        }
      }
    }, Wn = [{
      name: "offset",
      options: {
        offset: ue
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !Qe
      }
    }, wc];
    D() && pt && Wn.push({
      name: "arrow",
      options: {
        element: pt,
        padding: 3
      }
    }), Wn.push.apply(Wn, (I == null ? void 0 : I.modifiers) || []), _.popperInstance = J9(gi, y, Object.assign({}, I, {
      placement: q,
      onFirstUpdate: h,
      modifiers: Wn
    }));
  }
  function Ye() {
    _.popperInstance && (_.popperInstance.destroy(), _.popperInstance = null);
  }
  function oe() {
    var C = _.props.appendTo, I, q = j();
    _.props.interactive && C === Dp || C === "parent" ? I = q.parentNode : I = Rp(C, [q]), I.contains(y) || I.appendChild(y), _.state.isMounted = !0, Ot(), process.env.NODE_ENV !== "production" && rn(_.props.interactive && C === dt.appendTo && q.nextElementSibling !== y, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function Xe() {
    return Fo(y.querySelectorAll("[data-tippy-root]"));
  }
  function zt(C) {
    _.clearDelayTimeouts(), C && V("onTrigger", [_, C]), we();
    var I = B(!0), q = z(), ue = q[0], se = q[1];
    jt.isTouch && ue === "hold" && se && (I = se), I ? i = setTimeout(function() {
      _.show();
    }, I) : _.show();
  }
  function ct(C) {
    if (_.clearDelayTimeouts(), V("onUntrigger", [_, C]), !_.state.isVisible) {
      Oe();
      return;
    }
    if (!(_.props.trigger.indexOf("mouseenter") >= 0 && _.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(C.type) >= 0 && s)) {
      var I = B(!1);
      I ? r = setTimeout(function() {
        _.state.isVisible && _.hide();
      }, I) : o = requestAnimationFrame(function() {
        _.hide();
      });
    }
  }
  function At() {
    _.state.isEnabled = !0;
  }
  function _n() {
    _.hide(), _.state.isEnabled = !1;
  }
  function bn() {
    clearTimeout(i), clearTimeout(r), cancelAnimationFrame(o);
  }
  function pi(C) {
    if (process.env.NODE_ENV !== "production" && rn(_.state.isDestroyed, yi("setProps")), !_.state.isDestroyed) {
      V("onBeforeUpdate", [_, C]), Fn();
      var I = _.props, q = Yu(n, Object.assign({}, I, Wu(C), {
        ignoreAttributes: !0
      }));
      _.props = q, Jt(), I.interactiveDebounce !== q.interactiveDebounce && (Z(), p = Vu(qn, q.interactiveDebounce)), I.triggerTarget && !q.triggerTarget ? Ei(I.triggerTarget).forEach(function(ue) {
        ue.removeAttribute("aria-expanded");
      }) : q.triggerTarget && n.removeAttribute("aria-expanded"), me(), K(), w && w(I, q), _.popperInstance && (Ot(), Xe().forEach(function(ue) {
        requestAnimationFrame(ue._tippy.popperInstance.forceUpdate);
      })), V("onAfterUpdate", [_, C]);
    }
  }
  function Vn(C) {
    _.setProps({
      content: C
    });
  }
  function Nt() {
    process.env.NODE_ENV !== "production" && rn(_.state.isDestroyed, yi("show"));
    var C = _.state.isVisible, I = _.state.isDestroyed, q = !_.state.isEnabled, ue = jt.isTouch && !_.props.touch, se = pa(_.props.duration, 0, dt.duration);
    if (!(C || I || q || ue) && !j().hasAttribute("disabled") && (V("onShow", [_], !1), _.props.onShow(_) !== !1)) {
      if (_.state.isVisible = !0, D() && (y.style.visibility = "visible"), K(), we(), _.state.isMounted || (y.style.transition = "none"), D()) {
        var Qe = Y(), pt = Qe.box, gi = Qe.content;
        ma([pt, gi], 0);
      }
      h = function() {
        var Wn;
        if (!(!_.state.isVisible || c)) {
          if (c = !0, y.offsetHeight, y.style.transition = _.props.moveTransition, D() && _.props.animation) {
            var Zs = Y(), Hr = Zs.box, _i = Zs.content;
            ma([Hr, _i], se), Ku([Hr, _i], "visible");
          }
          pe(), me(), Uu(_a, _), (Wn = _.popperInstance) == null || Wn.forceUpdate(), V("onMount", [_]), _.props.animation && D() && be(se, function() {
            _.state.isShown = !0, V("onShown", [_]);
          });
        }
      }, oe();
    }
  }
  function mi() {
    process.env.NODE_ENV !== "production" && rn(_.state.isDestroyed, yi("hide"));
    var C = !_.state.isVisible, I = _.state.isDestroyed, q = !_.state.isEnabled, ue = pa(_.props.duration, 1, dt.duration);
    if (!(C || I || q) && (V("onHide", [_], !1), _.props.onHide(_) !== !1)) {
      if (_.state.isVisible = !1, _.state.isShown = !1, c = !1, s = !1, D() && (y.style.visibility = "hidden"), Z(), Oe(), K(!0), D()) {
        var se = Y(), Qe = se.box, pt = se.content;
        _.props.animation && (ma([Qe, pt], ue), Ku([Qe, pt], "hidden"));
      }
      pe(), me(), _.props.animation ? D() && re(ue, _.unmount) : _.unmount();
    }
  }
  function Un(C) {
    process.env.NODE_ENV !== "production" && rn(_.state.isDestroyed, yi("hideWithInteractivity")), U().addEventListener("mousemove", p), Uu(Qr, p), p(C);
  }
  function qr() {
    process.env.NODE_ENV !== "production" && rn(_.state.isDestroyed, yi("unmount")), _.state.isVisible && _.hide(), _.state.isMounted && (Ye(), Xe().forEach(function(C) {
      C._tippy.unmount();
    }), y.parentNode && y.parentNode.removeChild(y), _a = _a.filter(function(C) {
      return C !== _;
    }), _.state.isMounted = !1, V("onHidden", [_]));
  }
  function EA() {
    process.env.NODE_ENV !== "production" && rn(_.state.isDestroyed, yi("destroy")), !_.state.isDestroyed && (_.clearDelayTimeouts(), _.unmount(), Fn(), delete n._tippy, _.state.isDestroyed = !0, V("onDestroy", [_]));
  }
}
function Fr(n, e) {
  e === void 0 && (e = {});
  var t = dt.plugins.concat(e.plugins || []);
  process.env.NODE_ENV !== "production" && (g4(n), Fp(e, t)), d4();
  var i = Object.assign({}, e, {
    plugins: t
  }), r = s4(n);
  if (process.env.NODE_ENV !== "production") {
    var o = $r(i.content), s = r.length > 1;
    rn(o && s, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var a = r.reduce(function(l, c) {
    var u = c && S4(c, i);
    return u && l.push(u), l;
  }, []);
  return $r(n) ? a[0] : a;
}
Fr.defaultProps = dt;
Fr.setDefaultProps = k4;
Fr.currentInput = jt;
Object.assign({}, wp, {
  effect: function(e) {
    var t = e.state, i = {
      popper: {
        position: t.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(t.elements.popper.style, i.popper), t.styles = i, t.elements.arrow && Object.assign(t.elements.arrow.style, i.arrow);
  }
});
Fr.setDefaultProps({
  render: qp
});
class w4 {
  constructor({ editor: e, element: t, view: i, tippyOptions: r = {}, updateDelay: o = 250, shouldShow: s }) {
    this.preventHide = !1, this.shouldShow = ({ view: a, state: l, from: c, to: u }) => {
      const { doc: d, selection: h } = l, { empty: f } = h, p = !d.textBetween(c, u).length && Ql(l.selection), m = this.element.contains(document.activeElement);
      return !(!(a.hasFocus() || m) || f || p || !this.editor.isEditable);
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.dragstartHandler = () => {
      this.hide();
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: a }) => {
      var l;
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      a != null && a.relatedTarget && (!((l = this.element.parentNode) === null || l === void 0) && l.contains(a.relatedTarget)) || (a == null ? void 0 : a.relatedTarget) !== this.editor.view.dom && this.hide();
    }, this.tippyBlurHandler = (a) => {
      this.blurHandler({ event: a });
    }, this.handleDebouncedUpdate = (a, l) => {
      const c = !(l != null && l.selection.eq(a.state.selection)), u = !(l != null && l.doc.eq(a.state.doc));
      !c && !u || (this.updateDebounceTimer && clearTimeout(this.updateDebounceTimer), this.updateDebounceTimer = window.setTimeout(() => {
        this.updateHandler(a, c, u, l);
      }, this.updateDelay));
    }, this.updateHandler = (a, l, c, u) => {
      var d, h, f;
      const { state: p, composing: m } = a, { selection: g } = p;
      if (m || !l && !c)
        return;
      this.createTooltip();
      const { ranges: x } = g, S = Math.min(...x.map((y) => y.$from.pos)), _ = Math.max(...x.map((y) => y.$to.pos));
      if (!((d = this.shouldShow) === null || d === void 0 ? void 0 : d.call(this, {
        editor: this.editor,
        element: this.element,
        view: a,
        state: p,
        oldState: u,
        from: S,
        to: _
      }))) {
        this.hide();
        return;
      }
      (h = this.tippy) === null || h === void 0 || h.setProps({
        getReferenceClientRect: ((f = this.tippyOptions) === null || f === void 0 ? void 0 : f.getReferenceClientRect) || (() => {
          if (c5(p.selection)) {
            let y = a.nodeDOM(S);
            if (y) {
              const w = y.dataset.nodeViewWrapper ? y : y.querySelector("[data-node-view-wrapper]");
              if (w && (y = w.firstChild), y)
                return y.getBoundingClientRect();
            }
          }
          return u5(a, S, _);
        })
      }), this.show();
    }, this.editor = e, this.element = t, this.view = i, this.updateDelay = o, s && (this.shouldShow = s), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.addEventListener("dragstart", this.dragstartHandler), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.tippyOptions = r, this.element.remove(), this.element.style.visibility = "visible";
  }
  createTooltip() {
    const { element: e } = this.editor.options, t = !!e.parentElement;
    this.tippy || !t || (this.tippy = Fr(e, {
      duration: 0,
      getReferenceClientRect: null,
      content: this.element,
      interactive: !0,
      trigger: "manual",
      placement: "top",
      hideOnClick: "toggle",
      ...this.tippyOptions
    }), this.tippy.popper.firstChild && this.tippy.popper.firstChild.addEventListener("blur", this.tippyBlurHandler));
  }
  update(e, t) {
    const { state: i } = e, r = i.selection.from !== i.selection.to;
    if (this.updateDelay > 0 && r) {
      this.handleDebouncedUpdate(e, t);
      return;
    }
    const o = !(t != null && t.selection.eq(e.state.selection)), s = !(t != null && t.doc.eq(e.state.doc));
    this.updateHandler(e, o, s, t);
  }
  show() {
    var e;
    (e = this.tippy) === null || e === void 0 || e.show();
  }
  hide() {
    var e;
    (e = this.tippy) === null || e === void 0 || e.hide();
  }
  destroy() {
    var e, t;
    !((e = this.tippy) === null || e === void 0) && e.popper.firstChild && this.tippy.popper.firstChild.removeEventListener("blur", this.tippyBlurHandler), (t = this.tippy) === null || t === void 0 || t.destroy(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.removeEventListener("dragstart", this.dragstartHandler), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler);
  }
}
const Hp = (n) => new Ee({
  key: typeof n.pluginKey == "string" ? new Ue(n.pluginKey) : n.pluginKey,
  view: (e) => new w4({ view: e, ...n })
});
Se.create({
  name: "bubbleMenu",
  addOptions() {
    return {
      element: null,
      tippyOptions: {},
      pluginKey: "bubbleMenu",
      updateDelay: void 0,
      shouldShow: null
    };
  },
  addProseMirrorPlugins() {
    return this.options.element ? [
      Hp({
        pluginKey: this.options.pluginKey,
        editor: this.editor,
        element: this.options.element,
        tippyOptions: this.options.tippyOptions,
        updateDelay: this.options.updateDelay,
        shouldShow: this.options.shouldShow
      })
    ] : [];
  }
});
function C4(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var hl = { exports: {} }, ba = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ed;
function T4() {
  if (ed) return ba;
  ed = 1;
  var n = _e;
  function e(d, h) {
    return d === h && (d !== 0 || 1 / d === 1 / h) || d !== d && h !== h;
  }
  var t = typeof Object.is == "function" ? Object.is : e, i = n.useState, r = n.useEffect, o = n.useLayoutEffect, s = n.useDebugValue;
  function a(d, h) {
    var f = h(), p = i({ inst: { value: f, getSnapshot: h } }), m = p[0].inst, g = p[1];
    return o(function() {
      m.value = f, m.getSnapshot = h, l(m) && g({ inst: m });
    }, [d, f, h]), r(function() {
      return l(m) && g({ inst: m }), d(function() {
        l(m) && g({ inst: m });
      });
    }, [d]), s(f), f;
  }
  function l(d) {
    var h = d.getSnapshot;
    d = d.value;
    try {
      var f = h();
      return !t(d, f);
    } catch {
      return !0;
    }
  }
  function c(d, h) {
    return h();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : a;
  return ba.useSyncExternalStore = n.useSyncExternalStore !== void 0 ? n.useSyncExternalStore : u, ba;
}
var ka = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var td;
function M4() {
  return td || (td = 1, process.env.NODE_ENV !== "production" && (function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var n = _e, e = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function t(S) {
      {
        for (var _ = arguments.length, v = new Array(_ > 1 ? _ - 1 : 0), y = 1; y < _; y++)
          v[y - 1] = arguments[y];
        i("error", S, v);
      }
    }
    function i(S, _, v) {
      {
        var y = e.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (_ += "%s", v = v.concat([w]));
        var $ = v.map(function(A) {
          return String(A);
        });
        $.unshift("Warning: " + _), Function.prototype.apply.call(console[S], console, $);
      }
    }
    function r(S, _) {
      return S === _ && (S !== 0 || 1 / S === 1 / _) || S !== S && _ !== _;
    }
    var o = typeof Object.is == "function" ? Object.is : r, s = n.useState, a = n.useEffect, l = n.useLayoutEffect, c = n.useDebugValue, u = !1, d = !1;
    function h(S, _, v) {
      u || n.startTransition !== void 0 && (u = !0, t("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var y = _();
      if (!d) {
        var w = _();
        o(y, w) || (t("The result of getSnapshot should be cached to avoid an infinite loop"), d = !0);
      }
      var $ = s({
        inst: {
          value: y,
          getSnapshot: _
        }
      }), A = $[0].inst, z = $[1];
      return l(function() {
        A.value = y, A.getSnapshot = _, f(A) && z({
          inst: A
        });
      }, [S, y, _]), a(function() {
        f(A) && z({
          inst: A
        });
        var N = function() {
          f(A) && z({
            inst: A
          });
        };
        return S(N);
      }, [S]), c(y), y;
    }
    function f(S) {
      var _ = S.getSnapshot, v = S.value;
      try {
        var y = _();
        return !o(v, y);
      } catch {
        return !0;
      }
    }
    function p(S, _, v) {
      return _();
    }
    var m = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", g = !m, k = g ? p : h, x = n.useSyncExternalStore !== void 0 ? n.useSyncExternalStore : k;
    ka.useSyncExternalStore = x, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  })()), ka;
}
process.env.NODE_ENV === "production" ? hl.exports = T4() : hl.exports = M4();
var qs = hl.exports;
const E4 = (...n) => (e) => {
  n.forEach((t) => {
    typeof t == "function" ? t(e) : t && (t.current = e);
  });
}, $4 = ({ contentComponent: n }) => {
  const e = qs.useSyncExternalStore(n.subscribe, n.getSnapshot, n.getServerSnapshot);
  return _e.createElement(_e.Fragment, null, Object.values(e));
};
function O4() {
  const n = /* @__PURE__ */ new Set();
  let e = {};
  return {
    /**
     * Subscribe to the editor instance's changes.
     */
    subscribe(t) {
      return n.add(t), () => {
        n.delete(t);
      };
    },
    getSnapshot() {
      return e;
    },
    getServerSnapshot() {
      return e;
    },
    /**
     * Adds a new NodeView Renderer to the editor.
     */
    setRenderer(t, i) {
      e = {
        ...e,
        [t]: jA.createPortal(i.reactElement, i.element, t)
      }, n.forEach((r) => r());
    },
    /**
     * Removes a NodeView Renderer from the editor.
     */
    removeRenderer(t) {
      const i = { ...e };
      delete i[t], e = i, n.forEach((r) => r());
    }
  };
}
class z4 extends _e.Component {
  constructor(e) {
    var t;
    super(e), this.editorContentRef = _e.createRef(), this.initialized = !1, this.state = {
      hasContentComponentInitialized: !!(!((t = e.editor) === null || t === void 0) && t.contentComponent)
    };
  }
  componentDidMount() {
    this.init();
  }
  componentDidUpdate() {
    this.init();
  }
  init() {
    const e = this.props.editor;
    if (e && !e.isDestroyed && e.options.element) {
      if (e.contentComponent)
        return;
      const t = this.editorContentRef.current;
      t.append(...e.options.element.childNodes), e.setOptions({
        element: t
      }), e.contentComponent = O4(), this.state.hasContentComponentInitialized || (this.unsubscribeToContentComponent = e.contentComponent.subscribe(() => {
        this.setState((i) => i.hasContentComponentInitialized ? i : {
          hasContentComponentInitialized: !0
        }), this.unsubscribeToContentComponent && this.unsubscribeToContentComponent();
      })), e.createNodeViews(), this.initialized = !0;
    }
  }
  componentWillUnmount() {
    const e = this.props.editor;
    if (!e || (this.initialized = !1, e.isDestroyed || e.view.setProps({
      nodeViews: {}
    }), this.unsubscribeToContentComponent && this.unsubscribeToContentComponent(), e.contentComponent = null, !e.options.element.firstChild))
      return;
    const t = document.createElement("div");
    t.append(...e.options.element.childNodes), e.setOptions({
      element: t
    });
  }
  render() {
    const { editor: e, innerRef: t, ...i } = this.props;
    return _e.createElement(
      _e.Fragment,
      null,
      _e.createElement("div", { ref: E4(t, this.editorContentRef), ...i }),
      (e == null ? void 0 : e.contentComponent) && _e.createElement($4, { contentComponent: e.contentComponent })
    );
  }
}
const A4 = DA((n, e) => {
  const t = _e.useMemo(() => Math.floor(Math.random() * 4294967295).toString(), [n.editor]);
  return _e.createElement(z4, {
    key: t,
    innerRef: e,
    ...n
  });
}), N4 = _e.memo(A4);
var L4 = function n(e, t) {
  if (e === t) return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor) return !1;
    var i, r, o;
    if (Array.isArray(e)) {
      if (i = e.length, i != t.length) return !1;
      for (r = i; r-- !== 0; )
        if (!n(e[r], t[r])) return !1;
      return !0;
    }
    if (e instanceof Map && t instanceof Map) {
      if (e.size !== t.size) return !1;
      for (r of e.entries())
        if (!t.has(r[0])) return !1;
      for (r of e.entries())
        if (!n(r[1], t.get(r[0]))) return !1;
      return !0;
    }
    if (e instanceof Set && t instanceof Set) {
      if (e.size !== t.size) return !1;
      for (r of e.entries())
        if (!t.has(r[0])) return !1;
      return !0;
    }
    if (ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      if (i = e.length, i != t.length) return !1;
      for (r = i; r-- !== 0; )
        if (e[r] !== t[r]) return !1;
      return !0;
    }
    if (e.constructor === RegExp) return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString) return e.toString() === t.toString();
    if (o = Object.keys(e), i = o.length, i !== Object.keys(t).length) return !1;
    for (r = i; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, o[r])) return !1;
    for (r = i; r-- !== 0; ) {
      var s = o[r];
      if (!(s === "_owner" && e.$$typeof) && !n(e[s], t[s]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}, D4 = /* @__PURE__ */ C4(L4), fl = { exports: {} }, ya = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var nd;
function R4() {
  if (nd) return ya;
  nd = 1;
  var n = _e, e = qs;
  function t(c, u) {
    return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
  }
  var i = typeof Object.is == "function" ? Object.is : t, r = e.useSyncExternalStore, o = n.useRef, s = n.useEffect, a = n.useMemo, l = n.useDebugValue;
  return ya.useSyncExternalStoreWithSelector = function(c, u, d, h, f) {
    var p = o(null);
    if (p.current === null) {
      var m = { hasValue: !1, value: null };
      p.current = m;
    } else m = p.current;
    p = a(function() {
      function k(y) {
        if (!x) {
          if (x = !0, S = y, y = h(y), f !== void 0 && m.hasValue) {
            var w = m.value;
            if (f(w, y)) return _ = w;
          }
          return _ = y;
        }
        if (w = _, i(S, y)) return w;
        var $ = h(y);
        return f !== void 0 && f(w, $) ? w : (S = y, _ = $);
      }
      var x = !1, S, _, v = d === void 0 ? null : d;
      return [function() {
        return k(u());
      }, v === null ? void 0 : function() {
        return k(v());
      }];
    }, [u, d, h, f]);
    var g = r(c, p[0], p[1]);
    return s(function() {
      m.hasValue = !0, m.value = g;
    }, [g]), l(g), g;
  }, ya;
}
var va = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var id;
function I4() {
  return id || (id = 1, process.env.NODE_ENV !== "production" && (function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var n = _e, e = qs;
    function t(u, d) {
      return u === d && (u !== 0 || 1 / u === 1 / d) || u !== u && d !== d;
    }
    var i = typeof Object.is == "function" ? Object.is : t, r = e.useSyncExternalStore, o = n.useRef, s = n.useEffect, a = n.useMemo, l = n.useDebugValue;
    function c(u, d, h, f, p) {
      var m = o(null), g;
      m.current === null ? (g = {
        hasValue: !1,
        value: null
      }, m.current = g) : g = m.current;
      var k = a(function() {
        var v = !1, y, w, $ = function(D) {
          if (!v) {
            v = !0, y = D;
            var j = f(D);
            if (p !== void 0 && g.hasValue) {
              var U = g.value;
              if (p(U, j))
                return w = U, U;
            }
            return w = j, j;
          }
          var Y = y, B = w;
          if (i(Y, D))
            return B;
          var K = f(D);
          return p !== void 0 && p(B, K) ? B : (y = D, w = K, K);
        }, A = h === void 0 ? null : h, z = function() {
          return $(d());
        }, N = A === null ? void 0 : function() {
          return $(A());
        };
        return [z, N];
      }, [d, h, f, p]), x = k[0], S = k[1], _ = r(u, x, S);
      return s(function() {
        g.hasValue = !0, g.value = _;
      }, [_]), l(_), _;
    }
    va.useSyncExternalStoreWithSelector = c, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  })()), va;
}
process.env.NODE_ENV === "production" ? fl.exports = R4() : fl.exports = I4();
var P4 = fl.exports;
const j4 = typeof window < "u" ? RA : Je;
class B4 {
  constructor(e) {
    this.transactionNumber = 0, this.lastTransactionNumber = 0, this.subscribers = /* @__PURE__ */ new Set(), this.editor = e, this.lastSnapshot = { editor: e, transactionNumber: 0 }, this.getSnapshot = this.getSnapshot.bind(this), this.getServerSnapshot = this.getServerSnapshot.bind(this), this.watch = this.watch.bind(this), this.subscribe = this.subscribe.bind(this);
  }
  /**
   * Get the current editor instance.
   */
  getSnapshot() {
    return this.transactionNumber === this.lastTransactionNumber ? this.lastSnapshot : (this.lastTransactionNumber = this.transactionNumber, this.lastSnapshot = { editor: this.editor, transactionNumber: this.transactionNumber }, this.lastSnapshot);
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return { editor: null, transactionNumber: 0 };
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(e) {
    return this.subscribers.add(e), () => {
      this.subscribers.delete(e);
    };
  }
  /**
   * Watch the editor instance for changes.
   */
  watch(e) {
    if (this.editor = e, this.editor) {
      const t = () => {
        this.transactionNumber += 1, this.subscribers.forEach((r) => r());
      }, i = this.editor;
      return i.on("transaction", t), () => {
        i.off("transaction", t);
      };
    }
  }
}
function F4(n) {
  var e;
  const [t] = ye(() => new B4(n.editor)), i = P4.useSyncExternalStoreWithSelector(t.subscribe, t.getSnapshot, t.getServerSnapshot, n.selector, (e = n.equalityFn) !== null && e !== void 0 ? e : D4);
  return j4(() => t.watch(n.editor), [n.editor, t]), Th(i), i;
}
const rd = process.env.NODE_ENV !== "production", pl = typeof window > "u", q4 = pl || !!(typeof window < "u" && window.next);
class dc {
  constructor(e) {
    this.editor = null, this.subscriptions = /* @__PURE__ */ new Set(), this.isComponentMounted = !1, this.previousDeps = null, this.instanceId = "", this.options = e, this.subscriptions = /* @__PURE__ */ new Set(), this.setEditor(this.getInitialEditor()), this.scheduleDestroy(), this.getEditor = this.getEditor.bind(this), this.getServerSnapshot = this.getServerSnapshot.bind(this), this.subscribe = this.subscribe.bind(this), this.refreshEditorInstance = this.refreshEditorInstance.bind(this), this.scheduleDestroy = this.scheduleDestroy.bind(this), this.onRender = this.onRender.bind(this), this.createEditor = this.createEditor.bind(this);
  }
  setEditor(e) {
    this.editor = e, this.instanceId = Math.random().toString(36).slice(2, 9), this.subscriptions.forEach((t) => t());
  }
  getInitialEditor() {
    if (this.options.current.immediatelyRender === void 0)
      return pl || q4 ? (rd && console.warn("Tiptap Error: SSR has been detected, please set `immediatelyRender` explicitly to `false` to avoid hydration mismatches."), null) : this.createEditor();
    if (this.options.current.immediatelyRender && pl && rd)
      throw new Error("Tiptap Error: SSR has been detected, and `immediatelyRender` has been set to `true` this is an unsupported configuration that may result in errors, explicitly set `immediatelyRender` to `false` to avoid hydration mismatches.");
    return this.options.current.immediatelyRender ? this.createEditor() : null;
  }
  /**
   * Create a new editor instance. And attach event listeners.
   */
  createEditor() {
    const e = {
      ...this.options.current,
      // Always call the most recent version of the callback function by default
      onBeforeCreate: (...i) => {
        var r, o;
        return (o = (r = this.options.current).onBeforeCreate) === null || o === void 0 ? void 0 : o.call(r, ...i);
      },
      onBlur: (...i) => {
        var r, o;
        return (o = (r = this.options.current).onBlur) === null || o === void 0 ? void 0 : o.call(r, ...i);
      },
      onCreate: (...i) => {
        var r, o;
        return (o = (r = this.options.current).onCreate) === null || o === void 0 ? void 0 : o.call(r, ...i);
      },
      onDestroy: (...i) => {
        var r, o;
        return (o = (r = this.options.current).onDestroy) === null || o === void 0 ? void 0 : o.call(r, ...i);
      },
      onFocus: (...i) => {
        var r, o;
        return (o = (r = this.options.current).onFocus) === null || o === void 0 ? void 0 : o.call(r, ...i);
      },
      onSelectionUpdate: (...i) => {
        var r, o;
        return (o = (r = this.options.current).onSelectionUpdate) === null || o === void 0 ? void 0 : o.call(r, ...i);
      },
      onTransaction: (...i) => {
        var r, o;
        return (o = (r = this.options.current).onTransaction) === null || o === void 0 ? void 0 : o.call(r, ...i);
      },
      onUpdate: (...i) => {
        var r, o;
        return (o = (r = this.options.current).onUpdate) === null || o === void 0 ? void 0 : o.call(r, ...i);
      },
      onContentError: (...i) => {
        var r, o;
        return (o = (r = this.options.current).onContentError) === null || o === void 0 ? void 0 : o.call(r, ...i);
      },
      onDrop: (...i) => {
        var r, o;
        return (o = (r = this.options.current).onDrop) === null || o === void 0 ? void 0 : o.call(r, ...i);
      },
      onPaste: (...i) => {
        var r, o;
        return (o = (r = this.options.current).onPaste) === null || o === void 0 ? void 0 : o.call(r, ...i);
      }
    };
    return new F5(e);
  }
  /**
   * Get the current editor instance.
   */
  getEditor() {
    return this.editor;
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return null;
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(e) {
    return this.subscriptions.add(e), () => {
      this.subscriptions.delete(e);
    };
  }
  static compareOptions(e, t) {
    return Object.keys(e).every((i) => ["onCreate", "onBeforeCreate", "onDestroy", "onUpdate", "onTransaction", "onFocus", "onBlur", "onSelectionUpdate", "onContentError", "onDrop", "onPaste"].includes(i) ? !0 : i === "extensions" && e.extensions && t.extensions ? e.extensions.length !== t.extensions.length ? !1 : e.extensions.every((r, o) => {
      var s;
      return r === ((s = t.extensions) === null || s === void 0 ? void 0 : s[o]);
    }) : e[i] === t[i]);
  }
  /**
   * On each render, we will create, update, or destroy the editor instance.
   * @param deps The dependencies to watch for changes
   * @returns A cleanup function
   */
  onRender(e) {
    return () => (this.isComponentMounted = !0, clearTimeout(this.scheduledDestructionTimeout), this.editor && !this.editor.isDestroyed && e.length === 0 ? dc.compareOptions(this.options.current, this.editor.options) || this.editor.setOptions({
      ...this.options.current,
      editable: this.editor.isEditable
    }) : this.refreshEditorInstance(e), () => {
      this.isComponentMounted = !1, this.scheduleDestroy();
    });
  }
  /**
   * Recreate the editor instance if the dependencies have changed.
   */
  refreshEditorInstance(e) {
    if (this.editor && !this.editor.isDestroyed) {
      if (this.previousDeps === null) {
        this.previousDeps = e;
        return;
      }
      if (this.previousDeps.length === e.length && this.previousDeps.every((i, r) => i === e[r]))
        return;
    }
    this.editor && !this.editor.isDestroyed && this.editor.destroy(), this.setEditor(this.createEditor()), this.previousDeps = e;
  }
  /**
   * Schedule the destruction of the editor instance.
   * This will only destroy the editor if it was not mounted on the next tick.
   * This is to avoid destroying the editor instance when it's actually still mounted.
   */
  scheduleDestroy() {
    const e = this.instanceId, t = this.editor;
    this.scheduledDestructionTimeout = setTimeout(() => {
      if (this.isComponentMounted && this.instanceId === e) {
        t && t.setOptions(this.options.current);
        return;
      }
      t && !t.isDestroyed && (t.destroy(), this.instanceId === e && this.setEditor(null));
    }, 1);
  }
}
function H4(n = {}, e = []) {
  const t = gr(n);
  t.current = n;
  const [i] = ye(() => new dc(t)), r = qs.useSyncExternalStore(i.subscribe, i.getEditor, i.getServerSnapshot);
  return Th(r), Je(i.onRender(e)), F4({
    editor: r,
    selector: ({ transactionNumber: o }) => n.shouldRerenderOnTransaction === !1 ? null : n.immediatelyRender && o === 0 ? 0 : o + 1
  }), r;
}
const Vp = Cs({
  editor: null
});
Vp.Consumer;
const V4 = () => Ch(Vp), U4 = (n) => {
  const [e, t] = ye(null), { editor: i } = V4();
  return Je(() => {
    var r;
    if (!e || !((r = n.editor) === null || r === void 0) && r.isDestroyed || i != null && i.isDestroyed)
      return;
    const { pluginKey: o = "bubbleMenu", editor: s, tippyOptions: a = {}, updateDelay: l, shouldShow: c = null } = n, u = s || i;
    if (!u) {
      console.warn("BubbleMenu component is not rendered inside of an editor component or does not have editor prop.");
      return;
    }
    const d = Hp({
      updateDelay: l,
      editor: u,
      element: e,
      pluginKey: o,
      shouldShow: c,
      tippyOptions: a
    });
    return u.registerPlugin(d), () => {
      u.unregisterPlugin(o);
    };
  }, [n.editor, i, e]), _e.createElement("div", { ref: t, className: n.className, style: { visibility: "hidden" } }, n.children);
}, Up = Cs({
  onDragStart: void 0
}), hc = () => Ch(Up), Hs = (n) => {
  const e = n.as || "div", { nodeViewContentRef: t } = hc();
  return (
    // @ts-ignore
    _e.createElement(e, { ...n, ref: t, "data-node-view-content": "", style: {
      whiteSpace: "pre-wrap",
      ...n.style
    } })
  );
}, fc = _e.forwardRef((n, e) => {
  const { onDragStart: t } = hc(), i = n.as || "div";
  return (
    // @ts-ignore
    _e.createElement(i, { ...n, ref: e, "data-node-view-wrapper": "", onDragStart: t, style: {
      whiteSpace: "normal",
      ...n.style
    } })
  );
});
function W4(n) {
  return !!(typeof n == "function" && n.prototype && n.prototype.isReactComponent);
}
function K4(n) {
  var e;
  return typeof n == "object" && ((e = n.$$typeof) === null || e === void 0 ? void 0 : e.toString()) === "Symbol(react.forward_ref)";
}
class Z4 {
  /**
   * Immediately creates element and renders the provided React component.
   */
  constructor(e, { editor: t, props: i = {}, as: r = "div", className: o = "" }) {
    this.ref = null, this.id = Math.floor(Math.random() * 4294967295).toString(), this.component = e, this.editor = t, this.props = i, this.element = document.createElement(r), this.element.classList.add("react-renderer"), o && this.element.classList.add(...o.split(" ")), this.editor.isInitialized ? Mh(() => {
      this.render();
    }) : this.render();
  }
  /**
   * Render the React component.
   */
  render() {
    var e;
    const t = this.component, i = this.props, r = this.editor;
    (W4(t) || K4(t)) && (i.ref = (o) => {
      this.ref = o;
    }), this.reactElement = _e.createElement(t, { ...i }), (e = r == null ? void 0 : r.contentComponent) === null || e === void 0 || e.setRenderer(this.id, this);
  }
  /**
   * Re-renders the React component with new props.
   */
  updateProps(e = {}) {
    this.props = {
      ...this.props,
      ...e
    }, this.render();
  }
  /**
   * Destroy the React component.
   */
  destroy() {
    var e;
    const t = this.editor;
    (e = t == null ? void 0 : t.contentComponent) === null || e === void 0 || e.removeRenderer(this.id);
  }
  /**
   * Update the attributes of the element that holds the React component.
   */
  updateAttributes(e) {
    Object.keys(e).forEach((t) => {
      this.element.setAttribute(t, e[t]);
    });
  }
}
class J4 extends H5 {
  /**
   * Setup the React component.
   * Called on initialization.
   */
  mount() {
    const e = {
      editor: this.editor,
      node: this.node,
      decorations: this.decorations,
      innerDecorations: this.innerDecorations,
      view: this.view,
      selected: !1,
      extension: this.extension,
      HTMLAttributes: this.HTMLAttributes,
      getPos: () => this.getPos(),
      updateAttributes: (c = {}) => this.updateAttributes(c),
      deleteNode: () => this.deleteNode()
    };
    if (!this.component.displayName) {
      const c = (u) => u.charAt(0).toUpperCase() + u.substring(1);
      this.component.displayName = c(this.extension.name);
    }
    const r = { onDragStart: this.onDragStart.bind(this), nodeViewContentRef: (c) => {
      c && this.contentDOMElement && c.firstChild !== this.contentDOMElement && c.appendChild(this.contentDOMElement);
    } }, o = this.component, s = _e.memo((c) => _e.createElement(Up.Provider, { value: r }, _e.createElement(o, c)));
    s.displayName = "ReactNodeView", this.node.isLeaf ? this.contentDOMElement = null : this.options.contentDOMElementTag ? this.contentDOMElement = document.createElement(this.options.contentDOMElementTag) : this.contentDOMElement = document.createElement(this.node.isInline ? "span" : "div"), this.contentDOMElement && (this.contentDOMElement.dataset.nodeViewContentReact = "", this.contentDOMElement.style.whiteSpace = "inherit");
    let a = this.node.isInline ? "span" : "div";
    this.options.as && (a = this.options.as);
    const { className: l = "" } = this.options;
    this.handleSelectionUpdate = this.handleSelectionUpdate.bind(this), this.renderer = new Z4(s, {
      editor: this.editor,
      props: e,
      as: a,
      className: `node-${this.node.type.name} ${l}`.trim()
    }), this.editor.on("selectionUpdate", this.handleSelectionUpdate), this.updateElementAttributes();
  }
  /**
   * Return the DOM element.
   * This is the element that will be used to display the node view.
   */
  get dom() {
    var e;
    if (this.renderer.element.firstElementChild && !(!((e = this.renderer.element.firstElementChild) === null || e === void 0) && e.hasAttribute("data-node-view-wrapper")))
      throw Error("Please use the NodeViewWrapper component for your node view.");
    return this.renderer.element;
  }
  /**
   * Return the content DOM element.
   * This is the element that will be used to display the rich-text content of the node.
   */
  get contentDOM() {
    return this.node.isLeaf ? null : this.contentDOMElement;
  }
  /**
   * On editor selection update, check if the node is selected.
   * If it is, call `selectNode`, otherwise call `deselectNode`.
   */
  handleSelectionUpdate() {
    const { from: e, to: t } = this.editor.state.selection, i = this.getPos();
    if (typeof i == "number")
      if (e <= i && t >= i + this.node.nodeSize) {
        if (this.renderer.props.selected)
          return;
        this.selectNode();
      } else {
        if (!this.renderer.props.selected)
          return;
        this.deselectNode();
      }
  }
  /**
   * On update, update the React component.
   * To prevent unnecessary updates, the `update` option can be used.
   */
  update(e, t, i) {
    const r = (o) => {
      this.renderer.updateProps(o), typeof this.options.attrs == "function" && this.updateElementAttributes();
    };
    if (e.type !== this.node.type)
      return !1;
    if (typeof this.options.update == "function") {
      const o = this.node, s = this.decorations, a = this.innerDecorations;
      return this.node = e, this.decorations = t, this.innerDecorations = i, this.options.update({
        oldNode: o,
        oldDecorations: s,
        newNode: e,
        newDecorations: t,
        oldInnerDecorations: a,
        innerDecorations: i,
        updateProps: () => r({ node: e, decorations: t, innerDecorations: i })
      });
    }
    return e === this.node && this.decorations === t && this.innerDecorations === i || (this.node = e, this.decorations = t, this.innerDecorations = i, r({ node: e, decorations: t, innerDecorations: i })), !0;
  }
  /**
   * Select the node.
   * Add the `selected` prop and the `ProseMirror-selectednode` class.
   */
  selectNode() {
    this.renderer.updateProps({
      selected: !0
    }), this.renderer.element.classList.add("ProseMirror-selectednode");
  }
  /**
   * Deselect the node.
   * Remove the `selected` prop and the `ProseMirror-selectednode` class.
   */
  deselectNode() {
    this.renderer.updateProps({
      selected: !1
    }), this.renderer.element.classList.remove("ProseMirror-selectednode");
  }
  /**
   * Destroy the React component instance.
   */
  destroy() {
    this.renderer.destroy(), this.editor.off("selectionUpdate", this.handleSelectionUpdate), this.contentDOMElement = null;
  }
  /**
   * Update the attributes of the top-level element that holds the React component.
   * Applying the attributes defined in the `attrs` option.
   */
  updateElementAttributes() {
    if (this.options.attrs) {
      let e = {};
      if (typeof this.options.attrs == "function") {
        const t = this.editor.extensionManager.attributes, i = Io(this.node, t);
        e = this.options.attrs({ node: this.node, HTMLAttributes: i });
      } else
        e = this.options.attrs;
      this.renderer.updateAttributes(e);
    }
  }
}
function qi(n, e) {
  return (t) => t.editor.contentComponent ? new J4(n, t, e) : {};
}
var eo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function G4(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var xa, od;
function Y4() {
  if (od) return xa;
  od = 1;
  var n = "Expected a function", e = NaN, t = "[object Symbol]", i = /^\s+|\s+$/g, r = /^[-+]0x[0-9a-f]+$/i, o = /^0b[01]+$/i, s = /^0o[0-7]+$/i, a = parseInt, l = typeof eo == "object" && eo && eo.Object === Object && eo, c = typeof self == "object" && self && self.Object === Object && self, u = l || c || Function("return this")(), d = Object.prototype, h = d.toString, f = Math.max, p = Math.min, m = function() {
    return u.Date.now();
  };
  function g(v, y, w) {
    var $, A, z, N, D, j, U = 0, Y = !1, B = !1, K = !0;
    if (typeof v != "function")
      throw new TypeError(n);
    y = _(y) || 0, k(w) && (Y = !!w.leading, B = "maxWait" in w, z = B ? f(_(w.maxWait) || 0, y) : z, K = "trailing" in w ? !!w.trailing : K);
    function V(re) {
      var be = $, je = A;
      return $ = A = void 0, U = re, N = v.apply(je, be), N;
    }
    function pe(re) {
      return U = re, D = setTimeout(Q, y), Y ? V(re) : N;
    }
    function me(re) {
      var be = re - j, je = re - U, it = y - be;
      return B ? p(it, z - je) : it;
    }
    function Z(re) {
      var be = re - j, je = re - U;
      return j === void 0 || be >= y || be < 0 || B && je >= z;
    }
    function Q() {
      var re = m();
      if (Z(re))
        return X(re);
      D = setTimeout(Q, me(re));
    }
    function X(re) {
      return D = void 0, K && $ ? V(re) : ($ = A = void 0, N);
    }
    function $e() {
      D !== void 0 && clearTimeout(D), U = 0, $ = j = A = D = void 0;
    }
    function we() {
      return D === void 0 ? N : X(m());
    }
    function Oe() {
      var re = m(), be = Z(re);
      if ($ = arguments, A = this, j = re, be) {
        if (D === void 0)
          return pe(j);
        if (B)
          return D = setTimeout(Q, y), V(j);
      }
      return D === void 0 && (D = setTimeout(Q, y)), N;
    }
    return Oe.cancel = $e, Oe.flush = we, Oe;
  }
  function k(v) {
    var y = typeof v;
    return !!v && (y == "object" || y == "function");
  }
  function x(v) {
    return !!v && typeof v == "object";
  }
  function S(v) {
    return typeof v == "symbol" || x(v) && h.call(v) == t;
  }
  function _(v) {
    if (typeof v == "number")
      return v;
    if (S(v))
      return e;
    if (k(v)) {
      var y = typeof v.valueOf == "function" ? v.valueOf() : v;
      v = k(y) ? y + "" : y;
    }
    if (typeof v != "string")
      return v === 0 ? v : +v;
    v = v.replace(i, "");
    var w = o.test(v);
    return w || s.test(v) ? a(v.slice(2), w ? 2 : 8) : r.test(v) ? e : +v;
  }
  return xa = g, xa;
}
var X4 = Y4();
const Q4 = /* @__PURE__ */ G4(X4);
function eR({
  hint: n,
  editor: e,
  className: t
}) {
  if (!e) return null;
  const i = e.storage.characterCount.characters() || "";
  return i ? /* @__PURE__ */ b(Eh, { label: n ?? "", showHint: !!n, className: W(t, "h-5"), children: /* @__PURE__ */ b("span", { className: "mt-[2px]", children: i }) }) : /* @__PURE__ */ b("div", { className: W(t, "h-5") });
}
function zr(n) {
  "@babel/helpers - typeof";
  return zr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, zr(n);
}
function tR(n, e) {
  if (zr(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(n, e);
    if (zr(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
function Wp(n) {
  var e = tR(n, "string");
  return zr(e) == "symbol" ? e : e + "";
}
function nR(n, e, t) {
  return (e = Wp(e)) in n ? Object.defineProperty(n, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[e] = t, n;
}
function iR(n, e) {
  if (!(n instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function rR(n, e) {
  for (var t = 0; t < e.length; t++) {
    var i = e[t];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(n, Wp(i.key), i);
  }
}
function oR(n, e, t) {
  return e && rR(n.prototype, e), Object.defineProperty(n, "prototype", {
    writable: !1
  }), n;
}
var sR = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, aR = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, lR = function(e) {
  return aR[e];
}, cR = function(e) {
  return e.replace(sR, lR);
};
function sd(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(n);
    e && (i = i.filter(function(r) {
      return Object.getOwnPropertyDescriptor(n, r).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function ad(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? sd(Object(t), !0).forEach(function(i) {
      nR(n, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : sd(Object(t)).forEach(function(i) {
      Object.defineProperty(n, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return n;
}
var ld = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: cR
};
Cs();
function uR() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  ld = ad(ad({}, ld), n);
}
(function() {
  function n() {
    iR(this, n), this.usedNamespaces = {};
  }
  return oR(n, [{
    key: "addUsedNamespaces",
    value: function(t) {
      var i = this;
      t.forEach(function(r) {
        i.usedNamespaces[r] || (i.usedNamespaces[r] = !0);
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function() {
      return Object.keys(this.usedNamespaces);
    }
  }]), n;
})();
var dR = {
  type: "3rdParty",
  init: function(e) {
    uR(e.options.react);
  }
};
const H = (n) => typeof n == "string", Wi = () => {
  let n, e;
  const t = new Promise((i, r) => {
    n = i, e = r;
  });
  return t.resolve = n, t.reject = e, t;
}, cd = (n) => n == null ? "" : "" + n, hR = (n, e, t) => {
  n.forEach((i) => {
    e[i] && (t[i] = e[i]);
  });
}, fR = /###/g, ud = (n) => n && n.indexOf("###") > -1 ? n.replace(fR, ".") : n, dd = (n) => !n || H(n), sr = (n, e, t) => {
  const i = H(e) ? e.split(".") : e;
  let r = 0;
  for (; r < i.length - 1; ) {
    if (dd(n)) return {};
    const o = ud(i[r]);
    !n[o] && t && (n[o] = new t()), Object.prototype.hasOwnProperty.call(n, o) ? n = n[o] : n = {}, ++r;
  }
  return dd(n) ? {} : {
    obj: n,
    k: ud(i[r])
  };
}, hd = (n, e, t) => {
  const {
    obj: i,
    k: r
  } = sr(n, e, Object);
  if (i !== void 0 || e.length === 1) {
    i[r] = t;
    return;
  }
  let o = e[e.length - 1], s = e.slice(0, e.length - 1), a = sr(n, s, Object);
  for (; a.obj === void 0 && s.length; )
    o = `${s[s.length - 1]}.${o}`, s = s.slice(0, s.length - 1), a = sr(n, s, Object), a && a.obj && typeof a.obj[`${a.k}.${o}`] < "u" && (a.obj = void 0);
  a.obj[`${a.k}.${o}`] = t;
}, pR = (n, e, t, i) => {
  const {
    obj: r,
    k: o
  } = sr(n, e, Object);
  r[o] = r[o] || [], r[o].push(t);
}, qo = (n, e) => {
  const {
    obj: t,
    k: i
  } = sr(n, e);
  if (t)
    return t[i];
}, mR = (n, e, t) => {
  const i = qo(n, t);
  return i !== void 0 ? i : qo(e, t);
}, Kp = (n, e, t) => {
  for (const i in e)
    i !== "__proto__" && i !== "constructor" && (i in n ? H(n[i]) || n[i] instanceof String || H(e[i]) || e[i] instanceof String ? t && (n[i] = e[i]) : Kp(n[i], e[i], t) : n[i] = e[i]);
  return n;
}, vi = (n) => n.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var gR = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const _R = (n) => H(n) ? n.replace(/[&<>"'\/]/g, (e) => gR[e]) : n;
class bR {
  constructor(e) {
    this.capacity = e, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(e) {
    const t = this.regExpMap.get(e);
    if (t !== void 0)
      return t;
    const i = new RegExp(e);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(e, i), this.regExpQueue.push(e), i;
  }
}
const kR = [" ", ",", "?", "!", ";"], yR = new bR(20), vR = (n, e, t) => {
  e = e || "", t = t || "";
  const i = kR.filter((s) => e.indexOf(s) < 0 && t.indexOf(s) < 0);
  if (i.length === 0) return !0;
  const r = yR.getRegExp(`(${i.map((s) => s === "?" ? "\\?" : s).join("|")})`);
  let o = !r.test(n);
  if (!o) {
    const s = n.indexOf(t);
    s > 0 && !r.test(n.substring(0, s)) && (o = !0);
  }
  return o;
}, ml = function(n, e) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!n) return;
  if (n[e]) return n[e];
  const i = e.split(t);
  let r = n;
  for (let o = 0; o < i.length; ) {
    if (!r || typeof r != "object")
      return;
    let s, a = "";
    for (let l = o; l < i.length; ++l)
      if (l !== o && (a += t), a += i[l], s = r[a], s !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof s) > -1 && l < i.length - 1)
          continue;
        o += l - o + 1;
        break;
      }
    r = s;
  }
  return r;
}, Ho = (n) => n && n.replace("_", "-"), xR = {
  type: "logger",
  log(n) {
    this.output("log", n);
  },
  warn(n) {
    this.output("warn", n);
  },
  error(n) {
    this.output("error", n);
  },
  output(n, e) {
    console && console[n] && console[n].apply(console, e);
  }
};
class Vo {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(e, t);
  }
  init(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = t.prefix || "i18next:", this.logger = e || xR, this.options = t, this.debug = t.debug;
  }
  log() {
    for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
      t[i] = arguments[i];
    return this.forward(t, "log", "", !0);
  }
  warn() {
    for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
      t[i] = arguments[i];
    return this.forward(t, "warn", "", !0);
  }
  error() {
    for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
      t[i] = arguments[i];
    return this.forward(t, "error", "");
  }
  deprecate() {
    for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
      t[i] = arguments[i];
    return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(e, t, i, r) {
    return r && !this.debug ? null : (H(e[0]) && (e[0] = `${i}${this.prefix} ${e[0]}`), this.logger[t](e));
  }
  create(e) {
    return new Vo(this.logger, {
      prefix: `${this.prefix}:${e}:`,
      ...this.options
    });
  }
  clone(e) {
    return e = e || this.options, e.prefix = e.prefix || this.prefix, new Vo(this.logger, e);
  }
}
var Ft = new Vo();
class Vs {
  constructor() {
    this.observers = {};
  }
  on(e, t) {
    return e.split(" ").forEach((i) => {
      this.observers[i] || (this.observers[i] = /* @__PURE__ */ new Map());
      const r = this.observers[i].get(t) || 0;
      this.observers[i].set(t, r + 1);
    }), this;
  }
  off(e, t) {
    if (this.observers[e]) {
      if (!t) {
        delete this.observers[e];
        return;
      }
      this.observers[e].delete(t);
    }
  }
  emit(e) {
    for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
      i[r - 1] = arguments[r];
    this.observers[e] && Array.from(this.observers[e].entries()).forEach((s) => {
      let [a, l] = s;
      for (let c = 0; c < l; c++)
        a(...i);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((s) => {
      let [a, l] = s;
      for (let c = 0; c < l; c++)
        a.apply(a, [e, ...i]);
    });
  }
}
class fd extends Vs {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = e || {}, this.options = t, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(e) {
    this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
  }
  removeNamespaces(e) {
    const t = this.options.ns.indexOf(e);
    t > -1 && this.options.ns.splice(t, 1);
  }
  getResource(e, t, i) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const o = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator, s = r.ignoreJSONStructure !== void 0 ? r.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let a;
    e.indexOf(".") > -1 ? a = e.split(".") : (a = [e, t], i && (Array.isArray(i) ? a.push(...i) : H(i) && o ? a.push(...i.split(o)) : a.push(i)));
    const l = qo(this.data, a);
    return !l && !t && !i && e.indexOf(".") > -1 && (e = a[0], t = a[1], i = a.slice(2).join(".")), l || !s || !H(i) ? l : ml(this.data && this.data[e] && this.data[e][t], i, o);
  }
  addResource(e, t, i, r) {
    let o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const s = o.keySeparator !== void 0 ? o.keySeparator : this.options.keySeparator;
    let a = [e, t];
    i && (a = a.concat(s ? i.split(s) : i)), e.indexOf(".") > -1 && (a = e.split("."), r = t, t = a[1]), this.addNamespaces(t), hd(this.data, a, r), o.silent || this.emit("added", e, t, i, r);
  }
  addResources(e, t, i) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const o in i)
      (H(i[o]) || Array.isArray(i[o])) && this.addResource(e, t, o, i[o], {
        silent: !0
      });
    r.silent || this.emit("added", e, t, i);
  }
  addResourceBundle(e, t, i, r, o) {
    let s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, a = [e, t];
    e.indexOf(".") > -1 && (a = e.split("."), r = i, i = t, t = a[1]), this.addNamespaces(t);
    let l = qo(this.data, a) || {};
    s.skipCopy || (i = JSON.parse(JSON.stringify(i))), r ? Kp(l, i, o) : l = {
      ...l,
      ...i
    }, hd(this.data, a, l), s.silent || this.emit("added", e, t, i);
  }
  removeResourceBundle(e, t) {
    this.hasResourceBundle(e, t) && delete this.data[e][t], this.removeNamespaces(t), this.emit("removed", e, t);
  }
  hasResourceBundle(e, t) {
    return this.getResource(e, t) !== void 0;
  }
  getResourceBundle(e, t) {
    return t || (t = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(e, t)
    } : this.getResource(e, t);
  }
  getDataByLanguage(e) {
    return this.data[e];
  }
  hasLanguageSomeTranslations(e) {
    const t = this.getDataByLanguage(e);
    return !!(t && Object.keys(t) || []).find((r) => t[r] && Object.keys(t[r]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var Zp = {
  processors: {},
  addPostProcessor(n) {
    this.processors[n.name] = n;
  },
  handle(n, e, t, i, r) {
    return n.forEach((o) => {
      this.processors[o] && (e = this.processors[o].process(e, t, i, r));
    }), e;
  }
};
const pd = {};
class Uo extends Vs {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), hR(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, this), this.options = t, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Ft.create("translator");
  }
  changeLanguage(e) {
    e && (this.language = e);
  }
  exists(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (e == null)
      return !1;
    const i = this.resolve(e, t);
    return i && i.res !== void 0;
  }
  extractFromKey(e, t) {
    let i = t.nsSeparator !== void 0 ? t.nsSeparator : this.options.nsSeparator;
    i === void 0 && (i = ":");
    const r = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator;
    let o = t.ns || this.options.defaultNS || [];
    const s = i && e.indexOf(i) > -1, a = !this.options.userDefinedKeySeparator && !t.keySeparator && !this.options.userDefinedNsSeparator && !t.nsSeparator && !vR(e, i, r);
    if (s && !a) {
      const l = e.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: e,
          namespaces: H(o) ? [o] : o
        };
      const c = e.split(i);
      (i !== r || i === r && this.options.ns.indexOf(c[0]) > -1) && (o = c.shift()), e = c.join(r);
    }
    return {
      key: e,
      namespaces: H(o) ? [o] : o
    };
  }
  translate(e, t, i) {
    if (typeof t != "object" && this.options.overloadTranslationOptionHandler && (t = this.options.overloadTranslationOptionHandler(arguments)), typeof t == "object" && (t = {
      ...t
    }), t || (t = {}), e == null) return "";
    Array.isArray(e) || (e = [String(e)]);
    const r = t.returnDetails !== void 0 ? t.returnDetails : this.options.returnDetails, o = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator, {
      key: s,
      namespaces: a
    } = this.extractFromKey(e[e.length - 1], t), l = a[a.length - 1], c = t.lng || this.language, u = t.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (c && c.toLowerCase() === "cimode") {
      if (u) {
        const _ = t.nsSeparator || this.options.nsSeparator;
        return r ? {
          res: `${l}${_}${s}`,
          usedKey: s,
          exactUsedKey: s,
          usedLng: c,
          usedNS: l,
          usedParams: this.getUsedParamsDetails(t)
        } : `${l}${_}${s}`;
      }
      return r ? {
        res: s,
        usedKey: s,
        exactUsedKey: s,
        usedLng: c,
        usedNS: l,
        usedParams: this.getUsedParamsDetails(t)
      } : s;
    }
    const d = this.resolve(e, t);
    let h = d && d.res;
    const f = d && d.usedKey || s, p = d && d.exactUsedKey || s, m = Object.prototype.toString.apply(h), g = ["[object Number]", "[object Function]", "[object RegExp]"], k = t.joinArrays !== void 0 ? t.joinArrays : this.options.joinArrays, x = !this.i18nFormat || this.i18nFormat.handleAsObject, S = !H(h) && typeof h != "boolean" && typeof h != "number";
    if (x && h && S && g.indexOf(m) < 0 && !(H(k) && Array.isArray(h))) {
      if (!t.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const _ = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(f, h, {
          ...t,
          ns: a
        }) : `key '${s} (${this.language})' returned an object instead of string.`;
        return r ? (d.res = _, d.usedParams = this.getUsedParamsDetails(t), d) : _;
      }
      if (o) {
        const _ = Array.isArray(h), v = _ ? [] : {}, y = _ ? p : f;
        for (const w in h)
          if (Object.prototype.hasOwnProperty.call(h, w)) {
            const $ = `${y}${o}${w}`;
            v[w] = this.translate($, {
              ...t,
              joinArrays: !1,
              ns: a
            }), v[w] === $ && (v[w] = h[w]);
          }
        h = v;
      }
    } else if (x && H(k) && Array.isArray(h))
      h = h.join(k), h && (h = this.extendTranslation(h, e, t, i));
    else {
      let _ = !1, v = !1;
      const y = t.count !== void 0 && !H(t.count), w = Uo.hasDefaultValue(t), $ = y ? this.pluralResolver.getSuffix(c, t.count, t) : "", A = t.ordinal && y ? this.pluralResolver.getSuffix(c, t.count, {
        ordinal: !1
      }) : "", z = y && !t.ordinal && t.count === 0 && this.pluralResolver.shouldUseIntlApi(), N = z && t[`defaultValue${this.options.pluralSeparator}zero`] || t[`defaultValue${$}`] || t[`defaultValue${A}`] || t.defaultValue;
      !this.isValidLookup(h) && w && (_ = !0, h = N), this.isValidLookup(h) || (v = !0, h = s);
      const j = (t.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && v ? void 0 : h, U = w && N !== h && this.options.updateMissing;
      if (v || _ || U) {
        if (this.logger.log(U ? "updateKey" : "missingKey", c, l, s, U ? N : h), o) {
          const V = this.resolve(s, {
            ...t,
            keySeparator: !1
          });
          V && V.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let Y = [];
        const B = this.languageUtils.getFallbackCodes(this.options.fallbackLng, t.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && B && B[0])
          for (let V = 0; V < B.length; V++)
            Y.push(B[V]);
        else this.options.saveMissingTo === "all" ? Y = this.languageUtils.toResolveHierarchy(t.lng || this.language) : Y.push(t.lng || this.language);
        const K = (V, pe, me) => {
          const Z = w && me !== h ? me : j;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(V, l, pe, Z, U, t) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(V, l, pe, Z, U, t), this.emit("missingKey", V, l, pe, h);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && y ? Y.forEach((V) => {
          const pe = this.pluralResolver.getSuffixes(V, t);
          z && t[`defaultValue${this.options.pluralSeparator}zero`] && pe.indexOf(`${this.options.pluralSeparator}zero`) < 0 && pe.push(`${this.options.pluralSeparator}zero`), pe.forEach((me) => {
            K([V], s + me, t[`defaultValue${me}`] || N);
          });
        }) : K(Y, s, N));
      }
      h = this.extendTranslation(h, e, t, d, i), v && h === s && this.options.appendNamespaceToMissingKey && (h = `${l}:${s}`), (v || _) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? h = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${l}:${s}` : s, _ ? h : void 0) : h = this.options.parseMissingKeyHandler(h));
    }
    return r ? (d.res = h, d.usedParams = this.getUsedParamsDetails(t), d) : h;
  }
  extendTranslation(e, t, i, r, o) {
    var s = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      e = this.i18nFormat.parse(e, {
        ...this.options.interpolation.defaultVariables,
        ...i
      }, i.lng || this.language || r.usedLng, r.usedNS, r.usedKey, {
        resolved: r
      });
    else if (!i.skipInterpolation) {
      i.interpolation && this.interpolator.init({
        ...i,
        interpolation: {
          ...this.options.interpolation,
          ...i.interpolation
        }
      });
      const c = H(e) && (i && i.interpolation && i.interpolation.skipOnVariables !== void 0 ? i.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let u;
      if (c) {
        const h = e.match(this.interpolator.nestingRegexp);
        u = h && h.length;
      }
      let d = i.replace && !H(i.replace) ? i.replace : i;
      if (this.options.interpolation.defaultVariables && (d = {
        ...this.options.interpolation.defaultVariables,
        ...d
      }), e = this.interpolator.interpolate(e, d, i.lng || this.language || r.usedLng, i), c) {
        const h = e.match(this.interpolator.nestingRegexp), f = h && h.length;
        u < f && (i.nest = !1);
      }
      !i.lng && this.options.compatibilityAPI !== "v1" && r && r.res && (i.lng = this.language || r.usedLng), i.nest !== !1 && (e = this.interpolator.nest(e, function() {
        for (var h = arguments.length, f = new Array(h), p = 0; p < h; p++)
          f[p] = arguments[p];
        return o && o[0] === f[0] && !i.context ? (s.logger.warn(`It seems you are nesting recursively key: ${f[0]} in key: ${t[0]}`), null) : s.translate(...f, t);
      }, i)), i.interpolation && this.interpolator.reset();
    }
    const a = i.postProcess || this.options.postProcess, l = H(a) ? [a] : a;
    return e != null && l && l.length && i.applyPostProcessor !== !1 && (e = Zp.handle(l, e, t, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...r,
        usedParams: this.getUsedParamsDetails(i)
      },
      ...i
    } : i, this)), e;
  }
  resolve(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i, r, o, s, a;
    return H(e) && (e = [e]), e.forEach((l) => {
      if (this.isValidLookup(i)) return;
      const c = this.extractFromKey(l, t), u = c.key;
      r = u;
      let d = c.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const h = t.count !== void 0 && !H(t.count), f = h && !t.ordinal && t.count === 0 && this.pluralResolver.shouldUseIntlApi(), p = t.context !== void 0 && (H(t.context) || typeof t.context == "number") && t.context !== "", m = t.lngs ? t.lngs : this.languageUtils.toResolveHierarchy(t.lng || this.language, t.fallbackLng);
      d.forEach((g) => {
        this.isValidLookup(i) || (a = g, !pd[`${m[0]}-${g}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(a) && (pd[`${m[0]}-${g}`] = !0, this.logger.warn(`key "${r}" for languages "${m.join(", ")}" won't get resolved as namespace "${a}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), m.forEach((k) => {
          if (this.isValidLookup(i)) return;
          s = k;
          const x = [u];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(x, u, k, g, t);
          else {
            let _;
            h && (_ = this.pluralResolver.getSuffix(k, t.count, t));
            const v = `${this.options.pluralSeparator}zero`, y = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (h && (x.push(u + _), t.ordinal && _.indexOf(y) === 0 && x.push(u + _.replace(y, this.options.pluralSeparator)), f && x.push(u + v)), p) {
              const w = `${u}${this.options.contextSeparator}${t.context}`;
              x.push(w), h && (x.push(w + _), t.ordinal && _.indexOf(y) === 0 && x.push(w + _.replace(y, this.options.pluralSeparator)), f && x.push(w + v));
            }
          }
          let S;
          for (; S = x.pop(); )
            this.isValidLookup(i) || (o = S, i = this.getResource(k, g, S, t));
        }));
      });
    }), {
      res: i,
      usedKey: r,
      exactUsedKey: o,
      usedLng: s,
      usedNS: a
    };
  }
  isValidLookup(e) {
    return e !== void 0 && !(!this.options.returnNull && e === null) && !(!this.options.returnEmptyString && e === "");
  }
  getResource(e, t, i) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(e, t, i, r) : this.resourceStore.getResource(e, t, i, r);
  }
  getUsedParamsDetails() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const t = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], i = e.replace && !H(e.replace);
    let r = i ? e.replace : e;
    if (i && typeof e.count < "u" && (r.count = e.count), this.options.interpolation.defaultVariables && (r = {
      ...this.options.interpolation.defaultVariables,
      ...r
    }), !i) {
      r = {
        ...r
      };
      for (const o of t)
        delete r[o];
    }
    return r;
  }
  static hasDefaultValue(e) {
    const t = "defaultValue";
    for (const i in e)
      if (Object.prototype.hasOwnProperty.call(e, i) && t === i.substring(0, t.length) && e[i] !== void 0)
        return !0;
    return !1;
  }
}
const Sa = (n) => n.charAt(0).toUpperCase() + n.slice(1);
class md {
  constructor(e) {
    this.options = e, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Ft.create("languageUtils");
  }
  getScriptPartFromCode(e) {
    if (e = Ho(e), !e || e.indexOf("-") < 0) return null;
    const t = e.split("-");
    return t.length === 2 || (t.pop(), t[t.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(t.join("-"));
  }
  getLanguagePartFromCode(e) {
    if (e = Ho(e), !e || e.indexOf("-") < 0) return e;
    const t = e.split("-");
    return this.formatLanguageCode(t[0]);
  }
  formatLanguageCode(e) {
    if (H(e) && e.indexOf("-") > -1) {
      if (typeof Intl < "u" && typeof Intl.getCanonicalLocales < "u")
        try {
          let r = Intl.getCanonicalLocales(e)[0];
          if (r && this.options.lowerCaseLng && (r = r.toLowerCase()), r) return r;
        } catch {
        }
      const t = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let i = e.split("-");
      return this.options.lowerCaseLng ? i = i.map((r) => r.toLowerCase()) : i.length === 2 ? (i[0] = i[0].toLowerCase(), i[1] = i[1].toUpperCase(), t.indexOf(i[1].toLowerCase()) > -1 && (i[1] = Sa(i[1].toLowerCase()))) : i.length === 3 && (i[0] = i[0].toLowerCase(), i[1].length === 2 && (i[1] = i[1].toUpperCase()), i[0] !== "sgn" && i[2].length === 2 && (i[2] = i[2].toUpperCase()), t.indexOf(i[1].toLowerCase()) > -1 && (i[1] = Sa(i[1].toLowerCase())), t.indexOf(i[2].toLowerCase()) > -1 && (i[2] = Sa(i[2].toLowerCase()))), i.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
  }
  isSupportedCode(e) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
  }
  getBestMatchFromCodes(e) {
    if (!e) return null;
    let t;
    return e.forEach((i) => {
      if (t) return;
      const r = this.formatLanguageCode(i);
      (!this.options.supportedLngs || this.isSupportedCode(r)) && (t = r);
    }), !t && this.options.supportedLngs && e.forEach((i) => {
      if (t) return;
      const r = this.getLanguagePartFromCode(i);
      if (this.isSupportedCode(r)) return t = r;
      t = this.options.supportedLngs.find((o) => {
        if (o === r) return o;
        if (!(o.indexOf("-") < 0 && r.indexOf("-") < 0) && (o.indexOf("-") > 0 && r.indexOf("-") < 0 && o.substring(0, o.indexOf("-")) === r || o.indexOf(r) === 0 && r.length > 1))
          return o;
      });
    }), t || (t = this.getFallbackCodes(this.options.fallbackLng)[0]), t;
  }
  getFallbackCodes(e, t) {
    if (!e) return [];
    if (typeof e == "function" && (e = e(t)), H(e) && (e = [e]), Array.isArray(e)) return e;
    if (!t) return e.default || [];
    let i = e[t];
    return i || (i = e[this.getScriptPartFromCode(t)]), i || (i = e[this.formatLanguageCode(t)]), i || (i = e[this.getLanguagePartFromCode(t)]), i || (i = e.default), i || [];
  }
  toResolveHierarchy(e, t) {
    const i = this.getFallbackCodes(t || this.options.fallbackLng || [], e), r = [], o = (s) => {
      s && (this.isSupportedCode(s) ? r.push(s) : this.logger.warn(`rejecting language code not found in supportedLngs: ${s}`));
    };
    return H(e) && (e.indexOf("-") > -1 || e.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && o(this.formatLanguageCode(e)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && o(this.getScriptPartFromCode(e)), this.options.load !== "currentOnly" && o(this.getLanguagePartFromCode(e))) : H(e) && o(this.formatLanguageCode(e)), i.forEach((s) => {
      r.indexOf(s) < 0 && o(this.formatLanguageCode(s));
    }), r;
  }
}
let SR = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], wR = {
  1: (n) => +(n > 1),
  2: (n) => +(n != 1),
  3: (n) => 0,
  4: (n) => n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2,
  5: (n) => n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5,
  6: (n) => n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2,
  7: (n) => n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2,
  8: (n) => n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3,
  9: (n) => +(n >= 2),
  10: (n) => n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4,
  11: (n) => n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3,
  12: (n) => +(n % 10 != 1 || n % 100 == 11),
  13: (n) => +(n !== 0),
  14: (n) => n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3,
  15: (n) => n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2,
  16: (n) => n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2,
  17: (n) => n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1,
  18: (n) => n == 0 ? 0 : n == 1 ? 1 : 2,
  19: (n) => n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3,
  20: (n) => n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2,
  21: (n) => n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0,
  22: (n) => n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3
};
const CR = ["v1", "v2", "v3"], TR = ["v4"], gd = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, MR = () => {
  const n = {};
  return SR.forEach((e) => {
    e.lngs.forEach((t) => {
      n[t] = {
        numbers: e.nr,
        plurals: wR[e.fc]
      };
    });
  }), n;
};
class ER {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = e, this.options = t, this.logger = Ft.create("pluralResolver"), (!this.options.compatibilityJSON || TR.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = MR(), this.pluralRulesCache = {};
  }
  addRule(e, t) {
    this.rules[e] = t;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi()) {
      const i = Ho(e === "dev" ? "en" : e), r = t.ordinal ? "ordinal" : "cardinal", o = JSON.stringify({
        cleanedCode: i,
        type: r
      });
      if (o in this.pluralRulesCache)
        return this.pluralRulesCache[o];
      let s;
      try {
        s = new Intl.PluralRules(i, {
          type: r
        });
      } catch {
        if (!e.match(/-|_/)) return;
        const l = this.languageUtils.getLanguagePartFromCode(e);
        s = this.getRule(l, t);
      }
      return this.pluralRulesCache[o] = s, s;
    }
    return this.rules[e] || this.rules[this.languageUtils.getLanguagePartFromCode(e)];
  }
  needsPlural(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const i = this.getRule(e, t);
    return this.shouldUseIntlApi() ? i && i.resolvedOptions().pluralCategories.length > 1 : i && i.numbers.length > 1;
  }
  getPluralFormsOfKey(e, t) {
    let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(e, i).map((r) => `${t}${r}`);
  }
  getSuffixes(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const i = this.getRule(e, t);
    return i ? this.shouldUseIntlApi() ? i.resolvedOptions().pluralCategories.sort((r, o) => gd[r] - gd[o]).map((r) => `${this.options.prepend}${t.ordinal ? `ordinal${this.options.prepend}` : ""}${r}`) : i.numbers.map((r) => this.getSuffix(e, r, t)) : [];
  }
  getSuffix(e, t) {
    let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const r = this.getRule(e, i);
    return r ? this.shouldUseIntlApi() ? `${this.options.prepend}${i.ordinal ? `ordinal${this.options.prepend}` : ""}${r.select(t)}` : this.getSuffixRetroCompatible(r, t) : (this.logger.warn(`no plural rule found for: ${e}`), "");
  }
  getSuffixRetroCompatible(e, t) {
    const i = e.noAbs ? e.plurals(t) : e.plurals(Math.abs(t));
    let r = e.numbers[i];
    this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 && (r === 2 ? r = "plural" : r === 1 && (r = ""));
    const o = () => this.options.prepend && r.toString() ? this.options.prepend + r.toString() : r.toString();
    return this.options.compatibilityJSON === "v1" ? r === 1 ? "" : typeof r == "number" ? `_plural_${r.toString()}` : o() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 ? o() : this.options.prepend && i.toString() ? this.options.prepend + i.toString() : i.toString();
  }
  shouldUseIntlApi() {
    return !CR.includes(this.options.compatibilityJSON);
  }
}
const _d = function(n, e, t) {
  let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", r = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, o = mR(n, e, t);
  return !o && r && H(t) && (o = ml(n, t, i), o === void 0 && (o = ml(e, t, i))), o;
}, wa = (n) => n.replace(/\$/g, "$$$$");
class $R {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Ft.create("interpolator"), this.options = e, this.format = e.interpolation && e.interpolation.format || ((t) => t), this.init(e);
  }
  init() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    e.interpolation || (e.interpolation = {
      escapeValue: !0
    });
    const {
      escape: t,
      escapeValue: i,
      useRawValueToEscape: r,
      prefix: o,
      prefixEscaped: s,
      suffix: a,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: u,
      unescapePrefix: d,
      nestingPrefix: h,
      nestingPrefixEscaped: f,
      nestingSuffix: p,
      nestingSuffixEscaped: m,
      nestingOptionsSeparator: g,
      maxReplaces: k,
      alwaysFormat: x
    } = e.interpolation;
    this.escape = t !== void 0 ? t : _R, this.escapeValue = i !== void 0 ? i : !0, this.useRawValueToEscape = r !== void 0 ? r : !1, this.prefix = o ? vi(o) : s || "{{", this.suffix = a ? vi(a) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = u ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = h ? vi(h) : f || vi("$t("), this.nestingSuffix = p ? vi(p) : m || vi(")"), this.nestingOptionsSeparator = g || ",", this.maxReplaces = k || 1e3, this.alwaysFormat = x !== void 0 ? x : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const e = (t, i) => t && t.source === i ? (t.lastIndex = 0, t) : new RegExp(i, "g");
    this.regexp = e(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = e(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = e(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(e, t, i, r) {
    let o, s, a;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (f) => {
      if (f.indexOf(this.formatSeparator) < 0) {
        const k = _d(t, l, f, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(k, void 0, i, {
          ...r,
          ...t,
          interpolationkey: f
        }) : k;
      }
      const p = f.split(this.formatSeparator), m = p.shift().trim(), g = p.join(this.formatSeparator).trim();
      return this.format(_d(t, l, m, this.options.keySeparator, this.options.ignoreJSONStructure), g, i, {
        ...r,
        ...t,
        interpolationkey: m
      });
    };
    this.resetRegExp();
    const u = r && r.missingInterpolationHandler || this.options.missingInterpolationHandler, d = r && r.interpolation && r.interpolation.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (f) => wa(f)
    }, {
      regex: this.regexp,
      safeValue: (f) => this.escapeValue ? wa(this.escape(f)) : wa(f)
    }].forEach((f) => {
      for (a = 0; o = f.regex.exec(e); ) {
        const p = o[1].trim();
        if (s = c(p), s === void 0)
          if (typeof u == "function") {
            const g = u(e, o, r);
            s = H(g) ? g : "";
          } else if (r && Object.prototype.hasOwnProperty.call(r, p))
            s = "";
          else if (d) {
            s = o[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${p} for interpolating ${e}`), s = "";
        else !H(s) && !this.useRawValueToEscape && (s = cd(s));
        const m = f.safeValue(s);
        if (e = e.replace(o[0], m), d ? (f.regex.lastIndex += s.length, f.regex.lastIndex -= o[0].length) : f.regex.lastIndex = 0, a++, a >= this.maxReplaces)
          break;
      }
    }), e;
  }
  nest(e, t) {
    let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r, o, s;
    const a = (l, c) => {
      const u = this.nestingOptionsSeparator;
      if (l.indexOf(u) < 0) return l;
      const d = l.split(new RegExp(`${u}[ ]*{`));
      let h = `{${d[1]}`;
      l = d[0], h = this.interpolate(h, s);
      const f = h.match(/'/g), p = h.match(/"/g);
      (f && f.length % 2 === 0 && !p || p.length % 2 !== 0) && (h = h.replace(/'/g, '"'));
      try {
        s = JSON.parse(h), c && (s = {
          ...c,
          ...s
        });
      } catch (m) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, m), `${l}${u}${h}`;
      }
      return s.defaultValue && s.defaultValue.indexOf(this.prefix) > -1 && delete s.defaultValue, l;
    };
    for (; r = this.nestingRegexp.exec(e); ) {
      let l = [];
      s = {
        ...i
      }, s = s.replace && !H(s.replace) ? s.replace : s, s.applyPostProcessor = !1, delete s.defaultValue;
      let c = !1;
      if (r[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(r[1])) {
        const u = r[1].split(this.formatSeparator).map((d) => d.trim());
        r[1] = u.shift(), l = u, c = !0;
      }
      if (o = t(a.call(this, r[1].trim(), s), s), o && r[0] === e && !H(o)) return o;
      H(o) || (o = cd(o)), o || (this.logger.warn(`missed to resolve ${r[1]} for nesting ${e}`), o = ""), c && (o = l.reduce((u, d) => this.format(u, d, i.lng, {
        ...i,
        interpolationkey: r[1].trim()
      }), o.trim())), e = e.replace(r[0], o), this.regexp.lastIndex = 0;
    }
    return e;
  }
}
const OR = (n) => {
  let e = n.toLowerCase().trim();
  const t = {};
  if (n.indexOf("(") > -1) {
    const i = n.split("(");
    e = i[0].toLowerCase().trim();
    const r = i[1].substring(0, i[1].length - 1);
    e === "currency" && r.indexOf(":") < 0 ? t.currency || (t.currency = r.trim()) : e === "relativetime" && r.indexOf(":") < 0 ? t.range || (t.range = r.trim()) : r.split(";").forEach((s) => {
      if (s) {
        const [a, ...l] = s.split(":"), c = l.join(":").trim().replace(/^'+|'+$/g, ""), u = a.trim();
        t[u] || (t[u] = c), c === "false" && (t[u] = !1), c === "true" && (t[u] = !0), isNaN(c) || (t[u] = parseInt(c, 10));
      }
    });
  }
  return {
    formatName: e,
    formatOptions: t
  };
}, xi = (n) => {
  const e = {};
  return (t, i, r) => {
    let o = r;
    r && r.interpolationkey && r.formatParams && r.formatParams[r.interpolationkey] && r[r.interpolationkey] && (o = {
      ...o,
      [r.interpolationkey]: void 0
    });
    const s = i + JSON.stringify(o);
    let a = e[s];
    return a || (a = n(Ho(i), r), e[s] = a), a(t);
  };
};
class zR {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Ft.create("formatter"), this.options = e, this.formats = {
      number: xi((t, i) => {
        const r = new Intl.NumberFormat(t, {
          ...i
        });
        return (o) => r.format(o);
      }),
      currency: xi((t, i) => {
        const r = new Intl.NumberFormat(t, {
          ...i,
          style: "currency"
        });
        return (o) => r.format(o);
      }),
      datetime: xi((t, i) => {
        const r = new Intl.DateTimeFormat(t, {
          ...i
        });
        return (o) => r.format(o);
      }),
      relativetime: xi((t, i) => {
        const r = new Intl.RelativeTimeFormat(t, {
          ...i
        });
        return (o) => r.format(o, i.range || "day");
      }),
      list: xi((t, i) => {
        const r = new Intl.ListFormat(t, {
          ...i
        });
        return (o) => r.format(o);
      })
    }, this.init(e);
  }
  init(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = t.interpolation.formatSeparator || ",";
  }
  add(e, t) {
    this.formats[e.toLowerCase().trim()] = t;
  }
  addCached(e, t) {
    this.formats[e.toLowerCase().trim()] = xi(t);
  }
  format(e, t, i) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const o = t.split(this.formatSeparator);
    if (o.length > 1 && o[0].indexOf("(") > 1 && o[0].indexOf(")") < 0 && o.find((a) => a.indexOf(")") > -1)) {
      const a = o.findIndex((l) => l.indexOf(")") > -1);
      o[0] = [o[0], ...o.splice(1, a)].join(this.formatSeparator);
    }
    return o.reduce((a, l) => {
      const {
        formatName: c,
        formatOptions: u
      } = OR(l);
      if (this.formats[c]) {
        let d = a;
        try {
          const h = r && r.formatParams && r.formatParams[r.interpolationkey] || {}, f = h.locale || h.lng || r.locale || r.lng || i;
          d = this.formats[c](a, f, {
            ...u,
            ...r,
            ...h
          });
        } catch (h) {
          this.logger.warn(h);
        }
        return d;
      } else
        this.logger.warn(`there was no format function for ${c}`);
      return a;
    }, e);
  }
}
const AR = (n, e) => {
  n.pending[e] !== void 0 && (delete n.pending[e], n.pendingCount--);
};
class NR extends Vs {
  constructor(e, t, i) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = e, this.store = t, this.services = i, this.languageUtils = i.languageUtils, this.options = r, this.logger = Ft.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = r.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = r.maxRetries >= 0 ? r.maxRetries : 5, this.retryTimeout = r.retryTimeout >= 1 ? r.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(i, r.backend, r);
  }
  queueLoad(e, t, i, r) {
    const o = {}, s = {}, a = {}, l = {};
    return e.forEach((c) => {
      let u = !0;
      t.forEach((d) => {
        const h = `${c}|${d}`;
        !i.reload && this.store.hasResourceBundle(c, d) ? this.state[h] = 2 : this.state[h] < 0 || (this.state[h] === 1 ? s[h] === void 0 && (s[h] = !0) : (this.state[h] = 1, u = !1, s[h] === void 0 && (s[h] = !0), o[h] === void 0 && (o[h] = !0), l[d] === void 0 && (l[d] = !0)));
      }), u || (a[c] = !0);
    }), (Object.keys(o).length || Object.keys(s).length) && this.queue.push({
      pending: s,
      pendingCount: Object.keys(s).length,
      loaded: {},
      errors: [],
      callback: r
    }), {
      toLoad: Object.keys(o),
      pending: Object.keys(s),
      toLoadLanguages: Object.keys(a),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(e, t, i) {
    const r = e.split("|"), o = r[0], s = r[1];
    t && this.emit("failedLoading", o, s, t), !t && i && this.store.addResourceBundle(o, s, i, void 0, void 0, {
      skipCopy: !0
    }), this.state[e] = t ? -1 : 2, t && i && (this.state[e] = 0);
    const a = {};
    this.queue.forEach((l) => {
      pR(l.loaded, [o], s), AR(l, e), t && l.errors.push(t), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        a[c] || (a[c] = {});
        const u = l.loaded[c];
        u.length && u.forEach((d) => {
          a[c][d] === void 0 && (a[c][d] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", a), this.queue = this.queue.filter((l) => !l.done);
  }
  read(e, t, i) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, s = arguments.length > 5 ? arguments[5] : void 0;
    if (!e.length) return s(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: e,
        ns: t,
        fcName: i,
        tried: r,
        wait: o,
        callback: s
      });
      return;
    }
    this.readingCalls++;
    const a = (c, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (c && u && r < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, e, t, i, r + 1, o * 2, s);
        }, o);
        return;
      }
      s(c, u);
    }, l = this.backend[i].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(e, t);
        c && typeof c.then == "function" ? c.then((u) => a(null, u)).catch(a) : a(null, c);
      } catch (c) {
        a(c);
      }
      return;
    }
    return l(e, t, a);
  }
  prepareLoading(e, t) {
    let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), r && r();
    H(e) && (e = this.languageUtils.toResolveHierarchy(e)), H(t) && (t = [t]);
    const o = this.queueLoad(e, t, i, r);
    if (!o.toLoad.length)
      return o.pending.length || r(), null;
    o.toLoad.forEach((s) => {
      this.loadOne(s);
    });
  }
  load(e, t, i) {
    this.prepareLoading(e, t, {}, i);
  }
  reload(e, t, i) {
    this.prepareLoading(e, t, {
      reload: !0
    }, i);
  }
  loadOne(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const i = e.split("|"), r = i[0], o = i[1];
    this.read(r, o, "read", void 0, void 0, (s, a) => {
      s && this.logger.warn(`${t}loading namespace ${o} for language ${r} failed`, s), !s && a && this.logger.log(`${t}loaded namespace ${o} for language ${r}`, a), this.loaded(e, s, a);
    });
  }
  saveMissing(e, t, i, r, o) {
    let s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, a = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(t)) {
      this.logger.warn(`did not save key "${i}" as the namespace "${t}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(i == null || i === "")) {
      if (this.backend && this.backend.create) {
        const l = {
          ...s,
          isUpdate: o
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let u;
            c.length === 5 ? u = c(e, t, i, r, l) : u = c(e, t, i, r), u && typeof u.then == "function" ? u.then((d) => a(null, d)).catch(a) : a(null, u);
          } catch (u) {
            a(u);
          }
        else
          c(e, t, i, r, a, l);
      }
      !e || !e[0] || this.store.addResource(e[0], t, i, r);
    }
  }
}
const bd = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (n) => {
    let e = {};
    if (typeof n[1] == "object" && (e = n[1]), H(n[1]) && (e.defaultValue = n[1]), H(n[2]) && (e.tDescription = n[2]), typeof n[2] == "object" || typeof n[3] == "object") {
      const t = n[3] || n[2];
      Object.keys(t).forEach((i) => {
        e[i] = t[i];
      });
    }
    return e;
  },
  interpolation: {
    escapeValue: !0,
    format: (n) => n,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), kd = (n) => (H(n.ns) && (n.ns = [n.ns]), H(n.fallbackLng) && (n.fallbackLng = [n.fallbackLng]), H(n.fallbackNS) && (n.fallbackNS = [n.fallbackNS]), n.supportedLngs && n.supportedLngs.indexOf("cimode") < 0 && (n.supportedLngs = n.supportedLngs.concat(["cimode"])), n), to = () => {
}, LR = (n) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(n)).forEach((t) => {
    typeof n[t] == "function" && (n[t] = n[t].bind(n));
  });
};
class Ar extends Vs {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = kd(e), this.services = {}, this.logger = Ft, this.modules = {
      external: []
    }, LR(this), t && !this.isInitialized && !e.isClone) {
      if (!this.options.initImmediate)
        return this.init(e, t), this;
      setTimeout(() => {
        this.init(e, t);
      }, 0);
    }
  }
  init() {
    var e = this;
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof t == "function" && (i = t, t = {}), !t.defaultNS && t.defaultNS !== !1 && t.ns && (H(t.ns) ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
    const r = bd();
    this.options = {
      ...r,
      ...this.options,
      ...kd(t)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...r.interpolation,
      ...this.options.interpolation
    }), t.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = t.keySeparator), t.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = t.nsSeparator);
    const o = (u) => u ? typeof u == "function" ? new u() : u : null;
    if (!this.options.isClone) {
      this.modules.logger ? Ft.init(o(this.modules.logger), this.options) : Ft.init(null, this.options);
      let u;
      this.modules.formatter ? u = this.modules.formatter : typeof Intl < "u" && (u = zR);
      const d = new md(this.options);
      this.store = new fd(this.options.resources, this.options);
      const h = this.services;
      h.logger = Ft, h.resourceStore = this.store, h.languageUtils = d, h.pluralResolver = new ER(d, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), u && (!this.options.interpolation.format || this.options.interpolation.format === r.interpolation.format) && (h.formatter = o(u), h.formatter.init(h, this.options), this.options.interpolation.format = h.formatter.format.bind(h.formatter)), h.interpolator = new $R(this.options), h.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, h.backendConnector = new NR(o(this.modules.backend), h.resourceStore, h, this.options), h.backendConnector.on("*", function(f) {
        for (var p = arguments.length, m = new Array(p > 1 ? p - 1 : 0), g = 1; g < p; g++)
          m[g - 1] = arguments[g];
        e.emit(f, ...m);
      }), this.modules.languageDetector && (h.languageDetector = o(this.modules.languageDetector), h.languageDetector.init && h.languageDetector.init(h, this.options.detection, this.options)), this.modules.i18nFormat && (h.i18nFormat = o(this.modules.i18nFormat), h.i18nFormat.init && h.i18nFormat.init(this)), this.translator = new Uo(this.services, this.options), this.translator.on("*", function(f) {
        for (var p = arguments.length, m = new Array(p > 1 ? p - 1 : 0), g = 1; g < p; g++)
          m[g - 1] = arguments[g];
        e.emit(f, ...m);
      }), this.modules.external.forEach((f) => {
        f.init && f.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, i || (i = to), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const u = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      u.length > 0 && u[0] !== "dev" && (this.options.lng = u[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((u) => {
      this[u] = function() {
        return e.store[u](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((u) => {
      this[u] = function() {
        return e.store[u](...arguments), e;
      };
    });
    const l = Wi(), c = () => {
      const u = (d, h) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), l.resolve(h), i(d, h);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return u(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, u);
    };
    return this.options.resources || !this.options.initImmediate ? c() : setTimeout(c, 0), l;
  }
  loadResources(e) {
    let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : to;
    const r = H(e) ? e : this.language;
    if (typeof e == "function" && (i = e), !this.options.resources || this.options.partialBundledLanguages) {
      if (r && r.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return i();
      const o = [], s = (a) => {
        if (!a || a === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(a).forEach((c) => {
          c !== "cimode" && o.indexOf(c) < 0 && o.push(c);
        });
      };
      r ? s(r) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => s(l)), this.options.preload && this.options.preload.forEach((a) => s(a)), this.services.backendConnector.load(o, this.options.ns, (a) => {
        !a && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), i(a);
      });
    } else
      i(null);
  }
  reloadResources(e, t, i) {
    const r = Wi();
    return typeof e == "function" && (i = e, e = void 0), typeof t == "function" && (i = t, t = void 0), e || (e = this.languages), t || (t = this.options.ns), i || (i = to), this.services.backendConnector.reload(e, t, (o) => {
      r.resolve(), i(o);
    }), r;
  }
  use(e) {
    if (!e) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!e.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return e.type === "backend" && (this.modules.backend = e), (e.type === "logger" || e.log && e.warn && e.error) && (this.modules.logger = e), e.type === "languageDetector" && (this.modules.languageDetector = e), e.type === "i18nFormat" && (this.modules.i18nFormat = e), e.type === "postProcessor" && Zp.addPostProcessor(e), e.type === "formatter" && (this.modules.formatter = e), e.type === "3rdParty" && this.modules.external.push(e), this;
  }
  setResolvedLanguage(e) {
    if (!(!e || !this.languages) && !(["cimode", "dev"].indexOf(e) > -1))
      for (let t = 0; t < this.languages.length; t++) {
        const i = this.languages[t];
        if (!(["cimode", "dev"].indexOf(i) > -1) && this.store.hasLanguageSomeTranslations(i)) {
          this.resolvedLanguage = i;
          break;
        }
      }
  }
  changeLanguage(e, t) {
    var i = this;
    this.isLanguageChangingTo = e;
    const r = Wi();
    this.emit("languageChanging", e);
    const o = (l) => {
      this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
    }, s = (l, c) => {
      c ? (o(c), this.translator.changeLanguage(c), this.isLanguageChangingTo = void 0, this.emit("languageChanged", c), this.logger.log("languageChanged", c)) : this.isLanguageChangingTo = void 0, r.resolve(function() {
        return i.t(...arguments);
      }), t && t(l, function() {
        return i.t(...arguments);
      });
    }, a = (l) => {
      !e && !l && this.services.languageDetector && (l = []);
      const c = H(l) ? l : this.services.languageUtils.getBestMatchFromCodes(l);
      c && (this.language || o(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(c)), this.loadResources(c, (u) => {
        s(u, c);
      });
    };
    return !e && this.services.languageDetector && !this.services.languageDetector.async ? a(this.services.languageDetector.detect()) : !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(a) : this.services.languageDetector.detect(a) : a(e), r;
  }
  getFixedT(e, t, i) {
    var r = this;
    const o = function(s, a) {
      let l;
      if (typeof a != "object") {
        for (var c = arguments.length, u = new Array(c > 2 ? c - 2 : 0), d = 2; d < c; d++)
          u[d - 2] = arguments[d];
        l = r.options.overloadTranslationOptionHandler([s, a].concat(u));
      } else
        l = {
          ...a
        };
      l.lng = l.lng || o.lng, l.lngs = l.lngs || o.lngs, l.ns = l.ns || o.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || i || o.keyPrefix);
      const h = r.options.keySeparator || ".";
      let f;
      return l.keyPrefix && Array.isArray(s) ? f = s.map((p) => `${l.keyPrefix}${h}${p}`) : f = l.keyPrefix ? `${l.keyPrefix}${h}${s}` : s, r.t(f, l);
    };
    return H(e) ? o.lng = e : o.lngs = e, o.ns = t, o.keyPrefix = i, o;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(e) {
    this.options.defaultNS = e;
  }
  hasLoadedNamespace(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const i = t.lng || this.resolvedLanguage || this.languages[0], r = this.options ? this.options.fallbackLng : !1, o = this.languages[this.languages.length - 1];
    if (i.toLowerCase() === "cimode") return !0;
    const s = (a, l) => {
      const c = this.services.backendConnector.state[`${a}|${l}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (t.precheck) {
      const a = t.precheck(this, s);
      if (a !== void 0) return a;
    }
    return !!(this.hasResourceBundle(i, e) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || s(i, e) && (!r || s(o, e)));
  }
  loadNamespaces(e, t) {
    const i = Wi();
    return this.options.ns ? (H(e) && (e = [e]), e.forEach((r) => {
      this.options.ns.indexOf(r) < 0 && this.options.ns.push(r);
    }), this.loadResources((r) => {
      i.resolve(), t && t(r);
    }), i) : (t && t(), Promise.resolve());
  }
  loadLanguages(e, t) {
    const i = Wi();
    H(e) && (e = [e]);
    const r = this.options.preload || [], o = e.filter((s) => r.indexOf(s) < 0 && this.services.languageUtils.isSupportedCode(s));
    return o.length ? (this.options.preload = r.concat(o), this.loadResources((s) => {
      i.resolve(), t && t(s);
    }), i) : (t && t(), Promise.resolve());
  }
  dir(e) {
    if (e || (e = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !e) return "rtl";
    const t = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], i = this.services && this.services.languageUtils || new md(bd());
    return t.indexOf(i.getLanguagePartFromCode(e)) > -1 || e.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    return new Ar(e, t);
  }
  cloneInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : to;
    const i = e.forkResourceStore;
    i && delete e.forkResourceStore;
    const r = {
      ...this.options,
      ...e,
      isClone: !0
    }, o = new Ar(r);
    return (e.debug !== void 0 || e.prefix !== void 0) && (o.logger = o.logger.clone(e)), ["store", "services", "language"].forEach((a) => {
      o[a] = this[a];
    }), o.services = {
      ...this.services
    }, o.services.utils = {
      hasLoadedNamespace: o.hasLoadedNamespace.bind(o)
    }, i && (o.store = new fd(this.store.data, r), o.services.resourceStore = o.store), o.translator = new Uo(o.services, r), o.translator.on("*", function(a) {
      for (var l = arguments.length, c = new Array(l > 1 ? l - 1 : 0), u = 1; u < l; u++)
        c[u - 1] = arguments[u];
      o.emit(a, ...c);
    }), o.init(r, t), o.translator.options = r, o.translator.backendConnector.services.utils = {
      hasLoadedNamespace: o.hasLoadedNamespace.bind(o)
    }, o;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const O = Ar.createInstance();
O.createInstance = Ar.createInstance;
O.createInstance;
O.dir;
O.init;
O.loadResources;
O.reloadResources;
O.use;
O.changeLanguage;
O.getFixedT;
O.t;
O.exists;
O.setDefaultNamespace;
O.hasLoadedNamespace;
O.loadNamespaces;
O.loadLanguages;
const Jp = "المتغيرات البديلة", Gp = { title: "مجموعة الخطوط", hint: "الخط الافتراضي يعتمد على الخطوط المستخدمة في منصة المراسلة للعميل", default: "افتراضي" }, Yp = { title: "عنوان", paragraph: "الفقرة", header_one: "العنوان 1", header_two: "العنوان 2", header_three: "العنوان 3" }, Xp = { dollar: "رمز الدولار", euro: "رمز الأورو", yen: "رمز الين", pound: "رمز الجنيه", cent: "رمز السنت", euro_currency: "رمز عملة الأورو", colon: "رمز الكولون", cruzeiro: "رمز الكروزيرو", french_franc: "رمز الفرنك الفرنسي", lira: "رمز الليرة", currency: "رمز العملة", bitcoin: "رمز البيتكوين", mill: "رمز الميل", peseta: "رمز البيزيتا", rupee: "رمز الروبية", won: "رمز الوون", new_sheqel: "رمز الشيكل الجديد", dong: "رمز الدونغ", kip: "رمز الكيب", tugrik: "رمز التوغريك", drachma: "رمز الدراخما", german_penny: "رمز الفينين الألماني", peso: "رمز البيزو", guarani: "رمز الغواراني", austral: "رمز الأوسترا", hryvnia: "رمز الهريفنيا", cedi: "رمز السيدي", livre_tournois: "رمز الليفر تورنوا", spesmilo: "رمز سبسميلو", tenge: "رمز التينغي", indian_rupee: "رمز الروبية الهندية", turkish_lira: "رمز الليرة التركية", nordic_mark: "رمز العلامة النوردية", ruble: "رمز عملة الروبل", left_pointing_angle_quotation_mark: 'علامة تنصيص "زاوية منفردة لليسار"', right_pointing_angle_quotation_mark: 'علامة تنصيص "زاوية منفردة لليمين"', left_pointing_double_angle_quotation_mark: 'علامة تنصيص "زاوية مزدوجة لليسار"', right_pointing_double_angle_quotation_mark: 'علامة تنصيص "زاوية مزدوجة لليمين"', left_single_quotation_mark: 'علامة تنصيص منفردة "يسار"', right_single_quotation_mark: 'علامة تنصيص منفردة "يمين"', left_double_quotation_mark: 'علاماتا تنصيص "يسار"', right_double_quotation_mark: 'علاماتا تنصيص "يمين"', single_low_quotation_mark: "علامة تنصيص سفلية منفردة", double_low_quotation_mark: "علاماتا تنصيص سفليتان", inverted_exclamation_mark: "علامة تعجّب مقلوبة", inverted_question_mark: "علامة استفهام مقلوبة", two_dot_leader: "رمز الفاصل بنقطتين", horizontal_ellipsis: "رمز الحذف الأفقي", double_dagger: "رمز الخنجر المزدوج", per_mille_sign: 'رمز "لكل ميل"', per_ten_thousand_sign: 'رمز "لكل 10 آلاف"', question_exclamation_mark: "رمز تعجب و استفهام", exclamation_question_mark: "رمز استفهام و تعجب", double_question_mark: "رمز استفهام مزدوج", copyright_sign: "رمز حقوق الطبع والنشر", registered_sign: "رمز مسجّل", trade_mark_sign: "رمز العلامة التجارية", section_sign: "رمز القسم", paragraph_sign: "رمز الفقرة", reversed_paragraph_sign: "رمز الفقرة المعكوس", select_text: "نص", select_currency: "العملة", select_all: "الكل", title: "أحرف مميزة", manat: "رمز عملة المانات", double_exclamation_mark: "علامة تعجب مزدوجة" }, Qp = "لون خلفية الخط", em = "حجم الخط", tm = "إلغاء", nm = "إعادة", im = "زيادة مسافة البداية", rm = "تقليل مسافة البداية", om = "رابط", sm = "خط عريض", am = "خط مائل", lm = "تسطير", cm = "شطب الخط", um = "قائمة مرقّمة", dm = "قائمة نقطية", hm = "ضبط النص", fm = "لون الخط", pm = "تعليق توضيحي", mm = "نص بديل", gm = "صورة", _m = "محاذاة الصورة لليسار", bm = "محاذاة الصورة للوسط", km = "محاذاة", ym = "تغيير النص البديل للصورة", vm = "تغيير التعليق التوضيحي للصورة", xm = "تغيير رابط الصورة", Sm = "البدائل", wm = "إدراج صورة عبر رابط", Cm = "إدراج صورة عبر رابط", Tm = "فشل في معالجة الصورة", Mm = "ارتفاع السطر", Em = "غير مضبوط", $m = "تباعد الفقرات", Om = { apply: "تطبيق", clear: "حذف", error: "خطأ" }, zm = "افتراضي", Am = "ضبط عرض الصورة ليكون بعرض الجهاز المحمول بالكامل", Nm = { one: "اختبار" }, Lm = {
  substitute_variables: Jp,
  font_family: Gp,
  text_level: Yp,
  special_characters: Xp,
  background_color: Qp,
  font_size: em,
  undo: tm,
  redo: nm,
  increase_intent: im,
  decrease_intent: rm,
  link: om,
  bold: sm,
  italic: am,
  underline: lm,
  strike: cm,
  orderedList: um,
  bulletList: dm,
  text_align: hm,
  font_color: fm,
  caption: pm,
  alt_text: mm,
  image: gm,
  image_side: _m,
  image_center: bm,
  image_in_line: km,
  image_change_alt_text: ym,
  image_change_caption: vm,
  image_change_link: xm,
  substitutions: Sm,
  image_via_link: wm,
  image_insert_via_link: Cm,
  image_error: Tm,
  line_height: Mm,
  unset: Em,
  extra_spacing: $m,
  global: Om,
  default_font_size: zm,
  image_change_mobile_full_width: Am,
  test: Nm
}, DR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: mm,
  background_color: Qp,
  bold: sm,
  bulletList: dm,
  caption: pm,
  decrease_intent: rm,
  default: Lm,
  default_font_size: zm,
  extra_spacing: $m,
  font_color: fm,
  font_family: Gp,
  font_size: em,
  global: Om,
  image: gm,
  image_center: bm,
  image_change_alt_text: ym,
  image_change_caption: vm,
  image_change_link: xm,
  image_change_mobile_full_width: Am,
  image_error: Tm,
  image_in_line: km,
  image_insert_via_link: Cm,
  image_side: _m,
  image_via_link: wm,
  increase_intent: im,
  italic: am,
  line_height: Mm,
  link: om,
  orderedList: um,
  redo: nm,
  special_characters: Xp,
  strike: cm,
  substitute_variables: Jp,
  substitutions: Sm,
  test: Nm,
  text_align: hm,
  text_level: Yp,
  underline: lm,
  undo: tm,
  unset: Em
}, Symbol.toStringTag, { value: "Module" })), Dm = "Náhradní proměnné", Rm = { title: "Rodina písma", hint: "Standardní písmo používá písma e-mailového klienta", default: "Výchozí" }, Im = { title: "Nadpis", paragraph: "Odstavec", header_one: "Nadpis 1", header_two: "Nadpis 2", header_three: "Nadpis 3" }, Pm = { dollar: "Dolarový znak", euro: "Euro znak", yen: "Japonský jen znak", pound: "Libra znak", cent: "Cent znak", euro_currency: "Znak euro-měny", colon: "Znak dvojtečky", cruzeiro: "Znak cruzeiro", french_franc: "Znak francouzského franku", lira: "Znak liry", currency: "Symbol měny", bitcoin: "Symbol bitcoinu", mill: "Symbol millu", peseta: "Symbol pesety", rupee: "Symbol rupie", won: "Symbol wonu", new_sheqel: "Symbol nového šekelu", dong: "Symbol dongu", kip: "Symbol kipy", tugrik: "Symbol tugriku", drachma: "Symbol drachmy", german_penny: "Symbol německé pfenigu", peso: "Symbol pesa", guarani: "Symbol guaraní", austral: "Symbol australu", hryvnia: "Symbol hřivny", cedi: "Symbol cedi", livre_tournois: "Symbol livre tournois", spesmilo: "Symbol spesmila", tenge: "Symbol tenge", indian_rupee: "Symbol indické rupie", turkish_lira: "Symbol turecké liry", nordic_mark: "Symbol nordické marky", ruble: "Symbol rublu", left_pointing_angle_quotation_mark: "Jednoduchá levá úhlová uvozovka", right_pointing_angle_quotation_mark: "Jednoduchá pravá úhlová uvozovka", left_pointing_double_angle_quotation_mark: "Levé dvojité úhlové uvozovka", right_pointing_double_angle_quotation_mark: "Pravá dvojitá úhlová uvozovka", left_single_quotation_mark: "Levé jednoduché uvozovky", right_single_quotation_mark: "Pravé jednoduché uvozovky", left_double_quotation_mark: "Levé dvojité uvozovky", right_double_quotation_mark: "Pravé dvojité uvozovky", single_low_quotation_mark: "Jednoduchá nízká 9 uvozovka", double_low_quotation_mark: "Dvojitá nízká 9 uvozovka", inverted_exclamation_mark: "Inverzní vykřičník", inverted_question_mark: "Inverzní otazník", two_dot_leader: "Dvojtečkový vodítko", horizontal_ellipsis: "Horizontální elipsa", double_dagger: "Dvojitá dýka", per_mille_sign: "Per mille znak", per_ten_thousand_sign: "Per deset tisíc znak", question_exclamation_mark: "Otazník vykřičník", exclamation_question_mark: "Vykřičník otazník", double_question_mark: "Dvojitý otazník", copyright_sign: "Znak autorského práva", registered_sign: "Registrovaný znak", trade_mark_sign: "Znak ochranné známky", section_sign: "Znak paragrafu", paragraph_sign: "Znak odstavce", reversed_paragraph_sign: "Obrácený znak odstavce", select_text: "Text", select_currency: "Měna", select_all: "Vše", title: "Speciální znaky", manat: "Znak manat", double_exclamation_mark: "Dvojitý vykřičník" }, jm = "Barva pozadí písma", Bm = "Velikost písma", Fm = "Zpět", qm = "Znovu", Hm = "Zvětšit odsazení", Vm = "Zmenšit odsazení", Um = "Odkaz", Wm = "Tučně", Km = "Kurzíva", Zm = "Podtržené", Jm = "Přeškrtnuté", Gm = "Číslovaný seznam", Ym = "Odrážkový seznam", Xm = "Zarovnání textu", Qm = "Barva písma", eg = "Titulek", tg = "Textová alternativa", ng = "Obrázek", ig = "Zarovnat obrázek vlevo", rg = "Zarovnat obrázek na střed", og = "Zarovnat obrázek vpravo", sg = "Změnit alternativní text obrázku", ag = "Změnit popis obrázku", lg = "Změnit odkaz obrázku", cg = "Náhrady", ug = "Obrázek přes odkaz", dg = "Vložit obrázek přes odkaz", hg = "Nepodařilo se zpracovat obrázek", fg = "Výška řádku", pg = "Neurčeno", mg = "Mezera mezi odstavci", gg = { apply: "Aplikovat", clear: "Průhledná", error: "Chyba" }, _g = "Výchozí", bg = "Nastavit šířku obrázku na plnou šířku mobilního zařízení", kg = { one: "Test" }, yg = {
  substitute_variables: Dm,
  font_family: Rm,
  text_level: Im,
  special_characters: Pm,
  background_color: jm,
  font_size: Bm,
  undo: Fm,
  redo: qm,
  increase_intent: Hm,
  decrease_intent: Vm,
  link: Um,
  bold: Wm,
  italic: Km,
  underline: Zm,
  strike: Jm,
  orderedList: Gm,
  bulletList: Ym,
  text_align: Xm,
  font_color: Qm,
  caption: eg,
  alt_text: tg,
  image: ng,
  image_side: ig,
  image_center: rg,
  image_in_line: og,
  image_change_alt_text: sg,
  image_change_caption: ag,
  image_change_link: lg,
  substitutions: cg,
  image_via_link: ug,
  image_insert_via_link: dg,
  image_error: hg,
  line_height: fg,
  unset: pg,
  extra_spacing: mg,
  global: gg,
  default_font_size: _g,
  image_change_mobile_full_width: bg,
  test: kg
}, RR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: tg,
  background_color: jm,
  bold: Wm,
  bulletList: Ym,
  caption: eg,
  decrease_intent: Vm,
  default: yg,
  default_font_size: _g,
  extra_spacing: mg,
  font_color: Qm,
  font_family: Rm,
  font_size: Bm,
  global: gg,
  image: ng,
  image_center: rg,
  image_change_alt_text: sg,
  image_change_caption: ag,
  image_change_link: lg,
  image_change_mobile_full_width: bg,
  image_error: hg,
  image_in_line: og,
  image_insert_via_link: dg,
  image_side: ig,
  image_via_link: ug,
  increase_intent: Hm,
  italic: Km,
  line_height: fg,
  link: Um,
  orderedList: Gm,
  redo: qm,
  special_characters: Pm,
  strike: Jm,
  substitute_variables: Dm,
  substitutions: cg,
  test: kg,
  text_align: Xm,
  text_level: Im,
  underline: Zm,
  undo: Fm,
  unset: pg
}, Symbol.toStringTag, { value: "Module" })), vg = "Erstatningsvariable", xg = { title: "Fontfamilie", hint: "Standardskrifttype bruger e-mailklientskrifttyper", default: "Misligholdelse" }, Sg = { title: "Overskrift", paragraph: "Paragraf", header_one: "Overskrift 1", header_two: "Overskrift 2", header_three: "Overskrift 3" }, wg = { dollar: "Dollar tegn", euro: "Euro tegn", yen: "Yen tegn", pound: "Pund tegn", cent: "Cent tegn", euro_currency: "Euro-valuta tegn", colon: "Kolon tegn", cruzeiro: "Cruzeiro tegn", french_franc: "Fransk franc tegn", lira: "Lira tegn", currency: "Valuta tegn", bitcoin: "Bitcoin tegn", mill: "Mill. tegn", peseta: "Peseta tegn", rupee: "Rupee tegn", won: "Won tegn", new_sheqel: "Nyt shekel tegn", dong: "Dong tegn", kip: "Kip tegn", tugrik: "Tugrik tegn", drachma: "Drakme tegn", german_penny: "Tysk penny tegn", peso: "Peso tegn", guarani: "Guarani tegn", austral: "Australske tegn", hryvnia: "Hryvnia tegn", cedi: "Cedi tegn", livre_tournois: "Livre tournois tegn", spesmilo: "Spesmilo tegn", tenge: "Tenge tegn", indian_rupee: "Indiske rupee tegn", turkish_lira: "Tyrkisk lira tegn", nordic_mark: "Nordisk mærke tegn", ruble: "Rubel tegn", left_pointing_angle_quotation_mark: "Enkelt venstre-pegende vinkel anførselstegn", right_pointing_angle_quotation_mark: "Enkelt ret-pegende vinkel anførselstegn", left_pointing_double_angle_quotation_mark: "Venstre-pegende dobbelt vinkel anførselstegn", right_pointing_double_angle_quotation_mark: "Højre-pegende dobbelt vinkel anførselstegn", left_single_quotation_mark: "Venstre enkelt anførselstegn", right_single_quotation_mark: "Højre enkelt anførselstegn", left_double_quotation_mark: "Venstre dobbelte anførselstegn", right_double_quotation_mark: "Højre dobbelt anførselstegn", single_low_quotation_mark: "Enkelt lav-9 anførselstegn", double_low_quotation_mark: "Dobbelt lav-9 anførselstegn", inverted_exclamation_mark: "Omvendt udråbstegn", inverted_question_mark: "Omvendt spørgsmålstegn", two_dot_leader: "To prikker leder", horizontal_ellipsis: "Vandret ellipse", double_dagger: "Dobbelt dolk", per_mille_sign: "Promille tegn", per_ten_thousand_sign: "Per ti tusind tegn", question_exclamation_mark: "Spørgsmål udråbstegn", exclamation_question_mark: "Udråbstegn spørgsmålstegn", double_question_mark: "Dobbelt spørgsmålstegn", copyright_sign: "Copyright tegn", registered_sign: "Registreret tegn", trade_mark_sign: "Varemærke tegn", section_sign: "Sektionsskilt", paragraph_sign: "Paragraf-tegn", reversed_paragraph_sign: "Omvendt paragraftegn", select_text: "Tekst", select_currency: "Valuta", select_all: "Alle", title: "Specialtegn", manat: "Manat tegn", double_exclamation_mark: "Dobbelt udråbstegn" }, Cg = "Font baggrundsfarve", Tg = "Skriftstørrelse", Mg = "Fortryd", Eg = "Gentag", $g = "Øg hensigten", Og = "Reducer hensigten", zg = "Forbindelse", Ag = "fed tryk", Ng = "Kursiv", Lg = "Understrege", Dg = "Gennemstregning", Rg = "Nummereret liste", Ig = "Punktliste", Pg = "Tekstjustering", jg = "Skriftfarve", Bg = "Billedtekst", Fg = "Tekstalternativ", qg = "Billede", Hg = "Billedjustering til venstre", Vg = "Billedjustering i midten", Ug = "Billedjustering til højre", Wg = "Skift billedtekstalternativ", Kg = "Skift billedtekst", Zg = "Skift billedlink", Jg = "Udskiftninger", Gg = "Billede via link", Yg = "Indsæt billede via link", Xg = "Billedet kunne ikke behandles", Qg = "Linjehøjde", e_ = "Afbryd", t_ = "Afsnitsafstand", n_ = { apply: "Ansøge", clear: "Klar", error: "Fejl" }, i_ = "Misligholdelse", r_ = "Indstil billedbredden til mobilens fulde bredde", o_ = { one: "Test" }, s_ = {
  substitute_variables: vg,
  font_family: xg,
  text_level: Sg,
  special_characters: wg,
  background_color: Cg,
  font_size: Tg,
  undo: Mg,
  redo: Eg,
  increase_intent: $g,
  decrease_intent: Og,
  link: zg,
  bold: Ag,
  italic: Ng,
  underline: Lg,
  strike: Dg,
  orderedList: Rg,
  bulletList: Ig,
  text_align: Pg,
  font_color: jg,
  caption: Bg,
  alt_text: Fg,
  image: qg,
  image_side: Hg,
  image_center: Vg,
  image_in_line: Ug,
  image_change_alt_text: Wg,
  image_change_caption: Kg,
  image_change_link: Zg,
  substitutions: Jg,
  image_via_link: Gg,
  image_insert_via_link: Yg,
  image_error: Xg,
  line_height: Qg,
  unset: e_,
  extra_spacing: t_,
  global: n_,
  default_font_size: i_,
  image_change_mobile_full_width: r_,
  test: o_
}, IR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: Fg,
  background_color: Cg,
  bold: Ag,
  bulletList: Ig,
  caption: Bg,
  decrease_intent: Og,
  default: s_,
  default_font_size: i_,
  extra_spacing: t_,
  font_color: jg,
  font_family: xg,
  font_size: Tg,
  global: n_,
  image: qg,
  image_center: Vg,
  image_change_alt_text: Wg,
  image_change_caption: Kg,
  image_change_link: Zg,
  image_change_mobile_full_width: r_,
  image_error: Xg,
  image_in_line: Ug,
  image_insert_via_link: Yg,
  image_side: Hg,
  image_via_link: Gg,
  increase_intent: $g,
  italic: Ng,
  line_height: Qg,
  link: zg,
  orderedList: Rg,
  redo: Eg,
  special_characters: wg,
  strike: Dg,
  substitute_variables: vg,
  substitutions: Jg,
  test: o_,
  text_align: Pg,
  text_level: Sg,
  underline: Lg,
  undo: Mg,
  unset: e_
}, Symbol.toStringTag, { value: "Module" })), a_ = "Platzhalter", l_ = { title: "Schriftfamilie", hint: "Standardschriftart verwendet E-Mail-Client-Schriftarten", default: "Standard" }, c_ = { title: "Überschrift", paragraph: "Absatz", header_one: "Kopfzeile 1", header_two: "Kopfzeile 2", header_three: "Kopfzeile 3" }, u_ = { dollar: "Dollar Zeichen", euro: "Euro-Zeichen", yen: "Yen-Zeichen", pound: "Pfund-Zeichen", cent: "Cent-Zeichen", euro_currency: "Euro-Währungszeichen", colon: "Doppelpunkt-Zeichen", cruzeiro: "Cruzeiro-Zeichen", french_franc: "Französisches Franc-Zeichen", lira: "Lira-Zeichen", currency: "Währungszeichen", bitcoin: "Bitcoin-Zeichen", mill: "Mill. Zeichen", peseta: "Peseta-Zeichen", rupee: "Rupie-Zeichen", won: "Won-Zeichen", new_sheqel: "Neues Schekel-Zeichen", dong: "Dong-Zeichen", kip: "Kip-Zeichen", tugrik: "Tugrik-Zeichen", drachma: "Drachme-Zeichen", german_penny: "Deutsches Pfennigzeichen", peso: "Peso-Zeichen", guarani: "Guarani-Zeichen", austral: "Australisches Währungszeichen", hryvnia: "Griwna-Zeichen", cedi: "Cedi-Zeichen", livre_tournois: "Livre Tournois-Zeichen", spesmilo: "Spesmilo-Zeichen", tenge: "Tenge-Zeichen", indian_rupee: "Indisches Rupie Zeichen", turkish_lira: "Türkisches Lira-Zeichen", nordic_mark: "Zeichen der Nordischen Mark", ruble: "Rubel-Zeichen", left_pointing_angle_quotation_mark: "Einfaches, nach links weisendes Anführungszeichen", right_pointing_angle_quotation_mark: "Einfaches, nach rechts zeigendes Anführungszeichen", left_pointing_double_angle_quotation_mark: "Nach links zeigendes doppeltes Anführungszeichen", right_pointing_double_angle_quotation_mark: "Nach rechts zeigendes doppeltes spitzes Anführungszeichen", left_single_quotation_mark: "Linkes einfaches Anführungszeichen", right_single_quotation_mark: "Rechtes einfaches Anführungszeichen", left_double_quotation_mark: "Linkes doppeltes Anführungszeichen", right_double_quotation_mark: "Rechtes doppeltes Anführungszeichen", single_low_quotation_mark: "Einzelnes Anführungszeichen (9)", double_low_quotation_mark: "Doppeltes Anführungszeichen (9)", inverted_exclamation_mark: "Umgekehrtes Ausrufezeichen", inverted_question_mark: "Umgekehrtes Fragezeichen", two_dot_leader: "Zwei Punktführer", horizontal_ellipsis: "Horizontale Auslassungspunkte", double_dagger: "Doppeldolch", per_mille_sign: "Promille-Zeichen", per_ten_thousand_sign: "Pro-Zehntausend-Zeichen", question_exclamation_mark: "Fragezeichen Ausrufezeichen", exclamation_question_mark: "Ausrufezeichen Fragezeichen", double_question_mark: "Doppeltes Fragezeichen", copyright_sign: "Copyright-Zeichen", registered_sign: "Registriertes Zeichen", trade_mark_sign: "Markenzeichen", section_sign: "Abschnittszeichen", paragraph_sign: "Absatzzeichen", reversed_paragraph_sign: "Umgekehrtes Absatzzeichen", select_text: "Text", select_currency: "Währung", select_all: "Alle", title: "Sonderzeichen", manat: "Manat-Zeichen", double_exclamation_mark: "Doppeltes Ausrufezeichen" }, d_ = "Hintergrundfarbe der Schrift", h_ = "Schriftgröße", f_ = "Rückgängig machen", p_ = "Wiederholen", m_ = "Einrückung vergrößern", g_ = "Einrückung verkleinern", __ = "Link", b_ = "Fettdruck", k_ = "Kursiv", y_ = "Unterstreichen", v_ = "Durchgestrichen", x_ = "Nummerierte Liste", S_ = "Aufzählungsliste", w_ = "Textausrichtung", C_ = "Schriftfarbe", T_ = "Bildunterschrift", M_ = "Textalternative", E_ = "Bild", $_ = "Bild linksbündig ausrichten", O_ = "Bild zentriert ausrichten", z_ = "Bild rechtsbündig ausrichten", A_ = "Bildtextalternative ändern", N_ = "Bildunterschrift ändern", L_ = "Bildlink ändern", D_ = "Auswechslungen", R_ = "Bild über Link", I_ = "Bild per Link einfügen", P_ = "Das Bild konnte nicht verarbeitet werden", j_ = "Zeilenhöhe", B_ = "Zurücksetzen", F_ = "Absatzabstand", q_ = { apply: "Anwenden", clear: "Löschen", error: "Fehler" }, H_ = "Standard", V_ = "Stellen Sie die Bildbreite auf die volle Breite des Mobilgeräts ein", U_ = { one: "Test" }, W_ = {
  substitute_variables: a_,
  font_family: l_,
  text_level: c_,
  special_characters: u_,
  background_color: d_,
  font_size: h_,
  undo: f_,
  redo: p_,
  increase_intent: m_,
  decrease_intent: g_,
  link: __,
  bold: b_,
  italic: k_,
  underline: y_,
  strike: v_,
  orderedList: x_,
  bulletList: S_,
  text_align: w_,
  font_color: C_,
  caption: T_,
  alt_text: M_,
  image: E_,
  image_side: $_,
  image_center: O_,
  image_in_line: z_,
  image_change_alt_text: A_,
  image_change_caption: N_,
  image_change_link: L_,
  substitutions: D_,
  image_via_link: R_,
  image_insert_via_link: I_,
  image_error: P_,
  line_height: j_,
  unset: B_,
  extra_spacing: F_,
  global: q_,
  default_font_size: H_,
  image_change_mobile_full_width: V_,
  test: U_
}, PR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: M_,
  background_color: d_,
  bold: b_,
  bulletList: S_,
  caption: T_,
  decrease_intent: g_,
  default: W_,
  default_font_size: H_,
  extra_spacing: F_,
  font_color: C_,
  font_family: l_,
  font_size: h_,
  global: q_,
  image: E_,
  image_center: O_,
  image_change_alt_text: A_,
  image_change_caption: N_,
  image_change_link: L_,
  image_change_mobile_full_width: V_,
  image_error: P_,
  image_in_line: z_,
  image_insert_via_link: I_,
  image_side: $_,
  image_via_link: R_,
  increase_intent: m_,
  italic: k_,
  line_height: j_,
  link: __,
  orderedList: x_,
  redo: p_,
  special_characters: u_,
  strike: v_,
  substitute_variables: a_,
  substitutions: D_,
  test: U_,
  text_align: w_,
  text_level: c_,
  underline: y_,
  undo: f_,
  unset: B_
}, Symbol.toStringTag, { value: "Module" })), K_ = "Μεταβλητές αντικατάστασης", Z_ = { title: "Οικογένεια γραμματοσειράς", hint: "Η τυπική γραμματοσειρά χρησιμοποιεί τις γραμματοσειρές του email client", default: "Προεπιλογή" }, J_ = { title: "Επικεφαλίδα", paragraph: "Παράγραφος", header_one: "Επικεφαλίδα 1", header_two: "Επικεφαλίδα 2", header_three: "Επικεφαλίδα 3" }, G_ = { dollar: "Σύμβολο δολαρίου", euro: "Σύμβολο ευρώ", yen: "Σύμβολο γιεν", pound: "Σύμβολο στερλίνας", cent: "Σύμβολο σεντ", euro_currency: "Σύμβολο νομίσματος ευρώ", colon: "Σύμβολο άνω κάτω τελείας", cruzeiro: "Σύμβολο κρουζέιρο", french_franc: "Σύμβολο γαλλικού φράγκου", lira: "Σύμβολο λίρας", currency: "Σύμβολο νομίσματος", bitcoin: "Σύμβολο Bitcoin", mill: "Σύμβολο mill (₥)", peseta: "Σύμβολο πεσέτας", rupee: "Σύμβολο ρουπίας", won: "Σύμβολο γουόν", new_sheqel: "Σύμβολο νέου σεκέλ", dong: "Σύμβολο ντονγκ", kip: "Σύμβολο κιπ", tugrik: "Σύμβολο τουγκρίκ", drachma: "Σύμβολο δραχμής", german_penny: "Σύμβολο φένιχ", peso: "Σύμβολο πέσο", guarani: "Σύμβολο γκουαρανί", austral: "Σύμβολο αυστράλ", hryvnia: "Σύμβολο χρίβνια", cedi: "Σύμβολο σέντι", livre_tournois: "Σύμβολο λίβρας τουρνουά", spesmilo: "Σύμβολο spesmilo", tenge: "Σύμβολο τενγκέ", indian_rupee: "Σύμβολο ινδικής ρουπίας", turkish_lira: "Σύμβολο τουρκικής λίρας", nordic_mark: "Σύμβολο σκανδιναβικής μάρκας", ruble: "Σύμβολο ρουβλίου", left_pointing_angle_quotation_mark: "Αριστερό μονό γωνιακό εισαγωγικό", right_pointing_angle_quotation_mark: "Δεξί μονό γωνιακό εισαγωγικό", left_pointing_double_angle_quotation_mark: "Αριστερό διπλό γωνιακό εισαγωγικό", right_pointing_double_angle_quotation_mark: "Δεξί διπλό γωνιακό εισαγωγικό", left_single_quotation_mark: "Αριστερό μονό εισαγωγικό (‘)", right_single_quotation_mark: "Δεξί μονό εισαγωγικό (’)", left_double_quotation_mark: "Αριστερό διπλό εισαγωγικό (“)", right_double_quotation_mark: "Δεξί διπλό εισαγωγικό (”)", single_low_quotation_mark: "Μονό κάτω εισαγωγικό (‚)", double_low_quotation_mark: "Διπλό κάτω εισαγωγικό („)", inverted_exclamation_mark: "Αντεστραμμένο θαυμαστικό", inverted_question_mark: "Αντεστραμμένο ερωτηματικό", two_dot_leader: "Διπλή τελεία", horizontal_ellipsis: "Αποσιωπητικά", double_dagger: "Διπλός σταυρός (‡)", per_mille_sign: "Σύμβολο τοις χιλίοις (‰)", per_ten_thousand_sign: "Σύμβολο τοις μυρίοις (‱)", question_exclamation_mark: "Ερωτηματικό-θαυμαστικό (⁈)", exclamation_question_mark: "Θαυμαστικό-ερωτηματικό (⁉)", double_question_mark: "Διπλό ερωτηματικό", copyright_sign: "Σύμβολο πνευματικών δικαιωμάτων", registered_sign: "Σύμβολο καταχωρημένου εμπορικού σήματος", trade_mark_sign: "Σύμβολο εμπορικού σήματος", section_sign: "Σύμβολο § (παράγραφος)", paragraph_sign: "Σύμβολο ¶ (σήμα παραγράφου)", reversed_paragraph_sign: "Ανεστραμμένο σύμβολο ¶", select_text: "Κείμενο", select_currency: "Νόμισμα", select_all: "Όλα", title: "Ειδικοί χαρακτήρες", manat: "Σύμβολο μανάτ (₼)", double_exclamation_mark: "Διπλό θαυμαστικό" }, Y_ = "Χρώμα φόντου κειμένου", X_ = "Μέγεθος κειμένου", Q_ = "Αναίρεση", eb = "Επαναφορά", tb = "Αύξηση εσοχής", nb = "Μείωση εσοχής", ib = "Σύνδεσμος", rb = "Έντονη γραφή", ob = "Πλάγια γραφή", sb = "Υπογράμμιση", ab = "Διαγράμμιση", lb = "Αριθμημένη λίστα", cb = "Λίστα με κουκίδες", ub = "Στοίχιση κειμένου", db = "Χρώμα κειμένου", hb = "Λεζάντα", fb = "Εναλλακτικό κείμενο", pb = "Εικόνα", mb = "Εικόνα στο πλάι", gb = "Εικόνα στο κέντρο", _b = "Εικόνα μέσα στο κείμενο", bb = "Αλλαγή εναλλακτικού κειμένου εικόνας", kb = "Αλλαγή λεζάντας εικόνας", yb = "Αλλαγή συνδέσμου εικόνας", vb = "Αντικαταστάσεις", xb = "Εικόνα μέσω συνδέσμου", Sb = "Εισαγωγή εικόνας μέσω συνδέσμου", wb = "Αποτυχία επεξεργασίας εικόνας", Cb = "Διάστιχο", Tb = "Κατάργηση", Mb = "Απόσταση μεταξύ παραγράφων", Eb = { apply: "Εφαρμογή", clear: "Εκκαθάριση", error: "Σφάλμα" }, $b = "Προεπιλογή", Ob = "Ορίστε το πλάτος της εικόνας στο μέγιστο πλάτος της κινητής συσκευής", zb = { one: "Δοκιμή" }, Ab = {
  substitute_variables: K_,
  font_family: Z_,
  text_level: J_,
  special_characters: G_,
  background_color: Y_,
  font_size: X_,
  undo: Q_,
  redo: eb,
  increase_intent: tb,
  decrease_intent: nb,
  link: ib,
  bold: rb,
  italic: ob,
  underline: sb,
  strike: ab,
  orderedList: lb,
  bulletList: cb,
  text_align: ub,
  font_color: db,
  caption: hb,
  alt_text: fb,
  image: pb,
  image_side: mb,
  image_center: gb,
  image_in_line: _b,
  image_change_alt_text: bb,
  image_change_caption: kb,
  image_change_link: yb,
  substitutions: vb,
  image_via_link: xb,
  image_insert_via_link: Sb,
  image_error: wb,
  line_height: Cb,
  unset: Tb,
  extra_spacing: Mb,
  global: Eb,
  default_font_size: $b,
  image_change_mobile_full_width: Ob,
  test: zb
}, jR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: fb,
  background_color: Y_,
  bold: rb,
  bulletList: cb,
  caption: hb,
  decrease_intent: nb,
  default: Ab,
  default_font_size: $b,
  extra_spacing: Mb,
  font_color: db,
  font_family: Z_,
  font_size: X_,
  global: Eb,
  image: pb,
  image_center: gb,
  image_change_alt_text: bb,
  image_change_caption: kb,
  image_change_link: yb,
  image_change_mobile_full_width: Ob,
  image_error: wb,
  image_in_line: _b,
  image_insert_via_link: Sb,
  image_side: mb,
  image_via_link: xb,
  increase_intent: tb,
  italic: ob,
  line_height: Cb,
  link: ib,
  orderedList: lb,
  redo: eb,
  special_characters: G_,
  strike: ab,
  substitute_variables: K_,
  substitutions: vb,
  test: zb,
  text_align: ub,
  text_level: J_,
  underline: sb,
  undo: Q_,
  unset: Tb
}, Symbol.toStringTag, { value: "Module" })), Nb = "Substitute variables", Lb = { title: "Font family", hint: "Standard font uses email client fonts", default: "Default" }, Db = { title: "Heading", paragraph: "Paragraph", header_one: "Header 1", header_two: "Header 2", header_three: "Header 3" }, Rb = { dollar: "Dollar sign", euro: "Euro sign", yen: "Yen sign", pound: "Pound sign", cent: "Cent sign", euro_currency: "Euro-currency sign", colon: "Colon sign", cruzeiro: "Cruzeiro sign", french_franc: "French franc sign", lira: "Lira sign", currency: "Currency sign", bitcoin: "Bitcoin sign", mill: "Mill sign", peseta: "Peseta sign", rupee: "Rupee sign", won: "Won sign", new_sheqel: "New sheqel sign", dong: "Dong sign", kip: "Kip sign", tugrik: "Tugrik sign", drachma: "Drachma sign", german_penny: "German penny sign", peso: "Peso sign", guarani: "Guarani sign", austral: "Austral sign", hryvnia: "Hryvnia sign", cedi: "Cedi sign", livre_tournois: "Livre tournois sign", spesmilo: "Spesmilo sign", tenge: "Tenge sign", indian_rupee: "Indian rupee sign", turkish_lira: "Turkish lira sign", nordic_mark: "Nordic mark sign", ruble: "Ruble sign", left_pointing_angle_quotation_mark: "Single left-pointing angle quotation mark", right_pointing_angle_quotation_mark: "Single right-pointing angle quotation mark", left_pointing_double_angle_quotation_mark: "Left-pointing double angle quotation mark", right_pointing_double_angle_quotation_mark: "Right-pointing double angle quotation mark", left_single_quotation_mark: "Left single quotation mark", right_single_quotation_mark: "Right single quotation mark", left_double_quotation_mark: "Left double quotation mark", right_double_quotation_mark: "Right double quotation mark", single_low_quotation_mark: "Single low-9 quotation mark", double_low_quotation_mark: "Double low-9 quotation mark", inverted_exclamation_mark: "Inverted exclamation mark", inverted_question_mark: "Inverted question mark", two_dot_leader: "Two dot leader", horizontal_ellipsis: "Horizontal ellipsis", double_dagger: "Double dagger", per_mille_sign: "Per mille sign", per_ten_thousand_sign: "Per ten thousand sign", question_exclamation_mark: "Question exclamation mark", exclamation_question_mark: "Exclamation question mark", double_question_mark: "Double question mark", copyright_sign: "Copyright sign", registered_sign: "Registered sign", trade_mark_sign: "Trade mark sign", section_sign: "Section sign", paragraph_sign: "Paragraph sign", reversed_paragraph_sign: "Reversed paragraph sign", select_text: "Text", select_currency: "Currency", select_all: "All", title: "Special characters", manat: "Manat sign", double_exclamation_mark: "Double exclamation mark" }, Ib = "Font background color", Pb = "Font size", jb = "Undo", Bb = "Redo", Fb = "Increase indent", qb = "Decrease indent", Hb = "Link", Vb = "Bold", Ub = "Italic", Wb = "Underline", Kb = "Strikethrough", Zb = "Numbered list", Jb = "Bulleted list", Gb = "Text alignment", Yb = "Font color", Xb = "Caption", Qb = "Text alternative", ek = "Image", tk = "Side image", nk = "Centered image", ik = "In line", rk = "Change image text alternative", ok = "Change image caption", sk = "Change image link", ak = "Substitutions", lk = "Image via link", ck = "Insert image via link", uk = "Failed to process the image", dk = "Line hight", hk = "Unset", fk = "Paragraph spacing", pk = { apply: "Apply", clear: "Clear", error: "Error" }, mk = "Default", gk = "Set the image width to the full width of the mobile device", _k = { one: "Test" }, bk = {
  substitute_variables: Nb,
  font_family: Lb,
  text_level: Db,
  special_characters: Rb,
  background_color: Ib,
  font_size: Pb,
  undo: jb,
  redo: Bb,
  increase_intent: Fb,
  decrease_intent: qb,
  link: Hb,
  bold: Vb,
  italic: Ub,
  underline: Wb,
  strike: Kb,
  orderedList: Zb,
  bulletList: Jb,
  text_align: Gb,
  font_color: Yb,
  caption: Xb,
  alt_text: Qb,
  image: ek,
  image_side: tk,
  image_center: nk,
  image_in_line: ik,
  image_change_alt_text: rk,
  image_change_caption: ok,
  image_change_link: sk,
  substitutions: ak,
  image_via_link: lk,
  image_insert_via_link: ck,
  image_error: uk,
  line_height: dk,
  unset: hk,
  extra_spacing: fk,
  global: pk,
  default_font_size: mk,
  image_change_mobile_full_width: gk,
  test: _k
}, BR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: Qb,
  background_color: Ib,
  bold: Vb,
  bulletList: Jb,
  caption: Xb,
  decrease_intent: qb,
  default: bk,
  default_font_size: mk,
  extra_spacing: fk,
  font_color: Yb,
  font_family: Lb,
  font_size: Pb,
  global: pk,
  image: ek,
  image_center: nk,
  image_change_alt_text: rk,
  image_change_caption: ok,
  image_change_link: sk,
  image_change_mobile_full_width: gk,
  image_error: uk,
  image_in_line: ik,
  image_insert_via_link: ck,
  image_side: tk,
  image_via_link: lk,
  increase_intent: Fb,
  italic: Ub,
  line_height: dk,
  link: Hb,
  orderedList: Zb,
  redo: Bb,
  special_characters: Rb,
  strike: Kb,
  substitute_variables: Nb,
  substitutions: ak,
  test: _k,
  text_align: Gb,
  text_level: Db,
  underline: Wb,
  undo: jb,
  unset: hk
}, Symbol.toStringTag, { value: "Module" })), kk = "Variables de sustitución", yk = { title: "Familia de la fuente", hint: "La fuente estándar implementa las fuentes de utiliza el cliente en sus correos", default: "Estándar" }, vk = { title: "Encabezado", paragraph: "Parágrafo", header_one: "Encabezado 1", header_two: "Encabezado 2", header_three: "Encabezado 3" }, xk = { dollar: "Dólar", euro: "Euro", yen: "Yen", pound: "Libra esterlina", cent: "Centavo", euro_currency: "Eurodivisa", colon: "Colon", cruzeiro: "Cruzeiro", french_franc: "Franco francés", lira: "Lira turca", currency: "Signo monetario", bitcoin: "Bitcoin", mill: "Milésima", peseta: "Mill", rupee: "Rupia", won: "Won", new_sheqel: "Nuevo séquel", dong: "Dong", kip: "Kip", tugrik: "Tugrik mongól", drachma: "Drachma", german_penny: "Centavo alemán", peso: "Peso", guarani: "Guarani", austral: "Austral", hryvnia: "Grivna", cedi: "Cedi", livre_tournois: "Librta de tours", spesmilo: "Spesmilo", tenge: "Tenge", indian_rupee: "India rupia", turkish_lira: "Lira turca", nordic_mark: "Signo nórdico", ruble: "Rublo", left_pointing_angle_quotation_mark: "Comilla angular simple izquierda", right_pointing_angle_quotation_mark: "Comilla angular simple derecha", left_pointing_double_angle_quotation_mark: "Comilla angular doble izquierda", right_pointing_double_angle_quotation_mark: "Comilla angular doble derecha", left_single_quotation_mark: "Interrogación izquierda", right_single_quotation_mark: "Interrogación derecha", left_double_quotation_mark: "Doble interrogación izquierda", right_double_quotation_mark: "Doble interrogación derecha", single_low_quotation_mark: "Comillas", double_low_quotation_mark: "comillas dobles", inverted_exclamation_mark: "Exclamación invertida", inverted_question_mark: "Interrogación invertida", two_dot_leader: "dos puntos", horizontal_ellipsis: "puntos suspensivos", double_dagger: "Daga doble", per_mille_sign: "Por mil", per_ten_thousand_sign: "Por diez mil", question_exclamation_mark: "Interrogación exclamativa", exclamation_question_mark: "Interrogación exclamativa", double_question_mark: "Doble interrogante", copyright_sign: "Derechos reservados", registered_sign: "Marca registrada", trade_mark_sign: "Marca comercial", section_sign: "Sección", paragraph_sign: "Párrafo", reversed_paragraph_sign: "Párrafo invertido", select_text: "Texto", select_currency: "Monedas", select_all: "Todo", title: "Caracteres especiales", manat: "Manat", double_exclamation_mark: "Doble exclamación" }, Sk = "Color de fondo para la fuente", wk = "Tamaño de la fuente", Ck = "Deshacer", Tk = "Rehacer", Mk = "Aumentar sangría", Ek = "Disminuir sangría", $k = "Enlace", Ok = "Negrilla", zk = "Cursiva", Ak = "Subrayado", Nk = "Tachado", Lk = "Lista numerada", Dk = "Lista de viñetas", Rk = "Alineación del texto", Ik = "Color de la fuente", Pk = "Texto", jk = "Texto alternativo", Bk = "Imagen", Fk = "Alinear imagen a la izquierda", qk = "Alinear imagen al centro", Hk = "Alinear imagen a la derecha", Vk = "Cambiar el texto alternativo de la imagen", Uk = "Cambiar el texto de la imagen", Wk = "Cambiar el enlace de la imagen", Kk = "Sustituciones", Zk = "Imagen a través de enlace", Jk = "Insertar imagen a través de enlace", Gk = "Error al insertar la imagen", Yk = "Altura de línea", Xk = "Por defecto", Qk = "Espacio entre párrafos", ey = { apply: "Aplicar", clear: "Limpiar", error: "Error" }, ty = "Estándar", ny = "Establece el ancho de la imagen al ancho completo del dispositivo móvil", iy = { one: "Prueba" }, ry = {
  substitute_variables: kk,
  font_family: yk,
  text_level: vk,
  special_characters: xk,
  background_color: Sk,
  font_size: wk,
  undo: Ck,
  redo: Tk,
  increase_intent: Mk,
  decrease_intent: Ek,
  link: $k,
  bold: Ok,
  italic: zk,
  underline: Ak,
  strike: Nk,
  orderedList: Lk,
  bulletList: Dk,
  text_align: Rk,
  font_color: Ik,
  caption: Pk,
  alt_text: jk,
  image: Bk,
  image_side: Fk,
  image_center: qk,
  image_in_line: Hk,
  image_change_alt_text: Vk,
  image_change_caption: Uk,
  image_change_link: Wk,
  substitutions: Kk,
  image_via_link: Zk,
  image_insert_via_link: Jk,
  image_error: Gk,
  line_height: Yk,
  unset: Xk,
  extra_spacing: Qk,
  global: ey,
  default_font_size: ty,
  image_change_mobile_full_width: ny,
  test: iy
}, FR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: jk,
  background_color: Sk,
  bold: Ok,
  bulletList: Dk,
  caption: Pk,
  decrease_intent: Ek,
  default: ry,
  default_font_size: ty,
  extra_spacing: Qk,
  font_color: Ik,
  font_family: yk,
  font_size: wk,
  global: ey,
  image: Bk,
  image_center: qk,
  image_change_alt_text: Vk,
  image_change_caption: Uk,
  image_change_link: Wk,
  image_change_mobile_full_width: ny,
  image_error: Gk,
  image_in_line: Hk,
  image_insert_via_link: Jk,
  image_side: Fk,
  image_via_link: Zk,
  increase_intent: Mk,
  italic: zk,
  line_height: Yk,
  link: $k,
  orderedList: Lk,
  redo: Tk,
  special_characters: xk,
  strike: Nk,
  substitute_variables: kk,
  substitutions: Kk,
  test: iy,
  text_align: Rk,
  text_level: vk,
  underline: Ak,
  undo: Ck,
  unset: Xk
}, Symbol.toStringTag, { value: "Module" })), oy = "Variables de substitution", sy = { title: "Type de police", hint: "La police standard utilise les polices de la plateforme de messagerie du client", default: "Par défaut" }, ay = { title: "Intitulé", paragraph: "Paragraphe", header_one: "Titre 1", header_two: "Titre 2", header_three: "Titre 3" }, ly = { dollar: "Symbole du dollar", euro: "Symbole de l'euro", yen: "Symbole du Yen", pound: "Symbole de la livre", cent: "Symbole des cents", euro_currency: "Symbole de la monnaie européenne", colon: "Deux-points", cruzeiro: "Symbole du Cruzeiro", french_franc: "Symbole du franc français", lira: "Symbole de la livre", currency: "Symbole de la monnaie", bitcoin: "Symbole du bitcoin", mill: "Symbole du Mill", peseta: "Symbole de la peseta", rupee: "Symbole de la roupie", won: "Symbole du won", new_sheqel: "Nouveau symbole du Sheqel", dong: "Symbole du Dong", kip: "Symbole du Kip", tugrik: "Symbole de Tugrik", drachma: "Symbole du drachme", german_penny: "Symbole du penny allemand", peso: "Symbole du peso", guarani: "Symbole de Guarani", austral: "symbole austral", hryvnia: "Symbole de la Hryvnia", cedi: "Symbole du Cedi", livre_tournois: "Symbole du livre tournois", spesmilo: "Symbole du Spesmilo", tenge: "Symbole du Tenge", indian_rupee: "Symbole de la roupie indienne", turkish_lira: "Symbole de la livre turque", nordic_mark: "Symbole de la marque nordique", ruble: "Symbole du rouble", left_pointing_angle_quotation_mark: "Single left-pointing angle quotation mark", right_pointing_angle_quotation_mark: "Single right-pointing angle quotation mark", left_pointing_double_angle_quotation_mark: "Left-pointing double angle quotation mark", right_pointing_double_angle_quotation_mark: "Right-pointing double angle quotation mark", left_single_quotation_mark: "Left single quotation mark", right_single_quotation_mark: "Right single quotation mark", left_double_quotation_mark: "Left double quotation mark", right_double_quotation_mark: "Right double quotation mark", single_low_quotation_mark: "Single low-9 quotation mark", double_low_quotation_mark: "Double guillemet bas-9", inverted_exclamation_mark: "Point d'exclamation inversé", inverted_question_mark: "Point d'interrogation inversé", two_dot_leader: "Two dot leader", horizontal_ellipsis: "Ellipse horizontale", double_dagger: "Double dagger", per_mille_sign: "Symbole pour mille", per_ten_thousand_sign: "Symbole pour dix mille", question_exclamation_mark: "Question point d'exclamation", exclamation_question_mark: "Point d'interrogation", double_question_mark: "Double point d'interrogation", copyright_sign: "Symbole de copyright", registered_sign: "Symbole de marque déposée", trade_mark_sign: "Symbole de marque commerciale", section_sign: "Symbole de section", paragraph_sign: "Symbole du paragraphe", reversed_paragraph_sign: "Symbole du paragraphe inversé", select_text: "Texte", select_currency: "Monnaie", select_all: "Tous", title: "Caractères spéciaux", manat: "Symbole manat", double_exclamation_mark: "Double point d'exclamation" }, cy = "Couleur de fond de la police", uy = "Taille de la police", dy = "Annuler", hy = "Refaire", fy = "Augmenter le retrait", py = "Diminuer le retrait", my = "Lien", gy = "Gras", _y = "Italique", by = "Souligné", ky = "Barré", yy = "Liste numérotée", vy = "Liste à puces", xy = "Alignement du texte", Sy = "Couleur de la police", wy = "Légende", Cy = "Texte alternatif", Ty = "Image", My = "Aligner l'image à gauche", Ey = "Centrer l'image", $y = "Aligner l'image à droite", Oy = "Changer le texte alternatif de l'image", zy = "Changer la légende de l'image", Ay = "Changer le lien de l'image", Ny = "Substitutions", Ly = "Image via un lien", Dy = "Insérer une image via un lien", Ry = "Échec du traitement de l'image", Iy = "Hauteur de ligne", Py = "Non défini", jy = "Espacement des paragraphes", By = { apply: "Appliquer", clear: "Effacer", error: "Erreur" }, Fy = "Par défaut", qy = "Définissez la largeur de l'image à la largeur complète de l'appareil mobile", Hy = { one: "Test" }, Vy = {
  substitute_variables: oy,
  font_family: sy,
  text_level: ay,
  special_characters: ly,
  background_color: cy,
  font_size: uy,
  undo: dy,
  redo: hy,
  increase_intent: fy,
  decrease_intent: py,
  link: my,
  bold: gy,
  italic: _y,
  underline: by,
  strike: ky,
  orderedList: yy,
  bulletList: vy,
  text_align: xy,
  font_color: Sy,
  caption: wy,
  alt_text: Cy,
  image: Ty,
  image_side: My,
  image_center: Ey,
  image_in_line: $y,
  image_change_alt_text: Oy,
  image_change_caption: zy,
  image_change_link: Ay,
  substitutions: Ny,
  image_via_link: Ly,
  image_insert_via_link: Dy,
  image_error: Ry,
  line_height: Iy,
  unset: Py,
  extra_spacing: jy,
  global: By,
  default_font_size: Fy,
  image_change_mobile_full_width: qy,
  test: Hy
}, qR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: Cy,
  background_color: cy,
  bold: gy,
  bulletList: vy,
  caption: wy,
  decrease_intent: py,
  default: Vy,
  default_font_size: Fy,
  extra_spacing: jy,
  font_color: Sy,
  font_family: sy,
  font_size: uy,
  global: By,
  image: Ty,
  image_center: Ey,
  image_change_alt_text: Oy,
  image_change_caption: zy,
  image_change_link: Ay,
  image_change_mobile_full_width: qy,
  image_error: Ry,
  image_in_line: $y,
  image_insert_via_link: Dy,
  image_side: My,
  image_via_link: Ly,
  increase_intent: fy,
  italic: _y,
  line_height: Iy,
  link: my,
  orderedList: yy,
  redo: hy,
  special_characters: ly,
  strike: ky,
  substitute_variables: oy,
  substitutions: Ny,
  test: Hy,
  text_align: xy,
  text_level: ay,
  underline: by,
  undo: dy,
  unset: Py
}, Symbol.toStringTag, { value: "Module" })), Uy = "सब्स्टिटूट वेरिएबल्स", Wy = { title: "फॉण्ट फॅमिली", hint: "स्टैण्डर्ड फॉण्ट ईमेल क्लाइंट फॉण्ट का इस्तेमाल करता है", default: "पुनर्निश्चित" }, Ky = { title: "हेडिंग", paragraph: "पैराग्राफ", header_one: "हेडर १", header_two: "हेडर २", header_three: "हेडर ३" }, Zy = { dollar: "डॉलर चिन्ह", euro: "यूरो चिन्ह", yen: "येन चिन्ह", pound: "पाउंड चिन्ह", cent: "सेंट चिन्ह", euro_currency: "यूरो-करेंसी चिन्ह", colon: "कोलोन चिन्ह", cruzeiro: "क्रूज़ेरो चिन्ह", french_franc: "फ्रेंच फ्रैंक चिन्ह", lira: "लीरा चिन्ह", currency: "करेंसी चिन्ह", bitcoin: "बिटकॉइन चिन्ह", mill: "मिल चिन्ह", peseta: "पसेटा चिन्ह", rupee: "रुपया चिन्ह", won: "वॉन चिन्ह", new_sheqel: "नया शेकेल चिन्ह", dong: "डाँग चिन्ह", kip: "किप चिन्ह", tugrik: "तुगरिक चिन्ह", drachma: "द्राखमा चिन्ह", german_penny: "जर्मन पेनी चिन्ह", peso: "पेसो चिन्ह", guarani: "गुआरानी चिन्ह", austral: "ऑस्ट्रेल चिन्ह", hryvnia: "ह्रिव्निया चिन्ह", cedi: "सेडी चिन्ह", livre_tournois: "लिवर टूरनोइस चिन्ह", spesmilo: "स्पेस्मिलो चिन्ह", tenge: "तेंगे चिन्ह", indian_rupee: "भारतीय रुपया चिन्ह", turkish_lira: "तुर्की लीरा चिन्ह", nordic_mark: "नॉर्डिक मार्क चिन्ह", ruble: "रूबल चिन्ह", left_pointing_angle_quotation_mark: "सिंगल बाएँ इंगित करने वाला कोणीय उद्धरण चिन्ह", right_pointing_angle_quotation_mark: "सिंगल दाएँ इंगित करने वाला कोणीय उद्धरण चिन्ह", left_pointing_double_angle_quotation_mark: "बाएँ इंगित करने वाला डबल कोणीय उद्धरण चिन्ह", right_pointing_double_angle_quotation_mark: "दाएँ इंगित करने वाला डबल कोणीय उद्धरण चिन्ह", left_single_quotation_mark: "बाएँ सिंगल उद्धरण चिन्ह", right_single_quotation_mark: "दाएँ सिंगल उद्धरण चिन्ह", left_double_quotation_mark: "बाएँ डबल उद्धरण चिन्ह", right_double_quotation_mark: "दाएँ डबल उद्धरण चिन्ह", single_low_quotation_mark: "सिंगल लो-9 उद्धरण चिन्ह", double_low_quotation_mark: "डबल लो-9 उद्धरण चिन्ह", inverted_exclamation_mark: "उल्टा विस्मयादिबोधक चिन्ह", inverted_question_mark: "उल्टा प्रश्नवाचक चिन्ह", two_dot_leader: "दो बिंदु लीडर", horizontal_ellipsis: "क्षैतिज एलिप्सिस", double_dagger: "डबल डैगर", per_mille_sign: "प्रति हज़ार चिन्ह", per_ten_thousand_sign: "प्रति दस हजार चिन्ह", question_exclamation_mark: "प्रश्नवाचक-विस्मयादिबोधक चिन्ह", exclamation_question_mark: "विस्मयादिबोधक-प्रश्नवाचक चिन्ह", double_question_mark: "डबल प्रश्नवाचक चिन्ह", copyright_sign: "कॉपीराइट चिन्ह", registered_sign: "रजिस्टर्ड चिन्ह", trade_mark_sign: "ट्रेडमार्क चिन्ह", section_sign: "सेक्शन चिन्ह", paragraph_sign: "पैराग्राफ चिन्ह", reversed_paragraph_sign: "रिवर्स पैराग्राफ चिन्ह", select_text: "टेक्स्ट", select_currency: "करेंसी", select_all: "सभी", title: "विशेष अक्षर", manat: "मनत चिन्ह", double_exclamation_mark: "डबल एक्सक्लेमेशन मार्क" }, Jy = "फॉण्ट बैकग्राउंड कलर", Gy = "फॉण्ट साइज़", Yy = "अनडू", Xy = "रीडू", Qy = "इंटेंट को बढ़ाएं", e1 = "इंटेंट को घटायें", t1 = "लिंक", n1 = "बोल्ड", i1 = "इटैलिक", r1 = "अंडरलाइन", o1 = "स्ट्राइकथ्रू", s1 = "नंबर की गयी लिस्ट", a1 = "बुलेटेड लिस्ट", l1 = "टेक्स्ट एलाइनमेंट", c1 = "फॉण्ट कलर", u1 = "कैप्शन", d1 = "टेक्स्ट विकल्प", h1 = "इमेज", f1 = "साइड इमेज", p1 = "केंद्रित इमेज ", m1 = "लाइन में", g1 = "इमेज के लिए वैकल्पिक टेक्स्ट बदलें", _1 = "इमेज कैप्शन बदलें", b1 = "छवि लिंक बदलें", k1 = "स्थानापन्न", y1 = "लिंक के माध्यम से छवि", v1 = "लिंक के माध्यम से इमेज डालें", x1 = "इमेज को प्रोसेस करने में फेल", S1 = "रेखा ऊंचाई", w1 = "असंबद्ध", C1 = "पैराग्राफ स्पेसिंग", T1 = { apply: "अप्लाई करें", clear: "साफ़ करें", error: "त्रुटि" }, M1 = "पुनर्निश्चित", E1 = "छवि की चौड़ाई को मोबाइल डिवाइस की पूरी चौड़ाई पर सेट करें", $1 = { one: "परीक्षण" }, O1 = {
  substitute_variables: Uy,
  font_family: Wy,
  text_level: Ky,
  special_characters: Zy,
  background_color: Jy,
  font_size: Gy,
  undo: Yy,
  redo: Xy,
  increase_intent: Qy,
  decrease_intent: e1,
  link: t1,
  bold: n1,
  italic: i1,
  underline: r1,
  strike: o1,
  orderedList: s1,
  bulletList: a1,
  text_align: l1,
  font_color: c1,
  caption: u1,
  alt_text: d1,
  image: h1,
  image_side: f1,
  image_center: p1,
  image_in_line: m1,
  image_change_alt_text: g1,
  image_change_caption: _1,
  image_change_link: b1,
  substitutions: k1,
  image_via_link: y1,
  image_insert_via_link: v1,
  image_error: x1,
  line_height: S1,
  unset: w1,
  extra_spacing: C1,
  global: T1,
  default_font_size: M1,
  image_change_mobile_full_width: E1,
  test: $1
}, HR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: d1,
  background_color: Jy,
  bold: n1,
  bulletList: a1,
  caption: u1,
  decrease_intent: e1,
  default: O1,
  default_font_size: M1,
  extra_spacing: C1,
  font_color: c1,
  font_family: Wy,
  font_size: Gy,
  global: T1,
  image: h1,
  image_center: p1,
  image_change_alt_text: g1,
  image_change_caption: _1,
  image_change_link: b1,
  image_change_mobile_full_width: E1,
  image_error: x1,
  image_in_line: m1,
  image_insert_via_link: v1,
  image_side: f1,
  image_via_link: y1,
  increase_intent: Qy,
  italic: i1,
  line_height: S1,
  link: t1,
  orderedList: s1,
  redo: Xy,
  special_characters: Zy,
  strike: o1,
  substitute_variables: Uy,
  substitutions: k1,
  test: $1,
  text_align: l1,
  text_level: Ky,
  underline: r1,
  undo: Yy,
  unset: w1
}, Symbol.toStringTag, { value: "Module" })), z1 = "Helyettesítő változók", A1 = { title: "Betűtípus család", hint: "A standard betűtípus az e-mail kliens betűtípusait használja", default: "Alapértelmezett" }, N1 = { title: "Cím", paragraph: "Bekezdés", header_one: "Fejléc 1", header_two: "Fejléc 2", header_three: "Fejléc 3" }, L1 = { dollar: "Dollár jel", euro: "Euró jel", yen: "Jen jel", pound: "Font jel", cent: "Cent jel", euro_currency: "Euró valuta jel", colon: "Kettőspont jel", cruzeiro: "Cruzeiro jel", french_franc: "Francia frank jel", lira: "Lira jel", currency: "Valuta jel", bitcoin: "Bitcoin jel", mill: "Mill jel", peseta: "Peseta jel", rupee: "Rúpia jel", won: "Won jel", new_sheqel: "Új sékel jel", dong: "Dong jel", kip: "Kip jel", tugrik: "Tugrik jel", drachma: "Drachma jel", german_penny: "Német penny jel", peso: "Peso jel", guarani: "Guarani jel", austral: "Austral jel", hryvnia: "Hrivnya jel", cedi: "Cedi jel", livre_tournois: "Livre tournois jel", spesmilo: "Spesmilo jel", tenge: "Tenge jel", indian_rupee: "indiai rúpiás jel", turkish_lira: "török líra jel", nordic_mark: "északi márka jel", ruble: "rubel jel", left_pointing_angle_quotation_mark: "balra mutató egyes idézőjel", right_pointing_angle_quotation_mark: "jobbra mutató egyes idézőjel", left_pointing_double_angle_quotation_mark: "balra mutató dupla idézőjel", right_pointing_double_angle_quotation_mark: "jobbra mutató dupla idézőjel", left_single_quotation_mark: "baloldali egyes idézőjel", right_single_quotation_mark: "jobboldali egyes idézőjel", left_double_quotation_mark: "baloldali dupla idézőjel", right_double_quotation_mark: "jobboldali dupla idézőjel", single_low_quotation_mark: "alacsony 9-es idézőjel", double_low_quotation_mark: "dupla alacsony 9-es idézőjel", inverted_exclamation_mark: "fordított felkiáltójel", inverted_question_mark: "fordított kérdőjel", two_dot_leader: "két pont vezető", horizontal_ellipsis: "horizontális ellipszis", double_dagger: "dupla kereszt", per_mille_sign: "ezrelék jel", per_ten_thousand_sign: "tízezer jel", question_exclamation_mark: "kérdő felkiáltójel", exclamation_question_mark: "felkiáltó kérdőjel", double_question_mark: "dupla kérdőjel", copyright_sign: "szerzői jog jel", registered_sign: "bejegyzett jel", trade_mark_sign: "védjegy jel", section_sign: "szakasz jel", paragraph_sign: "bekezdés jel", reversed_paragraph_sign: "fordított bekezdés jel", select_text: "Szöveg", select_currency: "Pénznem", select_all: "Minden", title: "Speciális karakterek", manat: "Manat jel", double_exclamation_mark: "Kettős felkiáltójel" }, D1 = "Betűtípus háttérszíne", R1 = "Betűméret", I1 = "Visszavonás", P1 = "Újra", j1 = "Behúzás növelése", B1 = "Behúzás csökkentése", F1 = "Hivatkozás", q1 = "Félkövér", H1 = "Dőlt", V1 = "Aláhúzott", U1 = "Áthúzott", W1 = "Számozott lista", K1 = "Felsorolás lista", Z1 = "Szöveg igazítása", J1 = "Betűszín", G1 = "Felirat", Y1 = "Szöveges alternatíva", X1 = "Kép", Q1 = "Kép balra igazítása", e0 = "Kép középre igazítása", t0 = "Kép jobbra igazítása", n0 = "Kép alternatív szövegének megváltoztatása", i0 = "Kép feliratának megváltoztatása", r0 = "Kép hivatkozásának megváltoztatása", o0 = "Helyettesítések", s0 = "Kép link alapján", a0 = "Kép beillesztése link alapján", l0 = "A kép feldolgozása nem sikerült.", c0 = "Sor magassága", u0 = "Alaphelyzetbe állítva", d0 = "Extra térköz", h0 = { apply: "Alkalmaz", clear: "Egyértelmű", error: "Hiba" }, f0 = "Alapértelmezett", p0 = "Állítsa be a kép szélességét a mobil eszköz teljes szélességére", m0 = { one: "Teszt" }, g0 = {
  substitute_variables: z1,
  font_family: A1,
  text_level: N1,
  special_characters: L1,
  background_color: D1,
  font_size: R1,
  undo: I1,
  redo: P1,
  increase_intent: j1,
  decrease_intent: B1,
  link: F1,
  bold: q1,
  italic: H1,
  underline: V1,
  strike: U1,
  orderedList: W1,
  bulletList: K1,
  text_align: Z1,
  font_color: J1,
  caption: G1,
  alt_text: Y1,
  image: X1,
  image_side: Q1,
  image_center: e0,
  image_in_line: t0,
  image_change_alt_text: n0,
  image_change_caption: i0,
  image_change_link: r0,
  substitutions: o0,
  image_via_link: s0,
  image_insert_via_link: a0,
  image_error: l0,
  line_height: c0,
  unset: u0,
  extra_spacing: d0,
  global: h0,
  default_font_size: f0,
  image_change_mobile_full_width: p0,
  test: m0
}, VR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: Y1,
  background_color: D1,
  bold: q1,
  bulletList: K1,
  caption: G1,
  decrease_intent: B1,
  default: g0,
  default_font_size: f0,
  extra_spacing: d0,
  font_color: J1,
  font_family: A1,
  font_size: R1,
  global: h0,
  image: X1,
  image_center: e0,
  image_change_alt_text: n0,
  image_change_caption: i0,
  image_change_link: r0,
  image_change_mobile_full_width: p0,
  image_error: l0,
  image_in_line: t0,
  image_insert_via_link: a0,
  image_side: Q1,
  image_via_link: s0,
  increase_intent: j1,
  italic: H1,
  line_height: c0,
  link: F1,
  orderedList: W1,
  redo: P1,
  special_characters: L1,
  strike: U1,
  substitute_variables: z1,
  substitutions: o0,
  test: m0,
  text_align: Z1,
  text_level: N1,
  underline: V1,
  undo: I1,
  unset: u0
}, Symbol.toStringTag, { value: "Module" })), _0 = "Variabel pengganti", b0 = { title: "Keluarga font", hint: "Font standar menggunakan font klien email", default: "Default" }, k0 = { title: "Judul", paragraph: "Paragraf", header_one: "Header 1", header_two: "Header 2", header_three: "Header 3" }, y0 = { dollar: "Tanda dolar", euro: "Tanda euro", yen: "Tanda yen", pound: "Tanda pound", cent: "Tanda sen", euro_currency: "Tanda mata uang euro", colon: "Tanda titik dua", cruzeiro: "Tanda cruzeiro", french_franc: "Tanda franc Prancis", lira: "Tanda lira", currency: "Tanda mata uang", bitcoin: "Tanda Bitcoin", mill: "Tanda mil", peseta: "Tanda peseta", rupee: "Tanda rupee", won: "Tanda won", new_sheqel: "Tanda shekel baru", dong: "Tanda dong", kip: "Tanda kip", tugrik: "Tanda tugrik", drachma: "Tanda drachma", german_penny: "Tanda penny Jerman", peso: "Tanda peso", guarani: "Tanda guarani", austral: "Tanda austral", hryvnia: "Tanda hryvnia", cedi: "Tanda cedi", livre_tournois: "Tanda livre tournois", spesmilo: "Tanda spesmilo", tenge: "Tanda tenge", indian_rupee: "Tanda rupee India", turkish_lira: "Tanda lira Turki", nordic_mark: "Tanda mark Nordik", ruble: "Tanda rubel", left_pointing_angle_quotation_mark: "Tanda kutip sudut kiri tunggal", right_pointing_angle_quotation_mark: "Tanda kutip sudut kanan tunggal", left_pointing_double_angle_quotation_mark: "Tanda kutip sudut ganda kiri", right_pointing_double_angle_quotation_mark: "Tanda kutip sudut ganda kanan", left_single_quotation_mark: "Tanda kutip tunggal kiri", right_single_quotation_mark: "Tanda kutip tunggal kanan", left_double_quotation_mark: "Tanda kutip ganda kiri", right_double_quotation_mark: "Tanda kutip ganda kanan", single_low_quotation_mark: "Tanda kutip rendah tunggal 9", double_low_quotation_mark: "Tanda kutip rendah ganda 9", inverted_exclamation_mark: "Tanda seru terbalik", inverted_question_mark: "Tanda tanya terbalik", two_dot_leader: "Pemimpin dua titik", horizontal_ellipsis: "Elipsis horizontal", double_dagger: "Dagger ganda", per_mille_sign: "Tanda per mille", per_ten_thousand_sign: "Tanda per sepuluh ribu", question_exclamation_mark: "Tanda tanya seru", exclamation_question_mark: "Tanda seru tanya", double_question_mark: "Tanda tanya ganda", copyright_sign: "Tanda hak cipta", registered_sign: "Tanda terdaftar", trade_mark_sign: "Tanda merek dagang", section_sign: "Tanda bagian", paragraph_sign: "Tanda paragraf", reversed_paragraph_sign: "Tanda paragraf terbalik", select_text: "Teks", select_currency: "Mata uang", select_all: "Semua", title: "Karakter khusus", manat: "Tanda manat", double_exclamation_mark: "Tanda seru ganda" }, v0 = "Warna latar belakang font", x0 = "Ukuran font", S0 = "Batalkan", w0 = "Ulangi", C0 = "Tingkatkan indentasi", T0 = "Kurangi indentasi", M0 = "Tautan", E0 = "Tebal", $0 = "Miring", O0 = "Garis bawah", z0 = "Garis tengah", A0 = "Daftar bernomor", N0 = "Daftar berpoin", L0 = "Penyelarasan teks", D0 = "Warna font", R0 = "Keterangan", I0 = "Alternatif teks", P0 = "Gambar", j0 = "Gambar rata kiri", B0 = "Gambar rata tengah", F0 = "Gambar rata kanan", q0 = "Ubah teks alternatif gambar", H0 = "Ubah keterangan gambar", V0 = "Ubah tautan gambar", U0 = "Substitusi", W0 = "Gambar melalui tautan", K0 = "Sisipkan gambar melalui tautan", Z0 = "Gagal memproses gambar", J0 = "Tinggi garis", G0 = "Tidak diatur", Y0 = "Jarak ekstra", X0 = { apply: "Menerapkan", clear: "Jernih", error: "Kesalahan" }, Q0 = "Default", ev = "Atur lebar gambar agar sesuai dengan lebar penuh perangkat seluler", tv = { one: "Uji" }, nv = {
  substitute_variables: _0,
  font_family: b0,
  text_level: k0,
  special_characters: y0,
  background_color: v0,
  font_size: x0,
  undo: S0,
  redo: w0,
  increase_intent: C0,
  decrease_intent: T0,
  link: M0,
  bold: E0,
  italic: $0,
  underline: O0,
  strike: z0,
  orderedList: A0,
  bulletList: N0,
  text_align: L0,
  font_color: D0,
  caption: R0,
  alt_text: I0,
  image: P0,
  image_side: j0,
  image_center: B0,
  image_in_line: F0,
  image_change_alt_text: q0,
  image_change_caption: H0,
  image_change_link: V0,
  substitutions: U0,
  image_via_link: W0,
  image_insert_via_link: K0,
  image_error: Z0,
  line_height: J0,
  unset: G0,
  extra_spacing: Y0,
  global: X0,
  default_font_size: Q0,
  image_change_mobile_full_width: ev,
  test: tv
}, UR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: I0,
  background_color: v0,
  bold: E0,
  bulletList: N0,
  caption: R0,
  decrease_intent: T0,
  default: nv,
  default_font_size: Q0,
  extra_spacing: Y0,
  font_color: D0,
  font_family: b0,
  font_size: x0,
  global: X0,
  image: P0,
  image_center: B0,
  image_change_alt_text: q0,
  image_change_caption: H0,
  image_change_link: V0,
  image_change_mobile_full_width: ev,
  image_error: Z0,
  image_in_line: F0,
  image_insert_via_link: K0,
  image_side: j0,
  image_via_link: W0,
  increase_intent: C0,
  italic: $0,
  line_height: J0,
  link: M0,
  orderedList: A0,
  redo: w0,
  special_characters: y0,
  strike: z0,
  substitute_variables: _0,
  substitutions: U0,
  test: tv,
  text_align: L0,
  text_level: k0,
  underline: O0,
  undo: S0,
  unset: G0
}, Symbol.toStringTag, { value: "Module" })), iv = "Variabili", rv = { title: "Famiglia caratteri", hint: "Il font predefinito utilizza i font per il client di posta elettronica", default: "predefinito" }, ov = { title: "Intestazione", paragraph: "Paragrafo", header_one: "Intestazione 1", header_two: "Intestazione 2", header_three: "Intestazione 3" }, sv = { dollar: "Simbolo del dollaro", euro: "Simbolo dell'euro", yen: "Simbolo dello yen", pound: "Simbolo della sterlina", cent: "Simbolo del centesimo", euro_currency: "Simbolo della valuta in euro", colon: "Simbolo del colòn", cruzeiro: "Simbolo del cruzeiro", french_franc: "Simbolo del franco francese", lira: "Simbolo della lira", currency: "Simbolo della valuta", bitcoin: "Simbolo del bitcoin", mill: "Simbolo del mill", peseta: "Simbolo della peseta", rupee: "Simbolo della rupia", won: "Simbolo del won", new_sheqel: "Nuovo Simbolo sheqel", dong: "Simbolo del dong", kip: "Simbolo del kip", tugrik: "Simbolo del tugrik", drachma: "Simbolo della dracma", german_penny: "Simbolo del centesimo tedesco", peso: "Simbolo del peso", guarani: "Simbolo del Guarani", austral: "Simbolo dell'austral", hryvnia: "Simbolo della hryvnia", cedi: "Simbolo del Cedi", livre_tournois: "Simbolo del livre tournois", spesmilo: "Simbolo dello spesmilo", tenge: "Simbolo del tenge", indian_rupee: "Simbolo della rupia indiana", turkish_lira: "Simbolo della lira turca", nordic_mark: "Simbolo del marco nordico", ruble: "Simbolo del rublo", left_pointing_angle_quotation_mark: "Virgolette angolari singole a sinistra", right_pointing_angle_quotation_mark: "Virgoletta angolare singola rivolta a destra", left_pointing_double_angle_quotation_mark: "Virgolette doppie angolari a sinistra", right_pointing_double_angle_quotation_mark: "Virgolette doppie angolari con punta a destra", left_single_quotation_mark: "Virgolette singole a sinistra", right_single_quotation_mark: "Virgolette singole a destra", left_double_quotation_mark: "Virgolette doppie a sinistra", right_double_quotation_mark: "Virgolette doppie a destra", single_low_quotation_mark: "Singola virgoletta bassa-9", double_low_quotation_mark: "Doppie virgolette basse 9", inverted_exclamation_mark: "Punto esclamativo rovesciato", inverted_question_mark: "Punto interrogativo rovesciato", two_dot_leader: "Leader a due punti", horizontal_ellipsis: "Ellissi orizzontale", double_dagger: "Doppio pugnale", per_mille_sign: "Segno per mille", per_ten_thousand_sign: "Per ogni diecimila segni", question_exclamation_mark: "Domanda punto esclamativo", exclamation_question_mark: "Punto interrogativo esclamativo", double_question_mark: "Doppio punto interrogativo", copyright_sign: "Segno di copyright", registered_sign: "Segno registrato", trade_mark_sign: "Segno del marchio", section_sign: "Segno della sezione", paragraph_sign: "Segno del paragrafo", reversed_paragraph_sign: "Segno di paragrafo invertito", select_text: "Testo", select_currency: "Valuta", select_all: "Tutto", title: "Caratteri speciali", manat: "Segno Manat", double_exclamation_mark: "Doppio punto esclamativo" }, av = "Colore di sfondo del carattere", lv = "Dimensione carattere", cv = "Annullare", uv = "Ripetere", dv = "Aumentare l'intento", hv = "Diminuire l'intento", fv = "Collegamento", pv = "Grassetto", mv = "Corsivo", gv = "Sottolineato", _v = "Barrato", bv = "Elenco numerato", kv = "Elenco puntato", yv = "Allineamento del testo", vv = "Colori dei font", xv = "Didascalia", Sv = "Alternativa di testo", wv = "Immagine", Cv = "Allineamento dell'immagine a sinistra", Tv = "Allineamento dell'immagine al centro", Mv = "Allineamento dell'immagine a destra", Ev = "Cambia il testo alternativo dell'immagine", $v = "Cambia la didascalia dell'immagine", Ov = "Cambia il link dell'immagine", zv = "Sostituzioni", Av = "Immagine tramite link", Nv = "Inserisci immagine tramite link", Lv = "Impossibile elaborare l'immagine", Dv = "Altezza della linea", Rv = "Non impostato", Iv = "Spaziatura tra paragrafi", Pv = { apply: "Applica", clear: "Cancella", error: "Errore" }, jv = "predefinito", Bv = "Imposta la larghezza dell'immagine alla larghezza completa del dispositivo mobile", Fv = { one: "Prova" }, qv = {
  substitute_variables: iv,
  font_family: rv,
  text_level: ov,
  special_characters: sv,
  background_color: av,
  font_size: lv,
  undo: cv,
  redo: uv,
  increase_intent: dv,
  decrease_intent: hv,
  link: fv,
  bold: pv,
  italic: mv,
  underline: gv,
  strike: _v,
  orderedList: bv,
  bulletList: kv,
  text_align: yv,
  font_color: vv,
  caption: xv,
  alt_text: Sv,
  image: wv,
  image_side: Cv,
  image_center: Tv,
  image_in_line: Mv,
  image_change_alt_text: Ev,
  image_change_caption: $v,
  image_change_link: Ov,
  substitutions: zv,
  image_via_link: Av,
  image_insert_via_link: Nv,
  image_error: Lv,
  line_height: Dv,
  unset: Rv,
  extra_spacing: Iv,
  global: Pv,
  default_font_size: jv,
  image_change_mobile_full_width: Bv,
  test: Fv
}, WR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: Sv,
  background_color: av,
  bold: pv,
  bulletList: kv,
  caption: xv,
  decrease_intent: hv,
  default: qv,
  default_font_size: jv,
  extra_spacing: Iv,
  font_color: vv,
  font_family: rv,
  font_size: lv,
  global: Pv,
  image: wv,
  image_center: Tv,
  image_change_alt_text: Ev,
  image_change_caption: $v,
  image_change_link: Ov,
  image_change_mobile_full_width: Bv,
  image_error: Lv,
  image_in_line: Mv,
  image_insert_via_link: Nv,
  image_side: Cv,
  image_via_link: Av,
  increase_intent: dv,
  italic: mv,
  line_height: Dv,
  link: fv,
  orderedList: bv,
  redo: uv,
  special_characters: sv,
  strike: _v,
  substitute_variables: iv,
  substitutions: zv,
  test: Fv,
  text_align: yv,
  text_level: ov,
  underline: gv,
  undo: cv,
  unset: Rv
}, Symbol.toStringTag, { value: "Module" })), Hv = "代用変数", Vv = { title: "フォントファミリー", hint: "標準フォントはメールクライアントのフォントを使用しています。", default: "デフォルト" }, Uv = { title: "見出し", paragraph: "段落", header_one: "見出し１", header_two: "見出し２", header_three: "見出し３" }, Wv = { dollar: "ドル記号", euro: "ユーロ記号", yen: "円記号", pound: "ポンド記号", cent: "セント記号", euro_currency: "ユーロ通貨記号", colon: "コロン記号", cruzeiro: "クルゼイロ記号", french_franc: "フランスフラン記号", lira: "リラ記号", currency: "通貨記号", bitcoin: "ビットコイン記号", mill: "ミル記号", peseta: "ペセタ記号", rupee: "ルピー記号", won: "元記号", new_sheqel: "新シェケル記号", dong: "ドン記号", kip: "キップ記号", tugrik: "トゥグリク記号", drachma: "ドラクマ記号", german_penny: "ドイツペニー記号", peso: "ペソ記号", guarani: "グアラニ記号", austral: "南半球記号", hryvnia: "グリブナ記号", cedi: "セディ記号", livre_tournois: "リブレトゥルノワ記号", spesmilo: "スペすミーロ記号", tenge: "テンゲ記号", indian_rupee: "インドルピー記号", turkish_lira: "トルコリラ記号", nordic_mark: "北欧マーク記号", ruble: "ルーブル記号", left_pointing_angle_quotation_mark: "左向きシングル引用符", right_pointing_angle_quotation_mark: "右向きシングル引用符", left_pointing_double_angle_quotation_mark: "左向き二重引用符", right_pointing_double_angle_quotation_mark: "右向き二重引用符", left_single_quotation_mark: "左シングル引用符", right_single_quotation_mark: "右シングル引用符", left_double_quotation_mark: "左二重引用符", right_double_quotation_mark: "右二重引用符", single_low_quotation_mark: "シングル低9引用符", double_low_quotation_mark: "二重低9引用符", inverted_exclamation_mark: "逆向きビックリマーク", inverted_question_mark: "反転クエスチョンマーク", two_dot_leader: "2ドットリーダー", horizontal_ellipsis: "水平省略記号", double_dagger: "二重ダガー", per_mille_sign: "1000分記号", per_ten_thousand_sign: "1万ごと記号", question_exclamation_mark: "クエスチョンビックリマーク", exclamation_question_mark: "ビックリクエスチョンマーク", double_question_mark: "二重クエスチョンマーク", copyright_sign: "著作権記号", registered_sign: "登録記号", trade_mark_sign: "商標記号", section_sign: "区切り記号", paragraph_sign: "段落記号", reversed_paragraph_sign: "段落記号の反転", select_text: "テキスト", select_currency: "通過", select_all: "全て", title: "特殊文字", manat: "マネーのサイン", double_exclamation_mark: "二重ビックリマーク" }, Kv = "フォント背景色", Zv = "フォントサイズ", Jv = "元に戻す", Gv = "やり直す", Yv = "字上げ", Xv = "字下げ", Qv = "リンク", ex = "太字", tx = "斜体", nx = "下線", ix = "取消線", rx = "番号付きリスト", ox = "箇条書き", sx = "テキストの配置", ax = "フォントの色", lx = "キャプション", cx = "テキストの代替", ux = "画像", dx = "画像を左に配置", hx = "画像を中央に配置", fx = "画像を右に配置", px = "画像の代替テキストを変更", mx = "画像のキャプションを変更", gx = "画像のリンクを変更", _x = "差し込み項目", bx = "外部リンク画像", kx = "リンクから画像を挿入", yx = "画像の処理に失敗しました", vx = "行の高さ", xx = "未設定", Sx = "段落の余白", wx = { apply: "適用する", clear: "クリア", error: "エラー" }, Cx = "デフォルト", Tx = "画像の幅をモバイルデバイスの全幅に設定します", Mx = { one: "テスト" }, Ex = {
  substitute_variables: Hv,
  font_family: Vv,
  text_level: Uv,
  special_characters: Wv,
  background_color: Kv,
  font_size: Zv,
  undo: Jv,
  redo: Gv,
  increase_intent: Yv,
  decrease_intent: Xv,
  link: Qv,
  bold: ex,
  italic: tx,
  underline: nx,
  strike: ix,
  orderedList: rx,
  bulletList: ox,
  text_align: sx,
  font_color: ax,
  caption: lx,
  alt_text: cx,
  image: ux,
  image_side: dx,
  image_center: hx,
  image_in_line: fx,
  image_change_alt_text: px,
  image_change_caption: mx,
  image_change_link: gx,
  substitutions: _x,
  image_via_link: bx,
  image_insert_via_link: kx,
  image_error: yx,
  line_height: vx,
  unset: xx,
  extra_spacing: Sx,
  global: wx,
  default_font_size: Cx,
  image_change_mobile_full_width: Tx,
  test: Mx
}, KR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: cx,
  background_color: Kv,
  bold: ex,
  bulletList: ox,
  caption: lx,
  decrease_intent: Xv,
  default: Ex,
  default_font_size: Cx,
  extra_spacing: Sx,
  font_color: ax,
  font_family: Vv,
  font_size: Zv,
  global: wx,
  image: ux,
  image_center: hx,
  image_change_alt_text: px,
  image_change_caption: mx,
  image_change_link: gx,
  image_change_mobile_full_width: Tx,
  image_error: yx,
  image_in_line: fx,
  image_insert_via_link: kx,
  image_side: dx,
  image_via_link: bx,
  increase_intent: Yv,
  italic: tx,
  line_height: vx,
  link: Qv,
  orderedList: rx,
  redo: Gv,
  special_characters: Wv,
  strike: ix,
  substitute_variables: Hv,
  substitutions: _x,
  test: Mx,
  text_align: sx,
  text_level: Uv,
  underline: nx,
  undo: Jv,
  unset: xx
}, Symbol.toStringTag, { value: "Module" })), $x = "Vervangende variabelen", Ox = { title: "Lettertype", hint: "Standaardlettertype gebruikt de lettertypes van de e-mailclient", default: "Standaard" }, zx = { title: "Koptekst", paragraph: "Paragraaf", header_one: "Kop 1", header_two: "Kop 2", header_three: "Kop 3" }, Ax = { dollar: "Dollar-teken", euro: "Euro-teken", yen: "Yen-teken", pound: "Pond-teken", cent: "Cent-teken", euro_currency: "Euro-teken", colon: "Colón-teken", cruzeiro: "Cruzeiro-teken", french_franc: "Frank-teken", lira: "Lira-teken", currency: "Valutateken", bitcoin: "Bitcoin-teken", mill: "Mill-teken", peseta: "Peseta-teken", rupee: "Roepie-teken", won: "Zuid-Koreaanse won-teken", new_sheqel: "Nieuwe sjekel-teken", dong: "Dong-teken", kip: "Kip-teken", tugrik: "Tugrik-teken", drachma: "Drachme-teken", german_penny: "Duitse cent-teken", peso: "Peso-teken", guarani: "Guarani-teken", austral: "Austral-teken", hryvnia: "Hryvnia-teken", cedi: "Cedi-teken", livre_tournois: "Livre tournois-teken", spesmilo: "Spesmilo-teken", tenge: "Tenge-teken", indian_rupee: "Indiase roepie-teken", turkish_lira: "Turkse lira-teken", nordic_mark: "Noordse markteken", ruble: "Roebel-teken", left_pointing_angle_quotation_mark: "Enkele linkswijzende hoekaanhalingsteken", right_pointing_angle_quotation_mark: "Enkel rechtsdraaiend hoek-aanhalingsteken", left_pointing_double_angle_quotation_mark: "Linksdraaiend dubbel hoek-aanhalingsteken", right_pointing_double_angle_quotation_mark: "Rechtdraaiend dubbel hoek-aanhalingsteken", left_single_quotation_mark: "Linkermatig enkel aanhalingsteken", right_single_quotation_mark: "Rechtermatig enkele aanhalingsteken", left_double_quotation_mark: "Linkermatig dubbel aanhalingsteken", right_double_quotation_mark: "Rechtermatig dubbel aanhalingsteken", single_low_quotation_mark: "Enkele lage-9 aanhalingsteken", double_low_quotation_mark: "Dubbele lage-9 aanhalingstekens", inverted_exclamation_mark: "Omgekeerd uitroepteken", inverted_question_mark: "Omgekeerd vraagteken", two_dot_leader: "twee-punt-leider", horizontal_ellipsis: "Horizontale ellips", double_dagger: "Dubbele kruis", per_mille_sign: "Per duizend", per_ten_thousand_sign: "Per tienduizend-teken", question_exclamation_mark: "Uitroepvraagteken", exclamation_question_mark: "Uitroepvraagteken", double_question_mark: "Dubbele vraagteken", copyright_sign: "Auteursrecht-teken", registered_sign: "Geregistreerd merk-teken", trade_mark_sign: "Merkteken", section_sign: "Sectie-teken", paragraph_sign: "Alinea-teken", reversed_paragraph_sign: "Omgekeerd alinea-teken", select_text: "Tekst", select_currency: "Valuta", select_all: "Alles", title: "Speciale tekens", manat: "Alinea-teken", double_exclamation_mark: "Alinea-teken" }, Nx = "Achtergrondkleur tekst", Lx = "Lettergrootte", Dx = "Ongedaan maken", Rx = "Opnieuw uitvoeren", Ix = "Invoering vergroten", Px = "Invoering verkleinen", jx = "Link", Bx = "Vet", Fx = "Cursief", qx = "Onderstrepen", Hx = "Doorstrepen", Vx = "Genummerde lijst", Ux = "Opsomminglijst", Wx = "Tekstuitlijning", Kx = "Letterkleur", Zx = "Bijschrift", Jx = "Alternatieve tekst", Gx = "Afbeelding", Yx = "Afbeelding links uitlijnen", Xx = "Afbeelding centreren", Qx = "Afbeelding rechts uitlijnen", eS = "Wijzig alternatieve tekst voor afbeelding", tS = "Wijzig bijschrift van afbeelding", nS = "Wijzig afbeeldingslink", iS = "Vervangingen", rS = "Afbeelding via link", oS = "Afbeelding invoegen via link", sS = "Afbeelding kon niet worden verwerkt", aS = "Lijnhoogte", lS = "Niet ingesteld", cS = "Alinea-afstand", uS = { apply: "Toepassen", clear: "Wissen", error: "Fout" }, dS = "Standaard", hS = "Stel de breedte van de afbeelding in op de volledige breedte van het mobiele apparaat", fS = { one: "Test" }, pS = {
  substitute_variables: $x,
  font_family: Ox,
  text_level: zx,
  special_characters: Ax,
  background_color: Nx,
  font_size: Lx,
  undo: Dx,
  redo: Rx,
  increase_intent: Ix,
  decrease_intent: Px,
  link: jx,
  bold: Bx,
  italic: Fx,
  underline: qx,
  strike: Hx,
  orderedList: Vx,
  bulletList: Ux,
  text_align: Wx,
  font_color: Kx,
  caption: Zx,
  alt_text: Jx,
  image: Gx,
  image_side: Yx,
  image_center: Xx,
  image_in_line: Qx,
  image_change_alt_text: eS,
  image_change_caption: tS,
  image_change_link: nS,
  substitutions: iS,
  image_via_link: rS,
  image_insert_via_link: oS,
  image_error: sS,
  line_height: aS,
  unset: lS,
  extra_spacing: cS,
  global: uS,
  default_font_size: dS,
  image_change_mobile_full_width: hS,
  test: fS
}, ZR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: Jx,
  background_color: Nx,
  bold: Bx,
  bulletList: Ux,
  caption: Zx,
  decrease_intent: Px,
  default: pS,
  default_font_size: dS,
  extra_spacing: cS,
  font_color: Kx,
  font_family: Ox,
  font_size: Lx,
  global: uS,
  image: Gx,
  image_center: Xx,
  image_change_alt_text: eS,
  image_change_caption: tS,
  image_change_link: nS,
  image_change_mobile_full_width: hS,
  image_error: sS,
  image_in_line: Qx,
  image_insert_via_link: oS,
  image_side: Yx,
  image_via_link: rS,
  increase_intent: Ix,
  italic: Fx,
  line_height: aS,
  link: jx,
  orderedList: Vx,
  redo: Rx,
  special_characters: Ax,
  strike: Hx,
  substitute_variables: $x,
  substitutions: iS,
  test: fS,
  text_align: Wx,
  text_level: zx,
  underline: qx,
  undo: Dx,
  unset: lS
}, Symbol.toStringTag, { value: "Module" })), mS = "Erstatningsvariabler", gS = { title: "Skrifttypefamilie", hint: "Standard skrifttype bruker e-postklientens skrifttyper", default: "Standard" }, _S = { title: "Overskrift", paragraph: "Avsnitt", header_one: "Overskrift 1", header_two: "Overskrift 2", header_three: "Overskrift 3" }, bS = { dollar: "Dollar tegn", euro: "Euro tegn", yen: "Yen tegn", pound: "Pund tegn", cent: "Cent tegn", euro_currency: "Euro-valuta tegn", colon: "Kolon tegn", cruzeiro: "Cruzeiro tegn", french_franc: "Fransk franc tegn", lira: "Lira tegn", currency: "Valutasymbol", bitcoin: "Bitcoin-symbol", mill: "Millsymbol", peseta: "Pesetasymbol", rupee: "Rupiesymbol", won: "Wonsymbol", new_sheqel: "Ny shekel-symbol", dong: "Dong-symbol", kip: "Kipsymbol", tugrik: "Tugrik-symbol", drachma: "Drachmasymbol", german_penny: "Tysk penny-symbol", peso: "Pesosymbol", guarani: "Guaranisymbol", austral: "Australsymbol", hryvnia: "Hryvnia-symbol", cedi: "Cedisymbol", livre_tournois: "Livre tournois-symbol", spesmilo: "Spesmilo-symbol", tenge: "Tengesymbol", indian_rupee: "Indisk rupiesymbol", turkish_lira: "Tyrkisk lira-symbol", nordic_mark: "Nordisk mark-symbol", ruble: "Rublen-symbol", left_pointing_angle_quotation_mark: "Enkel venstre-pil vinkelsitattegn", right_pointing_angle_quotation_mark: "Enkel høyre-pil vinkelsitattegn", left_pointing_double_angle_quotation_mark: "Venstre dobbeltvinkel sitattegn", right_pointing_double_angle_quotation_mark: "Høyre dobbeltvinkel sitattegn", left_single_quotation_mark: "Venstre enkel sitattegn", right_single_quotation_mark: "Høyre enkel sitattegn", left_double_quotation_mark: "Venstre dobbel anførselstegn", right_double_quotation_mark: "Høyre dobbel anførselstegn", single_low_quotation_mark: "Enkelt lav-9 anførselstegn", double_low_quotation_mark: "Dobbel lav-9 anførselstegn", inverted_exclamation_mark: "Invertert utropstegn", inverted_question_mark: "Invertert spørsmålstegn", two_dot_leader: "To punkters leder", horizontal_ellipsis: "Horisonalt ellipsis", double_dagger: "Dobbel dolk", per_mille_sign: "Per mille-tegn", per_ten_thousand_sign: "Per ti tusen-tegn", question_exclamation_mark: "Spørsmål utropstegn", exclamation_question_mark: "Utrop spørsmålstegn", double_question_mark: "Dobbel spørsmålstegn", copyright_sign: "Opphavsrett-tegn", registered_sign: "Registrert tegn", trade_mark_sign: "Varemerke-tegn", section_sign: "Paragraf-tegn", paragraph_sign: "Avsnitt-tegn", reversed_paragraph_sign: "Reversert avsnitt-tegn", select_text: "Tekst", select_currency: "Valuta", select_all: "Alle", title: "Spesialtegn", manat: "Manat-tegn", double_exclamation_mark: "Dobbelt utropstegn" }, kS = "Bakgrunnsfarge på skrifttype", yS = "Skriftstørrelse", vS = "Angre", xS = "Gjør om", SS = "Øk innrykk", wS = "Reduser innrykk", CS = "Lenke", TS = "Fet", MS = "Kursiv", ES = "Understreket", $S = "Gjennomstreket", OS = "Nummerert liste", zS = "Punktliste", AS = "Tekstjustering", NS = "Skriftfarge", LS = "Bildetekst", DS = "Tekstalternativ", RS = "Bilde", IS = "Bilde juster venstre", PS = "Bilde juster senter", jS = "Bilde juster høyre", BS = "Endre bilde tekstalternativ", FS = "Endre bilde bildetekst", qS = "Endre bilde lenke", HS = "Substitusjoner", VS = "Bilde via lenke", US = "Sett inn bilde via lenke", WS = "Kunne ikke behandle bildet", KS = "Linjehøyde", ZS = "Tilbakestill", JS = "Ekstra mellomrom", GS = { apply: "Søke om", clear: "Klar", error: "Feil" }, YS = "Standard", XS = "Still inn bildets bredde til full bredde på mobilenheten", QS = { one: "Test" }, ew = {
  substitute_variables: mS,
  font_family: gS,
  text_level: _S,
  special_characters: bS,
  background_color: kS,
  font_size: yS,
  undo: vS,
  redo: xS,
  increase_intent: SS,
  decrease_intent: wS,
  link: CS,
  bold: TS,
  italic: MS,
  underline: ES,
  strike: $S,
  orderedList: OS,
  bulletList: zS,
  text_align: AS,
  font_color: NS,
  caption: LS,
  alt_text: DS,
  image: RS,
  image_side: IS,
  image_center: PS,
  image_in_line: jS,
  image_change_alt_text: BS,
  image_change_caption: FS,
  image_change_link: qS,
  substitutions: HS,
  image_via_link: VS,
  image_insert_via_link: US,
  image_error: WS,
  line_height: KS,
  unset: ZS,
  extra_spacing: JS,
  global: GS,
  default_font_size: YS,
  image_change_mobile_full_width: XS,
  test: QS
}, JR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: DS,
  background_color: kS,
  bold: TS,
  bulletList: zS,
  caption: LS,
  decrease_intent: wS,
  default: ew,
  default_font_size: YS,
  extra_spacing: JS,
  font_color: NS,
  font_family: gS,
  font_size: yS,
  global: GS,
  image: RS,
  image_center: PS,
  image_change_alt_text: BS,
  image_change_caption: FS,
  image_change_link: qS,
  image_change_mobile_full_width: XS,
  image_error: WS,
  image_in_line: jS,
  image_insert_via_link: US,
  image_side: IS,
  image_via_link: VS,
  increase_intent: SS,
  italic: MS,
  line_height: KS,
  link: CS,
  orderedList: OS,
  redo: xS,
  special_characters: bS,
  strike: $S,
  substitute_variables: mS,
  substitutions: HS,
  test: QS,
  text_align: AS,
  text_level: _S,
  underline: ES,
  undo: vS,
  unset: ZS
}, Symbol.toStringTag, { value: "Module" })), tw = "Zmienne zastępcze", nw = { title: "Rodzina czcionek", hint: "Standardowa czcionka używa czcionki klienta pocztowego", default: "Domyślny" }, iw = { title: "Nagłówek", paragraph: "Akapit", header_one: "Nagłówek 1", header_two: "Nagłówek 2", header_three: "Nagłówek 3" }, rw = { dollar: "Znak dolara", euro: "Znak euro", yen: "Znak jena", pound: "Znak funta", cent: "Znak centa", euro_currency: "Znak waluty euro", colon: "Dwukropek", cruzeiro: "Znak cruzeiro", french_franc: "Znak franka francuskiego", lira: "Znak liry", currency: "Znak waluty", bitcoin: "Znak Bitcoina", mill: "Znak mill", peseta: "Znak pesety", rupee: "Znak rupii", won: "Znak wona", new_sheqel: "Znak nowego szekla", dong: "Znak dong", kip: "Znak kip", tugrik: "Znak tugrik", drachma: "Znak drachmy", german_penny: "Znak niemieckiego feniga", peso: "Znak peso", guarani: "Znak guarani", austral: "Znak austral", hryvnia: "Znak hrywna", cedi: "Znak cedi", livre_tournois: "Znak livre tournois", spesmilo: "Znak spesmilo", tenge: "Znak Tenge", indian_rupee: "Znak rupii indyjskiej", turkish_lira: "Znak liry tureckiej", nordic_mark: "Znak marki nordyckiej", ruble: "Znak rubla", left_pointing_angle_quotation_mark: "Pojedynczy lewy szewron", right_pointing_angle_quotation_mark: "Pojedynczy prawy szewron", left_pointing_double_angle_quotation_mark: "Podwójny lewy szewron", right_pointing_double_angle_quotation_mark: "Podwójny prawy szewron", left_single_quotation_mark: "Lewy pojedynczy cudzysłów", right_single_quotation_mark: "Prawy pojedynczy cudzysłów", left_double_quotation_mark: "Lewy podwójny cudzysłów", right_double_quotation_mark: "Prawy podwójny cudzysłów", single_low_quotation_mark: "Pojedynczy niski cudzysłów 9", double_low_quotation_mark: "Podwójny niski cudzysłów 9", inverted_exclamation_mark: "Odwrócony wykrzyknik", inverted_question_mark: "Odwrócony znak zapytania", two_dot_leader: "Dwupunktowy lider", horizontal_ellipsis: "Pozioma elipsa", double_dagger: "Podwójny krzyżyk", per_mille_sign: "Znak promila", per_ten_thousand_sign: "Znak na dziesięć tysięcy", question_exclamation_mark: "Znak zapytania i wykrzyknik", exclamation_question_mark: "wykrzyknik i znak zapytania", double_question_mark: "Podwójny znak zapytania", copyright_sign: "Znak praw autorskich", registered_sign: "Znak zarejestrowany", trade_mark_sign: "Znak towarowy", section_sign: "Znak sekcji", paragraph_sign: "Znak paragrafu", reversed_paragraph_sign: "Odwrócony znak paragrafu", select_text: "Tekst", select_currency: "Waluta", select_all: "Wszystko", title: "Znaki specjalne", manat: "Znak manat", double_exclamation_mark: "Podwójny wykrzyknik" }, ow = "Kolor tła czcionki", sw = "Rozmiar czcionki", aw = "Cofnij", lw = "Ponów", cw = "Zwiększ wcięcie", uw = "Zmniejsz wcięcie", dw = "Link", hw = "Pogrubienie", fw = "Kursywa", pw = "Podkreślenie", mw = "Przekreślenie", gw = "Lista numerowana", _w = "Lista punktowana", bw = "Wyrównanie tekstu", kw = "Kolor czcionki", yw = "Podpis", vw = "Alternatywny tekst", xw = "Obraz", Sw = "Wyrównaj obrazek do boku", ww = "Wyrównaj obrazek do środka", Cw = "Wyrównanie", Tw = "Zmień tekst alternatywny obrazka", Mw = "Zmień podpis obrazka", Ew = "Zmień link obrazka", $w = "Zamienniki", Ow = "Obraz za pomocą linku", zw = "Wstaw obraz za pomocą linku", Aw = "Nie udało się przetworzyć obrazu", Nw = "Wysokość linii", Lw = "Nieustawione", Dw = "Dodatkowa przerwa", Rw = { apply: "Zastosuj", clear: "Wyczyść", error: "Błąd" }, Iw = "Domyślny", Pw = "Ustaw szerokość obrazu na pełną szerokość urządzenia mobilnego", jw = { one: "Test" }, Bw = {
  substitute_variables: tw,
  font_family: nw,
  text_level: iw,
  special_characters: rw,
  background_color: ow,
  font_size: sw,
  undo: aw,
  redo: lw,
  increase_intent: cw,
  decrease_intent: uw,
  link: dw,
  bold: hw,
  italic: fw,
  underline: pw,
  strike: mw,
  orderedList: gw,
  bulletList: _w,
  text_align: bw,
  font_color: kw,
  caption: yw,
  alt_text: vw,
  image: xw,
  image_side: Sw,
  image_center: ww,
  image_in_line: Cw,
  image_change_alt_text: Tw,
  image_change_caption: Mw,
  image_change_link: Ew,
  substitutions: $w,
  image_via_link: Ow,
  image_insert_via_link: zw,
  image_error: Aw,
  line_height: Nw,
  unset: Lw,
  extra_spacing: Dw,
  global: Rw,
  default_font_size: Iw,
  image_change_mobile_full_width: Pw,
  test: jw
}, GR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: vw,
  background_color: ow,
  bold: hw,
  bulletList: _w,
  caption: yw,
  decrease_intent: uw,
  default: Bw,
  default_font_size: Iw,
  extra_spacing: Dw,
  font_color: kw,
  font_family: nw,
  font_size: sw,
  global: Rw,
  image: xw,
  image_center: ww,
  image_change_alt_text: Tw,
  image_change_caption: Mw,
  image_change_link: Ew,
  image_change_mobile_full_width: Pw,
  image_error: Aw,
  image_in_line: Cw,
  image_insert_via_link: zw,
  image_side: Sw,
  image_via_link: Ow,
  increase_intent: cw,
  italic: fw,
  line_height: Nw,
  link: dw,
  orderedList: gw,
  redo: lw,
  special_characters: rw,
  strike: mw,
  substitute_variables: tw,
  substitutions: $w,
  test: jw,
  text_align: bw,
  text_level: iw,
  underline: pw,
  undo: aw,
  unset: Lw
}, Symbol.toStringTag, { value: "Module" })), Fw = "Variáveis de substituição", qw = { title: "Família da fonte", hint: "A fonte padrão usa as fontes da plataforma de emails do cliente", default: "Padrão" }, Hw = { title: "Título", paragraph: "Parágrafo", header_one: "Título 1", header_two: "Título 2", header_three: "Título 3" }, Vw = { dollar: "Dollar sign", euro: "Euro sign", yen: "Yen sign", pound: "Pound sign", cent: "Cent sign", euro_currency: "Euro-currency sign", colon: "Colon sign", cruzeiro: "Cruzeiro sign", french_franc: "French franc sign", lira: "Lira sign", currency: "Currency sign", bitcoin: "Bitcoin sign", mill: "Mill sign", peseta: "Peseta sign", rupee: "Rupee sign", won: "Won sign", new_sheqel: "New sheqel sign", dong: "Dong sign", kip: "Kip sign", tugrik: "Tugrik sign", drachma: "Drachma sign", german_penny: "German penny sign", peso: "Peso sign", guarani: "Guarani sign", austral: "Austral sign", hryvnia: "Hryvnia sign", cedi: "Cedi sign", livre_tournois: "Livre tournois sign", spesmilo: "Spesmilo sign", tenge: "Tenge sign", indian_rupee: "Indian rupee sign", turkish_lira: "Turkish lira sign", nordic_mark: "Nordic mark sign", ruble: "Ruble sign", left_pointing_angle_quotation_mark: "Single left-pointing angle quotation mark", right_pointing_angle_quotation_mark: "Single right-pointing angle quotation mark", left_pointing_double_angle_quotation_mark: "Left-pointing double angle quotation mark", right_pointing_double_angle_quotation_mark: "Right-pointing double angle quotation mark", left_single_quotation_mark: "Left single quotation mark", right_single_quotation_mark: "Right single quotation mark", left_double_quotation_mark: "Left double quotation mark", right_double_quotation_mark: "Right double quotation mark", single_low_quotation_mark: "Single low-9 quotation mark", double_low_quotation_mark: "Double low-9 quotation mark", inverted_exclamation_mark: "Inverted exclamation mark", inverted_question_mark: "Ponto de interrogação invertido", two_dot_leader: "Dois pontos", horizontal_ellipsis: "Horizontal ellipsis", double_dagger: "Double dagger", per_mille_sign: "Per mille sign", per_ten_thousand_sign: "Per ten thousand sign", question_exclamation_mark: "Question exclamation mark", exclamation_question_mark: "Exclamation question mark", double_question_mark: "Double question mark", copyright_sign: "Copyright sign", registered_sign: "Registered sign", trade_mark_sign: "Trade mark sign", section_sign: "Section sign", paragraph_sign: "Paragraph sign", reversed_paragraph_sign: "Reversed paragraph sign", select_text: "Texto", select_currency: "Moeda", select_all: "Todos", title: "Caracteres especiais", manat: "Manat sign", double_exclamation_mark: "Double exclamation mark" }, Uw = "Cor de fundo da fonte", Ww = "Tamanho da fonte", Kw = "Desfazer", Zw = "Refazer", Jw = "Aumentar recuo", Gw = "Diminuir recuo", Yw = "Link", Xw = "Negrito", Qw = "Itálico", eC = "Sublinhado", tC = "Riscado", nC = "Lista numerada", iC = "Lista com marcadores", rC = "Alinhamento do texto", oC = "Cor da fonte", sC = "Legenda", aC = "Texto alternativo", lC = "Imagem", cC = "Alinhar imagem à esquerda", uC = "Centralizar a imagem", dC = "Alinhar imagem à direita", hC = "Alterar o texto alternativo da imagem", fC = "Alterar a legenda da imagem", pC = "Alterar o link da imagem", mC = "Substituições", gC = "Imagem através de link", _C = "Inserir imagem através de link", bC = "Falha ao processar a imagem", kC = "Altura da linha", yC = "Desmarcar", vC = "Espaçamento entre parágrafos", xC = { apply: "Aplicar", clear: "Limpar", error: "Erro" }, SC = "Padrão", wC = "Defina a largura da imagem para a largura total do dispositivo móvel", CC = { one: "Teste" }, TC = {
  substitute_variables: Fw,
  font_family: qw,
  text_level: Hw,
  special_characters: Vw,
  background_color: Uw,
  font_size: Ww,
  undo: Kw,
  redo: Zw,
  increase_intent: Jw,
  decrease_intent: Gw,
  link: Yw,
  bold: Xw,
  italic: Qw,
  underline: eC,
  strike: tC,
  orderedList: nC,
  bulletList: iC,
  text_align: rC,
  font_color: oC,
  caption: sC,
  alt_text: aC,
  image: lC,
  image_side: cC,
  image_center: uC,
  image_in_line: dC,
  image_change_alt_text: hC,
  image_change_caption: fC,
  image_change_link: pC,
  substitutions: mC,
  image_via_link: gC,
  image_insert_via_link: _C,
  image_error: bC,
  line_height: kC,
  unset: yC,
  extra_spacing: vC,
  global: xC,
  default_font_size: SC,
  image_change_mobile_full_width: wC,
  test: CC
}, YR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: aC,
  background_color: Uw,
  bold: Xw,
  bulletList: iC,
  caption: sC,
  decrease_intent: Gw,
  default: TC,
  default_font_size: SC,
  extra_spacing: vC,
  font_color: oC,
  font_family: qw,
  font_size: Ww,
  global: xC,
  image: lC,
  image_center: uC,
  image_change_alt_text: hC,
  image_change_caption: fC,
  image_change_link: pC,
  image_change_mobile_full_width: wC,
  image_error: bC,
  image_in_line: dC,
  image_insert_via_link: _C,
  image_side: cC,
  image_via_link: gC,
  increase_intent: Jw,
  italic: Qw,
  line_height: kC,
  link: Yw,
  orderedList: nC,
  redo: Zw,
  special_characters: Vw,
  strike: tC,
  substitute_variables: Fw,
  substitutions: mC,
  test: CC,
  text_align: rC,
  text_level: Hw,
  underline: eC,
  undo: Kw,
  unset: yC
}, Symbol.toStringTag, { value: "Module" })), MC = "Variabile de substituție", EC = { title: "Familia de fonturi", hint: "Fontul standard folosește fonturile clientului de email", default: "Implicit" }, $C = { title: "Titlu", paragraph: "Paragraf", header_one: "Antet 1", header_two: "Antet 2", header_three: "Antet 3" }, OC = { dollar: "Semnul dolarului", euro: "Semnul euro", yen: "Semnul yenului", pound: "Semnul lirei", cent: "Semnul cenților", euro_currency: "Semnul monedei euro", colon: "Semnul două puncte", cruzeiro: "Semnul cruzeiro", french_franc: "Semnul francului francez", lira: "Semnul lirei italiene", currency: "Semn de valută", bitcoin: "Semn Bitcoin", mill: "Semn de milă", peseta: "Semn de pesetă", rupee: "Semn de rupie", won: "Semn de won", new_sheqel: "Semn de nouă shekel", dong: "Semn de dong", kip: "Semn de kip", tugrik: "Semn de tugrik", drachma: "Semn de drahmă", german_penny: "Semn de penny german", peso: "Semn de peso", guarani: "Semn de guarani", austral: "Semn de austral", hryvnia: "Semn de hrivnă", cedi: "Semn de cedi", livre_tournois: "Semn de livre tournois", spesmilo: "Semn de spesmilo", tenge: "Semn de tenge", indian_rupee: "Semn de rupie indiană", turkish_lira: "Semn de liră turcească", nordic_mark: "Semn de marcă nordică", ruble: "Semn de ruble", left_pointing_angle_quotation_mark: "Semn de citare unghiulară stângă simplă", right_pointing_angle_quotation_mark: "Semn de citare unghiulară dreaptă simplă", left_pointing_double_angle_quotation_mark: "Semn de citare unghiulară dublă stângă", right_pointing_double_angle_quotation_mark: "Semn de citare unghiulară dublă dreaptă", left_single_quotation_mark: "Semn de citare simplă stângă", right_single_quotation_mark: "Semn de citare simplă dreaptă", left_double_quotation_mark: "Semn de întrebare dublu stânga", right_double_quotation_mark: "Semn de întrebare dublu dreapta", single_low_quotation_mark: "Semn de întrebare simplu jos-9", double_low_quotation_mark: "Semn de întrebare dublu jos-9", inverted_exclamation_mark: "Semn de exclamare inversat", inverted_question_mark: "Semn de întrebare inversat", two_dot_leader: "Lider cu două puncte", horizontal_ellipsis: "Eliipsă orizontală", double_dagger: "Dagger dublu", per_mille_sign: "Semn de per mille", per_ten_thousand_sign: "Semn de per zece mii", question_exclamation_mark: "Semn de întrebare exclamare", exclamation_question_mark: "Semn de exclamare întrebare", double_question_mark: "Semn de întrebare dublu", copyright_sign: "Semn de copyright", registered_sign: "Semn înregistrat", trade_mark_sign: "Semn de marcă comercială", section_sign: "Semn de secțiune", paragraph_sign: "Semn de paragraf", reversed_paragraph_sign: "Semn de paragraf inversat", select_text: "Text", select_currency: "Monedă", select_all: "Toate", title: "Caractere speciale", manat: "Semn de manat", double_exclamation_mark: "Semn de exclamare dublu" }, zC = "Culoarea de fundal a fontului", AC = "Dimensiunea fontului", NC = "Anulează", LC = "Refă", DC = "Crește indentarea", RC = "Scade indentarea", IC = "Link", PC = "Îngroșat", jC = "Italic", BC = "Subliniat", FC = "Tăiat", qC = "Listă numerotată", HC = "Listă cu puncte", VC = "Alinierea textului", UC = "Culoarea fontului", WC = "Subtitlu", KC = "Text alternativ", ZC = "Imagine", JC = "Aliniere imagine la stânga", GC = "Aliniere imagine la centru", YC = "Aliniere imagine la dreapta", XC = "Schimbare text alternativ pentru imagine", QC = "Schimbare legendă pentru imagine", e3 = "Schimbare link pentru imagine", t3 = "Substituții", n3 = "Imagine prin link", i3 = "Inserare imagine prin link", r3 = "Procesarea imaginii a eșuat", o3 = "Înălțimea liniei", s3 = "Anulat", a3 = "Spațiere suplimentară", l3 = { apply: "Aplica", clear: "Clar", error: "Eroare" }, c3 = "Implicit", u3 = "Setează lățimea imaginii la lățimea completă a dispozitivului mobil", d3 = { one: "Test" }, h3 = {
  substitute_variables: MC,
  font_family: EC,
  text_level: $C,
  special_characters: OC,
  background_color: zC,
  font_size: AC,
  undo: NC,
  redo: LC,
  increase_intent: DC,
  decrease_intent: RC,
  link: IC,
  bold: PC,
  italic: jC,
  underline: BC,
  strike: FC,
  orderedList: qC,
  bulletList: HC,
  text_align: VC,
  font_color: UC,
  caption: WC,
  alt_text: KC,
  image: ZC,
  image_side: JC,
  image_center: GC,
  image_in_line: YC,
  image_change_alt_text: XC,
  image_change_caption: QC,
  image_change_link: e3,
  substitutions: t3,
  image_via_link: n3,
  image_insert_via_link: i3,
  image_error: r3,
  line_height: o3,
  unset: s3,
  extra_spacing: a3,
  global: l3,
  default_font_size: c3,
  image_change_mobile_full_width: u3,
  test: d3
}, XR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: KC,
  background_color: zC,
  bold: PC,
  bulletList: HC,
  caption: WC,
  decrease_intent: RC,
  default: h3,
  default_font_size: c3,
  extra_spacing: a3,
  font_color: UC,
  font_family: EC,
  font_size: AC,
  global: l3,
  image: ZC,
  image_center: GC,
  image_change_alt_text: XC,
  image_change_caption: QC,
  image_change_link: e3,
  image_change_mobile_full_width: u3,
  image_error: r3,
  image_in_line: YC,
  image_insert_via_link: i3,
  image_side: JC,
  image_via_link: n3,
  increase_intent: DC,
  italic: jC,
  line_height: o3,
  link: IC,
  orderedList: qC,
  redo: LC,
  special_characters: OC,
  strike: FC,
  substitute_variables: MC,
  substitutions: t3,
  test: d3,
  text_align: VC,
  text_level: $C,
  underline: BC,
  undo: NC,
  unset: s3
}, Symbol.toStringTag, { value: "Module" })), f3 = "Замещающие переменные", p3 = { title: "Семейство шрифтов", hint: "Стандартный шрифт использует шрифты почтового клиента", default: "По умолчанию" }, m3 = { title: "Заголовок", paragraph: "Параграф", header_one: "Заголовок 1", header_two: "Заголовок 2", header_three: "Заголовок 3" }, g3 = { dollar: "Знак доллара", euro: "Знак евро", yen: "Знак иены", pound: "Знак фунта", cent: "Знак цента", euro_currency: "Знак евровалюты", colon: "Знак колона", cruzeiro: "Круизный знак", french_franc: "Знак французского франка", lira: "Знак лиры", currency: "Знак валюты", bitcoin: "Знак биткоина", mill: "Знак мельницы", peseta: "Знак песеты", rupee: "Знак рупии", won: "Знак победы", new_sheqel: "Новый знак шекеля", dong: "Знак Донга", kip: "Знак Кипа", tugrik: "Знак Тугрика", drachma: "Знак драхмы", german_penny: "Знак немецкого пенни", peso: "Знак песо", guarani: "Знак гуарани", austral: "Австралийский знак", hryvnia: "Знак гривны", cedi: "Знак цеди", livre_tournois: "Знак турнирной книги", spesmilo: "Знак Спесмило", tenge: "Знак тенге", indian_rupee: "Знак индийской рупии", turkish_lira: "Знак турецкой лиры", nordic_mark: "Знак северной марки", ruble: "Рублевый знак", left_pointing_angle_quotation_mark: "Одиночная угловая кавычка, направленная влево", right_pointing_angle_quotation_mark: "Одиночная угловая кавычка, направленная вправо", left_pointing_double_angle_quotation_mark: "Кавычки с двойным углом наклона влево", right_pointing_double_angle_quotation_mark: "Кавычки под прямым углом", left_single_quotation_mark: "Левая одинарная кавычка", right_single_quotation_mark: "Правая одинарная кавычка", left_double_quotation_mark: "Левая двойная кавычка", right_double_quotation_mark: "Правая двойная кавычка", single_low_quotation_mark: "Одиночная кавычка со знаком минус 9", double_low_quotation_mark: "Двойная кавычка со знаком минус 9", inverted_exclamation_mark: "Перевернутый восклицательный знак", inverted_question_mark: "Перевернутый вопросительный знак", two_dot_leader: "Лидер с двумя точками", horizontal_ellipsis: "Горизонтальное многоточие", double_dagger: "Двойной кинжал", per_mille_sign: "За миллион знаков", per_ten_thousand_sign: "За десять тысяч знаков", question_exclamation_mark: "Вопросительный восклицательный знак", exclamation_question_mark: "Восклицательный знак вопроса", double_question_mark: "Двойной вопросительный знак", copyright_sign: "Знак копирайта", registered_sign: "Зарегистрированный знак", trade_mark_sign: "Знак торговой марки", section_sign: "Знак секции", paragraph_sign: "Знак параграфа", reversed_paragraph_sign: "Знак перевернутого параграфа", select_text: "Текст", select_currency: "Валюта", select_all: "Все", title: "Специальные символы", manat: "Знак Маната", double_exclamation_mark: "Двойной восклицательный знак" }, _3 = "Цвет фона шрифта", b3 = "Размер шрифта", k3 = "Отменить", y3 = "Повторить", v3 = "Увеличить отступ", x3 = "Уменьшить отступ", S3 = "Ссылка", w3 = "Жирный", C3 = "Курсив", T3 = "Подчеркивание", M3 = "Зачеркивание", E3 = "Нумерованный список", $3 = "Пунктирный список", O3 = "Выравнивание текста", z3 = "Цвет шрифта", A3 = "Подпись", N3 = "Текстовая альтернатива", L3 = "Изображение", D3 = "Изображение выровнено влево", R3 = "Изображение выровнено по центру", I3 = "Изображение выровнено вправо", P3 = "Изменить альтернативный текст изображения", j3 = "Изменить подпись изображения", B3 = "Изменить ссылку на изображение", F3 = "Заменители", q3 = "Изображение по ссылке", H3 = "Вставить изображение по ссылке", V3 = "Не удалось обработать изображение", U3 = "Высота строки", W3 = "Сброшено", K3 = "Интервал между абзацами", Z3 = { apply: "Применить", clear: "Очистить", error: "Ошибка" }, J3 = "По умолчанию", G3 = "Установите ширину изображения на полную ширину мобильного устройства", Y3 = { one: "Тест" }, X3 = {
  substitute_variables: f3,
  font_family: p3,
  text_level: m3,
  special_characters: g3,
  background_color: _3,
  font_size: b3,
  undo: k3,
  redo: y3,
  increase_intent: v3,
  decrease_intent: x3,
  link: S3,
  bold: w3,
  italic: C3,
  underline: T3,
  strike: M3,
  orderedList: E3,
  bulletList: $3,
  text_align: O3,
  font_color: z3,
  caption: A3,
  alt_text: N3,
  image: L3,
  image_side: D3,
  image_center: R3,
  image_in_line: I3,
  image_change_alt_text: P3,
  image_change_caption: j3,
  image_change_link: B3,
  substitutions: F3,
  image_via_link: q3,
  image_insert_via_link: H3,
  image_error: V3,
  line_height: U3,
  unset: W3,
  extra_spacing: K3,
  global: Z3,
  default_font_size: J3,
  image_change_mobile_full_width: G3,
  test: Y3
}, QR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: N3,
  background_color: _3,
  bold: w3,
  bulletList: $3,
  caption: A3,
  decrease_intent: x3,
  default: X3,
  default_font_size: J3,
  extra_spacing: K3,
  font_color: z3,
  font_family: p3,
  font_size: b3,
  global: Z3,
  image: L3,
  image_center: R3,
  image_change_alt_text: P3,
  image_change_caption: j3,
  image_change_link: B3,
  image_change_mobile_full_width: G3,
  image_error: V3,
  image_in_line: I3,
  image_insert_via_link: H3,
  image_side: D3,
  image_via_link: q3,
  increase_intent: v3,
  italic: C3,
  line_height: U3,
  link: S3,
  orderedList: E3,
  redo: y3,
  special_characters: g3,
  strike: M3,
  substitute_variables: f3,
  substitutions: F3,
  test: Y3,
  text_align: O3,
  text_level: m3,
  underline: T3,
  undo: k3,
  unset: W3
}, Symbol.toStringTag, { value: "Module" })), Q3 = "Náhradné premenné", e2 = { title: "Rodina písma", hint: "Štandardné písmo používa písma emailového klienta", default: "Predvolené" }, t2 = { title: "Nadpis", paragraph: "Odstavec", header_one: "Nadpis 1", header_two: "Nadpis 2", header_three: "Nadpis 3" }, n2 = { dollar: "Dolarový znak", euro: "Euro znak", yen: "Jenový znak", pound: "Librový znak", cent: "Centový znak", euro_currency: "Znak euro-meny", colon: "Znak dvojbodky", cruzeiro: "Znak cruzeiro", french_franc: "Znak francúzskeho franku", lira: "Znak líry", currency: "Znak meny", bitcoin: "Znak bitcoinu", mill: "Znak milu", peseta: "Znak pesety", rupee: "Znak rupie", won: "Znak wonu", new_sheqel: "Znak nového šekelu", dong: "Dong znak", kip: "Kip znak", tugrik: "Tugrik znak", drachma: "Drachma znak", german_penny: "Nemecký penny znak", peso: "Peso znak", guarani: "Guarani znak", austral: "Austral znak", hryvnia: "Hryvnia znak", cedi: "Cedi znak", livre_tournois: "Livre tournois znak", spesmilo: "Spesmilo znak", tenge: "Tenge znak", indian_rupee: "Indická rupia znak", turkish_lira: "Turecká líra znak", nordic_mark: "Nordická marka znak", ruble: "Rubeľ znak", left_pointing_angle_quotation_mark: "Jednoduché ľavé úvodzovky", right_pointing_angle_quotation_mark: "Jednoduché pravé úvodzovky", left_pointing_double_angle_quotation_mark: "Ľavé dvojité úvodzovky", right_pointing_double_angle_quotation_mark: "Pravé dvojité úvodzovky", left_single_quotation_mark: "Ľavé jednoduché úvodzovky", right_single_quotation_mark: "Pravé jednoduché úvodzovky", left_double_quotation_mark: "Ľavé dvojité úvodzovky", right_double_quotation_mark: "Pravé dvojité úvodzovky", single_low_quotation_mark: "Jednoduché nízke 9 úvodzovky", double_low_quotation_mark: "Dvojité nízke 9 úvodzovky", inverted_exclamation_mark: "Invertný výkričník", inverted_question_mark: "Invertná otázka", two_dot_leader: "Dvojbodový vodítko", horizontal_ellipsis: "Horizontálne elipsy", double_dagger: "Dvojitý kríž", per_mille_sign: "Per mille znak", per_ten_thousand_sign: "Per desaťtisíc znak", question_exclamation_mark: "Otázkový výkričník", exclamation_question_mark: "Výkričník otáznik", double_question_mark: "Dvojitý otáznik", copyright_sign: "Znak autorského práva", registered_sign: "Zaregistrovaný znak", trade_mark_sign: "Znak ochranné známky", section_sign: "Znak sekcie", paragraph_sign: "Znak odseku", reversed_paragraph_sign: "Obrátený znak odseku", select_text: "Text", select_currency: "Mena", select_all: "Všetko", title: "Špeciálne znaky", manat: "Znak manátu", double_exclamation_mark: "Dvojitý výkričník" }, i2 = "Farba pozadia písma", r2 = "Veľkosť písma", o2 = "Zrušiť", s2 = "Znova", a2 = "Zvýšiť odsadenie", l2 = "Znížiť odsadenie", c2 = "Odkaz", u2 = "Tučné", d2 = "Kurzíva", h2 = "Podčiarknuť", f2 = "Prečiarknuť", p2 = "Číslovaný zoznam", m2 = "Zoznam s odrážkami", g2 = "Zarovnanie textu", _2 = "Farba písma", b2 = "Popis", k2 = "Alternatívny text", y2 = "Obrázok", v2 = "Obrázok zarovnať doľava", x2 = "Obrázok zarovnať na stred", S2 = "Obrázok zarovnať doprava", w2 = "Zmeniť alternatívny text obrázka", C2 = "Zmeniť popis obrázka", T2 = "Zmeniť odkaz obrázka", M2 = "Náhrady", E2 = "Obrázok cez odkaz", $2 = "Vložte obrázok cez odkaz", O2 = "Nepodarilo sa spracovať obrázok", z2 = "Výška riadku", A2 = "Zrušiť", N2 = "Extra medzery", L2 = { apply: "Použiť", clear: "Jasný", error: "Chyba" }, D2 = "Predvolené", R2 = "Nastavte šírku obrázka na celú šírku mobilného zariadenia", I2 = { one: "Test" }, P2 = {
  substitute_variables: Q3,
  font_family: e2,
  text_level: t2,
  special_characters: n2,
  background_color: i2,
  font_size: r2,
  undo: o2,
  redo: s2,
  increase_intent: a2,
  decrease_intent: l2,
  link: c2,
  bold: u2,
  italic: d2,
  underline: h2,
  strike: f2,
  orderedList: p2,
  bulletList: m2,
  text_align: g2,
  font_color: _2,
  caption: b2,
  alt_text: k2,
  image: y2,
  image_side: v2,
  image_center: x2,
  image_in_line: S2,
  image_change_alt_text: w2,
  image_change_caption: C2,
  image_change_link: T2,
  substitutions: M2,
  image_via_link: E2,
  image_insert_via_link: $2,
  image_error: O2,
  line_height: z2,
  unset: A2,
  extra_spacing: N2,
  global: L2,
  default_font_size: D2,
  image_change_mobile_full_width: R2,
  test: I2
}, eI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: k2,
  background_color: i2,
  bold: u2,
  bulletList: m2,
  caption: b2,
  decrease_intent: l2,
  default: P2,
  default_font_size: D2,
  extra_spacing: N2,
  font_color: _2,
  font_family: e2,
  font_size: r2,
  global: L2,
  image: y2,
  image_center: x2,
  image_change_alt_text: w2,
  image_change_caption: C2,
  image_change_link: T2,
  image_change_mobile_full_width: R2,
  image_error: O2,
  image_in_line: S2,
  image_insert_via_link: $2,
  image_side: v2,
  image_via_link: E2,
  increase_intent: a2,
  italic: d2,
  line_height: z2,
  link: c2,
  orderedList: p2,
  redo: s2,
  special_characters: n2,
  strike: f2,
  substitute_variables: Q3,
  substitutions: M2,
  test: I2,
  text_align: g2,
  text_level: t2,
  underline: h2,
  undo: o2,
  unset: A2
}, Symbol.toStringTag, { value: "Module" })), j2 = "Nadomestne spremenljivke", B2 = { title: "Družina pisave", hint: "Standardna pisava uporablja pisave odjemalca e-pošte", default: "Privzeto" }, F2 = { title: "Naslov", paragraph: "Odlomek", header_one: "Glava 1", header_two: "Glava 2", header_three: "Glava 3" }, q2 = { dollar: "Znak dolarja", euro: "Znak evra", yen: "Znak jena", pound: "Znak funta", cent: "Znak centa", euro_currency: "Znak evrovalute", colon: "Znak dvopičje", cruzeiro: "Znak cruzeira", french_franc: "Znak francoskega franka", lira: "Znak lire", currency: "Simbol valute", bitcoin: "Simbol bitcoina", mill: "Simbol mila", peseta: "Simbol pesete", rupee: "Simbol rupije", won: "Simbol wona", new_sheqel: "Simbol novega šekela", dong: "Simbol donga", kip: "Simbol kipa", tugrik: "Simbol tugrika", drachma: "Simbol drahme", german_penny: "Simbol nemške penije", peso: "Simbol pesosa", guarani: "Simbol guaranija", austral: "Simbol australa", hryvnia: "Simbol grivna", cedi: "Simbol cedi", livre_tournois: "Simbol livre tournois", spesmilo: "Simbol spesmila", tenge: "Simbol tenge", indian_rupee: "Simbol indijske rupije", turkish_lira: "Simbol turške lire", nordic_mark: "Simbol nordijske marke", ruble: "Simbol rublja", left_pointing_angle_quotation_mark: "Enojni levo usmerjen kotni narekovaj", right_pointing_angle_quotation_mark: "Enojni desno usmerjen kotni narekovaj", left_pointing_double_angle_quotation_mark: "Levo usmerjen dvojni kotni narekovaj", right_pointing_double_angle_quotation_mark: "Desno usmerjen dvojni kotni narekovaj", left_single_quotation_mark: "Levi enojni narekovaj", right_single_quotation_mark: "Desni enojni narekovaj", left_double_quotation_mark: "Leva dvojna narekovaja", right_double_quotation_mark: "Desna dvojna narekovaja", single_low_quotation_mark: "Enojni nizki 9 narekovaj", double_low_quotation_mark: "Dvojni nizki 9 narekovaj", inverted_exclamation_mark: "Obrnjen vzklik", inverted_question_mark: "Obrnjen vprašaj", two_dot_leader: "Dva pika vodilo", horizontal_ellipsis: "Horizontalne elipse", double_dagger: "Dvojni meč", per_mille_sign: "Znak za promil", per_ten_thousand_sign: "Znak za deset tisoč", question_exclamation_mark: "Vprašalni vzklik", exclamation_question_mark: "Vzklik vprašaj", double_question_mark: "Dvojni vprašaj", copyright_sign: "Znak avtorskih pravic", registered_sign: "Znak registracije", trade_mark_sign: "Znak blagovne znamke", section_sign: "Znak odseka", paragraph_sign: "Znak odstavka", reversed_paragraph_sign: "Obrnjen znak odstavka", select_text: "Besedilo", select_currency: "Valuta", select_all: "Vse", title: "Posebni znaki", manat: "Znak manat", double_exclamation_mark: "Dvojni klicaj" }, H2 = "Barva ozadja pisave", V2 = "Velikost pisave", U2 = "Razveljavi", W2 = "Ponovi", K2 = "Povečaj zamik", Z2 = "Zmanjšaj zamik", J2 = "Povezava", G2 = "Krepko", Y2 = "Ležeče", X2 = "Podčrtano", Q2 = "Prečrtano", eT = "Oštevilčen seznam", tT = "Seznam z oznakami", nT = "Poravnava besedila", iT = "Barva pisave", rT = "Podnapis", oT = "Besedilna alternativa", sT = "Slika", aT = "Slika poravnana levo", lT = "Slika poravnana na sredino", cT = "Slika poravnana desno", uT = "Spremeni alternativno besedilo slike", dT = "Spremeni napis slike", hT = "Spremeni povezavo slike", fT = "Nadomestila", pT = "Slika prek povezave", mT = "Vstavite sliko prek povezave", gT = "Obdelava slike ni uspela", _T = "Višina črte", bT = "Nastavi", kT = "Dodatni razmik", yT = { apply: "Prijavite se", clear: "Jasno", error: "Napaka" }, vT = "Privzeto", xT = "Nastavi širino slike na celotno širino mobilne naprave", ST = { one: "Test" }, wT = {
  substitute_variables: j2,
  font_family: B2,
  text_level: F2,
  special_characters: q2,
  background_color: H2,
  font_size: V2,
  undo: U2,
  redo: W2,
  increase_intent: K2,
  decrease_intent: Z2,
  link: J2,
  bold: G2,
  italic: Y2,
  underline: X2,
  strike: Q2,
  orderedList: eT,
  bulletList: tT,
  text_align: nT,
  font_color: iT,
  caption: rT,
  alt_text: oT,
  image: sT,
  image_side: aT,
  image_center: lT,
  image_in_line: cT,
  image_change_alt_text: uT,
  image_change_caption: dT,
  image_change_link: hT,
  substitutions: fT,
  image_via_link: pT,
  image_insert_via_link: mT,
  image_error: gT,
  line_height: _T,
  unset: bT,
  extra_spacing: kT,
  global: yT,
  default_font_size: vT,
  image_change_mobile_full_width: xT,
  test: ST
}, tI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: oT,
  background_color: H2,
  bold: G2,
  bulletList: tT,
  caption: rT,
  decrease_intent: Z2,
  default: wT,
  default_font_size: vT,
  extra_spacing: kT,
  font_color: iT,
  font_family: B2,
  font_size: V2,
  global: yT,
  image: sT,
  image_center: lT,
  image_change_alt_text: uT,
  image_change_caption: dT,
  image_change_link: hT,
  image_change_mobile_full_width: xT,
  image_error: gT,
  image_in_line: cT,
  image_insert_via_link: mT,
  image_side: aT,
  image_via_link: pT,
  increase_intent: K2,
  italic: Y2,
  line_height: _T,
  link: J2,
  orderedList: eT,
  redo: W2,
  special_characters: q2,
  strike: Q2,
  substitute_variables: j2,
  substitutions: fT,
  test: ST,
  text_align: nT,
  text_level: F2,
  underline: X2,
  undo: U2,
  unset: bT
}, Symbol.toStringTag, { value: "Module" })), CT = "Ndryshoret zëvendësuese", TT = { title: "Familja e shkronjave", hint: "Fonti standard përdor fontet e klientit të emailit", default: "Parazgjedhje" }, MT = { title: "Titulli", paragraph: "Paragrafi", header_one: "Titulli 1", header_two: "Titulli 2", header_three: "Titulli 3" }, ET = { dollar: "Shenja e dollarit", euro: "Shenja e euros", yen: "Shenja e yenit", pound: "Shenja e poundit", cent: "Shenja e centit", euro_currency: "Shenja e monedhës euro", colon: "Shenja e kolonës", cruzeiro: "Shenja e cruzeiro", french_franc: "Shenja e frangës franceze", lira: "Shenja e lirës", currency: "Shenja e monedhës", bitcoin: "Shenja e Bitcoin", mill: "Shenja e Mill", peseta: "Shenja e Peseta", rupee: "Shenja e Rupee", won: "Shenja e Won", new_sheqel: "Shenja e shekellit të ri", dong: "Shenja e Dong", kip: "Shenja e Kip", tugrik: "Shenja e Tugrik", drachma: "Shenja e Drachma", german_penny: "Shenja e centit gjerman", peso: "Shenja e Peso", guarani: "Shenja e Guarani", austral: "Shenja e Austral", hryvnia: "Shenja e Hryvnia", cedi: "Shenja e Cedi", livre_tournois: "Shenja e livre tournois", spesmilo: "Shenja e Spesmilo", tenge: "Shenja e Tenge", indian_rupee: "Shenja e rupees indiane", turkish_lira: "Shenja e lira turke", nordic_mark: "Shenja e markës nordike", ruble: "Shenja e Ruble", left_pointing_angle_quotation_mark: "Shenja e cituar me kënd të majtë", right_pointing_angle_quotation_mark: "Shenja e cituar me kënd të djathtë", left_pointing_double_angle_quotation_mark: "Shenja e cituar me dy kënde të majtë", right_pointing_double_angle_quotation_mark: "Shenja e cituar me dy kënde të djathtë", left_single_quotation_mark: "Shenja e cituar e majtë", right_single_quotation_mark: "Shenja e cituar e djathtë", left_double_quotation_mark: "Shenja e cituar e majtë", right_double_quotation_mark: "Shenja e cituar e djathtë", single_low_quotation_mark: "Shenja e cituar e ulët-9", double_low_quotation_mark: "Shenja e cituar e ulët-9 dyfish", inverted_exclamation_mark: "Shenja e përmbysur e thirrjes", inverted_question_mark: "Shenja e përmbysur e pyetjes", two_dot_leader: "Lideri me dy pika", horizontal_ellipsis: "Ellips horizontal", double_dagger: "Daga dyfish", per_mille_sign: "Shenja per mille", per_ten_thousand_sign: "Shenja per dhjetë mijë", question_exclamation_mark: "Shenja e pyetjes dhe thirrjes", exclamation_question_mark: "Shenja e thirrjes dhe pyetjes", double_question_mark: "Shenja e pyetjes dyfish", copyright_sign: "Shenja e të drejtat e autorit", registered_sign: "Shenja e regjistruar", trade_mark_sign: "Shenja e markës tregtare", section_sign: "Shenja e seksionit", paragraph_sign: "Shenja e paragrafit", reversed_paragraph_sign: "Shenja e paragrafit të përmbysur", select_text: "Teksti", select_currency: "Monedha", select_all: "Të gjitha", title: "Karaktere speciale", manat: "Shenja e manatit", double_exclamation_mark: "Shenjë dyfishi e exclamacionit" }, $T = "Ngjyra e sfondit të shkronjave", OT = "Madhësia e shkronjave", zT = "Anulo", AT = "Rifillo", NT = "Rrit indentimin", LT = "Pako indentimin", DT = "Lidhje", RT = "Të theksuara", IT = "Të italizuara", PT = "Të nënvizuara", jT = "Të goditura", BT = "Lista e numrave", FT = "Lista me bullets", qT = "Rreshtimi i tekstit", HT = "Ngjyra e shkronjave", VT = "Titulli", UT = "Alternativa e tekstit", WT = "Imazhi", KT = "Imazhi në anën e majtë", ZT = "Imazhi në qendër", JT = "Imazhi në anën e djathtë", GT = "Ndrysho tekstin alternativ të imazhit", YT = "Ndrysho titullin e imazhit", XT = "Ndrysho lidhjen e imazhit", QT = "Zëvendësimet", eM = "Imazhi përmes lidhjes", tM = "Shtoni imazhin përmes lidhjes", nM = "Dështoi për të procesuar imazhin", iM = "Lartësia e linjës", rM = "Ç'aktivizuar", oM = "Hapësirë shtesë", sM = { apply: "Aplikoni", clear: "Qartë", error: "Gabim" }, aM = "Parazgjedhje", lM = "Cakto gjatësinë e imazhit në gjatësinë e plotë të pajisjes mobile", cM = { one: "Provë" }, uM = {
  substitute_variables: CT,
  font_family: TT,
  text_level: MT,
  special_characters: ET,
  background_color: $T,
  font_size: OT,
  undo: zT,
  redo: AT,
  increase_intent: NT,
  decrease_intent: LT,
  link: DT,
  bold: RT,
  italic: IT,
  underline: PT,
  strike: jT,
  orderedList: BT,
  bulletList: FT,
  text_align: qT,
  font_color: HT,
  caption: VT,
  alt_text: UT,
  image: WT,
  image_side: KT,
  image_center: ZT,
  image_in_line: JT,
  image_change_alt_text: GT,
  image_change_caption: YT,
  image_change_link: XT,
  substitutions: QT,
  image_via_link: eM,
  image_insert_via_link: tM,
  image_error: nM,
  line_height: iM,
  unset: rM,
  extra_spacing: oM,
  global: sM,
  default_font_size: aM,
  image_change_mobile_full_width: lM,
  test: cM
}, nI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: UT,
  background_color: $T,
  bold: RT,
  bulletList: FT,
  caption: VT,
  decrease_intent: LT,
  default: uM,
  default_font_size: aM,
  extra_spacing: oM,
  font_color: HT,
  font_family: TT,
  font_size: OT,
  global: sM,
  image: WT,
  image_center: ZT,
  image_change_alt_text: GT,
  image_change_caption: YT,
  image_change_link: XT,
  image_change_mobile_full_width: lM,
  image_error: nM,
  image_in_line: JT,
  image_insert_via_link: tM,
  image_side: KT,
  image_via_link: eM,
  increase_intent: NT,
  italic: IT,
  line_height: iM,
  link: DT,
  orderedList: BT,
  redo: AT,
  special_characters: ET,
  strike: jT,
  substitute_variables: CT,
  substitutions: QT,
  test: cM,
  text_align: qT,
  text_level: MT,
  underline: PT,
  undo: zT,
  unset: rM
}, Symbol.toStringTag, { value: "Module" })), dM = "Zamenski varijable", hM = { title: "Porodica fonta", hint: "Standardni font koristi fontove klijenta za e-poštu", default: "Podrazumevano" }, fM = { title: "Naslov", paragraph: "Paragraf", header_one: "Naslov 1", header_two: "Naslov 2", header_three: "Naslov 3" }, pM = { dollar: "Znak dolara", euro: "Znak evra", yen: "Znak jena", pound: "Znak funte", cent: "Znak centa", euro_currency: "Znak evro-valute", colon: "Znak dvotačka", cruzeiro: "Znak kruzeira", french_franc: "Znak francuskog franka", lira: "Znak lire", currency: "Znak valute", bitcoin: "Znak bitcoina", mill: "Znak mila", peseta: "Znak pesete", rupee: "Znak rupije", won: "Znak wona", new_sheqel: "Znak novog šekela", dong: "Znak donga", kip: "Znak kipa", tugrik: "Znak tugrika", drachma: "Znak drahme", german_penny: "Znak nemačke penije", peso: "Znak pesosa", guarani: "Znak guarane", austral: "Znak austral", hryvnia: "Znak grivnje", cedi: "Znak cedi", livre_tournois: "Znak livre turnoisa", spesmilo: "Znak spesmila", tenge: "Znak tenge", indian_rupee: "Znak indijske rupije", turkish_lira: "Znak turske lire", nordic_mark: "Znak nordijske marke", ruble: "Znak ruble", left_pointing_angle_quotation_mark: "Levi jednostruki uglasti navodnik", right_pointing_angle_quotation_mark: "Desni jednostruki uglasti navodnik", left_pointing_double_angle_quotation_mark: "Levi dvostruki uglasti navodnik", right_pointing_double_angle_quotation_mark: "Desni dvostruki uglasti navodnik", left_single_quotation_mark: "Levi jednostruki navodnik", right_single_quotation_mark: "Desni jednostruki navodnik", left_double_quotation_mark: "Levi dvostruki navodnik", right_double_quotation_mark: "Desni dvostruki navodnik", single_low_quotation_mark: "Jednostruki nisko-9 navodnik", double_low_quotation_mark: "Dvostruki nisko-9 navodnik", inverted_exclamation_mark: "Obrnuti uzvičnik", inverted_question_mark: "Obrnuto pitanje", two_dot_leader: "Dvo-tačka vođa", horizontal_ellipsis: "Horizontalna elipsa", double_dagger: "Dupli dagger", per_mille_sign: "Per mille znak", per_ten_thousand_sign: "Per deset hiljada znak", question_exclamation_mark: "Znak pitanja i uzvika", exclamation_question_mark: "Znak uzvika i pitanja", double_question_mark: "Dupli znak pitanja", copyright_sign: "Znak autorskih prava", registered_sign: "Registrovani znak", trade_mark_sign: "Znak trgovinske marke", section_sign: "Znak odeljka", paragraph_sign: "Znak paragrafa", reversed_paragraph_sign: "Obrnuti znak paragrafa", select_text: "Tekst", select_currency: "Valuta", select_all: "Sve", title: "Specijalni karakteri", manat: "Znak manat", double_exclamation_mark: "Dupli znak uzvika" }, mM = "Boja pozadine fonta", gM = "Veličina fonta", _M = "Poništi", bM = "Ponovi", kM = "Povećaj uvlačenje", yM = "Smanji uvlačenje", vM = "Link", xM = "Podebljano", SM = "Kurziv", wM = "Podvučeno", CM = "Precrtano", TM = "Numerisana lista", MM = "Lista sa oznakama", EM = "Poravnanje teksta", $M = "Boja fonta", OM = "Natpis", zM = "Alternativa za tekst", AM = "Slika", NM = "Bočna slika", LM = "Središnja slika", DM = "U redu", RM = "Promeni alternativni tekst slike", IM = "Promeni opis slike", PM = "Promeni link slike", jM = "Zamene", BM = "Slika putem linka", FM = "Umetnite sliku putem linka", qM = "Nije uspelo da se obradi slika", HM = "Visina linije", VM = "Poništi", UM = "Dodatni razmak", WM = { apply: "Primeni", clear: "Obriši", error: "Greška" }, KM = "Podrazumevano", ZM = "Podesi širinu slike na punu širinu mobilnog uređaja", JM = { one: "Test" }, GM = {
  substitute_variables: dM,
  font_family: hM,
  text_level: fM,
  special_characters: pM,
  background_color: mM,
  font_size: gM,
  undo: _M,
  redo: bM,
  increase_intent: kM,
  decrease_intent: yM,
  link: vM,
  bold: xM,
  italic: SM,
  underline: wM,
  strike: CM,
  orderedList: TM,
  bulletList: MM,
  text_align: EM,
  font_color: $M,
  caption: OM,
  alt_text: zM,
  image: AM,
  image_side: NM,
  image_center: LM,
  image_in_line: DM,
  image_change_alt_text: RM,
  image_change_caption: IM,
  image_change_link: PM,
  substitutions: jM,
  image_via_link: BM,
  image_insert_via_link: FM,
  image_error: qM,
  line_height: HM,
  unset: VM,
  extra_spacing: UM,
  global: WM,
  default_font_size: KM,
  image_change_mobile_full_width: ZM,
  test: JM
}, iI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: zM,
  background_color: mM,
  bold: xM,
  bulletList: MM,
  caption: OM,
  decrease_intent: yM,
  default: GM,
  default_font_size: KM,
  extra_spacing: UM,
  font_color: $M,
  font_family: hM,
  font_size: gM,
  global: WM,
  image: AM,
  image_center: LM,
  image_change_alt_text: RM,
  image_change_caption: IM,
  image_change_link: PM,
  image_change_mobile_full_width: ZM,
  image_error: qM,
  image_in_line: DM,
  image_insert_via_link: FM,
  image_side: NM,
  image_via_link: BM,
  increase_intent: kM,
  italic: SM,
  line_height: HM,
  link: vM,
  orderedList: TM,
  redo: bM,
  special_characters: pM,
  strike: CM,
  substitute_variables: dM,
  substitutions: jM,
  test: JM,
  text_align: EM,
  text_level: fM,
  underline: wM,
  undo: _M,
  unset: VM
}, Symbol.toStringTag, { value: "Module" })), YM = "Ersättande variabler", XM = { title: "Teckensnittsfamilj", hint: "Standardteckensnitt använder e-postklientens teckensnitt", default: "Standard" }, QM = { title: "Rubrik", paragraph: "Stycke", header_one: "Rubrik 1", header_two: "Rubrik 2", header_three: "Rubrik 3" }, eE = { dollar: "Dollar-tecken", euro: "Euro-tecken", yen: "Yen-tecken", pound: "Pund-tecken", cent: "Cent-tecken", euro_currency: "Euro-valuta-tecken", colon: "Kolontecken", cruzeiro: "Cruzeiro-tecken", french_franc: "Fransk franc-tecken", lira: "Lira-tecken", currency: "Valutasymbol", bitcoin: "Bitcoinsymbol", mill: "Mill-symbol", peseta: "Pesetasymbol", rupee: "Rupiesymbol", won: "Won-symbol", new_sheqel: "Ny shekel-symbol", dong: "Dong-symbol", kip: "Kip-symbol", tugrik: "Tugrik-symbol", drachma: "Drachmasymbol", german_penny: "Tysk penny-symbol", peso: "Pesosymbol", guarani: "Guaranísymbol", austral: "Australsymbol", hryvnia: "Hryvnia-symbol", cedi: "Cedi-symbol", livre_tournois: "Livre tournois-symbol", spesmilo: "Spesmilo-symbol", tenge: "Tenge-symbol", indian_rupee: "Indisk rupiesymbol", turkish_lira: "Turkisk lira-symbol", nordic_mark: "Nordisk mark-symbol", ruble: "Rublésymbol", left_pointing_angle_quotation_mark: "Enkel vänsterpekande vinkelcitattecken", right_pointing_angle_quotation_mark: "Enkel högerpekande vinkelcitattecken", left_pointing_double_angle_quotation_mark: "Vänsterpekande dubbla vinkelcitattecken", right_pointing_double_angle_quotation_mark: "Högerpekande dubbla vinkelcitattecken", left_single_quotation_mark: "Vänster enkel citattecken", right_single_quotation_mark: "Höger enkel citattecken", left_double_quotation_mark: "Vänster dubbelfnutt", right_double_quotation_mark: "Höger dubbelfnutt", single_low_quotation_mark: "Enkel låg-9 fnutt", double_low_quotation_mark: "Dubbelt låg-9 fnutt", inverted_exclamation_mark: "Omvänt utropstecken", inverted_question_mark: "Omvänt frågetecken", two_dot_leader: "Två punkters ledare", horizontal_ellipsis: "Horisontell ellips", double_dagger: "Dubbelt kors", per_mille_sign: "Per mille-tecken", per_ten_thousand_sign: "Per tiotusen-tecken", question_exclamation_mark: "Frågeutropstecken", exclamation_question_mark: "Utropfrågetecken", double_question_mark: "Dubbelt frågetecken", copyright_sign: "Upphovsrättstecken", registered_sign: "Registrerat tecken", trade_mark_sign: "Varumärkestecken", section_sign: "Paragraftecken", paragraph_sign: "Stycke-tecken", reversed_paragraph_sign: "Omvänt stycke-tecken", select_text: "Text", select_currency: "Valuta", select_all: "Alla", title: "Specialtecken", manat: "Manat-tecken", double_exclamation_mark: "Dubbel utropstecken" }, tE = "Teckensnittets bakgrundsfärg", nE = "Teckensnittsstorlek", iE = "Ångra", rE = "Gör om", oE = "Öka indrag", sE = "Minska indrag", aE = "Länk", lE = "Fet", cE = "Kursiv", uE = "Understruken", dE = "Genomstruken", hE = "Numrerad lista", fE = "Punktlista", pE = "Textjustering", mE = "Teckensnittsfärg", gE = "Bildtext", _E = "Textalternativ", bE = "Bild", kE = "Bildjustering vänster", yE = "Bildjustering center", vE = "Bildjustering höger", xE = "Ändra bildens alternativa text", SE = "Ändra bildtext", wE = "Ändra bildlänk", CE = "Substitutioner", TE = "Bild via länk", ME = "Infoga bild via länk", EE = "Misslyckades med att bearbeta bilden", $E = "Radavstånd", OE = "Åtkomst avstängd", zE = "Extra mellanrum", AE = { apply: "Tillämpa", clear: "Klar", error: "Fel" }, NE = "Standard", LE = "Ställ in bildens bredd till hela bredden på mobilen", DE = { one: "Test" }, RE = {
  substitute_variables: YM,
  font_family: XM,
  text_level: QM,
  special_characters: eE,
  background_color: tE,
  font_size: nE,
  undo: iE,
  redo: rE,
  increase_intent: oE,
  decrease_intent: sE,
  link: aE,
  bold: lE,
  italic: cE,
  underline: uE,
  strike: dE,
  orderedList: hE,
  bulletList: fE,
  text_align: pE,
  font_color: mE,
  caption: gE,
  alt_text: _E,
  image: bE,
  image_side: kE,
  image_center: yE,
  image_in_line: vE,
  image_change_alt_text: xE,
  image_change_caption: SE,
  image_change_link: wE,
  substitutions: CE,
  image_via_link: TE,
  image_insert_via_link: ME,
  image_error: EE,
  line_height: $E,
  unset: OE,
  extra_spacing: zE,
  global: AE,
  default_font_size: NE,
  image_change_mobile_full_width: LE,
  test: DE
}, rI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: _E,
  background_color: tE,
  bold: lE,
  bulletList: fE,
  caption: gE,
  decrease_intent: sE,
  default: RE,
  default_font_size: NE,
  extra_spacing: zE,
  font_color: mE,
  font_family: XM,
  font_size: nE,
  global: AE,
  image: bE,
  image_center: yE,
  image_change_alt_text: xE,
  image_change_caption: SE,
  image_change_link: wE,
  image_change_mobile_full_width: LE,
  image_error: EE,
  image_in_line: vE,
  image_insert_via_link: ME,
  image_side: kE,
  image_via_link: TE,
  increase_intent: oE,
  italic: cE,
  line_height: $E,
  link: aE,
  orderedList: hE,
  redo: rE,
  special_characters: eE,
  strike: dE,
  substitute_variables: YM,
  substitutions: CE,
  test: DE,
  text_align: pE,
  text_level: QM,
  underline: uE,
  undo: iE,
  unset: OE
}, Symbol.toStringTag, { value: "Module" })), IE = "ตัวแปรทดแทน", PE = { title: "ตระกูลฟอนต์", hint: "ฟอนต์มาตรฐานใช้ฟอนต์ของโปรแกรมอีเมล", default: "ค่าเริ่มต้น" }, jE = { title: "หัวเรื่อง", paragraph: "ย่อหน้า", header_one: "หัวเรื่อง 1", header_two: "หัวเรื่อง 2", header_three: "หัวเรื่อง 3" }, BE = { dollar: "สัญลักษณ์ดอลลาร์", euro: "สัญลักษณ์ยูโร", yen: "สัญลักษณ์เยน", pound: "สัญลักษณ์ปอนด์", cent: "สัญลักษณ์เซนต์", euro_currency: "สัญลักษณ์สกุลเงินยูโร", colon: "สัญลักษณ์โคลอน", cruzeiro: "สัญลักษณ์ครูเซโร", french_franc: "สัญลักษณ์ฟรังก์ฝรั่งเศส", lira: "สัญลักษณ์ลิรา", currency: "สัญลักษณ์สกุลเงิน", bitcoin: "สัญลักษณ์บิตคอยน์", mill: "สัญลักษณ์มิลล์", peseta: "สัญลักษณ์เปเซตา", rupee: "สัญลักษณ์รูปี", won: "สัญลักษณ์วอน", new_sheqel: "สัญลักษณ์เชเคลใหม่", dong: "สัญลักษณ์ดง", kip: "สัญลักษณ์คิป", tugrik: "สัญลักษณ์ทูกริก", drachma: "สัญลักษณ์ดรัคมา", german_penny: "สัญลักษณ์เพนนีเยอรมัน", peso: "สัญลักษณ์เปโซ", guarani: "สัญลักษณ์กัวรานี", austral: "สัญลักษณ์ออสตรัล", hryvnia: "สัญลักษณ์ฮรีฟเนีย", cedi: "สัญลักษณ์เซดี", livre_tournois: "สัญลักษณ์ลิฟร์ตูร์นัว", spesmilo: "สัญลักษณ์สเปสมีโล", tenge: "สัญลักษณ์เทนเก", indian_rupee: "สัญลักษณ์รูปีอินเดีย", turkish_lira: "สัญลักษณ์ลีราตุรกี", nordic_mark: "สัญลักษณ์มาร์คเหนือ", ruble: "สัญลักษณ์รูเบิล", left_pointing_angle_quotation_mark: "เครื่องหมายคำพูดแบบมุมซ้ายเดี่ยว", right_pointing_angle_quotation_mark: "เครื่องหมายคำพูดแบบมุมขวาเดี่ยว", left_pointing_double_angle_quotation_mark: "เครื่องหมายคำพูดแบบมุมซ้ายคู่", right_pointing_double_angle_quotation_mark: "เครื่องหมายคำพูดแบบมุมขวาคู่", left_single_quotation_mark: "เครื่องหมายคำพูดเดี่ยวแบบซ้าย", right_single_quotation_mark: "เครื่องหมายคำพูดเดี่ยวแบบขวา", left_double_quotation_mark: "เครื่องหมายคำพูดเปิดแบบคู่", right_double_quotation_mark: "เครื่องหมายคำพูดปิดแบบคู่", single_low_quotation_mark: "เครื่องหมายคำพูดต่ำแบบเดี่ยว 9", double_low_quotation_mark: "เครื่องหมายคำพูดต่ำแบบคู่ 9", inverted_exclamation_mark: "เครื่องหมายอัศเจรีย์กลับด้าน", inverted_question_mark: "เครื่องหมายคำถามกลับด้าน", two_dot_leader: "จุดนำสองจุด", horizontal_ellipsis: "จุดไข่ปลาแนวนอน", double_dagger: "เครื่องหมายดาบคู่", per_mille_sign: "เครื่องหมายเปอร์มิลล์", per_ten_thousand_sign: "เครื่องหมายเปอร์สิบพัน", question_exclamation_mark: "เครื่องหมายคำถามอัศเจรีย์", exclamation_question_mark: "เครื่องหมายอัศเจรีย์คำถาม", double_question_mark: "เครื่องหมายคำถามคู่", copyright_sign: "เครื่องหมายลิขสิทธิ์", registered_sign: "เครื่องหมายจดทะเบียน", trade_mark_sign: "เครื่องหมายการค้า", section_sign: "เครื่องหมายหมวดหมู่", paragraph_sign: "เครื่องหมายย่อหน้า", reversed_paragraph_sign: "เครื่องหมายย่อหน้ากลับด้าน", select_text: "ข้อความ", select_currency: "สกุลเงิน", select_all: "ทั้งหมด", title: "อักขระพิเศษ", manat: "เครื่องหมายมานัต", double_exclamation_mark: "เครื่องหมายตกใจสองตัว" }, FE = "สีพื้นหลังฟอนต์", qE = "ขนาดฟอนต์", HE = "ย้อนกลับ", VE = "ทำซ้ำ", UE = "เพิ่มการเยื้อง", WE = "ลดการเยื้อง", KE = "ลิงก์", ZE = "ตัวหนา", JE = "ตัวเอียง", GE = "ขีดเส้นใต้", YE = "ขีดทับ", XE = "รายการที่มีหมายเลข", QE = "รายการที่มีสัญลักษณ์จุด", e$ = "การจัดแนวข้อความ", t$ = "สีฟอนต์", n$ = "คำบรรยาย", i$ = "ข้อความทางเลือก", r$ = "ภาพ", o$ = "จัดภาพไปทางซ้าย", s$ = "จัดภาพไปกลาง", a$ = "จัดภาพไปทางขวา", l$ = "เปลี่ยนข้อความทางเลือกของภาพ", c$ = "เปลี่ยนคำบรรยายภาพ", u$ = "เปลี่ยนลิงก์ของภาพ", d$ = "การแทนที่", h$ = "ภาพผ่านลิงก์", f$ = "แทรกรูปภาพผ่านลิงก์", p$ = "ไม่สามารถประมวลผลภาพได้", m$ = "ความสูงของบรรทัด", g$ = "ไม่กำหนด", _$ = "ช่องว่างเพิ่มเติม", b$ = { apply: "นำมาใช้", clear: "ชัดเจน", error: "ข้อผิดพลาด" }, k$ = "ค่าเริ่มต้น", y$ = "ตั้งค่าความกว้างของภาพให้เต็มความกว้างของอุปกรณ์มือถือ", v$ = { one: "ทดสอบ" }, x$ = {
  substitute_variables: IE,
  font_family: PE,
  text_level: jE,
  special_characters: BE,
  background_color: FE,
  font_size: qE,
  undo: HE,
  redo: VE,
  increase_intent: UE,
  decrease_intent: WE,
  link: KE,
  bold: ZE,
  italic: JE,
  underline: GE,
  strike: YE,
  orderedList: XE,
  bulletList: QE,
  text_align: e$,
  font_color: t$,
  caption: n$,
  alt_text: i$,
  image: r$,
  image_side: o$,
  image_center: s$,
  image_in_line: a$,
  image_change_alt_text: l$,
  image_change_caption: c$,
  image_change_link: u$,
  substitutions: d$,
  image_via_link: h$,
  image_insert_via_link: f$,
  image_error: p$,
  line_height: m$,
  unset: g$,
  extra_spacing: _$,
  global: b$,
  default_font_size: k$,
  image_change_mobile_full_width: y$,
  test: v$
}, oI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: i$,
  background_color: FE,
  bold: ZE,
  bulletList: QE,
  caption: n$,
  decrease_intent: WE,
  default: x$,
  default_font_size: k$,
  extra_spacing: _$,
  font_color: t$,
  font_family: PE,
  font_size: qE,
  global: b$,
  image: r$,
  image_center: s$,
  image_change_alt_text: l$,
  image_change_caption: c$,
  image_change_link: u$,
  image_change_mobile_full_width: y$,
  image_error: p$,
  image_in_line: a$,
  image_insert_via_link: f$,
  image_side: o$,
  image_via_link: h$,
  increase_intent: UE,
  italic: JE,
  line_height: m$,
  link: KE,
  orderedList: XE,
  redo: VE,
  special_characters: BE,
  strike: YE,
  substitute_variables: IE,
  substitutions: d$,
  test: v$,
  text_align: e$,
  text_level: jE,
  underline: GE,
  undo: HE,
  unset: g$
}, Symbol.toStringTag, { value: "Module" })), S$ = "Yedek değişkenler", w$ = { title: "Yazı tipi ailesi", hint: "Standart yazı tipi e-posta istemcisi yazı tiplerini kullanır", default: "Varsayılan" }, C$ = { title: "Başlık", paragraph: "Paragraf", header_one: "Başlık 1", header_two: "Başlık 2", header_three: "Başlık 3" }, T$ = { dollar: "Dolar işareti", euro: "Euro işareti", yen: "Yen işareti", pound: "Pound işareti", cent: "Sent işareti", euro_currency: "Euro para birimi işareti", colon: "Colon işareti", cruzeiro: "Cruzeiro işareti", french_franc: "Fransız frankı işareti", lira: "Lira işareti", currency: "Para birimi işareti", bitcoin: "Bitcoin işareti", mill: "Mill işareti", peseta: "Peseta işareti", rupee: "Rupi işareti", won: "Won işareti", new_sheqel: "Yeni şekel işareti", dong: "Dong işareti", kip: "Kip işareti", tugrik: "Tugrik işareti", drachma: "Drahmi işareti", german_penny: "Alman kuruşu işareti", peso: "Peso işareti", guarani: "Guarani işareti", austral: "Avustral işareti", hryvnia: "Hırvat kunası işareti", cedi: "Cedi işareti", livre_tournois: "Livre tournois işareti", spesmilo: "Spesmilo işareti", tenge: "Tenge işareti", indian_rupee: "Hindistan rupisi işareti", turkish_lira: "Türk lirası işareti", nordic_mark: "Nordik işareti", ruble: "Ruble işareti", left_pointing_angle_quotation_mark: "Sola bakan tek açı tırnak işareti", right_pointing_angle_quotation_mark: "Sağa bakan tek açı tırnak işareti", left_pointing_double_angle_quotation_mark: "Sola bakan çift açı tırnak işareti", right_pointing_double_angle_quotation_mark: "Sağa bakan çift açı tırnak işareti", left_single_quotation_mark: "Sol tek tırnak işareti", right_single_quotation_mark: "Sağ tek tırnak işareti", left_double_quotation_mark: "Sol çift tırnak işareti", right_double_quotation_mark: "Sağ çift tırnak işareti", single_low_quotation_mark: "Tek düşük-9 tırnak işareti", double_low_quotation_mark: "Çift düşük-9 tırnak işareti", inverted_exclamation_mark: "Ters ünlem işareti", inverted_question_mark: "Ters soru işareti", two_dot_leader: "İki nokta lideri", horizontal_ellipsis: "Yatay üç nokta", double_dagger: "Çift hançer işareti", per_mille_sign: "Binde işareti", per_ten_thousand_sign: "On binde işareti", question_exclamation_mark: "Soru ünlem işareti", exclamation_question_mark: "Ünlem soru işareti", double_question_mark: "Çift soru işareti", copyright_sign: "Telif hakkı işareti", registered_sign: "Tescilli işareti", trade_mark_sign: "Ticari marka işareti", section_sign: "Bölüm işareti", paragraph_sign: "Paragraf işareti", reversed_paragraph_sign: "Ters paragraf işareti", select_text: "Metin", select_currency: "Para birimi", select_all: "Hepsi", title: "Özel karakterler", manat: "Manat işareti", double_exclamation_mark: "Çift ünlem işareti" }, M$ = "Yazı tipi arka plan rengi", E$ = "Yazı tipi boyutu", $$ = "Geri al", O$ = "Yinele", z$ = "Girintiyi artır", A$ = "Girintiyi azalt", N$ = "Bağlantı", L$ = "Kalın", D$ = "İtalik", R$ = "Altı çizili", I$ = "Üstü çizili", P$ = "Numaralandırılmış liste", j$ = "Madde işaretli liste", B$ = "Metin hizalama", F$ = "Yazı tipi rengi", q$ = "Resim yazısı", H$ = "Metin alternatifi", V$ = "Resim", U$ = "Resmi sola hizala", W$ = "Resmi ortaya hizala", K$ = "Resmi sağa hizala", Z$ = "Resim metin alternatifini değiştir", J$ = "Resim yazısını değiştir", G$ = "Resim bağlantısını değiştir", Y$ = "Yedekler", X$ = "Bağlantı yoluyla görüntü", Q$ = "Bağlantı aracılığıyla görüntü ekle", eO = "Görüntü işleme başarısız oldu", tO = "Satır yüksekliği", nO = "Sıfırla", iO = "Ekstra boşluk", rO = { apply: "Uygula", clear: "Temizlemek", error: "Hata" }, oO = "Varsayılan", sO = "Görüntü genişliğini mobil cihazın tam genişliğine ayarla", aO = { one: "Test" }, lO = {
  substitute_variables: S$,
  font_family: w$,
  text_level: C$,
  special_characters: T$,
  background_color: M$,
  font_size: E$,
  undo: $$,
  redo: O$,
  increase_intent: z$,
  decrease_intent: A$,
  link: N$,
  bold: L$,
  italic: D$,
  underline: R$,
  strike: I$,
  orderedList: P$,
  bulletList: j$,
  text_align: B$,
  font_color: F$,
  caption: q$,
  alt_text: H$,
  image: V$,
  image_side: U$,
  image_center: W$,
  image_in_line: K$,
  image_change_alt_text: Z$,
  image_change_caption: J$,
  image_change_link: G$,
  substitutions: Y$,
  image_via_link: X$,
  image_insert_via_link: Q$,
  image_error: eO,
  line_height: tO,
  unset: nO,
  extra_spacing: iO,
  global: rO,
  default_font_size: oO,
  image_change_mobile_full_width: sO,
  test: aO
}, sI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: H$,
  background_color: M$,
  bold: L$,
  bulletList: j$,
  caption: q$,
  decrease_intent: A$,
  default: lO,
  default_font_size: oO,
  extra_spacing: iO,
  font_color: F$,
  font_family: w$,
  font_size: E$,
  global: rO,
  image: V$,
  image_center: W$,
  image_change_alt_text: Z$,
  image_change_caption: J$,
  image_change_link: G$,
  image_change_mobile_full_width: sO,
  image_error: eO,
  image_in_line: K$,
  image_insert_via_link: Q$,
  image_side: U$,
  image_via_link: X$,
  increase_intent: z$,
  italic: D$,
  line_height: tO,
  link: N$,
  orderedList: P$,
  redo: O$,
  special_characters: T$,
  strike: I$,
  substitute_variables: S$,
  substitutions: Y$,
  test: aO,
  text_align: B$,
  text_level: C$,
  underline: R$,
  undo: $$,
  unset: nO
}, Symbol.toStringTag, { value: "Module" })), cO = "Замінні змінні", uO = { title: "Сімейство шрифтів", hint: "Стандартний шрифт використовує шрифти поштового клієнта", default: "За замовчуванням" }, dO = { title: "Заголовок", paragraph: "Абзац", header_one: "Заголовок 1", header_two: "Заголовок 2", header_three: "Заголовок 3" }, hO = { dollar: "Знак долара", euro: "Знак євро", yen: "Знак єни", pound: "Знак фунта", cent: "Знак центу", euro_currency: "Знак євро-валюти", colon: "Знак двокрапки", cruzeiro: "Знак крузейро", french_franc: "Знак французького франка", lira: "Знак ліри", currency: "Знак валюти", bitcoin: "Знак біткоїна", mill: "Знак мілі", peseta: "Знак песети", rupee: "Знак рупії", won: "Знак вона", new_sheqel: "Знак нового шекеля", dong: "Знак донга", kip: "Знак кипа", tugrik: "Знак тугрика", drachma: "Знак драхми", german_penny: "Знак німецької пенні", peso: "Знак песо", guarani: "Знак гуарані", austral: "Знак австрала", hryvnia: "Знак гривні", cedi: "Знак седі", livre_tournois: "Знак ліври турно", spesmilo: "Знак спесміло", tenge: "Знак тенге", indian_rupee: "Знак індійської рупії", turkish_lira: "Знак турецької ліри", nordic_mark: "Знак нордичної марки", ruble: "Знак рубля", left_pointing_angle_quotation_mark: "Одинична лівостороння кутова лапка", right_pointing_angle_quotation_mark: "Одинична правостороння кутова лапка", left_pointing_double_angle_quotation_mark: "Подвійна лівостороння кутова лапка", right_pointing_double_angle_quotation_mark: "Подвійна правостороння кутова лапка", left_single_quotation_mark: "Лівостороння одинична лапка", right_single_quotation_mark: "Правостороння одинична лапка", left_double_quotation_mark: "Ліва подвійна лапка", right_double_quotation_mark: "Права подвійна лапка", single_low_quotation_mark: "Одиночна низька лапка-9", double_low_quotation_mark: "Подвійна низька лапка-9", inverted_exclamation_mark: "Перевернутий знак оклику", inverted_question_mark: "Перевернуте питання", two_dot_leader: "Двокрапка-лідер", horizontal_ellipsis: "Горизонтальні три крапки", double_dagger: "Подвійний хрестик", per_mille_sign: "Знак пер mille", per_ten_thousand_sign: "Знак пер десять тисяч", question_exclamation_mark: "Знак питання-оклик", exclamation_question_mark: "Знак оклику-питання", double_question_mark: "Подвійний знак питання", copyright_sign: "Знак авторського права", registered_sign: "Знак зареєстрованої торгової марки", trade_mark_sign: "Знак торгової марки", section_sign: "Знак розділу", paragraph_sign: "Знак абзацу", reversed_paragraph_sign: "Перевернутий знак абзацу", select_text: "Текст", select_currency: "Валюта", select_all: "Усе", title: "Спеціальні символи", manat: "Знак маната", double_exclamation_mark: "Подвійний знак оклику" }, fO = "Колір фону шрифту", pO = "Розмір шрифту", mO = "Скасувати", gO = "Повторити", _O = "Збільшити відступ", bO = "Зменшити відступ", kO = "Посилання", yO = "Жирний", vO = "Курсив", xO = "Підкреслений", SO = "Перекреслений", wO = "Нумерований список", CO = "Маркерований список", TO = "Вирівнювання тексту", MO = "Колір шрифту", EO = "Підпис", $O = "Текстова альтернатива", OO = "Зображення", zO = "Вирівняти зображення ліворуч", AO = "Вирівняти зображення по центру", NO = "Вирівняти зображення праворуч", LO = "Змінити альтернативний текст зображення", DO = "Змінити підпис зображення", RO = "Змінити посилання на зображення", IO = "Зам substitutions", PO = "Зображення за посиланням", jO = "Вставити зображення за посиланням", BO = "Не вдалося обробити зображення", FO = "Висота рядка", qO = "Скинути", HO = "Додатковий інтервал", VO = { apply: "Застосувати", clear: "ясно", error: "Помилка" }, UO = "За замовчуванням", WO = "Встановіть ширину зображення на повну ширину мобільного пристрою", KO = { one: "Тест" }, ZO = {
  substitute_variables: cO,
  font_family: uO,
  text_level: dO,
  special_characters: hO,
  background_color: fO,
  font_size: pO,
  undo: mO,
  redo: gO,
  increase_intent: _O,
  decrease_intent: bO,
  link: kO,
  bold: yO,
  italic: vO,
  underline: xO,
  strike: SO,
  orderedList: wO,
  bulletList: CO,
  text_align: TO,
  font_color: MO,
  caption: EO,
  alt_text: $O,
  image: OO,
  image_side: zO,
  image_center: AO,
  image_in_line: NO,
  image_change_alt_text: LO,
  image_change_caption: DO,
  image_change_link: RO,
  substitutions: IO,
  image_via_link: PO,
  image_insert_via_link: jO,
  image_error: BO,
  line_height: FO,
  unset: qO,
  extra_spacing: HO,
  global: VO,
  default_font_size: UO,
  image_change_mobile_full_width: WO,
  test: KO
}, aI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: $O,
  background_color: fO,
  bold: yO,
  bulletList: CO,
  caption: EO,
  decrease_intent: bO,
  default: ZO,
  default_font_size: UO,
  extra_spacing: HO,
  font_color: MO,
  font_family: uO,
  font_size: pO,
  global: VO,
  image: OO,
  image_center: AO,
  image_change_alt_text: LO,
  image_change_caption: DO,
  image_change_link: RO,
  image_change_mobile_full_width: WO,
  image_error: BO,
  image_in_line: NO,
  image_insert_via_link: jO,
  image_side: zO,
  image_via_link: PO,
  increase_intent: _O,
  italic: vO,
  line_height: FO,
  link: kO,
  orderedList: wO,
  redo: gO,
  special_characters: hO,
  strike: SO,
  substitute_variables: cO,
  substitutions: IO,
  test: KO,
  text_align: TO,
  text_level: dO,
  underline: xO,
  undo: mO,
  unset: qO
}, Symbol.toStringTag, { value: "Module" })), JO = "替代变量", GO = { title: "字体", hint: "标准字体使用电子邮件客户端字体", default: "默认" }, YO = { title: "标题", paragraph: "段落", header_one: "标题1", header_two: "标题 2", header_three: "标题 3" }, XO = { dollar: "美元标志", euro: "欧元标志", yen: "日元标志", pound: "英镑标志", cent: "美分标志", euro_currency: "欧洲货币标志", colon: "Colon标志", cruzeiro: "克鲁塞罗标志", french_franc: "法国法郎标志", lira: "里拉标志", currency: "货币标志", bitcoin: "比特币标志", mill: "Mill标志", peseta: "比塞塔标志", rupee: "卢比标志", won: "Won标志", new_sheqel: "新 Sheqel 标志", dong: "侗族标志", kip: "基普标志", tugrik: "图格里克标志", drachma: "德拉克马标志", german_penny: "德国便士标志", peso: "比索标志", guarani: "瓜拉尼标志", austral: "澳大利亚标志", hryvnia: "格里夫纳标志", cedi: "塞地标志", livre_tournois: "巡回赛标志", spesmilo: "Spesmilo 标志", tenge: "坚戈标志", indian_rupee: "印度卢比标志", turkish_lira: "土耳其里拉标志", nordic_mark: "北欧标志", ruble: "卢布标志", left_pointing_angle_quotation_mark: "单个左角引号", right_pointing_angle_quotation_mark: "单个右角引号", left_pointing_double_angle_quotation_mark: "左侧双角引号", right_pointing_double_angle_quotation_mark: "直角双角引号", left_single_quotation_mark: "左单引号", right_single_quotation_mark: "右单引号", left_double_quotation_mark: "左双引号", right_double_quotation_mark: "右双引号", single_low_quotation_mark: "单引号", double_low_quotation_mark: "双低引号", inverted_exclamation_mark: "倒置感叹号", inverted_question_mark: "倒置问号", two_dot_leader: "两点领航", horizontal_ellipsis: "水平省略号", double_dagger: "双匕", per_mille_sign: "每米标志", per_ten_thousand_sign: "每万个标志", question_exclamation_mark: "问号感叹号", exclamation_question_mark: "感叹问号", double_question_mark: "双问号", copyright_sign: "版权标记", registered_sign: "已注册标记", trade_mark_sign: "商标标记", section_sign: "部分标记", paragraph_sign: "段落标记", reversed_paragraph_sign: "反向段落标记", select_text: "文本", select_currency: "货币", select_all: "所有", title: "特殊字符", manat: "马纳特标志", double_exclamation_mark: "双感叹号" }, QO = "字体背景颜色", ez = "字体大小", tz = "撤销", nz = "重做", iz = "增加意图", rz = "减少意图", oz = "链接", sz = "粗体", az = "斜体", lz = "下划线", cz = "划线", uz = "编号列表", dz = "项目符号列表", hz = "文本对齐", fz = "字体颜色", pz = "标题", mz = "文本替代", gz = "图像", _z = "图片左对齐", bz = "图片居中对齐", kz = "图片右对齐", yz = "更改图片替代文本", vz = "更改图片标题", xz = "更改图片链接", Sz = "替代品", wz = "通过链接插入的图像", Cz = "通过链接插入图像", Tz = "处理图像失败", Mz = "行高", Ez = "未设置", $z = "段落间距", Oz = { apply: "申请", clear: "清空", error: "错误" }, zz = "默认", Az = "将图像宽度设置为移动设备的全宽", Nz = { one: "测试" }, Lz = {
  substitute_variables: JO,
  font_family: GO,
  text_level: YO,
  special_characters: XO,
  background_color: QO,
  font_size: ez,
  undo: tz,
  redo: nz,
  increase_intent: iz,
  decrease_intent: rz,
  link: oz,
  bold: sz,
  italic: az,
  underline: lz,
  strike: cz,
  orderedList: uz,
  bulletList: dz,
  text_align: hz,
  font_color: fz,
  caption: pz,
  alt_text: mz,
  image: gz,
  image_side: _z,
  image_center: bz,
  image_in_line: kz,
  image_change_alt_text: yz,
  image_change_caption: vz,
  image_change_link: xz,
  substitutions: Sz,
  image_via_link: wz,
  image_insert_via_link: Cz,
  image_error: Tz,
  line_height: Mz,
  unset: Ez,
  extra_spacing: $z,
  global: Oz,
  default_font_size: zz,
  image_change_mobile_full_width: Az,
  test: Nz
}, lI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alt_text: mz,
  background_color: QO,
  bold: sz,
  bulletList: dz,
  caption: pz,
  decrease_intent: rz,
  default: Lz,
  default_font_size: zz,
  extra_spacing: $z,
  font_color: fz,
  font_family: GO,
  font_size: ez,
  global: Oz,
  image: gz,
  image_center: bz,
  image_change_alt_text: yz,
  image_change_caption: vz,
  image_change_link: xz,
  image_change_mobile_full_width: Az,
  image_error: Tz,
  image_in_line: kz,
  image_insert_via_link: Cz,
  image_side: _z,
  image_via_link: wz,
  increase_intent: iz,
  italic: az,
  line_height: Mz,
  link: oz,
  orderedList: uz,
  redo: nz,
  special_characters: XO,
  strike: cz,
  substitute_variables: JO,
  substitutions: Sz,
  test: Nz,
  text_align: hz,
  text_level: YO,
  underline: lz,
  undo: tz,
  unset: Ez
}, Symbol.toStringTag, { value: "Module" })), Dz = ["common"], cI = Dz[0], uI = Object.values(qa), dI = {
  ar: { common: Lm },
  cs: { common: yg },
  da: { common: s_ },
  de: { common: W_ },
  el: { common: Ab },
  en: { common: bk },
  es: { common: ry },
  fr: { common: Vy },
  hi: { common: O1 },
  hu: { common: g0 },
  id: { common: nv },
  it: { common: qv },
  ja: { common: Ex },
  nl: { common: pS },
  no: { common: ew },
  pl: { common: Bw },
  pt: { common: TC },
  ro: { common: h3 },
  ru: { common: X3 },
  sk: { common: P2 },
  sl: { common: wT },
  sq: { common: uM },
  sr: { common: GM },
  sv: { common: RE },
  th: { common: x$ },
  tr: { common: lO },
  uk: { common: ZO },
  zh: { common: Lz }
}, hI = {
  supportedLngs: uI,
  load: "languageOnly",
  debug: !1,
  defaultNS: cI,
  react: { useSuspense: !1 },
  returnEmptyString: !1,
  ns: Dz,
  compatibilityJSON: "v3",
  fallbackLng: qa.ENGLISH,
  lng: qa.ENGLISH,
  interpolation: {
    escapeValue: !1
  },
  resources: dI
};
O.use(dR).init(hI);
function Rz(n) {
  return /* @__PURE__ */ P("svg", { width: "20", height: "20", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ...n, children: [
    /* @__PURE__ */ b(
      "path",
      {
        d: "M13.2656 1.6875H6.73438C5.75172 1.6875 4.95312 2.48609 4.95312 3.46875V16.5312C4.95312 17.5139 5.75172 18.3125 6.73438 18.3125H13.2656C14.2483 18.3125 15.0469 17.5139 15.0469 16.5312V3.46875C15.0469 2.48609 14.2483 1.6875 13.2656 1.6875ZM13.8594 16.5312C13.8594 16.8578 13.5922 17.125 13.2656 17.125H6.73438C6.40781 17.125 6.14062 16.8578 6.14062 16.5312V3.46875C6.14062 3.14219 6.40781 2.875 6.73438 2.875H7.32812C7.32812 3.36484 7.72891 3.76562 8.21875 3.76562H11.7812C12.2711 3.76562 12.6719 3.36484 12.6719 2.875H13.2656C13.5922 2.875 13.8594 3.14219 13.8594 3.46875V16.5312Z",
        fill: "#142D63"
      }
    ),
    /* @__PURE__ */ b(
      "path",
      {
        d: "M7.5 13L12.5 8M7.5 13H9.16667M7.5 13L7.5 11.3333M12.5 8H10.8333M12.5 8V9.66667",
        strokeWidth: "0.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  ] });
}
const Rn = "group flex items-center justify-center focus-visible:outline-brand-primary rounded-lg h-3 px-[9px] py-4 [&>svg]:h-3.5 [&>svg]:w-3.5 cursor-pointer", he = (n) => W(
  "main-transition-colors",
  n ? "stroke-text-secondary" : "stroke-text-primary group-hover:stroke-brand-primary"
), yd = (n) => W(
  "main-transition-colors",
  n ? "fill-text-secondary" : "fill-text-primary group-hover:fill-brand-primary"
), Iz = (n) => W(
  "main-transition-colors",
  n ? "text-text-secondary" : "text-text-primary hover:text-brand-primary"
), fI = "#000000", pI = "15px", mI = "#ffffff", gl = "1rem", vd = "8px", gI = {
  marginTop: 0,
  marginBottom: 0
}, ko = {
  2: {
    marginTop: "0.83em",
    marginBottom: "0.83em",
    fontSize: "1.5em",
    lineHeight: "normal",
    fontFamily: "inherit",
    fontWeight: "bold"
  },
  3: {
    marginTop: "1em",
    marginBottom: "1em",
    fontSize: "1.17em",
    lineHeight: "normal",
    fontFamily: "inherit",
    fontWeight: "bold"
  },
  4: {
    marginTop: "1.33em",
    marginBottom: "1.33em",
    lineHeight: "normal",
    fontFamily: "inherit",
    fontWeight: "bold",
    fontSize: "1em"
  }
}, Wo = {
  marginTop: gl,
  marginBottom: gl,
  paddingLeft: "40px"
}, ie = {
  hoverOpenDelay: 900,
  popoverClassName: "px-2 py-1 shadow-md [--anchor-gap:5px] z-[9999]"
}, Pz = {
  display: "table",
  clear: "both",
  textAlign: "center",
  minWidth: "50px",
  maxWidth: "100%",
  margin: ".9em auto"
}, _I = "@media (max-width: 600px) { .is-mobile-full-width figure { width: 100% !important; } }", bI = "@media (max-width: 600px) { .is-mobile-full-width img { width: 100% !important; max-width: 100% !important; } }", jz = (n) => ({
  display: "table",
  float: "right",
  clear: "both",
  textAlign: "center",
  minWidth: "50px",
  maxWidth: "100%",
  margin: n ? `${gl} 0 .9em 1.5em` : "0 0 .9em 1.5em"
}), kI = {
  display: "block",
  margin: "0 auto",
  minWidth: "100%",
  maxWidth: "100%"
}, Bz = {
  display: "table-caption",
  captionSide: "bottom",
  wordBreak: "break-word",
  textAlign: "center",
  color: "rgb(var(--text-primary))",
  backgroundColor: "rgb(var(--background-primary))",
  padding: ".6em",
  fontSize: ".75em",
  outlineOffset: "-1px"
};
var ze = /* @__PURE__ */ ((n) => (n.Inline = "inline-image", n.Block = "block-image", n))(ze || {}), ce = /* @__PURE__ */ ((n) => (n.Inline = "inline", n.BlockCenter = "blockCenter", n.BlockRight = "blockRight", n))(ce || {}), Yi = /* @__PURE__ */ ((n) => (n.Before = "before", n.After = "after", n))(Yi || {}), le = /* @__PURE__ */ ((n) => (n[n.InitialMode = 0] = "InitialMode", n[n.ViewLinkMode = 1] = "ViewLinkMode", n.EditCaptionMode = "caption", n.EditAltMode = "alt", n.EditLinkMode = "href", n))(le || {});
function ae({ className: n, children: e, ...t }) {
  return /* @__PURE__ */ b(
    "button",
    {
      type: "button",
      className: W(
        Rn,
        "main-transition-colors",
        t.disabled ? "text-text-secondary" : "text-text-primary hover:text-brand-primary",
        n
      ),
      ...t,
      children: e
    }
  );
}
function yI(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      stroke: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M19 13V14.2C19 15.8802 19 16.7202 18.673 17.362C18.3854 17.9265 17.9265 18.3854 17.362 18.673C16.7202 19 15.8802 19 14.2 19H5.8C4.11984 19 3.27976 19 2.63803 18.673C2.07354 18.3854 1.6146 17.9265 1.32698 17.362C1 16.7202 1 15.8802 1 14.2V13M15 8L10 13M10 13L5 8M10 13V1",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
function vI(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M21 20.9998H13M2.5 21.4998L8.04927 19.3655C8.40421 19.229 8.58168 19.1607 8.74772 19.0716C8.8952 18.9924 9.0358 18.901 9.16804 18.7984C9.31692 18.6829 9.45137 18.5484 9.72028 18.2795L21 6.99982C22.1046 5.89525 22.1046 4.10438 21 2.99981C19.8955 1.89525 18.1046 1.89524 17 2.99981L5.72028 14.2795C5.45138 14.5484 5.31692 14.6829 5.20139 14.8318C5.09877 14.964 5.0074 15.1046 4.92823 15.2521C4.83911 15.4181 4.77085 15.5956 4.63433 15.9506L2.5 21.4998ZM2.5 21.4998L4.55812 16.1488C4.7054 15.7659 4.77903 15.5744 4.90534 15.4867C5.01572 15.4101 5.1523 15.3811 5.2843 15.4063C5.43533 15.4351 5.58038 15.5802 5.87048 15.8703L8.12957 18.1294C8.41967 18.4195 8.56472 18.5645 8.59356 18.7155C8.61877 18.8475 8.58979 18.9841 8.51314 19.0945C8.42545 19.2208 8.23399 19.2944 7.85107 19.4417L2.5 21.4998Z",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
function xI(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M9 4V2M15 20V22M4 9H2M20 15H22M4.91421 4.91421L3.5 3.5M19.0858 19.0858L20.5 20.5M12 17.6569L9.87868 19.7782C8.31658 21.3403 5.78392 21.3403 4.22183 19.7782C2.65973 18.2161 2.65973 15.6834 4.22183 14.1213L6.34315 12M17.6569 12L19.7782 9.87868C21.3403 8.31658 21.3403 5.78392 19.7782 4.22183C18.2161 2.65973 15.6834 2.65973 14.1213 4.22183L12 6.34315",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
function Fz({ link: n, unsetLink: e, setIsEditing: t }) {
  return /* @__PURE__ */ P(dn, { children: [
    /* @__PURE__ */ b("div", { className: "w-[220px] truncate", children: /* @__PURE__ */ b(
      "a",
      {
        href: n,
        target: "_blank",
        className: "text-brand-primary px-3 truncate underline",
        children: n
      }
    ) }),
    /* @__PURE__ */ P("div", { className: "flex", children: [
      /* @__PURE__ */ b(ae, { onClick: e, children: /* @__PURE__ */ b(xI, { className: "main-transition-colors stroke-text-primary group-hover:stroke-red h-3.5 w-3.5" }) }),
      /* @__PURE__ */ b(ae, { onClick: () => t(!0), children: /* @__PURE__ */ b(vI, { className: he(!1) }) })
    ] })
  ] });
}
function qz({
  newLink: n,
  onChangeLink: e,
  onSaveLink: t,
  openFileSelector: i
}) {
  const r = !Lh(n);
  return /* @__PURE__ */ P(dn, { children: [
    /* @__PURE__ */ b(
      $h,
      {
        className: "w-[250px]",
        value: n,
        placeholder: "example.com",
        onChange: e
      }
    ),
    /* @__PURE__ */ P("div", { className: "flex", children: [
      /* @__PURE__ */ b(ae, { onClick: i, children: /* @__PURE__ */ b(yI, { className: he(!1) }) }),
      /* @__PURE__ */ b(ae, { type: "submit", onClick: () => t(n), disabled: r, children: /* @__PURE__ */ b(zl, { className: he(r) }) })
    ] })
  ] });
}
function SI(n) {
  return /* @__PURE__ */ b("svg", { width: "14", height: "14", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 576 512", ...n, children: /* @__PURE__ */ b("path", { d: "M0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM200 208c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48s21.5-48 48-48zm144 48c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48z" }) });
}
function _l(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "12",
      height: "12",
      viewBox: "0 0 12 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M1.92684 0.666649V11.3333M9.92684 0.666649V11.3333M3.26017 0.666649H0.593506M9.92684 5.99998L1.92684 5.99998M3.26017 11.3333H0.593506M11.2602 11.3333H8.59351M11.2602 0.666649H8.59351",
          "stroke-width": "1.2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
function wI(n) {
  return /* @__PURE__ */ P("svg", { width: "20", height: "20", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ...n, children: [
    /* @__PURE__ */ b("path", { opacity: ".5", d: "M2 3h16v1.5H2zm0 12h16v1.5H2z" }),
    /* @__PURE__ */ b("path", { d: "M15.003 7v5.5a1 1 0 0 1-1 1H5.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H6.5V12h6.997V7.5z" })
  ] });
}
function CI(n) {
  return /* @__PURE__ */ P("svg", { width: "20", height: "20", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ...n, children: [
    /* @__PURE__ */ b("path", { opacity: ".5", d: "M2 3h16v1.5H2zm11.5 9H18v1.5h-4.5zM2 15h16v1.5H2z" }),
    /* @__PURE__ */ b("path", { d: "M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z" })
  ] });
}
function TI(n) {
  return /* @__PURE__ */ P("svg", { width: "20", height: "20", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ...n, children: [
    /* @__PURE__ */ b(
      "path",
      {
        opacity: ".5",
        d: "M2 3h16v1.5H2zm0 12h16v1.5H2zm0-9h5v1.5H2zm0 3h5v1.5H2zm0 3h5v1.5H2z"
      }
    ),
    /* @__PURE__ */ b("path", { d: "M18.003 7v5.5a1 1 0 0 1-1 1H8.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H9.5V12h6.997V7.5z" })
  ] });
}
function Ko(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M6.66668 8.66666C6.95298 9.04942 7.31825 9.36612 7.73771 9.59529C8.15717 9.82446 8.62102 9.96074 9.09778 9.99489C9.57454 10.029 10.0531 9.96024 10.5009 9.79319C10.9487 9.62613 11.3554 9.36471 11.6933 9.02666L13.6933 7.02666C14.3005 6.39799 14.6365 5.55598 14.6289 4.68199C14.6213 3.808 14.2708 2.97196 13.6527 2.35394C13.0347 1.73591 12.1987 1.38535 11.3247 1.37775C10.4507 1.37016 9.60869 1.70614 8.98001 2.31333L7.83334 3.45333M9.33334 7.33333C9.04704 6.95058 8.68177 6.63388 8.26231 6.4047C7.84285 6.17553 7.37901 6.03925 6.90224 6.00511C6.42548 5.97096 5.94695 6.03975 5.49911 6.20681C5.05128 6.37387 4.6446 6.63528 4.30668 6.97333L2.30668 8.97333C1.69948 9.602 1.3635 10.444 1.3711 11.318C1.37869 12.192 1.72926 13.028 2.34728 13.6461C2.96531 14.2641 3.80135 14.6147 4.67534 14.6222C5.54933 14.6298 6.39134 14.2939 7.02001 13.6867L8.16001 12.5467",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
const Tt = (n) => n ? n.isActive(ze.Block) || n.isActive(ze.Inline) : !1;
function Hz({
  editor: n,
  children: e,
  className: t,
  shouldShow: i,
  tippyOptions: r,
  ...o
}) {
  return /* @__PURE__ */ b(
    U4,
    {
      className: W("bg-background-secondary shadow-3xl rounded-lg", t),
      editor: n,
      shouldShow: i,
      updateDelay: 0,
      tippyOptions: {
        appendTo: "parent",
        duration: [200, 0],
        placement: "bottom",
        offset: [0, 10],
        hideOnClick: !0,
        ...r
      },
      ...o,
      children: e
    }
  );
}
const xd = (n) => {
  var a;
  const e = n == null ? void 0 : n.state, t = e == null ? void 0 : e.selection.from, i = (a = e == null ? void 0 : e.doc.nodeAt(t ?? 0)) == null ? void 0 : a.type.name, r = i ? n == null ? void 0 : n.getAttributes(i).caption : null, o = i ? n == null ? void 0 : n.getAttributes(i).alt : null, s = i ? n == null ? void 0 : n.getAttributes(i).href : null;
  return {
    [le.EditAltMode]: o ?? "",
    [le.EditLinkMode]: s ?? "",
    [le.EditCaptionMode]: r ?? ""
  };
}, MI = ({ editor: n, fileSource: e }) => {
  var A;
  const [t, i] = ye(xd(n)), [r, o] = ye(
    le.InitialMode
  ), [s, a] = ye(!1), l = n == null ? void 0 : n.state, c = l == null ? void 0 : l.selection.from, u = (A = l == null ? void 0 : l.doc.nodeAt(c ?? 0)) == null ? void 0 : A.type.name, d = u ? n == null ? void 0 : n.getAttributes(u).imageMode : null, h = u ? n == null ? void 0 : n.getAttributes(u).isMobileFullWidth : !1, [f, p] = ye(!1);
  if (Je(() => {
    const z = () => {
      o(le.InitialMode), i(xd(n));
    };
    return z(), () => z();
  }, [c, n]), !n || !(n != null && n.options.editable)) return null;
  const m = (z) => {
    i((N) => ({ ...N, [r]: z }));
  }, g = (z) => {
    if (r === le.InitialMode || r === le.ViewLinkMode || !u)
      return;
    const N = z ?? t[r];
    n.chain().focus().updateAttributes(u, { [r]: N }).run(), o(le.InitialMode);
  }, k = (z) => {
    u && (n.chain().focus().updateAttributes(u, { [z]: null }).run(), i((N) => ({ ...N, [z]: "" })), o(le.InitialMode));
  }, x = (z) => {
    n.chain().focus().toggleImageMode(z).run();
  }, S = () => {
    d === ce.Inline && x(ce.BlockCenter), setTimeout(() => {
      o(le.EditCaptionMode);
    }, 0);
  }, _ = () => {
    u && n.chain().focus().updateAttributes(u, { isMobileFullWidth: !h }).run();
  }, v = t[le.EditAltMode].length > 0, y = t[le.EditCaptionMode].length > 0, w = t[le.EditLinkMode].length > 0, $ = () => {
    switch (r) {
      case le.ViewLinkMode:
        return /* @__PURE__ */ b(
          Fz,
          {
            link: t[le.EditLinkMode],
            unsetLink: () => k(le.EditLinkMode),
            setIsEditing: () => o(le.EditLinkMode)
          }
        );
      case le.EditLinkMode:
        return /* @__PURE__ */ b(
          qz,
          {
            newLink: t[le.EditLinkMode],
            onChangeLink: m,
            onSaveLink: g,
            openFileSelector: () => {
              a(!0);
            }
          }
        );
      case le.EditCaptionMode:
      case le.EditAltMode: {
        const z = t[r];
        let N = "";
        switch (r) {
          case le.EditCaptionMode: {
            N = O.t("caption");
            break;
          }
          case le.EditAltMode:
            N = O.t("alt_text");
            break;
        }
        return /* @__PURE__ */ P(dn, { children: [
          /* @__PURE__ */ b(
            BA,
            {
              placeholder: N,
              value: z,
              onChange: (D) => m(D.target.value)
            }
          ),
          /* @__PURE__ */ b(ae, { type: "submit", onClick: () => g(), children: /* @__PURE__ */ b(zl, { className: he(!1) }) })
        ] });
      }
      case le.InitialMode:
      default:
        return /* @__PURE__ */ P(dn, { children: [
          /* @__PURE__ */ b(
            te,
            {
              label: O.t("image_in_line"),
              anchor: "left",
              disabled: f,
              ...ie,
              children: /* @__PURE__ */ b(
                ae,
                {
                  onClick: () => x(ce.Inline),
                  className: Te(d === ce.Inline && "bg-brand-primary/10"),
                  children: /* @__PURE__ */ b(
                    CI,
                    {
                      className: Te(
                        d === ce.Inline ? "fill-brand-primary" : "fill-text-primary group-hover:fill-brand-primary",
                        "main-transition-colors"
                      )
                    }
                  )
                }
              )
            }
          ),
          /* @__PURE__ */ b(
            te,
            {
              label: O.t("image_center"),
              anchor: "left",
              disabled: f,
              ...ie,
              children: /* @__PURE__ */ b(
                ae,
                {
                  onClick: () => x(ce.BlockCenter),
                  className: Te(d === ce.BlockCenter && "bg-brand-primary/10"),
                  children: /* @__PURE__ */ b(
                    wI,
                    {
                      className: Te(
                        d === ce.BlockCenter ? "fill-brand-primary" : "fill-text-primary group-hover:fill-brand-primary",
                        "main-transition-colors"
                      )
                    }
                  )
                }
              )
            }
          ),
          /* @__PURE__ */ b(
            te,
            {
              label: O.t("image_side"),
              anchor: "left",
              disabled: f,
              ...ie,
              children: /* @__PURE__ */ b(
                ae,
                {
                  onClick: () => x(ce.BlockRight),
                  className: Te(d === ce.BlockRight && "bg-brand-primary/10"),
                  children: /* @__PURE__ */ b(
                    TI,
                    {
                      className: Te(
                        d === ce.BlockRight ? "fill-brand-primary" : "fill-text-primary group-hover:fill-brand-primary",
                        "main-transition-colors"
                      )
                    }
                  )
                }
              )
            }
          ),
          /* @__PURE__ */ b(
            te,
            {
              disabled: f,
              label: O.t("image_change_alt_text"),
              anchor: "left",
              ...ie,
              children: /* @__PURE__ */ b(
                ae,
                {
                  onClick: () => o(le.EditAltMode),
                  className: Te(v && "bg-brand-primary/10"),
                  children: /* @__PURE__ */ b(
                    _l,
                    {
                      className: Te(
                        "main-transition-colors",
                        v ? "stroke-brand-primary" : "stroke-text-primary group-hover:stroke-brand-primary"
                      )
                    }
                  )
                }
              )
            }
          ),
          /* @__PURE__ */ b(te, { label: O.t("image_change_caption"), anchor: "left", ...ie, children: /* @__PURE__ */ b(
            ae,
            {
              className: Te(y && "bg-brand-primary/10"),
              onClick: S,
              children: /* @__PURE__ */ b(
                SI,
                {
                  className: Te(
                    y ? "fill-brand-primary" : "fill-text-primary group-hover:fill-brand-primary",
                    "main-transition-colors"
                  )
                }
              )
            }
          ) }),
          /* @__PURE__ */ b(
            te,
            {
              disabled: f,
              label: O.t("image_change_link"),
              anchor: "left",
              ...ie,
              children: /* @__PURE__ */ b(
                ae,
                {
                  className: Te("main-transition-colors", w && "bg-brand-primary/10"),
                  onClick: () => o(
                    w ? le.ViewLinkMode : le.EditLinkMode
                  ),
                  children: /* @__PURE__ */ b(
                    Ko,
                    {
                      className: Te(
                        "main-transition-colors",
                        w ? "stroke-brand-primary" : "stroke-text-primary group-hover:stroke-brand-primary"
                      )
                    }
                  )
                }
              )
            }
          ),
          /* @__PURE__ */ b(
            te,
            {
              disabled: f,
              label: O.t("image_change_mobile_full_width"),
              anchor: "left",
              ...ie,
              children: /* @__PURE__ */ b(
                ae,
                {
                  className: Te(
                    "main-transition-colors",
                    h && "bg-brand-primary/10"
                  ),
                  onClick: _,
                  children: /* @__PURE__ */ b(
                    Rz,
                    {
                      className: Te(
                        "main-transition-colors",
                        h ? "stroke-brand-primary" : "stroke-text-primary group-hover:stroke-brand-primary"
                      )
                    }
                  )
                }
              )
            }
          )
        ] });
    }
  };
  return /* @__PURE__ */ P("div", { children: [
    /* @__PURE__ */ b(
      Hz,
      {
        className: Te(s && "hidden"),
        editor: n,
        tippyOptions: {
          maxWidth: 400,
          onHide() {
            o(le.InitialMode), p(!0);
          },
          onShow() {
            p(!1);
          },
          hideOnClick: !1
        },
        shouldShow: ({ editor: z }) => Tt(z) ? (z == null ? void 0 : z.getAttributes(ze.Block).showBubbleMenu) || (z == null ? void 0 : z.getAttributes(ze.Inline).showBubbleMenu) : !1,
        children: /* @__PURE__ */ b(
          "form",
          {
            onSubmit: (z) => z.preventDefault(),
            className: W(
              "flex items-center p-2",
              r === le.InitialMode && "gap-0.5"
            ),
            children: $()
          }
        )
      }
    ),
    /* @__PURE__ */ b(
      Ol,
      {
        uploadingFromSource: e,
        initialSearchFilters: {
          source: [e],
          name: "",
          type: []
        },
        opened: s,
        onClose: () => {
          a(!1);
        },
        onSelect: (z) => {
          m(z.path), g(z.path), a(!1);
        }
      }
    )
  ] });
}, Vz = (n) => {
  if (!n) return !1;
  const { from: e, to: t } = n.state.selection;
  let i = !1;
  return n.state.doc.nodesBetween(e, t, (r) => {
    r.isText && r.marks.find((s) => s.type.name === "link") && (i = !0);
  }), i;
}, EI = ({ editor: n, fileSource: e }) => {
  const t = n == null ? void 0 : n.getAttributes("link").href, i = gr(t), [r, o] = ye(""), [s, a] = ye(!1), [l, c] = ye(!1);
  Je(() => {
    i.current = t, o(i.current || ""), a(!i.current);
  }, [t]);
  const u = () => n == null ? void 0 : n.chain().focus().extendMarkRange("link").unsetLink().setMeta("addToHistory", !1).run(), d = (p) => {
    a(!0), o(p);
  }, h = (p) => {
    n && (a(!1), n.chain().extendMarkRange("link").setLink({ href: p }).run());
  }, f = () => {
    i.current ? (o((p) => i.current || p), a(!1)) : (u(), o(""));
  };
  return !n || !(n != null && n.options.editable) ? null : /* @__PURE__ */ P("div", { children: [
    /* @__PURE__ */ b(
      Hz,
      {
        className: Te(l && "hidden"),
        editor: n,
        shouldShow: ({ editor: p }) => Vz(p),
        tippyOptions: {
          onHide: f
        },
        children: /* @__PURE__ */ b("form", { onSubmit: (p) => p.preventDefault(), className: "flex items-center p-2", children: s ? /* @__PURE__ */ b(
          qz,
          {
            newLink: r,
            onChangeLink: d,
            onSaveLink: h,
            openFileSelector: () => {
              n.commands.blur(), c(!0);
            }
          }
        ) : /* @__PURE__ */ b(Fz, { link: r, unsetLink: u, setIsEditing: a }) })
      }
    ),
    /* @__PURE__ */ b(
      Ol,
      {
        uploadingFromSource: e,
        initialSearchFilters: {
          source: [e],
          name: "",
          type: []
        },
        opened: l,
        onClose: () => {
          c(!1);
        },
        onSelect: (p) => {
          h(p.path), c(!1);
        }
      }
    )
  ] });
}, $I = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3nd0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0axi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2", OI = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2", bl = "numeric", kl = "ascii", yl = "alpha", ar = "asciinumeric", Xi = "alphanumeric", vl = "domain", Uz = "emoji", zI = "scheme", AI = "slashscheme", Ca = "whitespace";
function NI(n, e) {
  return n in e || (e[n] = []), e[n];
}
function ti(n, e, t) {
  e[bl] && (e[ar] = !0, e[Xi] = !0), e[kl] && (e[ar] = !0, e[yl] = !0), e[ar] && (e[Xi] = !0), e[yl] && (e[Xi] = !0), e[Xi] && (e[vl] = !0), e[Uz] && (e[vl] = !0);
  for (const i in e) {
    const r = NI(i, t);
    r.indexOf(n) < 0 && r.push(n);
  }
}
function LI(n, e) {
  const t = {};
  for (const i in e)
    e[i].indexOf(n) >= 0 && (t[i] = !0);
  return t;
}
function rt(n = null) {
  this.j = {}, this.jr = [], this.jd = null, this.t = n;
}
rt.groups = {};
rt.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(n) {
    const e = this, t = e.j[n];
    if (t)
      return t;
    for (let i = 0; i < e.jr.length; i++) {
      const r = e.jr[i][0], o = e.jr[i][1];
      if (o && r.test(n))
        return o;
    }
    return e.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(n, e = !1) {
    return e ? n in this.j : !!this.go(n);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(n, e, t, i) {
    for (let r = 0; r < n.length; r++)
      this.tt(n[r], e, t, i);
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(n, e, t, i) {
    i = i || rt.groups;
    let r;
    return e && e.j ? r = e : (r = new rt(e), t && i && ti(e, t, i)), this.jr.push([n, r]), r;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(n, e, t, i) {
    let r = this;
    const o = n.length;
    if (!o)
      return r;
    for (let s = 0; s < o - 1; s++)
      r = r.tt(n[s]);
    return r.tt(n[o - 1], e, t, i);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(n, e, t, i) {
    i = i || rt.groups;
    const r = this;
    if (e && e.j)
      return r.j[n] = e, e;
    const o = e;
    let s, a = r.go(n);
    if (a ? (s = new rt(), Object.assign(s.j, a.j), s.jr.push.apply(s.jr, a.jr), s.jd = a.jd, s.t = a.t) : s = new rt(), o) {
      if (i)
        if (s.t && typeof s.t == "string") {
          const l = Object.assign(LI(s.t, i), t);
          ti(o, l, i);
        } else t && ti(o, t, i);
      s.t = o;
    }
    return r.j[n] = s, s;
  }
};
const J = (n, e, t, i, r) => n.ta(e, t, i, r), ve = (n, e, t, i, r) => n.tr(e, t, i, r), Sd = (n, e, t, i, r) => n.ts(e, t, i, r), E = (n, e, t, i, r) => n.tt(e, t, i, r), tn = "WORD", xl = "UWORD", Wz = "ASCIINUMERICAL", Kz = "ALPHANUMERICAL", Nr = "LOCALHOST", Sl = "TLD", wl = "UTLD", yo = "SCHEME", $i = "SLASH_SCHEME", pc = "NUM", Cl = "WS", mc = "NL", lr = "OPENBRACE", cr = "CLOSEBRACE", Zo = "OPENBRACKET", Jo = "CLOSEBRACKET", Go = "OPENPAREN", Yo = "CLOSEPAREN", Xo = "OPENANGLEBRACKET", Qo = "CLOSEANGLEBRACKET", es = "FULLWIDTHLEFTPAREN", ts = "FULLWIDTHRIGHTPAREN", ns = "LEFTCORNERBRACKET", is = "RIGHTCORNERBRACKET", rs = "LEFTWHITECORNERBRACKET", ss = "RIGHTWHITECORNERBRACKET", as = "FULLWIDTHLESSTHAN", ls = "FULLWIDTHGREATERTHAN", cs = "AMPERSAND", us = "APOSTROPHE", ds = "ASTERISK", xn = "AT", hs = "BACKSLASH", fs = "BACKTICK", ps = "CARET", Cn = "COLON", gc = "COMMA", ms = "DOLLAR", Dt = "DOT", gs = "EQUALS", _c = "EXCLAMATION", gt = "HYPHEN", ur = "PERCENT", _s = "PIPE", bs = "PLUS", ks = "POUND", dr = "QUERY", bc = "QUOTE", Zz = "FULLWIDTHMIDDLEDOT", kc = "SEMI", Rt = "SLASH", hr = "TILDE", ys = "UNDERSCORE", Jz = "EMOJI", vs = "SYM";
var Gz = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ALPHANUMERICAL: Kz,
  AMPERSAND: cs,
  APOSTROPHE: us,
  ASCIINUMERICAL: Wz,
  ASTERISK: ds,
  AT: xn,
  BACKSLASH: hs,
  BACKTICK: fs,
  CARET: ps,
  CLOSEANGLEBRACKET: Qo,
  CLOSEBRACE: cr,
  CLOSEBRACKET: Jo,
  CLOSEPAREN: Yo,
  COLON: Cn,
  COMMA: gc,
  DOLLAR: ms,
  DOT: Dt,
  EMOJI: Jz,
  EQUALS: gs,
  EXCLAMATION: _c,
  FULLWIDTHGREATERTHAN: ls,
  FULLWIDTHLEFTPAREN: es,
  FULLWIDTHLESSTHAN: as,
  FULLWIDTHMIDDLEDOT: Zz,
  FULLWIDTHRIGHTPAREN: ts,
  HYPHEN: gt,
  LEFTCORNERBRACKET: ns,
  LEFTWHITECORNERBRACKET: rs,
  LOCALHOST: Nr,
  NL: mc,
  NUM: pc,
  OPENANGLEBRACKET: Xo,
  OPENBRACE: lr,
  OPENBRACKET: Zo,
  OPENPAREN: Go,
  PERCENT: ur,
  PIPE: _s,
  PLUS: bs,
  POUND: ks,
  QUERY: dr,
  QUOTE: bc,
  RIGHTCORNERBRACKET: is,
  RIGHTWHITECORNERBRACKET: ss,
  SCHEME: yo,
  SEMI: kc,
  SLASH: Rt,
  SLASH_SCHEME: $i,
  SYM: vs,
  TILDE: hr,
  TLD: Sl,
  UNDERSCORE: ys,
  UTLD: wl,
  UWORD: xl,
  WORD: tn,
  WS: Cl
});
const Xt = /[a-z]/, Ki = new RegExp("\\p{L}", "u"), Ta = new RegExp("\\p{Emoji}", "u"), Qt = /\d/, Ma = /\s/, wd = "\r", Ea = `
`, DI = "️", RI = "‍", $a = "￼";
let no = null, io = null;
function II(n = []) {
  const e = {};
  rt.groups = e;
  const t = new rt();
  no == null && (no = Cd($I)), io == null && (io = Cd(OI)), E(t, "'", us), E(t, "{", lr), E(t, "}", cr), E(t, "[", Zo), E(t, "]", Jo), E(t, "(", Go), E(t, ")", Yo), E(t, "<", Xo), E(t, ">", Qo), E(t, "（", es), E(t, "）", ts), E(t, "「", ns), E(t, "」", is), E(t, "『", rs), E(t, "』", ss), E(t, "＜", as), E(t, "＞", ls), E(t, "&", cs), E(t, "*", ds), E(t, "@", xn), E(t, "`", fs), E(t, "^", ps), E(t, ":", Cn), E(t, ",", gc), E(t, "$", ms), E(t, ".", Dt), E(t, "=", gs), E(t, "!", _c), E(t, "-", gt), E(t, "%", ur), E(t, "|", _s), E(t, "+", bs), E(t, "#", ks), E(t, "?", dr), E(t, '"', bc), E(t, "/", Rt), E(t, ";", kc), E(t, "~", hr), E(t, "_", ys), E(t, "\\", hs), E(t, "・", Zz);
  const i = ve(t, Qt, pc, {
    [bl]: !0
  });
  ve(i, Qt, i);
  const r = ve(i, Xt, Wz, {
    [ar]: !0
  }), o = ve(i, Ki, Kz, {
    [Xi]: !0
  }), s = ve(t, Xt, tn, {
    [kl]: !0
  });
  ve(s, Qt, r), ve(s, Xt, s), ve(r, Qt, r), ve(r, Xt, r);
  const a = ve(t, Ki, xl, {
    [yl]: !0
  });
  ve(a, Xt), ve(a, Qt, o), ve(a, Ki, a), ve(o, Qt, o), ve(o, Xt), ve(o, Ki, o);
  const l = E(t, Ea, mc, {
    [Ca]: !0
  }), c = E(t, wd, Cl, {
    [Ca]: !0
  }), u = ve(t, Ma, Cl, {
    [Ca]: !0
  });
  E(t, $a, u), E(c, Ea, l), E(c, $a, u), ve(c, Ma, u), E(u, wd), E(u, Ea), ve(u, Ma, u), E(u, $a, u);
  const d = ve(t, Ta, Jz, {
    [Uz]: !0
  });
  E(d, "#"), ve(d, Ta, d), E(d, DI, d);
  const h = E(d, RI);
  E(h, "#"), ve(h, Ta, d);
  const f = [[Xt, s], [Qt, r]], p = [[Xt, null], [Ki, a], [Qt, o]];
  for (let m = 0; m < no.length; m++)
    kn(t, no[m], Sl, tn, f);
  for (let m = 0; m < io.length; m++)
    kn(t, io[m], wl, xl, p);
  ti(Sl, {
    tld: !0,
    ascii: !0
  }, e), ti(wl, {
    utld: !0,
    alpha: !0
  }, e), kn(t, "file", yo, tn, f), kn(t, "mailto", yo, tn, f), kn(t, "http", $i, tn, f), kn(t, "https", $i, tn, f), kn(t, "ftp", $i, tn, f), kn(t, "ftps", $i, tn, f), ti(yo, {
    scheme: !0,
    ascii: !0
  }, e), ti($i, {
    slashscheme: !0,
    ascii: !0
  }, e), n = n.sort((m, g) => m[0] > g[0] ? 1 : -1);
  for (let m = 0; m < n.length; m++) {
    const g = n[m][0], x = n[m][1] ? {
      [zI]: !0
    } : {
      [AI]: !0
    };
    g.indexOf("-") >= 0 ? x[vl] = !0 : Xt.test(g) ? Qt.test(g) ? x[ar] = !0 : x[kl] = !0 : x[bl] = !0, Sd(t, g, g, x);
  }
  return Sd(t, "localhost", Nr, {
    ascii: !0
  }), t.jd = new rt(vs), {
    start: t,
    tokens: Object.assign({
      groups: e
    }, Gz)
  };
}
function Yz(n, e) {
  const t = PI(e.replace(/[A-Z]/g, (a) => a.toLowerCase())), i = t.length, r = [];
  let o = 0, s = 0;
  for (; s < i; ) {
    let a = n, l = null, c = 0, u = null, d = -1, h = -1;
    for (; s < i && (l = a.go(t[s])); )
      a = l, a.accepts() ? (d = 0, h = 0, u = a) : d >= 0 && (d += t[s].length, h++), c += t[s].length, o += t[s].length, s++;
    o -= d, s -= h, c -= d, r.push({
      t: u.t,
      // token type/name
      v: e.slice(o - c, o),
      // string value
      s: o - c,
      // start index
      e: o
      // end index (excluding)
    });
  }
  return r;
}
function PI(n) {
  const e = [], t = n.length;
  let i = 0;
  for (; i < t; ) {
    let r = n.charCodeAt(i), o, s = r < 55296 || r > 56319 || i + 1 === t || (o = n.charCodeAt(i + 1)) < 56320 || o > 57343 ? n[i] : n.slice(i, i + 2);
    e.push(s), i += s.length;
  }
  return e;
}
function kn(n, e, t, i, r) {
  let o;
  const s = e.length;
  for (let a = 0; a < s - 1; a++) {
    const l = e[a];
    n.j[l] ? o = n.j[l] : (o = new rt(i), o.jr = r.slice(), n.j[l] = o), n = o;
  }
  return o = new rt(t), o.jr = r.slice(), n.j[e[s - 1]] = o, o;
}
function Cd(n) {
  const e = [], t = [];
  let i = 0, r = "0123456789";
  for (; i < n.length; ) {
    let o = 0;
    for (; r.indexOf(n[i + o]) >= 0; )
      o++;
    if (o > 0) {
      e.push(t.join(""));
      for (let s = parseInt(n.substring(i, i + o), 10); s > 0; s--)
        t.pop();
      i += o;
    } else
      t.push(n[i]), i++;
  }
  return e;
}
const Lr = {
  defaultProtocol: "http",
  events: null,
  format: Td,
  formatHref: Td,
  nl2br: !1,
  tagName: "a",
  target: null,
  rel: null,
  validate: !0,
  truncate: 1 / 0,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function yc(n, e = null) {
  let t = Object.assign({}, Lr);
  n && (t = Object.assign(t, n instanceof yc ? n.o : n));
  const i = t.ignoreTags, r = [];
  for (let o = 0; o < i.length; o++)
    r.push(i[o].toUpperCase());
  this.o = t, e && (this.defaultRender = e), this.ignoreTags = r;
}
yc.prototype = {
  o: Lr,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(n) {
    return n;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(n) {
    return this.get("validate", n.toString(), n);
  },
  // Private methods
  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(n, e, t) {
    const i = e != null;
    let r = this.o[n];
    return r && (typeof r == "object" ? (r = t.t in r ? r[t.t] : Lr[n], typeof r == "function" && i && (r = r(e, t))) : typeof r == "function" && i && (r = r(e, t.t, t)), r);
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(n, e, t) {
    let i = this.o[n];
    return typeof i == "function" && e != null && (i = i(e, t.t, t)), i;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(n) {
    const e = n.render(this);
    return (this.get("render", null, n) || this.defaultRender)(e, n.t, n);
  }
};
function Td(n) {
  return n;
}
function Xz(n, e) {
  this.t = "token", this.v = n, this.tk = e;
}
Xz.prototype = {
  isLink: !1,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
   */
  toHref(n) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(n) {
    const e = this.toString(), t = n.get("truncate", e, this), i = n.get("format", e, this);
    return t && i.length > t ? i.substring(0, t) + "…" : i;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(n) {
    return n.get("formatHref", this.toHref(n.get("defaultProtocol")), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(n = Lr.defaultProtocol) {
    return {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(n),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(n) {
    return {
      type: this.t,
      value: this.toFormattedString(n),
      isLink: this.isLink,
      href: this.toFormattedHref(n),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(n) {
    return n.get("validate", this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(n) {
    const e = this, t = this.toHref(n.get("defaultProtocol")), i = n.get("formatHref", t, this), r = n.get("tagName", t, e), o = this.toFormattedString(n), s = {}, a = n.get("className", t, e), l = n.get("target", t, e), c = n.get("rel", t, e), u = n.getObj("attributes", t, e), d = n.getObj("events", t, e);
    return s.href = i, a && (s.class = a), l && (s.target = l), c && (s.rel = c), u && Object.assign(s, u), {
      tagName: r,
      attributes: s,
      content: o,
      eventListeners: d
    };
  }
};
function Us(n, e) {
  class t extends Xz {
    constructor(r, o) {
      super(r, o), this.t = n;
    }
  }
  for (const i in e)
    t.prototype[i] = e[i];
  return t.t = n, t;
}
const Md = Us("email", {
  isLink: !0,
  toHref() {
    return "mailto:" + this.toString();
  }
}), Ed = Us("text"), jI = Us("nl"), ro = Us("url", {
  isLink: !0,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(n = Lr.defaultProtocol) {
    return this.hasProtocol() ? this.v : `${n}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const n = this.tk;
    return n.length >= 2 && n[0].t !== Nr && n[1].t === Cn;
  }
}), mt = (n) => new rt(n);
function BI({
  groups: n
}) {
  const e = n.domain.concat([cs, ds, xn, hs, fs, ps, ms, gs, gt, pc, ur, _s, bs, ks, Rt, vs, hr, ys]), t = [us, Cn, gc, Dt, _c, ur, dr, bc, kc, Xo, Qo, lr, cr, Jo, Zo, Go, Yo, es, ts, ns, is, rs, ss, as, ls], i = [cs, us, ds, hs, fs, ps, ms, gs, gt, lr, cr, ur, _s, bs, ks, dr, Rt, vs, hr, ys], r = mt(), o = E(r, hr);
  J(o, i, o), J(o, n.domain, o);
  const s = mt(), a = mt(), l = mt();
  J(r, n.domain, s), J(r, n.scheme, a), J(r, n.slashscheme, l), J(s, i, o), J(s, n.domain, s);
  const c = E(s, xn);
  E(o, xn, c), E(a, xn, c), E(l, xn, c);
  const u = E(o, Dt);
  J(u, i, o), J(u, n.domain, o);
  const d = mt();
  J(c, n.domain, d), J(d, n.domain, d);
  const h = E(d, Dt);
  J(h, n.domain, d);
  const f = mt(Md);
  J(h, n.tld, f), J(h, n.utld, f), E(c, Nr, f);
  const p = E(d, gt);
  E(p, gt, p), J(p, n.domain, d), J(f, n.domain, d), E(f, Dt, h), E(f, gt, p);
  const m = E(f, Cn);
  J(m, n.numeric, Md);
  const g = E(s, gt), k = E(s, Dt);
  E(g, gt, g), J(g, n.domain, s), J(k, i, o), J(k, n.domain, s);
  const x = mt(ro);
  J(k, n.tld, x), J(k, n.utld, x), J(x, n.domain, s), J(x, i, o), E(x, Dt, k), E(x, gt, g), E(x, xn, c);
  const S = E(x, Cn), _ = mt(ro);
  J(S, n.numeric, _);
  const v = mt(ro), y = mt();
  J(v, e, v), J(v, t, y), J(y, e, v), J(y, t, y), E(x, Rt, v), E(_, Rt, v);
  const w = E(a, Cn), $ = E(l, Cn), A = E($, Rt), z = E(A, Rt);
  J(a, n.domain, s), E(a, Dt, k), E(a, gt, g), J(l, n.domain, s), E(l, Dt, k), E(l, gt, g), J(w, n.domain, v), E(w, Rt, v), E(w, dr, v), J(z, n.domain, v), J(z, e, v), E(z, Rt, v);
  const N = [
    [lr, cr],
    // {}
    [Zo, Jo],
    // []
    [Go, Yo],
    // ()
    [Xo, Qo],
    // <>
    [es, ts],
    // （）
    [ns, is],
    // 「」
    [rs, ss],
    // 『』
    [as, ls]
    // ＜＞
  ];
  for (let D = 0; D < N.length; D++) {
    const [j, U] = N[D], Y = E(v, j);
    E(y, j, Y), E(Y, U, v);
    const B = mt(ro);
    J(Y, e, B);
    const K = mt();
    J(Y, t), J(B, e, B), J(B, t, K), J(K, e, B), J(K, t, K), E(B, U, v), E(K, U, v);
  }
  return E(r, Nr, x), E(r, mc, jI), {
    start: r,
    tokens: Gz
  };
}
function FI(n, e, t) {
  let i = t.length, r = 0, o = [], s = [];
  for (; r < i; ) {
    let a = n, l = null, c = null, u = 0, d = null, h = -1;
    for (; r < i && !(l = a.go(t[r].t)); )
      s.push(t[r++]);
    for (; r < i && (c = l || a.go(t[r].t)); )
      l = null, a = c, a.accepts() ? (h = 0, d = a) : h >= 0 && h++, r++, u++;
    if (h < 0)
      r -= u, r < i && (s.push(t[r]), r++);
    else {
      s.length > 0 && (o.push(Oa(Ed, e, s)), s = []), r -= h, u -= h;
      const f = d.t, p = t.slice(r - u, r);
      o.push(Oa(f, e, p));
    }
  }
  return s.length > 0 && o.push(Oa(Ed, e, s)), o;
}
function Oa(n, e, t) {
  const i = t[0].s, r = t[t.length - 1].e, o = e.slice(i, r);
  return new n(o, t);
}
const qI = typeof console < "u" && console && console.warn || (() => {
}), HI = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.", ge = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: !1
};
function VI() {
  return rt.groups = {}, ge.scanner = null, ge.parser = null, ge.tokenQueue = [], ge.pluginQueue = [], ge.customSchemes = [], ge.initialized = !1, ge;
}
function $d(n, e = !1) {
  if (ge.initialized && qI(`linkifyjs: already initialized - will not register custom scheme "${n}" ${HI}`), !/^[0-9a-z]+(-[0-9a-z]+)*$/.test(n))
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  ge.customSchemes.push([n, e]);
}
function UI() {
  ge.scanner = II(ge.customSchemes);
  for (let n = 0; n < ge.tokenQueue.length; n++)
    ge.tokenQueue[n][1]({
      scanner: ge.scanner
    });
  ge.parser = BI(ge.scanner.tokens);
  for (let n = 0; n < ge.pluginQueue.length; n++)
    ge.pluginQueue[n][1]({
      scanner: ge.scanner,
      parser: ge.parser
    });
  return ge.initialized = !0, ge;
}
function vc(n) {
  return ge.initialized || UI(), FI(ge.parser.start, n, Yz(ge.scanner.start, n));
}
vc.scan = Yz;
function Qz(n, e = null, t = null) {
  if (e && typeof e == "object") {
    if (t)
      throw Error(`linkifyjs: Invalid link type ${e}; must be a string`);
    t = e, e = null;
  }
  const i = new yc(t), r = vc(n), o = [];
  for (let s = 0; s < r.length; s++) {
    const a = r[s];
    a.isLink && (!e || a.t === e) && i.check(a) && o.push(a.toFormattedObject(i));
  }
  return o;
}
function WI(n) {
  return n.length === 1 ? n[0].isLink : n.length === 3 && n[1].isLink ? ["()", "[]"].includes(n[0].value + n[2].value) : !1;
}
function KI(n) {
  return new Ee({
    key: new Ue("autolink"),
    appendTransaction: (e, t, i) => {
      const r = e.some((c) => c.docChanged) && !t.doc.eq(i.doc), o = e.some((c) => c.getMeta("preventAutolink"));
      if (!r || o)
        return;
      const { tr: s } = i, a = X6(t.doc, [...e]);
      if (a5(a).forEach(({ newRange: c }) => {
        const u = yp(i.doc, c, (f) => f.isTextblock);
        let d, h;
        if (u.length > 1 ? (d = u[0], h = i.doc.textBetween(d.pos, d.pos + d.node.nodeSize, void 0, " ")) : u.length && i.doc.textBetween(c.from, c.to, " ", " ").endsWith(" ") && (d = u[0], h = i.doc.textBetween(d.pos, c.to, void 0, " ")), d && h) {
          const f = h.split(" ").filter((k) => k !== "");
          if (f.length <= 0)
            return !1;
          const p = f[f.length - 1], m = d.pos + h.lastIndexOf(p);
          if (!p)
            return !1;
          const g = vc(p).map((k) => k.toObject(n.defaultProtocol));
          if (!WI(g))
            return !1;
          g.filter((k) => k.isLink).map((k) => ({
            ...k,
            from: m + k.start + 1,
            to: m + k.end + 1
          })).filter((k) => i.schema.marks.code ? !i.doc.rangeHasMark(k.from, k.to, i.schema.marks.code) : !0).filter((k) => n.validate(k.value)).filter((k) => n.shouldAutoLink(k.value)).forEach((k) => {
            tc(k.from, k.to, i.doc).some((x) => x.mark.type === n.type) || s.addMark(k.from, k.to, n.type.create({
              href: k.href
            }));
          });
        }
      }), !!s.steps.length)
        return s;
    }
  });
}
function ZI(n) {
  return new Ee({
    key: new Ue("handleClickLink"),
    props: {
      handleClick: (e, t, i) => {
        var r, o;
        if (i.button !== 0 || !e.editable)
          return !1;
        let s = i.target;
        const a = [];
        for (; s.nodeName !== "DIV"; )
          a.push(s), s = s.parentNode;
        if (!a.find((h) => h.nodeName === "A"))
          return !1;
        const l = vp(e.state, n.type.name), c = i.target, u = (r = c == null ? void 0 : c.href) !== null && r !== void 0 ? r : l.href, d = (o = c == null ? void 0 : c.target) !== null && o !== void 0 ? o : l.target;
        return c && u ? (window.open(u, d), !0) : !1;
      }
    }
  });
}
function JI(n) {
  return new Ee({
    key: new Ue("handlePasteLink"),
    props: {
      handlePaste: (e, t, i) => {
        const { state: r } = e, { selection: o } = r, { empty: s } = o;
        if (s)
          return !1;
        let a = "";
        i.content.forEach((c) => {
          a += c.textContent;
        });
        const l = Qz(a, { defaultProtocol: n.defaultProtocol }).find((c) => c.isLink && c.value === a);
        return !a || !l ? !1 : n.editor.commands.setMark(n.type, {
          href: l.href
        });
      }
    }
  });
}
const GI = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g;
function Kn(n, e) {
  const t = [
    "http",
    "https",
    "ftp",
    "ftps",
    "mailto",
    "tel",
    "callto",
    "sms",
    "cid",
    "xmpp"
  ];
  return e && e.forEach((i) => {
    const r = typeof i == "string" ? i : i.scheme;
    r && t.push(r);
  }), !n || n.replace(GI, "").match(new RegExp(
    // eslint-disable-next-line no-useless-escape
    `^(?:(?:${t.join("|")}):|[^a-z]|[a-z0-9+.-]+(?:[^a-z+.-:]|$))`,
    "i"
  ));
}
const YI = Wt.create({
  name: "link",
  priority: 1e3,
  keepOnSplit: !1,
  exitable: !0,
  onCreate() {
    this.options.validate && !this.options.shouldAutoLink && (this.options.shouldAutoLink = this.options.validate, console.warn("The `validate` option is deprecated. Rename to the `shouldAutoLink` option instead.")), this.options.protocols.forEach((n) => {
      if (typeof n == "string") {
        $d(n);
        return;
      }
      $d(n.scheme, n.optionalSlashes);
    });
  },
  onDestroy() {
    VI();
  },
  inclusive() {
    return this.options.autolink;
  },
  addOptions() {
    return {
      openOnClick: !0,
      linkOnPaste: !0,
      autolink: !0,
      protocols: [],
      defaultProtocol: "http",
      HTMLAttributes: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
        class: null
      },
      isAllowedUri: (n, e) => !!Kn(n, e.protocols),
      validate: (n) => !!n,
      shouldAutoLink: (n) => !!n
    };
  },
  addAttributes() {
    return {
      href: {
        default: null,
        parseHTML(n) {
          return n.getAttribute("href");
        }
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      class: {
        default: this.options.HTMLAttributes.class
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "a[href]",
        getAttrs: (n) => {
          const e = n.getAttribute("href");
          return !e || !this.options.isAllowedUri(e, {
            defaultValidate: (t) => !!Kn(t, this.options.protocols),
            protocols: this.options.protocols,
            defaultProtocol: this.options.defaultProtocol
          }) ? !1 : null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return this.options.isAllowedUri(n.href, {
      defaultValidate: (e) => !!Kn(e, this.options.protocols),
      protocols: this.options.protocols,
      defaultProtocol: this.options.defaultProtocol
    }) ? ["a", ke(this.options.HTMLAttributes, n), 0] : [
      "a",
      ke(this.options.HTMLAttributes, { ...n, href: "" }),
      0
    ];
  },
  addCommands() {
    return {
      setLink: (n) => ({ chain: e }) => {
        const { href: t } = n;
        return this.options.isAllowedUri(t, {
          defaultValidate: (i) => !!Kn(i, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? e().setMark(this.name, n).setMeta("preventAutolink", !0).run() : !1;
      },
      toggleLink: (n) => ({ chain: e }) => {
        const { href: t } = n;
        return this.options.isAllowedUri(t, {
          defaultValidate: (i) => !!Kn(i, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? e().toggleMark(this.name, n, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run() : !1;
      },
      unsetLink: () => ({ chain: n }) => n().unsetMark(this.name, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run()
    };
  },
  addPasteRules() {
    return [
      Ii({
        find: (n) => {
          const e = [];
          if (n) {
            const { protocols: t, defaultProtocol: i } = this.options, r = Qz(n).filter((o) => o.isLink && this.options.isAllowedUri(o.value, {
              defaultValidate: (s) => !!Kn(s, t),
              protocols: t,
              defaultProtocol: i
            }));
            r.length && r.forEach((o) => e.push({
              text: o.value,
              data: {
                href: o.href
              },
              index: o.start
            }));
          }
          return e;
        },
        type: this.type,
        getAttributes: (n) => {
          var e;
          return {
            href: (e = n.data) === null || e === void 0 ? void 0 : e.href
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const n = [], { protocols: e, defaultProtocol: t } = this.options;
    return this.options.autolink && n.push(KI({
      type: this.type,
      defaultProtocol: this.options.defaultProtocol,
      validate: (i) => this.options.isAllowedUri(i, {
        defaultValidate: (r) => !!Kn(r, e),
        protocols: e,
        defaultProtocol: t
      }),
      shouldAutoLink: this.options.shouldAutoLink
    })), this.options.openOnClick === !0 && n.push(ZI({
      type: this.type
    })), this.options.linkOnPaste && n.push(JI({
      editor: this.editor,
      defaultProtocol: this.options.defaultProtocol,
      type: this.type
    })), n;
  }
}), $t = (n) => Object.entries(n).map(([e, t]) => `${e.replace(/([A-Z])/g, "-$1").toLowerCase()}: ${t}`).join("; "), Od = (n) => YI.extend({
  addAttributes() {
    var e;
    return {
      ...(e = this.parent) == null ? void 0 : e.call(this),
      color: {
        default: (n == null ? void 0 : n.color) ?? "rgb(17 85 204)"
      }
    };
  },
  renderHTML({ HTMLAttributes: e, mark: t }) {
    const r = {
      color: t.attrs.color,
      textDecorationLine: "underline"
    };
    return [
      "a",
      ke(e, {
        style: $t(r)
      }),
      0
    ];
  }
}), XI = (n, e) => {
  const { state: t } = n, i = t.tr;
  let r = !1;
  t.doc.descendants((o, s) => {
    const a = s + o.nodeSize;
    o.marks.forEach((l) => {
      if (l.type.name === "link") {
        const c = l.type.create({
          ...l.attrs,
          color: e
        });
        i.removeMark(s, a, l.type).addMark(s, a, c), r = !0;
      }
    });
  }), r && n.view.dispatch(i);
}, QI = (n, e) => {
  Je(() => {
    !n || !(e != null && e.color) || XI(n, e.color);
  }, [e == null ? void 0 : e.color]);
}, eP = 300, za = (n, e) => {
  n.state.doc.descendants((t, i) => {
    var r;
    return t.type.name === ze.Block && ((r = t.attrs.uploadingProps) == null ? void 0 : r.id) === e ? (n.dispatch(n.state.tr.delete(i, i + t.nodeSize).setMeta("addToHistory", !1)), !1) : !0;
  });
}, zd = (n) => {
  var t;
  return ((t = n.split("/").pop()) == null ? void 0 : t.split("?")[0]) || "image";
}, Ad = (n, e) => {
  if (/\.\w+$/.test(n)) return n;
  const t = e.split("/")[1] || "png";
  return `${n}.${t}`;
}, eA = (n) => n.startsWith("file:///"), tP = async (n) => {
  if (eA(n))
    return null;
  const e = "image/png";
  try {
    const t = await fetch(n);
    if (!t.ok) throw new Error("Failed to fetch image");
    const i = await t.blob(), r = i.type || e, o = Ad(zd(n), r);
    return new File([i], o, { type: r });
  } catch {
    try {
      const t = new Image();
      t.crossOrigin = "anonymous", await new Promise((r, o) => {
        t.onload = r, t.onerror = o, t.src = n;
      });
      const i = Ad(zd(n), e);
      return await NA(t, i, e);
    } catch {
      return null;
    }
  }
}, nP = (n) => {
  const { startUploading: e } = AA({
    source: n
  }), t = async (s, a, l) => {
    try {
      const c = await e(s);
      if (!c) {
        po.error(O.t("global.error")), za(l, a);
        return;
      }
      l.state.doc.descendants((u, d) => {
        var f;
        if ((u.type.name === ze.Block || u.type.name === ze.Inline) && ((f = u.attrs.uploadingProps) == null ? void 0 : f.id) === a) {
          const p = {
            ...u.attrs,
            src: c.path,
            uploadingProps: null
          };
          return l.dispatch(
            l.state.tr.setNodeMarkup(d, null, p).setMeta("addToHistory", !1)
          ), !1;
        }
        return !0;
      });
    } catch {
      po.error(O.t("global.error")), za(l, a);
    }
  }, i = async (s, a, l) => {
    if (s.length === 0) return;
    const c = s.map(async (p) => {
      const m = crypto.randomUUID(), g = URL.createObjectURL(p), k = new Image();
      return k.src = g, await new Promise((x) => {
        k.onload = () => x();
      }), { file: p, id: m, src: g, width: k.naturalWidth, height: k.naturalHeight };
    }), u = await Promise.all(c), { schema: d } = a.state;
    let h = a.state.tr, f = 0;
    u.forEach(({ id: p, src: m, width: g, height: k }) => {
      const x = d.nodes[ze.Block].create({
        src: m,
        width: g,
        height: k,
        containerWidth: "auto",
        imageMode: ce.BlockCenter,
        uploadingProps: { isUploading: !0, id: p }
      });
      h = h.insert(l + f, x), f += x.nodeSize;
    }), a.dispatch(h), u.forEach(({ file: p, id: m }) => {
      t(p, m, a);
    });
  };
  return { onDrop: (s, a) => {
    if (!a.dataTransfer) return;
    const l = Array.from(a.dataTransfer.files).filter(
      (u) => Cc(u.type, Tc.image)
    );
    if (l.length === 0) return !1;
    a.preventDefault();
    const c = s.posAtCoords({ left: a.clientX, top: a.clientY });
    return i(l, s, (c == null ? void 0 : c.pos) ?? 1), !0;
  }, onPaste: (s, a) => {
    if (!a.clipboardData) return;
    const { clipboardData: l } = a, { selection: c } = s.state, { from: u } = c, d = Array.from(l.files).filter(
      (p) => Cc(p.type, Tc.image)
    );
    if (d.length > 0)
      return a.preventDefault(), i(d, s, u), !0;
    const h = l.getData("text/html");
    return h && h.includes("<img") && setTimeout(() => {
      const p = [];
      s.state.doc.descendants((m, g) => {
        var _;
        const k = m.type.name === ze.Block || m.type.name === ze.Inline, x = (_ = m.attrs) == null ? void 0 : _.src;
        if (!x || !k || m.attrs.uploadingProps) return !0;
        if (eA(x)) {
          const v = s.state.tr.delete(g, g + m.nodeSize);
          return s.dispatch(v), !0;
        }
        const S = crypto.randomUUID();
        return p.push({ pos: g, src: x, id: S }), !0;
      }), p.length !== 0 && (p.forEach(({ pos: m, id: g }) => {
        const k = s.state.doc.nodeAt(m);
        if (!k) return;
        const x = {
          ...k.attrs,
          uploadingProps: { isUploading: !0, id: g }
        };
        s.dispatch(
          s.state.tr.setNodeMarkup(m, null, x).setMeta("addToHistory", !1)
        );
      }), p.forEach(async ({ id: m, src: g }) => {
        const k = await tP(g);
        if (!k) {
          po.error(O.t("global.error")), za(s, m);
          return;
        }
        t(k, m, s);
      }));
    }, eP), !1;
  } };
}, iP = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, rP = /[\0-\x1F\x7F-\x9F]/, oP = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/, sP = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;
function aP(n) {
  const e = {};
  n = n || {}, e.src_Any = iP.source, e.src_Cc = rP.source, e.src_Z = sP.source, e.src_P = oP.source, e.src_ZPCc = [e.src_Z, e.src_P, e.src_Cc].join("|"), e.src_ZCc = [e.src_Z, e.src_Cc].join("|");
  const t = "[><｜]";
  return e.src_pseudo_letter = "(?:(?!" + t + "|" + e.src_ZPCc + ")" + e.src_Any + ")", e.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)", e.src_auth = "(?:(?:(?!" + e.src_ZCc + "|[@/\\[\\]()]).)+@)?", e.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?", e.src_host_terminator = "(?=$|" + t + "|" + e.src_ZPCc + ")(?!" + (n["---"] ? "-(?!--)|" : "-|") + "_|:\\d|\\.-|\\.(?!$|" + e.src_ZPCc + "))", e.src_path = "(?:[/?#](?:(?!" + e.src_ZCc + "|" + t + `|[()[\\]{}.,"'?!\\-;]).|\\[(?:(?!` + e.src_ZCc + "|\\]).)*\\]|\\((?:(?!" + e.src_ZCc + "|[)]).)*\\)|\\{(?:(?!" + e.src_ZCc + '|[}]).)*\\}|\\"(?:(?!' + e.src_ZCc + `|["]).)+\\"|\\'(?:(?!` + e.src_ZCc + "|[']).)+\\'|\\'(?=" + e.src_pseudo_letter + "|[-])|\\.{2,}[a-zA-Z0-9%/&]|\\.(?!" + e.src_ZCc + "|[.]|$)|" + (n["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" : "\\-+|") + // allow `,,,` in paths
  ",(?!" + e.src_ZCc + "|$)|;(?!" + e.src_ZCc + "|$)|\\!+(?!" + e.src_ZCc + "|[!]|$)|\\?(?!" + e.src_ZCc + "|[?]|$))+|\\/)?", e.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*', e.src_xn = "xn--[a-z0-9\\-]{1,59}", e.src_domain_root = // Allow letters & digits (http://test1)
  "(?:" + e.src_xn + "|" + e.src_pseudo_letter + "{1,63})", e.src_domain = "(?:" + e.src_xn + "|(?:" + e.src_pseudo_letter + ")|(?:" + e.src_pseudo_letter + "(?:-|" + e.src_pseudo_letter + "){0,61}" + e.src_pseudo_letter + "))", e.src_host = "(?:(?:(?:(?:" + e.src_domain + ")\\.)*" + e.src_domain + "))", e.tpl_host_fuzzy = "(?:" + e.src_ip4 + "|(?:(?:(?:" + e.src_domain + ")\\.)+(?:%TLDS%)))", e.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + e.src_domain + ")\\.)+(?:%TLDS%))", e.src_host_strict = e.src_host + e.src_host_terminator, e.tpl_host_fuzzy_strict = e.tpl_host_fuzzy + e.src_host_terminator, e.src_host_port_strict = e.src_host + e.src_port + e.src_host_terminator, e.tpl_host_port_fuzzy_strict = e.tpl_host_fuzzy + e.src_port + e.src_host_terminator, e.tpl_host_port_no_ip_fuzzy_strict = e.tpl_host_no_ip_fuzzy + e.src_port + e.src_host_terminator, e.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + e.src_ZPCc + "|>|$))", e.tpl_email_fuzzy = "(^|" + t + '|"|\\(|' + e.src_ZCc + ")(" + e.src_email_name + "@" + e.tpl_host_fuzzy_strict + ")", e.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
  // but can start with > (markdown blockquote)
  "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + e.src_ZPCc + "))((?![$+<=>^`|｜])" + e.tpl_host_port_fuzzy_strict + e.src_path + ")", e.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
  // but can start with > (markdown blockquote)
  "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + e.src_ZPCc + "))((?![$+<=>^`|｜])" + e.tpl_host_port_no_ip_fuzzy_strict + e.src_path + ")", e;
}
function Tl(n) {
  return Array.prototype.slice.call(arguments, 1).forEach(function(t) {
    t && Object.keys(t).forEach(function(i) {
      n[i] = t[i];
    });
  }), n;
}
function Ws(n) {
  return Object.prototype.toString.call(n);
}
function lP(n) {
  return Ws(n) === "[object String]";
}
function cP(n) {
  return Ws(n) === "[object Object]";
}
function uP(n) {
  return Ws(n) === "[object RegExp]";
}
function Nd(n) {
  return Ws(n) === "[object Function]";
}
function dP(n) {
  return n.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
const tA = {
  fuzzyLink: !0,
  fuzzyEmail: !0,
  fuzzyIP: !1
};
function hP(n) {
  return Object.keys(n || {}).reduce(function(e, t) {
    return e || tA.hasOwnProperty(t);
  }, !1);
}
const fP = {
  "http:": {
    validate: function(n, e, t) {
      const i = n.slice(e);
      return t.re.http || (t.re.http = new RegExp(
        "^\\/\\/" + t.re.src_auth + t.re.src_host_port_strict + t.re.src_path,
        "i"
      )), t.re.http.test(i) ? i.match(t.re.http)[0].length : 0;
    }
  },
  "https:": "http:",
  "ftp:": "http:",
  "//": {
    validate: function(n, e, t) {
      const i = n.slice(e);
      return t.re.no_http || (t.re.no_http = new RegExp(
        "^" + t.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
        // with code comments
        "(?:localhost|(?:(?:" + t.re.src_domain + ")\\.)+" + t.re.src_domain_root + ")" + t.re.src_port + t.re.src_host_terminator + t.re.src_path,
        "i"
      )), t.re.no_http.test(i) ? e >= 3 && n[e - 3] === ":" || e >= 3 && n[e - 3] === "/" ? 0 : i.match(t.re.no_http)[0].length : 0;
    }
  },
  "mailto:": {
    validate: function(n, e, t) {
      const i = n.slice(e);
      return t.re.mailto || (t.re.mailto = new RegExp(
        "^" + t.re.src_email_name + "@" + t.re.src_host_strict,
        "i"
      )), t.re.mailto.test(i) ? i.match(t.re.mailto)[0].length : 0;
    }
  }
}, pP = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]", mP = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф".split("|");
function gP(n) {
  n.__index__ = -1, n.__text_cache__ = "";
}
function _P(n) {
  return function(e, t) {
    const i = e.slice(t);
    return n.test(i) ? i.match(n)[0].length : 0;
  };
}
function Ld() {
  return function(n, e) {
    e.normalize(n);
  };
}
function xs(n) {
  const e = n.re = aP(n.__opts__), t = n.__tlds__.slice();
  n.onCompile(), n.__tlds_replaced__ || t.push(pP), t.push(e.src_xn), e.src_tlds = t.join("|");
  function i(a) {
    return a.replace("%TLDS%", e.src_tlds);
  }
  e.email_fuzzy = RegExp(i(e.tpl_email_fuzzy), "i"), e.link_fuzzy = RegExp(i(e.tpl_link_fuzzy), "i"), e.link_no_ip_fuzzy = RegExp(i(e.tpl_link_no_ip_fuzzy), "i"), e.host_fuzzy_test = RegExp(i(e.tpl_host_fuzzy_test), "i");
  const r = [];
  n.__compiled__ = {};
  function o(a, l) {
    throw new Error('(LinkifyIt) Invalid schema "' + a + '": ' + l);
  }
  Object.keys(n.__schemas__).forEach(function(a) {
    const l = n.__schemas__[a];
    if (l === null)
      return;
    const c = { validate: null, link: null };
    if (n.__compiled__[a] = c, cP(l)) {
      uP(l.validate) ? c.validate = _P(l.validate) : Nd(l.validate) ? c.validate = l.validate : o(a, l), Nd(l.normalize) ? c.normalize = l.normalize : l.normalize ? o(a, l) : c.normalize = Ld();
      return;
    }
    if (lP(l)) {
      r.push(a);
      return;
    }
    o(a, l);
  }), r.forEach(function(a) {
    n.__compiled__[n.__schemas__[a]] && (n.__compiled__[a].validate = n.__compiled__[n.__schemas__[a]].validate, n.__compiled__[a].normalize = n.__compiled__[n.__schemas__[a]].normalize);
  }), n.__compiled__[""] = { validate: null, normalize: Ld() };
  const s = Object.keys(n.__compiled__).filter(function(a) {
    return a.length > 0 && n.__compiled__[a];
  }).map(dP).join("|");
  n.re.schema_test = RegExp("(^|(?!_)(?:[><｜]|" + e.src_ZPCc + "))(" + s + ")", "i"), n.re.schema_search = RegExp("(^|(?!_)(?:[><｜]|" + e.src_ZPCc + "))(" + s + ")", "ig"), n.re.schema_at_start = RegExp("^" + n.re.schema_search.source, "i"), n.re.pretest = RegExp(
    "(" + n.re.schema_test.source + ")|(" + n.re.host_fuzzy_test.source + ")|@",
    "i"
  ), gP(n);
}
function bP(n, e) {
  const t = n.__index__, i = n.__last_index__, r = n.__text_cache__.slice(t, i);
  this.schema = n.__schema__.toLowerCase(), this.index = t + e, this.lastIndex = i + e, this.raw = r, this.text = r, this.url = r;
}
function Ml(n, e) {
  const t = new bP(n, e);
  return n.__compiled__[t.schema].normalize(t, n), t;
}
function ft(n, e) {
  if (!(this instanceof ft))
    return new ft(n, e);
  e || hP(n) && (e = n, n = {}), this.__opts__ = Tl({}, tA, e), this.__index__ = -1, this.__last_index__ = -1, this.__schema__ = "", this.__text_cache__ = "", this.__schemas__ = Tl({}, fP, n), this.__compiled__ = {}, this.__tlds__ = mP, this.__tlds_replaced__ = !1, this.re = {}, xs(this);
}
ft.prototype.add = function(e, t) {
  return this.__schemas__[e] = t, xs(this), this;
};
ft.prototype.set = function(e) {
  return this.__opts__ = Tl(this.__opts__, e), this;
};
ft.prototype.test = function(e) {
  if (this.__text_cache__ = e, this.__index__ = -1, !e.length)
    return !1;
  let t, i, r, o, s, a, l, c, u;
  if (this.re.schema_test.test(e)) {
    for (l = this.re.schema_search, l.lastIndex = 0; (t = l.exec(e)) !== null; )
      if (o = this.testSchemaAt(e, t[2], l.lastIndex), o) {
        this.__schema__ = t[2], this.__index__ = t.index + t[1].length, this.__last_index__ = t.index + t[0].length + o;
        break;
      }
  }
  return this.__opts__.fuzzyLink && this.__compiled__["http:"] && (c = e.search(this.re.host_fuzzy_test), c >= 0 && (this.__index__ < 0 || c < this.__index__) && (i = e.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null && (s = i.index + i[1].length, (this.__index__ < 0 || s < this.__index__) && (this.__schema__ = "", this.__index__ = s, this.__last_index__ = i.index + i[0].length))), this.__opts__.fuzzyEmail && this.__compiled__["mailto:"] && (u = e.indexOf("@"), u >= 0 && (r = e.match(this.re.email_fuzzy)) !== null && (s = r.index + r[1].length, a = r.index + r[0].length, (this.__index__ < 0 || s < this.__index__ || s === this.__index__ && a > this.__last_index__) && (this.__schema__ = "mailto:", this.__index__ = s, this.__last_index__ = a))), this.__index__ >= 0;
};
ft.prototype.pretest = function(e) {
  return this.re.pretest.test(e);
};
ft.prototype.testSchemaAt = function(e, t, i) {
  return this.__compiled__[t.toLowerCase()] ? this.__compiled__[t.toLowerCase()].validate(e, i, this) : 0;
};
ft.prototype.match = function(e) {
  const t = [];
  let i = 0;
  this.__index__ >= 0 && this.__text_cache__ === e && (t.push(Ml(this, i)), i = this.__last_index__);
  let r = i ? e.slice(i) : e;
  for (; this.test(r); )
    t.push(Ml(this, i)), r = r.slice(this.__last_index__), i += this.__last_index__;
  return t.length ? t : null;
};
ft.prototype.matchAtStart = function(e) {
  if (this.__text_cache__ = e, this.__index__ = -1, !e.length) return null;
  const t = this.re.schema_at_start.exec(e);
  if (!t) return null;
  const i = this.testSchemaAt(e, t[2], t[0].length);
  return i ? (this.__schema__ = t[2], this.__index__ = t.index + t[1].length, this.__last_index__ = t.index + t[0].length + i, Ml(this, 0)) : null;
};
ft.prototype.tlds = function(e, t) {
  return e = Array.isArray(e) ? e : [e], t ? (this.__tlds__ = this.__tlds__.concat(e).sort().filter(function(i, r, o) {
    return i !== o[r - 1];
  }).reverse(), xs(this), this) : (this.__tlds__ = e.slice(), this.__tlds_replaced__ = !0, xs(this), this);
};
ft.prototype.normalize = function(e) {
  e.schema || (e.url = "http://" + e.url), e.schema === "mailto:" && !/^mailto:/i.test(e.url) && (e.url = "mailto:" + e.url);
};
ft.prototype.onCompile = function() {
};
const kP = new ft();
function yP(n) {
  const e = kP.match(n);
  if (!e)
    return {
      type: "doc",
      content: [
        {
          type: "paragraph",
          content: [{ type: "text", text: n }]
        }
      ]
    };
  const t = [];
  let i = 0;
  for (const r of e)
    r.index > i && t.push({
      type: "text",
      text: n.slice(i, r.index)
    }), t.push({
      type: "text",
      text: r.raw,
      marks: [
        {
          type: "link",
          attrs: { href: r.url }
        }
      ]
    }), i = r.lastIndex;
  return i < n.length && t.push({
    type: "text",
    text: n.slice(i)
  }), {
    type: "doc",
    content: t
  };
}
const vP = ({ editor: n, content: e, shouldInitialize: t }) => {
  const i = gr(!1);
  Je(() => {
    !n || !e || i.current || !t || typeof e != "string" || (n.commands.setContent(yP(e)), i.current = !0);
  }, [n, e, t]);
};
function Dd(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "20",
      height: "18",
      viewBox: "0 0 20 18",
      fill: "#ADB0B9",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      children: /* @__PURE__ */ b("path", { d: "M3.99992 0C4.26514 1.26282e-07 4.51942 0.105433 4.70696 0.292969L7.70696 3.29297L7.77532 3.36914C8.09567 3.76191 8.07307 4.34092 7.70696 4.70703C7.34084 5.07315 6.76184 5.09574 6.36907 4.77539L6.29289 4.70703L4.99992 3.41406V14.5859L6.29289 13.293C6.68342 12.9024 7.31643 12.9024 7.70696 13.293C8.09748 13.6835 8.09748 14.3165 7.70696 14.707L4.70696 17.707C4.51942 17.8946 4.26514 18 3.99992 18C3.73471 18 3.48043 17.8946 3.29289 17.707L0.292893 14.707C-0.0976311 14.3165 -0.097631 13.6835 0.292893 13.293C0.659009 12.9269 1.23801 12.9043 1.63078 13.2246L1.70696 13.293L2.99992 14.5859V3.41406L1.70696 4.70703C1.31643 5.09756 0.683418 5.09756 0.292893 4.70703C-0.0976311 4.31651 -0.097631 3.68349 0.292893 3.29297L3.29289 0.292969L3.36614 0.226562C3.54409 0.0807275 3.76783 0 3.99992 0ZM18.9999 14C19.5522 14 19.9999 14.4477 19.9999 15C19.9999 15.5523 19.5522 16 18.9999 16H10.9999C10.4476 16 9.99992 15.5523 9.99992 15C9.99992 14.4477 10.4476 14 10.9999 14H18.9999ZM18.9999 10C19.5522 10 19.9999 10.4477 19.9999 11C19.9999 11.5523 19.5522 12 18.9999 12H10.9999C10.4476 12 9.99992 11.5523 9.99992 11C9.99992 10.4477 10.4476 10 10.9999 10H18.9999ZM18.9999 6C19.5522 6 19.9999 6.44772 19.9999 7C19.9999 7.55228 19.5522 8 18.9999 8H10.9999C10.4476 8 9.99992 7.55228 9.99992 7C9.99992 6.44772 10.4476 6 10.9999 6H18.9999ZM18.9999 2C19.5522 2 19.9999 2.44772 19.9999 3C19.9999 3.55228 19.5522 4 18.9999 4H10.9999C10.4476 4 9.99992 3.55228 9.99992 3C9.99992 2.44772 10.4476 2 10.9999 2H18.9999Z" })
    }
  );
}
const Dr = "extra-spacing", Rd = (n) => n.attrs[Dr], xP = (n, e) => {
  const { from: t, to: i } = (n == null ? void 0 : n.state.selection) || {}, r = Ve(() => {
    if (!n || t === void 0 || i === void 0) return !1;
    if (t === i)
      return n.isActive("paragraph");
    let l = !1;
    return n.state.doc.nodesBetween(t, i, (c) => {
      if (c.type.name === "paragraph")
        return l = !0, !1;
    }), l;
  }, [n, t, i]), o = !(n != null && n.options.editable) || Tt(n) || !r, s = (() => {
    if (!n || t === void 0 || i === void 0) return !1;
    if (t === i) {
      const c = n.state.doc.resolve(t);
      for (let u = c.depth; u >= 0; u--) {
        const d = c.node(u);
        if (d.type.name === "paragraph")
          return Rd(d);
      }
      return !1;
    }
    let l = !1;
    return n.state.doc.nodesBetween(t, i, (c) => {
      if (c.type.name === "paragraph")
        return l = Rd(c), !1;
    }), l;
  })();
  return Ve(() => {
    const l = () => {
      n && n.chain().focus().updateAttributes("paragraph", {
        [Dr]: !s
      }).run();
    };
    return {
      toolbarRender: /* @__PURE__ */ b(
        te,
        {
          disabled: o,
          label: O.t("extra_spacing"),
          ...ie,
          children: /* @__PURE__ */ b(
            ae,
            {
              disabled: o,
              onClick: l,
              className: W(
                s && "bg-brand-primary/10 main-transition-colors"
              ),
              children: /* @__PURE__ */ b(Dd, { className: yd(o) })
            }
          )
        },
        "paragraph-spacing"
      ),
      tooltipRender: /* @__PURE__ */ b(
        te,
        {
          disabled: o,
          label: O.t("extra_spacing"),
          ...ie,
          children: /* @__PURE__ */ P(
            ae,
            {
              disabled: o,
              onClick: l,
              className: W(
                s && "bg-brand-primary/10 main-transition-colors",
                "flex gap-1"
              ),
              children: [
                /* @__PURE__ */ b(Dd, { className: yd(o) }),
                O.t("extra_spacing")
              ]
            }
          )
        },
        "paragraph-spacing"
      )
    };
  }, [n, s, o, e]);
};
var fn = /* @__PURE__ */ ((n) => (n.BulletList = "bulletList", n.OrderedList = "orderedList", n))(fn || {}), He = /* @__PURE__ */ ((n) => (n.Bold = "bold", n.Italic = "italic", n.Underline = "underline", n.Strike = "strike", n))(He || {});
function Zt({ className: n, children: e, disabled: t, open: i }) {
  return /* @__PURE__ */ P(
    "div",
    {
      className: W(
        Rn,
        "main-transition-colors gap-1.5",
        t ? "text-text-secondary" : "text-text-primary hover:text-brand-primary",
        n
      ),
      children: [
        e,
        /* @__PURE__ */ b(
          Ah,
          {
            className: W(
              "transition-transform ease-linear duration-200 ",
              i && "rotate-180",
              t ? "stroke-text-secondary" : "stroke-text-primary "
            )
          }
        )
      ]
    }
  );
}
var xc = /* @__PURE__ */ ((n) => (n.Arial = "Arial, Helvetica, sans-serif", n.ArialBlack = "Arial Black, Gadget, sans-serif", n.Lucida = "Lucida sans unicode,lucida grande,sans-serif", n.Verdana = "verdana,geneva,sans-serif", n.Tahoma = "tahoma,geneva,sans-serif", n.TrebuchetMS = "trebuchet ms,helvetica,sans-serif", n.TimesNewRoman = "times new roman,times,serif", n.Georgia = "georgia, serif", n.Garamond = "garamond, serif", n.CourierNew = "courier new,courier,monospace", n.BrushScriptMT = "brush script mt, cursive", n.Helvetica = "Helvetica, Arial, sans-serif", n.ComicSansMS = "Comic Sans MS, cursive, sans-serif", n.Impact = "Impact, Charcoal, sans-serif", n))(xc || {});
const Ae = (n) => n.split(",")[0].toLowerCase().replace(/["']/g, "").replace(/,/g, "_"), SP = Object.values(xc).reduce((n, e) => (n[Ae(e)] = e, n), {}), nA = (n) => {
  switch (Ae(n)) {
    case Ae(
      "Arial, Helvetica, sans-serif"
      /* Arial */
    ):
      return "Arial";
    case Ae(
      "Arial Black, Gadget, sans-serif"
      /* ArialBlack */
    ):
      return "Arial Black";
    case Ae(
      "Lucida sans unicode,lucida grande,sans-serif"
      /* Lucida */
    ):
      return "Lucida";
    case Ae(
      "verdana,geneva,sans-serif"
      /* Verdana */
    ):
      return "Verdana";
    case Ae(
      "tahoma,geneva,sans-serif"
      /* Tahoma */
    ):
      return "Tahoma";
    case Ae(
      "trebuchet ms,helvetica,sans-serif"
      /* TrebuchetMS */
    ):
      return "Trebuchet MS";
    case Ae(
      "times new roman,times,serif"
      /* TimesNewRoman */
    ):
      return "Times New Roman";
    case Ae(
      "georgia, serif"
      /* Georgia */
    ):
      return "Georgia";
    case Ae(
      "garamond, serif"
      /* Garamond */
    ):
      return "Garamond";
    case Ae(
      "courier new,courier,monospace"
      /* CourierNew */
    ):
      return "Courier New";
    case Ae(
      "brush script mt, cursive"
      /* BrushScriptMT */
    ):
      return "Brush Script MT";
    case Ae(
      "Helvetica, Arial, sans-serif"
      /* Helvetica */
    ):
      return "Helvetica";
    case Ae(
      "Comic Sans MS, cursive, sans-serif"
      /* ComicSansMS */
    ):
      return "Comic Sans MS";
    case Ae(
      "Impact, Charcoal, sans-serif"
      /* Impact */
    ):
      return "Impact";
    default:
      return n;
  }
}, Id = () => Object.values(xc).map((n) => {
  const e = nA(n);
  return {
    id: Ae(n),
    caption: e,
    customCaption: /* @__PURE__ */ b("div", { style: { fontFamily: n }, children: e })
  };
}), wP = (n) => {
  const e = !(n != null && n.options.editable) || Tt(n), t = n != null && n.getAttributes("textStyle").fontFamily ? Ae(n == null ? void 0 : n.getAttributes("textStyle").fontFamily) : void 0;
  return Ve(() => {
    const r = (a) => {
      if (!n || !a) return null;
      n.chain().focus().setFontFamily(SP[a]).run();
    }, o = () => {
      n && n.chain().focus().unsetFontFamily().run();
    }, s = (a) => /* @__PURE__ */ b("div", { className: "flex items-center", children: /* @__PURE__ */ P(Zt, { className: "flex gap-1", disabled: e, open: a, children: [
      t ? nA(t) : /* @__PURE__ */ b(Eh, { label: O.t("font_family.hint"), children: O.t("font_family.default") }),
      !!t && /* @__PURE__ */ b(
        Nh,
        {
          onClick: (l) => {
            l.stopPropagation(), o();
          },
          className: "fill-text-primary cursor-pointer"
        }
      )
    ] }) });
    return {
      toolbarRender: /* @__PURE__ */ b(
        Ht,
        {
          disabled: e,
          data: Id(),
          value: t,
          onChange: r,
          children: (a) => /* @__PURE__ */ b(
            te,
            {
              disabled: e,
              label: O.t("font_family.title"),
              anchor: "left",
              ...ie,
              children: s(a)
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ b(
        Ht,
        {
          optionsClassName: "z-40",
          disabled: e,
          data: Id(),
          value: t,
          onChange: r,
          children: (a) => /* @__PURE__ */ b(
            te,
            {
              disabled: e,
              label: O.t("font_family.title"),
              anchor: "left",
              ...ie,
              children: s(a)
            }
          )
        }
      )
    };
  }, [n, e, t]);
};
function CP(n) {
  return /* @__PURE__ */ P(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      children: [
        /* @__PURE__ */ b("path", { d: "M4.00384 18.1914C3.77528 18.6941 3.18238 18.916 2.67962 18.6875C2.17722 18.4589 1.95528 17.8669 2.18353 17.3643L4.00384 18.1914ZM8.01751 5.38282C8.45246 5.16859 8.96243 5.16864 9.3974 5.38282C9.77416 5.5684 9.97651 5.89497 10.08 6.07716C10.1951 6.27974 10.3148 6.54389 10.4365 6.81153L15.2324 17.3643C15.4606 17.8668 15.2386 18.4589 14.7363 18.6875C14.2335 18.916 13.6406 18.6941 13.412 18.1914L11.6367 14.2861H5.77923L4.00384 18.1914L2.18353 17.3643L6.97943 6.81153C7.10108 6.54389 7.21984 6.27974 7.3349 6.07716C7.43829 5.89512 7.64084 5.56857 8.01751 5.38282ZM6.68841 12.2861H10.7275L8.70794 7.84278L6.68841 12.2861Z" }),
        /* @__PURE__ */ b("path", { d: "M18.6611 4.82422C18.9315 4.82433 19.1907 4.9338 19.3789 5.12793L21.624 7.44434C22.0084 7.84083 21.999 8.47395 21.6025 8.8584C21.206 9.24266 20.5729 9.23235 20.1885 8.83594L19.6611 8.29199V15.7061L20.1885 15.1631C20.5729 14.7668 21.2061 14.7572 21.6025 15.1416C21.999 15.5261 22.0085 16.1592 21.624 16.5557L19.3789 18.8721C19.1907 19.0661 18.9315 19.1757 18.6611 19.1758C18.3906 19.1758 18.1307 19.0663 17.9424 18.8721L15.6973 16.5557C15.3128 16.1592 15.3223 15.5261 15.7187 15.1416C16.1151 14.7572 16.7483 14.7668 17.1328 15.1631L17.6611 15.707V8.29102L17.1328 8.83594L15.6973 7.44434L17.9424 5.12793L18.0166 5.05957C18.1961 4.90837 18.4243 4.82422 18.6611 4.82422ZM17.1328 8.83594C16.7484 9.23238 16.1152 9.24273 15.7187 8.8584C15.3223 8.47397 15.3129 7.84083 15.6973 7.44434L17.1328 8.83594Z" })
      ]
    }
  );
}
const TP = [
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  20,
  22,
  24,
  26,
  28,
  30,
  34,
  38,
  42,
  46,
  50,
  58,
  64,
  72,
  80,
  88,
  96
], Pd = () => TP.map((n) => {
  const e = `${n}px`;
  return {
    id: e,
    caption: e
  };
}), MP = (n, e) => {
  const t = !(n != null && n.options.editable) || Tt(n), i = (n == null ? void 0 : n.getAttributes("textStyle").fontSize) || null;
  return Ve(() => {
    const o = (a) => {
      if (!n) return null;
      a ? n.chain().focus().setFontSize(a).run() : n.chain().focus().unsetFontSize().run();
    }, s = (a, l) => /* @__PURE__ */ b("div", { className: "flex items-center", children: /* @__PURE__ */ P(Zt, { className: "flex gap-1", disabled: t, open: a, children: [
      i ?? /* @__PURE__ */ P("div", { className: "flex items-center justify-center gap-1", children: [
        /* @__PURE__ */ b(
          CP,
          {
            className: W(
              "main-transition-colors h-3.5 w-3.5 scale-125",
              t ? "fill-text-secondary" : "fill-text-primary group-hover:fill-brand-primary"
            )
          }
        ),
        l
      ] }),
      (e == null ? void 0 : e.clearable) && !!i && /* @__PURE__ */ b(
        Nh,
        {
          onClick: (c) => {
            c.stopPropagation(), o(null);
          },
          className: "fill-text-primary cursor-pointer"
        }
      )
    ] }) });
    return {
      toolbarRender: /* @__PURE__ */ b(
        Ht,
        {
          optionsProps: { unmount: !1 },
          optionsClassName: "min-w-[100px] w-[100px]",
          disabled: t,
          value: i,
          onChange: o,
          data: Pd(),
          children: (a) => /* @__PURE__ */ b(
            te,
            {
              disabled: t,
              label: O.t("font_size"),
              anchor: "left",
              ...ie,
              children: s(a)
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ b(
        Ht,
        {
          optionsProps: { unmount: !1 },
          optionsClassName: "z-40 min-w-[100px] w-[100px]",
          disabled: t,
          value: i,
          onChange: o,
          data: Pd(),
          children: (a) => /* @__PURE__ */ b(
            te,
            {
              disabled: t,
              label: O.t("font_size"),
              anchor: "left",
              ...ie,
              children: s(a, O.t("font_size"))
            }
          )
        }
      )
    };
  }, [n, t, i]);
};
var de = /* @__PURE__ */ ((n) => (n[n.Default = 0] = "Default", n[n.H2 = 2] = "H2", n[n.H3 = 3] = "H3", n[n.H4 = 4] = "H4", n))(de || {});
const Aa = (n) => {
  const e = (t) => {
    switch (t) {
      case de.Default:
      default:
        return n("text_level.paragraph");
      case de.H2:
        return n("text_level.header_one");
      case de.H3:
        return n("text_level.header_two");
      case de.H4:
        return n("text_level.header_three");
    }
  };
  return [
    {
      id: de.Default,
      caption: e(de.Default),
      customCaption: /* @__PURE__ */ b("div", { children: e(de.Default) })
    },
    {
      id: de.H2,
      caption: e(de.H2),
      customCaption: /* @__PURE__ */ b(
        "div",
        {
          style: { fontSize: ko[de.H2].fontSize },
          className: "font-bold",
          children: e(de.H2)
        }
      )
    },
    {
      id: de.H3,
      caption: e(de.H3),
      customCaption: /* @__PURE__ */ b(
        "div",
        {
          style: { fontSize: ko[de.H3].fontSize },
          className: "font-bold",
          children: e(de.H3)
        }
      )
    },
    {
      id: de.H4,
      caption: e(de.H4),
      customCaption: /* @__PURE__ */ b(
        "div",
        {
          style: { fontSize: ko[de.H4].fontSize },
          className: "font-semibold",
          children: e(de.H4)
        }
      )
    }
  ];
}, Na = (n) => {
  if (!n) return;
  const e = n.getAttributes("heading");
  if (e.level)
    switch (e.level) {
      case 2:
        return de.H2;
      case 3:
        return de.H3;
      case 4:
        return de.H4;
    }
  return de.Default;
}, EP = (n) => {
  var r;
  const e = (r = Aa(O.t).find(
    (o) => o.id === Na(n)
  )) == null ? void 0 : r.caption, t = !(n != null && n.options.editable) || Tt(n);
  return Ve(() => {
    const o = (s) => {
      if (!n) return null;
      if (s === de.Default)
        return n.chain().focus().setParagraph().run();
      n.chain().focus().toggleHeading({ level: s }).run();
    };
    return {
      toolbarRender: /* @__PURE__ */ b(
        Ht,
        {
          disabled: t,
          value: Na(n),
          onChange: o,
          data: Aa(O.t),
          children: (s) => /* @__PURE__ */ b(
            te,
            {
              disabled: t,
              label: O.t("text_level.title"),
              anchor: "left",
              ...ie,
              children: /* @__PURE__ */ P(
                Zt,
                {
                  className: "flex gap-1",
                  disabled: t,
                  open: s,
                  children: [
                    /* @__PURE__ */ b(_l, { className: he(t) }),
                    e
                  ]
                }
              )
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ b(
        Ht,
        {
          optionsClassName: "z-40",
          disabled: t,
          value: Na(n),
          onChange: o,
          data: Aa(O.t),
          children: (s) => /* @__PURE__ */ b(
            te,
            {
              disabled: t,
              label: O.t("text_level.title"),
              anchor: "left",
              ...ie,
              children: /* @__PURE__ */ P(
                Zt,
                {
                  className: "flex gap-1",
                  disabled: t,
                  open: s,
                  children: [
                    /* @__PURE__ */ b(_l, { className: he(t) }),
                    e
                  ]
                }
              )
            }
          )
        }
      )
    };
  }, [e, n, t]);
};
function oo(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "12",
      height: "12",
      viewBox: "0 0 12 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M10.6667 6H1.33337M1.33337 6L6.00004 10.6667M1.33337 6L6.00004 1.33334",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
var Ke = /* @__PURE__ */ ((n) => (n.Left = "left", n.Right = "right", n.Center = "center", n.Justify = "justify", n))(Ke || {});
const $P = () => {
  var e;
  if (typeof window > "u") return;
  if ((e = navigator.userAgentData) != null && e.platform)
    return navigator.userAgentData.platform;
  const n = navigator.userAgent.toLowerCase();
  if (n.includes("mac")) return "macOS";
  if (n.includes("win")) return "Windows";
  if (n.includes("linux")) return "Linux";
}, $n = {
  [He.Bold]: {
    toggle: "Mod-B"
  },
  [He.Italic]: {
    toggle: "Mod-I"
  },
  [He.Strike]: {
    toggle: "Mod-Shift-S"
  },
  [He.Underline]: {
    toggle: "Mod-U"
  },
  textAlign: {
    [Ke.Left]: "Mod-Shift-L",
    [Ke.Center]: "Mod-Shift-E",
    [Ke.Right]: "Mod-Shift-R",
    [Ke.Justify]: "Mod-Shift-J"
  },
  list: {
    [fn.OrderedList]: "Mod-Shift-7",
    [fn.BulletList]: "Mod-Shift-8"
  },
  heading: {
    [de.Default]: "Mod-Alt-0",
    [de.H2]: "Mod-Alt-2",
    [de.H3]: "Mod-Alt-3",
    [de.H4]: "Mod-Alt-4"
  },
  history: {
    undo: "Mod-Z",
    redo: "Shift-Mod-Z"
  }
}, On = (n) => {
  const e = $P();
  return n.replace("Mod", e === "macOS" ? "⌘" : "Ctrl").replace("Alt", e === "macOS" ? "⌥" : "Alt").replace("-", " ");
}, OP = (n) => {
  const e = !(n != null && n.options.editable) || !(n != null && n.can().undo()), t = !(n != null && n.options.editable) || !(n != null && n.can().redo());
  return Ve(() => [
    {
      toolbarRender: /* @__PURE__ */ b(
        te,
        {
          disabled: e,
          label: `${O.t("undo")} (${On($n.history.undo)})`,
          ...ie,
          children: /* @__PURE__ */ b(
            ae,
            {
              onClick: () => n == null ? void 0 : n.chain().focus().undo().run(),
              disabled: e,
              children: /* @__PURE__ */ b(oo, { className: he(e) })
            }
          )
        },
        "undo"
      ),
      tooltipRender: /* @__PURE__ */ b(
        te,
        {
          disabled: e,
          label: On($n.history.undo),
          ...ie,
          children: /* @__PURE__ */ P(
            ae,
            {
              onClick: () => n == null ? void 0 : n.chain().focus().undo().run(),
              className: "flex gap-1",
              disabled: e,
              children: [
                /* @__PURE__ */ b(oo, { className: he(e) }),
                O.t("undo")
              ]
            }
          )
        },
        "undo"
      )
    },
    {
      toolbarRender: /* @__PURE__ */ b(
        te,
        {
          disabled: t,
          label: `${O.t("redo")} (${On($n.history.redo)})`,
          ...ie,
          children: /* @__PURE__ */ b(
            ae,
            {
              onClick: () => n == null ? void 0 : n.chain().focus().redo().run(),
              disabled: t,
              children: /* @__PURE__ */ b(
                oo,
                {
                  className: W(
                    he(t),
                    "rotate-180"
                  )
                }
              )
            }
          )
        },
        "redo"
      ),
      tooltipRender: /* @__PURE__ */ b(
        te,
        {
          disabled: t,
          label: On($n.history.redo),
          ...ie,
          children: /* @__PURE__ */ P(
            ae,
            {
              onClick: () => n == null ? void 0 : n.chain().focus().redo().run(),
              className: "flex gap-1",
              disabled: t,
              children: [
                /* @__PURE__ */ b(
                  oo,
                  {
                    className: W(
                      he(t),
                      "rotate-180"
                    )
                  }
                ),
                O.t("redo")
              ]
            }
          )
        },
        "redo"
      )
    }
  ], [n, t, e]);
};
function jd(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "16",
      height: "14",
      viewBox: "0 0 16 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M2.84804 12.8186L7.24573 8.42091C7.50974 8.1569 7.64175 8.0249 7.79397 7.97544C7.92786 7.93193 8.0721 7.93193 8.20599 7.97544C8.35821 8.0249 8.49022 8.15691 8.75423 8.42091L13.1226 12.7893M9.33331 9L11.2457 7.08758C11.5097 6.82357 11.6417 6.69156 11.794 6.6421C11.9279 6.5986 12.0721 6.5986 12.206 6.6421C12.3582 6.69156 12.4902 6.82357 12.7542 7.08758L14.6666 9M6.66665 5C6.66665 5.73638 6.06969 6.33333 5.33331 6.33333C4.59693 6.33333 3.99998 5.73638 3.99998 5C3.99998 4.26362 4.59693 3.66667 5.33331 3.66667C6.06969 3.66667 6.66665 4.26362 6.66665 5ZM4.53331 13H11.4666C12.5868 13 13.1468 13 13.5746 12.782C13.951 12.5903 14.2569 12.2843 14.4487 11.908C14.6666 11.4802 14.6666 10.9201 14.6666 9.8V4.2C14.6666 3.0799 14.6666 2.51984 14.4487 2.09202C14.2569 1.71569 13.951 1.40973 13.5746 1.21799C13.1468 1 12.5868 1 11.4666 1H4.53331C3.41321 1 2.85316 1 2.42533 1.21799C2.04901 1.40973 1.74305 1.71569 1.5513 2.09202C1.33331 2.51984 1.33331 3.0799 1.33331 4.2V9.8C1.33331 10.9201 1.33331 11.4802 1.5513 11.908C1.74305 12.2843 2.04901 12.5903 2.42533 12.782C2.85316 13 3.41321 13 4.53331 13Z",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
function Bd({ isDisabled: n, handleSetImage: e }) {
  return /* @__PURE__ */ b(
    xo,
    {
      disabled: n,
      anchor: "bottom",
      wrapperClassName: "group px-1.5",
      label: /* @__PURE__ */ b(zP, { handleSetImage: e, isDisabled: n }),
      children: (t) => /* @__PURE__ */ b(
        te,
        {
          disabled: n,
          className: "content-center",
          label: O.t("image_via_link"),
          wrapperClassName: "h-full",
          ...ie,
          children: /* @__PURE__ */ b(
            Ah,
            {
              className: W(
                he(n),
                "transition-transform duration-200 ease-linear ",
                "main-transition-colors h-3.5 w-3.5",
                n ? "stroke-text-secondary" : "stroke-text-primary group-hover:stroke-brand-primary",
                t && "rotate-180"
              )
            }
          )
        }
      )
    }
  );
}
function zP({ handleSetImage: n, isDisabled: e }) {
  const [t, i] = ye(""), r = e || !t || !Lh(t);
  return /* @__PURE__ */ P("form", { onSubmit: (o) => o.preventDefault(), className: "flex items-end", children: [
    /* @__PURE__ */ b(
      $h,
      {
        inputClassName: "min-w-[200px]",
        placeholder: "example.com/image.png",
        disabled: e,
        label: O.t("image_insert_via_link"),
        value: t,
        onChange: (o) => i(o)
      }
    ),
    /* @__PURE__ */ b(
      ae,
      {
        disabled: r,
        type: "submit",
        onClick: () => n(t),
        className: "mb-[5px]",
        children: /* @__PURE__ */ b(zl, { className: he(r) })
      }
    )
  ] });
}
const AP = (n, e) => {
  const [t, i] = ye(!1), r = !(n != null && n.options.editable);
  return Ve(() => {
    const s = (a) => {
      if (!n) return null;
      const l = () => n.chain().focus().run();
      if (!a) return l();
      const c = new Image();
      c.src = a, c.onerror = () => {
        po.error(O.t("image_error")), l();
      }, c.onload = () => {
        const u = c.naturalWidth, d = c.naturalHeight;
        n.chain().focus().setImage({
          src: a,
          imageMode: ce.BlockCenter,
          containerWidth: "auto",
          width: u,
          height: d
        }).run(), i(!1);
      };
    };
    return {
      toolbarRender: /* @__PURE__ */ P("div", { className: "hover:divide-text-secondary/30 flex divide-x divide-transparent", children: [
        /* @__PURE__ */ b(te, { disabled: r, label: O.t("image"), ...ie, children: /* @__PURE__ */ b(ae, { disabled: r, onClick: () => i(!0), children: /* @__PURE__ */ b(jd, { className: he(r) }) }) }),
        /* @__PURE__ */ b(Bd, { handleSetImage: s, isDisabled: r })
      ] }),
      tooltipRender: /* @__PURE__ */ P("div", { className: "divide-text-secondary/30 flex divide-x", children: [
        /* @__PURE__ */ P(
          ae,
          {
            className: "gap-1.5",
            disabled: r,
            onClick: () => i(!0),
            children: [
              /* @__PURE__ */ b(jd, { className: he(r) }),
              O.t("image")
            ]
          }
        ),
        /* @__PURE__ */ b(Bd, { handleSetImage: s, isDisabled: r })
      ] }),
      additionalRender: /* @__PURE__ */ b(
        Ol,
        {
          initialSearchFilters: {
            name: "",
            source: [e],
            type: [Mc.Image, Mc.ImageOther]
          },
          opened: t,
          onClose: () => i(!1),
          onSelect: ({ path: a }) => s(a),
          uploadingFromSource: e,
          disabledFileTypeSelect: !0
        }
      )
    };
  }, [r, t, n, e]);
};
function so(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "14",
      height: "14",
      viewBox: "0 0 14 14",
      fill: "none",
      stroke: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M13 1.66666H1M13 12.3333H1M7 5.16666H1M7 8.83333H1M12.1467 4.64L9.56889 6.57333C9.37589 6.71808 9.2794 6.79045 9.24489 6.87917C9.21467 6.95689 9.21467 7.04311 9.24489 7.12082C9.2794 7.20954 9.37589 7.28192 9.56889 7.42666L12.1467 9.36C12.4213 9.56599 12.5586 9.66898 12.6736 9.66659C12.7736 9.66451 12.8674 9.61761 12.9291 9.53883C13 9.4483 13 9.27665 13 8.93333V5.06666C13 4.72335 13 4.55169 12.9291 4.46116C12.8674 4.38239 12.7736 4.33548 12.6736 4.3334C12.5586 4.33101 12.4213 4.43401 12.1467 4.64Z",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
function NP(n, e, t) {
  return n < e ? e : n > t ? t : n;
}
var El = /* @__PURE__ */ ((n) => (n[n.min = 0] = "min", n[n.max = 140] = "max", n[n.more = 20] = "more", n[n.less = -20] = "less", n))(El || {});
function LP(n) {
  return n.type.name === "bullet_list";
}
function DP(n) {
  return n.type.name === "order_list";
}
function RP(n) {
  return LP(n) || DP(n);
}
function IP(n, e, t) {
  if (!n.doc) return n;
  const i = n.doc.nodeAt(e);
  if (!i) return n;
  const r = 0, o = 140;
  let s = 0;
  typeof i.attrs.indent == "number" ? s = i.attrs.indent : typeof i.attrs.indent == "string" && (s = parseInt(i.attrs.indent) || 0);
  const a = NP(s + t, r, o);
  if (a === s) return n;
  const l = {
    ...i.attrs,
    indent: a
  };
  return n.setNodeMarkup(e, i.type, l, i.marks);
}
function Fd(n, e) {
  const { doc: t, selection: i } = n;
  if (!t || !i || !(i instanceof G || i instanceof ot))
    return n;
  const { from: r, to: o } = i;
  return t.nodesBetween(r, o, (s, a) => {
    const l = s.type;
    return l.name === "paragraph" || l.name === "heading" ? (n = IP(n, a, e), !1) : !RP(s);
  }), n;
}
const PP = Se.create({
  name: "indent",
  addOptions() {
    return {
      types: ["heading", "paragraph"],
      indentLevels: [0, 20, 40, 60, 80, 100, 120, 140],
      defaultIndentLevel: 0
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          indent: {
            default: this.options.defaultIndentLevel,
            renderHTML: (n) => ({
              style: `margin-left: ${typeof n.indent == "number" ? n.indent : parseInt(String(n.indent)) || this.options.defaultIndentLevel}px;`
            }),
            parseHTML: (n) => {
              const e = n.style.marginLeft;
              let t = this.options.defaultIndentLevel;
              if (e && typeof e == "string") {
                const i = parseInt(e.replace(/[^\d.-]/g, ""));
                isNaN(i) || (t = i);
              }
              return t;
            }
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      indent: () => ({ tr: n, state: e, dispatch: t }) => {
        const { selection: i } = e;
        return n = n.setSelection(i), n = Fd(
          n,
          20
          /* more */
        ), n.docChanged ? (t && t(n), !0) : !1;
      },
      outdent: () => ({ tr: n, state: e, dispatch: t }) => {
        const { selection: i } = e;
        return n = n.setSelection(i), n = Fd(
          n,
          -20
          /* less */
        ), n.docChanged ? (t && t(n), !0) : !1;
      }
    };
  }
}), jP = (n) => {
  const t = (() => {
    if (!n) return 0;
    const s = ["paragraph", "heading", "bulletList", "orderedList"];
    for (const a of s) {
      const l = n.getAttributes(a);
      if (l && typeof l.indent == "number")
        return l.indent;
    }
    return 0;
  })(), i = !(n != null && n.options.editable) || Tt(n) || t <= El.min, r = !(n != null && n.options.editable) || Tt(n) || t >= El.max;
  return Ve(() => {
    const s = () => n == null ? void 0 : n.chain().focus().outdent().run(), a = () => n == null ? void 0 : n.chain().focus().indent().run();
    return [
      {
        toolbarRender: /* @__PURE__ */ b(
          te,
          {
            disabled: i,
            label: O.t("decrease_intent"),
            ...ie,
            children: /* @__PURE__ */ b(
              ae,
              {
                className: "flex gap-1",
                onClick: s,
                disabled: i,
                children: /* @__PURE__ */ b(so, { className: he(i) })
              }
            )
          },
          "outdent"
        ),
        tooltipRender: /* @__PURE__ */ P(
          ae,
          {
            className: "flex gap-1",
            onClick: s,
            disabled: i,
            children: [
              /* @__PURE__ */ b(so, { className: he(i) }),
              O.t("decrease_intent")
            ]
          }
        )
      },
      {
        toolbarRender: /* @__PURE__ */ b(
          te,
          {
            disabled: r,
            label: O.t("increase_intent"),
            ...ie,
            children: /* @__PURE__ */ b(
              ae,
              {
                className: "flex gap-1",
                onClick: a,
                disabled: r,
                children: /* @__PURE__ */ b(
                  so,
                  {
                    className: W(
                      he(r),
                      "rotate-180"
                    )
                  }
                )
              }
            )
          },
          "indent"
        ),
        tooltipRender: /* @__PURE__ */ P(
          ae,
          {
            className: "flex gap-1",
            onClick: a,
            disabled: r,
            children: [
              /* @__PURE__ */ b(
                so,
                {
                  className: W(
                    he(r),
                    "rotate-180"
                  )
                }
              ),
              O.t("increase_intent")
            ]
          }
        )
      }
    ];
  }, [n, r, i]);
}, BP = (n, e) => {
  const t = Vz(n), i = !(n != null && n.options.editable) || Tt(n);
  return Ve(() => {
    const o = () => {
      if (!n) return null;
      n.isActive("link") ? n.chain().focus() : n.chain().focus().extendMarkRange("link").setLink({ href: "" }).run();
    };
    return {
      toolbarRender: /* @__PURE__ */ b(
        te,
        {
          disabled: i,
          label: O.t("link"),
          ...ie,
          children: /* @__PURE__ */ b(
            ae,
            {
              disabled: i,
              className: W(
                t && "bg-brand-primary/10 main-transition-colors"
              ),
              onClick: o,
              children: /* @__PURE__ */ b(Ko, { className: he(i) })
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ P(
        ae,
        {
          disabled: i,
          className: W(
            t && "bg-brand-primary/10 main-transition-colors",
            "flex gap-1"
          ),
          onClick: o,
          children: [
            /* @__PURE__ */ b(Ko, { className: he(i) }),
            O.t("link")
          ]
        }
      )
    };
  }, [n, t, i, e]);
};
function FP(n) {
  return /* @__PURE__ */ P(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...n,
      children: [
        /* @__PURE__ */ b("path", { d: "M6.66663 3H14", "stroke-linecap": "round", "stroke-linejoin": "round" }),
        /* @__PURE__ */ b("path", { d: "M6.66663 6.33334H14", "stroke-linecap": "round", "stroke-linejoin": "round" }),
        /* @__PURE__ */ b("path", { d: "M6.66663 9.66666H14", "stroke-linecap": "round", "stroke-linejoin": "round" }),
        /* @__PURE__ */ b("path", { d: "M6.66663 13H14", "stroke-linecap": "round", "stroke-linejoin": "round" }),
        /* @__PURE__ */ b(
          "path",
          {
            d: "M2 9.66666H4V10.6667L2 12.6667V13H4",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        ),
        /* @__PURE__ */ b(
          "path",
          {
            d: "M2.33337 3.66667L3.00004 3V6.33333M3.00004 6.33333H2.33337M3.00004 6.33333H3.66671",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        )
      ]
    }
  );
}
function qP(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M21 12L9 12M21 6L9 6M21 18L9 18M5 12C5 12.5523 4.55228 13 4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11C4.55228 11 5 11.4477 5 12ZM5 6C5 6.55228 4.55228 7 4 7C3.44772 7 3 6.55228 3 6C3 5.44772 3.44772 5 4 5C4.55228 5 5 5.44772 5 6ZM5 18C5 18.5523 4.55228 19 4 19C3.44772 19 3 18.5523 3 18C3 17.4477 3.44772 17 4 17C4.55228 17 5 17.4477 5 18Z",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
const HP = ({ listType: n, editor: e }) => {
  if (e)
    switch (n) {
      case fn.BulletList:
        e.chain().focus().toggleBulletList().run();
        break;
      case fn.OrderedList:
        e.chain().focus().toggleOrderedList().run();
        break;
    }
}, VP = ({ listType: n }) => {
  switch (n) {
    case fn.BulletList:
      return qP;
    case fn.OrderedList:
      return FP;
  }
}, iA = (n) => {
  switch (n) {
    case 0:
      return "disc";
    case 1:
      return "circle";
    default:
      return "square";
  }
}, rA = (n) => {
  switch (n) {
    case 0:
      return "decimal";
    case 1:
      return "lower-latin";
    case 2:
      return "lower-roman";
    case 3:
      return "upper-latin";
    default:
      return "upper-roman";
  }
}, qd = (n, e) => {
  const t = !(n != null && n.options.editable), i = n == null ? void 0 : n.isActive(e);
  return Ve(() => {
    const o = () => HP({ editor: n, listType: e }), s = VP({ listType: e });
    return {
      toolbarRender: /* @__PURE__ */ b(
        te,
        {
          disabled: t,
          label: `${O.t(`${e}`)} (${On($n.list[e])})`,
          ...ie,
          children: /* @__PURE__ */ b(
            ae,
            {
              disabled: t,
              className: W(
                Rn,
                i && "bg-brand-primary/10",
                "main-transition-colors"
              ),
              onClick: o,
              children: /* @__PURE__ */ b(s, { className: he(t) })
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ b(
        te,
        {
          disabled: t,
          label: On($n.list[e]),
          ...ie,
          children: /* @__PURE__ */ P(
            ae,
            {
              disabled: t,
              className: W(
                Rn,
                i && "bg-brand-primary/10",
                "main-transition-colors",
                "flex gap-1"
              ),
              onClick: o,
              children: [
                /* @__PURE__ */ b(s, { className: he(t) }),
                O.t(`${e}`)
              ]
            }
          )
        }
      )
    };
  }, [n, i, t, e]);
}, Hd = [
  {
    name: "special_characters.dollar",
    code: "U+0024",
    symbol: "$"
  },
  {
    name: "special_characters.euro",
    code: "U+20ac",
    symbol: "€"
  },
  {
    name: "special_characters.yen",
    code: "U+00a5",
    symbol: "¥"
  },
  {
    name: "special_characters.pound",
    code: "U+00a3",
    symbol: "£"
  },
  {
    name: "special_characters.cent",
    code: "U+00a2",
    symbol: "¢"
  },
  {
    name: "special_characters.euro_currency",
    code: "U+20a0",
    symbol: "₠"
  },
  {
    name: "special_characters.colon",
    code: "U+20a1",
    symbol: "₡"
  },
  {
    name: "special_characters.cruzeiro",
    code: "U+20a2",
    symbol: "₢"
  },
  {
    name: "special_characters.french_franc",
    code: "U+20a3",
    symbol: "₣"
  },
  {
    name: "special_characters.lira",
    code: "U+20a4",
    symbol: "₤"
  },
  {
    name: "special_characters.currency",
    code: "U+00a4",
    symbol: "¤"
  },
  {
    name: "special_characters.bitcoin",
    code: "U+20bf",
    symbol: "₿"
  },
  {
    name: "special_characters.mill",
    code: "U+20a5",
    symbol: "₥"
  },
  {
    name: "special_characters.mill",
    code: "U+20a6",
    symbol: "₦"
  },
  {
    name: "special_characters.peseta",
    code: "U+20a7",
    symbol: "₧"
  },
  {
    name: "special_characters.rupee",
    code: "U+20a8",
    symbol: "₨"
  },
  {
    name: "special_characters.won",
    code: "U+20a9",
    symbol: "₩"
  },
  {
    name: "special_characters.new_sheqel",
    code: "U+20aa",
    symbol: "₪"
  },
  {
    name: "special_characters.dong",
    code: "U+20ab",
    symbol: "₫"
  },
  {
    name: "special_characters.kip",
    code: "U+20ad",
    symbol: "₭"
  },
  {
    name: "special_characters.tugrik",
    code: "U+20ae",
    symbol: "₮"
  },
  {
    name: "special_characters.drachma",
    code: "U+20af",
    symbol: "₯"
  },
  {
    name: "special_characters.german_penny",
    code: "U+20b0",
    symbol: "₰"
  },
  {
    name: "special_characters.peso",
    code: "U+20b1",
    symbol: "₱"
  },
  {
    name: "special_characters.guarani",
    code: "U+20b2",
    symbol: "₲"
  },
  {
    name: "special_characters.austral",
    code: "U+20b3",
    symbol: "₳"
  },
  {
    name: "special_characters.hryvnia",
    code: "U+20b4",
    symbol: "₴"
  },
  {
    name: "special_characters.cedi",
    code: "U+20b5",
    symbol: "₵"
  },
  {
    name: "special_characters.livre_tournois",
    code: "U+20b6",
    symbol: "₶"
  },
  {
    name: "special_characters.spesmilo",
    code: "U+20b7",
    symbol: "₷"
  },
  {
    name: "special_characters.tenge",
    code: "U+20b8",
    symbol: "₸"
  },
  {
    name: "special_characters.indian_rupee",
    code: "U+20b9",
    symbol: "₹"
  },
  {
    name: "special_characters.turkish_lira",
    code: "U+20ba",
    symbol: "₺"
  },
  {
    name: "special_characters.nordic_mark",
    code: "U+20bb",
    symbol: "₻"
  },
  {
    name: "special_characters.manat",
    code: "U+20bc",
    symbol: "₼"
  },
  {
    name: "special_characters.ruble",
    code: "U+20bd",
    symbol: "₽"
  }
], Vd = [
  {
    name: "special_characters.left_pointing_angle_quotation_mark",
    code: "U+2039",
    symbol: "‹"
  },
  {
    name: "special_characters.right_pointing_angle_quotation_mark",
    code: "U+203a",
    symbol: "›"
  },
  {
    name: "special_characters.left_pointing_double_angle_quotation_mark",
    code: "U+00ab",
    symbol: "«"
  },
  {
    name: "special_characters.right_pointing_double_angle_quotation_mark",
    code: "U+00bb",
    symbol: "»"
  },
  {
    name: "special_characters.left_single_quotation_mark",
    code: "U+2018",
    symbol: "‘"
  },
  {
    name: "special_characters.right_single_quotation_mark",
    code: "U+2019",
    symbol: "’"
  },
  {
    name: "special_characters.left_double_quotation_mark",
    code: "U+201c",
    symbol: "“"
  },
  {
    name: "special_characters.right_double_quotation_mark",
    code: "U+201d",
    symbol: "”"
  },
  {
    name: "special_characters.single_low_quotation_mark",
    code: "U+201a",
    symbol: "‚"
  },
  {
    name: "special_characters.double_low_quotation_mark",
    code: "U+201e",
    symbol: "„"
  },
  {
    name: "special_characters.inverted_exclamation_mark",
    code: "U+00a1",
    symbol: "¡"
  },
  {
    name: "special_characters.inverted_question_mark",
    code: "U+00bf",
    symbol: "¿"
  },
  {
    name: "special_characters.two_dot_leader",
    code: "U+2025",
    symbol: "‥"
  },
  {
    name: "special_characters.horizontal_ellipsis",
    code: "U+2026",
    symbol: "…"
  },
  {
    name: "special_characters.double_dagger",
    code: "U+2021",
    symbol: "‡"
  },
  {
    name: "special_characters.per_mille_sign",
    code: "U+2030",
    symbol: "‰"
  },
  {
    name: "special_characters.per_ten_thousand_sign",
    code: "U+2031",
    symbol: "‱"
  },
  {
    name: "special_characters.double_exclamation_mark",
    code: "U+203c",
    symbol: "‼"
  },
  {
    name: "special_characters.question_exclamation_mark",
    code: "U+2048",
    symbol: "⁈"
  },
  {
    name: "special_characters.exclamation_question_mark",
    code: "U+2049",
    symbol: "⁉"
  },
  {
    name: "special_characters.double_question_mark",
    code: "U+2047",
    symbol: "⁇"
  },
  {
    name: "special_characters.copyright_sign",
    code: "U+00a9",
    symbol: "©"
  },
  {
    name: "special_characters.registered_sign",
    code: "U+00ae",
    symbol: "®"
  },
  {
    name: "special_characters.trade_mark_sign",
    code: "U+2122",
    symbol: "™"
  },
  {
    name: "special_characters.section_sign",
    code: "U+00a7",
    symbol: "§"
  },
  {
    name: "special_characters.paragraph_sign",
    code: "U+00b6",
    symbol: "¶"
  },
  {
    name: "special_characters.reversed_paragraph_sign",
    code: "U+204b",
    symbol: "⁋"
  }
], Si = {
  currency: Hd,
  text: Vd,
  all: [...Hd, ...Vd]
};
var fr = /* @__PURE__ */ ((n) => (n.Text = "text", n.Currency = "currency", n.All = "all", n))(fr || {});
function Ud(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      className: "ck ck-icon ck-reset_all-excluded ck-icon_inherit-color ck-button__icon",
      viewBox: "0 0 20 20",
      width: 14,
      height: 14,
      ...n,
      children: /* @__PURE__ */ b("path", { d: "M10 2.5a7.47 7.47 0 0 1 4.231 1.31 7.268 7.268 0 0 1 2.703 3.454 7.128 7.128 0 0 1 .199 4.353c-.39 1.436-1.475 2.72-2.633 3.677h2.013c0-.226.092-.443.254-.603a.876.876 0 0 1 1.229 0c.163.16.254.377.254.603v.853c0 .209-.078.41-.22.567a.873.873 0 0 1-.547.28l-.101.006h-4.695a.517.517 0 0 1-.516-.518v-1.265c0-.21.128-.398.317-.489a5.601 5.601 0 0 0 2.492-2.371 5.459 5.459 0 0 0 .552-3.693 5.53 5.53 0 0 0-1.955-3.2A5.71 5.71 0 0 0 10 4.206 5.708 5.708 0 0 0 6.419 5.46 5.527 5.527 0 0 0 4.46 8.663a5.457 5.457 0 0 0 .554 3.695 5.6 5.6 0 0 0 2.497 2.37.55.55 0 0 1 .317.49v1.264c0 .286-.23.518-.516.518H2.618a.877.877 0 0 1-.614-.25.845.845 0 0 1-.254-.603v-.853c0-.226.091-.443.254-.603a.876.876 0 0 1 1.228 0c.163.16.255.377.255.603h1.925c-1.158-.958-2.155-2.241-2.545-3.678a7.128 7.128 0 0 1 .199-4.352 7.268 7.268 0 0 1 2.703-3.455A7.475 7.475 0 0 1 10 2.5z" })
    }
  );
}
const Wd = (n) => [
  {
    caption: n("special_characters.select_text"),
    id: fr.Text
  },
  {
    caption: n("special_characters.select_currency"),
    id: fr.Currency
  },
  {
    caption: n("special_characters.select_all"),
    id: fr.All
  }
], UP = (n) => {
  const [e, t] = ye(fr.All), [i, r] = ye(null), o = !(n != null && n.options.editable);
  return Ve(() => {
    const a = (l) => {
      if (!n) return null;
      n.chain().focus().insertContent(l).run();
    };
    return {
      toolbarRender: /* @__PURE__ */ b(
        xo,
        {
          className: W("group"),
          popoverClassName: "bg-background-secondary rounded-lg shadow-around-sm z-40 transition duration-200 ease-out",
          disabled: o,
          anchor: "bottom",
          label: /* @__PURE__ */ P("div", { className: "max-w-[280px] lg:max-w-[320px]", children: [
            /* @__PURE__ */ P(
              "div",
              {
                className: "border-text-secondary/30 flex items-center justify-between border-b pb-2",
                children: [
                  /* @__PURE__ */ b("span", { className: "text-text-primary text-base", children: O.t("special_characters.title") }),
                  /* @__PURE__ */ b(
                    Ec,
                    {
                      optionsClassName: "z-50",
                      onChange: (l) => l && t(l),
                      value: e,
                      data: Wd(O.t),
                      withoutCloseIcon: !0,
                      captionClassName: "no-underline"
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ b("div", { className: "customScroll flex max-h-[180px] flex-wrap gap-2 overflow-auto py-3", children: Si[e].map((l, c) => /* @__PURE__ */ b(
              "div",
              {
                className: "hover:border-brand-primary main-transition-colors h-[26px] w-[26px] cursor-pointer rounded-sm text-center",
                onClick: () => a(l.symbol),
                onMouseEnter: () => r(c),
                onMouseLeave: () => r(null),
                children: /* @__PURE__ */ b("span", { className: "text-text-primary text-base", children: l.symbol })
              },
              l.code
            )) }),
            /* @__PURE__ */ b("div", { className: "mt-3 flex h-5 items-center justify-between", children: i !== null && /* @__PURE__ */ P(dn, { children: [
              /* @__PURE__ */ b("span", { className: "text-xs", children: O.t(Si[e][i].name) }),
              " ",
              /* @__PURE__ */ b("span", { className: "text-xs", children: Si[e][i].code })
            ] }) })
          ] }),
          children: (l) => /* @__PURE__ */ b(
            te,
            {
              disabled: o,
              label: O.t("special_characters.title"),
              anchor: "left",
              ...ie,
              children: /* @__PURE__ */ b(Zt, { disabled: o, open: l, children: /* @__PURE__ */ b(
                Ud,
                {
                  className: Te(
                    o ? "fill-text-secondary" : "fill-text-primary group-hover:fill-brand-primary",
                    "main-transition-colors"
                  )
                }
              ) })
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ b(
        xo,
        {
          className: W("group"),
          popoverClassName: "bg-background-secondary rounded-lg shadow-around-sm z-40 transition duration-200 ease-out",
          disabled: o,
          anchor: "bottom",
          label: /* @__PURE__ */ P("div", { className: "max-w-[280px] lg:max-w-[320px]", children: [
            /* @__PURE__ */ P(
              "div",
              {
                className: "border-text-secondary/30 flex items-center justify-between border-b pb-2",
                children: [
                  /* @__PURE__ */ b("span", { className: "text-text-primary text-base", children: O.t("special_characters.title") }),
                  /* @__PURE__ */ b(
                    Ec,
                    {
                      optionsClassName: "z-50",
                      onChange: (l) => l && t(l),
                      value: e,
                      data: Wd(O.t),
                      withoutCloseIcon: !0,
                      captionClassName: "no-underline"
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ b("div", { className: "customScroll flex max-h-[180px] flex-wrap gap-2 overflow-auto py-3", children: Si[e].map((l, c) => /* @__PURE__ */ b(
              "div",
              {
                className: "hover:border-brand-primary main-transition-colors h-[26px] w-[26px] cursor-pointer rounded-sm text-center",
                onClick: () => a(l.symbol),
                onMouseEnter: () => r(c),
                onMouseLeave: () => r(null),
                children: /* @__PURE__ */ b("span", { className: "text-text-primary text-base", children: l.symbol })
              },
              l.code
            )) }),
            /* @__PURE__ */ b("div", { className: "mt-3 flex h-5 items-center justify-between", children: i !== null && /* @__PURE__ */ P(dn, { children: [
              /* @__PURE__ */ b("span", { className: "text-xs", children: O.t(Si[e][i].name) }),
              " ",
              /* @__PURE__ */ b("span", { className: "text-xs", children: Si[e][i].code })
            ] }) })
          ] }),
          children: (l) => /* @__PURE__ */ b(
            te,
            {
              disabled: o,
              label: O.t("special_characters.title"),
              anchor: "left",
              ...ie,
              children: /* @__PURE__ */ P(Zt, { className: "flex gap-1", disabled: o, open: l, children: [
                /* @__PURE__ */ b(
                  Ud,
                  {
                    className: Te(
                      o ? "fill-text-secondary" : "fill-text-primary group-hover:fill-brand-primary",
                      "main-transition-colors"
                    )
                  }
                ),
                O.t("special_characters.title")
              ] })
            }
          )
        }
      )
    };
  }, [n, i, o, e]);
}, WP = (n, e) => {
  const t = !(n != null && n.options.editable);
  return Ve(() => {
    const r = (o) => {
      if (!n) return null;
      o && n.chain().focus().insertContent(o).run();
    };
    return {
      toolbarRender: /* @__PURE__ */ b(
        Ht,
        {
          value: void 0,
          disabled: t,
          data: e,
          onChange: r,
          children: (o) => /* @__PURE__ */ b(
            te,
            {
              disabled: t,
              label: O.t("substitute_variables"),
              anchor: "left",
              ...ie,
              children: /* @__PURE__ */ b(Zt, { open: o, disabled: t, children: O.t("substitutions") })
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ b(
        Ht,
        {
          optionsClassName: "z-40",
          value: void 0,
          disabled: t,
          data: e,
          onChange: r,
          children: (o) => /* @__PURE__ */ b(
            te,
            {
              disabled: t,
              label: O.t("substitute_variables"),
              anchor: "left",
              ...ie,
              children: /* @__PURE__ */ b(Zt, { open: o, disabled: t, children: O.t("substitutions") })
            }
          )
        }
      )
    };
  }, [n, t, e]);
};
function oA(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M18 10H6M21 6H3M21 14H3M18 18H6",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
function sA(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "20",
      height: "14",
      viewBox: "0 0 20 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M19 5H1M19 13H1M19 1H1M19 9H1",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
function aA(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "19",
      height: "14",
      viewBox: "0 0 19 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M14 5H1M18 1H1M18 9H1M14 13H1",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
function lA(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "19",
      height: "14",
      viewBox: "0 0 19 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M18 5H5M18 1H1M18 9H1M18 13H5",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
const $l = (n) => {
  const e = (t) => {
    const i = W(
      "stroke-text-primary",
      "group-hover:stroke-background-secondary",
      n === t && "stroke-background-secondary"
    );
    switch (t) {
      case Ke.Left:
        return /* @__PURE__ */ b(aA, { className: i });
      case Ke.Right:
        return /* @__PURE__ */ b(lA, { className: i });
      case Ke.Center:
        return /* @__PURE__ */ b(oA, { className: i });
      case Ke.Justify:
        return /* @__PURE__ */ b(sA, { className: i });
    }
  };
  return Object.values(Ke).map((t) => ({
    id: t,
    caption: t,
    customCaption: e(t)
  }));
}, La = (n) => {
  if (!n) return Ke.Left;
  const e = $l().find(({ id: t }) => n.isActive({ textAlign: t }));
  return e ? e.id : Ke.Left;
}, KP = (n) => {
  const e = La(n), t = !(n != null && n.options.editable) || Tt(n);
  return Ve(() => {
    const r = () => {
      const s = he(t);
      switch (e) {
        case Ke.Right:
          return /* @__PURE__ */ b(lA, { className: s });
        case Ke.Center:
          return /* @__PURE__ */ b(oA, { className: s });
        case Ke.Justify:
          return /* @__PURE__ */ b(sA, { className: s });
        case Ke.Left:
        default:
          return /* @__PURE__ */ b(aA, { className: s });
      }
    }, o = (s) => {
      if (!n || !s) return null;
      n.chain().focus().setTextAlign(s).run();
    };
    return {
      toolbarRender: /* @__PURE__ */ b(
        Ht,
        {
          disabled: t,
          value: La(n),
          data: $l(e),
          onChange: o,
          optionClassName: "group",
          children: (s) => /* @__PURE__ */ b(
            te,
            {
              disabled: t,
              label: O.t("text_align"),
              anchor: "left",
              ...ie,
              children: /* @__PURE__ */ b(Zt, { disabled: t, open: s, children: r() })
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ b(
        Ht,
        {
          optionsClassName: "z-40",
          disabled: t,
          value: La(n),
          data: $l(e),
          onChange: o,
          optionClassName: "group",
          children: (s) => /* @__PURE__ */ P(
            Zt,
            {
              className: W("flex gap-1"),
              disabled: t,
              open: s,
              children: [
                r(),
                O.t("text_align")
              ]
            }
          )
        }
      )
    };
  }, [n, t, e]);
};
function Kd(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M10.6665 7.33334L1.33313 7.33334M6.66647 2.66667L5.33313 1.33334M9.33313 14.6667L1.33313 14.6667M14.6665 10.6667C14.6665 11.403 14.0695 12 13.3331 12C12.5968 12 11.9998 11.403 11.9998 10.6667C11.9998 9.93029 13.3331 8.66667 13.3331 8.66667C13.3331 8.66667 14.6665 9.93029 14.6665 10.6667ZM5.9998 2L10.5789 6.57909C10.8429 6.8431 10.9749 6.97511 11.0244 7.12732C11.0679 7.26122 11.0679 7.40545 11.0244 7.53935C10.9749 7.69157 10.8429 7.82357 10.5789 8.08758L7.50829 11.1582C6.98027 11.6862 6.71626 11.9502 6.41182 12.0491C6.14403 12.1361 5.85557 12.1361 5.58778 12.0491C5.28334 11.9502 5.01933 11.6862 4.4913 11.1582L2.17496 8.84183C1.64694 8.31381 1.38293 8.0498 1.28401 7.74536C1.197 7.47757 1.197 7.1891 1.28401 6.92131C1.38293 6.61688 1.64694 6.35286 2.17496 5.82484L5.9998 2Z",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
var ZP = { grad: 0.9, turn: 360, rad: 360 / (2 * Math.PI) }, en = function(n) {
  return typeof n == "string" ? n.length > 0 : typeof n == "number";
}, Ne = function(n, e, t) {
  return e === void 0 && (e = 0), t === void 0 && (t = Math.pow(10, e)), Math.round(t * n) / t + 0;
}, kt = function(n, e, t) {
  return e === void 0 && (e = 0), t === void 0 && (t = 1), n > t ? t : n > e ? n : e;
}, cA = function(n) {
  return (n = isFinite(n) ? n % 360 : 0) > 0 ? n : n + 360;
}, Zd = function(n) {
  return { r: kt(n.r, 0, 255), g: kt(n.g, 0, 255), b: kt(n.b, 0, 255), a: kt(n.a) };
}, Da = function(n) {
  return { r: Ne(n.r), g: Ne(n.g), b: Ne(n.b), a: Ne(n.a, 3) };
}, JP = /^#([0-9a-f]{3,8})$/i, ao = function(n) {
  var e = n.toString(16);
  return e.length < 2 ? "0" + e : e;
}, uA = function(n) {
  var e = n.r, t = n.g, i = n.b, r = n.a, o = Math.max(e, t, i), s = o - Math.min(e, t, i), a = s ? o === e ? (t - i) / s : o === t ? 2 + (i - e) / s : 4 + (e - t) / s : 0;
  return { h: 60 * (a < 0 ? a + 6 : a), s: o ? s / o * 100 : 0, v: o / 255 * 100, a: r };
}, dA = function(n) {
  var e = n.h, t = n.s, i = n.v, r = n.a;
  e = e / 360 * 6, t /= 100, i /= 100;
  var o = Math.floor(e), s = i * (1 - t), a = i * (1 - (e - o) * t), l = i * (1 - (1 - e + o) * t), c = o % 6;
  return { r: 255 * [i, a, s, s, l, i][c], g: 255 * [l, i, i, a, s, s][c], b: 255 * [s, s, l, i, i, a][c], a: r };
}, Jd = function(n) {
  return { h: cA(n.h), s: kt(n.s, 0, 100), l: kt(n.l, 0, 100), a: kt(n.a) };
}, Gd = function(n) {
  return { h: Ne(n.h), s: Ne(n.s), l: Ne(n.l), a: Ne(n.a, 3) };
}, Yd = function(n) {
  return dA((t = (e = n).s, { h: e.h, s: (t *= ((i = e.l) < 50 ? i : 100 - i) / 100) > 0 ? 2 * t / (i + t) * 100 : 0, v: i + t, a: e.a }));
  var e, t, i;
}, pr = function(n) {
  return { h: (e = uA(n)).h, s: (r = (200 - (t = e.s)) * (i = e.v) / 100) > 0 && r < 200 ? t * i / 100 / (r <= 100 ? r : 200 - r) * 100 : 0, l: r / 2, a: e.a };
  var e, t, i, r;
}, GP = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, YP = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, XP = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, QP = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, Xd = { string: [[function(n) {
  var e = JP.exec(n);
  return e ? (n = e[1]).length <= 4 ? { r: parseInt(n[0] + n[0], 16), g: parseInt(n[1] + n[1], 16), b: parseInt(n[2] + n[2], 16), a: n.length === 4 ? Ne(parseInt(n[3] + n[3], 16) / 255, 2) : 1 } : n.length === 6 || n.length === 8 ? { r: parseInt(n.substr(0, 2), 16), g: parseInt(n.substr(2, 2), 16), b: parseInt(n.substr(4, 2), 16), a: n.length === 8 ? Ne(parseInt(n.substr(6, 2), 16) / 255, 2) : 1 } : null : null;
}, "hex"], [function(n) {
  var e = XP.exec(n) || QP.exec(n);
  return e ? e[2] !== e[4] || e[4] !== e[6] ? null : Zd({ r: Number(e[1]) / (e[2] ? 100 / 255 : 1), g: Number(e[3]) / (e[4] ? 100 / 255 : 1), b: Number(e[5]) / (e[6] ? 100 / 255 : 1), a: e[7] === void 0 ? 1 : Number(e[7]) / (e[8] ? 100 : 1) }) : null;
}, "rgb"], [function(n) {
  var e = GP.exec(n) || YP.exec(n);
  if (!e) return null;
  var t, i, r = Jd({ h: (t = e[1], i = e[2], i === void 0 && (i = "deg"), Number(t) * (ZP[i] || 1)), s: Number(e[3]), l: Number(e[4]), a: e[5] === void 0 ? 1 : Number(e[5]) / (e[6] ? 100 : 1) });
  return Yd(r);
}, "hsl"]], object: [[function(n) {
  var e = n.r, t = n.g, i = n.b, r = n.a, o = r === void 0 ? 1 : r;
  return en(e) && en(t) && en(i) ? Zd({ r: Number(e), g: Number(t), b: Number(i), a: Number(o) }) : null;
}, "rgb"], [function(n) {
  var e = n.h, t = n.s, i = n.l, r = n.a, o = r === void 0 ? 1 : r;
  if (!en(e) || !en(t) || !en(i)) return null;
  var s = Jd({ h: Number(e), s: Number(t), l: Number(i), a: Number(o) });
  return Yd(s);
}, "hsl"], [function(n) {
  var e = n.h, t = n.s, i = n.v, r = n.a, o = r === void 0 ? 1 : r;
  if (!en(e) || !en(t) || !en(i)) return null;
  var s = (function(a) {
    return { h: cA(a.h), s: kt(a.s, 0, 100), v: kt(a.v, 0, 100), a: kt(a.a) };
  })({ h: Number(e), s: Number(t), v: Number(i), a: Number(o) });
  return dA(s);
}, "hsv"]] }, Qd = function(n, e) {
  for (var t = 0; t < e.length; t++) {
    var i = e[t][0](n);
    if (i) return [i, e[t][1]];
  }
  return [null, void 0];
}, ej = function(n) {
  return typeof n == "string" ? Qd(n.trim(), Xd.string) : typeof n == "object" && n !== null ? Qd(n, Xd.object) : [null, void 0];
}, Ra = function(n, e) {
  var t = pr(n);
  return { h: t.h, s: kt(t.s + 100 * e, 0, 100), l: t.l, a: t.a };
}, Ia = function(n) {
  return (299 * n.r + 587 * n.g + 114 * n.b) / 1e3 / 255;
}, eh = function(n, e) {
  var t = pr(n);
  return { h: t.h, s: t.s, l: kt(t.l + 100 * e, 0, 100), a: t.a };
}, th = (function() {
  function n(e) {
    this.parsed = ej(e)[0], this.rgba = this.parsed || { r: 0, g: 0, b: 0, a: 1 };
  }
  return n.prototype.isValid = function() {
    return this.parsed !== null;
  }, n.prototype.brightness = function() {
    return Ne(Ia(this.rgba), 2);
  }, n.prototype.isDark = function() {
    return Ia(this.rgba) < 0.5;
  }, n.prototype.isLight = function() {
    return Ia(this.rgba) >= 0.5;
  }, n.prototype.toHex = function() {
    return e = Da(this.rgba), t = e.r, i = e.g, r = e.b, s = (o = e.a) < 1 ? ao(Ne(255 * o)) : "", "#" + ao(t) + ao(i) + ao(r) + s;
    var e, t, i, r, o, s;
  }, n.prototype.toRgb = function() {
    return Da(this.rgba);
  }, n.prototype.toRgbString = function() {
    return e = Da(this.rgba), t = e.r, i = e.g, r = e.b, (o = e.a) < 1 ? "rgba(" + t + ", " + i + ", " + r + ", " + o + ")" : "rgb(" + t + ", " + i + ", " + r + ")";
    var e, t, i, r, o;
  }, n.prototype.toHsl = function() {
    return Gd(pr(this.rgba));
  }, n.prototype.toHslString = function() {
    return e = Gd(pr(this.rgba)), t = e.h, i = e.s, r = e.l, (o = e.a) < 1 ? "hsla(" + t + ", " + i + "%, " + r + "%, " + o + ")" : "hsl(" + t + ", " + i + "%, " + r + "%)";
    var e, t, i, r, o;
  }, n.prototype.toHsv = function() {
    return e = uA(this.rgba), { h: Ne(e.h), s: Ne(e.s), v: Ne(e.v), a: Ne(e.a, 3) };
    var e;
  }, n.prototype.invert = function() {
    return Lt({ r: 255 - (e = this.rgba).r, g: 255 - e.g, b: 255 - e.b, a: e.a });
    var e;
  }, n.prototype.saturate = function(e) {
    return e === void 0 && (e = 0.1), Lt(Ra(this.rgba, e));
  }, n.prototype.desaturate = function(e) {
    return e === void 0 && (e = 0.1), Lt(Ra(this.rgba, -e));
  }, n.prototype.grayscale = function() {
    return Lt(Ra(this.rgba, -1));
  }, n.prototype.lighten = function(e) {
    return e === void 0 && (e = 0.1), Lt(eh(this.rgba, e));
  }, n.prototype.darken = function(e) {
    return e === void 0 && (e = 0.1), Lt(eh(this.rgba, -e));
  }, n.prototype.rotate = function(e) {
    return e === void 0 && (e = 15), this.hue(this.hue() + e);
  }, n.prototype.alpha = function(e) {
    return typeof e == "number" ? Lt({ r: (t = this.rgba).r, g: t.g, b: t.b, a: e }) : Ne(this.rgba.a, 3);
    var t;
  }, n.prototype.hue = function(e) {
    var t = pr(this.rgba);
    return typeof e == "number" ? Lt({ h: e, s: t.s, l: t.l, a: t.a }) : Ne(t.h);
  }, n.prototype.isEqual = function(e) {
    return this.toHex() === Lt(e).toHex();
  }, n;
})(), Lt = function(n) {
  return n instanceof th ? n : new th(n);
};
const Sc = (n) => n && Lt(n).toHex(), tj = (n, e) => {
  const t = Sc(n == null ? void 0 : n.getAttributes("textStyle").backgroundColor) || mI, i = !(n != null && n.options.editable) || Tt(n), r = !!(n != null && n.getAttributes("textStyle").backgroundColor);
  return Ve(() => {
    const s = (u) => {
      if (!n) return null;
      n.chain().setBackgroundColor(u).run();
    }, a = () => {
      if (!n) return null;
      n.chain().focus().setBackgroundColor(t).run();
    }, l = () => {
      if (!n) return null;
      n.chain().focus().unsetBackgroundColor().run();
    }, c = () => /* @__PURE__ */ b(Dh, { features: Co.None, children: /* @__PURE__ */ P("div", { className: "flex gap-3", children: [
      /* @__PURE__ */ b(
        Oh,
        {
          className: "w-full",
          neutralType: zh.danger,
          disabled: !r,
          onClick: l,
          children: O.t("global.clear")
        }
      ),
      /* @__PURE__ */ b(wo, { className: "w-full", onClick: a, children: O.t("global.apply") })
    ] }) });
    return {
      toolbarRender: /* @__PURE__ */ b(
        So,
        {
          disabled: i,
          additionalPopoverChildren: c,
          color: t,
          onChange: s,
          children: () => /* @__PURE__ */ b(
            te,
            {
              disabled: i,
              label: O.t("background_color"),
              ...ie,
              children: /* @__PURE__ */ P(
                "div",
                {
                  className: W(
                    Rn,
                    "main-transition-colors gap-1.5",
                    "relative"
                  ),
                  children: [
                    /* @__PURE__ */ b(Kd, { className: he(i) }),
                    r && /* @__PURE__ */ b(
                      "div",
                      {
                        className: "absolute bottom-0 h-1 w-4 rounded-lg",
                        style: { backgroundColor: t }
                      }
                    )
                  ]
                }
              )
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ b(
        So,
        {
          disabled: i,
          focusTrapFeatures: Co.FocusLock,
          additionalPopoverChildren: c,
          color: t,
          onChange: s,
          children: () => /* @__PURE__ */ P(
            "div",
            {
              className: W(
                Rn,
                "gap-1.5",
                "relative",
                "flex gap-1",
                Iz(i)
              ),
              children: [
                /* @__PURE__ */ b(Kd, { className: he(i) }),
                O.t("background_color"),
                r && /* @__PURE__ */ b(
                  "div",
                  {
                    className: "absolute right-0 h-1.5 w-1.5 rounded-full",
                    style: { backgroundColor: t }
                  }
                )
              ]
            }
          )
        }
      )
    };
  }, [t, n, r, i, e]);
};
function nh(n) {
  return /* @__PURE__ */ P(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...n,
      children: [
        /* @__PURE__ */ b(
          "path",
          {
            d: "M1.33337 8C1.33337 11.6819 4.31814 14.6667 8.00004 14.6667C9.10461 14.6667 10 13.7712 10 12.6667V12.3333C10 12.0237 10 11.8689 10.0172 11.739C10.1353 10.8415 10.8415 10.1353 11.739 10.0171C11.869 10 12.0238 10 12.3334 10H12.6667C13.7713 10 14.6667 9.10457 14.6667 8C14.6667 4.3181 11.6819 1.33334 8.00004 1.33334C4.31814 1.33334 1.33337 4.3181 1.33337 8Z",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        ),
        /* @__PURE__ */ b(
          "path",
          {
            d: "M4.66671 8.66667C5.0349 8.66667 5.33337 8.36819 5.33337 8C5.33337 7.63181 5.0349 7.33334 4.66671 7.33334C4.29852 7.33334 4.00004 7.63181 4.00004 8C4.00004 8.36819 4.29852 8.66667 4.66671 8.66667Z",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        ),
        /* @__PURE__ */ b(
          "path",
          {
            d: "M10.6667 6C11.0349 6 11.3334 5.70153 11.3334 5.33334C11.3334 4.96515 11.0349 4.66667 10.6667 4.66667C10.2985 4.66667 10 4.96515 10 5.33334C10 5.70153 10.2985 6 10.6667 6Z",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        ),
        /* @__PURE__ */ b(
          "path",
          {
            d: "M6.66671 5.33334C7.0349 5.33334 7.33337 5.03486 7.33337 4.66667C7.33337 4.29848 7.0349 4 6.66671 4C6.29852 4 6.00004 4.29848 6.00004 4.66667C6.00004 5.03486 6.29852 5.33334 6.66671 5.33334Z",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        )
      ]
    }
  );
}
const nj = (n, e) => {
  const t = Sc(n == null ? void 0 : n.getAttributes("textStyle").color) || fI, i = !!(n != null && n.getAttributes("textStyle").color), r = !(n != null && n.options.editable) || Tt(n);
  return Ve(() => {
    const s = (u) => {
      if (!n) return null;
      n.chain().setColor(u).run();
    }, a = () => {
      if (!n) return null;
      n.chain().focus().setColor(t).run();
    }, l = () => {
      if (!n) return null;
      n.chain().focus().unsetColor().run();
    }, c = () => /* @__PURE__ */ b(Dh, { features: Co.None, children: /* @__PURE__ */ P("div", { className: "flex gap-3", children: [
      /* @__PURE__ */ b(
        Oh,
        {
          className: "w-full",
          neutralType: zh.danger,
          disabled: !i,
          onClick: l,
          children: O.t("global.clear")
        }
      ),
      /* @__PURE__ */ b(wo, { className: "w-full", onClick: a, children: O.t("global.apply") })
    ] }) });
    return {
      toolbarRender: /* @__PURE__ */ b(
        So,
        {
          color: t,
          onChange: s,
          additionalPopoverChildren: c,
          disabled: r,
          children: () => /* @__PURE__ */ b(
            te,
            {
              disabled: r,
              label: O.t("font_color"),
              ...ie,
              children: /* @__PURE__ */ P(
                "div",
                {
                  className: W(
                    Rn,
                    "main-transition-colors gap-1.5",
                    "relative"
                  ),
                  children: [
                    /* @__PURE__ */ b(nh, { className: he(r) }),
                    i && /* @__PURE__ */ b(
                      "div",
                      {
                        className: "absolute bottom-0 h-1 w-4 rounded-lg",
                        style: { backgroundColor: t }
                      }
                    )
                  ]
                }
              )
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ b(
        So,
        {
          focusTrapFeatures: Co.FocusLock,
          color: t,
          onChange: s,
          additionalPopoverChildren: c,
          disabled: r,
          children: () => /* @__PURE__ */ P(
            "div",
            {
              className: W(
                Rn,
                "gap-1.5",
                "relative",
                "flex gap-1",
                Iz(r)
              ),
              children: [
                /* @__PURE__ */ b(nh, { className: he(r) }),
                O.t("font_color"),
                i && /* @__PURE__ */ b(
                  "div",
                  {
                    className: "absolute right-0 h-1.5 w-1.5 rounded-full",
                    style: { backgroundColor: t }
                  }
                )
              ]
            }
          )
        }
      )
    };
  }, [t, n, i, r, e]);
};
function ij(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "11",
      height: "14",
      viewBox: "0 0 11 14",
      fill: "none",
      stroke: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M1 7H6.33333C7.80609 7 9 5.80609 9 4.33333C9 2.86057 7.80609 1.66666 6.33333 1.66666H1V7ZM1 7H7C8.47276 7 9.66667 8.1939 9.66667 9.66666C9.66667 11.1394 8.47276 12.3333 7 12.3333H1V7Z",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
function rj(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "12",
      height: "14",
      viewBox: "0 0 12 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M10.6667 1.66666H4.66671M7.33337 12.3333H1.33337M8.00004 1.66666L4.00004 12.3333",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
function oj(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "14",
      height: "14",
      viewBox: "0 0 14 14",
      fill: "none",
      stroke: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M3 9.66666C3 11.1394 4.19391 12.3333 5.66667 12.3333H8.33333C9.80609 12.3333 11 11.1394 11 9.66666C11 8.1939 9.80609 7 8.33333 7M11 4.33333C11 2.86057 9.80609 1.66666 8.33333 1.66666H5.66667C4.19391 1.66666 3 2.86057 3 4.33333M1 7H13",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
function sj(n) {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "14",
      height: "14",
      viewBox: "0 0 14 14",
      fill: "none",
      stroke: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M11 1.66666V6.33333C11 8.54247 9.2091 10.3333 6.99996 10.3333C4.79082 10.3333 2.99996 8.54247 2.99996 6.33333V1.66666M1.66663 13H12.3333",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
const aj = ({
  formatType: n,
  editor: e
}) => {
  if (e)
    switch (n) {
      case He.Bold:
        e.chain().focus().toggleBold().run();
        break;
      case He.Italic:
        e.chain().focus().toggleItalic().run();
        break;
      case He.Underline:
        e.chain().focus().toggleUnderline().run();
        break;
      case He.Strike:
        e.chain().focus().toggleStrike().run();
        break;
    }
}, lj = ({ formatType: n }) => {
  switch (n) {
    case He.Bold:
      return ij;
    case He.Italic:
      return rj;
    case He.Underline:
      return sj;
    case He.Strike:
      return oj;
  }
}, lo = (n, e, t) => {
  const i = !(n != null && n.options.editable) || Tt(n), r = n == null ? void 0 : n.isActive(e);
  return Ve(() => {
    const s = () => aj({ formatType: e, editor: n }), a = lj({ formatType: e });
    return {
      toolbarRender: /* @__PURE__ */ b(
        te,
        {
          disabled: i,
          label: `${O.t(`${e}`)} (${On($n[e].toggle)})`,
          ...ie,
          children: /* @__PURE__ */ b(
            ae,
            {
              disabled: i,
              onClick: s,
              className: W(
                r && "bg-brand-primary/10 main-transition-colors"
              ),
              children: /* @__PURE__ */ b(a, { className: he(i) })
            }
          )
        },
        e
      ),
      tooltipRender: /* @__PURE__ */ b(
        te,
        {
          disabled: i,
          label: On($n[e].toggle),
          ...ie,
          children: /* @__PURE__ */ P(
            ae,
            {
              disabled: i,
              onClick: s,
              className: W(
                r && "bg-brand-primary/10 main-transition-colors",
                "flex gap-1"
              ),
              children: [
                /* @__PURE__ */ b(a, { className: he(i) }),
                O.t(`${e}`)
              ]
            }
          )
        },
        e
      )
    };
  }, [n, e, r, i, t]);
}, cj = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, uj = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, dj = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, hj = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, fj = Wt.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (n) => n.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight=400",
        clearMark: (n) => n.type.name === this.name
      },
      {
        style: "font-weight",
        getAttrs: (n) => /^(bold(er)?|[5-9]\d{2,})$/.test(n) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["strong", ke(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setBold: () => ({ commands: n }) => n.setMark(this.name),
      toggleBold: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetBold: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      Tr({
        find: cj,
        type: this.type
      }),
      Tr({
        find: dj,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Ii({
        find: uj,
        type: this.type
      }),
      Ii({
        find: hj,
        type: this.type
      })
    ];
  }
}), pj = "listItem", ih = "textStyle", rh = /^\s*([-+*])\s$/, mj = St.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      { tag: "ul" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["ul", ke(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: n, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(pj, this.editor.getAttributes(ih)).run() : n.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let n = jo({
      find: rh,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (n = jo({
      find: rh,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(ih),
      editor: this.editor
    })), [
      n
    ];
  }
}), gj = Se.create({
  name: "characterCount",
  addOptions() {
    return {
      limit: null,
      mode: "textSize",
      textCounter: (n) => n.length,
      wordCounter: (n) => n.split(" ").filter((e) => e !== "").length
    };
  },
  addStorage() {
    return {
      characters: () => 0,
      words: () => 0
    };
  },
  onBeforeCreate() {
    this.storage.characters = (n) => {
      const e = (n == null ? void 0 : n.node) || this.editor.state.doc;
      if (((n == null ? void 0 : n.mode) || this.options.mode) === "textSize") {
        const i = e.textBetween(0, e.content.size, void 0, " ");
        return this.options.textCounter(i);
      }
      return e.nodeSize;
    }, this.storage.words = (n) => {
      const e = (n == null ? void 0 : n.node) || this.editor.state.doc, t = e.textBetween(0, e.content.size, " ", " ");
      return this.options.wordCounter(t);
    };
  },
  addProseMirrorPlugins() {
    let n = !1;
    return [
      new Ee({
        key: new Ue("characterCount"),
        appendTransaction: (e, t, i) => {
          if (n)
            return;
          const r = this.options.limit;
          if (r == null || r === 0) {
            n = !0;
            return;
          }
          const o = this.storage.characters({ node: i.doc });
          if (o > r) {
            const s = o - r, a = 0, l = s;
            console.warn(`[CharacterCount] Initial content exceeded limit of ${r} characters. Content was automatically trimmed.`);
            const c = i.tr.deleteRange(a, l);
            return n = !0, c;
          }
          n = !0;
        },
        filterTransaction: (e, t) => {
          const i = this.options.limit;
          if (!e.docChanged || i === 0 || i === null || i === void 0)
            return !0;
          const r = this.storage.characters({ node: t.doc }), o = this.storage.characters({ node: e.doc });
          if (o <= i || r > i && o > i && o <= r)
            return !0;
          if (r > i && o > i && o > r || !e.getMeta("paste"))
            return !1;
          const a = e.selection.$head.pos, l = o - i, c = a - l, u = a;
          return e.deleteRange(c, u), !(this.storage.characters({ node: e.doc }) > i);
        }
      })
    ];
  }
}), _j = St.create({
  name: "doc",
  topNode: !0,
  content: "block+"
});
function bj(n = {}) {
  return new Ee({
    view(e) {
      return new kj(e, n);
    }
  });
}
class kj {
  constructor(e, t) {
    var i;
    this.editorView = e, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (i = t.width) !== null && i !== void 0 ? i : 1, this.color = t.color === !1 ? void 0 : t.color || "black", this.class = t.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((r) => {
      let o = (s) => {
        this[r](s);
      };
      return e.dom.addEventListener(r, o), { name: r, handler: o };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: e, handler: t }) => this.editorView.dom.removeEventListener(e, t));
  }
  update(e, t) {
    this.cursorPos != null && t.doc != e.state.doc && (this.cursorPos > e.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(e) {
    e != this.cursorPos && (this.cursorPos = e, e == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let e = this.editorView.state.doc.resolve(this.cursorPos), t = !e.parent.inlineContent, i, r = this.editorView.dom, o = r.getBoundingClientRect(), s = o.width / r.offsetWidth, a = o.height / r.offsetHeight;
    if (t) {
      let d = e.nodeBefore, h = e.nodeAfter;
      if (d || h) {
        let f = this.editorView.nodeDOM(this.cursorPos - (d ? d.nodeSize : 0));
        if (f) {
          let p = f.getBoundingClientRect(), m = d ? p.bottom : p.top;
          d && h && (m = (m + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2);
          let g = this.width / 2 * a;
          i = { left: p.left, right: p.right, top: m - g, bottom: m + g };
        }
      }
    }
    if (!i) {
      let d = this.editorView.coordsAtPos(this.cursorPos), h = this.width / 2 * s;
      i = { left: d.left - h, right: d.left + h, top: d.top, bottom: d.bottom };
    }
    let l = this.editorView.dom.offsetParent;
    this.element || (this.element = l.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", t), this.element.classList.toggle("prosemirror-dropcursor-inline", !t);
    let c, u;
    if (!l || l == document.body && getComputedStyle(l).position == "static")
      c = -pageXOffset, u = -pageYOffset;
    else {
      let d = l.getBoundingClientRect(), h = d.width / l.offsetWidth, f = d.height / l.offsetHeight;
      c = d.left - l.scrollLeft * h, u = d.top - l.scrollTop * f;
    }
    this.element.style.left = (i.left - c) / s + "px", this.element.style.top = (i.top - u) / a + "px", this.element.style.width = (i.right - i.left) / s + "px", this.element.style.height = (i.bottom - i.top) / a + "px";
  }
  scheduleRemoval(e) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), e);
  }
  dragover(e) {
    if (!this.editorView.editable)
      return;
    let t = this.editorView.posAtCoords({ left: e.clientX, top: e.clientY }), i = t && t.inside >= 0 && this.editorView.state.doc.nodeAt(t.inside), r = i && i.type.spec.disableDropCursor, o = typeof r == "function" ? r(this.editorView, t, e) : r;
    if (t && !o) {
      let s = t.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let a = cf(this.editorView.state.doc, s, this.editorView.dragging.slice);
        a != null && (s = a);
      }
      this.setCursor(s), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(e) {
    this.editorView.dom.contains(e.relatedTarget) || this.setCursor(null);
  }
}
const yj = Se.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      bj(this.options)
    ];
  }
}), oh = St.create({
  name: "hardBreak",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  linebreakReplacement: !0,
  parseHTML() {
    return [
      { tag: "br" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["br", ke(this.options.HTMLAttributes, n)];
  },
  renderText() {
    return `
`;
  },
  addCommands() {
    return {
      setHardBreak: () => ({ commands: n, chain: e, state: t, editor: i }) => n.first([
        () => n.exitCode(),
        () => n.command(() => {
          const { selection: r, storedMarks: o } = t;
          if (r.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: s } = this.options, { splittableMarks: a } = i.extensionManager, l = o || r.$to.parentOffset && r.$from.marks();
          return e().insertContent({ type: this.name }).command(({ tr: c, dispatch: u }) => {
            if (u && l && s) {
              const d = l.filter((h) => a.includes(h.type.name));
              c.ensureMarks(d);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), vj = St.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((n) => ({
      tag: `h${n}`,
      attrs: { level: n }
    }));
  },
  renderHTML({ node: n, HTMLAttributes: e }) {
    return [`h${this.options.levels.includes(n.attrs.level) ? n.attrs.level : this.options.levels[0]}`, ke(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setHeading: (n) => ({ commands: e }) => this.options.levels.includes(n.level) ? e.setNode(this.name, n) : !1,
      toggleHeading: (n) => ({ commands: e }) => this.options.levels.includes(n.level) ? e.toggleNode(this.name, "paragraph", n) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce((n, e) => ({
      ...n,
      [`Mod-Alt-${e}`]: () => this.editor.commands.toggleHeading({ level: e })
    }), {});
  },
  addInputRules() {
    return this.options.levels.map((n) => q5({
      find: new RegExp(`^(#{${Math.min(...this.options.levels)},${n}})\\s$`),
      type: this.type,
      getAttributes: {
        level: n
      }
    }));
  }
});
var Ss = 200, Ie = function() {
};
Ie.prototype.append = function(e) {
  return e.length ? (e = Ie.from(e), !this.length && e || e.length < Ss && this.leafAppend(e) || this.length < Ss && e.leafPrepend(this) || this.appendInner(e)) : this;
};
Ie.prototype.prepend = function(e) {
  return e.length ? Ie.from(e).append(this) : this;
};
Ie.prototype.appendInner = function(e) {
  return new xj(this, e);
};
Ie.prototype.slice = function(e, t) {
  return e === void 0 && (e = 0), t === void 0 && (t = this.length), e >= t ? Ie.empty : this.sliceInner(Math.max(0, e), Math.min(this.length, t));
};
Ie.prototype.get = function(e) {
  if (!(e < 0 || e >= this.length))
    return this.getInner(e);
};
Ie.prototype.forEach = function(e, t, i) {
  t === void 0 && (t = 0), i === void 0 && (i = this.length), t <= i ? this.forEachInner(e, t, i, 0) : this.forEachInvertedInner(e, t, i, 0);
};
Ie.prototype.map = function(e, t, i) {
  t === void 0 && (t = 0), i === void 0 && (i = this.length);
  var r = [];
  return this.forEach(function(o, s) {
    return r.push(e(o, s));
  }, t, i), r;
};
Ie.from = function(e) {
  return e instanceof Ie ? e : e && e.length ? new hA(e) : Ie.empty;
};
var hA = /* @__PURE__ */ (function(n) {
  function e(i) {
    n.call(this), this.values = i;
  }
  n && (e.__proto__ = n), e.prototype = Object.create(n && n.prototype), e.prototype.constructor = e;
  var t = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return e.prototype.flatten = function() {
    return this.values;
  }, e.prototype.sliceInner = function(r, o) {
    return r == 0 && o == this.length ? this : new e(this.values.slice(r, o));
  }, e.prototype.getInner = function(r) {
    return this.values[r];
  }, e.prototype.forEachInner = function(r, o, s, a) {
    for (var l = o; l < s; l++)
      if (r(this.values[l], a + l) === !1)
        return !1;
  }, e.prototype.forEachInvertedInner = function(r, o, s, a) {
    for (var l = o - 1; l >= s; l--)
      if (r(this.values[l], a + l) === !1)
        return !1;
  }, e.prototype.leafAppend = function(r) {
    if (this.length + r.length <= Ss)
      return new e(this.values.concat(r.flatten()));
  }, e.prototype.leafPrepend = function(r) {
    if (this.length + r.length <= Ss)
      return new e(r.flatten().concat(this.values));
  }, t.length.get = function() {
    return this.values.length;
  }, t.depth.get = function() {
    return 0;
  }, Object.defineProperties(e.prototype, t), e;
})(Ie);
Ie.empty = new hA([]);
var xj = /* @__PURE__ */ (function(n) {
  function e(t, i) {
    n.call(this), this.left = t, this.right = i, this.length = t.length + i.length, this.depth = Math.max(t.depth, i.depth) + 1;
  }
  return n && (e.__proto__ = n), e.prototype = Object.create(n && n.prototype), e.prototype.constructor = e, e.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, e.prototype.getInner = function(i) {
    return i < this.left.length ? this.left.get(i) : this.right.get(i - this.left.length);
  }, e.prototype.forEachInner = function(i, r, o, s) {
    var a = this.left.length;
    if (r < a && this.left.forEachInner(i, r, Math.min(o, a), s) === !1 || o > a && this.right.forEachInner(i, Math.max(r - a, 0), Math.min(this.length, o) - a, s + a) === !1)
      return !1;
  }, e.prototype.forEachInvertedInner = function(i, r, o, s) {
    var a = this.left.length;
    if (r > a && this.right.forEachInvertedInner(i, r - a, Math.max(o, a) - a, s + a) === !1 || o < a && this.left.forEachInvertedInner(i, Math.min(r, a), o, s) === !1)
      return !1;
  }, e.prototype.sliceInner = function(i, r) {
    if (i == 0 && r == this.length)
      return this;
    var o = this.left.length;
    return r <= o ? this.left.slice(i, r) : i >= o ? this.right.slice(i - o, r - o) : this.left.slice(i, o).append(this.right.slice(0, r - o));
  }, e.prototype.leafAppend = function(i) {
    var r = this.right.leafAppend(i);
    if (r)
      return new e(this.left, r);
  }, e.prototype.leafPrepend = function(i) {
    var r = this.left.leafPrepend(i);
    if (r)
      return new e(r, this.right);
  }, e.prototype.appendInner = function(i) {
    return this.left.depth >= Math.max(this.right.depth, i.depth) + 1 ? new e(this.left, new e(this.right, i)) : new e(this, i);
  }, e;
})(Ie);
const Sj = 500;
class Mt {
  constructor(e, t) {
    this.items = e, this.eventCount = t;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(e, t) {
    if (this.eventCount == 0)
      return null;
    let i = this.items.length;
    for (; ; i--)
      if (this.items.get(i - 1).selection) {
        --i;
        break;
      }
    let r, o;
    t && (r = this.remapping(i, this.items.length), o = r.maps.length);
    let s = e.tr, a, l, c = [], u = [];
    return this.items.forEach((d, h) => {
      if (!d.step) {
        r || (r = this.remapping(i, h + 1), o = r.maps.length), o--, u.push(d);
        return;
      }
      if (r) {
        u.push(new It(d.map));
        let f = d.step.map(r.slice(o)), p;
        f && s.maybeStep(f).doc && (p = s.mapping.maps[s.mapping.maps.length - 1], c.push(new It(p, void 0, void 0, c.length + u.length))), o--, p && r.appendMap(p, o);
      } else
        s.maybeStep(d.step);
      if (d.selection)
        return a = r ? d.selection.map(r.slice(o)) : d.selection, l = new Mt(this.items.slice(0, i).append(u.reverse().concat(c)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: l, transform: s, selection: a };
  }
  // Create a new branch with the given transform added.
  addTransform(e, t, i, r) {
    let o = [], s = this.eventCount, a = this.items, l = !r && a.length ? a.get(a.length - 1) : null;
    for (let u = 0; u < e.steps.length; u++) {
      let d = e.steps[u].invert(e.docs[u]), h = new It(e.mapping.maps[u], d, t), f;
      (f = l && l.merge(h)) && (h = f, u ? o.pop() : a = a.slice(0, a.length - 1)), o.push(h), t && (s++, t = void 0), r || (l = h);
    }
    let c = s - i.depth;
    return c > Cj && (a = wj(a, c), s -= c), new Mt(a.append(o), s);
  }
  remapping(e, t) {
    let i = new kr();
    return this.items.forEach((r, o) => {
      let s = r.mirrorOffset != null && o - r.mirrorOffset >= e ? i.maps.length - r.mirrorOffset : void 0;
      i.appendMap(r.map, s);
    }, e, t), i;
  }
  addMaps(e) {
    return this.eventCount == 0 ? this : new Mt(this.items.append(e.map((t) => new It(t))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(e, t) {
    if (!this.eventCount)
      return this;
    let i = [], r = Math.max(0, this.items.length - t), o = e.mapping, s = e.steps.length, a = this.eventCount;
    this.items.forEach((h) => {
      h.selection && a--;
    }, r);
    let l = t;
    this.items.forEach((h) => {
      let f = o.getMirror(--l);
      if (f == null)
        return;
      s = Math.min(s, f);
      let p = o.maps[f];
      if (h.step) {
        let m = e.steps[f].invert(e.docs[f]), g = h.selection && h.selection.map(o.slice(l + 1, f));
        g && a++, i.push(new It(p, m, g));
      } else
        i.push(new It(p));
    }, r);
    let c = [];
    for (let h = t; h < s; h++)
      c.push(new It(o.maps[h]));
    let u = this.items.slice(0, r).append(c).append(i), d = new Mt(u, a);
    return d.emptyItemCount() > Sj && (d = d.compress(this.items.length - i.length)), d;
  }
  emptyItemCount() {
    let e = 0;
    return this.items.forEach((t) => {
      t.step || e++;
    }), e;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(e = this.items.length) {
    let t = this.remapping(0, e), i = t.maps.length, r = [], o = 0;
    return this.items.forEach((s, a) => {
      if (a >= e)
        r.push(s), s.selection && o++;
      else if (s.step) {
        let l = s.step.map(t.slice(i)), c = l && l.getMap();
        if (i--, c && t.appendMap(c, i), l) {
          let u = s.selection && s.selection.map(t.slice(i));
          u && o++;
          let d = new It(c.invert(), l, u), h, f = r.length - 1;
          (h = r.length && r[f].merge(d)) ? r[f] = h : r.push(d);
        }
      } else s.map && i--;
    }, this.items.length, 0), new Mt(Ie.from(r.reverse()), o);
  }
}
Mt.empty = new Mt(Ie.empty, 0);
function wj(n, e) {
  let t;
  return n.forEach((i, r) => {
    if (i.selection && e-- == 0)
      return t = r, !1;
  }), n.slice(t);
}
class It {
  constructor(e, t, i, r) {
    this.map = e, this.step = t, this.selection = i, this.mirrorOffset = r;
  }
  merge(e) {
    if (this.step && e.step && !e.selection) {
      let t = e.step.merge(this.step);
      if (t)
        return new It(t.getMap().invert(), t, this.selection);
    }
  }
}
class Sn {
  constructor(e, t, i, r, o) {
    this.done = e, this.undone = t, this.prevRanges = i, this.prevTime = r, this.prevComposition = o;
  }
}
const Cj = 20;
function Tj(n, e, t, i) {
  let r = t.getMeta(ai), o;
  if (r)
    return r.historyState;
  t.getMeta($j) && (n = new Sn(n.done, n.undone, null, 0, -1));
  let s = t.getMeta("appendedTransaction");
  if (t.steps.length == 0)
    return n;
  if (s && s.getMeta(ai))
    return s.getMeta(ai).redo ? new Sn(n.done.addTransform(t, void 0, i, vo(e)), n.undone, sh(t.mapping.maps), n.prevTime, n.prevComposition) : new Sn(n.done, n.undone.addTransform(t, void 0, i, vo(e)), null, n.prevTime, n.prevComposition);
  if (t.getMeta("addToHistory") !== !1 && !(s && s.getMeta("addToHistory") === !1)) {
    let a = t.getMeta("composition"), l = n.prevTime == 0 || !s && n.prevComposition != a && (n.prevTime < (t.time || 0) - i.newGroupDelay || !Mj(t, n.prevRanges)), c = s ? Pa(n.prevRanges, t.mapping) : sh(t.mapping.maps);
    return new Sn(n.done.addTransform(t, l ? e.selection.getBookmark() : void 0, i, vo(e)), Mt.empty, c, t.time, a ?? n.prevComposition);
  } else return (o = t.getMeta("rebased")) ? new Sn(n.done.rebased(t, o), n.undone.rebased(t, o), Pa(n.prevRanges, t.mapping), n.prevTime, n.prevComposition) : new Sn(n.done.addMaps(t.mapping.maps), n.undone.addMaps(t.mapping.maps), Pa(n.prevRanges, t.mapping), n.prevTime, n.prevComposition);
}
function Mj(n, e) {
  if (!e)
    return !1;
  if (!n.docChanged)
    return !0;
  let t = !1;
  return n.mapping.maps[0].forEach((i, r) => {
    for (let o = 0; o < e.length; o += 2)
      i <= e[o + 1] && r >= e[o] && (t = !0);
  }), t;
}
function sh(n) {
  let e = [];
  for (let t = n.length - 1; t >= 0 && e.length == 0; t--)
    n[t].forEach((i, r, o, s) => e.push(o, s));
  return e;
}
function Pa(n, e) {
  if (!n)
    return null;
  let t = [];
  for (let i = 0; i < n.length; i += 2) {
    let r = e.map(n[i], 1), o = e.map(n[i + 1], -1);
    r <= o && t.push(r, o);
  }
  return t;
}
function Ej(n, e, t) {
  let i = vo(e), r = ai.get(e).spec.config, o = (t ? n.undone : n.done).popEvent(e, i);
  if (!o)
    return null;
  let s = o.selection.resolve(o.transform.doc), a = (t ? n.done : n.undone).addTransform(o.transform, e.selection.getBookmark(), r, i), l = new Sn(t ? a : o.remaining, t ? o.remaining : a, null, 0, -1);
  return o.transform.setSelection(s).setMeta(ai, { redo: t, historyState: l });
}
let ja = !1, ah = null;
function vo(n) {
  let e = n.plugins;
  if (ah != e) {
    ja = !1, ah = e;
    for (let t = 0; t < e.length; t++)
      if (e[t].spec.historyPreserveItems) {
        ja = !0;
        break;
      }
  }
  return ja;
}
const ai = new Ue("history"), $j = new Ue("closeHistory");
function Oj(n = {}) {
  return n = {
    depth: n.depth || 100,
    newGroupDelay: n.newGroupDelay || 500
  }, new Ee({
    key: ai,
    state: {
      init() {
        return new Sn(Mt.empty, Mt.empty, null, 0, -1);
      },
      apply(e, t, i) {
        return Tj(t, i, e, n);
      }
    },
    config: n,
    props: {
      handleDOMEvents: {
        beforeinput(e, t) {
          let i = t.inputType, r = i == "historyUndo" ? pA : i == "historyRedo" ? mA : null;
          return r ? (t.preventDefault(), r(e.state, e.dispatch)) : !1;
        }
      }
    }
  });
}
function fA(n, e) {
  return (t, i) => {
    let r = ai.getState(t);
    if (!r || (n ? r.undone : r.done).eventCount == 0)
      return !1;
    if (i) {
      let o = Ej(r, t, n);
      o && i(e ? o.scrollIntoView() : o);
    }
    return !0;
  };
}
const pA = fA(!1, !0), mA = fA(!0, !0), zj = Se.create({
  name: "history",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: n, dispatch: e }) => pA(n, e),
      redo: () => ({ state: n, dispatch: e }) => mA(n, e)
    };
  },
  addProseMirrorPlugins() {
    return [
      Oj(this.options)
    ];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
}), Aj = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, Nj = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, Lj = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, Dj = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, Rj = Wt.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (n) => n.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=normal",
        clearMark: (n) => n.type.name === this.name
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["em", ke(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: n }) => n.setMark(this.name),
      toggleItalic: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetItalic: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      Tr({
        find: Aj,
        type: this.type
      }),
      Tr({
        find: Lj,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Ii({
        find: Nj,
        type: this.type
      }),
      Ii({
        find: Dj,
        type: this.type
      })
    ];
  }
}), Ij = "listItem", lh = "textStyle", ch = /^(\d+)\.\s$/, Pj = St.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (n) => n.hasAttribute("start") ? parseInt(n.getAttribute("start") || "", 10) : 1
      },
      type: {
        default: null,
        parseHTML: (n) => n.getAttribute("type")
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    const { start: e, ...t } = n;
    return e === 1 ? ["ol", ke(this.options.HTMLAttributes, t), 0] : ["ol", ke(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: n, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(Ij, this.editor.getAttributes(lh)).run() : n.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let n = jo({
      find: ch,
      type: this.type,
      getAttributes: (e) => ({ start: +e[1] }),
      joinPredicate: (e, t) => t.childCount + t.attrs.start === +e[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (n = jo({
      find: ch,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (e) => ({ start: +e[1], ...this.editor.getAttributes(lh) }),
      joinPredicate: (e, t) => t.childCount + t.attrs.start === +e[1],
      editor: this.editor
    })), [
      n
    ];
  }
}), jj = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/, Bj = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g, Fj = Wt.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (n) => n.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["s", ke(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setStrike: () => ({ commands: n }) => n.setMark(this.name),
      toggleStrike: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetStrike: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      Tr({
        find: jj,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Ii({
        find: Bj,
        type: this.type
      })
    ];
  }
}), qj = St.create({
  name: "text",
  group: "inline"
}), Hj = Se.create({
  name: "textAlign",
  addOptions() {
    return {
      types: [],
      alignments: ["left", "center", "right", "justify"],
      defaultAlignment: null
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          textAlign: {
            default: this.options.defaultAlignment,
            parseHTML: (n) => {
              const e = n.style.textAlign;
              return this.options.alignments.includes(e) ? e : this.options.defaultAlignment;
            },
            renderHTML: (n) => n.textAlign ? { style: `text-align: ${n.textAlign}` } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setTextAlign: (n) => ({ commands: e }) => this.options.alignments.includes(n) ? this.options.types.map((t) => e.updateAttributes(t, { textAlign: n })).every((t) => t) : !1,
      unsetTextAlign: () => ({ commands: n }) => this.options.types.map((e) => n.resetAttributes(e, "textAlign")).every((e) => e)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-l": () => this.editor.commands.setTextAlign("left"),
      "Mod-Shift-e": () => this.editor.commands.setTextAlign("center"),
      "Mod-Shift-r": () => this.editor.commands.setTextAlign("right"),
      "Mod-Shift-j": () => this.editor.commands.setTextAlign("justify")
    };
  }
}), Vj = Wt.create({
  name: "underline",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "u"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (n) => n.includes("underline") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["u", ke(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setUnderline: () => ({ commands: n }) => n.setMark(this.name),
      toggleUnderline: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetUnderline: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-u": () => this.editor.commands.toggleUnderline(),
      "Mod-U": () => this.editor.commands.toggleUnderline()
    };
  }
}), Uj = (n) => {
  if (!n.children.length)
    return;
  const e = n.querySelectorAll("span");
  e && e.forEach((t) => {
    var i, r;
    const o = t.getAttribute("style"), s = (r = (i = t.parentElement) === null || i === void 0 ? void 0 : i.closest("span")) === null || r === void 0 ? void 0 : r.getAttribute("style");
    t.setAttribute("style", `${s};${o}`);
  });
}, Wj = Wt.create({
  name: "textStyle",
  priority: 101,
  addOptions() {
    return {
      HTMLAttributes: {},
      mergeNestedSpanStyles: !1
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        getAttrs: (n) => n.hasAttribute("style") ? (this.options.mergeNestedSpanStyles && Uj(n), {}) : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["span", ke(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      removeEmptyTextStyle: () => ({ tr: n }) => {
        const { selection: e } = n;
        return n.doc.nodesBetween(e.from, e.to, (t, i) => {
          if (t.isTextblock)
            return !0;
          t.marks.filter((r) => r.type === this.type).some((r) => Object.values(r.attrs).some((o) => !!o)) || n.removeMark(i, i + t.nodeSize, this.type);
        }), !0;
      }
    };
  }
}), Ks = (n, e, t, i) => {
  const { selection: r } = e, { from: o, to: s } = r, a = [];
  return e.doc.nodesBetween(o, s, (l, c) => {
    l.isText && l.marks.forEach((u) => {
      u.type.name === "textStyle" && u.attrs[n] && a.push({ mark: u, pos: c, size: l.nodeSize });
    });
  }), a.forEach(({ mark: l, pos: c, size: u }) => {
    const d = { ...l.attrs, [n]: null }, h = Math.max(o, c), f = Math.min(s, c + u);
    if (t.removeMark(h, f, l.type), Object.entries(d).some(
      ([m, g]) => m !== n && g !== null && g !== void 0
    )) {
      const m = e.schema.marks.textStyle.create(d);
      t.addMark(h, f, m);
    }
  }), i && i(t), !0;
}, Kj = Se.create({
  name: "fontFamily",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontFamily: {
            default: null,
            parseHTML: (n) => {
              var e;
              return (e = n.style.fontFamily) == null ? void 0 : e.replace(/['"]+/g, "");
            },
            renderHTML: (n) => n.fontFamily ? {
              style: `font-family: ${n.fontFamily}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontFamily: (n) => ({ chain: e }) => e().setMark("textStyle", { fontFamily: n }).run(),
      unsetFontFamily: () => ({ tr: n, state: e, dispatch: t }) => Ks("fontFamily", e, n, t)
    };
  }
}), Zj = new Ue("defaultFontSize"), Jj = Se.create({
  name: "fontSize",
  addOptions() {
    return {
      types: ["textStyle"],
      defaultFontSize: null
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            default: null,
            parseHTML: (n) => n.style.fontSize.replace(/['"]+/g, ""),
            renderHTML: (n) => n.fontSize ? {
              style: `font-size: ${n.fontSize}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontSize: (n) => ({ chain: e }) => e().setMark("textStyle", { fontSize: n }).run(),
      unsetFontSize: () => ({ tr: n, state: e, dispatch: t }) => Ks("fontSize", e, n, t)
    };
  },
  addProseMirrorPlugins() {
    const n = this.options.defaultFontSize;
    return n ? [
      new Ee({
        key: Zj,
        appendTransaction: (e, t, i) => {
          if (!e.some((a) => a.docChanged))
            return null;
          const o = i.tr;
          let s = !1;
          return i.doc.descendants((a, l) => {
            if (!a.isText)
              return;
            const u = i.doc.resolve(l).parent, d = u.type.name === "paragraph", h = u.type.name === "listItem", f = u.type.name === "heading";
            if (!d && !h || f)
              return;
            const p = a.marks.find((g) => g.type.name === "textStyle");
            if (!(p == null ? void 0 : p.attrs.fontSize)) {
              const g = l, k = l + a.nodeSize, x = i.schema.marks.textStyle.create({
                ...p == null ? void 0 : p.attrs,
                fontSize: n
              });
              o.addMark(g, k, x), s = !0;
            }
          }), s ? o : null;
        }
      })
    ] : [];
  }
}), Gj = St.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["li", ke(this.options.HTMLAttributes, n), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), Yj = new Ue("listItemStyle"), Xj = ({ node: n }) => {
  const e = {};
  return n.attrs.fontSize && (e.fontSize = n.attrs.fontSize), n.attrs.fontFamily && (e.fontFamily = n.attrs.fontFamily), n.attrs.color && (e.color = n.attrs.color), n.attrs.textAlign && (e.textAlign = n.attrs.textAlign), /* @__PURE__ */ b(fc, { as: "li", style: e, children: /* @__PURE__ */ b(Hs, {}) });
}, Qj = Gj.extend({
  content: "block*",
  addAttributes() {
    var n;
    return {
      ...(n = this.parent) == null ? void 0 : n.call(this),
      fontSize: {
        default: null,
        parseHTML: () => null,
        renderHTML: () => ({})
      },
      fontFamily: {
        default: null,
        parseHTML: () => null,
        renderHTML: () => ({})
      },
      color: {
        default: null,
        parseHTML: () => null,
        renderHTML: () => ({})
      }
    };
  },
  addNodeView() {
    return qi(Xj);
  },
  addProseMirrorPlugins() {
    return [
      new Ee({
        key: Yj,
        appendTransaction: (n, e, t) => {
          if (!n.some((l) => l.docChanged))
            return null;
          const r = t.tr;
          let o = !1;
          const s = (l) => l == null ? void 0 : l.find((c) => c.type.name === "textStyle"), a = (l) => {
            const c = l.firstChild;
            if (!c)
              return null;
            if (c.isText)
              return s(c.marks);
            const u = c.firstChild;
            return u != null && u.isText ? s(u.marks) : null;
          };
          return t.doc.descendants((l, c) => {
            if (l.type.name === "listItem") {
              let u = null, d = null, h = null;
              const f = a(l), p = t.selection, g = p.anchor >= c && p.anchor < c + l.nodeSize || p.head >= c && p.head < c + l.nodeSize ? s(t.storedMarks) : null, k = f || g;
              k && (u = k.attrs.fontSize, d = k.attrs.fontFamily, h = k.attrs.color), (l.attrs.fontSize !== u || l.attrs.fontFamily !== d || l.attrs.color !== h) && (r.setNodeMarkup(c, void 0, {
                ...l.attrs,
                fontSize: u,
                fontFamily: d,
                color: h
              }), o = !0);
            }
          }), o ? r : null;
        }
      })
    ];
  },
  renderHTML({ HTMLAttributes: n, node: e }) {
    const t = {};
    return e.attrs.fontSize && (t.fontSize = e.attrs.fontSize), e.attrs.fontFamily && (t.fontFamily = e.attrs.fontFamily), e.attrs.color && (t.color = e.attrs.color), e.attrs.textAlign && (t.textAlign = e.attrs.textAlign), [
      "li",
      ke(n, {
        ...Object.keys(t).length > 0 ? { style: $t(t) } : {}
      }),
      0
    ];
  }
}), gA = ({
  editor: n,
  getPos: e,
  nodeName: t
}) => {
  const [i, r] = ye(0);
  return Je(() => {
    const s = (() => {
      let a = 0;
      const l = n.state.doc.resolve(e());
      for (let c = l.depth; c >= 0; c--) {
        const u = l.node(c);
        t ? (u == null ? void 0 : u.type.name) === t && a++ : a++;
      }
      return a;
    })();
    i !== s && r(s);
  }, [n.state.doc, e, t, i]), { realDepth: i };
}, e8 = ({ getPos: n, editor: e, updateAttributes: t }) => {
  const { realDepth: i } = gA({ editor: e, getPos: n, nodeName: "bulletList" });
  return Je(() => {
    setTimeout(() => {
      t({ depth: i });
    });
  }, [i, t]), /* @__PURE__ */ b(
    fc,
    {
      as: "ul",
      style: {
        ...Wo,
        listStyleType: iA(i)
      },
      children: /* @__PURE__ */ b(Hs, {})
    }
  );
}, t8 = ({ getPos: n, editor: e, updateAttributes: t }) => {
  const { realDepth: i } = gA({ editor: e, getPos: n, nodeName: "orderedList" });
  return Je(() => {
    setTimeout(() => {
      t({ depth: i });
    });
  }, [i, t]), /* @__PURE__ */ b(
    fc,
    {
      as: "ol",
      style: {
        ...Wo,
        listStyleType: rA(i)
      },
      children: /* @__PURE__ */ b(Hs, {})
    }
  );
}, n8 = Se.create({
  name: "backgroundColor",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          backgroundColor: {
            default: null,
            parseHTML: (n) => n.style.backgroundColor,
            renderHTML: (n) => n.backgroundColor ? {
              style: `background-color: ${n.backgroundColor}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setBackgroundColor: (n) => ({ chain: e }) => e().setMark("textStyle", { backgroundColor: n }).run(),
      unsetBackgroundColor: () => ({ tr: n, state: e, dispatch: t }) => Ks("backgroundColor", e, n, t)
    };
  }
}), i8 = Se.create({
  name: "color",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          color: {
            default: null,
            parseHTML: (n) => {
              var e;
              return (e = n.style.color) == null ? void 0 : e.replace(/['"]+/g, "");
            },
            renderHTML: (n) => n.color ? {
              style: `color: ${n.color}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setColor: (n) => ({ chain: e }) => e().setMark("textStyle", { color: n }).run(),
      unsetColor: () => ({ tr: n, state: e, dispatch: t }) => Ks("color", e, n, t)
    };
  }
});
var r8 = /* @__PURE__ */ (function() {
  var n = function(e, t) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(i, r) {
      i.__proto__ = r;
    } || function(i, r) {
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (i[o] = r[o]);
    }, n(e, t);
  };
  return function(e, t) {
    n(e, t);
    function i() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (i.prototype = t.prototype, new i());
  };
})(), Ce = function() {
  return Ce = Object.assign || function(n) {
    for (var e, t = 1, i = arguments.length; t < i; t++) {
      e = arguments[t];
      for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
    }
    return n;
  }, Ce.apply(this, arguments);
}, uh = {
  width: "100%",
  height: "10px",
  top: "0px",
  left: "0px",
  cursor: "row-resize"
}, dh = {
  width: "10px",
  height: "100%",
  top: "0px",
  left: "0px",
  cursor: "col-resize"
}, co = {
  width: "20px",
  height: "20px",
  position: "absolute"
}, o8 = {
  top: Ce(Ce({}, uh), { top: "-5px" }),
  right: Ce(Ce({}, dh), { left: void 0, right: "-5px" }),
  bottom: Ce(Ce({}, uh), { top: void 0, bottom: "-5px" }),
  left: Ce(Ce({}, dh), { left: "-5px" }),
  topRight: Ce(Ce({}, co), { right: "-10px", top: "-10px", cursor: "ne-resize" }),
  bottomRight: Ce(Ce({}, co), { right: "-10px", bottom: "-10px", cursor: "se-resize" }),
  bottomLeft: Ce(Ce({}, co), { left: "-10px", bottom: "-10px", cursor: "sw-resize" }),
  topLeft: Ce(Ce({}, co), { left: "-10px", top: "-10px", cursor: "nw-resize" })
}, s8 = (
  /** @class */
  (function(n) {
    r8(e, n);
    function e() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t.onMouseDown = function(i) {
        t.props.onResizeStart(i, t.props.direction);
      }, t.onTouchStart = function(i) {
        t.props.onResizeStart(i, t.props.direction);
      }, t;
    }
    return e.prototype.render = function() {
      return Jn.createElement("div", { className: this.props.className || "", style: Ce(Ce({ position: "absolute", userSelect: "none" }, o8[this.props.direction]), this.props.replaceStyles || {}), onMouseDown: this.onMouseDown, onTouchStart: this.onTouchStart }, this.props.children);
    }, e;
  })(Jn.PureComponent)
), a8 = /* @__PURE__ */ (function() {
  var n = function(e, t) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(i, r) {
      i.__proto__ = r;
    } || function(i, r) {
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (i[o] = r[o]);
    }, n(e, t);
  };
  return function(e, t) {
    n(e, t);
    function i() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (i.prototype = t.prototype, new i());
  };
})(), Pt = function() {
  return Pt = Object.assign || function(n) {
    for (var e, t = 1, i = arguments.length; t < i; t++) {
      e = arguments[t];
      for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
    }
    return n;
  }, Pt.apply(this, arguments);
}, l8 = {
  width: "auto",
  height: "auto"
}, uo = function(n, e, t) {
  return Math.max(Math.min(n, t), e);
}, hh = function(n, e, t) {
  var i = Math.round(n / e);
  return i * e + t * (i - 1);
}, wi = function(n, e) {
  return new RegExp(n, "i").test(e);
}, ho = function(n) {
  return !!(n.touches && n.touches.length);
}, c8 = function(n) {
  return !!((n.clientX || n.clientX === 0) && (n.clientY || n.clientY === 0));
}, fh = function(n, e, t) {
  t === void 0 && (t = 0);
  var i = e.reduce(function(o, s, a) {
    return Math.abs(s - n) < Math.abs(e[o] - n) ? a : o;
  }, 0), r = Math.abs(e[i] - n);
  return t === 0 || r < t ? e[i] : n;
}, Ba = function(n) {
  return n = n.toString(), n === "auto" || n.endsWith("px") || n.endsWith("%") || n.endsWith("vh") || n.endsWith("vw") || n.endsWith("vmax") || n.endsWith("vmin") ? n : n + "px";
}, fo = function(n, e, t, i) {
  if (n && typeof n == "string") {
    if (n.endsWith("px"))
      return Number(n.replace("px", ""));
    if (n.endsWith("%")) {
      var r = Number(n.replace("%", "")) / 100;
      return e * r;
    }
    if (n.endsWith("vw")) {
      var r = Number(n.replace("vw", "")) / 100;
      return t * r;
    }
    if (n.endsWith("vh")) {
      var r = Number(n.replace("vh", "")) / 100;
      return i * r;
    }
  }
  return n;
}, u8 = function(n, e, t, i, r, o, s) {
  return i = fo(i, n.width, e, t), r = fo(r, n.height, e, t), o = fo(o, n.width, e, t), s = fo(s, n.height, e, t), {
    maxWidth: typeof i > "u" ? void 0 : Number(i),
    maxHeight: typeof r > "u" ? void 0 : Number(r),
    minWidth: typeof o > "u" ? void 0 : Number(o),
    minHeight: typeof s > "u" ? void 0 : Number(s)
  };
}, d8 = function(n) {
  return Array.isArray(n) ? n : [n, n];
}, h8 = [
  "as",
  "ref",
  "style",
  "className",
  "grid",
  "gridGap",
  "snap",
  "bounds",
  "boundsByDirection",
  "size",
  "defaultSize",
  "minWidth",
  "minHeight",
  "maxWidth",
  "maxHeight",
  "lockAspectRatio",
  "lockAspectRatioExtraWidth",
  "lockAspectRatioExtraHeight",
  "enable",
  "handleStyles",
  "handleClasses",
  "handleWrapperStyle",
  "handleWrapperClass",
  "children",
  "onResizeStart",
  "onResize",
  "onResizeStop",
  "handleComponent",
  "scale",
  "resizeRatio",
  "snapGap"
], ph = "__resizable_base__", f8 = (
  /** @class */
  (function(n) {
    a8(e, n);
    function e(t) {
      var i, r, o, s, a = n.call(this, t) || this;
      return a.ratio = 1, a.resizable = null, a.parentLeft = 0, a.parentTop = 0, a.resizableLeft = 0, a.resizableRight = 0, a.resizableTop = 0, a.resizableBottom = 0, a.targetLeft = 0, a.targetTop = 0, a.appendBase = function() {
        if (!a.resizable || !a.window)
          return null;
        var l = a.parentNode;
        if (!l)
          return null;
        var c = a.window.document.createElement("div");
        return c.style.width = "100%", c.style.height = "100%", c.style.position = "absolute", c.style.transform = "scale(0, 0)", c.style.left = "0", c.style.flex = "0 0 100%", c.classList ? c.classList.add(ph) : c.className += ph, l.appendChild(c), c;
      }, a.removeBase = function(l) {
        var c = a.parentNode;
        c && c.removeChild(l);
      }, a.state = {
        isResizing: !1,
        width: (r = (i = a.propsSize) === null || i === void 0 ? void 0 : i.width) !== null && r !== void 0 ? r : "auto",
        height: (s = (o = a.propsSize) === null || o === void 0 ? void 0 : o.height) !== null && s !== void 0 ? s : "auto",
        direction: "right",
        original: {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        },
        backgroundStyle: {
          height: "100%",
          width: "100%",
          backgroundColor: "rgba(0,0,0,0)",
          cursor: "auto",
          opacity: 0,
          position: "fixed",
          zIndex: 9999,
          top: "0",
          left: "0",
          bottom: "0",
          right: "0"
        },
        flexBasis: void 0
      }, a.onResizeStart = a.onResizeStart.bind(a), a.onMouseMove = a.onMouseMove.bind(a), a.onMouseUp = a.onMouseUp.bind(a), a;
    }
    return Object.defineProperty(e.prototype, "parentNode", {
      get: function() {
        return this.resizable ? this.resizable.parentNode : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "window", {
      get: function() {
        return !this.resizable || !this.resizable.ownerDocument ? null : this.resizable.ownerDocument.defaultView;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "propsSize", {
      get: function() {
        return this.props.size || this.props.defaultSize || l8;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "size", {
      get: function() {
        var t = 0, i = 0;
        if (this.resizable && this.window) {
          var r = this.resizable.offsetWidth, o = this.resizable.offsetHeight, s = this.resizable.style.position;
          s !== "relative" && (this.resizable.style.position = "relative"), t = this.resizable.style.width !== "auto" ? this.resizable.offsetWidth : r, i = this.resizable.style.height !== "auto" ? this.resizable.offsetHeight : o, this.resizable.style.position = s;
        }
        return { width: t, height: i };
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "sizeStyle", {
      get: function() {
        var t = this, i = this.props.size, r = function(a) {
          var l;
          if (typeof t.state[a] > "u" || t.state[a] === "auto")
            return "auto";
          if (t.propsSize && t.propsSize[a] && (!((l = t.propsSize[a]) === null || l === void 0) && l.toString().endsWith("%"))) {
            if (t.state[a].toString().endsWith("%"))
              return t.state[a].toString();
            var c = t.getParentSize(), u = Number(t.state[a].toString().replace("px", "")), d = u / c[a] * 100;
            return d + "%";
          }
          return Ba(t.state[a]);
        }, o = i && typeof i.width < "u" && !this.state.isResizing ? Ba(i.width) : r("width"), s = i && typeof i.height < "u" && !this.state.isResizing ? Ba(i.height) : r("height");
        return { width: o, height: s };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.getParentSize = function() {
      if (!this.parentNode)
        return this.window ? { width: this.window.innerWidth, height: this.window.innerHeight } : { width: 0, height: 0 };
      var t = this.appendBase();
      if (!t)
        return { width: 0, height: 0 };
      var i = !1, r = this.parentNode.style.flexWrap;
      r !== "wrap" && (i = !0, this.parentNode.style.flexWrap = "wrap"), t.style.position = "relative", t.style.minWidth = "100%", t.style.minHeight = "100%";
      var o = {
        width: t.offsetWidth,
        height: t.offsetHeight
      };
      return i && (this.parentNode.style.flexWrap = r), this.removeBase(t), o;
    }, e.prototype.bindEvents = function() {
      this.window && (this.window.addEventListener("mouseup", this.onMouseUp), this.window.addEventListener("mousemove", this.onMouseMove), this.window.addEventListener("mouseleave", this.onMouseUp), this.window.addEventListener("touchmove", this.onMouseMove, {
        capture: !0,
        passive: !1
      }), this.window.addEventListener("touchend", this.onMouseUp));
    }, e.prototype.unbindEvents = function() {
      this.window && (this.window.removeEventListener("mouseup", this.onMouseUp), this.window.removeEventListener("mousemove", this.onMouseMove), this.window.removeEventListener("mouseleave", this.onMouseUp), this.window.removeEventListener("touchmove", this.onMouseMove, !0), this.window.removeEventListener("touchend", this.onMouseUp));
    }, e.prototype.componentDidMount = function() {
      if (!(!this.resizable || !this.window)) {
        var t = this.window.getComputedStyle(this.resizable);
        this.setState({
          width: this.state.width || this.size.width,
          height: this.state.height || this.size.height,
          flexBasis: t.flexBasis !== "auto" ? t.flexBasis : void 0
        });
      }
    }, e.prototype.componentWillUnmount = function() {
      this.window && this.unbindEvents();
    }, e.prototype.createSizeForCssProperty = function(t, i) {
      var r = this.propsSize && this.propsSize[i];
      return this.state[i] === "auto" && this.state.original[i] === t && (typeof r > "u" || r === "auto") ? "auto" : t;
    }, e.prototype.calculateNewMaxFromBoundary = function(t, i) {
      var r = this.props.boundsByDirection, o = this.state.direction, s = r && wi("left", o), a = r && wi("top", o), l, c;
      if (this.props.bounds === "parent") {
        var u = this.parentNode;
        u && (l = s ? this.resizableRight - this.parentLeft : u.offsetWidth + (this.parentLeft - this.resizableLeft), c = a ? this.resizableBottom - this.parentTop : u.offsetHeight + (this.parentTop - this.resizableTop));
      } else this.props.bounds === "window" ? this.window && (l = s ? this.resizableRight : this.window.innerWidth - this.resizableLeft, c = a ? this.resizableBottom : this.window.innerHeight - this.resizableTop) : this.props.bounds && (l = s ? this.resizableRight - this.targetLeft : this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft), c = a ? this.resizableBottom - this.targetTop : this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop));
      return l && Number.isFinite(l) && (t = t && t < l ? t : l), c && Number.isFinite(c) && (i = i && i < c ? i : c), { maxWidth: t, maxHeight: i };
    }, e.prototype.calculateNewSizeFromDirection = function(t, i) {
      var r = this.props.scale || 1, o = d8(this.props.resizeRatio || 1), s = o[0], a = o[1], l = this.state, c = l.direction, u = l.original, d = this.props, h = d.lockAspectRatio, f = d.lockAspectRatioExtraHeight, p = d.lockAspectRatioExtraWidth, m = u.width, g = u.height, k = f || 0, x = p || 0;
      return wi("right", c) && (m = u.width + (t - u.x) * s / r, h && (g = (m - x) / this.ratio + k)), wi("left", c) && (m = u.width - (t - u.x) * s / r, h && (g = (m - x) / this.ratio + k)), wi("bottom", c) && (g = u.height + (i - u.y) * a / r, h && (m = (g - k) * this.ratio + x)), wi("top", c) && (g = u.height - (i - u.y) * a / r, h && (m = (g - k) * this.ratio + x)), { newWidth: m, newHeight: g };
    }, e.prototype.calculateNewSizeFromAspectRatio = function(t, i, r, o) {
      var s = this.props, a = s.lockAspectRatio, l = s.lockAspectRatioExtraHeight, c = s.lockAspectRatioExtraWidth, u = typeof o.width > "u" ? 10 : o.width, d = typeof r.width > "u" || r.width < 0 ? t : r.width, h = typeof o.height > "u" ? 10 : o.height, f = typeof r.height > "u" || r.height < 0 ? i : r.height, p = l || 0, m = c || 0;
      if (a) {
        var g = (h - p) * this.ratio + m, k = (f - p) * this.ratio + m, x = (u - m) / this.ratio + p, S = (d - m) / this.ratio + p, _ = Math.max(u, g), v = Math.min(d, k), y = Math.max(h, x), w = Math.min(f, S);
        t = uo(t, _, v), i = uo(i, y, w);
      } else
        t = uo(t, u, d), i = uo(i, h, f);
      return { newWidth: t, newHeight: i };
    }, e.prototype.setBoundingClientRect = function() {
      var t = 1 / (this.props.scale || 1);
      if (this.props.bounds === "parent") {
        var i = this.parentNode;
        if (i) {
          var r = i.getBoundingClientRect();
          this.parentLeft = r.left * t, this.parentTop = r.top * t;
        }
      }
      if (this.props.bounds && typeof this.props.bounds != "string") {
        var o = this.props.bounds.getBoundingClientRect();
        this.targetLeft = o.left * t, this.targetTop = o.top * t;
      }
      if (this.resizable) {
        var s = this.resizable.getBoundingClientRect(), a = s.left, l = s.top, c = s.right, u = s.bottom;
        this.resizableLeft = a * t, this.resizableRight = c * t, this.resizableTop = l * t, this.resizableBottom = u * t;
      }
    }, e.prototype.onResizeStart = function(t, i) {
      if (!(!this.resizable || !this.window)) {
        var r = 0, o = 0;
        if (t.nativeEvent && c8(t.nativeEvent) ? (r = t.nativeEvent.clientX, o = t.nativeEvent.clientY) : t.nativeEvent && ho(t.nativeEvent) && (r = t.nativeEvent.touches[0].clientX, o = t.nativeEvent.touches[0].clientY), this.props.onResizeStart && this.resizable) {
          var s = this.props.onResizeStart(t, i, this.resizable);
          if (s === !1)
            return;
        }
        this.props.size && (typeof this.props.size.height < "u" && this.props.size.height !== this.state.height && this.setState({ height: this.props.size.height }), typeof this.props.size.width < "u" && this.props.size.width !== this.state.width && this.setState({ width: this.props.size.width })), this.ratio = typeof this.props.lockAspectRatio == "number" ? this.props.lockAspectRatio : this.size.width / this.size.height;
        var a, l = this.window.getComputedStyle(this.resizable);
        if (l.flexBasis !== "auto") {
          var c = this.parentNode;
          if (c) {
            var u = this.window.getComputedStyle(c).flexDirection;
            this.flexDir = u.startsWith("row") ? "row" : "column", a = l.flexBasis;
          }
        }
        this.setBoundingClientRect(), this.bindEvents();
        var d = {
          original: {
            x: r,
            y: o,
            width: this.size.width,
            height: this.size.height
          },
          isResizing: !0,
          backgroundStyle: Pt(Pt({}, this.state.backgroundStyle), { cursor: this.window.getComputedStyle(t.target).cursor || "auto" }),
          direction: i,
          flexBasis: a
        };
        this.setState(d);
      }
    }, e.prototype.onMouseMove = function(t) {
      var i = this;
      if (!(!this.state.isResizing || !this.resizable || !this.window)) {
        if (this.window.TouchEvent && ho(t))
          try {
            t.preventDefault(), t.stopPropagation();
          } catch {
          }
        var r = this.props, o = r.maxWidth, s = r.maxHeight, a = r.minWidth, l = r.minHeight, c = ho(t) ? t.touches[0].clientX : t.clientX, u = ho(t) ? t.touches[0].clientY : t.clientY, d = this.state, h = d.direction, f = d.original, p = d.width, m = d.height, g = this.getParentSize(), k = u8(g, this.window.innerWidth, this.window.innerHeight, o, s, a, l);
        o = k.maxWidth, s = k.maxHeight, a = k.minWidth, l = k.minHeight;
        var x = this.calculateNewSizeFromDirection(c, u), S = x.newHeight, _ = x.newWidth, v = this.calculateNewMaxFromBoundary(o, s);
        this.props.snap && this.props.snap.x && (_ = fh(_, this.props.snap.x, this.props.snapGap)), this.props.snap && this.props.snap.y && (S = fh(S, this.props.snap.y, this.props.snapGap));
        var y = this.calculateNewSizeFromAspectRatio(_, S, { width: v.maxWidth, height: v.maxHeight }, { width: a, height: l });
        if (_ = y.newWidth, S = y.newHeight, this.props.grid) {
          var w = hh(_, this.props.grid[0], this.props.gridGap ? this.props.gridGap[0] : 0), $ = hh(S, this.props.grid[1], this.props.gridGap ? this.props.gridGap[1] : 0), A = this.props.snapGap || 0, z = A === 0 || Math.abs(w - _) <= A ? w : _, N = A === 0 || Math.abs($ - S) <= A ? $ : S;
          _ = z, S = N;
        }
        var D = {
          width: _ - f.width,
          height: S - f.height
        };
        if (p && typeof p == "string") {
          if (p.endsWith("%")) {
            var j = _ / g.width * 100;
            _ = j + "%";
          } else if (p.endsWith("vw")) {
            var U = _ / this.window.innerWidth * 100;
            _ = U + "vw";
          } else if (p.endsWith("vh")) {
            var Y = _ / this.window.innerHeight * 100;
            _ = Y + "vh";
          }
        }
        if (m && typeof m == "string") {
          if (m.endsWith("%")) {
            var j = S / g.height * 100;
            S = j + "%";
          } else if (m.endsWith("vw")) {
            var U = S / this.window.innerWidth * 100;
            S = U + "vw";
          } else if (m.endsWith("vh")) {
            var Y = S / this.window.innerHeight * 100;
            S = Y + "vh";
          }
        }
        var B = {
          width: this.createSizeForCssProperty(_, "width"),
          height: this.createSizeForCssProperty(S, "height")
        };
        this.flexDir === "row" ? B.flexBasis = B.width : this.flexDir === "column" && (B.flexBasis = B.height);
        var K = this.state.width !== B.width, V = this.state.height !== B.height, pe = this.state.flexBasis !== B.flexBasis, me = K || V || pe;
        me && Mh(function() {
          i.setState(B);
        }), this.props.onResize && me && this.props.onResize(t, h, this.resizable, D);
      }
    }, e.prototype.onMouseUp = function(t) {
      var i, r, o = this.state, s = o.isResizing, a = o.direction, l = o.original;
      if (!(!s || !this.resizable)) {
        var c = {
          width: this.size.width - l.width,
          height: this.size.height - l.height
        };
        this.props.onResizeStop && this.props.onResizeStop(t, a, this.resizable, c), this.props.size && this.setState({ width: (i = this.props.size.width) !== null && i !== void 0 ? i : "auto", height: (r = this.props.size.height) !== null && r !== void 0 ? r : "auto" }), this.unbindEvents(), this.setState({
          isResizing: !1,
          backgroundStyle: Pt(Pt({}, this.state.backgroundStyle), { cursor: "auto" })
        });
      }
    }, e.prototype.updateSize = function(t) {
      var i, r;
      this.setState({ width: (i = t.width) !== null && i !== void 0 ? i : "auto", height: (r = t.height) !== null && r !== void 0 ? r : "auto" });
    }, e.prototype.renderResizer = function() {
      var t = this, i = this.props, r = i.enable, o = i.handleStyles, s = i.handleClasses, a = i.handleWrapperStyle, l = i.handleWrapperClass, c = i.handleComponent;
      if (!r)
        return null;
      var u = Object.keys(r).map(function(d) {
        return r[d] !== !1 ? Jn.createElement(s8, { key: d, direction: d, onResizeStart: t.onResizeStart, replaceStyles: o && o[d], className: s && s[d] }, c && c[d] ? c[d] : null) : null;
      });
      return Jn.createElement("div", { className: l, style: a }, u);
    }, e.prototype.render = function() {
      var t = this, i = Object.keys(this.props).reduce(function(s, a) {
        return h8.indexOf(a) !== -1 || (s[a] = t.props[a]), s;
      }, {}), r = Pt(Pt(Pt({ position: "relative", userSelect: this.state.isResizing ? "none" : "auto" }, this.props.style), this.sizeStyle), { maxWidth: this.props.maxWidth, maxHeight: this.props.maxHeight, minWidth: this.props.minWidth, minHeight: this.props.minHeight, boxSizing: "border-box", flexShrink: 0 });
      this.state.flexBasis && (r.flexBasis = this.state.flexBasis);
      var o = this.props.as || "div";
      return Jn.createElement(
        o,
        Pt({ style: r, className: this.props.className }, i, {
          // `ref` is after `extendsProps` to ensure this one wins over a version
          // passed in
          ref: function(s) {
            s && (t.resizable = s);
          }
        }),
        this.state.isResizing && Jn.createElement("div", { style: this.state.backgroundStyle }),
        this.props.children,
        this.renderResizer()
      );
    }, e.defaultProps = {
      as: "div",
      onResizeStart: function() {
      },
      onResize: function() {
      },
      onResizeStop: function() {
      },
      enable: {
        top: !0,
        right: !0,
        bottom: !0,
        left: !0,
        topRight: !0,
        bottomRight: !0,
        bottomLeft: !0,
        topLeft: !0
      },
      style: {},
      grid: [1, 1],
      gridGap: [0, 0],
      lockAspectRatio: !1,
      lockAspectRatioExtraWidth: 0,
      lockAspectRatioExtraHeight: 0,
      scale: 1,
      resizeRatio: 1,
      snapGap: 0
    }, e;
  })(Jn.PureComponent)
);
function mh(n) {
  return /* @__PURE__ */ b("svg", { width: "14", height: "14", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 384 512", ...n, children: /* @__PURE__ */ b("path", { d: "M32 64C14.3 64 0 49.7 0 32S14.3 0 32 0l96 0c53 0 96 43 96 96l0 306.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 402.7 160 96c0-17.7-14.3-32-32-32L32 64z" }) });
}
const _A = ({ node: n, selected: e, editor: t, getPos: i, updateAttributes: r }) => {
  const {
    src: o,
    alt: s,
    title: a,
    caption: l,
    width: c,
    height: u,
    containerWidth: d,
    href: h,
    imageMode: f,
    uploadingProps: p,
    isMobileFullWidth: m
  } = n.attrs, [g, k] = ye(!1), [x, S] = ye(!1), [_, v] = ye(i() === 0), [y, w] = ye(t.view.hasFocus()), $ = y && e;
  Je(() => {
    const Z = () => {
      v(i() === 0);
    };
    return t.on("update", Z), () => {
      t.off("update", Z);
    };
  }, [t, i]), Je(() => {
    const Z = () => {
      w(t.view.hasFocus());
    };
    return t.on("focus", Z), t.on("blur", Z), () => {
      t.off("focus", Z), t.off("blur", Z);
    };
  }, [t]);
  const A = (t == null ? void 0 : t.options.editable) && !p, z = f === ce.Inline, N = f === ce.BlockCenter, D = f === ce.BlockRight, j = (Z) => {
    if (Z.preventDefault(), typeof i == "function") {
      const Q = i();
      t.commands.setNodeSelection(Q), t.commands.focus();
    }
  }, U = (Z, Q, X) => {
    var be;
    const $e = X.style.width, we = (be = X.parentElement) == null ? void 0 : be.offsetWidth;
    if (!we) return;
    const Oe = X.querySelector("img");
    if (!Oe) return;
    let re;
    if ($e.includes("%"))
      re = $e;
    else if ($e.includes("px")) {
      const je = $e.split("px")[0];
      re = Number(je) / we * 100 + "%";
    } else
      re = Number(Oe.naturalWidth) / we * 100 + "%";
    r({
      containerWidth: re
    });
  }, Y = (Z) => {
    if (!t) return;
    const Q = i();
    if (Q === null) return;
    let X = 0;
    switch (Z) {
      case Yi.Before:
        X = Q > 0 ? Q - 1 : 0;
        break;
      case Yi.After:
        X = Q + n.nodeSize;
    }
    t.chain().insertContentAt(X, {
      type: "paragraph"
    }).focus().run();
  }, { onDragStart: B } = hc(), K = (Z) => {
    const Q = W(
      $ || g ? "bg-brand-primary" : x ? "bg-yellow" : "bg-transparent",
      "main-transition-colors"
    ), X = 2;
    return /* @__PURE__ */ P(
      f8,
      {
        "data-node-view-wrapper": "",
        onDragStart: B,
        style: {
          ...N && Pz,
          ...D && jz(_)
        },
        as: z ? "span" : "figure",
        size: { width: d, height: "100%" },
        handleClasses: {
          top: Q,
          bottom: Q,
          left: Q,
          right: Q
        },
        handleStyles: {
          top: {
            height: X,
            top: -X,
            width: `calc(100% + ${X}px)`,
            left: -X
          },
          bottom: {
            height: X,
            bottom: -X,
            width: `calc(100% + ${X}px)`,
            right: -X
          },
          left: {
            width: X,
            left: -X,
            height: `calc(100% + ${X}px)`,
            bottom: -X
          },
          right: {
            width: X,
            right: -X,
            height: `calc(100% + ${X}px)`,
            top: -X
          }
        },
        enable: A ? void 0 : !1,
        onResize: U,
        minWidth: 50,
        minHeight: 50,
        maxWidth: "100%",
        lockAspectRatio: !0,
        onResizeStart: () => {
          k(!0), r({
            showBubbleMenu: !1
          });
        },
        onResizeStop: () => {
          k(!1);
        },
        className: W(
          z ? "inline-flex" : "flex",
          "flex-col",
          h ? "cursor-pointer" : "cursor-default",
          D && "justify-end",
          N && "justify-center"
        ),
        children: [
          Z,
          l && /* @__PURE__ */ b("figcaption", { style: Bz, children: l })
        ]
      }
    );
  }, V = (Z) => /* @__PURE__ */ b(
    "img",
    {
      src: o,
      alt: s ?? "",
      title: a ?? "",
      width: c,
      height: u,
      style: {
        minWidth: "100%",
        maxWidth: "100%",
        aspectRatio: c && u ? `${c}/${u}` : void 0
      },
      ...Z
    }
  );
  return p != null && p.isUploading ? K(V({ className: "animate-pulse" })) : K(((Z) => h ? /* @__PURE__ */ b("a", { className: "flex h-full w-full", href: h, onClick: (Q) => Q.preventDefault(), children: Z }) : Z)((() => {
    const Z = d.includes("%") ? Number(d.split("%")[0]).toFixed(2) : void 0;
    return /* @__PURE__ */ P(dn, { children: [
      V({
        onMouseEnter: () => S(!0),
        onMouseLeave: () => S(!1),
        onClick: j,
        onMouseDownCapture: () => r({
          showBubbleMenu: !0
        }),
        "data-drag-handle": ""
      }),
      A && $ && !z && /* @__PURE__ */ P(dn, { children: [
        /* @__PURE__ */ b(
          wo,
          {
            onMouseDown: (Q) => Q.preventDefault(),
            className: W(
              "z-1 absolute -top-2.5 left-[5%] flex min-h-[24px] min-w-[24px] p-1"
            ),
            onClick: () => Y(Yi.Before),
            children: /* @__PURE__ */ b(mh, { className: W("fill-background-secondary rotate-90") })
          }
        ),
        /* @__PURE__ */ b(
          wo,
          {
            onMouseDown: (Q) => Q.preventDefault(),
            className: W(
              "z-1 absolute -bottom-2.5 right-[5%] flex min-h-[24px] min-w-[24px] p-1"
            ),
            onClick: () => Y(Yi.After),
            children: /* @__PURE__ */ b(mh, { className: W("fill-background-secondary rotate-90") })
          }
        )
      ] }),
      /* @__PURE__ */ P("div", { className: "absolute right-3 top-3 flex flex-col items-center justify-center gap-1.5", children: [
        h && /* @__PURE__ */ b(
          Ko,
          {
            className: "stroke-background-secondary h-[20px] w-[20px] rounded-sm bg-black/30"
          }
        ),
        m && /* @__PURE__ */ b(
          Rz,
          {
            className: "stroke-background-secondary h-[20px] w-[20px] rounded-sm bg-black/30"
          }
        )
      ] }),
      g && Z && /* @__PURE__ */ P(
        "span",
        {
          className: "text-background-secondary absolute left-3 bottom-3 bg-black/70 px-1 text-[10px]",
          children: [
            Z,
            "%"
          ]
        }
      )
    ] });
  })()));
}, bA = (n) => {
  var e, t;
  return n.style.cssText ? ((t = (e = n.style.cssText.split(";").map((i) => i.trim()).find((i) => i.startsWith("width"))) == null ? void 0 : e.split(":")[1]) == null ? void 0 : t.trim()) ?? "auto" : "auto";
}, kA = (n) => {
  const e = n == null ? void 0 : n.getAttribute("src"), t = n == null ? void 0 : n.getAttribute("alt"), i = n == null ? void 0 : n.getAttribute("title"), r = n == null ? void 0 : n.getAttribute("width"), o = n == null ? void 0 : n.getAttribute("height");
  return {
    src: e,
    alt: t,
    title: i,
    width: r,
    height: o
  };
}, yA = (n, e) => typeof (e == null ? void 0 : e.href) == "string" ? ["a", e, ["img", n]] : ["img", n], vA = St.create({
  name: "image",
  addOptions() {
    return {
      inline: !1
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: !0,
  addAttributes() {
    return {
      src: {
        default: null
      },
      alt: {
        default: null
      },
      title: {
        default: null
      },
      imageMode: {
        default: null
      },
      width: {
        default: null
      },
      height: {
        default: null
      },
      href: {
        default: null
      },
      containerWidth: {
        default: "auto"
      },
      showBubbleMenu: {
        default: !1
      },
      caption: {
        default: null
      },
      uploadingProps: {
        default: null
      },
      isMobileFullWidth: {
        default: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: 'img[src]:not([src^="data:"])'
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["img", ke(this.options.HTMLAttributes, n)];
  },
  addCommands() {
    return {
      setImage: (n) => ({ commands: e }) => {
        let t;
        switch (n.imageMode) {
          case ce.Inline: {
            t = ze.Inline;
            break;
          }
          case ce.BlockRight:
          case ce.BlockCenter: {
            t = ze.Block;
            break;
          }
          default: {
            t = "image";
            break;
          }
        }
        return e.insertContent({
          type: t,
          attrs: n
        });
      },
      toggleImageMode: (n) => ({ tr: e, commands: t }) => {
        const { doc: i, selection: r } = e, { from: o, to: s } = r, a = yp(
          i,
          { from: o, to: s },
          (c) => c.type.name === ze.Inline || c.type.name === ze.Block
        );
        if (!a.length)
          return !1;
        const l = new V5(e);
        return t.forEach(a, ({ node: c, pos: u }) => {
          const d = l.map(u);
          if (d.deleted)
            return !1;
          const h = {
            from: d.position,
            to: d.position + c.nodeSize
          }, f = t.insertContentAt(h, {
            type: n === ce.Inline ? ze.Inline : ze.Block,
            attrs: {
              ...c.attrs,
              imageMode: n,
              caption: n === ce.Inline ? void 0 : c.attrs.caption,
              float: n === ce.BlockRight ? "right" : null
            }
          }), p = d.position - 1;
          if (p >= 0) {
            const m = e.doc.nodeAt(p);
            (m == null ? void 0 : m.type.name) === "paragraph" && m.nodeSize === 2 && e.delete(p, p + m.nodeSize);
          }
          return n === ce.Inline && (c.attrs.imageMode === ce.BlockCenter || c.attrs.imageMode === ce.BlockRight) && t.setNodeSelection(o + 1), f;
        });
      }
    };
  }
}), p8 = vA.extend({
  name: ze.Block,
  addNodeView() {
    return qi(_A);
  },
  parseHTML() {
    return [
      {
        // skip ckeditor's legacy - tables https://app.shortcut.com/systeme/story/53281/he-has-a-problem-with-one-of-his-campaigns-in-the-classic-editor-where-he-can-no-longer-find-the-content-of-his-emails
        tag: "figure:not(.table)",
        getAttrs: (n) => {
          const e = n.querySelector("img"), t = n.querySelector("a"), i = n.querySelector("figcaption"), r = t == null ? void 0 : t.getAttribute("href"), o = kA(e), s = bA(n), a = n.hasAttribute("is-mobile-full-width");
          return {
            imageMode: n != null && n.style.float ? ce.BlockRight : ce.BlockCenter,
            href: r,
            containerWidth: s,
            caption: i == null ? void 0 : i.textContent,
            isMobileFullWidth: a,
            ...o
          };
        }
      }
    ];
  },
  renderHTML({
    HTMLAttributes: {
      caption: n,
      href: e,
      imageMode: t,
      alt: i,
      src: r,
      title: o,
      width: s,
      height: a,
      containerWidth: l,
      uploadingProps: c,
      isMobileFullWidth: u
    }
  }) {
    if (c) return ["span", { style: "display: none;" }];
    const d = { ...kI };
    s && a && (d.aspectRatio = `${s}/${a}`), l !== "auto" && (d.width = l);
    const h = ke({
      src: r,
      alt: i,
      title: o,
      width: s,
      style: $t(d)
    }), p = [yA(h, { href: e })];
    n && p.push([
      "figcaption",
      {
        style: $t(Bz)
      },
      n
    ]);
    const m = t === ce.BlockCenter ? {
      ...Pz,
      ...l && { width: l }
    } : {
      ...jz(!1),
      ...l && { width: l }
    }, k = {
      style: $t(m)
    };
    u && (k["is-mobile-full-width"] = "true");
    const x = ["figure", k, ...p];
    return u ? [
      "div",
      { class: "is-mobile-full-width" },
      ["head", {}, ["style", { type: "text/css" }, _I]],
      x
    ] : x;
  }
}), m8 = vA.configure({ inline: !0 }).extend({
  name: ze.Inline,
  inline: !0,
  addNodeView() {
    return qi(_A);
  },
  parseHTML() {
    return [
      {
        tag: "p img",
        getAttrs: (n) => {
          const e = n.closest("a"), t = e == null ? void 0 : e.getAttribute("href"), i = kA(n), r = bA(n), o = n.closest("span.inline-image-wrapper"), s = (o == null ? void 0 : o.hasAttribute("is-mobile-full-width")) || !1;
          return {
            imageMode: ce.Inline,
            ...i,
            href: t,
            containerWidth: r,
            isMobileFullWidth: s
          };
        }
      }
    ];
  },
  renderHTML({
    HTMLAttributes: { href: n, alt: e, title: t, width: i, height: r, containerWidth: o, src: s, isMobileFullWidth: a }
  }) {
    const l = {};
    i && r && (l.aspectRatio = `${i}/${r}`), o !== "auto" && (l.width = o);
    const c = ke({
      src: s,
      alt: e,
      title: t,
      width: i,
      style: $t(l)
    }), u = yA(c, { href: n });
    return a ? [
      "span",
      { class: "inline-image-wrapper is-mobile-full-width" },
      ["head", {}, ["style", { type: "text/css" }, bI]],
      u
    ] : u;
  }
}), g8 = St.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [
      { tag: "p" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["p", ke(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: n }) => n.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), xA = (n = !1) => ({
  ...gI,
  ...n ? { marginTop: "1rem", marginBottom: "1rem" } : { marginTop: "0", marginBottom: "0" }
}), _8 = ({ node: n }) => {
  const { textAlign: e, indent: t } = n.attrs, i = n.attrs[Dr];
  return /* @__PURE__ */ b(
    "p",
    {
      "data-node-view-wrapper": "",
      style: {
        ...xA(i),
        textAlign: e,
        marginLeft: `${t}px`
      },
      dir: "auto",
      children: /* @__PURE__ */ b(Hs, { as: "span" })
    }
  );
}, gh = (n) => n !== "0" && n !== "0px" && n !== "0rem" && n !== "0em" && n !== 0 && n !== "" && n !== null && n !== void 0 && n !== " ", b8 = g8.extend({
  addAttributes() {
    return {
      [Dr]: {
        default: !1,
        parseHTML: (n) => {
          if (!n.style) return !1;
          const e = gh(n.style.marginTop), t = gh(n.style.marginBottom);
          return e && t;
        }
      }
    };
  },
  addNodeView() {
    return qi(_8);
  },
  renderHTML({ HTMLAttributes: n, node: e }) {
    const t = e.attrs[Dr], i = e.content.size === 0;
    return [
      "p",
      ke(n, {
        dir: "auto",
        style: $t(xA(t))
      }),
      i ? ["br", { class: "trailingBreak" }] : 0
    ];
  }
}), k8 = new Ue("restoreMarks"), y8 = Wj.extend({
  addProseMirrorPlugins() {
    return [v8()];
  }
}), v8 = () => new Ee({
  key: k8,
  appendTransaction: (n, e, t) => {
    const i = n.some((l) => l.docChanged), r = !e.selection.eq(t.selection);
    if (!i && !r)
      return null;
    const { selection: o } = t, { $head: s } = o;
    if (s.parent.content.size === 0 || s.parent.content.size === 1 && s.parent.textContent === "") {
      let l = t.storedMarks || s.marks();
      if (!l || l.length === 0) {
        let c = s.pos - 1;
        for (; c > 0; ) {
          const d = t.doc.resolve(c).marks();
          if (d.length > 0) {
            l = d;
            break;
          }
          c--;
        }
      }
      if (l && l.length > 0) {
        const c = [
          "bold",
          "italic",
          "strike",
          "underline",
          "textStyle",
          "textColor",
          "textBackgroundColor",
          "fontSize",
          "fontFamily"
        ], u = l.filter((d) => c.includes(d.type.name));
        if (u.length > 0) {
          const d = t.tr;
          return d.setStoredMarks(u), d;
        }
      }
    }
    return null;
  }
}), SA = (n, e) => {
  var i;
  const t = {
    [T.Document]: _j,
    [T.Paragraph]: b8,
    [T.Text]: qj,
    [T.TextStyle]: y8,
    [T.FontFamily]: Kj.configure({
      types: ["textStyle"]
    }),
    [T.Heading]: vj.extend({
      renderHTML({ node: r, HTMLAttributes: o }) {
        const a = [2, 3, 4].includes(r.attrs.level) ? r.attrs.level : 2;
        return [
          `h${a}`,
          ke(o, {
            dir: "auto",
            style: $t(ko[a])
          }),
          0
        ];
      }
    }),
    [T.Bold]: fj,
    [T.Italic]: Rj,
    [T.Strike]: Fj,
    [T.Underline]: Vj,
    [T.BulletList]: mj.extend({
      addAttributes() {
        return {
          depth: {
            default: 0
          }
        };
      },
      addNodeView() {
        return qi(e8);
      },
      renderHTML({ HTMLAttributes: r }) {
        const { depth: o } = r;
        return [
          "ul",
          ke(r, {
            style: $t({
              ...Wo,
              listStyleType: iA(o)
            })
          }),
          0
        ];
      }
    }),
    [T.OrderedList]: Pj.extend({
      addAttributes() {
        return {
          depth: {
            default: 0
          }
        };
      },
      addNodeView() {
        return qi(t8);
      },
      renderHTML({ HTMLAttributes: r }) {
        const { depth: o } = r;
        return [
          "ol",
          ke(r, {
            style: $t({
              ...Wo,
              listStyleType: rA(o)
            })
          }),
          0
        ];
      }
    }),
    [T.ListItem]: Qj,
    [T.TextAlign]: Hj.configure({
      types: ["heading", "paragraph", "listItem"],
      alignments: ["left", "center", "right", "justify"]
    }),
    [T.Link]: Od(e == null ? void 0 : e[T.Link]).configure({
      openOnClick: !1
    }),
    [T.SimpleLink]: Od(e == null ? void 0 : e[T.Link]).configure({
      HTMLAttributes: {
        rel: "noopener noreferrer"
      }
    }),
    [T.History]: zj,
    [T.TextColor]: i8,
    [T.TextBackgroundColor]: n8,
    [T.FontSize]: Jj.configure({
      defaultFontSize: (i = e == null ? void 0 : e[T.FontSize]) != null && i.clearable ? null : pI
    }),
    [T.Indent]: PP,
    [T.HardBreak]: oh.extend({
      addAttributes() {
        return {
          class: {
            default: null,
            parseHTML: (r) => r.getAttribute("class"),
            renderHTML: (r) => r.class ? { class: r.class } : {}
          }
        };
      }
    }),
    [T.SimpleHardBreak]: oh.extend({
      addKeyboardShortcuts() {
        return {
          Enter: () => this.editor.commands.setHardBreak()
        };
      }
    }),
    [T.Substitution]: null,
    [T.SpecialCharacters]: null,
    [T.Image]: [p8, m8],
    [T.DropCursor]: yj,
    [T.CharacterCount]: gj
  };
  return n.flatMap((r) => {
    const o = t[r];
    return Array.isArray(o) ? o : [o];
  }).filter((r) => r !== null);
}, wA = (n) => Object.values(T).reduce(
  (e, t) => ({
    ...e,
    [`has${T[t]}`]: n.includes(t)
  }),
  {}
), ws = [
  T.History,
  [
    T.Heading,
    T.FontFamily,
    T.FontSize,
    T.TextColor,
    T.TextBackgroundColor
  ],
  [
    T.Paragraph,
    T.Indent,
    T.TextAlign,
    T.Substitution
  ],
  [
    T.Bold,
    T.Italic,
    T.Underline,
    T.Strike,
    T.BulletList,
    T.OrderedList
  ],
  [T.Link, T.Image, T.SpecialCharacters]
], _h = ({
  extension: n,
  source: e,
  skipRef: t,
  withRightBorder: i,
  inTooltip: r
}) => {
  const o = e.filter((s) => s.key === n);
  return o.length ? o.map((s, a) => /* @__PURE__ */ b(
    "div",
    {
      ref: t ? void 0 : s.ref,
      className: Te(
        a === o.length - 1 && i && "border-r border-text-secondary/30 last-of-type:border-r-0",
        "flex items-center",
        !r && "px-px first-of-type:pl-0 last-of-type:pr-0"
      ),
      children: r ? s.toolbarItem.tooltipRender : s.toolbarItem.toolbarRender
    },
    `${s.key}-${a}`
  )) : null;
}, Fa = ({
  source: n,
  skipBorder: e,
  skipRef: t,
  inTooltip: i
}) => ws.flatMap((r, o) => {
  const s = o === ws.length - 1;
  return Array.isArray(r) ? r.flatMap((a, l) => _h({
    extension: a,
    source: n,
    skipRef: t,
    withRightBorder: !e && !s && l === r.length - 1,
    inTooltip: i
  })) : _h({
    extension: r,
    source: n,
    skipRef: t,
    withRightBorder: !e && !s,
    inTooltip: i
  });
}), x8 = ({
  substitutions: n,
  extensions: e,
  editor: t,
  toolbarStyles: i,
  fileSource: r,
  toolbarClassName: o,
  showAllItems: s = !1,
  extensionOption: a
}) => {
  const {
    hasHistory: l,
    hasHeading: c,
    hasIndent: u,
    hasTextAlign: d,
    hasLink: h,
    hasTextColor: f,
    hasFontSize: p,
    hasTextBackgroundColor: m,
    hasFontFamily: g,
    hasSubstitution: k,
    hasSpecialCharacters: x,
    hasImage: S,
    hasOrderedList: _,
    hasBulletList: v,
    hasListItem: y,
    hasBold: w,
    hasItalic: $,
    hasUnderline: A,
    hasStrike: z,
    hasParagraph: N,
    hasSimpleHardBreak: D
  } = wA(e), j = gr(null), U = gr(null), [Y, B] = ye([]), [K, V] = ye([]), pe = AP(t, r), me = OP(t), Z = jP(t), Q = BP(t), X = KP(t), $e = EP(t), we = WP(t, n), Oe = lo(t, He.Bold), re = lo(t, He.Italic), be = lo(t, He.Underline), je = lo(t, He.Strike), it = MP(
    t,
    a == null ? void 0 : a[T.FontSize]
  ), Jt = qd(t, fn.OrderedList), Fn = qd(t, fn.BulletList), pn = wP(t), qn = nj(t), Hn = tj(t), mn = UP(t), gn = xP(t), Ot = Ve(() => {
    const Ye = [], oe = (Xe, zt) => {
      Array.isArray(Xe) ? Xe.forEach((ct) => {
        Ye.push({
          toolbarItem: ct,
          ref: _e.createRef(),
          key: zt
        });
      }) : Ye.push({
        toolbarItem: Xe,
        ref: _e.createRef(),
        key: zt
      });
    };
    return N && !D && oe(gn, T.Paragraph), l && oe(me, T.History), S && oe(pe, T.Image), h && oe(Q, T.Link), u && oe(Z, T.Indent), d && oe(X, T.TextAlign), c && oe($e, T.Heading), k && oe(we, T.Substitution), w && oe(Oe, T.Bold), $ && oe(re, T.Italic), A && oe(be, T.Underline), z && oe(je, T.Strike), p && oe(it, T.FontSize), _ && y && oe(Jt, T.OrderedList), v && y && oe(Fn, T.BulletList), g && oe(pn, T.FontFamily), f && oe(qn, T.TextColor), m && oe(Hn, T.TextBackgroundColor), x && oe(mn, T.SpecialCharacters), Ye;
  }, [
    N,
    D,
    gn,
    l,
    me,
    S,
    pe,
    h,
    Q,
    u,
    Z,
    d,
    X,
    c,
    $e,
    k,
    we,
    w,
    Oe,
    $,
    re,
    A,
    be,
    z,
    je,
    p,
    it,
    _,
    y,
    Jt,
    v,
    Fn,
    g,
    pn,
    f,
    qn,
    m,
    Hn,
    x,
    mn
  ]);
  return Je(() => {
    const Ye = () => {
      var Vn;
      if (!j.current) return;
      if (s) {
        B(Ot), V([]);
        return;
      }
      const Xe = j.current.clientWidth, zt = Ot.sort(
        (Nt, mi) => ws.flatMap((Un) => Un).indexOf(Nt.key) - ws.flatMap((Un) => Un).indexOf(mi.key)
      ), ct = [], At = [];
      let _n = 0, bn = !1;
      const pi = ((Vn = U.current) == null ? void 0 : Vn.offsetWidth) ?? 0;
      for (const Nt of zt) {
        const mi = Nt.ref.current;
        if (!mi) continue;
        const Un = mi.offsetWidth, qr = _n + Un;
        !bn && qr <= Xe ? (ct.push(Nt), _n = qr) : (bn = !0, At.push(Nt));
      }
      if (bn && At.length > 0 && _n + pi > Xe) {
        const Nt = ct.pop();
        Nt && At.unshift(Nt);
      }
      B(ct), V(At);
    }, oe = new ResizeObserver(Ye);
    return j.current && oe.observe(j.current), Ye(), () => {
      oe.disconnect();
    };
  }, [Ot, s]), /* @__PURE__ */ P(
    "div",
    {
      style: i,
      className: W(
        "border-text-secondary/30 z-sticky bg-background-secondary sticky top-0 flex items-center rounded-t-lg border border-b-0 p-1",
        o
      ),
      children: [
        /* @__PURE__ */ P(
          "div",
          {
            ref: j,
            className: W("flex w-full", s && "flex-wrap gap-1"),
            children: [
              Fa({ source: Y, skipRef: !0 }),
              /* @__PURE__ */ b(
                "div",
                {
                  ref: U,
                  className: Te(
                    "ml-auto flex items-center",
                    K.length > 0 ? "visible" : "invisible",
                    s && "hidden"
                  ),
                  children: /* @__PURE__ */ b(
                    xo,
                    {
                      anchor: "bottom end",
                      className: "main-transition-colors data-[open]:bg-brand-primary/10 group h-7 rounded-lg px-2",
                      label: /* @__PURE__ */ b(dn, { children: Fa({
                        source: K,
                        skipRef: !0,
                        skipBorder: !0,
                        inTooltip: !0
                      }) }),
                      children: /* @__PURE__ */ b(FA, { className: "group-hover:fill-brand-primary main-transition-colors" })
                    }
                  )
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ b("div", { className: "pointer-events-none absolute left-0 top-0 flex h-0 overflow-hidden opacity-0", children: Fa({ source: Ot }) }),
        Ot.filter(({ toolbarItem: Ye }) => Ye.additionalRender).map(({ toolbarItem: Ye, key: oe }) => /* @__PURE__ */ b(IA, { children: Ye.additionalRender }, `${oe}-additional-render`))
      ]
    }
  );
}, K8 = ({
  mode: n = "html",
  content: e,
  isPreFetching: t,
  isEditable: i = !0,
  substitutions: r,
  extensions: o = Ts,
  className: s,
  onBlur: a,
  onChange: l,
  fileSource: c = LA.TextEditor,
  toolbarStyles: u,
  characterCountHint: d,
  style: h,
  toolbarClassName: f,
  extensionOption: p,
  showAllItems: m,
  skeletonClassName: g
}) => {
  const { onDrop: k, onPaste: x } = nP(c), [S, _] = ye(!1), v = n === "html" ? "getHTML" : "getText", y = Array.from(new Set(o)), { hasLink: w, hasImage: $, hasCharacterCount: A, hasSimpleLink: z } = wA(y), N = H4({
    content: e,
    immediatelyRender: !1,
    onCreate: () => _(!0),
    extensions: SA(y, p),
    onUpdate: ({ editor: D }) => S && l(D.isEmpty ? "" : D[v]()),
    onBlur: ({ editor: D }) => S && (a == null ? void 0 : a(D.isEmpty ? "" : D[v]())),
    editorProps: {
      handlePaste: $ ? x : void 0,
      handleDrop: $ ? k : void 0,
      attributes: {
        class: W(
          "border",
          "border-text-secondary/30",
          "main-transition-colors",
          "min-h-[500px]",
          "w-full",
          "focus:outline-hidden",
          "focus:border-brand-primary",
          "font-times",
          "overflow-auto",
          "rounded-b-lg",
          !i && "pointer-events-none cursor-default",
          s
        ),
        style: $t({
          paddingLeft: vd,
          paddingRight: vd,
          ...h
        })
      }
    }
  });
  return vP({
    editor: N,
    content: e,
    shouldInitialize: z && n === "text"
  }), Je(() => {
    N && N.setOptions({ editable: i && !t });
  }, [i, t, N]), Je(() => {
    if (!N) return;
    const D = Q4(() => {
      N[v]() !== e && N.commands.setContent(e ?? "", !1);
    }, 300);
    return D(), () => {
      D.cancel();
    };
  }, [e, N, v]), QI(N, p == null ? void 0 : p[T.Link]), N != null && N.isInitialized ? /* @__PURE__ */ P("div", { className: "relative", children: [
    o.length !== 0 && /* @__PURE__ */ b(
      x8,
      {
        editor: N,
        substitutions: r,
        extensions: y,
        toolbarStyles: u,
        fileSource: c,
        toolbarClassName: f,
        showAllItems: m,
        extensionOption: p
      }
    ),
    /* @__PURE__ */ b(N4, { editor: N }),
    w && /* @__PURE__ */ b(EI, { editor: N, fileSource: c }),
    $ && /* @__PURE__ */ b(MI, { fileSource: c, editor: N }),
    A && /* @__PURE__ */ b(
      eR,
      {
        editor: N,
        hint: d,
        className: "ml-auto mt-2 mr-2 w-fit"
      }
    )
  ] }) : /* @__PURE__ */ b(
    "div",
    {
      className: W(
        "bg-background-tertiary h-[500px] w-full animate-pulse rounded-lg",
        g
      )
    }
  );
}, S8 = (n, e, t) => {
  const i = n[e];
  return i ? typeof i == "function" ? i() : Promise.resolve(i) : new Promise((r, o) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
      o.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + e + (e.split("/").length !== t ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
}, CA = "common", w8 = Cs(null), C8 = async (n) => {
  try {
    const e = await S8(/* @__PURE__ */ Object.assign({ "../translations/locales/ar/common.json": () => Promise.resolve().then(() => DR), "../translations/locales/cs/common.json": () => Promise.resolve().then(() => RR), "../translations/locales/da/common.json": () => Promise.resolve().then(() => IR), "../translations/locales/de/common.json": () => Promise.resolve().then(() => PR), "../translations/locales/el/common.json": () => Promise.resolve().then(() => jR), "../translations/locales/en/common.json": () => Promise.resolve().then(() => BR), "../translations/locales/es/common.json": () => Promise.resolve().then(() => FR), "../translations/locales/fr/common.json": () => Promise.resolve().then(() => qR), "../translations/locales/hi/common.json": () => Promise.resolve().then(() => HR), "../translations/locales/hu/common.json": () => Promise.resolve().then(() => VR), "../translations/locales/id/common.json": () => Promise.resolve().then(() => UR), "../translations/locales/it/common.json": () => Promise.resolve().then(() => WR), "../translations/locales/ja/common.json": () => Promise.resolve().then(() => KR), "../translations/locales/nl/common.json": () => Promise.resolve().then(() => ZR), "../translations/locales/no/common.json": () => Promise.resolve().then(() => JR), "../translations/locales/pl/common.json": () => Promise.resolve().then(() => GR), "../translations/locales/pt/common.json": () => Promise.resolve().then(() => YR), "../translations/locales/ro/common.json": () => Promise.resolve().then(() => XR), "../translations/locales/ru/common.json": () => Promise.resolve().then(() => QR), "../translations/locales/sk/common.json": () => Promise.resolve().then(() => eI), "../translations/locales/sl/common.json": () => Promise.resolve().then(() => tI), "../translations/locales/sq/common.json": () => Promise.resolve().then(() => nI), "../translations/locales/sr/common.json": () => Promise.resolve().then(() => iI), "../translations/locales/sv/common.json": () => Promise.resolve().then(() => rI), "../translations/locales/th/common.json": () => Promise.resolve().then(() => oI), "../translations/locales/tr/common.json": () => Promise.resolve().then(() => sI), "../translations/locales/uk/common.json": () => Promise.resolve().then(() => aI), "../translations/locales/zh/common.json": () => Promise.resolve().then(() => lI) }), `../translations/locales/${n}/common.json`, 5);
    return O.addResourceBundle(n, CA, e.default), e;
  } catch (e) {
    return console.warn(`Failed to load language bundle for ${n}`, e), null;
  }
}, Z8 = ({
  children: n,
  languageCode: e
}) => {
  const [t, i] = ye(e), r = PA((o) => {
    O.hasResourceBundle(o, CA) ? (O.changeLanguage(o), i(o)) : C8(o).then(() => {
      O.changeLanguage(o), i(o);
    });
  }, []);
  return Je(() => {
    O.isInitialized && r(e);
  }, [e, r]), /* @__PURE__ */ b(w8.Provider, { value: { currentLanguageCode: t, changeLocale: r }, children: n });
};
function un(n, e) {
  if (!n && !e)
    throw new Error("Cannot add a null child to a null parent.");
  return e && (n.content || (n.content = []), Array.isArray(e) ? n.content.push.apply(n.content, e) : n.content.push(e)), n;
}
function bh(n, e) {
  if (!n && !e)
    throw new Error("Cannot add a null mark to a null node.");
  return e && (n.marks || (n.marks = []), Array.isArray(e) ? n.marks.push.apply(n.marks, e) : n.marks.push(e)), n;
}
function xe(n, e) {
  return { type: n, ...e };
}
function T8() {
  return { type: "doc", content: [] };
}
function mr(n, e) {
  return { type: "text", text: n, marks: e || [] };
}
function M8(n) {
  return "style" in n;
}
function E8(n) {
  return !!(n && (n.type === "bulletList" || n.type === "orderedList"));
}
var kh = function({
  doc: n,
  getCurrentBlock: e,
  entityMap: t,
  peek: i,
  next: r,
  converter: o
}) {
  var a, l;
  const s = e().type === "unordered-list-item" ? xe("bulletList") : xe("orderedList");
  for (; ; ) {
    let c = s;
    const u = e();
    let d = 0;
    for (; d < u.depth; ) {
      (a = c.content) != null && a.length || (c.content = []);
      let f = c.content[c.content.length - 1];
      f || (f = xe("listItem"), un(c, f));
      let p = (l = f.content) == null ? void 0 : l[f.content.length - 1];
      if (E8(p))
        c = p, d++;
      else {
        p = u.type === "unordered-list-item" ? xe("bulletList") : xe("orderedList"), un(f, p), c = p;
        break;
      }
    }
    un(
      c,
      xe("listItem", {
        content: [
          xe("paragraph", {
            content: o.splitTextByEntityRangesAndInlineStyleRanges({
              doc: n,
              block: e(),
              entityMap: t
            })
          })
        ]
      })
    );
    const h = i();
    if (!(h && h.type === "unordered-list-item" || h && h.type === "ordered-list-item") || h && h.type !== u.type)
      break;
    r();
  }
  return s;
}, Ci = function({
  block: n,
  entityMap: e,
  converter: t,
  doc: i
}) {
  const r = {
    "header-one": 1,
    "header-two": 2,
    "header-three": 3,
    "header-four": 4,
    "header-five": 5,
    "header-six": 6
  }[n.type];
  return xe("heading", {
    attrs: { level: r || 1 },
    content: t.splitTextByEntityRangesAndInlineStyleRanges({
      block: n,
      entityMap: e,
      doc: i
    })
  });
}, $8 = function({
  doc: n,
  getCurrentBlock: e,
  entityMap: t,
  converter: i,
  peek: r,
  next: o
}) {
  var c;
  const s = xe("table");
  let a = xe("tableRow"), l = e();
  do {
    if (l.depth + 1 !== e().depth && (a = xe("tableRow"), un(s, a)), un(
      a,
      xe("tableCell", {
        content: [
          xe("paragraph", {
            content: i.splitTextByEntityRangesAndInlineStyleRanges({
              doc: n,
              block: e(),
              entityMap: t
            })
          })
        ]
      })
    ), ((c = r()) == null ? void 0 : c.type) !== "table-cell")
      break;
    l = o();
  } while (!0);
  return s;
}, yh = {
  atomic({ doc: n, block: e, entityMap: t, converter: i }) {
    if (e.entityRanges.length === 0 && e.inlineStyleRanges.length === 0)
      return mr(e.text);
    const r = xe("paragraph"), o = e.entityRanges.map((s) => i.mapEntityToNode({
      doc: n,
      block: e,
      range: s,
      entityMap: t,
      converter: i
    })).filter(Boolean);
    return o.length === 0 ? null : un(r, o);
  },
  "code-block"({ block: n }) {
    return xe("codeBlock", {
      content: [mr(n.text)]
    });
  },
  blockquote({ doc: n, block: e, entityMap: t, converter: i }) {
    return xe("blockquote", {
      content: [
        xe("paragraph", {
          content: i.splitTextByEntityRangesAndInlineStyleRanges({
            doc: n,
            block: e,
            entityMap: t
          })
        })
      ]
    });
  },
  unstyled({ doc: n, block: e, entityMap: t, converter: i }) {
    const r = xe("paragraph");
    return e.inlineStyleRanges.length === 0 && e.entityRanges.length === 0 ? un(r, mr(e.text)) : un(
      r,
      i.splitTextByEntityRangesAndInlineStyleRanges({
        doc: n,
        block: e,
        entityMap: t
      })
    );
  },
  "unordered-list-item": kh,
  "ordered-list-item": kh,
  "header-one": Ci,
  "header-two": Ci,
  "header-three": Ci,
  "header-four": Ci,
  "header-five": Ci,
  "header-six": Ci,
  "table-cell": $8
}, O8 = function(n) {
  const e = n.getCurrentBlock();
  return yh[e.type] ? yh[e.type](n) : null;
}, vh = {
  LINK: ({ entity: n }) => ({
    type: "link",
    attrs: {
      href: n.data.url,
      target: n.data.target
    }
  })
}, z8 = function({
  range: { key: n },
  entityMap: e,
  converter: t
}) {
  return vh[e[n].type] ? vh[e[n].type]({
    entity: e[n],
    converter: t
  }) : null;
}, xh = {
  HORIZONTAL_RULE: () => xe("horizontalRule"),
  IMAGE: ({ entity: n }) => xe("image", {
    attrs: {
      src: n.data.src,
      alt: n.data.alt
    }
  })
}, A8 = function({
  range: { key: n },
  entityMap: e,
  converter: t
}) {
  return xh[e[n].type] ? xh[e[n].type]({
    entity: e[n],
    converter: t
  }) : null;
}, Sh = {
  BOLD: { type: "bold" },
  CODE: { type: "code" },
  KEYBOARD: { type: "code" },
  ITALIC: { type: "italic" },
  STRIKETHROUGH: { type: "strike" },
  UNDERLINE: { type: "underline" },
  SUBSCRIPT: { type: "subscript" },
  SUPERSCRIPT: { type: "superscript" },
  HIGHLIGHT: { type: "highlight" }
}, N8 = function({
  range: { style: n }
}) {
  return Sh[n] ? Sh[n] : n.startsWith("bgcolor-") ? {
    type: "highlight",
    attrs: {
      color: n.replace("bgcolor-", "")
    }
  } : n.startsWith("fontfamily-") ? {
    type: "textStyle",
    attrs: {
      fontFamily: n.replace("fontfamily-", "")
    }
  } : null;
}, wh = class {
  constructor(n) {
    /**
     * Any unmatched blocks, entities, or inline styles that were not converted.
     */
    Gt(this, "unmatched", {
      blocks: [],
      entities: {},
      inlineStyles: []
    });
    Gt(this, "options");
    Gt(this, "createNode", xe);
    Gt(this, "addChild", un);
    Gt(this, "createText", mr);
    Gt(this, "addMark", bh);
    Gt(this, "mapBlockToNode", (n) => {
      let e = null;
      try {
        e = this.options.mapBlockToNode.call(this, n) ?? null;
      } catch (t) {
        console.error(t);
      }
      return e === null && this.unmatched.blocks.push(n.getCurrentBlock()), e;
    });
    Gt(this, "mapEntityToNode", ({ range: n, entityMap: e, doc: t, block: i }) => {
      try {
        const r = this.options.mapEntityToNode({
          range: n,
          entityMap: e,
          converter: this,
          doc: t,
          block: i
        });
        if (r)
          return r;
      } catch (r) {
        console.error(r);
      }
      return this.unmatched.entities[n.key] = e[n.key], null;
    });
    this.options = {
      mapBlockToNode: O8,
      mapInlineStyleToMark: N8,
      mapEntityToMark: z8,
      mapEntityToNode: A8,
      ...n
    };
  }
  mapRangeToMark({
    range: n,
    entityMap: e,
    doc: t,
    block: i
  }) {
    if (M8(n)) {
      try {
        const r = this.options.mapInlineStyleToMark({
          range: n,
          converter: this,
          doc: t,
          block: i
        }) ?? null;
        if (r)
          return r;
      } catch (r) {
        console.error(r);
      }
      return this.unmatched.inlineStyles.push(n), null;
    }
    try {
      const r = this.options.mapEntityToMark({
        range: n,
        entityMap: e,
        converter: this,
        doc: t,
        block: i
      }) ?? null;
      if (r)
        return r;
    } catch (r) {
      console.error(r);
    }
    return this.unmatched.entities[n.key] = e[n.key], null;
  }
  /**
   * This function splits a text into Nodes based on the entity ranges and inline style ranges.
   * Applying them as marks to the text. Which may overlap in their ranges.
   */
  splitTextByEntityRangesAndInlineStyleRanges(n) {
    const e = [
      ...n.block.entityRanges,
      ...n.block.inlineStyleRanges
    ].sort((a, l) => a.offset === l.offset ? a.length - l.length : a.offset - l.offset);
    let t = [], i = {};
    for (let a of e)
      for (let l = a.offset; l < a.offset + a.length; l++)
        i[l] || (i[l] = []), i[l].push(a);
    let r = [], o = "";
    const s = Array.from(n.block.text);
    for (let a = 0; a < s.length; a++) {
      let l = i[a] || [];
      (l.length !== r.length || !l.every((c) => r.includes(c))) && (o && t.push({ text: o, ranges: r }), o = "", r = l), o += s[a];
    }
    return o && t.push({ text: o, ranges: r }), t.map(({ text: a, ranges: l }) => {
      const c = mr(a);
      return l.forEach(
        (u) => bh(
          c,
          this.mapRangeToMark({
            range: u,
            entityMap: n.entityMap,
            doc: n.doc,
            block: n.block
          })
        )
      ), c;
    });
  }
  convert(n) {
    this.unmatched = {
      blocks: [],
      entities: {},
      inlineStyles: []
    };
    const e = T8();
    let t = 0;
    const i = {
      get index() {
        return t;
      },
      setIndex: (r) => {
        t = r;
      },
      get block() {
        return n.blocks[t];
      },
      allBlocks: n.blocks,
      get doc() {
        return e;
      },
      entityMap: n.entityMap,
      peek: () => n.blocks[t + 1] || null,
      peekPrev: () => n.blocks[t - 1] || null,
      getCurrentBlock: () => n.blocks[t],
      next: () => n.blocks[t++] || null,
      prev: () => n.blocks[t--] || null,
      converter: this
    };
    for (; t < n.blocks.length; t++) {
      const r = this.mapBlockToNode.call(this, i);
      typeof r != "boolean" && r && this.addChild(e, r);
    }
    return e;
  }
};
const TA = (n) => (Array.isArray(n.content) && (n.content = n.content.map(TA).filter((e) => !(e.type === "text" && (!e.text || e.text === "")))), n), MA = (n, e) => {
  var t;
  if (Array.isArray(n.content) && (n.content = n.content.map((i) => MA(i, e))), (n.type === "paragraph" || n.type === "listItem" || n.type === "heading") && (e != null && e.textAlign) && (n.attrs = {
    ...n.attrs,
    textAlign: e.textAlign
  }), n.type === "text") {
    const i = ((t = n.marks) == null ? void 0 : t.slice()) || [], r = i.filter((a) => a.type === "textStyle"), o = i.filter((a) => a.type !== "textStyle"), s = r.reduce(
      (a, l) => ({
        ...a,
        ...l.attrs
      }),
      {}
    );
    if (e != null && e.fontFamily && (s.fontFamily = e.fontFamily), Object.keys(s).length > 0) {
      const a = {
        type: "textStyle",
        attrs: s
      };
      n.marks = [...o, a];
    } else
      n.marks = o;
  }
  return n;
}, J8 = ({
  draftContent: n,
  extension: e,
  additionalStyles: t,
  options: i
}) => {
  const r = new wh(), o = r.options.mapInlineStyleToMark;
  try {
    const s = typeof n == "string" ? JSON.parse(n) : n;
    s.blocks = s.blocks.map((h) => {
      var f;
      return h.type === "section" ? { ...h, type: "unstyled" } : h.type === "code-block" ? ((f = i == null ? void 0 : i.logger) == null || f.call(i, "code-block converted to paragraph (no code block node in schema)"), { ...h, type: "unstyled" }) : h;
    });
    const l = new wh({
      mapBlockToNode: (h) => {
        var f, p;
        return (p = (f = r.options).mapBlockToNode) == null ? void 0 : p.call(f, h);
      },
      mapInlineStyleToMark: (h) => {
        var f, p, m;
        return (f = h.range.style) != null && f.includes("rgba") ? {
          type: "textStyle",
          attrs: {
            color: Sc(h.range.style)
          }
        } : (p = h.range.style) != null && p.startsWith("FONT_SIZE_") ? {
          type: "textStyle",
          attrs: {
            fontSize: h.range.style.replace("FONT_SIZE_", "") + "px"
          }
        } : h.range.style === "CODE" ? ((m = i == null ? void 0 : i.logger) == null || m.call(i, "CODE inline style converted to plain text (no code mark in schema)"), null) : o == null ? void 0 : o(h);
      }
    }).convert(s), c = MA(l, t), u = Array.from(new Set(e.list));
    return n5(
      TA(c),
      SA(u, e.options)
    );
  } catch (s) {
    if (i != null && i.throwErrors)
      throw s;
    return console.error(s), "";
  }
};
export {
  T as EditorExtensionEnum,
  xc as FontFamilyEnum,
  K8 as TipTapEditor,
  Z8 as TipTapLocaleProvider,
  HA as advancedTextEditorExtensions,
  Ts as baseExtensions,
  J8 as convertDraftToTiptap,
  V8 as emailTextExtensions,
  U8 as extensionsForSms,
  nA as getFontFamilyLabel,
  Id as getFontFamilyValues,
  Ae as getInternalFontFamily,
  SP as internalToPublicFontFamily,
  qA as simpleTextExtensions
};
